(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $dc96d98a7dcdceb5$exports = {};
function $7e5af7f007906526$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}


!function(e, t) {
    $dc96d98a7dcdceb5$exports = t();
}("undefined" != typeof self ? self : undefined, function() {
    return function() {
        var e = {
            75: function(e) {
                (function() {
                    var t, _$n, r, o, a, i;
                    "undefined" != typeof performance && null !== performance && performance.now ? e.exports = function() {
                        return performance.now();
                    } : Date.now ? (e.exports = function() {
                        return Date.now() - r;
                    }, r = Date.now()) : (e.exports = function() {
                        return (new Date).getTime() - r;
                    }, r = (new Date).getTime());
                }).call(this);
            },
            4087: function(e, t, n) {
                for(var r = n(75), o = "undefined" == typeof window ? n.g : window, a = [
                    "moz",
                    "webkit"
                ], i = "AnimationFrame", s = o["request" + i], u = o["cancel" + i] || o["cancelRequest" + i], l = 0; !s && l < a.length; l++)s = o[a[l] + "Request" + i], u = o[a[l] + "Cancel" + i] || o[a[l] + "CancelRequest" + i];
                if (!s || !u) {
                    var c = 0, p = 0, d = [];
                    s = function s(e) {
                        if (0 === d.length) {
                            var t = r(), _$n = Math.max(0, 16.666666666666668 - (t - c));
                            c = _$n + t, setTimeout(function() {
                                var _$e = d.slice(0);
                                d.length = 0;
                                for(var t = 0; t < _$e.length; t++)if (!_$e[t].cancelled) try {
                                    _$e[t].callback(c);
                                } catch (e) {
                                    setTimeout(function() {
                                        throw e;
                                    }, 0);
                                }
                            }, Math.round(_$n));
                        }
                        return d.push({
                            handle: ++p,
                            callback: e,
                            cancelled: !1
                        }), p;
                    }, u = function u(e) {
                        for(var t = 0; t < d.length; t++)d[t].handle === e && (d[t].cancelled = !0);
                    };
                }
                e.exports = function(e) {
                    return s.call(o, e);
                }, e.exports.cancel = function() {
                    u.apply(o, arguments);
                }, e.exports.polyfill = function(e) {
                    e || (e = o), e.requestAnimationFrame = s, e.cancelAnimationFrame = u;
                };
            }
        }, t = {};
        function n(r) {
            var o = t[r];
            if (void 0 !== o) return o.exports;
            var a = t[r] = {
                exports: {}
            };
            return e[r].call(a.exports, a, a.exports, n), a.exports;
        }
        n.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e["default"];
            } : function() {
                return e;
            };
            return n.d(t, {
                a: t
            }), t;
        }, n.d = function(e, t) {
            for(var r in t)n.o(t, r) && !n.o(e, r) && Object.defineProperty(e, r, {
                enumerable: !0,
                get: t[r]
            });
        }, n.g = function() {
            if ("object" == (typeof globalThis === "undefined" ? "undefined" : (0, $7e5af7f007906526$export$71511d61b312f219)(globalThis))) return globalThis;
            try {
                return this || new Function("return this")();
            } catch (e) {
                if ("object" == (typeof window === "undefined" ? "undefined" : (0, $7e5af7f007906526$export$71511d61b312f219)(window))) return window;
            }
        }(), n.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        };
        var r = {};
        return function() {
            "use strict";
            var E = function E(e, t) {
                var _$n = Object.keys(e);
                if (Object.getOwnPropertySymbols) {
                    var r = Object.getOwnPropertySymbols(e);
                    t && (r = r.filter(function(t) {
                        return Object.getOwnPropertyDescriptor(e, t).enumerable;
                    })), _$n.push.apply(_$n, r);
                }
                return _$n;
            };
            var w = function w(e) {
                for(var t = 1; t < arguments.length; t++){
                    var _$n = null != arguments[t] ? arguments[t] : {};
                    t % 2 ? E(Object(_$n), !0).forEach(function(t) {
                        A(e, t, _$n[t]);
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(_$n)) : E(Object(_$n)).forEach(function(t) {
                        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(_$n, t));
                    });
                }
                return e;
            };
            var b = function b(e) {
                return function(e) {
                    if (Array.isArray(e)) return T(e);
                }(e) || function(e) {
                    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
                }(e) || function(e, t) {
                    if (e) {
                        if ("string" == typeof e) return T(e, t);
                        var _$n = Object.prototype.toString.call(e).slice(8, -1);
                        return "Object" === _$n && e.constructor && (_$n = e.constructor.name), "Map" === _$n || "Set" === _$n ? Array.from(e) : "Arguments" === _$n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(_$n) ? T(e, t) : void 0;
                    }
                }(e) || function() {
                    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }();
            };
            var T = function T(e, t) {
                (null == t || t > e.length) && (t = e.length);
                for(var _$n = 0, r = new Array(t); _$n < t; _$n++)r[_$n] = e[_$n];
                return r;
            };
            var S = function S(e, t) {
                for(var _$n = 0; _$n < t.length; _$n++){
                    var r = t[_$n];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, N(r.key), r);
                }
            };
            var A = function A(e, t, n) {
                return (t = N(t)) in e ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : e[t] = n, e;
            };
            var N = function N(e) {
                var t = function(e, t) {
                    if ("object" !== g(e) || null === e) return e;
                    var _$n = e[Symbol.toPrimitive];
                    if (void 0 !== _$n) {
                        var r = _$n.call(e, "string");
                        if ("object" !== g(r)) return r;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e);
                }(e);
                return "symbol" === g(t) ? t : String(t);
            };
            n.d(r, {
                "default": function() {
                    return C;
                }
            });
            var e = n(4087), t = n.n(e);
            var o = function o(e) {
                return new RegExp(/<[a-z][\s\S]*>/i).test(e);
            }, a = function a(e, t) {
                return Math.floor(Math.random() * (t - e + 1)) + e;
            };
            var i = "TYPE_CHARACTER", s = "REMOVE_CHARACTER", u = "REMOVE_ALL", l = "REMOVE_LAST_VISIBLE_NODE", c = "PAUSE_FOR", p = "CALL_FUNCTION", d = "ADD_HTML_TAG_ELEMENT", f = "CHANGE_DELETE_SPEED", v = "CHANGE_DELAY", h = "CHANGE_CURSOR", m = "PASTE_STRING", y = "HTML_TAG";
            function g(e) {
                return g = "function" == typeof Symbol && "symbol" == (0, $7e5af7f007906526$export$71511d61b312f219)(Symbol.iterator) ? function g(e) {
                    return typeof e === "undefined" ? "undefined" : (0, $7e5af7f007906526$export$71511d61b312f219)(e);
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e === "undefined" ? "undefined" : (0, $7e5af7f007906526$export$71511d61b312f219)(e);
                }, g(e);
            }
            var C = function() {
                function n(r, g) {
                    var E = this;
                    if (function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, n), A(this, "state", {
                        cursorAnimation: null,
                        lastFrameTime: null,
                        pauseUntil: null,
                        eventQueue: [],
                        eventLoop: null,
                        eventLoopPaused: !1,
                        reverseCalledEvents: [],
                        calledEvents: [],
                        visibleNodes: [],
                        initialOptions: null,
                        elements: {
                            container: null,
                            wrapper: document.createElement("span"),
                            cursor: document.createElement("span")
                        }
                    }), A(this, "options", {
                        strings: null,
                        cursor: "|",
                        delay: "natural",
                        pauseFor: 1500,
                        deleteSpeed: "natural",
                        loop: !1,
                        autoStart: !1,
                        devMode: !1,
                        skipAddStyles: !1,
                        wrapperClassName: "Typewriter__wrapper",
                        cursorClassName: "Typewriter__cursor",
                        stringSplitter: null,
                        onCreateTextNode: null,
                        onRemoveNode: null
                    }), A(this, "setupWrapperElement", function() {
                        E.state.elements.container && (E.state.elements.wrapper.className = E.options.wrapperClassName, E.state.elements.cursor.className = E.options.cursorClassName, E.state.elements.cursor.innerHTML = E.options.cursor, E.state.elements.container.innerHTML = "", E.state.elements.container.appendChild(E.state.elements.wrapper), E.state.elements.container.appendChild(E.state.elements.cursor));
                    }), A(this, "start", function() {
                        return E.state.eventLoopPaused = !1, E.runEventLoop(), E;
                    }), A(this, "pause", function() {
                        return E.state.eventLoopPaused = !0, E;
                    }), A(this, "stop", function() {
                        return E.state.eventLoop && ((0, e.cancel)(E.state.eventLoop), E.state.eventLoop = null), E;
                    }), A(this, "pauseFor", function(e) {
                        return E.addEventToQueue(c, {
                            ms: e
                        }), E;
                    }), A(this, "typeOutAllStrings", function() {
                        return "string" == typeof E.options.strings ? (E.typeString(E.options.strings).pauseFor(E.options.pauseFor), E) : (E.options.strings.forEach(function(e) {
                            E.typeString(e).pauseFor(E.options.pauseFor).deleteAll(E.options.deleteSpeed);
                        }), E);
                    }), A(this, "typeString", function(e) {
                        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                        if (o(e)) return E.typeOutHTMLString(e, t);
                        if (e) {
                            var _$n = (E.options || {}).stringSplitter, _$r = "function" == typeof _$n ? _$n(e) : e.split("");
                            E.typeCharacters(_$r, t);
                        }
                        return E;
                    }), A(this, "pasteString", function(e) {
                        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                        return o(e) ? E.typeOutHTMLString(e, t, !0) : (e && E.addEventToQueue(m, {
                            character: e,
                            node: t
                        }), E);
                    }), A(this, "typeOutHTMLString", function(e) {
                        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null, _$n = arguments.length > 2 ? arguments[2] : void 0, _$r = function(e) {
                            var t = document.createElement("div");
                            return t.innerHTML = e, t.childNodes;
                        }(e);
                        if (_$r.length > 0) for(var o = 0; o < _$r.length; o++){
                            var a = _$r[o], i = a.innerHTML;
                            a && 3 !== a.nodeType ? (a.innerHTML = "", E.addEventToQueue(d, {
                                node: a,
                                parentNode: t
                            }), _$n ? E.pasteString(i, a) : E.typeString(i, a)) : a.textContent && (_$n ? E.pasteString(a.textContent, t) : E.typeString(a.textContent, t));
                        }
                        return E;
                    }), A(this, "deleteAll", function() {
                        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "natural";
                        return E.addEventToQueue(u, {
                            speed: e
                        }), E;
                    }), A(this, "changeDeleteSpeed", function(e) {
                        if (!e) throw new Error("Must provide new delete speed");
                        return E.addEventToQueue(f, {
                            speed: e
                        }), E;
                    }), A(this, "changeDelay", function(e) {
                        if (!e) throw new Error("Must provide new delay");
                        return E.addEventToQueue(v, {
                            delay: e
                        }), E;
                    }), A(this, "changeCursor", function(e) {
                        if (!e) throw new Error("Must provide new cursor");
                        return E.addEventToQueue(h, {
                            cursor: e
                        }), E;
                    }), A(this, "deleteChars", function(e) {
                        if (!e) throw new Error("Must provide amount of characters to delete");
                        for(var t = 0; t < e; t++)E.addEventToQueue(s);
                        return E;
                    }), A(this, "callFunction", function(e, t) {
                        if (!e || "function" != typeof e) throw new Error("Callback must be a function");
                        return E.addEventToQueue(p, {
                            cb: e,
                            thisArg: t
                        }), E;
                    }), A(this, "typeCharacters", function(e) {
                        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                        if (!e || !Array.isArray(e)) throw new Error("Characters must be an array");
                        return e.forEach(function(e) {
                            E.addEventToQueue(i, {
                                character: e,
                                node: t
                            });
                        }), E;
                    }), A(this, "removeCharacters", function(e) {
                        if (!e || !Array.isArray(e)) throw new Error("Characters must be an array");
                        return e.forEach(function() {
                            E.addEventToQueue(s);
                        }), E;
                    }), A(this, "addEventToQueue", function(e, t) {
                        var _$n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                        return E.addEventToStateProperty(e, t, _$n, "eventQueue");
                    }), A(this, "addReverseCalledEvent", function(e, t) {
                        var _$n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                        return E.options.loop ? E.addEventToStateProperty(e, t, _$n, "reverseCalledEvents") : E;
                    }), A(this, "addEventToStateProperty", function(e, t) {
                        var _$n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], _$r = arguments.length > 3 ? arguments[3] : void 0, o = {
                            eventName: e,
                            eventArgs: t || {}
                        };
                        return E.state[_$r] = _$n ? [
                            o
                        ].concat(b(E.state[_$r])) : [].concat(b(E.state[_$r]), [
                            o
                        ]), E;
                    }), A(this, "runEventLoop", function() {
                        E.state.lastFrameTime || (E.state.lastFrameTime = Date.now());
                        var e = Date.now(), _$n = e - E.state.lastFrameTime;
                        if (!E.state.eventQueue.length) {
                            if (!E.options.loop) return;
                            E.state.eventQueue = b(E.state.calledEvents), E.state.calledEvents = [], E.options = w({}, E.state.initialOptions);
                        }
                        if (E.state.eventLoop = t()(E.runEventLoop), !E.state.eventLoopPaused) {
                            if (E.state.pauseUntil) {
                                if (e < E.state.pauseUntil) return;
                                E.state.pauseUntil = null;
                            }
                            var _$r, o = b(E.state.eventQueue), _$g = o.shift();
                            if (!(_$n <= (_$r = _$g.eventName === l || _$g.eventName === s ? "natural" === E.options.deleteSpeed ? a(40, 80) : E.options.deleteSpeed : "natural" === E.options.delay ? a(120, 160) : E.options.delay))) {
                                var T = _$g.eventName, S = _$g.eventArgs;
                                switch(E.logInDevMode({
                                    currentEvent: _$g,
                                    state: E.state,
                                    delay: _$r
                                }), T){
                                    case m:
                                    case i:
                                        var A = S.character, N = S.node, C = document.createTextNode(A), _ = C;
                                        E.options.onCreateTextNode && "function" == typeof E.options.onCreateTextNode && (_ = E.options.onCreateTextNode(A, C)), _ && (N ? N.appendChild(_) : E.state.elements.wrapper.appendChild(_)), E.state.visibleNodes = [].concat(b(E.state.visibleNodes), [
                                            {
                                                type: "TEXT_NODE",
                                                character: A,
                                                node: _
                                            }
                                        ]);
                                        break;
                                    case s:
                                        o.unshift({
                                            eventName: l,
                                            eventArgs: {
                                                removingCharacterNode: !0
                                            }
                                        });
                                        break;
                                    case c:
                                        var O = _$g.eventArgs.ms;
                                        E.state.pauseUntil = Date.now() + parseInt(O);
                                        break;
                                    case p:
                                        var L = _$g.eventArgs, D = L.cb, M = L.thisArg;
                                        D.call(M, {
                                            elements: E.state.elements
                                        });
                                        break;
                                    case d:
                                        var x = _$g.eventArgs, P = x.node, j = x.parentNode;
                                        j ? j.appendChild(P) : E.state.elements.wrapper.appendChild(P), E.state.visibleNodes = [].concat(b(E.state.visibleNodes), [
                                            {
                                                type: y,
                                                node: P,
                                                parentNode: j || E.state.elements.wrapper
                                            }
                                        ]);
                                        break;
                                    case u:
                                        var R = E.state.visibleNodes, k = S.speed, Q = [];
                                        k && Q.push({
                                            eventName: f,
                                            eventArgs: {
                                                speed: k,
                                                temp: !0
                                            }
                                        });
                                        for(var F = 0, H = R.length; F < H; F++)Q.push({
                                            eventName: l,
                                            eventArgs: {
                                                removingCharacterNode: !1
                                            }
                                        });
                                        k && Q.push({
                                            eventName: f,
                                            eventArgs: {
                                                speed: E.options.deleteSpeed,
                                                temp: !0
                                            }
                                        }), o.unshift.apply(o, Q);
                                        break;
                                    case l:
                                        var I = _$g.eventArgs.removingCharacterNode;
                                        if (E.state.visibleNodes.length) {
                                            var U = E.state.visibleNodes.pop(), q = U.type, G = U.node, Y = U.character;
                                            E.options.onRemoveNode && "function" == typeof E.options.onRemoveNode && E.options.onRemoveNode({
                                                node: G,
                                                character: Y
                                            }), G && G.parentNode.removeChild(G), q === y && I && o.unshift({
                                                eventName: l,
                                                eventArgs: {}
                                            });
                                        }
                                        break;
                                    case f:
                                        E.options.deleteSpeed = _$g.eventArgs.speed;
                                        break;
                                    case v:
                                        E.options.delay = _$g.eventArgs.delay;
                                        break;
                                    case h:
                                        E.options.cursor = _$g.eventArgs.cursor, E.state.elements.cursor.innerHTML = _$g.eventArgs.cursor;
                                }
                                E.options.loop && (_$g.eventName === l || _$g.eventArgs && _$g.eventArgs.temp || (E.state.calledEvents = [].concat(b(E.state.calledEvents), [
                                    _$g
                                ]))), E.state.eventQueue = o, E.state.lastFrameTime = e;
                            }
                        }
                    }), r) {
                        if ("string" == typeof r) {
                            var T = document.querySelector(r);
                            if (!T) throw new Error("Could not find container element");
                            this.state.elements.container = T;
                        } else this.state.elements.container = r;
                    }
                    g && (this.options = w(w({}, this.options), g)), this.state.initialOptions = w({}, this.options), this.init();
                }
                var r, g;
                return r = n, g = [
                    {
                        key: "init",
                        value: function value() {
                            var e, t;
                            this.setupWrapperElement(), this.addEventToQueue(h, {
                                cursor: this.options.cursor
                            }, !0), this.addEventToQueue(u, null, !0), !window || window.___TYPEWRITER_JS_STYLES_ADDED___ || this.options.skipAddStyles || (e = ".Typewriter__cursor{-webkit-animation:Typewriter-cursor 1s infinite;animation:Typewriter-cursor 1s infinite;margin-left:1px}@-webkit-keyframes Typewriter-cursor{0%{opacity:0}50%{opacity:1}100%{opacity:0}}@keyframes Typewriter-cursor{0%{opacity:0}50%{opacity:1}100%{opacity:0}}", (t = document.createElement("style")).appendChild(document.createTextNode(e)), document.head.appendChild(t), window.___TYPEWRITER_JS_STYLES_ADDED___ = !0), !0 === this.options.autoStart && this.options.strings && this.typeOutAllStrings().start();
                        }
                    },
                    {
                        key: "logInDevMode",
                        value: function value(e) {
                            this.options.devMode && console.log(e);
                        }
                    }
                ], S(r.prototype, g), Object.defineProperty(r, "prototype", {
                    writable: !1
                }), n;
            }();
        }(), r["default"];
    }();
});


var $b71bb28694fa61f2$var$cursor = document.querySelector('.cursor');
var $b71bb28694fa61f2$var$hoverTargets = document.querySelectorAll('.cursor-hover');
// Mouse position
var $b71bb28694fa61f2$var$mouseX = 0;
var $b71bb28694fa61f2$var$mouseY = 0;
// Track the mouse position
window.addEventListener('mousemove', function(e) {
    $b71bb28694fa61f2$var$mouseX = e.pageX;
    $b71bb28694fa61f2$var$mouseY = e.pageY;
});
// Animate the cursor
window.requestAnimationFrame(function mousePos(e) {
    $b71bb28694fa61f2$var$cursor.style.left = $b71bb28694fa61f2$var$mouseX + 'px';
    $b71bb28694fa61f2$var$cursor.style.top = $b71bb28694fa61f2$var$mouseY + 'px';
    window.requestAnimationFrame(mousePos);
});
$b71bb28694fa61f2$var$hoverTargets.forEach(function(target) {
    target.addEventListener('mouseenter', function(e) {
        $b71bb28694fa61f2$var$cursor.style.transform = 'scale(0) translate(-150%, -150%)';
    });
    target.addEventListener('mouseleave', function(e) {
        $b71bb28694fa61f2$var$cursor.style.transform = 'scale(1) translate(-50%, -50%)';
    });
});


/**
 * Interactive Floating Leaves Animation
 * 
 * A Three.js application that renders floating leaf models with dust particles
 * and interactive mouse-based movement. The leaves float gently and respond
 * to mouse movement with repulsion effects.
 */ function $313db6c3a7373211$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $bd3afd8f91324b60$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $bd3afd8f91324b60$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $bd3afd8f91324b60$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $bd3afd8f91324b60$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


/**
 * @license
 * Copyright 2010-2021 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ function $ba14d604d8d555ce$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $ba14d604d8d555ce$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $ba14d604d8d555ce$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $ba14d604d8d555ce$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


function $dd7760de693fac15$export$71511d61b312f219(o) {
    $dd7760de693fac15$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $dd7760de693fac15$export$71511d61b312f219(o);
}


function $2e4a809d588e45b7$export$71511d61b312f219() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($2e4a809d588e45b7$export$71511d61b312f219 = function() {
        return !!result;
    })();
}


function $ac1b2f7b157026ac$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}



function $aa137087616882c2$export$71511d61b312f219(self, call) {
    if (call && ((0, $7e5af7f007906526$export$71511d61b312f219)(call) === "object" || typeof call === "function")) return call;
    return (0, $ac1b2f7b157026ac$export$71511d61b312f219)(self);
}


function $3fd3dd3bc726a20c$export$71511d61b312f219(_this, derived, args) {
    // Super
    derived = (0, $dd7760de693fac15$export$71511d61b312f219)(derived);
    return (0, $aa137087616882c2$export$71511d61b312f219)(_this, (0, $2e4a809d588e45b7$export$71511d61b312f219)() ? Reflect.construct(derived, args || [], (0, $dd7760de693fac15$export$71511d61b312f219)(_this).constructor) : derived.apply(_this, args));
}




function $c83f3a938e737400$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}



function $20c3d3ce2372a6aa$export$71511d61b312f219(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $dd7760de693fac15$export$71511d61b312f219)(object);
        if (object === null) break;
    }
    return object;
}


function $7f1320a35f8074b1$export$71511d61b312f219(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $7f1320a35f8074b1$export$71511d61b312f219 = Reflect.get;
    else $7f1320a35f8074b1$export$71511d61b312f219 = function get(target, property, receiver) {
        var base = (0, $20c3d3ce2372a6aa$export$71511d61b312f219)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $7f1320a35f8074b1$export$71511d61b312f219(target, property, receiver || target);
}



function $0f6f41d200d222b3$export$71511d61b312f219(o, p) {
    $0f6f41d200d222b3$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0f6f41d200d222b3$export$71511d61b312f219(o, p);
}


function $6937a2c821db5183$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $0f6f41d200d222b3$export$71511d61b312f219)(subClass, superClass);
}



function $9583e96e3d380e4c$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $c83f3a938e737400$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}



function $ae9fd0c711226eb3$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $8fa55f7ba8b7562b$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $7e7ede098b1c2c4d$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $e27ec29cf3fe52a0$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $d228b570309c4f7f$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $e27ec29cf3fe52a0$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $e27ec29cf3fe52a0$export$71511d61b312f219)(o, minLen);
}


function $de8f2615c12e293b$export$71511d61b312f219(arr, i) {
    return (0, $ae9fd0c711226eb3$export$71511d61b312f219)(arr) || (0, $8fa55f7ba8b7562b$export$71511d61b312f219)(arr, i) || (0, $d228b570309c4f7f$export$71511d61b312f219)(arr, i) || (0, $7e7ede098b1c2c4d$export$71511d61b312f219)();
}




function $a551a34061de08b7$export$71511d61b312f219(Parent, args, Class) {
    if ((0, $2e4a809d588e45b7$export$71511d61b312f219)()) $a551a34061de08b7$export$71511d61b312f219 = Reflect.construct;
    else $a551a34061de08b7$export$71511d61b312f219 = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $0f6f41d200d222b3$export$71511d61b312f219)(instance, Class.prototype);
        return instance;
    };
    return $a551a34061de08b7$export$71511d61b312f219.apply(null, arguments);
}



function $98436fc31971822c$export$71511d61b312f219(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}



function $314aa8324adb934d$export$71511d61b312f219(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $314aa8324adb934d$export$71511d61b312f219 = function(Class) {
        if (Class === null || !(0, $98436fc31971822c$export$71511d61b312f219)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $a551a34061de08b7$export$71511d61b312f219)(Class, arguments, (0, $dd7760de693fac15$export$71511d61b312f219)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $0f6f41d200d222b3$export$71511d61b312f219)(Wrapper, Class);
    };
    return $314aa8324adb934d$export$71511d61b312f219(Class);
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ 
var $b602c7a134484286$var$extendStatics = function extendStatics1(d, b) {
    $b602c7a134484286$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $b602c7a134484286$var$extendStatics(d, b);
};
function $b602c7a134484286$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $b602c7a134484286$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $b602c7a134484286$export$18ce0697a983be9b = function __assign1() {
    $b602c7a134484286$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b602c7a134484286$export$18ce0697a983be9b.apply(this, arguments);
};
function $b602c7a134484286$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $b602c7a134484286$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $7e5af7f007906526$export$71511d61b312f219)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $b602c7a134484286$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $b602c7a134484286$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $7e5af7f007906526$export$71511d61b312f219)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $b602c7a134484286$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $b602c7a134484286$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $7e5af7f007906526$export$71511d61b312f219)(x)) === "symbol" ? x : "".concat(x);
}
function $b602c7a134484286$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $7e5af7f007906526$export$71511d61b312f219)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $b602c7a134484286$export$f1db080c865becb9(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $7e5af7f007906526$export$71511d61b312f219)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $b602c7a134484286$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $b602c7a134484286$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $b602c7a134484286$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $b602c7a134484286$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $b602c7a134484286$export$45d3717a4c69092e(o, m, p);
}
function $b602c7a134484286$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $b602c7a134484286$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $b602c7a134484286$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($b602c7a134484286$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $b602c7a134484286$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $b602c7a134484286$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $b602c7a134484286$export$10c90e4f7922046c(v) {
    return this instanceof $b602c7a134484286$export$10c90e4f7922046c ? (this.v = v, this) : new $b602c7a134484286$export$10c90e4f7922046c(v);
}
function $b602c7a134484286$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $b602c7a134484286$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $b602c7a134484286$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $b602c7a134484286$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $b602c7a134484286$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $b602c7a134484286$export$19a8beecd37a4c45 === "function" ? $b602c7a134484286$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $b602c7a134484286$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $b602c7a134484286$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $b602c7a134484286$var$ownKeys = function ownKeys1(o) {
    $b602c7a134484286$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $b602c7a134484286$var$ownKeys(o);
};
function $b602c7a134484286$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $b602c7a134484286$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $b602c7a134484286$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $b602c7a134484286$var$__setModuleDefault(result, mod);
    return result;
}
function $b602c7a134484286$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
}
function $b602c7a134484286$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $b602c7a134484286$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $b602c7a134484286$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || (typeof receiver === "undefined" ? "undefined" : (0, $7e5af7f007906526$export$71511d61b312f219)(receiver)) !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $b602c7a134484286$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if ((typeof value === "undefined" ? "undefined" : (0, $7e5af7f007906526$export$71511d61b312f219)(value)) !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $b602c7a134484286$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $b602c7a134484286$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $b602c7a134484286$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $b602c7a134484286$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $b602c7a134484286$export$2e2bcd8739ae039 = {
    __extends: $b602c7a134484286$export$a8ba968b8961cb8a,
    __assign: $b602c7a134484286$export$18ce0697a983be9b,
    __rest: $b602c7a134484286$export$3c9a16f847548506,
    __decorate: $b602c7a134484286$export$29e00dfd3077644b,
    __param: $b602c7a134484286$export$d5ad3fd78186038f,
    __esDecorate: $b602c7a134484286$export$3a84e1ae4e97e9b0,
    __runInitializers: $b602c7a134484286$export$d831c04e792af3d,
    __propKey: $b602c7a134484286$export$6a2a36740a146cb8,
    __setFunctionName: $b602c7a134484286$export$d1a06452d3489bc7,
    __metadata: $b602c7a134484286$export$f1db080c865becb9,
    __awaiter: $b602c7a134484286$export$1050f835b63b671e,
    __generator: $b602c7a134484286$export$67ebef60e6f28a6,
    __createBinding: $b602c7a134484286$export$45d3717a4c69092e,
    __exportStar: $b602c7a134484286$export$f33643c0debef087,
    __values: $b602c7a134484286$export$19a8beecd37a4c45,
    __read: $b602c7a134484286$export$8d051b38c9118094,
    __spread: $b602c7a134484286$export$afc72e2116322959,
    __spreadArrays: $b602c7a134484286$export$6388937ca91ccae8,
    __spreadArray: $b602c7a134484286$export$1216008129fb82ed,
    __await: $b602c7a134484286$export$10c90e4f7922046c,
    __asyncGenerator: $b602c7a134484286$export$e427f37a30a4de9b,
    __asyncDelegator: $b602c7a134484286$export$bbd80228419bb833,
    __asyncValues: $b602c7a134484286$export$e3b29a3d6162315f,
    __makeTemplateObject: $b602c7a134484286$export$4fb47efe1390b86f,
    __importStar: $b602c7a134484286$export$c21735bcef00d192,
    __importDefault: $b602c7a134484286$export$da59b14a69baef04,
    __classPrivateFieldGet: $b602c7a134484286$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $b602c7a134484286$export$d40a35129aaff81f,
    __classPrivateFieldIn: $b602c7a134484286$export$81fdc39f203e4e04,
    __addDisposableResource: $b602c7a134484286$export$88ac25d8e944e405,
    __disposeResources: $b602c7a134484286$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $b602c7a134484286$export$889dfb5d17574b0b
};


var $c702e238df7c5123$export$3545e07a80636437 = '130';
var $c702e238df7c5123$export$7177b3e430c2d7ca = {
    LEFT: 0,
    MIDDLE: 1,
    RIGHT: 2,
    ROTATE: 0,
    DOLLY: 1,
    PAN: 2
};
var $c702e238df7c5123$export$d46bd3ead7cc759b = {
    ROTATE: 0,
    PAN: 1,
    DOLLY_PAN: 2,
    DOLLY_ROTATE: 3
};
var $c702e238df7c5123$export$3237e1f2c1ea1f44 = 0;
var $c702e238df7c5123$export$b9a7b4fc5cb15f9b = 1;
var $c702e238df7c5123$export$b8058bcc7037d3f3 = 2;
var $c702e238df7c5123$export$f24be24dcddeac0d = 3;
var $c702e238df7c5123$export$346307dbae2b7447 = 0;
var $c702e238df7c5123$export$5813f879eee7cd88 = 1;
var $c702e238df7c5123$export$a47c4b43a1be34f0 = 2;
var $c702e238df7c5123$export$896ae1ade6c829c4 = 3;
var $c702e238df7c5123$export$2ede184fc2998901 = 0;
var $c702e238df7c5123$export$d9f0486e75b5ace = 1;
var $c702e238df7c5123$export$3b296b6f144d5b03 = 2;
var $c702e238df7c5123$export$a62047d29c96d8ff = 1;
var $c702e238df7c5123$export$fadb74c06a7f490 = 2;
var $c702e238df7c5123$export$63b8d6b580fc65ba = 0;
var $c702e238df7c5123$export$5b29a26d96ee6af0 = 1;
var $c702e238df7c5123$export$777d8f9551c2216b = 2;
var $c702e238df7c5123$export$cdfa06f868e2e467 = 3;
var $c702e238df7c5123$export$4138e1c684b46a20 = 4;
var $c702e238df7c5123$export$eda4864c68df1fa2 = 5;
var $c702e238df7c5123$export$20183a0484ce21a0 = 100;
var $c702e238df7c5123$export$73e0df5177988548 = 101;
var $c702e238df7c5123$export$28e582859cbec660 = 102;
var $c702e238df7c5123$export$c8c1508da8d0600c = 103;
var $c702e238df7c5123$export$99948c02fb51055f = 104;
var $c702e238df7c5123$export$2110f05edf778d3d = 200;
var $c702e238df7c5123$export$8805bad65e24940e = 201;
var $c702e238df7c5123$export$7fbe15b28d28cf52 = 202;
var $c702e238df7c5123$export$947829af9f2c17f6 = 203;
var $c702e238df7c5123$export$d5773124e86cf28c = 204;
var $c702e238df7c5123$export$11d468cc7f19e971 = 205;
var $c702e238df7c5123$export$a78aed1ca2a87192 = 206;
var $c702e238df7c5123$export$5d0fe17fd8773bac = 207;
var $c702e238df7c5123$export$ef5f2dd8ffac5574 = 208;
var $c702e238df7c5123$export$56b85b2686ab16 = 209;
var $c702e238df7c5123$export$c05e2a1fc8609506 = 210;
var $c702e238df7c5123$export$69025ce147cee220 = 0;
var $c702e238df7c5123$export$7182eb52ea3b3f04 = 1;
var $c702e238df7c5123$export$eedccec66ab7ebe = 2;
var $c702e238df7c5123$export$296f78a0b892f81a = 3;
var $c702e238df7c5123$export$a60d398fc7b7590e = 4;
var $c702e238df7c5123$export$7d7234c1240a1fc4 = 5;
var $c702e238df7c5123$export$c5e2c52991f30937 = 6;
var $c702e238df7c5123$export$2f843afa843d8916 = 7;
var $c702e238df7c5123$export$e50ac29801f1774d = 0;
var $c702e238df7c5123$export$9f9d94f963c85479 = 1;
var $c702e238df7c5123$export$e641dc52bc3494aa = 2;
var $c702e238df7c5123$export$9fcb6b4294603b2 = 0;
var $c702e238df7c5123$export$98f52c2a46c598ca = 1;
var $c702e238df7c5123$export$74b25e54b3bcd548 = 2;
var $c702e238df7c5123$export$932b3dd283d4a366 = 3;
var $c702e238df7c5123$export$a0d98fe6d7e4af64 = 4;
var $c702e238df7c5123$export$2c7b09c1e9abfb5e = 5;
var $c702e238df7c5123$export$1beec6768cbb3d2d = 300;
var $c702e238df7c5123$export$8759762a6477f2c4 = 301;
var $c702e238df7c5123$export$dc59f8aed047f61d = 302;
var $c702e238df7c5123$export$d64030b316d3b087 = 303;
var $c702e238df7c5123$export$ee99d97d46898098 = 304;
var $c702e238df7c5123$export$dbf3e70ff37af79 = 306;
var $c702e238df7c5123$export$76a9f4355364345c = 307;
var $c702e238df7c5123$export$533346c8e8dac0f5 = 1000;
var $c702e238df7c5123$export$9d9334239a5a5e06 = 1001;
var $c702e238df7c5123$export$c7e7c00b14f51a4f = 1002;
var $c702e238df7c5123$export$727aa5ec3fe39bf0 = 1003;
var $c702e238df7c5123$export$d129e38cf6feaa8c = 1004;
var $c702e238df7c5123$export$14a4936464a36496 = 1004;
var $c702e238df7c5123$export$d2327c1afe5bfdf2 = 1005;
var $c702e238df7c5123$export$cbc5b7f5647595d8 = 1005;
var $c702e238df7c5123$export$8a72f490b25c56c8 = 1006;
var $c702e238df7c5123$export$19a719f377145a13 = 1007;
var $c702e238df7c5123$export$dbe96bee3fe9dbf0 = 1007;
var $c702e238df7c5123$export$5d8599b6a933fb1b = 1008;
var $c702e238df7c5123$export$90d80f1e3506775f = 1008;
var $c702e238df7c5123$export$2e8ce08d3f6f5e10 = 1009;
var $c702e238df7c5123$export$545fce0311a9796a = 1010;
var $c702e238df7c5123$export$88572337f312435f = 1011;
var $c702e238df7c5123$export$c63dc51868b06a9d = 1012;
var $c702e238df7c5123$export$5c612977753abe2 = 1013;
var $c702e238df7c5123$export$c3c7fc4518ebba96 = 1014;
var $c702e238df7c5123$export$f6d331659b644596 = 1015;
var $c702e238df7c5123$export$2697304443f382bc = 1016;
var $c702e238df7c5123$export$b3969b01faf587f2 = 1017;
var $c702e238df7c5123$export$18886f8ae33e90de = 1018;
var $c702e238df7c5123$export$cb1fa50553eb14c4 = 1019;
var $c702e238df7c5123$export$6c8ea339bfab1301 = 1020;
var $c702e238df7c5123$export$988473390501ed4b = 1021;
var $c702e238df7c5123$export$7c67423a5ee6f5eb = 1022;
var $c702e238df7c5123$export$3f8bb04b555a363c = 1023;
var $c702e238df7c5123$export$cc09ccbf6d1ed449 = 1024;
var $c702e238df7c5123$export$9053a81c4a69c289 = 1025;
var $c702e238df7c5123$export$7f419e36e2229a1d = $c702e238df7c5123$export$3f8bb04b555a363c;
var $c702e238df7c5123$export$c1b6b5136be58045 = 1026;
var $c702e238df7c5123$export$1e113ac2d0905829 = 1027;
var $c702e238df7c5123$export$4e041a7967d15c4b = 1028;
var $c702e238df7c5123$export$aa92e870a709d190 = 1029;
var $c702e238df7c5123$export$6cdf0b461c7ce8a0 = 1030;
var $c702e238df7c5123$export$1ba1c45f9f77d4d7 = 1031;
var $c702e238df7c5123$export$d1fd40c11bfa798e = 1032;
var $c702e238df7c5123$export$c200e7d26f592f21 = 1033;
var $c702e238df7c5123$export$21d1799c6d552fc0 = 33776;
var $c702e238df7c5123$export$afa304c3e981b668 = 33777;
var $c702e238df7c5123$export$d2a1a68024a3e56c = 33778;
var $c702e238df7c5123$export$9a79c424327dacf9 = 33779;
var $c702e238df7c5123$export$19ada9bbb1af3573 = 35840;
var $c702e238df7c5123$export$d0f0355bb3d948e4 = 35841;
var $c702e238df7c5123$export$b82296714358084c = 35842;
var $c702e238df7c5123$export$b71692456c47b6c3 = 35843;
var $c702e238df7c5123$export$6ab91af2d757aee7 = 36196;
var $c702e238df7c5123$export$7800993ef8106a6a = 37492;
var $c702e238df7c5123$export$23ed8300a860e7d8 = 37496;
var $c702e238df7c5123$export$dc5570b4a2b92d48 = 37808;
var $c702e238df7c5123$export$68880cd325f8b2fb = 37809;
var $c702e238df7c5123$export$7d2c0be323373d95 = 37810;
var $c702e238df7c5123$export$22b52da301fc3a3e = 37811;
var $c702e238df7c5123$export$c009e2cb4a66485e = 37812;
var $c702e238df7c5123$export$118fff5afa255b63 = 37813;
var $c702e238df7c5123$export$120713c829ae0667 = 37814;
var $c702e238df7c5123$export$c79eeabbf53313e9 = 37815;
var $c702e238df7c5123$export$443cf6567cdd6424 = 37816;
var $c702e238df7c5123$export$6573984fc9840780 = 37817;
var $c702e238df7c5123$export$e7aee563f30091de = 37818;
var $c702e238df7c5123$export$2eb8634622ddeab7 = 37819;
var $c702e238df7c5123$export$202b1ce7b5d25742 = 37820;
var $c702e238df7c5123$export$18ab77abd087e467 = 37821;
var $c702e238df7c5123$export$ce40b115e188bc81 = 36492;
var $c702e238df7c5123$export$4487000d1baf578b = 37840;
var $c702e238df7c5123$export$4a1746c7512b1ea1 = 37841;
var $c702e238df7c5123$export$4208debc782f5653 = 37842;
var $c702e238df7c5123$export$82c5f9d3037aaea3 = 37843;
var $c702e238df7c5123$export$64e357a152723eb9 = 37844;
var $c702e238df7c5123$export$1b7711037f5e380e = 37845;
var $c702e238df7c5123$export$eb234716dfb52c31 = 37846;
var $c702e238df7c5123$export$8041d2df79c555f = 37847;
var $c702e238df7c5123$export$27d2c8c0fcc7b83a = 37848;
var $c702e238df7c5123$export$27b9de07b84a1334 = 37849;
var $c702e238df7c5123$export$5c2b31a31ccc15c8 = 37850;
var $c702e238df7c5123$export$5c4d4b335786f8f3 = 37851;
var $c702e238df7c5123$export$e0c50c800e38be11 = 37852;
var $c702e238df7c5123$export$9b0442bae422b2db = 37853;
var $c702e238df7c5123$export$d62fdc9d1b1cccad = 2200;
var $c702e238df7c5123$export$dfaf4422ce096e29 = 2201;
var $c702e238df7c5123$export$f8f6f2041b78e210 = 2202;
var $c702e238df7c5123$export$995b32462a65e855 = 2300;
var $c702e238df7c5123$export$30fac1aace31cf4d = 2301;
var $c702e238df7c5123$export$198b11ff4c72bb30 = 2302;
var $c702e238df7c5123$export$7f795934b84ab523 = 2400;
var $c702e238df7c5123$export$24a4ccb5099273b5 = 2401;
var $c702e238df7c5123$export$8e8c3ecdcd8e1fee = 2402;
var $c702e238df7c5123$export$bcfbbdcf8de7f8cd = 2500;
var $c702e238df7c5123$export$d875e029ef558d3 = 2501;
var $c702e238df7c5123$export$4c28c87c2dc84758 = 0;
var $c702e238df7c5123$export$b23a071aa286eb29 = 1;
var $c702e238df7c5123$export$f0d8293634f88842 = 2;
var $c702e238df7c5123$export$7207336e4151a112 = 3000;
var $c702e238df7c5123$export$f32388edbb32674 = 3001;
var $c702e238df7c5123$export$eaab32c1bcea1817 = 3007;
var $c702e238df7c5123$export$3be4c466a12b5dcf = 3002;
var $c702e238df7c5123$export$8d4cbbeb1eea9f67 = 3003;
var $c702e238df7c5123$export$2c4bdfd76b188654 = 3004;
var $c702e238df7c5123$export$48a0051d6a5a9b9 = 3005;
var $c702e238df7c5123$export$ca2f89b13b49d951 = 3006;
var $c702e238df7c5123$export$deeb383078690b50 = 3200;
var $c702e238df7c5123$export$8f910f4c4f73df11 = 3201;
var $c702e238df7c5123$export$2852a58ebdac27b8 = 0;
var $c702e238df7c5123$export$9990ad26f9db5b2c = 1;
var $c702e238df7c5123$export$69433f11f42d5527 = 0;
var $c702e238df7c5123$export$9f542ae4b5baca34 = 7680;
var $c702e238df7c5123$export$8a4f28336ef203d3 = 7681;
var $c702e238df7c5123$export$2928c0231297c036 = 7682;
var $c702e238df7c5123$export$c0e9611c8a15f9a8 = 7683;
var $c702e238df7c5123$export$9c2c08927385dcc4 = 34055;
var $c702e238df7c5123$export$7c74ea00fa1315e6 = 34056;
var $c702e238df7c5123$export$22e2e5726612443 = 5386;
var $c702e238df7c5123$export$1343870698229224 = 512;
var $c702e238df7c5123$export$8e1d8ed281997fa6 = 513;
var $c702e238df7c5123$export$55648a1cde8329a7 = 514;
var $c702e238df7c5123$export$2dff107857e6aca2 = 515;
var $c702e238df7c5123$export$6f93765ab2f451a2 = 516;
var $c702e238df7c5123$export$6f3fb2d2440f2b76 = 517;
var $c702e238df7c5123$export$4119cf7b4c98fd5a = 518;
var $c702e238df7c5123$export$14cf96713ddd97a8 = 519;
var $c702e238df7c5123$export$763e8360f4d7f77d = 35044;
var $c702e238df7c5123$export$8505d14ac8546ca = 35048;
var $c702e238df7c5123$export$721e63549e51d81e = 35040;
var $c702e238df7c5123$export$415731dc4f48e299 = 35045;
var $c702e238df7c5123$export$9e809946455f13bc = 35049;
var $c702e238df7c5123$export$2ed9499a35b5f832 = 35041;
var $c702e238df7c5123$export$32ab2503ea19469a = 35046;
var $c702e238df7c5123$export$ab4022c2c3f86315 = 35050;
var $c702e238df7c5123$export$ba7f1db36a76a970 = 35042;
var $c702e238df7c5123$export$43600cc67fabd9f = '100';
var $c702e238df7c5123$export$f63012db5506e7dd = '300 es';
/**
 * https://github.com/mrdoob/eventdispatcher.js/
 */ var $c702e238df7c5123$export$ec8b666c5fe2c75a = /*#__PURE__*/ function() {
    "use strict";
    function EventDispatcher() {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, EventDispatcher);
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(EventDispatcher, [
        {
            key: "addEventListener",
            value: function addEventListener(type, listener) {
                if (this._listeners === undefined) this._listeners = {};
                var listeners = this._listeners;
                if (listeners[type] === undefined) listeners[type] = [];
                if (listeners[type].indexOf(listener) === -1) listeners[type].push(listener);
            }
        },
        {
            key: "hasEventListener",
            value: function hasEventListener(type, listener) {
                if (this._listeners === undefined) return false;
                var listeners = this._listeners;
                return listeners[type] !== undefined && listeners[type].indexOf(listener) !== -1;
            }
        },
        {
            key: "removeEventListener",
            value: function removeEventListener(type, listener) {
                if (this._listeners === undefined) return;
                var listeners = this._listeners;
                var listenerArray = listeners[type];
                if (listenerArray !== undefined) {
                    var index = listenerArray.indexOf(listener);
                    if (index !== -1) listenerArray.splice(index, 1);
                }
            }
        },
        {
            key: "dispatchEvent",
            value: function dispatchEvent(event) {
                if (this._listeners === undefined) return;
                var listeners = this._listeners;
                var listenerArray = listeners[event.type];
                if (listenerArray !== undefined) {
                    event.target = this;
                    // Make a copy, in case listeners are removed while iterating.
                    var array = listenerArray.slice(0);
                    for(var i = 0, l = array.length; i < l; i++)array[i].call(this, event);
                    event.target = null;
                }
            }
        }
    ]);
    return EventDispatcher;
}();
var $c702e238df7c5123$var$_lut = [];
for(var $c702e238df7c5123$var$i = 0; $c702e238df7c5123$var$i < 256; $c702e238df7c5123$var$i++)$c702e238df7c5123$var$_lut[$c702e238df7c5123$var$i] = ($c702e238df7c5123$var$i < 16 ? '0' : '') + $c702e238df7c5123$var$i.toString(16);
var $c702e238df7c5123$var$_seed = 1234567;
var $c702e238df7c5123$var$DEG2RAD = Math.PI / 180;
var $c702e238df7c5123$var$RAD2DEG = 180 / Math.PI;
// http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
function $c702e238df7c5123$var$generateUUID() {
    var d0 = Math.random() * 0xffffffff | 0;
    var d1 = Math.random() * 0xffffffff | 0;
    var d2 = Math.random() * 0xffffffff | 0;
    var d3 = Math.random() * 0xffffffff | 0;
    var uuid = $c702e238df7c5123$var$_lut[d0 & 0xff] + $c702e238df7c5123$var$_lut[d0 >> 8 & 0xff] + $c702e238df7c5123$var$_lut[d0 >> 16 & 0xff] + $c702e238df7c5123$var$_lut[d0 >> 24 & 0xff] + '-' + $c702e238df7c5123$var$_lut[d1 & 0xff] + $c702e238df7c5123$var$_lut[d1 >> 8 & 0xff] + '-' + $c702e238df7c5123$var$_lut[d1 >> 16 & 0x0f | 0x40] + $c702e238df7c5123$var$_lut[d1 >> 24 & 0xff] + '-' + $c702e238df7c5123$var$_lut[d2 & 0x3f | 0x80] + $c702e238df7c5123$var$_lut[d2 >> 8 & 0xff] + '-' + $c702e238df7c5123$var$_lut[d2 >> 16 & 0xff] + $c702e238df7c5123$var$_lut[d2 >> 24 & 0xff] + $c702e238df7c5123$var$_lut[d3 & 0xff] + $c702e238df7c5123$var$_lut[d3 >> 8 & 0xff] + $c702e238df7c5123$var$_lut[d3 >> 16 & 0xff] + $c702e238df7c5123$var$_lut[d3 >> 24 & 0xff];
    // .toUpperCase() here flattens concatenated strings to save heap memory space.
    return uuid.toUpperCase();
}
function $c702e238df7c5123$var$clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
// compute euclidian modulo of m % n
// https://en.wikipedia.org/wiki/Modulo_operation
function $c702e238df7c5123$var$euclideanModulo(n, m) {
    return (n % m + m) % m;
}
// Linear mapping from range <a1, a2> to range <b1, b2>
function $c702e238df7c5123$var$mapLinear(x, a1, a2, b1, b2) {
    return b1 + (x - a1) * (b2 - b1) / (a2 - a1);
}
// https://www.gamedev.net/tutorials/programming/general-and-gameplay-programming/inverse-lerp-a-super-useful-yet-often-overlooked-function-r5230/
function $c702e238df7c5123$var$inverseLerp(x, y, value) {
    if (x !== y) return (value - x) / (y - x);
    else return 0;
}
// https://en.wikipedia.org/wiki/Linear_interpolation
function $c702e238df7c5123$var$lerp(x, y, t) {
    return (1 - t) * x + t * y;
}
// http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/
function $c702e238df7c5123$var$damp(x, y, lambda, dt) {
    return $c702e238df7c5123$var$lerp(x, y, 1 - Math.exp(-lambda * dt));
}
// https://www.desmos.com/calculator/vcsjnyz7x4
function $c702e238df7c5123$var$pingpong(x) {
    var length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    return length - Math.abs($c702e238df7c5123$var$euclideanModulo(x, length * 2) - length);
}
// http://en.wikipedia.org/wiki/Smoothstep
function $c702e238df7c5123$var$smoothstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * (3 - 2 * x);
}
function $c702e238df7c5123$var$smootherstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * x * (x * (x * 6 - 15) + 10);
}
// Random integer from <low, high> interval
function $c702e238df7c5123$var$randInt(low, high) {
    return low + Math.floor(Math.random() * (high - low + 1));
}
// Random float from <low, high> interval
function $c702e238df7c5123$var$randFloat(low, high) {
    return low + Math.random() * (high - low);
}
// Random float from <-range/2, range/2> interval
function $c702e238df7c5123$var$randFloatSpread(range) {
    return range * (0.5 - Math.random());
}
// Deterministic pseudo-random float in the interval [ 0, 1 ]
function $c702e238df7c5123$var$seededRandom(s) {
    if (s !== undefined) $c702e238df7c5123$var$_seed = s % 2147483647;
    // Park-Miller algorithm
    $c702e238df7c5123$var$_seed = $c702e238df7c5123$var$_seed * 16807 % 2147483647;
    return ($c702e238df7c5123$var$_seed - 1) / 2147483646;
}
function $c702e238df7c5123$var$degToRad(degrees) {
    return degrees * $c702e238df7c5123$var$DEG2RAD;
}
function $c702e238df7c5123$var$radToDeg(radians) {
    return radians * $c702e238df7c5123$var$RAD2DEG;
}
function $c702e238df7c5123$var$isPowerOfTwo(value) {
    return (value & value - 1) === 0 && value !== 0;
}
function $c702e238df7c5123$var$ceilPowerOfTwo(value) {
    return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
}
function $c702e238df7c5123$var$floorPowerOfTwo(value) {
    return Math.pow(2, Math.floor(Math.log(value) / Math.LN2));
}
function $c702e238df7c5123$var$setQuaternionFromProperEuler(q, a, b, c, order) {
    // Intrinsic Proper Euler Angles - see https://en.wikipedia.org/wiki/Euler_angles
    // rotations are applied to the axes in the order specified by 'order'
    // rotation by angle 'a' is applied first, then by angle 'b', then by angle 'c'
    // angles are in radians
    var cos = Math.cos;
    var sin = Math.sin;
    var c2 = cos(b / 2);
    var s2 = sin(b / 2);
    var c13 = cos((a + c) / 2);
    var s13 = sin((a + c) / 2);
    var c1_3 = cos((a - c) / 2);
    var s1_3 = sin((a - c) / 2);
    var c3_1 = cos((c - a) / 2);
    var s3_1 = sin((c - a) / 2);
    switch(order){
        case 'XYX':
            q.set(c2 * s13, s2 * c1_3, s2 * s1_3, c2 * c13);
            break;
        case 'YZY':
            q.set(s2 * s1_3, c2 * s13, s2 * c1_3, c2 * c13);
            break;
        case 'ZXZ':
            q.set(s2 * c1_3, s2 * s1_3, c2 * s13, c2 * c13);
            break;
        case 'XZX':
            q.set(c2 * s13, s2 * s3_1, s2 * c3_1, c2 * c13);
            break;
        case 'YXY':
            q.set(s2 * c3_1, c2 * s13, s2 * s3_1, c2 * c13);
            break;
        case 'ZYZ':
            q.set(s2 * s3_1, s2 * c3_1, c2 * s13, c2 * c13);
            break;
        default:
            console.warn('THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: ' + order);
    }
}
var $c702e238df7c5123$export$380958644dbbc22b = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    DEG2RAD: $c702e238df7c5123$var$DEG2RAD,
    RAD2DEG: $c702e238df7c5123$var$RAD2DEG,
    generateUUID: $c702e238df7c5123$var$generateUUID,
    clamp: $c702e238df7c5123$var$clamp,
    euclideanModulo: $c702e238df7c5123$var$euclideanModulo,
    mapLinear: $c702e238df7c5123$var$mapLinear,
    inverseLerp: $c702e238df7c5123$var$inverseLerp,
    lerp: $c702e238df7c5123$var$lerp,
    damp: $c702e238df7c5123$var$damp,
    pingpong: $c702e238df7c5123$var$pingpong,
    smoothstep: $c702e238df7c5123$var$smoothstep,
    smootherstep: $c702e238df7c5123$var$smootherstep,
    randInt: $c702e238df7c5123$var$randInt,
    randFloat: $c702e238df7c5123$var$randFloat,
    randFloatSpread: $c702e238df7c5123$var$randFloatSpread,
    seededRandom: $c702e238df7c5123$var$seededRandom,
    degToRad: $c702e238df7c5123$var$degToRad,
    radToDeg: $c702e238df7c5123$var$radToDeg,
    isPowerOfTwo: $c702e238df7c5123$var$isPowerOfTwo,
    ceilPowerOfTwo: $c702e238df7c5123$var$ceilPowerOfTwo,
    floorPowerOfTwo: $c702e238df7c5123$var$floorPowerOfTwo,
    setQuaternionFromProperEuler: $c702e238df7c5123$var$setQuaternionFromProperEuler
});
var $c702e238df7c5123$export$c977b3e384af9ae1 = /*#__PURE__*/ function() {
    "use strict";
    function Vector2() {
        var x = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Vector2);
        this.x = x;
        this.y = y;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(Vector2, [
        {
            key: "width",
            get: function get() {
                return this.x;
            },
            set: function set(value) {
                this.x = value;
            }
        },
        {
            key: "height",
            get: function get() {
                return this.y;
            },
            set: function set(value) {
                this.y = value;
            }
        },
        {
            key: "set",
            value: function set(x, y) {
                this.x = x;
                this.y = y;
                return this;
            }
        },
        {
            key: "setScalar",
            value: function setScalar(scalar) {
                this.x = scalar;
                this.y = scalar;
                return this;
            }
        },
        {
            key: "setX",
            value: function setX(x) {
                this.x = x;
                return this;
            }
        },
        {
            key: "setY",
            value: function setY(y) {
                this.y = y;
                return this;
            }
        },
        {
            key: "setComponent",
            value: function setComponent(index, value) {
                switch(index){
                    case 0:
                        this.x = value;
                        break;
                    case 1:
                        this.y = value;
                        break;
                    default:
                        throw new Error('index is out of range: ' + index);
                }
                return this;
            }
        },
        {
            key: "getComponent",
            value: function getComponent(index) {
                switch(index){
                    case 0:
                        return this.x;
                    case 1:
                        return this.y;
                    default:
                        throw new Error('index is out of range: ' + index);
                }
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor(this.x, this.y);
            }
        },
        {
            key: "copy",
            value: function copy(v) {
                this.x = v.x;
                this.y = v.y;
                return this;
            }
        },
        {
            key: "add",
            value: function add(v, w) {
                if (w !== undefined) {
                    console.warn('THREE.Vector2: .add() now only accepts one argument. Use .addVectors( a, b ) instead.');
                    return this.addVectors(v, w);
                }
                this.x += v.x;
                this.y += v.y;
                return this;
            }
        },
        {
            key: "addScalar",
            value: function addScalar(s) {
                this.x += s;
                this.y += s;
                return this;
            }
        },
        {
            key: "addVectors",
            value: function addVectors(a, b) {
                this.x = a.x + b.x;
                this.y = a.y + b.y;
                return this;
            }
        },
        {
            key: "addScaledVector",
            value: function addScaledVector(v, s) {
                this.x += v.x * s;
                this.y += v.y * s;
                return this;
            }
        },
        {
            key: "sub",
            value: function sub(v, w) {
                if (w !== undefined) {
                    console.warn('THREE.Vector2: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.');
                    return this.subVectors(v, w);
                }
                this.x -= v.x;
                this.y -= v.y;
                return this;
            }
        },
        {
            key: "subScalar",
            value: function subScalar(s) {
                this.x -= s;
                this.y -= s;
                return this;
            }
        },
        {
            key: "subVectors",
            value: function subVectors(a, b) {
                this.x = a.x - b.x;
                this.y = a.y - b.y;
                return this;
            }
        },
        {
            key: "multiply",
            value: function multiply(v) {
                this.x *= v.x;
                this.y *= v.y;
                return this;
            }
        },
        {
            key: "multiplyScalar",
            value: function multiplyScalar(scalar) {
                this.x *= scalar;
                this.y *= scalar;
                return this;
            }
        },
        {
            key: "divide",
            value: function divide(v) {
                this.x /= v.x;
                this.y /= v.y;
                return this;
            }
        },
        {
            key: "divideScalar",
            value: function divideScalar(scalar) {
                return this.multiplyScalar(1 / scalar);
            }
        },
        {
            key: "applyMatrix3",
            value: function applyMatrix3(m) {
                var x = this.x, y = this.y;
                var e = m.elements;
                this.x = e[0] * x + e[3] * y + e[6];
                this.y = e[1] * x + e[4] * y + e[7];
                return this;
            }
        },
        {
            key: "min",
            value: function min(v) {
                this.x = Math.min(this.x, v.x);
                this.y = Math.min(this.y, v.y);
                return this;
            }
        },
        {
            key: "max",
            value: function max(v) {
                this.x = Math.max(this.x, v.x);
                this.y = Math.max(this.y, v.y);
                return this;
            }
        },
        {
            key: "clamp",
            value: function clamp(min, max) {
                // assumes min < max, componentwise
                this.x = Math.max(min.x, Math.min(max.x, this.x));
                this.y = Math.max(min.y, Math.min(max.y, this.y));
                return this;
            }
        },
        {
            key: "clampScalar",
            value: function clampScalar(minVal, maxVal) {
                this.x = Math.max(minVal, Math.min(maxVal, this.x));
                this.y = Math.max(minVal, Math.min(maxVal, this.y));
                return this;
            }
        },
        {
            key: "clampLength",
            value: function clampLength(min, max) {
                var length = this.length();
                return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
            }
        },
        {
            key: "floor",
            value: function floor() {
                this.x = Math.floor(this.x);
                this.y = Math.floor(this.y);
                return this;
            }
        },
        {
            key: "ceil",
            value: function ceil() {
                this.x = Math.ceil(this.x);
                this.y = Math.ceil(this.y);
                return this;
            }
        },
        {
            key: "round",
            value: function round() {
                this.x = Math.round(this.x);
                this.y = Math.round(this.y);
                return this;
            }
        },
        {
            key: "roundToZero",
            value: function roundToZero() {
                this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
                this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
                return this;
            }
        },
        {
            key: "negate",
            value: function negate() {
                this.x = -this.x;
                this.y = -this.y;
                return this;
            }
        },
        {
            key: "dot",
            value: function dot(v) {
                return this.x * v.x + this.y * v.y;
            }
        },
        {
            key: "cross",
            value: function cross(v) {
                return this.x * v.y - this.y * v.x;
            }
        },
        {
            key: "lengthSq",
            value: function lengthSq() {
                return this.x * this.x + this.y * this.y;
            }
        },
        {
            key: "length",
            value: function length() {
                return Math.sqrt(this.x * this.x + this.y * this.y);
            }
        },
        {
            key: "manhattanLength",
            value: function manhattanLength() {
                return Math.abs(this.x) + Math.abs(this.y);
            }
        },
        {
            key: "normalize",
            value: function normalize() {
                return this.divideScalar(this.length() || 1);
            }
        },
        {
            key: "angle",
            value: function angle() {
                // computes the angle in radians with respect to the positive x-axis
                var angle = Math.atan2(-this.y, -this.x) + Math.PI;
                return angle;
            }
        },
        {
            key: "distanceTo",
            value: function distanceTo(v) {
                return Math.sqrt(this.distanceToSquared(v));
            }
        },
        {
            key: "distanceToSquared",
            value: function distanceToSquared(v) {
                var dx = this.x - v.x, dy = this.y - v.y;
                return dx * dx + dy * dy;
            }
        },
        {
            key: "manhattanDistanceTo",
            value: function manhattanDistanceTo(v) {
                return Math.abs(this.x - v.x) + Math.abs(this.y - v.y);
            }
        },
        {
            key: "setLength",
            value: function setLength(length) {
                return this.normalize().multiplyScalar(length);
            }
        },
        {
            key: "lerp",
            value: function lerp(v, alpha) {
                this.x += (v.x - this.x) * alpha;
                this.y += (v.y - this.y) * alpha;
                return this;
            }
        },
        {
            key: "lerpVectors",
            value: function lerpVectors(v1, v2, alpha) {
                this.x = v1.x + (v2.x - v1.x) * alpha;
                this.y = v1.y + (v2.y - v1.y) * alpha;
                return this;
            }
        },
        {
            key: "equals",
            value: function equals(v) {
                return v.x === this.x && v.y === this.y;
            }
        },
        {
            key: "fromArray",
            value: function fromArray(array) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                this.x = array[offset];
                this.y = array[offset + 1];
                return this;
            }
        },
        {
            key: "toArray",
            value: function toArray() {
                var array = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                array[offset] = this.x;
                array[offset + 1] = this.y;
                return array;
            }
        },
        {
            key: "fromBufferAttribute",
            value: function fromBufferAttribute(attribute, index, offset) {
                if (offset !== undefined) console.warn('THREE.Vector2: offset has been removed from .fromBufferAttribute().');
                this.x = attribute.getX(index);
                this.y = attribute.getY(index);
                return this;
            }
        },
        {
            key: "rotateAround",
            value: function rotateAround(center, angle) {
                var c = Math.cos(angle), s = Math.sin(angle);
                var x = this.x - center.x;
                var y = this.y - center.y;
                this.x = x * c - y * s + center.x;
                this.y = x * s + y * c + center.y;
                return this;
            }
        },
        {
            key: "random",
            value: function random() {
                this.x = Math.random();
                this.y = Math.random();
                return this;
            }
        }
    ]);
    return Vector2;
}();
$c702e238df7c5123$export$c977b3e384af9ae1.prototype.isVector2 = true;
var $c702e238df7c5123$export$8ff26dafa08918 = /*#__PURE__*/ function() {
    "use strict";
    function Matrix3() {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Matrix3);
        this.elements = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (arguments.length > 0) console.error('THREE.Matrix3: the constructor no longer reads arguments. use .set() instead.');
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(Matrix3, [
        {
            key: "set",
            value: function set(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
                var te = this.elements;
                te[0] = n11;
                te[1] = n21;
                te[2] = n31;
                te[3] = n12;
                te[4] = n22;
                te[5] = n32;
                te[6] = n13;
                te[7] = n23;
                te[8] = n33;
                return this;
            }
        },
        {
            key: "identity",
            value: function identity() {
                this.set(1, 0, 0, 0, 1, 0, 0, 0, 1);
                return this;
            }
        },
        {
            key: "copy",
            value: function copy(m) {
                var te = this.elements;
                var me = m.elements;
                te[0] = me[0];
                te[1] = me[1];
                te[2] = me[2];
                te[3] = me[3];
                te[4] = me[4];
                te[5] = me[5];
                te[6] = me[6];
                te[7] = me[7];
                te[8] = me[8];
                return this;
            }
        },
        {
            key: "extractBasis",
            value: function extractBasis(xAxis, yAxis, zAxis) {
                xAxis.setFromMatrix3Column(this, 0);
                yAxis.setFromMatrix3Column(this, 1);
                zAxis.setFromMatrix3Column(this, 2);
                return this;
            }
        },
        {
            key: "setFromMatrix4",
            value: function setFromMatrix4(m) {
                var me = m.elements;
                this.set(me[0], me[4], me[8], me[1], me[5], me[9], me[2], me[6], me[10]);
                return this;
            }
        },
        {
            key: "multiply",
            value: function multiply(m) {
                return this.multiplyMatrices(this, m);
            }
        },
        {
            key: "premultiply",
            value: function premultiply(m) {
                return this.multiplyMatrices(m, this);
            }
        },
        {
            key: "multiplyMatrices",
            value: function multiplyMatrices(a, b) {
                var ae = a.elements;
                var be = b.elements;
                var te = this.elements;
                var a11 = ae[0], a12 = ae[3], a13 = ae[6];
                var a21 = ae[1], a22 = ae[4], a23 = ae[7];
                var a31 = ae[2], a32 = ae[5], a33 = ae[8];
                var b11 = be[0], b12 = be[3], b13 = be[6];
                var b21 = be[1], b22 = be[4], b23 = be[7];
                var b31 = be[2], b32 = be[5], b33 = be[8];
                te[0] = a11 * b11 + a12 * b21 + a13 * b31;
                te[3] = a11 * b12 + a12 * b22 + a13 * b32;
                te[6] = a11 * b13 + a12 * b23 + a13 * b33;
                te[1] = a21 * b11 + a22 * b21 + a23 * b31;
                te[4] = a21 * b12 + a22 * b22 + a23 * b32;
                te[7] = a21 * b13 + a22 * b23 + a23 * b33;
                te[2] = a31 * b11 + a32 * b21 + a33 * b31;
                te[5] = a31 * b12 + a32 * b22 + a33 * b32;
                te[8] = a31 * b13 + a32 * b23 + a33 * b33;
                return this;
            }
        },
        {
            key: "multiplyScalar",
            value: function multiplyScalar(s) {
                var te = this.elements;
                te[0] *= s;
                te[3] *= s;
                te[6] *= s;
                te[1] *= s;
                te[4] *= s;
                te[7] *= s;
                te[2] *= s;
                te[5] *= s;
                te[8] *= s;
                return this;
            }
        },
        {
            key: "determinant",
            value: function determinant() {
                var te = this.elements;
                var a = te[0], b = te[1], c = te[2], d = te[3], e = te[4], f = te[5], g = te[6], h = te[7], i = te[8];
                return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;
            }
        },
        {
            key: "invert",
            value: function invert() {
                var te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n12 = te[3], n22 = te[4], n32 = te[5], n13 = te[6], n23 = te[7], n33 = te[8], t11 = n33 * n22 - n32 * n23, t12 = n32 * n13 - n33 * n12, t13 = n23 * n12 - n22 * n13, det = n11 * t11 + n21 * t12 + n31 * t13;
                if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
                var detInv = 1 / det;
                te[0] = t11 * detInv;
                te[1] = (n31 * n23 - n33 * n21) * detInv;
                te[2] = (n32 * n21 - n31 * n22) * detInv;
                te[3] = t12 * detInv;
                te[4] = (n33 * n11 - n31 * n13) * detInv;
                te[5] = (n31 * n12 - n32 * n11) * detInv;
                te[6] = t13 * detInv;
                te[7] = (n21 * n13 - n23 * n11) * detInv;
                te[8] = (n22 * n11 - n21 * n12) * detInv;
                return this;
            }
        },
        {
            key: "transpose",
            value: function transpose() {
                var tmp;
                var m = this.elements;
                tmp = m[1];
                m[1] = m[3];
                m[3] = tmp;
                tmp = m[2];
                m[2] = m[6];
                m[6] = tmp;
                tmp = m[5];
                m[5] = m[7];
                m[7] = tmp;
                return this;
            }
        },
        {
            key: "getNormalMatrix",
            value: function getNormalMatrix(matrix4) {
                return this.setFromMatrix4(matrix4).invert().transpose();
            }
        },
        {
            key: "transposeIntoArray",
            value: function transposeIntoArray(r) {
                var m = this.elements;
                r[0] = m[0];
                r[1] = m[3];
                r[2] = m[6];
                r[3] = m[1];
                r[4] = m[4];
                r[5] = m[7];
                r[6] = m[2];
                r[7] = m[5];
                r[8] = m[8];
                return this;
            }
        },
        {
            key: "setUvTransform",
            value: function setUvTransform(tx, ty, sx, sy, rotation, cx, cy) {
                var c = Math.cos(rotation);
                var s = Math.sin(rotation);
                this.set(sx * c, sx * s, -sx * (c * cx + s * cy) + cx + tx, -sy * s, sy * c, -sy * (-s * cx + c * cy) + cy + ty, 0, 0, 1);
                return this;
            }
        },
        {
            key: "scale",
            value: function scale(sx, sy) {
                var te = this.elements;
                te[0] *= sx;
                te[3] *= sx;
                te[6] *= sx;
                te[1] *= sy;
                te[4] *= sy;
                te[7] *= sy;
                return this;
            }
        },
        {
            key: "rotate",
            value: function rotate(theta) {
                var c = Math.cos(theta);
                var s = Math.sin(theta);
                var te = this.elements;
                var a11 = te[0], a12 = te[3], a13 = te[6];
                var a21 = te[1], a22 = te[4], a23 = te[7];
                te[0] = c * a11 + s * a21;
                te[3] = c * a12 + s * a22;
                te[6] = c * a13 + s * a23;
                te[1] = -s * a11 + c * a21;
                te[4] = -s * a12 + c * a22;
                te[7] = -s * a13 + c * a23;
                return this;
            }
        },
        {
            key: "translate",
            value: function translate(tx, ty) {
                var te = this.elements;
                te[0] += tx * te[2];
                te[3] += tx * te[5];
                te[6] += tx * te[8];
                te[1] += ty * te[2];
                te[4] += ty * te[5];
                te[7] += ty * te[8];
                return this;
            }
        },
        {
            key: "equals",
            value: function equals(matrix) {
                var te = this.elements;
                var me = matrix.elements;
                for(var i = 0; i < 9; i++){
                    if (te[i] !== me[i]) return false;
                }
                return true;
            }
        },
        {
            key: "fromArray",
            value: function fromArray(array) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                for(var i = 0; i < 9; i++)this.elements[i] = array[i + offset];
                return this;
            }
        },
        {
            key: "toArray",
            value: function toArray() {
                var array = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var te = this.elements;
                array[offset] = te[0];
                array[offset + 1] = te[1];
                array[offset + 2] = te[2];
                array[offset + 3] = te[3];
                array[offset + 4] = te[4];
                array[offset + 5] = te[5];
                array[offset + 6] = te[6];
                array[offset + 7] = te[7];
                array[offset + 8] = te[8];
                return array;
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor().fromArray(this.elements);
            }
        }
    ]);
    return Matrix3;
}();
$c702e238df7c5123$export$8ff26dafa08918.prototype.isMatrix3 = true;
var $c702e238df7c5123$var$_canvas;
var $c702e238df7c5123$export$698882cf06df44aa = /*#__PURE__*/ function() {
    "use strict";
    function ImageUtils() {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, ImageUtils);
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(ImageUtils, null, [
        {
            key: "getDataURL",
            value: function getDataURL(image) {
                if (/^data:/i.test(image.src)) return image.src;
                if (typeof HTMLCanvasElement == 'undefined') return image.src;
                var canvas;
                if (image instanceof HTMLCanvasElement) canvas = image;
                else {
                    if ($c702e238df7c5123$var$_canvas === undefined) $c702e238df7c5123$var$_canvas = document.createElementNS('http://www.w3.org/1999/xhtml', 'canvas');
                    $c702e238df7c5123$var$_canvas.width = image.width;
                    $c702e238df7c5123$var$_canvas.height = image.height;
                    var context = $c702e238df7c5123$var$_canvas.getContext('2d');
                    if (image instanceof ImageData) context.putImageData(image, 0, 0);
                    else context.drawImage(image, 0, 0, image.width, image.height);
                    canvas = $c702e238df7c5123$var$_canvas;
                }
                if (canvas.width > 2048 || canvas.height > 2048) {
                    console.warn('THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons', image);
                    return canvas.toDataURL('image/jpeg', 0.6);
                } else return canvas.toDataURL('image/png');
            }
        }
    ]);
    return ImageUtils;
}();
var $c702e238df7c5123$var$textureId = 0;
var $c702e238df7c5123$export$5431306cf43de24a = /*#__PURE__*/ function(EventDispatcher) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(Texture, EventDispatcher);
    function Texture() {
        var image = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Texture.DEFAULT_IMAGE, mapping = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Texture.DEFAULT_MAPPING, wrapS = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $c702e238df7c5123$export$9d9334239a5a5e06, wrapT = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $c702e238df7c5123$export$9d9334239a5a5e06, magFilter = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : $c702e238df7c5123$export$8a72f490b25c56c8, minFilter = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : $c702e238df7c5123$export$5d8599b6a933fb1b, format = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : $c702e238df7c5123$export$3f8bb04b555a363c, type = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : $c702e238df7c5123$export$2e8ce08d3f6f5e10, anisotropy = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : 1, encoding = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : $c702e238df7c5123$export$7207336e4151a112;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Texture);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, Texture);
        Object.defineProperty(_this, 'id', {
            value: $c702e238df7c5123$var$textureId++
        });
        _this.uuid = $c702e238df7c5123$var$generateUUID();
        _this.name = '';
        _this.image = image;
        _this.mipmaps = [];
        _this.mapping = mapping;
        _this.wrapS = wrapS;
        _this.wrapT = wrapT;
        _this.magFilter = magFilter;
        _this.minFilter = minFilter;
        _this.anisotropy = anisotropy;
        _this.format = format;
        _this.internalFormat = null;
        _this.type = type;
        _this.offset = new $c702e238df7c5123$export$c977b3e384af9ae1(0, 0);
        _this.repeat = new $c702e238df7c5123$export$c977b3e384af9ae1(1, 1);
        _this.center = new $c702e238df7c5123$export$c977b3e384af9ae1(0, 0);
        _this.rotation = 0;
        _this.matrixAutoUpdate = true;
        _this.matrix = new $c702e238df7c5123$export$8ff26dafa08918();
        _this.generateMipmaps = true;
        _this.premultiplyAlpha = false;
        _this.flipY = true;
        _this.unpackAlignment = 4; // valid values: 1, 2, 4, 8 (see http://www.khronos.org/opengles/sdk/docs/man/xhtml/glPixelStorei.xml)
        // Values of encoding !== THREE.LinearEncoding only supported on map, envMap and emissiveMap.
        //
        // Also changing the encoding after already used by a Material will not automatically make the Material
        // update. You need to explicitly call Material.needsUpdate to trigger it to recompile.
        _this.encoding = encoding;
        _this.version = 0;
        _this.onUpdate = null;
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(Texture, [
        {
            key: "updateMatrix",
            value: function updateMatrix() {
                this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                this.name = source.name;
                this.image = source.image;
                this.mipmaps = source.mipmaps.slice(0);
                this.mapping = source.mapping;
                this.wrapS = source.wrapS;
                this.wrapT = source.wrapT;
                this.magFilter = source.magFilter;
                this.minFilter = source.minFilter;
                this.anisotropy = source.anisotropy;
                this.format = source.format;
                this.internalFormat = source.internalFormat;
                this.type = source.type;
                this.offset.copy(source.offset);
                this.repeat.copy(source.repeat);
                this.center.copy(source.center);
                this.rotation = source.rotation;
                this.matrixAutoUpdate = source.matrixAutoUpdate;
                this.matrix.copy(source.matrix);
                this.generateMipmaps = source.generateMipmaps;
                this.premultiplyAlpha = source.premultiplyAlpha;
                this.flipY = source.flipY;
                this.unpackAlignment = source.unpackAlignment;
                this.encoding = source.encoding;
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON(meta) {
                var isRootObject = meta === undefined || typeof meta === 'string';
                if (!isRootObject && meta.textures[this.uuid] !== undefined) return meta.textures[this.uuid];
                var output = {
                    metadata: {
                        version: 4.5,
                        type: 'Texture',
                        generator: 'Texture.toJSON'
                    },
                    uuid: this.uuid,
                    name: this.name,
                    mapping: this.mapping,
                    repeat: [
                        this.repeat.x,
                        this.repeat.y
                    ],
                    offset: [
                        this.offset.x,
                        this.offset.y
                    ],
                    center: [
                        this.center.x,
                        this.center.y
                    ],
                    rotation: this.rotation,
                    wrap: [
                        this.wrapS,
                        this.wrapT
                    ],
                    format: this.format,
                    type: this.type,
                    encoding: this.encoding,
                    minFilter: this.minFilter,
                    magFilter: this.magFilter,
                    anisotropy: this.anisotropy,
                    flipY: this.flipY,
                    premultiplyAlpha: this.premultiplyAlpha,
                    unpackAlignment: this.unpackAlignment
                };
                if (this.image !== undefined) {
                    // TODO: Move to THREE.Image
                    var image = this.image;
                    if (image.uuid === undefined) image.uuid = $c702e238df7c5123$var$generateUUID(); // UGH
                    if (!isRootObject && meta.images[image.uuid] === undefined) {
                        var url;
                        if (Array.isArray(image)) {
                            // process array of images e.g. CubeTexture
                            url = [];
                            for(var i = 0, l = image.length; i < l; i++)// check cube texture with data textures
                            if (image[i].isDataTexture) url.push($c702e238df7c5123$var$serializeImage(image[i].image));
                            else url.push($c702e238df7c5123$var$serializeImage(image[i]));
                        } else // process single image
                        url = $c702e238df7c5123$var$serializeImage(image);
                        meta.images[image.uuid] = {
                            uuid: image.uuid,
                            url: url
                        };
                    }
                    output.image = image.uuid;
                }
                if (!isRootObject) meta.textures[this.uuid] = output;
                return output;
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this.dispatchEvent({
                    type: 'dispose'
                });
            }
        },
        {
            key: "transformUv",
            value: function transformUv(uv) {
                if (this.mapping !== $c702e238df7c5123$export$1beec6768cbb3d2d) return uv;
                uv.applyMatrix3(this.matrix);
                if (uv.x < 0 || uv.x > 1) switch(this.wrapS){
                    case $c702e238df7c5123$export$533346c8e8dac0f5:
                        uv.x = uv.x - Math.floor(uv.x);
                        break;
                    case $c702e238df7c5123$export$9d9334239a5a5e06:
                        uv.x = uv.x < 0 ? 0 : 1;
                        break;
                    case $c702e238df7c5123$export$c7e7c00b14f51a4f:
                        if (Math.abs(Math.floor(uv.x) % 2) === 1) uv.x = Math.ceil(uv.x) - uv.x;
                        else uv.x = uv.x - Math.floor(uv.x);
                        break;
                }
                if (uv.y < 0 || uv.y > 1) switch(this.wrapT){
                    case $c702e238df7c5123$export$533346c8e8dac0f5:
                        uv.y = uv.y - Math.floor(uv.y);
                        break;
                    case $c702e238df7c5123$export$9d9334239a5a5e06:
                        uv.y = uv.y < 0 ? 0 : 1;
                        break;
                    case $c702e238df7c5123$export$c7e7c00b14f51a4f:
                        if (Math.abs(Math.floor(uv.y) % 2) === 1) uv.y = Math.ceil(uv.y) - uv.y;
                        else uv.y = uv.y - Math.floor(uv.y);
                        break;
                }
                if (this.flipY) uv.y = 1 - uv.y;
                return uv;
            }
        },
        {
            key: "needsUpdate",
            set: function set(value) {
                if (value === true) this.version++;
            }
        }
    ]);
    return Texture;
}($c702e238df7c5123$export$ec8b666c5fe2c75a);
$c702e238df7c5123$export$5431306cf43de24a.DEFAULT_IMAGE = undefined;
$c702e238df7c5123$export$5431306cf43de24a.DEFAULT_MAPPING = $c702e238df7c5123$export$1beec6768cbb3d2d;
$c702e238df7c5123$export$5431306cf43de24a.prototype.isTexture = true;
function $c702e238df7c5123$var$serializeImage(image) {
    if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) // default images
    return $c702e238df7c5123$export$698882cf06df44aa.getDataURL(image);
    else {
        if (image.data) // images of DataTexture
        return {
            data: Array.prototype.slice.call(image.data),
            width: image.width,
            height: image.height,
            type: image.data.constructor.name
        };
        else {
            console.warn('THREE.Texture: Unable to serialize Texture.');
            return {};
        }
    }
}
var $c702e238df7c5123$export$fa7daccca11cdbe3 = /*#__PURE__*/ function() {
    "use strict";
    function Vector4() {
        var x = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, z = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, w = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Vector4);
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(Vector4, [
        {
            key: "width",
            get: function get() {
                return this.z;
            },
            set: function set(value) {
                this.z = value;
            }
        },
        {
            key: "height",
            get: function get() {
                return this.w;
            },
            set: function set(value) {
                this.w = value;
            }
        },
        {
            key: "set",
            value: function set(x, y, z, w) {
                this.x = x;
                this.y = y;
                this.z = z;
                this.w = w;
                return this;
            }
        },
        {
            key: "setScalar",
            value: function setScalar(scalar) {
                this.x = scalar;
                this.y = scalar;
                this.z = scalar;
                this.w = scalar;
                return this;
            }
        },
        {
            key: "setX",
            value: function setX(x) {
                this.x = x;
                return this;
            }
        },
        {
            key: "setY",
            value: function setY(y) {
                this.y = y;
                return this;
            }
        },
        {
            key: "setZ",
            value: function setZ(z) {
                this.z = z;
                return this;
            }
        },
        {
            key: "setW",
            value: function setW(w) {
                this.w = w;
                return this;
            }
        },
        {
            key: "setComponent",
            value: function setComponent(index, value) {
                switch(index){
                    case 0:
                        this.x = value;
                        break;
                    case 1:
                        this.y = value;
                        break;
                    case 2:
                        this.z = value;
                        break;
                    case 3:
                        this.w = value;
                        break;
                    default:
                        throw new Error('index is out of range: ' + index);
                }
                return this;
            }
        },
        {
            key: "getComponent",
            value: function getComponent(index) {
                switch(index){
                    case 0:
                        return this.x;
                    case 1:
                        return this.y;
                    case 2:
                        return this.z;
                    case 3:
                        return this.w;
                    default:
                        throw new Error('index is out of range: ' + index);
                }
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor(this.x, this.y, this.z, this.w);
            }
        },
        {
            key: "copy",
            value: function copy(v) {
                this.x = v.x;
                this.y = v.y;
                this.z = v.z;
                this.w = v.w !== undefined ? v.w : 1;
                return this;
            }
        },
        {
            key: "add",
            value: function add(v, w) {
                if (w !== undefined) {
                    console.warn('THREE.Vector4: .add() now only accepts one argument. Use .addVectors( a, b ) instead.');
                    return this.addVectors(v, w);
                }
                this.x += v.x;
                this.y += v.y;
                this.z += v.z;
                this.w += v.w;
                return this;
            }
        },
        {
            key: "addScalar",
            value: function addScalar(s) {
                this.x += s;
                this.y += s;
                this.z += s;
                this.w += s;
                return this;
            }
        },
        {
            key: "addVectors",
            value: function addVectors(a, b) {
                this.x = a.x + b.x;
                this.y = a.y + b.y;
                this.z = a.z + b.z;
                this.w = a.w + b.w;
                return this;
            }
        },
        {
            key: "addScaledVector",
            value: function addScaledVector(v, s) {
                this.x += v.x * s;
                this.y += v.y * s;
                this.z += v.z * s;
                this.w += v.w * s;
                return this;
            }
        },
        {
            key: "sub",
            value: function sub(v, w) {
                if (w !== undefined) {
                    console.warn('THREE.Vector4: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.');
                    return this.subVectors(v, w);
                }
                this.x -= v.x;
                this.y -= v.y;
                this.z -= v.z;
                this.w -= v.w;
                return this;
            }
        },
        {
            key: "subScalar",
            value: function subScalar(s) {
                this.x -= s;
                this.y -= s;
                this.z -= s;
                this.w -= s;
                return this;
            }
        },
        {
            key: "subVectors",
            value: function subVectors(a, b) {
                this.x = a.x - b.x;
                this.y = a.y - b.y;
                this.z = a.z - b.z;
                this.w = a.w - b.w;
                return this;
            }
        },
        {
            key: "multiply",
            value: function multiply(v) {
                this.x *= v.x;
                this.y *= v.y;
                this.z *= v.z;
                this.w *= v.w;
                return this;
            }
        },
        {
            key: "multiplyScalar",
            value: function multiplyScalar(scalar) {
                this.x *= scalar;
                this.y *= scalar;
                this.z *= scalar;
                this.w *= scalar;
                return this;
            }
        },
        {
            key: "applyMatrix4",
            value: function applyMatrix4(m) {
                var x = this.x, y = this.y, z = this.z, w = this.w;
                var e = m.elements;
                this.x = e[0] * x + e[4] * y + e[8] * z + e[12] * w;
                this.y = e[1] * x + e[5] * y + e[9] * z + e[13] * w;
                this.z = e[2] * x + e[6] * y + e[10] * z + e[14] * w;
                this.w = e[3] * x + e[7] * y + e[11] * z + e[15] * w;
                return this;
            }
        },
        {
            key: "divideScalar",
            value: function divideScalar(scalar) {
                return this.multiplyScalar(1 / scalar);
            }
        },
        {
            key: "setAxisAngleFromQuaternion",
            value: function setAxisAngleFromQuaternion(q) {
                // http://www.euclideanspace.com/maths/geometry/rotations/conversions/quaternionToAngle/index.htm
                // q is assumed to be normalized
                this.w = 2 * Math.acos(q.w);
                var s = Math.sqrt(1 - q.w * q.w);
                if (s < 0.0001) {
                    this.x = 1;
                    this.y = 0;
                    this.z = 0;
                } else {
                    this.x = q.x / s;
                    this.y = q.y / s;
                    this.z = q.z / s;
                }
                return this;
            }
        },
        {
            key: "setAxisAngleFromRotationMatrix",
            value: function setAxisAngleFromRotationMatrix(m) {
                // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToAngle/index.htm
                // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
                var angle, x, y, z; // variables for result
                var epsilon = 0.01, epsilon2 = 0.1, te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10];
                if (Math.abs(m12 - m21) < epsilon && Math.abs(m13 - m31) < epsilon && Math.abs(m23 - m32) < epsilon) {
                    // singularity found
                    // first check for identity matrix which must have +1 for all terms
                    // in leading diagonal and zero in other terms
                    if (Math.abs(m12 + m21) < epsilon2 && Math.abs(m13 + m31) < epsilon2 && Math.abs(m23 + m32) < epsilon2 && Math.abs(m11 + m22 + m33 - 3) < epsilon2) {
                        // this singularity is identity matrix so angle = 0
                        this.set(1, 0, 0, 0);
                        return this; // zero angle, arbitrary axis
                    }
                    // otherwise this singularity is angle = 180
                    angle = Math.PI;
                    var xx = (m11 + 1) / 2;
                    var yy = (m22 + 1) / 2;
                    var zz = (m33 + 1) / 2;
                    var xy = (m12 + m21) / 4;
                    var xz = (m13 + m31) / 4;
                    var yz = (m23 + m32) / 4;
                    if (xx > yy && xx > zz) {
                        // m11 is the largest diagonal term
                        if (xx < epsilon) {
                            x = 0;
                            y = 0.707106781;
                            z = 0.707106781;
                        } else {
                            x = Math.sqrt(xx);
                            y = xy / x;
                            z = xz / x;
                        }
                    } else if (yy > zz) {
                        // m22 is the largest diagonal term
                        if (yy < epsilon) {
                            x = 0.707106781;
                            y = 0;
                            z = 0.707106781;
                        } else {
                            y = Math.sqrt(yy);
                            x = xy / y;
                            z = yz / y;
                        }
                    } else // m33 is the largest diagonal term so base result on this
                    if (zz < epsilon) {
                        x = 0.707106781;
                        y = 0.707106781;
                        z = 0;
                    } else {
                        z = Math.sqrt(zz);
                        x = xz / z;
                        y = yz / z;
                    }
                    this.set(x, y, z, angle);
                    return this; // return 180 deg rotation
                }
                // as we have reached here there are no singularities so we can handle normally
                var s = Math.sqrt((m32 - m23) * (m32 - m23) + (m13 - m31) * (m13 - m31) + (m21 - m12) * (m21 - m12)); // used to normalize
                if (Math.abs(s) < 0.001) s = 1;
                // prevent divide by zero, should not happen if matrix is orthogonal and should be
                // caught by singularity test above, but I've left it in just in case
                this.x = (m32 - m23) / s;
                this.y = (m13 - m31) / s;
                this.z = (m21 - m12) / s;
                this.w = Math.acos((m11 + m22 + m33 - 1) / 2);
                return this;
            }
        },
        {
            key: "min",
            value: function min(v) {
                this.x = Math.min(this.x, v.x);
                this.y = Math.min(this.y, v.y);
                this.z = Math.min(this.z, v.z);
                this.w = Math.min(this.w, v.w);
                return this;
            }
        },
        {
            key: "max",
            value: function max(v) {
                this.x = Math.max(this.x, v.x);
                this.y = Math.max(this.y, v.y);
                this.z = Math.max(this.z, v.z);
                this.w = Math.max(this.w, v.w);
                return this;
            }
        },
        {
            key: "clamp",
            value: function clamp(min, max) {
                // assumes min < max, componentwise
                this.x = Math.max(min.x, Math.min(max.x, this.x));
                this.y = Math.max(min.y, Math.min(max.y, this.y));
                this.z = Math.max(min.z, Math.min(max.z, this.z));
                this.w = Math.max(min.w, Math.min(max.w, this.w));
                return this;
            }
        },
        {
            key: "clampScalar",
            value: function clampScalar(minVal, maxVal) {
                this.x = Math.max(minVal, Math.min(maxVal, this.x));
                this.y = Math.max(minVal, Math.min(maxVal, this.y));
                this.z = Math.max(minVal, Math.min(maxVal, this.z));
                this.w = Math.max(minVal, Math.min(maxVal, this.w));
                return this;
            }
        },
        {
            key: "clampLength",
            value: function clampLength(min, max) {
                var length = this.length();
                return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
            }
        },
        {
            key: "floor",
            value: function floor() {
                this.x = Math.floor(this.x);
                this.y = Math.floor(this.y);
                this.z = Math.floor(this.z);
                this.w = Math.floor(this.w);
                return this;
            }
        },
        {
            key: "ceil",
            value: function ceil() {
                this.x = Math.ceil(this.x);
                this.y = Math.ceil(this.y);
                this.z = Math.ceil(this.z);
                this.w = Math.ceil(this.w);
                return this;
            }
        },
        {
            key: "round",
            value: function round() {
                this.x = Math.round(this.x);
                this.y = Math.round(this.y);
                this.z = Math.round(this.z);
                this.w = Math.round(this.w);
                return this;
            }
        },
        {
            key: "roundToZero",
            value: function roundToZero() {
                this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
                this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
                this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z);
                this.w = this.w < 0 ? Math.ceil(this.w) : Math.floor(this.w);
                return this;
            }
        },
        {
            key: "negate",
            value: function negate() {
                this.x = -this.x;
                this.y = -this.y;
                this.z = -this.z;
                this.w = -this.w;
                return this;
            }
        },
        {
            key: "dot",
            value: function dot(v) {
                return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
            }
        },
        {
            key: "lengthSq",
            value: function lengthSq() {
                return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
            }
        },
        {
            key: "length",
            value: function length() {
                return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
            }
        },
        {
            key: "manhattanLength",
            value: function manhattanLength() {
                return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
            }
        },
        {
            key: "normalize",
            value: function normalize() {
                return this.divideScalar(this.length() || 1);
            }
        },
        {
            key: "setLength",
            value: function setLength(length) {
                return this.normalize().multiplyScalar(length);
            }
        },
        {
            key: "lerp",
            value: function lerp(v, alpha) {
                this.x += (v.x - this.x) * alpha;
                this.y += (v.y - this.y) * alpha;
                this.z += (v.z - this.z) * alpha;
                this.w += (v.w - this.w) * alpha;
                return this;
            }
        },
        {
            key: "lerpVectors",
            value: function lerpVectors(v1, v2, alpha) {
                this.x = v1.x + (v2.x - v1.x) * alpha;
                this.y = v1.y + (v2.y - v1.y) * alpha;
                this.z = v1.z + (v2.z - v1.z) * alpha;
                this.w = v1.w + (v2.w - v1.w) * alpha;
                return this;
            }
        },
        {
            key: "equals",
            value: function equals(v) {
                return v.x === this.x && v.y === this.y && v.z === this.z && v.w === this.w;
            }
        },
        {
            key: "fromArray",
            value: function fromArray(array) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                this.x = array[offset];
                this.y = array[offset + 1];
                this.z = array[offset + 2];
                this.w = array[offset + 3];
                return this;
            }
        },
        {
            key: "toArray",
            value: function toArray() {
                var array = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                array[offset] = this.x;
                array[offset + 1] = this.y;
                array[offset + 2] = this.z;
                array[offset + 3] = this.w;
                return array;
            }
        },
        {
            key: "fromBufferAttribute",
            value: function fromBufferAttribute(attribute, index, offset) {
                if (offset !== undefined) console.warn('THREE.Vector4: offset has been removed from .fromBufferAttribute().');
                this.x = attribute.getX(index);
                this.y = attribute.getY(index);
                this.z = attribute.getZ(index);
                this.w = attribute.getW(index);
                return this;
            }
        },
        {
            key: "random",
            value: function random() {
                this.x = Math.random();
                this.y = Math.random();
                this.z = Math.random();
                this.w = Math.random();
                return this;
            }
        }
    ]);
    return Vector4;
}();
$c702e238df7c5123$export$fa7daccca11cdbe3.prototype.isVector4 = true;
/*
 In options, we can specify:
 * Texture parameters for an auto-generated target texture
 * depthBuffer/stencilBuffer: Booleans to indicate if we should generate these buffers
*/ var $c702e238df7c5123$export$3c052beb2e51e23f = /*#__PURE__*/ function(EventDispatcher) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(WebGLRenderTarget, EventDispatcher);
    function WebGLRenderTarget(width, height) {
        var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, WebGLRenderTarget);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, WebGLRenderTarget);
        _this.width = width;
        _this.height = height;
        _this.depth = 1;
        _this.scissor = new $c702e238df7c5123$export$fa7daccca11cdbe3(0, 0, width, height);
        _this.scissorTest = false;
        _this.viewport = new $c702e238df7c5123$export$fa7daccca11cdbe3(0, 0, width, height);
        _this.texture = new $c702e238df7c5123$export$5431306cf43de24a(undefined, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.encoding);
        _this.texture.image = {
            width: width,
            height: height,
            depth: 1
        };
        _this.texture.generateMipmaps = options.generateMipmaps !== undefined ? options.generateMipmaps : false;
        _this.texture.minFilter = options.minFilter !== undefined ? options.minFilter : $c702e238df7c5123$export$8a72f490b25c56c8;
        _this.depthBuffer = options.depthBuffer !== undefined ? options.depthBuffer : true;
        _this.stencilBuffer = options.stencilBuffer !== undefined ? options.stencilBuffer : false;
        _this.depthTexture = options.depthTexture !== undefined ? options.depthTexture : null;
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(WebGLRenderTarget, [
        {
            key: "setTexture",
            value: function setTexture(texture) {
                texture.image = {
                    width: this.width,
                    height: this.height,
                    depth: this.depth
                };
                this.texture = texture;
            }
        },
        {
            key: "setSize",
            value: function setSize(width, height) {
                var depth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
                if (this.width !== width || this.height !== height || this.depth !== depth) {
                    this.width = width;
                    this.height = height;
                    this.depth = depth;
                    this.texture.image.width = width;
                    this.texture.image.height = height;
                    this.texture.image.depth = depth;
                    this.dispose();
                }
                this.viewport.set(0, 0, width, height);
                this.scissor.set(0, 0, width, height);
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                this.width = source.width;
                this.height = source.height;
                this.depth = source.depth;
                this.viewport.copy(source.viewport);
                this.texture = source.texture.clone();
                this.texture.image = (0, $9583e96e3d380e4c$export$71511d61b312f219)({}, this.texture.image); // See #20328.
                this.depthBuffer = source.depthBuffer;
                this.stencilBuffer = source.stencilBuffer;
                this.depthTexture = source.depthTexture;
                return this;
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this.dispatchEvent({
                    type: 'dispose'
                });
            }
        }
    ]);
    return WebGLRenderTarget;
}($c702e238df7c5123$export$ec8b666c5fe2c75a);
$c702e238df7c5123$export$3c052beb2e51e23f.prototype.isWebGLRenderTarget = true;
var $c702e238df7c5123$export$bd934554fb721730 = /*#__PURE__*/ function(WebGLRenderTarget) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(WebGLMultipleRenderTargets, WebGLRenderTarget);
    function WebGLMultipleRenderTargets(width, height, count) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, WebGLMultipleRenderTargets);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, WebGLMultipleRenderTargets, [
            width,
            height
        ]);
        var texture = _this.texture;
        _this.texture = [];
        for(var i = 0; i < count; i++)_this.texture[i] = texture.clone();
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(WebGLMultipleRenderTargets, [
        {
            key: "setSize",
            value: function setSize(width, height) {
                var depth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
                if (this.width !== width || this.height !== height || this.depth !== depth) {
                    this.width = width;
                    this.height = height;
                    this.depth = depth;
                    for(var i = 0, il = this.texture.length; i < il; i++){
                        this.texture[i].image.width = width;
                        this.texture[i].image.height = height;
                        this.texture[i].image.depth = depth;
                    }
                    this.dispose();
                }
                this.viewport.set(0, 0, width, height);
                this.scissor.set(0, 0, width, height);
                return this;
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                this.dispose();
                this.width = source.width;
                this.height = source.height;
                this.depth = source.depth;
                this.viewport.set(0, 0, this.width, this.height);
                this.scissor.set(0, 0, this.width, this.height);
                this.depthBuffer = source.depthBuffer;
                this.stencilBuffer = source.stencilBuffer;
                this.depthTexture = source.depthTexture;
                this.texture.length = 0;
                for(var i = 0, il = source.texture.length; i < il; i++)this.texture[i] = source.texture[i].clone();
                return this;
            }
        }
    ]);
    return WebGLMultipleRenderTargets;
}($c702e238df7c5123$export$3c052beb2e51e23f);
$c702e238df7c5123$export$bd934554fb721730.prototype.isWebGLMultipleRenderTargets = true;
var $c702e238df7c5123$export$cb2022643d3c928d = /*#__PURE__*/ function(WebGLRenderTarget) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(WebGLMultisampleRenderTarget, WebGLRenderTarget);
    function WebGLMultisampleRenderTarget(width, height, options) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, WebGLMultisampleRenderTarget);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, WebGLMultisampleRenderTarget, [
            width,
            height,
            options
        ]);
        _this.samples = 4;
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(WebGLMultisampleRenderTarget, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(WebGLMultisampleRenderTarget.prototype), "copy", this).call(this, source);
                this.samples = source.samples;
                return this;
            }
        }
    ]);
    return WebGLMultisampleRenderTarget;
}($c702e238df7c5123$export$3c052beb2e51e23f);
$c702e238df7c5123$export$cb2022643d3c928d.prototype.isWebGLMultisampleRenderTarget = true;
var $c702e238df7c5123$export$23d6a54f0bbc85a3 = /*#__PURE__*/ function() {
    "use strict";
    function Quaternion() {
        var x = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, z = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, w = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Quaternion);
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(Quaternion, [
        {
            key: "x",
            get: function get() {
                return this._x;
            },
            set: function set(value) {
                this._x = value;
                this._onChangeCallback();
            }
        },
        {
            key: "y",
            get: function get() {
                return this._y;
            },
            set: function set(value) {
                this._y = value;
                this._onChangeCallback();
            }
        },
        {
            key: "z",
            get: function get() {
                return this._z;
            },
            set: function set(value) {
                this._z = value;
                this._onChangeCallback();
            }
        },
        {
            key: "w",
            get: function get() {
                return this._w;
            },
            set: function set(value) {
                this._w = value;
                this._onChangeCallback();
            }
        },
        {
            key: "set",
            value: function set(x, y, z, w) {
                this._x = x;
                this._y = y;
                this._z = z;
                this._w = w;
                this._onChangeCallback();
                return this;
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor(this._x, this._y, this._z, this._w);
            }
        },
        {
            key: "copy",
            value: function copy(quaternion) {
                this._x = quaternion.x;
                this._y = quaternion.y;
                this._z = quaternion.z;
                this._w = quaternion.w;
                this._onChangeCallback();
                return this;
            }
        },
        {
            key: "setFromEuler",
            value: function setFromEuler(euler, update) {
                if (!(euler && euler.isEuler)) throw new Error('THREE.Quaternion: .setFromEuler() now expects an Euler rotation rather than a Vector3 and order.');
                var x = euler._x, y = euler._y, z = euler._z, order = euler._order;
                // http://www.mathworks.com/matlabcentral/fileexchange/
                // 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
                //	content/SpinCalc.m
                var cos = Math.cos;
                var sin = Math.sin;
                var c1 = cos(x / 2);
                var c2 = cos(y / 2);
                var c3 = cos(z / 2);
                var s1 = sin(x / 2);
                var s2 = sin(y / 2);
                var s3 = sin(z / 2);
                switch(order){
                    case 'XYZ':
                        this._x = s1 * c2 * c3 + c1 * s2 * s3;
                        this._y = c1 * s2 * c3 - s1 * c2 * s3;
                        this._z = c1 * c2 * s3 + s1 * s2 * c3;
                        this._w = c1 * c2 * c3 - s1 * s2 * s3;
                        break;
                    case 'YXZ':
                        this._x = s1 * c2 * c3 + c1 * s2 * s3;
                        this._y = c1 * s2 * c3 - s1 * c2 * s3;
                        this._z = c1 * c2 * s3 - s1 * s2 * c3;
                        this._w = c1 * c2 * c3 + s1 * s2 * s3;
                        break;
                    case 'ZXY':
                        this._x = s1 * c2 * c3 - c1 * s2 * s3;
                        this._y = c1 * s2 * c3 + s1 * c2 * s3;
                        this._z = c1 * c2 * s3 + s1 * s2 * c3;
                        this._w = c1 * c2 * c3 - s1 * s2 * s3;
                        break;
                    case 'ZYX':
                        this._x = s1 * c2 * c3 - c1 * s2 * s3;
                        this._y = c1 * s2 * c3 + s1 * c2 * s3;
                        this._z = c1 * c2 * s3 - s1 * s2 * c3;
                        this._w = c1 * c2 * c3 + s1 * s2 * s3;
                        break;
                    case 'YZX':
                        this._x = s1 * c2 * c3 + c1 * s2 * s3;
                        this._y = c1 * s2 * c3 + s1 * c2 * s3;
                        this._z = c1 * c2 * s3 - s1 * s2 * c3;
                        this._w = c1 * c2 * c3 - s1 * s2 * s3;
                        break;
                    case 'XZY':
                        this._x = s1 * c2 * c3 - c1 * s2 * s3;
                        this._y = c1 * s2 * c3 - s1 * c2 * s3;
                        this._z = c1 * c2 * s3 + s1 * s2 * c3;
                        this._w = c1 * c2 * c3 + s1 * s2 * s3;
                        break;
                    default:
                        console.warn('THREE.Quaternion: .setFromEuler() encountered an unknown order: ' + order);
                }
                if (update !== false) this._onChangeCallback();
                return this;
            }
        },
        {
            key: "setFromAxisAngle",
            value: function setFromAxisAngle(axis, angle) {
                // http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm
                // assumes axis is normalized
                var halfAngle = angle / 2, s = Math.sin(halfAngle);
                this._x = axis.x * s;
                this._y = axis.y * s;
                this._z = axis.z * s;
                this._w = Math.cos(halfAngle);
                this._onChangeCallback();
                return this;
            }
        },
        {
            key: "setFromRotationMatrix",
            value: function setFromRotationMatrix(m) {
                // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm
                // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
                var te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10], trace = m11 + m22 + m33;
                if (trace > 0) {
                    var s = 0.5 / Math.sqrt(trace + 1.0);
                    this._w = 0.25 / s;
                    this._x = (m32 - m23) * s;
                    this._y = (m13 - m31) * s;
                    this._z = (m21 - m12) * s;
                } else if (m11 > m22 && m11 > m33) {
                    var s1 = 2.0 * Math.sqrt(1.0 + m11 - m22 - m33);
                    this._w = (m32 - m23) / s1;
                    this._x = 0.25 * s1;
                    this._y = (m12 + m21) / s1;
                    this._z = (m13 + m31) / s1;
                } else if (m22 > m33) {
                    var s2 = 2.0 * Math.sqrt(1.0 + m22 - m11 - m33);
                    this._w = (m13 - m31) / s2;
                    this._x = (m12 + m21) / s2;
                    this._y = 0.25 * s2;
                    this._z = (m23 + m32) / s2;
                } else {
                    var s3 = 2.0 * Math.sqrt(1.0 + m33 - m11 - m22);
                    this._w = (m21 - m12) / s3;
                    this._x = (m13 + m31) / s3;
                    this._y = (m23 + m32) / s3;
                    this._z = 0.25 * s3;
                }
                this._onChangeCallback();
                return this;
            }
        },
        {
            key: "setFromUnitVectors",
            value: function setFromUnitVectors(vFrom, vTo) {
                // assumes direction vectors vFrom and vTo are normalized
                var r = vFrom.dot(vTo) + 1;
                if (r < Number.EPSILON) {
                    // vFrom and vTo point in opposite directions
                    r = 0;
                    if (Math.abs(vFrom.x) > Math.abs(vFrom.z)) {
                        this._x = -vFrom.y;
                        this._y = vFrom.x;
                        this._z = 0;
                        this._w = r;
                    } else {
                        this._x = 0;
                        this._y = -vFrom.z;
                        this._z = vFrom.y;
                        this._w = r;
                    }
                } else {
                    // crossVectors( vFrom, vTo ); // inlined to avoid cyclic dependency on Vector3
                    this._x = vFrom.y * vTo.z - vFrom.z * vTo.y;
                    this._y = vFrom.z * vTo.x - vFrom.x * vTo.z;
                    this._z = vFrom.x * vTo.y - vFrom.y * vTo.x;
                    this._w = r;
                }
                return this.normalize();
            }
        },
        {
            key: "angleTo",
            value: function angleTo(q) {
                return 2 * Math.acos(Math.abs($c702e238df7c5123$var$clamp(this.dot(q), -1, 1)));
            }
        },
        {
            key: "rotateTowards",
            value: function rotateTowards(q, step) {
                var angle = this.angleTo(q);
                if (angle === 0) return this;
                var t = Math.min(1, step / angle);
                this.slerp(q, t);
                return this;
            }
        },
        {
            key: "identity",
            value: function identity() {
                return this.set(0, 0, 0, 1);
            }
        },
        {
            key: "invert",
            value: function invert() {
                // quaternion is assumed to have unit length
                return this.conjugate();
            }
        },
        {
            key: "conjugate",
            value: function conjugate() {
                this._x *= -1;
                this._y *= -1;
                this._z *= -1;
                this._onChangeCallback();
                return this;
            }
        },
        {
            key: "dot",
            value: function dot(v) {
                return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;
            }
        },
        {
            key: "lengthSq",
            value: function lengthSq() {
                return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
            }
        },
        {
            key: "length",
            value: function length() {
                return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
            }
        },
        {
            key: "normalize",
            value: function normalize() {
                var l = this.length();
                if (l === 0) {
                    this._x = 0;
                    this._y = 0;
                    this._z = 0;
                    this._w = 1;
                } else {
                    l = 1 / l;
                    this._x = this._x * l;
                    this._y = this._y * l;
                    this._z = this._z * l;
                    this._w = this._w * l;
                }
                this._onChangeCallback();
                return this;
            }
        },
        {
            key: "multiply",
            value: function multiply(q, p) {
                if (p !== undefined) {
                    console.warn('THREE.Quaternion: .multiply() now only accepts one argument. Use .multiplyQuaternions( a, b ) instead.');
                    return this.multiplyQuaternions(q, p);
                }
                return this.multiplyQuaternions(this, q);
            }
        },
        {
            key: "premultiply",
            value: function premultiply(q) {
                return this.multiplyQuaternions(q, this);
            }
        },
        {
            key: "multiplyQuaternions",
            value: function multiplyQuaternions(a, b) {
                // from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm
                var qax = a._x, qay = a._y, qaz = a._z, qaw = a._w;
                var qbx = b._x, qby = b._y, qbz = b._z, qbw = b._w;
                this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
                this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
                this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
                this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;
                this._onChangeCallback();
                return this;
            }
        },
        {
            key: "slerp",
            value: function slerp(qb, t) {
                if (t === 0) return this;
                if (t === 1) return this.copy(qb);
                var x = this._x, y = this._y, z = this._z, w = this._w;
                // http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/slerp/
                var cosHalfTheta = w * qb._w + x * qb._x + y * qb._y + z * qb._z;
                if (cosHalfTheta < 0) {
                    this._w = -qb._w;
                    this._x = -qb._x;
                    this._y = -qb._y;
                    this._z = -qb._z;
                    cosHalfTheta = -cosHalfTheta;
                } else this.copy(qb);
                if (cosHalfTheta >= 1.0) {
                    this._w = w;
                    this._x = x;
                    this._y = y;
                    this._z = z;
                    return this;
                }
                var sqrSinHalfTheta = 1.0 - cosHalfTheta * cosHalfTheta;
                if (sqrSinHalfTheta <= Number.EPSILON) {
                    var s = 1 - t;
                    this._w = s * w + t * this._w;
                    this._x = s * x + t * this._x;
                    this._y = s * y + t * this._y;
                    this._z = s * z + t * this._z;
                    this.normalize();
                    this._onChangeCallback();
                    return this;
                }
                var sinHalfTheta = Math.sqrt(sqrSinHalfTheta);
                var halfTheta = Math.atan2(sinHalfTheta, cosHalfTheta);
                var ratioA = Math.sin((1 - t) * halfTheta) / sinHalfTheta, ratioB = Math.sin(t * halfTheta) / sinHalfTheta;
                this._w = w * ratioA + this._w * ratioB;
                this._x = x * ratioA + this._x * ratioB;
                this._y = y * ratioA + this._y * ratioB;
                this._z = z * ratioA + this._z * ratioB;
                this._onChangeCallback();
                return this;
            }
        },
        {
            key: "slerpQuaternions",
            value: function slerpQuaternions(qa, qb, t) {
                this.copy(qa).slerp(qb, t);
            }
        },
        {
            key: "equals",
            value: function equals(quaternion) {
                return quaternion._x === this._x && quaternion._y === this._y && quaternion._z === this._z && quaternion._w === this._w;
            }
        },
        {
            key: "fromArray",
            value: function fromArray(array) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                this._x = array[offset];
                this._y = array[offset + 1];
                this._z = array[offset + 2];
                this._w = array[offset + 3];
                this._onChangeCallback();
                return this;
            }
        },
        {
            key: "toArray",
            value: function toArray() {
                var array = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                array[offset] = this._x;
                array[offset + 1] = this._y;
                array[offset + 2] = this._z;
                array[offset + 3] = this._w;
                return array;
            }
        },
        {
            key: "fromBufferAttribute",
            value: function fromBufferAttribute(attribute, index) {
                this._x = attribute.getX(index);
                this._y = attribute.getY(index);
                this._z = attribute.getZ(index);
                this._w = attribute.getW(index);
                return this;
            }
        },
        {
            key: "_onChange",
            value: function _onChange(callback) {
                this._onChangeCallback = callback;
                return this;
            }
        },
        {
            key: "_onChangeCallback",
            value: function _onChangeCallback() {}
        }
    ], [
        {
            key: "slerp",
            value: function slerp(qa, qb, qm, t) {
                console.warn('THREE.Quaternion: Static .slerp() has been deprecated. Use qm.slerpQuaternions( qa, qb, t ) instead.');
                return qm.slerpQuaternions(qa, qb, t);
            }
        },
        {
            key: "slerpFlat",
            value: function slerpFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t) {
                // fuzz-free, array-based Quaternion SLERP operation
                var x0 = src0[srcOffset0 + 0], y0 = src0[srcOffset0 + 1], z0 = src0[srcOffset0 + 2], w0 = src0[srcOffset0 + 3];
                var x1 = src1[srcOffset1 + 0], y1 = src1[srcOffset1 + 1], z1 = src1[srcOffset1 + 2], w1 = src1[srcOffset1 + 3];
                if (t === 0) {
                    dst[dstOffset + 0] = x0;
                    dst[dstOffset + 1] = y0;
                    dst[dstOffset + 2] = z0;
                    dst[dstOffset + 3] = w0;
                    return;
                }
                if (t === 1) {
                    dst[dstOffset + 0] = x1;
                    dst[dstOffset + 1] = y1;
                    dst[dstOffset + 2] = z1;
                    dst[dstOffset + 3] = w1;
                    return;
                }
                if (w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1) {
                    var s = 1 - t;
                    var cos = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1, dir = cos >= 0 ? 1 : -1, sqrSin = 1 - cos * cos;
                    // Skip the Slerp for tiny steps to avoid numeric problems:
                    if (sqrSin > Number.EPSILON) {
                        var sin = Math.sqrt(sqrSin), len = Math.atan2(sin, cos * dir);
                        s = Math.sin(s * len) / sin;
                        t = Math.sin(t * len) / sin;
                    }
                    var tDir = t * dir;
                    x0 = x0 * s + x1 * tDir;
                    y0 = y0 * s + y1 * tDir;
                    z0 = z0 * s + z1 * tDir;
                    w0 = w0 * s + w1 * tDir;
                    // Normalize in case we just did a lerp:
                    if (s === 1 - t) {
                        var f = 1 / Math.sqrt(x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0);
                        x0 *= f;
                        y0 *= f;
                        z0 *= f;
                        w0 *= f;
                    }
                }
                dst[dstOffset] = x0;
                dst[dstOffset + 1] = y0;
                dst[dstOffset + 2] = z0;
                dst[dstOffset + 3] = w0;
            }
        },
        {
            key: "multiplyQuaternionsFlat",
            value: function multiplyQuaternionsFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1) {
                var x0 = src0[srcOffset0];
                var y0 = src0[srcOffset0 + 1];
                var z0 = src0[srcOffset0 + 2];
                var w0 = src0[srcOffset0 + 3];
                var x1 = src1[srcOffset1];
                var y1 = src1[srcOffset1 + 1];
                var z1 = src1[srcOffset1 + 2];
                var w1 = src1[srcOffset1 + 3];
                dst[dstOffset] = x0 * w1 + w0 * x1 + y0 * z1 - z0 * y1;
                dst[dstOffset + 1] = y0 * w1 + w0 * y1 + z0 * x1 - x0 * z1;
                dst[dstOffset + 2] = z0 * w1 + w0 * z1 + x0 * y1 - y0 * x1;
                dst[dstOffset + 3] = w0 * w1 - x0 * x1 - y0 * y1 - z0 * z1;
                return dst;
            }
        }
    ]);
    return Quaternion;
}();
$c702e238df7c5123$export$23d6a54f0bbc85a3.prototype.isQuaternion = true;
var $c702e238df7c5123$export$64b5c384219d3699 = /*#__PURE__*/ function() {
    "use strict";
    function Vector3() {
        var x = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, z = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Vector3);
        this.x = x;
        this.y = y;
        this.z = z;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(Vector3, [
        {
            key: "set",
            value: function set(x, y, z) {
                if (z === undefined) z = this.z; // sprite.scale.set(x,y)
                this.x = x;
                this.y = y;
                this.z = z;
                return this;
            }
        },
        {
            key: "setScalar",
            value: function setScalar(scalar) {
                this.x = scalar;
                this.y = scalar;
                this.z = scalar;
                return this;
            }
        },
        {
            key: "setX",
            value: function setX(x) {
                this.x = x;
                return this;
            }
        },
        {
            key: "setY",
            value: function setY(y) {
                this.y = y;
                return this;
            }
        },
        {
            key: "setZ",
            value: function setZ(z) {
                this.z = z;
                return this;
            }
        },
        {
            key: "setComponent",
            value: function setComponent(index, value) {
                switch(index){
                    case 0:
                        this.x = value;
                        break;
                    case 1:
                        this.y = value;
                        break;
                    case 2:
                        this.z = value;
                        break;
                    default:
                        throw new Error('index is out of range: ' + index);
                }
                return this;
            }
        },
        {
            key: "getComponent",
            value: function getComponent(index) {
                switch(index){
                    case 0:
                        return this.x;
                    case 1:
                        return this.y;
                    case 2:
                        return this.z;
                    default:
                        throw new Error('index is out of range: ' + index);
                }
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor(this.x, this.y, this.z);
            }
        },
        {
            key: "copy",
            value: function copy(v) {
                this.x = v.x;
                this.y = v.y;
                this.z = v.z;
                return this;
            }
        },
        {
            key: "add",
            value: function add(v, w) {
                if (w !== undefined) {
                    console.warn('THREE.Vector3: .add() now only accepts one argument. Use .addVectors( a, b ) instead.');
                    return this.addVectors(v, w);
                }
                this.x += v.x;
                this.y += v.y;
                this.z += v.z;
                return this;
            }
        },
        {
            key: "addScalar",
            value: function addScalar(s) {
                this.x += s;
                this.y += s;
                this.z += s;
                return this;
            }
        },
        {
            key: "addVectors",
            value: function addVectors(a, b) {
                this.x = a.x + b.x;
                this.y = a.y + b.y;
                this.z = a.z + b.z;
                return this;
            }
        },
        {
            key: "addScaledVector",
            value: function addScaledVector(v, s) {
                this.x += v.x * s;
                this.y += v.y * s;
                this.z += v.z * s;
                return this;
            }
        },
        {
            key: "sub",
            value: function sub(v, w) {
                if (w !== undefined) {
                    console.warn('THREE.Vector3: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.');
                    return this.subVectors(v, w);
                }
                this.x -= v.x;
                this.y -= v.y;
                this.z -= v.z;
                return this;
            }
        },
        {
            key: "subScalar",
            value: function subScalar(s) {
                this.x -= s;
                this.y -= s;
                this.z -= s;
                return this;
            }
        },
        {
            key: "subVectors",
            value: function subVectors(a, b) {
                this.x = a.x - b.x;
                this.y = a.y - b.y;
                this.z = a.z - b.z;
                return this;
            }
        },
        {
            key: "multiply",
            value: function multiply(v, w) {
                if (w !== undefined) {
                    console.warn('THREE.Vector3: .multiply() now only accepts one argument. Use .multiplyVectors( a, b ) instead.');
                    return this.multiplyVectors(v, w);
                }
                this.x *= v.x;
                this.y *= v.y;
                this.z *= v.z;
                return this;
            }
        },
        {
            key: "multiplyScalar",
            value: function multiplyScalar(scalar) {
                this.x *= scalar;
                this.y *= scalar;
                this.z *= scalar;
                return this;
            }
        },
        {
            key: "multiplyVectors",
            value: function multiplyVectors(a, b) {
                this.x = a.x * b.x;
                this.y = a.y * b.y;
                this.z = a.z * b.z;
                return this;
            }
        },
        {
            key: "applyEuler",
            value: function applyEuler(euler) {
                if (!(euler && euler.isEuler)) console.error('THREE.Vector3: .applyEuler() now expects an Euler rotation rather than a Vector3 and order.');
                return this.applyQuaternion($c702e238df7c5123$var$_quaternion$4.setFromEuler(euler));
            }
        },
        {
            key: "applyAxisAngle",
            value: function applyAxisAngle(axis, angle) {
                return this.applyQuaternion($c702e238df7c5123$var$_quaternion$4.setFromAxisAngle(axis, angle));
            }
        },
        {
            key: "applyMatrix3",
            value: function applyMatrix3(m) {
                var x = this.x, y = this.y, z = this.z;
                var e = m.elements;
                this.x = e[0] * x + e[3] * y + e[6] * z;
                this.y = e[1] * x + e[4] * y + e[7] * z;
                this.z = e[2] * x + e[5] * y + e[8] * z;
                return this;
            }
        },
        {
            key: "applyNormalMatrix",
            value: function applyNormalMatrix(m) {
                return this.applyMatrix3(m).normalize();
            }
        },
        {
            key: "applyMatrix4",
            value: function applyMatrix4(m) {
                var x = this.x, y = this.y, z = this.z;
                var e = m.elements;
                var w = 1 / (e[3] * x + e[7] * y + e[11] * z + e[15]);
                this.x = (e[0] * x + e[4] * y + e[8] * z + e[12]) * w;
                this.y = (e[1] * x + e[5] * y + e[9] * z + e[13]) * w;
                this.z = (e[2] * x + e[6] * y + e[10] * z + e[14]) * w;
                return this;
            }
        },
        {
            key: "applyQuaternion",
            value: function applyQuaternion(q) {
                var x = this.x, y = this.y, z = this.z;
                var qx = q.x, qy = q.y, qz = q.z, qw = q.w;
                // calculate quat * vector
                var ix = qw * x + qy * z - qz * y;
                var iy = qw * y + qz * x - qx * z;
                var iz = qw * z + qx * y - qy * x;
                var iw = -qx * x - qy * y - qz * z;
                // calculate result * inverse quat
                this.x = ix * qw + iw * -qx + iy * -qz - iz * -qy;
                this.y = iy * qw + iw * -qy + iz * -qx - ix * -qz;
                this.z = iz * qw + iw * -qz + ix * -qy - iy * -qx;
                return this;
            }
        },
        {
            key: "project",
            value: function project(camera) {
                return this.applyMatrix4(camera.matrixWorldInverse).applyMatrix4(camera.projectionMatrix);
            }
        },
        {
            key: "unproject",
            value: function unproject(camera) {
                return this.applyMatrix4(camera.projectionMatrixInverse).applyMatrix4(camera.matrixWorld);
            }
        },
        {
            key: "transformDirection",
            value: function transformDirection(m) {
                // input: THREE.Matrix4 affine matrix
                // vector interpreted as a direction
                var x = this.x, y = this.y, z = this.z;
                var e = m.elements;
                this.x = e[0] * x + e[4] * y + e[8] * z;
                this.y = e[1] * x + e[5] * y + e[9] * z;
                this.z = e[2] * x + e[6] * y + e[10] * z;
                return this.normalize();
            }
        },
        {
            key: "divide",
            value: function divide(v) {
                this.x /= v.x;
                this.y /= v.y;
                this.z /= v.z;
                return this;
            }
        },
        {
            key: "divideScalar",
            value: function divideScalar(scalar) {
                return this.multiplyScalar(1 / scalar);
            }
        },
        {
            key: "min",
            value: function min(v) {
                this.x = Math.min(this.x, v.x);
                this.y = Math.min(this.y, v.y);
                this.z = Math.min(this.z, v.z);
                return this;
            }
        },
        {
            key: "max",
            value: function max(v) {
                this.x = Math.max(this.x, v.x);
                this.y = Math.max(this.y, v.y);
                this.z = Math.max(this.z, v.z);
                return this;
            }
        },
        {
            key: "clamp",
            value: function clamp(min, max) {
                // assumes min < max, componentwise
                this.x = Math.max(min.x, Math.min(max.x, this.x));
                this.y = Math.max(min.y, Math.min(max.y, this.y));
                this.z = Math.max(min.z, Math.min(max.z, this.z));
                return this;
            }
        },
        {
            key: "clampScalar",
            value: function clampScalar(minVal, maxVal) {
                this.x = Math.max(minVal, Math.min(maxVal, this.x));
                this.y = Math.max(minVal, Math.min(maxVal, this.y));
                this.z = Math.max(minVal, Math.min(maxVal, this.z));
                return this;
            }
        },
        {
            key: "clampLength",
            value: function clampLength(min, max) {
                var length = this.length();
                return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
            }
        },
        {
            key: "floor",
            value: function floor() {
                this.x = Math.floor(this.x);
                this.y = Math.floor(this.y);
                this.z = Math.floor(this.z);
                return this;
            }
        },
        {
            key: "ceil",
            value: function ceil() {
                this.x = Math.ceil(this.x);
                this.y = Math.ceil(this.y);
                this.z = Math.ceil(this.z);
                return this;
            }
        },
        {
            key: "round",
            value: function round() {
                this.x = Math.round(this.x);
                this.y = Math.round(this.y);
                this.z = Math.round(this.z);
                return this;
            }
        },
        {
            key: "roundToZero",
            value: function roundToZero() {
                this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
                this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
                this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z);
                return this;
            }
        },
        {
            key: "negate",
            value: function negate() {
                this.x = -this.x;
                this.y = -this.y;
                this.z = -this.z;
                return this;
            }
        },
        {
            key: "dot",
            value: function dot(v) {
                return this.x * v.x + this.y * v.y + this.z * v.z;
            }
        },
        {
            // TODO lengthSquared?
            key: "lengthSq",
            value: function lengthSq() {
                return this.x * this.x + this.y * this.y + this.z * this.z;
            }
        },
        {
            key: "length",
            value: function length() {
                return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
            }
        },
        {
            key: "manhattanLength",
            value: function manhattanLength() {
                return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
            }
        },
        {
            key: "normalize",
            value: function normalize() {
                return this.divideScalar(this.length() || 1);
            }
        },
        {
            key: "setLength",
            value: function setLength(length) {
                return this.normalize().multiplyScalar(length);
            }
        },
        {
            key: "lerp",
            value: function lerp(v, alpha) {
                this.x += (v.x - this.x) * alpha;
                this.y += (v.y - this.y) * alpha;
                this.z += (v.z - this.z) * alpha;
                return this;
            }
        },
        {
            key: "lerpVectors",
            value: function lerpVectors(v1, v2, alpha) {
                this.x = v1.x + (v2.x - v1.x) * alpha;
                this.y = v1.y + (v2.y - v1.y) * alpha;
                this.z = v1.z + (v2.z - v1.z) * alpha;
                return this;
            }
        },
        {
            key: "cross",
            value: function cross(v, w) {
                if (w !== undefined) {
                    console.warn('THREE.Vector3: .cross() now only accepts one argument. Use .crossVectors( a, b ) instead.');
                    return this.crossVectors(v, w);
                }
                return this.crossVectors(this, v);
            }
        },
        {
            key: "crossVectors",
            value: function crossVectors(a, b) {
                var ax = a.x, ay = a.y, az = a.z;
                var bx = b.x, by = b.y, bz = b.z;
                this.x = ay * bz - az * by;
                this.y = az * bx - ax * bz;
                this.z = ax * by - ay * bx;
                return this;
            }
        },
        {
            key: "projectOnVector",
            value: function projectOnVector(v) {
                var denominator = v.lengthSq();
                if (denominator === 0) return this.set(0, 0, 0);
                var scalar = v.dot(this) / denominator;
                return this.copy(v).multiplyScalar(scalar);
            }
        },
        {
            key: "projectOnPlane",
            value: function projectOnPlane(planeNormal) {
                $c702e238df7c5123$var$_vector$c.copy(this).projectOnVector(planeNormal);
                return this.sub($c702e238df7c5123$var$_vector$c);
            }
        },
        {
            key: "reflect",
            value: function reflect(normal) {
                // reflect incident vector off plane orthogonal to normal
                // normal is assumed to have unit length
                return this.sub($c702e238df7c5123$var$_vector$c.copy(normal).multiplyScalar(2 * this.dot(normal)));
            }
        },
        {
            key: "angleTo",
            value: function angleTo(v) {
                var denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
                if (denominator === 0) return Math.PI / 2;
                var theta = this.dot(v) / denominator;
                // clamp, to handle numerical problems
                return Math.acos($c702e238df7c5123$var$clamp(theta, -1, 1));
            }
        },
        {
            key: "distanceTo",
            value: function distanceTo(v) {
                return Math.sqrt(this.distanceToSquared(v));
            }
        },
        {
            key: "distanceToSquared",
            value: function distanceToSquared(v) {
                var dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z;
                return dx * dx + dy * dy + dz * dz;
            }
        },
        {
            key: "manhattanDistanceTo",
            value: function manhattanDistanceTo(v) {
                return Math.abs(this.x - v.x) + Math.abs(this.y - v.y) + Math.abs(this.z - v.z);
            }
        },
        {
            key: "setFromSpherical",
            value: function setFromSpherical(s) {
                return this.setFromSphericalCoords(s.radius, s.phi, s.theta);
            }
        },
        {
            key: "setFromSphericalCoords",
            value: function setFromSphericalCoords(radius, phi, theta) {
                var sinPhiRadius = Math.sin(phi) * radius;
                this.x = sinPhiRadius * Math.sin(theta);
                this.y = Math.cos(phi) * radius;
                this.z = sinPhiRadius * Math.cos(theta);
                return this;
            }
        },
        {
            key: "setFromCylindrical",
            value: function setFromCylindrical(c) {
                return this.setFromCylindricalCoords(c.radius, c.theta, c.y);
            }
        },
        {
            key: "setFromCylindricalCoords",
            value: function setFromCylindricalCoords(radius, theta, y) {
                this.x = radius * Math.sin(theta);
                this.y = y;
                this.z = radius * Math.cos(theta);
                return this;
            }
        },
        {
            key: "setFromMatrixPosition",
            value: function setFromMatrixPosition(m) {
                var e = m.elements;
                this.x = e[12];
                this.y = e[13];
                this.z = e[14];
                return this;
            }
        },
        {
            key: "setFromMatrixScale",
            value: function setFromMatrixScale(m) {
                var sx = this.setFromMatrixColumn(m, 0).length();
                var sy = this.setFromMatrixColumn(m, 1).length();
                var sz = this.setFromMatrixColumn(m, 2).length();
                this.x = sx;
                this.y = sy;
                this.z = sz;
                return this;
            }
        },
        {
            key: "setFromMatrixColumn",
            value: function setFromMatrixColumn(m, index) {
                return this.fromArray(m.elements, index * 4);
            }
        },
        {
            key: "setFromMatrix3Column",
            value: function setFromMatrix3Column(m, index) {
                return this.fromArray(m.elements, index * 3);
            }
        },
        {
            key: "equals",
            value: function equals(v) {
                return v.x === this.x && v.y === this.y && v.z === this.z;
            }
        },
        {
            key: "fromArray",
            value: function fromArray(array) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                this.x = array[offset];
                this.y = array[offset + 1];
                this.z = array[offset + 2];
                return this;
            }
        },
        {
            key: "toArray",
            value: function toArray() {
                var array = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                array[offset] = this.x;
                array[offset + 1] = this.y;
                array[offset + 2] = this.z;
                return array;
            }
        },
        {
            key: "fromBufferAttribute",
            value: function fromBufferAttribute(attribute, index, offset) {
                if (offset !== undefined) console.warn('THREE.Vector3: offset has been removed from .fromBufferAttribute().');
                this.x = attribute.getX(index);
                this.y = attribute.getY(index);
                this.z = attribute.getZ(index);
                return this;
            }
        },
        {
            key: "random",
            value: function random() {
                this.x = Math.random();
                this.y = Math.random();
                this.z = Math.random();
                return this;
            }
        }
    ]);
    return Vector3;
}();
$c702e238df7c5123$export$64b5c384219d3699.prototype.isVector3 = true;
var $c702e238df7c5123$var$_vector$c = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_quaternion$4 = /*@__PURE__*/ new $c702e238df7c5123$export$23d6a54f0bbc85a3();
var $c702e238df7c5123$export$6f7d5a9418ab2aa3 = /*#__PURE__*/ function() {
    "use strict";
    function Box3() {
        var min = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $c702e238df7c5123$export$64b5c384219d3699(Infinity, Infinity, Infinity), max = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $c702e238df7c5123$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity);
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Box3);
        this.min = min;
        this.max = max;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(Box3, [
        {
            key: "set",
            value: function set(min, max) {
                this.min.copy(min);
                this.max.copy(max);
                return this;
            }
        },
        {
            key: "setFromArray",
            value: function setFromArray(array) {
                var minX = Infinity;
                var minY = Infinity;
                var minZ = Infinity;
                var maxX = -Infinity;
                var maxY = -Infinity;
                var maxZ = -Infinity;
                for(var i = 0, l = array.length; i < l; i += 3){
                    var x = array[i];
                    var y = array[i + 1];
                    var z = array[i + 2];
                    if (x < minX) minX = x;
                    if (y < minY) minY = y;
                    if (z < minZ) minZ = z;
                    if (x > maxX) maxX = x;
                    if (y > maxY) maxY = y;
                    if (z > maxZ) maxZ = z;
                }
                this.min.set(minX, minY, minZ);
                this.max.set(maxX, maxY, maxZ);
                return this;
            }
        },
        {
            key: "setFromBufferAttribute",
            value: function setFromBufferAttribute(attribute) {
                var minX = Infinity;
                var minY = Infinity;
                var minZ = Infinity;
                var maxX = -Infinity;
                var maxY = -Infinity;
                var maxZ = -Infinity;
                for(var i = 0, l = attribute.count; i < l; i++){
                    var x = attribute.getX(i);
                    var y = attribute.getY(i);
                    var z = attribute.getZ(i);
                    if (x < minX) minX = x;
                    if (y < minY) minY = y;
                    if (z < minZ) minZ = z;
                    if (x > maxX) maxX = x;
                    if (y > maxY) maxY = y;
                    if (z > maxZ) maxZ = z;
                }
                this.min.set(minX, minY, minZ);
                this.max.set(maxX, maxY, maxZ);
                return this;
            }
        },
        {
            key: "setFromPoints",
            value: function setFromPoints(points) {
                this.makeEmpty();
                for(var i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
                return this;
            }
        },
        {
            key: "setFromCenterAndSize",
            value: function setFromCenterAndSize(center, size) {
                var halfSize = $c702e238df7c5123$var$_vector$b.copy(size).multiplyScalar(0.5);
                this.min.copy(center).sub(halfSize);
                this.max.copy(center).add(halfSize);
                return this;
            }
        },
        {
            key: "setFromObject",
            value: function setFromObject(object) {
                this.makeEmpty();
                return this.expandByObject(object);
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        },
        {
            key: "copy",
            value: function copy(box) {
                this.min.copy(box.min);
                this.max.copy(box.max);
                return this;
            }
        },
        {
            key: "makeEmpty",
            value: function makeEmpty() {
                this.min.x = this.min.y = this.min.z = Infinity;
                this.max.x = this.max.y = this.max.z = -Infinity;
                return this;
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
                return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
            }
        },
        {
            key: "getCenter",
            value: function getCenter(target) {
                return this.isEmpty() ? target.set(0, 0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
            }
        },
        {
            key: "getSize",
            value: function getSize(target) {
                return this.isEmpty() ? target.set(0, 0, 0) : target.subVectors(this.max, this.min);
            }
        },
        {
            key: "expandByPoint",
            value: function expandByPoint(point) {
                this.min.min(point);
                this.max.max(point);
                return this;
            }
        },
        {
            key: "expandByVector",
            value: function expandByVector(vector) {
                this.min.sub(vector);
                this.max.add(vector);
                return this;
            }
        },
        {
            key: "expandByScalar",
            value: function expandByScalar(scalar) {
                this.min.addScalar(-scalar);
                this.max.addScalar(scalar);
                return this;
            }
        },
        {
            key: "expandByObject",
            value: function expandByObject(object) {
                // Computes the world-axis-aligned bounding box of an object (including its children),
                // accounting for both the object's, and children's, world transforms
                object.updateWorldMatrix(false, false);
                var geometry = object.geometry;
                if (geometry !== undefined) {
                    if (geometry.boundingBox === null) geometry.computeBoundingBox();
                    $c702e238df7c5123$var$_box$3.copy(geometry.boundingBox);
                    $c702e238df7c5123$var$_box$3.applyMatrix4(object.matrixWorld);
                    this.union($c702e238df7c5123$var$_box$3);
                }
                var children = object.children;
                for(var i = 0, l = children.length; i < l; i++)this.expandByObject(children[i]);
                return this;
            }
        },
        {
            key: "containsPoint",
            value: function containsPoint(point) {
                return point.x < this.min.x || point.x > this.max.x || point.y < this.min.y || point.y > this.max.y || point.z < this.min.z || point.z > this.max.z ? false : true;
            }
        },
        {
            key: "containsBox",
            value: function containsBox(box) {
                return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y && this.min.z <= box.min.z && box.max.z <= this.max.z;
            }
        },
        {
            key: "getParameter",
            value: function getParameter(point, target) {
                // This can potentially have a divide by zero if the box
                // has a size dimension of 0.
                return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y), (point.z - this.min.z) / (this.max.z - this.min.z));
            }
        },
        {
            key: "intersectsBox",
            value: function intersectsBox(box) {
                // using 6 splitting planes to rule out intersections.
                return box.max.x < this.min.x || box.min.x > this.max.x || box.max.y < this.min.y || box.min.y > this.max.y || box.max.z < this.min.z || box.min.z > this.max.z ? false : true;
            }
        },
        {
            key: "intersectsSphere",
            value: function intersectsSphere(sphere) {
                // Find the point on the AABB closest to the sphere center.
                this.clampPoint(sphere.center, $c702e238df7c5123$var$_vector$b);
                // If that point is inside the sphere, the AABB and sphere intersect.
                return $c702e238df7c5123$var$_vector$b.distanceToSquared(sphere.center) <= sphere.radius * sphere.radius;
            }
        },
        {
            key: "intersectsPlane",
            value: function intersectsPlane(plane) {
                // We compute the minimum and maximum dot product values. If those values
                // are on the same side (back or front) of the plane, then there is no intersection.
                var min, max;
                if (plane.normal.x > 0) {
                    min = plane.normal.x * this.min.x;
                    max = plane.normal.x * this.max.x;
                } else {
                    min = plane.normal.x * this.max.x;
                    max = plane.normal.x * this.min.x;
                }
                if (plane.normal.y > 0) {
                    min += plane.normal.y * this.min.y;
                    max += plane.normal.y * this.max.y;
                } else {
                    min += plane.normal.y * this.max.y;
                    max += plane.normal.y * this.min.y;
                }
                if (plane.normal.z > 0) {
                    min += plane.normal.z * this.min.z;
                    max += plane.normal.z * this.max.z;
                } else {
                    min += plane.normal.z * this.max.z;
                    max += plane.normal.z * this.min.z;
                }
                return min <= -plane.constant && max >= -plane.constant;
            }
        },
        {
            key: "intersectsTriangle",
            value: function intersectsTriangle(triangle) {
                if (this.isEmpty()) return false;
                // compute box center and extents
                this.getCenter($c702e238df7c5123$var$_center);
                $c702e238df7c5123$var$_extents.subVectors(this.max, $c702e238df7c5123$var$_center);
                // translate triangle to aabb origin
                $c702e238df7c5123$var$_v0$2.subVectors(triangle.a, $c702e238df7c5123$var$_center);
                $c702e238df7c5123$var$_v1$7.subVectors(triangle.b, $c702e238df7c5123$var$_center);
                $c702e238df7c5123$var$_v2$3.subVectors(triangle.c, $c702e238df7c5123$var$_center);
                // compute edge vectors for triangle
                $c702e238df7c5123$var$_f0.subVectors($c702e238df7c5123$var$_v1$7, $c702e238df7c5123$var$_v0$2);
                $c702e238df7c5123$var$_f1.subVectors($c702e238df7c5123$var$_v2$3, $c702e238df7c5123$var$_v1$7);
                $c702e238df7c5123$var$_f2.subVectors($c702e238df7c5123$var$_v0$2, $c702e238df7c5123$var$_v2$3);
                // test against axes that are given by cross product combinations of the edges of the triangle and the edges of the aabb
                // make an axis testing of each of the 3 sides of the aabb against each of the 3 sides of the triangle = 9 axis of separation
                // axis_ij = u_i x f_j (u0, u1, u2 = face normals of aabb = x,y,z axes vectors since aabb is axis aligned)
                var axes = [
                    0,
                    -$c702e238df7c5123$var$_f0.z,
                    $c702e238df7c5123$var$_f0.y,
                    0,
                    -$c702e238df7c5123$var$_f1.z,
                    $c702e238df7c5123$var$_f1.y,
                    0,
                    -$c702e238df7c5123$var$_f2.z,
                    $c702e238df7c5123$var$_f2.y,
                    $c702e238df7c5123$var$_f0.z,
                    0,
                    -$c702e238df7c5123$var$_f0.x,
                    $c702e238df7c5123$var$_f1.z,
                    0,
                    -$c702e238df7c5123$var$_f1.x,
                    $c702e238df7c5123$var$_f2.z,
                    0,
                    -$c702e238df7c5123$var$_f2.x,
                    -$c702e238df7c5123$var$_f0.y,
                    $c702e238df7c5123$var$_f0.x,
                    0,
                    -$c702e238df7c5123$var$_f1.y,
                    $c702e238df7c5123$var$_f1.x,
                    0,
                    -$c702e238df7c5123$var$_f2.y,
                    $c702e238df7c5123$var$_f2.x,
                    0
                ];
                if (!$c702e238df7c5123$var$satForAxes(axes, $c702e238df7c5123$var$_v0$2, $c702e238df7c5123$var$_v1$7, $c702e238df7c5123$var$_v2$3, $c702e238df7c5123$var$_extents)) return false;
                // test 3 face normals from the aabb
                axes = [
                    1,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    1
                ];
                if (!$c702e238df7c5123$var$satForAxes(axes, $c702e238df7c5123$var$_v0$2, $c702e238df7c5123$var$_v1$7, $c702e238df7c5123$var$_v2$3, $c702e238df7c5123$var$_extents)) return false;
                // finally testing the face normal of the triangle
                // use already existing triangle edge vectors here
                $c702e238df7c5123$var$_triangleNormal.crossVectors($c702e238df7c5123$var$_f0, $c702e238df7c5123$var$_f1);
                axes = [
                    $c702e238df7c5123$var$_triangleNormal.x,
                    $c702e238df7c5123$var$_triangleNormal.y,
                    $c702e238df7c5123$var$_triangleNormal.z
                ];
                return $c702e238df7c5123$var$satForAxes(axes, $c702e238df7c5123$var$_v0$2, $c702e238df7c5123$var$_v1$7, $c702e238df7c5123$var$_v2$3, $c702e238df7c5123$var$_extents);
            }
        },
        {
            key: "clampPoint",
            value: function clampPoint(point, target) {
                return target.copy(point).clamp(this.min, this.max);
            }
        },
        {
            key: "distanceToPoint",
            value: function distanceToPoint(point) {
                var clampedPoint = $c702e238df7c5123$var$_vector$b.copy(point).clamp(this.min, this.max);
                return clampedPoint.sub(point).length();
            }
        },
        {
            key: "getBoundingSphere",
            value: function getBoundingSphere(target) {
                this.getCenter(target.center);
                target.radius = this.getSize($c702e238df7c5123$var$_vector$b).length() * 0.5;
                return target;
            }
        },
        {
            key: "intersect",
            value: function intersect(box) {
                this.min.max(box.min);
                this.max.min(box.max);
                // ensure that if there is no overlap, the result is fully empty, not slightly empty with non-inf/+inf values that will cause subsequence intersects to erroneously return valid values.
                if (this.isEmpty()) this.makeEmpty();
                return this;
            }
        },
        {
            key: "union",
            value: function union(box) {
                this.min.min(box.min);
                this.max.max(box.max);
                return this;
            }
        },
        {
            key: "applyMatrix4",
            value: function applyMatrix4(matrix) {
                // transform of empty box is an empty box.
                if (this.isEmpty()) return this;
                // NOTE: I am using a binary pattern to specify all 2^3 combinations below
                $c702e238df7c5123$var$_points[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(matrix); // 000
                $c702e238df7c5123$var$_points[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(matrix); // 001
                $c702e238df7c5123$var$_points[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(matrix); // 010
                $c702e238df7c5123$var$_points[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(matrix); // 011
                $c702e238df7c5123$var$_points[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(matrix); // 100
                $c702e238df7c5123$var$_points[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(matrix); // 101
                $c702e238df7c5123$var$_points[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(matrix); // 110
                $c702e238df7c5123$var$_points[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(matrix); // 111
                this.setFromPoints($c702e238df7c5123$var$_points);
                return this;
            }
        },
        {
            key: "translate",
            value: function translate(offset) {
                this.min.add(offset);
                this.max.add(offset);
                return this;
            }
        },
        {
            key: "equals",
            value: function equals(box) {
                return box.min.equals(this.min) && box.max.equals(this.max);
            }
        }
    ]);
    return Box3;
}();
$c702e238df7c5123$export$6f7d5a9418ab2aa3.prototype.isBox3 = true;
var $c702e238df7c5123$var$_points = [
    /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699(),
    /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699(),
    /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699(),
    /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699(),
    /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699(),
    /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699(),
    /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699(),
    /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699()
];
var $c702e238df7c5123$var$_vector$b = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_box$3 = /*@__PURE__*/ new $c702e238df7c5123$export$6f7d5a9418ab2aa3();
// triangle centered vertices
var $c702e238df7c5123$var$_v0$2 = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_v1$7 = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_v2$3 = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
// triangle edge vectors
var $c702e238df7c5123$var$_f0 = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_f1 = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_f2 = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_center = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_extents = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_triangleNormal = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_testAxis = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
function $c702e238df7c5123$var$satForAxes(axes, v0, v1, v2, extents) {
    for(var i = 0, j = axes.length - 3; i <= j; i += 3){
        $c702e238df7c5123$var$_testAxis.fromArray(axes, i);
        // project the aabb onto the seperating axis
        var r = extents.x * Math.abs($c702e238df7c5123$var$_testAxis.x) + extents.y * Math.abs($c702e238df7c5123$var$_testAxis.y) + extents.z * Math.abs($c702e238df7c5123$var$_testAxis.z);
        // project all 3 vertices of the triangle onto the seperating axis
        var p0 = v0.dot($c702e238df7c5123$var$_testAxis);
        var p1 = v1.dot($c702e238df7c5123$var$_testAxis);
        var p2 = v2.dot($c702e238df7c5123$var$_testAxis);
        // actual test, basically see if either of the most extreme of the triangle points intersects r
        if (Math.max(-Math.max(p0, p1, p2), Math.min(p0, p1, p2)) > r) // points of the projected triangle are outside the projected half-length of the aabb
        // the axis is seperating and we can exit
        return false;
    }
    return true;
}
var $c702e238df7c5123$var$_box$2 = /*@__PURE__*/ new $c702e238df7c5123$export$6f7d5a9418ab2aa3();
var $c702e238df7c5123$var$_v1$6 = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_toFarthestPoint = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_toPoint = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$export$805e8b72413ccaba = /*#__PURE__*/ function() {
    "use strict";
    function Sphere() {
        var center = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $c702e238df7c5123$export$64b5c384219d3699(), radius = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Sphere);
        this.center = center;
        this.radius = radius;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(Sphere, [
        {
            key: "set",
            value: function set(center, radius) {
                this.center.copy(center);
                this.radius = radius;
                return this;
            }
        },
        {
            key: "setFromPoints",
            value: function setFromPoints(points, optionalCenter) {
                var center = this.center;
                if (optionalCenter !== undefined) center.copy(optionalCenter);
                else $c702e238df7c5123$var$_box$2.setFromPoints(points).getCenter(center);
                var maxRadiusSq = 0;
                for(var i = 0, il = points.length; i < il; i++)maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(points[i]));
                this.radius = Math.sqrt(maxRadiusSq);
                return this;
            }
        },
        {
            key: "copy",
            value: function copy(sphere) {
                this.center.copy(sphere.center);
                this.radius = sphere.radius;
                return this;
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return this.radius < 0;
            }
        },
        {
            key: "makeEmpty",
            value: function makeEmpty() {
                this.center.set(0, 0, 0);
                this.radius = -1;
                return this;
            }
        },
        {
            key: "containsPoint",
            value: function containsPoint(point) {
                return point.distanceToSquared(this.center) <= this.radius * this.radius;
            }
        },
        {
            key: "distanceToPoint",
            value: function distanceToPoint(point) {
                return point.distanceTo(this.center) - this.radius;
            }
        },
        {
            key: "intersectsSphere",
            value: function intersectsSphere(sphere) {
                var radiusSum = this.radius + sphere.radius;
                return sphere.center.distanceToSquared(this.center) <= radiusSum * radiusSum;
            }
        },
        {
            key: "intersectsBox",
            value: function intersectsBox(box) {
                return box.intersectsSphere(this);
            }
        },
        {
            key: "intersectsPlane",
            value: function intersectsPlane(plane) {
                return Math.abs(plane.distanceToPoint(this.center)) <= this.radius;
            }
        },
        {
            key: "clampPoint",
            value: function clampPoint(point, target) {
                var deltaLengthSq = this.center.distanceToSquared(point);
                target.copy(point);
                if (deltaLengthSq > this.radius * this.radius) {
                    target.sub(this.center).normalize();
                    target.multiplyScalar(this.radius).add(this.center);
                }
                return target;
            }
        },
        {
            key: "getBoundingBox",
            value: function getBoundingBox(target) {
                if (this.isEmpty()) {
                    // Empty sphere produces empty bounding box
                    target.makeEmpty();
                    return target;
                }
                target.set(this.center, this.center);
                target.expandByScalar(this.radius);
                return target;
            }
        },
        {
            key: "applyMatrix4",
            value: function applyMatrix4(matrix) {
                this.center.applyMatrix4(matrix);
                this.radius = this.radius * matrix.getMaxScaleOnAxis();
                return this;
            }
        },
        {
            key: "translate",
            value: function translate(offset) {
                this.center.add(offset);
                return this;
            }
        },
        {
            key: "expandByPoint",
            value: function expandByPoint(point) {
                // from https://github.com/juj/MathGeoLib/blob/2940b99b99cfe575dd45103ef20f4019dee15b54/src/Geometry/Sphere.cpp#L649-L671
                $c702e238df7c5123$var$_toPoint.subVectors(point, this.center);
                var lengthSq = $c702e238df7c5123$var$_toPoint.lengthSq();
                if (lengthSq > this.radius * this.radius) {
                    var length = Math.sqrt(lengthSq);
                    var missingRadiusHalf = (length - this.radius) * 0.5;
                    // Nudge this sphere towards the target point. Add half the missing distance to radius,
                    // and the other half to position. This gives a tighter enclosure, instead of if
                    // the whole missing distance were just added to radius.
                    this.center.add($c702e238df7c5123$var$_toPoint.multiplyScalar(missingRadiusHalf / length));
                    this.radius += missingRadiusHalf;
                }
                return this;
            }
        },
        {
            key: "union",
            value: function union(sphere) {
                // from https://github.com/juj/MathGeoLib/blob/2940b99b99cfe575dd45103ef20f4019dee15b54/src/Geometry/Sphere.cpp#L759-L769
                // To enclose another sphere into this sphere, we only need to enclose two points:
                // 1) Enclose the farthest point on the other sphere into this sphere.
                // 2) Enclose the opposite point of the farthest point into this sphere.
                $c702e238df7c5123$var$_toFarthestPoint.subVectors(sphere.center, this.center).normalize().multiplyScalar(sphere.radius);
                this.expandByPoint($c702e238df7c5123$var$_v1$6.copy(sphere.center).add($c702e238df7c5123$var$_toFarthestPoint));
                this.expandByPoint($c702e238df7c5123$var$_v1$6.copy(sphere.center).sub($c702e238df7c5123$var$_toFarthestPoint));
                return this;
            }
        },
        {
            key: "equals",
            value: function equals(sphere) {
                return sphere.center.equals(this.center) && sphere.radius === this.radius;
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        }
    ]);
    return Sphere;
}();
var $c702e238df7c5123$var$_vector$a = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_segCenter = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_segDir = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_diff = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_edge1 = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_edge2 = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_normal$1 = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$export$a186db52eed6d40e = /*#__PURE__*/ function() {
    "use strict";
    function Ray() {
        var origin = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $c702e238df7c5123$export$64b5c384219d3699(), direction = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $c702e238df7c5123$export$64b5c384219d3699(0, 0, -1);
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Ray);
        this.origin = origin;
        this.direction = direction;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(Ray, [
        {
            key: "set",
            value: function set(origin, direction) {
                this.origin.copy(origin);
                this.direction.copy(direction);
                return this;
            }
        },
        {
            key: "copy",
            value: function copy(ray) {
                this.origin.copy(ray.origin);
                this.direction.copy(ray.direction);
                return this;
            }
        },
        {
            key: "at",
            value: function at(t, target) {
                return target.copy(this.direction).multiplyScalar(t).add(this.origin);
            }
        },
        {
            key: "lookAt",
            value: function lookAt(v) {
                this.direction.copy(v).sub(this.origin).normalize();
                return this;
            }
        },
        {
            key: "recast",
            value: function recast(t) {
                this.origin.copy(this.at(t, $c702e238df7c5123$var$_vector$a));
                return this;
            }
        },
        {
            key: "closestPointToPoint",
            value: function closestPointToPoint(point, target) {
                target.subVectors(point, this.origin);
                var directionDistance = target.dot(this.direction);
                if (directionDistance < 0) return target.copy(this.origin);
                return target.copy(this.direction).multiplyScalar(directionDistance).add(this.origin);
            }
        },
        {
            key: "distanceToPoint",
            value: function distanceToPoint(point) {
                return Math.sqrt(this.distanceSqToPoint(point));
            }
        },
        {
            key: "distanceSqToPoint",
            value: function distanceSqToPoint(point) {
                var directionDistance = $c702e238df7c5123$var$_vector$a.subVectors(point, this.origin).dot(this.direction);
                // point behind the ray
                if (directionDistance < 0) return this.origin.distanceToSquared(point);
                $c702e238df7c5123$var$_vector$a.copy(this.direction).multiplyScalar(directionDistance).add(this.origin);
                return $c702e238df7c5123$var$_vector$a.distanceToSquared(point);
            }
        },
        {
            key: "distanceSqToSegment",
            value: function distanceSqToSegment(v0, v1, optionalPointOnRay, optionalPointOnSegment) {
                // from http://www.geometrictools.com/GTEngine/Include/Mathematics/GteDistRaySegment.h
                // It returns the min distance between the ray and the segment
                // defined by v0 and v1
                // It can also set two optional targets :
                // - The closest point on the ray
                // - The closest point on the segment
                $c702e238df7c5123$var$_segCenter.copy(v0).add(v1).multiplyScalar(0.5);
                $c702e238df7c5123$var$_segDir.copy(v1).sub(v0).normalize();
                $c702e238df7c5123$var$_diff.copy(this.origin).sub($c702e238df7c5123$var$_segCenter);
                var segExtent = v0.distanceTo(v1) * 0.5;
                var a01 = -this.direction.dot($c702e238df7c5123$var$_segDir);
                var b0 = $c702e238df7c5123$var$_diff.dot(this.direction);
                var b1 = -$c702e238df7c5123$var$_diff.dot($c702e238df7c5123$var$_segDir);
                var c = $c702e238df7c5123$var$_diff.lengthSq();
                var det = Math.abs(1 - a01 * a01);
                var s0, s1, sqrDist, extDet;
                if (det > 0) {
                    // The ray and segment are not parallel.
                    s0 = a01 * b1 - b0;
                    s1 = a01 * b0 - b1;
                    extDet = segExtent * det;
                    if (s0 >= 0) {
                        if (s1 >= -extDet) {
                            if (s1 <= extDet) {
                                // region 0
                                // Minimum at interior points of ray and segment.
                                var invDet = 1 / det;
                                s0 *= invDet;
                                s1 *= invDet;
                                sqrDist = s0 * (s0 + a01 * s1 + 2 * b0) + s1 * (a01 * s0 + s1 + 2 * b1) + c;
                            } else {
                                // region 1
                                s1 = segExtent;
                                s0 = Math.max(0, -(a01 * s1 + b0));
                                sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                            }
                        } else {
                            // region 5
                            s1 = -segExtent;
                            s0 = Math.max(0, -(a01 * s1 + b0));
                            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                        }
                    } else {
                        if (s1 <= -extDet) {
                            // region 4
                            s0 = Math.max(0, -(-a01 * segExtent + b0));
                            s1 = s0 > 0 ? -segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                        } else if (s1 <= extDet) {
                            // region 3
                            s0 = 0;
                            s1 = Math.min(Math.max(-segExtent, -b1), segExtent);
                            sqrDist = s1 * (s1 + 2 * b1) + c;
                        } else {
                            // region 2
                            s0 = Math.max(0, -(a01 * segExtent + b0));
                            s1 = s0 > 0 ? segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                        }
                    }
                } else {
                    // Ray and segment are parallel.
                    s1 = a01 > 0 ? -segExtent : segExtent;
                    s0 = Math.max(0, -(a01 * s1 + b0));
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
                if (optionalPointOnRay) optionalPointOnRay.copy(this.direction).multiplyScalar(s0).add(this.origin);
                if (optionalPointOnSegment) optionalPointOnSegment.copy($c702e238df7c5123$var$_segDir).multiplyScalar(s1).add($c702e238df7c5123$var$_segCenter);
                return sqrDist;
            }
        },
        {
            key: "intersectSphere",
            value: function intersectSphere(sphere, target) {
                $c702e238df7c5123$var$_vector$a.subVectors(sphere.center, this.origin);
                var tca = $c702e238df7c5123$var$_vector$a.dot(this.direction);
                var d2 = $c702e238df7c5123$var$_vector$a.dot($c702e238df7c5123$var$_vector$a) - tca * tca;
                var radius2 = sphere.radius * sphere.radius;
                if (d2 > radius2) return null;
                var thc = Math.sqrt(radius2 - d2);
                // t0 = first intersect point - entrance on front of sphere
                var t0 = tca - thc;
                // t1 = second intersect point - exit point on back of sphere
                var t1 = tca + thc;
                // test to see if both t0 and t1 are behind the ray - if so, return null
                if (t0 < 0 && t1 < 0) return null;
                // test to see if t0 is behind the ray:
                // if it is, the ray is inside the sphere, so return the second exit point scaled by t1,
                // in order to always return an intersect point that is in front of the ray.
                if (t0 < 0) return this.at(t1, target);
                // else t0 is in front of the ray, so return the first collision point scaled by t0
                return this.at(t0, target);
            }
        },
        {
            key: "intersectsSphere",
            value: function intersectsSphere(sphere) {
                return this.distanceSqToPoint(sphere.center) <= sphere.radius * sphere.radius;
            }
        },
        {
            key: "distanceToPlane",
            value: function distanceToPlane(plane) {
                var denominator = plane.normal.dot(this.direction);
                if (denominator === 0) {
                    // line is coplanar, return origin
                    if (plane.distanceToPoint(this.origin) === 0) return 0;
                    // Null is preferable to undefined since undefined means.... it is undefined
                    return null;
                }
                var t = -(this.origin.dot(plane.normal) + plane.constant) / denominator;
                // Return if the ray never intersects the plane
                return t >= 0 ? t : null;
            }
        },
        {
            key: "intersectPlane",
            value: function intersectPlane(plane, target) {
                var t = this.distanceToPlane(plane);
                if (t === null) return null;
                return this.at(t, target);
            }
        },
        {
            key: "intersectsPlane",
            value: function intersectsPlane(plane) {
                // check if the ray lies on the plane first
                var distToPoint = plane.distanceToPoint(this.origin);
                if (distToPoint === 0) return true;
                var denominator = plane.normal.dot(this.direction);
                if (denominator * distToPoint < 0) return true;
                // ray origin is behind the plane (and is pointing behind it)
                return false;
            }
        },
        {
            key: "intersectBox",
            value: function intersectBox(box, target) {
                var tmin, tmax, tymin, tymax, tzmin, tzmax;
                var invdirx = 1 / this.direction.x, invdiry = 1 / this.direction.y, invdirz = 1 / this.direction.z;
                var origin = this.origin;
                if (invdirx >= 0) {
                    tmin = (box.min.x - origin.x) * invdirx;
                    tmax = (box.max.x - origin.x) * invdirx;
                } else {
                    tmin = (box.max.x - origin.x) * invdirx;
                    tmax = (box.min.x - origin.x) * invdirx;
                }
                if (invdiry >= 0) {
                    tymin = (box.min.y - origin.y) * invdiry;
                    tymax = (box.max.y - origin.y) * invdiry;
                } else {
                    tymin = (box.max.y - origin.y) * invdiry;
                    tymax = (box.min.y - origin.y) * invdiry;
                }
                if (tmin > tymax || tymin > tmax) return null;
                // These lines also handle the case where tmin or tmax is NaN
                // (result of 0 * Infinity). x !== x returns true if x is NaN
                if (tymin > tmin || tmin !== tmin) tmin = tymin;
                if (tymax < tmax || tmax !== tmax) tmax = tymax;
                if (invdirz >= 0) {
                    tzmin = (box.min.z - origin.z) * invdirz;
                    tzmax = (box.max.z - origin.z) * invdirz;
                } else {
                    tzmin = (box.max.z - origin.z) * invdirz;
                    tzmax = (box.min.z - origin.z) * invdirz;
                }
                if (tmin > tzmax || tzmin > tmax) return null;
                if (tzmin > tmin || tmin !== tmin) tmin = tzmin;
                if (tzmax < tmax || tmax !== tmax) tmax = tzmax;
                //return point closest to the ray (positive side)
                if (tmax < 0) return null;
                return this.at(tmin >= 0 ? tmin : tmax, target);
            }
        },
        {
            key: "intersectsBox",
            value: function intersectsBox(box) {
                return this.intersectBox(box, $c702e238df7c5123$var$_vector$a) !== null;
            }
        },
        {
            key: "intersectTriangle",
            value: function intersectTriangle(a, b, c, backfaceCulling, target) {
                // Compute the offset origin, edges, and normal.
                // from http://www.geometrictools.com/GTEngine/Include/Mathematics/GteIntrRay3Triangle3.h
                $c702e238df7c5123$var$_edge1.subVectors(b, a);
                $c702e238df7c5123$var$_edge2.subVectors(c, a);
                $c702e238df7c5123$var$_normal$1.crossVectors($c702e238df7c5123$var$_edge1, $c702e238df7c5123$var$_edge2);
                // Solve Q + t*D = b1*E1 + b2*E2 (Q = kDiff, D = ray direction,
                // E1 = kEdge1, E2 = kEdge2, N = Cross(E1,E2)) by
                //   |Dot(D,N)|*b1 = sign(Dot(D,N))*Dot(D,Cross(Q,E2))
                //   |Dot(D,N)|*b2 = sign(Dot(D,N))*Dot(D,Cross(E1,Q))
                //   |Dot(D,N)|*t = -sign(Dot(D,N))*Dot(Q,N)
                var DdN = this.direction.dot($c702e238df7c5123$var$_normal$1);
                var sign;
                if (DdN > 0) {
                    if (backfaceCulling) return null;
                    sign = 1;
                } else if (DdN < 0) {
                    sign = -1;
                    DdN = -DdN;
                } else return null;
                $c702e238df7c5123$var$_diff.subVectors(this.origin, a);
                var DdQxE2 = sign * this.direction.dot($c702e238df7c5123$var$_edge2.crossVectors($c702e238df7c5123$var$_diff, $c702e238df7c5123$var$_edge2));
                // b1 < 0, no intersection
                if (DdQxE2 < 0) return null;
                var DdE1xQ = sign * this.direction.dot($c702e238df7c5123$var$_edge1.cross($c702e238df7c5123$var$_diff));
                // b2 < 0, no intersection
                if (DdE1xQ < 0) return null;
                // b1+b2 > 1, no intersection
                if (DdQxE2 + DdE1xQ > DdN) return null;
                // Line intersects triangle, check if ray does.
                var QdN = -sign * $c702e238df7c5123$var$_diff.dot($c702e238df7c5123$var$_normal$1);
                // t < 0, no intersection
                if (QdN < 0) return null;
                // Ray intersects triangle.
                return this.at(QdN / DdN, target);
            }
        },
        {
            key: "applyMatrix4",
            value: function applyMatrix4(matrix4) {
                this.origin.applyMatrix4(matrix4);
                this.direction.transformDirection(matrix4);
                return this;
            }
        },
        {
            key: "equals",
            value: function equals(ray) {
                return ray.origin.equals(this.origin) && ray.direction.equals(this.direction);
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        }
    ]);
    return Ray;
}();
var $c702e238df7c5123$export$2ae72fc923e5eb5 = /*#__PURE__*/ function() {
    "use strict";
    function Matrix4() {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Matrix4);
        this.elements = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ];
        if (arguments.length > 0) console.error('THREE.Matrix4: the constructor no longer reads arguments. use .set() instead.');
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(Matrix4, [
        {
            key: "set",
            value: function set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
                var te = this.elements;
                te[0] = n11;
                te[4] = n12;
                te[8] = n13;
                te[12] = n14;
                te[1] = n21;
                te[5] = n22;
                te[9] = n23;
                te[13] = n24;
                te[2] = n31;
                te[6] = n32;
                te[10] = n33;
                te[14] = n34;
                te[3] = n41;
                te[7] = n42;
                te[11] = n43;
                te[15] = n44;
                return this;
            }
        },
        {
            key: "identity",
            value: function identity() {
                this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
                return this;
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new Matrix4().fromArray(this.elements);
            }
        },
        {
            key: "copy",
            value: function copy(m) {
                var te = this.elements;
                var me = m.elements;
                te[0] = me[0];
                te[1] = me[1];
                te[2] = me[2];
                te[3] = me[3];
                te[4] = me[4];
                te[5] = me[5];
                te[6] = me[6];
                te[7] = me[7];
                te[8] = me[8];
                te[9] = me[9];
                te[10] = me[10];
                te[11] = me[11];
                te[12] = me[12];
                te[13] = me[13];
                te[14] = me[14];
                te[15] = me[15];
                return this;
            }
        },
        {
            key: "copyPosition",
            value: function copyPosition(m) {
                var te = this.elements, me = m.elements;
                te[12] = me[12];
                te[13] = me[13];
                te[14] = me[14];
                return this;
            }
        },
        {
            key: "setFromMatrix3",
            value: function setFromMatrix3(m) {
                var me = m.elements;
                this.set(me[0], me[3], me[6], 0, me[1], me[4], me[7], 0, me[2], me[5], me[8], 0, 0, 0, 0, 1);
                return this;
            }
        },
        {
            key: "extractBasis",
            value: function extractBasis(xAxis, yAxis, zAxis) {
                xAxis.setFromMatrixColumn(this, 0);
                yAxis.setFromMatrixColumn(this, 1);
                zAxis.setFromMatrixColumn(this, 2);
                return this;
            }
        },
        {
            key: "makeBasis",
            value: function makeBasis(xAxis, yAxis, zAxis) {
                this.set(xAxis.x, yAxis.x, zAxis.x, 0, xAxis.y, yAxis.y, zAxis.y, 0, xAxis.z, yAxis.z, zAxis.z, 0, 0, 0, 0, 1);
                return this;
            }
        },
        {
            key: "extractRotation",
            value: function extractRotation(m) {
                // this method does not support reflection matrices
                var te = this.elements;
                var me = m.elements;
                var scaleX = 1 / $c702e238df7c5123$var$_v1$5.setFromMatrixColumn(m, 0).length();
                var scaleY = 1 / $c702e238df7c5123$var$_v1$5.setFromMatrixColumn(m, 1).length();
                var scaleZ = 1 / $c702e238df7c5123$var$_v1$5.setFromMatrixColumn(m, 2).length();
                te[0] = me[0] * scaleX;
                te[1] = me[1] * scaleX;
                te[2] = me[2] * scaleX;
                te[3] = 0;
                te[4] = me[4] * scaleY;
                te[5] = me[5] * scaleY;
                te[6] = me[6] * scaleY;
                te[7] = 0;
                te[8] = me[8] * scaleZ;
                te[9] = me[9] * scaleZ;
                te[10] = me[10] * scaleZ;
                te[11] = 0;
                te[12] = 0;
                te[13] = 0;
                te[14] = 0;
                te[15] = 1;
                return this;
            }
        },
        {
            key: "makeRotationFromEuler",
            value: function makeRotationFromEuler(euler) {
                if (!(euler && euler.isEuler)) console.error('THREE.Matrix4: .makeRotationFromEuler() now expects a Euler rotation rather than a Vector3 and order.');
                var te = this.elements;
                var x = euler.x, y = euler.y, z = euler.z;
                var a = Math.cos(x), b = Math.sin(x);
                var c = Math.cos(y), d = Math.sin(y);
                var e = Math.cos(z), f = Math.sin(z);
                if (euler.order === 'XYZ') {
                    var ae = a * e, af = a * f, be = b * e, bf = b * f;
                    te[0] = c * e;
                    te[4] = -c * f;
                    te[8] = d;
                    te[1] = af + be * d;
                    te[5] = ae - bf * d;
                    te[9] = -b * c;
                    te[2] = bf - ae * d;
                    te[6] = be + af * d;
                    te[10] = a * c;
                } else if (euler.order === 'YXZ') {
                    var ce = c * e, cf = c * f, de = d * e, df = d * f;
                    te[0] = ce + df * b;
                    te[4] = de * b - cf;
                    te[8] = a * d;
                    te[1] = a * f;
                    te[5] = a * e;
                    te[9] = -b;
                    te[2] = cf * b - de;
                    te[6] = df + ce * b;
                    te[10] = a * c;
                } else if (euler.order === 'ZXY') {
                    var ce1 = c * e, cf1 = c * f, de1 = d * e, df1 = d * f;
                    te[0] = ce1 - df1 * b;
                    te[4] = -a * f;
                    te[8] = de1 + cf1 * b;
                    te[1] = cf1 + de1 * b;
                    te[5] = a * e;
                    te[9] = df1 - ce1 * b;
                    te[2] = -a * d;
                    te[6] = b;
                    te[10] = a * c;
                } else if (euler.order === 'ZYX') {
                    var ae1 = a * e, af1 = a * f, be1 = b * e, bf1 = b * f;
                    te[0] = c * e;
                    te[4] = be1 * d - af1;
                    te[8] = ae1 * d + bf1;
                    te[1] = c * f;
                    te[5] = bf1 * d + ae1;
                    te[9] = af1 * d - be1;
                    te[2] = -d;
                    te[6] = b * c;
                    te[10] = a * c;
                } else if (euler.order === 'YZX') {
                    var ac = a * c, ad = a * d, bc = b * c, bd = b * d;
                    te[0] = c * e;
                    te[4] = bd - ac * f;
                    te[8] = bc * f + ad;
                    te[1] = f;
                    te[5] = a * e;
                    te[9] = -b * e;
                    te[2] = -d * e;
                    te[6] = ad * f + bc;
                    te[10] = ac - bd * f;
                } else if (euler.order === 'XZY') {
                    var ac1 = a * c, ad1 = a * d, bc1 = b * c, bd1 = b * d;
                    te[0] = c * e;
                    te[4] = -f;
                    te[8] = d * e;
                    te[1] = ac1 * f + bd1;
                    te[5] = a * e;
                    te[9] = ad1 * f - bc1;
                    te[2] = bc1 * f - ad1;
                    te[6] = b * e;
                    te[10] = bd1 * f + ac1;
                }
                // bottom row
                te[3] = 0;
                te[7] = 0;
                te[11] = 0;
                // last column
                te[12] = 0;
                te[13] = 0;
                te[14] = 0;
                te[15] = 1;
                return this;
            }
        },
        {
            key: "makeRotationFromQuaternion",
            value: function makeRotationFromQuaternion(q) {
                return this.compose($c702e238df7c5123$var$_zero, q, $c702e238df7c5123$var$_one);
            }
        },
        {
            key: "lookAt",
            value: function lookAt(eye, target, up) {
                var te = this.elements;
                $c702e238df7c5123$var$_z.subVectors(eye, target);
                if ($c702e238df7c5123$var$_z.lengthSq() === 0) // eye and target are in the same position
                $c702e238df7c5123$var$_z.z = 1;
                $c702e238df7c5123$var$_z.normalize();
                $c702e238df7c5123$var$_x.crossVectors(up, $c702e238df7c5123$var$_z);
                if ($c702e238df7c5123$var$_x.lengthSq() === 0) {
                    // up and z are parallel
                    if (Math.abs(up.z) === 1) $c702e238df7c5123$var$_z.x += 0.0001;
                    else $c702e238df7c5123$var$_z.z += 0.0001;
                    $c702e238df7c5123$var$_z.normalize();
                    $c702e238df7c5123$var$_x.crossVectors(up, $c702e238df7c5123$var$_z);
                }
                $c702e238df7c5123$var$_x.normalize();
                $c702e238df7c5123$var$_y.crossVectors($c702e238df7c5123$var$_z, $c702e238df7c5123$var$_x);
                te[0] = $c702e238df7c5123$var$_x.x;
                te[4] = $c702e238df7c5123$var$_y.x;
                te[8] = $c702e238df7c5123$var$_z.x;
                te[1] = $c702e238df7c5123$var$_x.y;
                te[5] = $c702e238df7c5123$var$_y.y;
                te[9] = $c702e238df7c5123$var$_z.y;
                te[2] = $c702e238df7c5123$var$_x.z;
                te[6] = $c702e238df7c5123$var$_y.z;
                te[10] = $c702e238df7c5123$var$_z.z;
                return this;
            }
        },
        {
            key: "multiply",
            value: function multiply(m, n) {
                if (n !== undefined) {
                    console.warn('THREE.Matrix4: .multiply() now only accepts one argument. Use .multiplyMatrices( a, b ) instead.');
                    return this.multiplyMatrices(m, n);
                }
                return this.multiplyMatrices(this, m);
            }
        },
        {
            key: "premultiply",
            value: function premultiply(m) {
                return this.multiplyMatrices(m, this);
            }
        },
        {
            key: "multiplyMatrices",
            value: function multiplyMatrices(a, b) {
                var ae = a.elements;
                var be = b.elements;
                var te = this.elements;
                var a11 = ae[0], a12 = ae[4], a13 = ae[8], a14 = ae[12];
                var a21 = ae[1], a22 = ae[5], a23 = ae[9], a24 = ae[13];
                var a31 = ae[2], a32 = ae[6], a33 = ae[10], a34 = ae[14];
                var a41 = ae[3], a42 = ae[7], a43 = ae[11], a44 = ae[15];
                var b11 = be[0], b12 = be[4], b13 = be[8], b14 = be[12];
                var b21 = be[1], b22 = be[5], b23 = be[9], b24 = be[13];
                var b31 = be[2], b32 = be[6], b33 = be[10], b34 = be[14];
                var b41 = be[3], b42 = be[7], b43 = be[11], b44 = be[15];
                te[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
                te[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
                te[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
                te[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
                te[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
                te[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
                te[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
                te[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
                te[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
                te[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
                te[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
                te[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
                te[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
                te[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
                te[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
                te[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
                return this;
            }
        },
        {
            key: "multiplyScalar",
            value: function multiplyScalar(s) {
                var te = this.elements;
                te[0] *= s;
                te[4] *= s;
                te[8] *= s;
                te[12] *= s;
                te[1] *= s;
                te[5] *= s;
                te[9] *= s;
                te[13] *= s;
                te[2] *= s;
                te[6] *= s;
                te[10] *= s;
                te[14] *= s;
                te[3] *= s;
                te[7] *= s;
                te[11] *= s;
                te[15] *= s;
                return this;
            }
        },
        {
            key: "determinant",
            value: function determinant() {
                var te = this.elements;
                var n11 = te[0], n12 = te[4], n13 = te[8], n14 = te[12];
                var n21 = te[1], n22 = te[5], n23 = te[9], n24 = te[13];
                var n31 = te[2], n32 = te[6], n33 = te[10], n34 = te[14];
                var n41 = te[3], n42 = te[7], n43 = te[11], n44 = te[15];
                //TODO: make this more efficient
                //( based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm )
                return n41 * (+n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34) + n42 * (+n11 * n23 * n34 - n11 * n24 * n33 + n14 * n21 * n33 - n13 * n21 * n34 + n13 * n24 * n31 - n14 * n23 * n31) + n43 * (+n11 * n24 * n32 - n11 * n22 * n34 - n14 * n21 * n32 + n12 * n21 * n34 + n14 * n22 * n31 - n12 * n24 * n31) + n44 * (-n13 * n22 * n31 - n11 * n23 * n32 + n11 * n22 * n33 + n13 * n21 * n32 - n12 * n21 * n33 + n12 * n23 * n31);
            }
        },
        {
            key: "transpose",
            value: function transpose() {
                var te = this.elements;
                var tmp;
                tmp = te[1];
                te[1] = te[4];
                te[4] = tmp;
                tmp = te[2];
                te[2] = te[8];
                te[8] = tmp;
                tmp = te[6];
                te[6] = te[9];
                te[9] = tmp;
                tmp = te[3];
                te[3] = te[12];
                te[12] = tmp;
                tmp = te[7];
                te[7] = te[13];
                te[13] = tmp;
                tmp = te[11];
                te[11] = te[14];
                te[14] = tmp;
                return this;
            }
        },
        {
            key: "setPosition",
            value: function setPosition(x, y, z) {
                var te = this.elements;
                if (x.isVector3) {
                    te[12] = x.x;
                    te[13] = x.y;
                    te[14] = x.z;
                } else {
                    te[12] = x;
                    te[13] = y;
                    te[14] = z;
                }
                return this;
            }
        },
        {
            key: "invert",
            value: function invert() {
                // based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm
                var te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n41 = te[3], n12 = te[4], n22 = te[5], n32 = te[6], n42 = te[7], n13 = te[8], n23 = te[9], n33 = te[10], n43 = te[11], n14 = te[12], n24 = te[13], n34 = te[14], n44 = te[15], t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44, t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44, t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44, t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;
                var det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;
                if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
                var detInv = 1 / det;
                te[0] = t11 * detInv;
                te[1] = (n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44) * detInv;
                te[2] = (n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44) * detInv;
                te[3] = (n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43) * detInv;
                te[4] = t12 * detInv;
                te[5] = (n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44) * detInv;
                te[6] = (n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44) * detInv;
                te[7] = (n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43) * detInv;
                te[8] = t13 * detInv;
                te[9] = (n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44) * detInv;
                te[10] = (n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44) * detInv;
                te[11] = (n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43) * detInv;
                te[12] = t14 * detInv;
                te[13] = (n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34) * detInv;
                te[14] = (n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34) * detInv;
                te[15] = (n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33) * detInv;
                return this;
            }
        },
        {
            key: "scale",
            value: function scale(v) {
                var te = this.elements;
                var x = v.x, y = v.y, z = v.z;
                te[0] *= x;
                te[4] *= y;
                te[8] *= z;
                te[1] *= x;
                te[5] *= y;
                te[9] *= z;
                te[2] *= x;
                te[6] *= y;
                te[10] *= z;
                te[3] *= x;
                te[7] *= y;
                te[11] *= z;
                return this;
            }
        },
        {
            key: "getMaxScaleOnAxis",
            value: function getMaxScaleOnAxis() {
                var te = this.elements;
                var scaleXSq = te[0] * te[0] + te[1] * te[1] + te[2] * te[2];
                var scaleYSq = te[4] * te[4] + te[5] * te[5] + te[6] * te[6];
                var scaleZSq = te[8] * te[8] + te[9] * te[9] + te[10] * te[10];
                return Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
            }
        },
        {
            key: "makeTranslation",
            value: function makeTranslation(x, y, z) {
                this.set(1, 0, 0, x, 0, 1, 0, y, 0, 0, 1, z, 0, 0, 0, 1);
                return this;
            }
        },
        {
            key: "makeRotationX",
            value: function makeRotationX(theta) {
                var c = Math.cos(theta), s = Math.sin(theta);
                this.set(1, 0, 0, 0, 0, c, -s, 0, 0, s, c, 0, 0, 0, 0, 1);
                return this;
            }
        },
        {
            key: "makeRotationY",
            value: function makeRotationY(theta) {
                var c = Math.cos(theta), s = Math.sin(theta);
                this.set(c, 0, s, 0, 0, 1, 0, 0, -s, 0, c, 0, 0, 0, 0, 1);
                return this;
            }
        },
        {
            key: "makeRotationZ",
            value: function makeRotationZ(theta) {
                var c = Math.cos(theta), s = Math.sin(theta);
                this.set(c, -s, 0, 0, s, c, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
                return this;
            }
        },
        {
            key: "makeRotationAxis",
            value: function makeRotationAxis(axis, angle) {
                // Based on http://www.gamedev.net/reference/articles/article1199.asp
                var c = Math.cos(angle);
                var s = Math.sin(angle);
                var t = 1 - c;
                var x = axis.x, y = axis.y, z = axis.z;
                var tx = t * x, ty = t * y;
                this.set(tx * x + c, tx * y - s * z, tx * z + s * y, 0, tx * y + s * z, ty * y + c, ty * z - s * x, 0, tx * z - s * y, ty * z + s * x, t * z * z + c, 0, 0, 0, 0, 1);
                return this;
            }
        },
        {
            key: "makeScale",
            value: function makeScale(x, y, z) {
                this.set(x, 0, 0, 0, 0, y, 0, 0, 0, 0, z, 0, 0, 0, 0, 1);
                return this;
            }
        },
        {
            key: "makeShear",
            value: function makeShear(xy, xz, yx, yz, zx, zy) {
                this.set(1, yx, zx, 0, xy, 1, zy, 0, xz, yz, 1, 0, 0, 0, 0, 1);
                return this;
            }
        },
        {
            key: "compose",
            value: function compose(position, quaternion, scale) {
                var te = this.elements;
                var x = quaternion._x, y = quaternion._y, z = quaternion._z, w = quaternion._w;
                var x2 = x + x, y2 = y + y, z2 = z + z;
                var xx = x * x2, xy = x * y2, xz = x * z2;
                var yy = y * y2, yz = y * z2, zz = z * z2;
                var wx = w * x2, wy = w * y2, wz = w * z2;
                var sx = scale.x, sy = scale.y, sz = scale.z;
                te[0] = (1 - (yy + zz)) * sx;
                te[1] = (xy + wz) * sx;
                te[2] = (xz - wy) * sx;
                te[3] = 0;
                te[4] = (xy - wz) * sy;
                te[5] = (1 - (xx + zz)) * sy;
                te[6] = (yz + wx) * sy;
                te[7] = 0;
                te[8] = (xz + wy) * sz;
                te[9] = (yz - wx) * sz;
                te[10] = (1 - (xx + yy)) * sz;
                te[11] = 0;
                te[12] = position.x;
                te[13] = position.y;
                te[14] = position.z;
                te[15] = 1;
                return this;
            }
        },
        {
            key: "decompose",
            value: function decompose(position, quaternion, scale) {
                var te = this.elements;
                var sx = $c702e238df7c5123$var$_v1$5.set(te[0], te[1], te[2]).length();
                var sy = $c702e238df7c5123$var$_v1$5.set(te[4], te[5], te[6]).length();
                var sz = $c702e238df7c5123$var$_v1$5.set(te[8], te[9], te[10]).length();
                // if determine is negative, we need to invert one scale
                var det = this.determinant();
                if (det < 0) sx = -sx;
                position.x = te[12];
                position.y = te[13];
                position.z = te[14];
                // scale the rotation part
                $c702e238df7c5123$var$_m1$2.copy(this);
                var invSX = 1 / sx;
                var invSY = 1 / sy;
                var invSZ = 1 / sz;
                $c702e238df7c5123$var$_m1$2.elements[0] *= invSX;
                $c702e238df7c5123$var$_m1$2.elements[1] *= invSX;
                $c702e238df7c5123$var$_m1$2.elements[2] *= invSX;
                $c702e238df7c5123$var$_m1$2.elements[4] *= invSY;
                $c702e238df7c5123$var$_m1$2.elements[5] *= invSY;
                $c702e238df7c5123$var$_m1$2.elements[6] *= invSY;
                $c702e238df7c5123$var$_m1$2.elements[8] *= invSZ;
                $c702e238df7c5123$var$_m1$2.elements[9] *= invSZ;
                $c702e238df7c5123$var$_m1$2.elements[10] *= invSZ;
                quaternion.setFromRotationMatrix($c702e238df7c5123$var$_m1$2);
                scale.x = sx;
                scale.y = sy;
                scale.z = sz;
                return this;
            }
        },
        {
            key: "makePerspective",
            value: function makePerspective(left, right, top, bottom, near, far) {
                if (far === undefined) console.warn('THREE.Matrix4: .makePerspective() has been redefined and has a new signature. Please check the docs.');
                var te = this.elements;
                var x = 2 * near / (right - left);
                var y = 2 * near / (top - bottom);
                var a = (right + left) / (right - left);
                var b = (top + bottom) / (top - bottom);
                var c = -(far + near) / (far - near);
                var d = -2 * far * near / (far - near);
                te[0] = x;
                te[4] = 0;
                te[8] = a;
                te[12] = 0;
                te[1] = 0;
                te[5] = y;
                te[9] = b;
                te[13] = 0;
                te[2] = 0;
                te[6] = 0;
                te[10] = c;
                te[14] = d;
                te[3] = 0;
                te[7] = 0;
                te[11] = -1;
                te[15] = 0;
                return this;
            }
        },
        {
            key: "makeOrthographic",
            value: function makeOrthographic(left, right, top, bottom, near, far) {
                var te = this.elements;
                var w = 1.0 / (right - left);
                var h = 1.0 / (top - bottom);
                var p = 1.0 / (far - near);
                var x = (right + left) * w;
                var y = (top + bottom) * h;
                var z = (far + near) * p;
                te[0] = 2 * w;
                te[4] = 0;
                te[8] = 0;
                te[12] = -x;
                te[1] = 0;
                te[5] = 2 * h;
                te[9] = 0;
                te[13] = -y;
                te[2] = 0;
                te[6] = 0;
                te[10] = -2 * p;
                te[14] = -z;
                te[3] = 0;
                te[7] = 0;
                te[11] = 0;
                te[15] = 1;
                return this;
            }
        },
        {
            key: "equals",
            value: function equals(matrix) {
                var te = this.elements;
                var me = matrix.elements;
                for(var i = 0; i < 16; i++){
                    if (te[i] !== me[i]) return false;
                }
                return true;
            }
        },
        {
            key: "fromArray",
            value: function fromArray(array) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                for(var i = 0; i < 16; i++)this.elements[i] = array[i + offset];
                return this;
            }
        },
        {
            key: "toArray",
            value: function toArray() {
                var array = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var te = this.elements;
                array[offset] = te[0];
                array[offset + 1] = te[1];
                array[offset + 2] = te[2];
                array[offset + 3] = te[3];
                array[offset + 4] = te[4];
                array[offset + 5] = te[5];
                array[offset + 6] = te[6];
                array[offset + 7] = te[7];
                array[offset + 8] = te[8];
                array[offset + 9] = te[9];
                array[offset + 10] = te[10];
                array[offset + 11] = te[11];
                array[offset + 12] = te[12];
                array[offset + 13] = te[13];
                array[offset + 14] = te[14];
                array[offset + 15] = te[15];
                return array;
            }
        }
    ]);
    return Matrix4;
}();
$c702e238df7c5123$export$2ae72fc923e5eb5.prototype.isMatrix4 = true;
var $c702e238df7c5123$var$_v1$5 = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_m1$2 = /*@__PURE__*/ new $c702e238df7c5123$export$2ae72fc923e5eb5();
var $c702e238df7c5123$var$_zero = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699(0, 0, 0);
var $c702e238df7c5123$var$_one = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699(1, 1, 1);
var $c702e238df7c5123$var$_x = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_y = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_z = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_matrix$1 = /*@__PURE__*/ new $c702e238df7c5123$export$2ae72fc923e5eb5();
var $c702e238df7c5123$var$_quaternion$3 = /*@__PURE__*/ new $c702e238df7c5123$export$23d6a54f0bbc85a3();
var $c702e238df7c5123$export$d93cc409a0768c5f = /*#__PURE__*/ function() {
    "use strict";
    function Euler() {
        var x = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, z = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, order = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Euler.DefaultOrder;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Euler);
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(Euler, [
        {
            key: "x",
            get: function get() {
                return this._x;
            },
            set: function set(value) {
                this._x = value;
                this._onChangeCallback();
            }
        },
        {
            key: "y",
            get: function get() {
                return this._y;
            },
            set: function set(value) {
                this._y = value;
                this._onChangeCallback();
            }
        },
        {
            key: "z",
            get: function get() {
                return this._z;
            },
            set: function set(value) {
                this._z = value;
                this._onChangeCallback();
            }
        },
        {
            key: "order",
            get: function get() {
                return this._order;
            },
            set: function set(value) {
                this._order = value;
                this._onChangeCallback();
            }
        },
        {
            key: "set",
            value: function set(x, y, z) {
                var order = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : this._order;
                this._x = x;
                this._y = y;
                this._z = z;
                this._order = order;
                this._onChangeCallback();
                return this;
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor(this._x, this._y, this._z, this._order);
            }
        },
        {
            key: "copy",
            value: function copy(euler) {
                this._x = euler._x;
                this._y = euler._y;
                this._z = euler._z;
                this._order = euler._order;
                this._onChangeCallback();
                return this;
            }
        },
        {
            key: "setFromRotationMatrix",
            value: function setFromRotationMatrix(m) {
                var order = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this._order, update = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
                // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
                var te = m.elements;
                var m11 = te[0], m12 = te[4], m13 = te[8];
                var m21 = te[1], m22 = te[5], m23 = te[9];
                var m31 = te[2], m32 = te[6], m33 = te[10];
                switch(order){
                    case 'XYZ':
                        this._y = Math.asin($c702e238df7c5123$var$clamp(m13, -1, 1));
                        if (Math.abs(m13) < 0.9999999) {
                            this._x = Math.atan2(-m23, m33);
                            this._z = Math.atan2(-m12, m11);
                        } else {
                            this._x = Math.atan2(m32, m22);
                            this._z = 0;
                        }
                        break;
                    case 'YXZ':
                        this._x = Math.asin(-$c702e238df7c5123$var$clamp(m23, -1, 1));
                        if (Math.abs(m23) < 0.9999999) {
                            this._y = Math.atan2(m13, m33);
                            this._z = Math.atan2(m21, m22);
                        } else {
                            this._y = Math.atan2(-m31, m11);
                            this._z = 0;
                        }
                        break;
                    case 'ZXY':
                        this._x = Math.asin($c702e238df7c5123$var$clamp(m32, -1, 1));
                        if (Math.abs(m32) < 0.9999999) {
                            this._y = Math.atan2(-m31, m33);
                            this._z = Math.atan2(-m12, m22);
                        } else {
                            this._y = 0;
                            this._z = Math.atan2(m21, m11);
                        }
                        break;
                    case 'ZYX':
                        this._y = Math.asin(-$c702e238df7c5123$var$clamp(m31, -1, 1));
                        if (Math.abs(m31) < 0.9999999) {
                            this._x = Math.atan2(m32, m33);
                            this._z = Math.atan2(m21, m11);
                        } else {
                            this._x = 0;
                            this._z = Math.atan2(-m12, m22);
                        }
                        break;
                    case 'YZX':
                        this._z = Math.asin($c702e238df7c5123$var$clamp(m21, -1, 1));
                        if (Math.abs(m21) < 0.9999999) {
                            this._x = Math.atan2(-m23, m22);
                            this._y = Math.atan2(-m31, m11);
                        } else {
                            this._x = 0;
                            this._y = Math.atan2(m13, m33);
                        }
                        break;
                    case 'XZY':
                        this._z = Math.asin(-$c702e238df7c5123$var$clamp(m12, -1, 1));
                        if (Math.abs(m12) < 0.9999999) {
                            this._x = Math.atan2(m32, m22);
                            this._y = Math.atan2(m13, m11);
                        } else {
                            this._x = Math.atan2(-m23, m33);
                            this._y = 0;
                        }
                        break;
                    default:
                        console.warn('THREE.Euler: .setFromRotationMatrix() encountered an unknown order: ' + order);
                }
                this._order = order;
                if (update === true) this._onChangeCallback();
                return this;
            }
        },
        {
            key: "setFromQuaternion",
            value: function setFromQuaternion(q, order, update) {
                $c702e238df7c5123$var$_matrix$1.makeRotationFromQuaternion(q);
                return this.setFromRotationMatrix($c702e238df7c5123$var$_matrix$1, order, update);
            }
        },
        {
            key: "setFromVector3",
            value: function setFromVector3(v) {
                var order = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this._order;
                return this.set(v.x, v.y, v.z, order);
            }
        },
        {
            key: "reorder",
            value: function reorder(newOrder) {
                // WARNING: this discards revolution information -bhouston
                $c702e238df7c5123$var$_quaternion$3.setFromEuler(this);
                return this.setFromQuaternion($c702e238df7c5123$var$_quaternion$3, newOrder);
            }
        },
        {
            key: "equals",
            value: function equals(euler) {
                return euler._x === this._x && euler._y === this._y && euler._z === this._z && euler._order === this._order;
            }
        },
        {
            key: "fromArray",
            value: function fromArray(array) {
                this._x = array[0];
                this._y = array[1];
                this._z = array[2];
                if (array[3] !== undefined) this._order = array[3];
                this._onChangeCallback();
                return this;
            }
        },
        {
            key: "toArray",
            value: function toArray() {
                var array = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                array[offset] = this._x;
                array[offset + 1] = this._y;
                array[offset + 2] = this._z;
                array[offset + 3] = this._order;
                return array;
            }
        },
        {
            key: "toVector3",
            value: function toVector3(optionalResult) {
                if (optionalResult) return optionalResult.set(this._x, this._y, this._z);
                else return new $c702e238df7c5123$export$64b5c384219d3699(this._x, this._y, this._z);
            }
        },
        {
            key: "_onChange",
            value: function _onChange(callback) {
                this._onChangeCallback = callback;
                return this;
            }
        },
        {
            key: "_onChangeCallback",
            value: function _onChangeCallback() {}
        }
    ]);
    return Euler;
}();
$c702e238df7c5123$export$d93cc409a0768c5f.prototype.isEuler = true;
$c702e238df7c5123$export$d93cc409a0768c5f.DefaultOrder = 'XYZ';
$c702e238df7c5123$export$d93cc409a0768c5f.RotationOrders = [
    'XYZ',
    'YZX',
    'ZXY',
    'XZY',
    'YXZ',
    'ZYX'
];
var $c702e238df7c5123$export$89312ce47c0ca777 = /*#__PURE__*/ function() {
    "use strict";
    function Layers() {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Layers);
        this.mask = 1;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(Layers, [
        {
            key: "set",
            value: function set(channel) {
                this.mask = 1 << channel | 0;
            }
        },
        {
            key: "enable",
            value: function enable(channel) {
                this.mask |= 1 << channel | 0;
            }
        },
        {
            key: "enableAll",
            value: function enableAll() {
                this.mask = -1;
            }
        },
        {
            key: "toggle",
            value: function toggle(channel) {
                this.mask ^= 1 << channel | 0;
            }
        },
        {
            key: "disable",
            value: function disable(channel) {
                this.mask &= ~(1 << channel | 0);
            }
        },
        {
            key: "disableAll",
            value: function disableAll() {
                this.mask = 0;
            }
        },
        {
            key: "test",
            value: function test(layers) {
                return (this.mask & layers.mask) !== 0;
            }
        }
    ]);
    return Layers;
}();
var $c702e238df7c5123$var$_object3DId = 0;
var $c702e238df7c5123$var$_v1$4 = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_q1 = /*@__PURE__*/ new $c702e238df7c5123$export$23d6a54f0bbc85a3();
var $c702e238df7c5123$var$_m1$1 = /*@__PURE__*/ new $c702e238df7c5123$export$2ae72fc923e5eb5();
var $c702e238df7c5123$var$_target = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_position$3 = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_scale$2 = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_quaternion$2 = /*@__PURE__*/ new $c702e238df7c5123$export$23d6a54f0bbc85a3();
var $c702e238df7c5123$var$_xAxis = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699(1, 0, 0);
var $c702e238df7c5123$var$_yAxis = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699(0, 1, 0);
var $c702e238df7c5123$var$_zAxis = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699(0, 0, 1);
var $c702e238df7c5123$var$_addedEvent = {
    type: 'added'
};
var $c702e238df7c5123$var$_removedEvent = {
    type: 'removed'
};
var $c702e238df7c5123$export$e4dd07dff30cc924 = /*#__PURE__*/ function(EventDispatcher) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(Object3D, EventDispatcher);
    function Object3D() {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Object3D);
        var _this;
        var onRotationChange = function onRotationChange() {
            quaternion.setFromEuler(rotation, false);
        };
        var onQuaternionChange = function onQuaternionChange() {
            rotation.setFromQuaternion(quaternion, undefined, false);
        };
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, Object3D);
        Object.defineProperty(_this, 'id', {
            value: $c702e238df7c5123$var$_object3DId++
        });
        _this.uuid = $c702e238df7c5123$var$generateUUID();
        _this.name = '';
        _this.type = 'Object3D';
        _this.parent = null;
        _this.children = [];
        _this.up = Object3D.DefaultUp.clone();
        var position = new $c702e238df7c5123$export$64b5c384219d3699();
        var rotation = new $c702e238df7c5123$export$d93cc409a0768c5f();
        var quaternion = new $c702e238df7c5123$export$23d6a54f0bbc85a3();
        var scale = new $c702e238df7c5123$export$64b5c384219d3699(1, 1, 1);
        rotation._onChange(onRotationChange);
        quaternion._onChange(onQuaternionChange);
        Object.defineProperties(_this, {
            position: {
                configurable: true,
                enumerable: true,
                value: position
            },
            rotation: {
                configurable: true,
                enumerable: true,
                value: rotation
            },
            quaternion: {
                configurable: true,
                enumerable: true,
                value: quaternion
            },
            scale: {
                configurable: true,
                enumerable: true,
                value: scale
            },
            modelViewMatrix: {
                value: new $c702e238df7c5123$export$2ae72fc923e5eb5()
            },
            normalMatrix: {
                value: new $c702e238df7c5123$export$8ff26dafa08918()
            }
        });
        _this.matrix = new $c702e238df7c5123$export$2ae72fc923e5eb5();
        _this.matrixWorld = new $c702e238df7c5123$export$2ae72fc923e5eb5();
        _this.matrixAutoUpdate = Object3D.DefaultMatrixAutoUpdate;
        _this.matrixWorldNeedsUpdate = false;
        _this.layers = new $c702e238df7c5123$export$89312ce47c0ca777();
        _this.visible = true;
        _this.castShadow = false;
        _this.receiveShadow = false;
        _this.frustumCulled = true;
        _this.renderOrder = 0;
        _this.animations = [];
        _this.userData = {};
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(Object3D, [
        {
            key: "onBeforeRender",
            value: function onBeforeRender() {}
        },
        {
            key: "onAfterRender",
            value: function onAfterRender() {}
        },
        {
            key: "applyMatrix4",
            value: function applyMatrix4(matrix) {
                if (this.matrixAutoUpdate) this.updateMatrix();
                this.matrix.premultiply(matrix);
                this.matrix.decompose(this.position, this.quaternion, this.scale);
            }
        },
        {
            key: "applyQuaternion",
            value: function applyQuaternion(q) {
                this.quaternion.premultiply(q);
                return this;
            }
        },
        {
            key: "setRotationFromAxisAngle",
            value: function setRotationFromAxisAngle(axis, angle) {
                // assumes axis is normalized
                this.quaternion.setFromAxisAngle(axis, angle);
            }
        },
        {
            key: "setRotationFromEuler",
            value: function setRotationFromEuler(euler) {
                this.quaternion.setFromEuler(euler, true);
            }
        },
        {
            key: "setRotationFromMatrix",
            value: function setRotationFromMatrix(m) {
                // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
                this.quaternion.setFromRotationMatrix(m);
            }
        },
        {
            key: "setRotationFromQuaternion",
            value: function setRotationFromQuaternion(q) {
                // assumes q is normalized
                this.quaternion.copy(q);
            }
        },
        {
            key: "rotateOnAxis",
            value: function rotateOnAxis(axis, angle) {
                // rotate object on axis in object space
                // axis is assumed to be normalized
                $c702e238df7c5123$var$_q1.setFromAxisAngle(axis, angle);
                this.quaternion.multiply($c702e238df7c5123$var$_q1);
                return this;
            }
        },
        {
            key: "rotateOnWorldAxis",
            value: function rotateOnWorldAxis(axis, angle) {
                // rotate object on axis in world space
                // axis is assumed to be normalized
                // method assumes no rotated parent
                $c702e238df7c5123$var$_q1.setFromAxisAngle(axis, angle);
                this.quaternion.premultiply($c702e238df7c5123$var$_q1);
                return this;
            }
        },
        {
            key: "rotateX",
            value: function rotateX(angle) {
                return this.rotateOnAxis($c702e238df7c5123$var$_xAxis, angle);
            }
        },
        {
            key: "rotateY",
            value: function rotateY(angle) {
                return this.rotateOnAxis($c702e238df7c5123$var$_yAxis, angle);
            }
        },
        {
            key: "rotateZ",
            value: function rotateZ(angle) {
                return this.rotateOnAxis($c702e238df7c5123$var$_zAxis, angle);
            }
        },
        {
            key: "translateOnAxis",
            value: function translateOnAxis(axis, distance) {
                // translate object by distance along axis in object space
                // axis is assumed to be normalized
                $c702e238df7c5123$var$_v1$4.copy(axis).applyQuaternion(this.quaternion);
                this.position.add($c702e238df7c5123$var$_v1$4.multiplyScalar(distance));
                return this;
            }
        },
        {
            key: "translateX",
            value: function translateX(distance) {
                return this.translateOnAxis($c702e238df7c5123$var$_xAxis, distance);
            }
        },
        {
            key: "translateY",
            value: function translateY(distance) {
                return this.translateOnAxis($c702e238df7c5123$var$_yAxis, distance);
            }
        },
        {
            key: "translateZ",
            value: function translateZ(distance) {
                return this.translateOnAxis($c702e238df7c5123$var$_zAxis, distance);
            }
        },
        {
            key: "localToWorld",
            value: function localToWorld(vector) {
                return vector.applyMatrix4(this.matrixWorld);
            }
        },
        {
            key: "worldToLocal",
            value: function worldToLocal(vector) {
                return vector.applyMatrix4($c702e238df7c5123$var$_m1$1.copy(this.matrixWorld).invert());
            }
        },
        {
            key: "lookAt",
            value: function lookAt(x, y, z) {
                // This method does not support objects having non-uniformly-scaled parent(s)
                if (x.isVector3) $c702e238df7c5123$var$_target.copy(x);
                else $c702e238df7c5123$var$_target.set(x, y, z);
                var parent = this.parent;
                this.updateWorldMatrix(true, false);
                $c702e238df7c5123$var$_position$3.setFromMatrixPosition(this.matrixWorld);
                if (this.isCamera || this.isLight) $c702e238df7c5123$var$_m1$1.lookAt($c702e238df7c5123$var$_position$3, $c702e238df7c5123$var$_target, this.up);
                else $c702e238df7c5123$var$_m1$1.lookAt($c702e238df7c5123$var$_target, $c702e238df7c5123$var$_position$3, this.up);
                this.quaternion.setFromRotationMatrix($c702e238df7c5123$var$_m1$1);
                if (parent) {
                    $c702e238df7c5123$var$_m1$1.extractRotation(parent.matrixWorld);
                    $c702e238df7c5123$var$_q1.setFromRotationMatrix($c702e238df7c5123$var$_m1$1);
                    this.quaternion.premultiply($c702e238df7c5123$var$_q1.invert());
                }
            }
        },
        {
            key: "add",
            value: function add(object) {
                if (arguments.length > 1) {
                    for(var i = 0; i < arguments.length; i++)this.add(arguments[i]);
                    return this;
                }
                if (object === this) {
                    console.error('THREE.Object3D.add: object can\'t be added as a child of itself.', object);
                    return this;
                }
                if (object && object.isObject3D) {
                    if (object.parent !== null) object.parent.remove(object);
                    object.parent = this;
                    this.children.push(object);
                    object.dispatchEvent($c702e238df7c5123$var$_addedEvent);
                } else console.error('THREE.Object3D.add: object not an instance of THREE.Object3D.', object);
                return this;
            }
        },
        {
            key: "remove",
            value: function remove(object) {
                if (arguments.length > 1) {
                    for(var i = 0; i < arguments.length; i++)this.remove(arguments[i]);
                    return this;
                }
                var index = this.children.indexOf(object);
                if (index !== -1) {
                    object.parent = null;
                    this.children.splice(index, 1);
                    object.dispatchEvent($c702e238df7c5123$var$_removedEvent);
                }
                return this;
            }
        },
        {
            key: "removeFromParent",
            value: function removeFromParent() {
                var parent = this.parent;
                if (parent !== null) parent.remove(this);
                return this;
            }
        },
        {
            key: "clear",
            value: function clear() {
                for(var i = 0; i < this.children.length; i++){
                    var object = this.children[i];
                    object.parent = null;
                    object.dispatchEvent($c702e238df7c5123$var$_removedEvent);
                }
                this.children.length = 0;
                return this;
            }
        },
        {
            key: "attach",
            value: function attach(object) {
                // adds object as a child of this, while maintaining the object's world transform
                this.updateWorldMatrix(true, false);
                $c702e238df7c5123$var$_m1$1.copy(this.matrixWorld).invert();
                if (object.parent !== null) {
                    object.parent.updateWorldMatrix(true, false);
                    $c702e238df7c5123$var$_m1$1.multiply(object.parent.matrixWorld);
                }
                object.applyMatrix4($c702e238df7c5123$var$_m1$1);
                this.add(object);
                object.updateWorldMatrix(false, true);
                return this;
            }
        },
        {
            key: "getObjectById",
            value: function getObjectById(id) {
                return this.getObjectByProperty('id', id);
            }
        },
        {
            key: "getObjectByName",
            value: function getObjectByName(name) {
                return this.getObjectByProperty('name', name);
            }
        },
        {
            key: "getObjectByProperty",
            value: function getObjectByProperty(name, value) {
                if (this[name] === value) return this;
                for(var i = 0, l = this.children.length; i < l; i++){
                    var child = this.children[i];
                    var object = child.getObjectByProperty(name, value);
                    if (object !== undefined) return object;
                }
                return undefined;
            }
        },
        {
            key: "getWorldPosition",
            value: function getWorldPosition(target) {
                this.updateWorldMatrix(true, false);
                return target.setFromMatrixPosition(this.matrixWorld);
            }
        },
        {
            key: "getWorldQuaternion",
            value: function getWorldQuaternion(target) {
                this.updateWorldMatrix(true, false);
                this.matrixWorld.decompose($c702e238df7c5123$var$_position$3, target, $c702e238df7c5123$var$_scale$2);
                return target;
            }
        },
        {
            key: "getWorldScale",
            value: function getWorldScale(target) {
                this.updateWorldMatrix(true, false);
                this.matrixWorld.decompose($c702e238df7c5123$var$_position$3, $c702e238df7c5123$var$_quaternion$2, target);
                return target;
            }
        },
        {
            key: "getWorldDirection",
            value: function getWorldDirection(target) {
                this.updateWorldMatrix(true, false);
                var e = this.matrixWorld.elements;
                return target.set(e[8], e[9], e[10]).normalize();
            }
        },
        {
            key: "raycast",
            value: function raycast() {}
        },
        {
            key: "traverse",
            value: function traverse(callback) {
                callback(this);
                var children = this.children;
                for(var i = 0, l = children.length; i < l; i++)children[i].traverse(callback);
            }
        },
        {
            key: "traverseVisible",
            value: function traverseVisible(callback) {
                if (this.visible === false) return;
                callback(this);
                var children = this.children;
                for(var i = 0, l = children.length; i < l; i++)children[i].traverseVisible(callback);
            }
        },
        {
            key: "traverseAncestors",
            value: function traverseAncestors(callback) {
                var parent = this.parent;
                if (parent !== null) {
                    callback(parent);
                    parent.traverseAncestors(callback);
                }
            }
        },
        {
            key: "updateMatrix",
            value: function updateMatrix() {
                this.matrix.compose(this.position, this.quaternion, this.scale);
                this.matrixWorldNeedsUpdate = true;
            }
        },
        {
            key: "updateMatrixWorld",
            value: function updateMatrixWorld(force) {
                if (this.matrixAutoUpdate) this.updateMatrix();
                if (this.matrixWorldNeedsUpdate || force) {
                    if (this.parent === null) this.matrixWorld.copy(this.matrix);
                    else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
                    this.matrixWorldNeedsUpdate = false;
                    force = true;
                }
                // update children
                var children = this.children;
                for(var i = 0, l = children.length; i < l; i++)children[i].updateMatrixWorld(force);
            }
        },
        {
            key: "updateWorldMatrix",
            value: function updateWorldMatrix(updateParents, updateChildren) {
                var parent = this.parent;
                if (updateParents === true && parent !== null) parent.updateWorldMatrix(true, false);
                if (this.matrixAutoUpdate) this.updateMatrix();
                if (this.parent === null) this.matrixWorld.copy(this.matrix);
                else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
                // update children
                if (updateChildren === true) {
                    var children = this.children;
                    for(var i = 0, l = children.length; i < l; i++)children[i].updateWorldMatrix(false, true);
                }
            }
        },
        {
            key: "toJSON",
            value: function toJSON(meta) {
                // meta is a string when called from JSON.stringify
                var isRootObject = meta === undefined || typeof meta === 'string';
                var output = {};
                // meta is a hash used to collect geometries, materials.
                // not providing it implies that this is the root object
                // being serialized.
                if (isRootObject) {
                    // initialize meta obj
                    meta = {
                        geometries: {},
                        materials: {},
                        textures: {},
                        images: {},
                        shapes: {},
                        skeletons: {},
                        animations: {}
                    };
                    output.metadata = {
                        version: 4.5,
                        type: 'Object',
                        generator: 'Object3D.toJSON'
                    };
                }
                // standard Object3D serialization
                var object = {};
                object.uuid = this.uuid;
                object.type = this.type;
                if (this.name !== '') object.name = this.name;
                if (this.castShadow === true) object.castShadow = true;
                if (this.receiveShadow === true) object.receiveShadow = true;
                if (this.visible === false) object.visible = false;
                if (this.frustumCulled === false) object.frustumCulled = false;
                if (this.renderOrder !== 0) object.renderOrder = this.renderOrder;
                if (JSON.stringify(this.userData) !== '{}') object.userData = this.userData;
                object.layers = this.layers.mask;
                object.matrix = this.matrix.toArray();
                if (this.matrixAutoUpdate === false) object.matrixAutoUpdate = false;
                // object specific properties
                if (this.isInstancedMesh) {
                    object.type = 'InstancedMesh';
                    object.count = this.count;
                    object.instanceMatrix = this.instanceMatrix.toJSON();
                    if (this.instanceColor !== null) object.instanceColor = this.instanceColor.toJSON();
                }
                //
                function serialize(library, element) {
                    if (library[element.uuid] === undefined) library[element.uuid] = element.toJSON(meta);
                    return element.uuid;
                }
                if (this.isScene) {
                    if (this.background) {
                        if (this.background.isColor) object.background = this.background.toJSON();
                        else if (this.background.isTexture) object.background = this.background.toJSON(meta).uuid;
                    }
                    if (this.environment && this.environment.isTexture) object.environment = this.environment.toJSON(meta).uuid;
                } else if (this.isMesh || this.isLine || this.isPoints) {
                    object.geometry = serialize(meta.geometries, this.geometry);
                    var parameters = this.geometry.parameters;
                    if (parameters !== undefined && parameters.shapes !== undefined) {
                        var shapes = parameters.shapes;
                        if (Array.isArray(shapes)) for(var i = 0, l = shapes.length; i < l; i++){
                            var shape = shapes[i];
                            serialize(meta.shapes, shape);
                        }
                        else serialize(meta.shapes, shapes);
                    }
                }
                if (this.isSkinnedMesh) {
                    object.bindMode = this.bindMode;
                    object.bindMatrix = this.bindMatrix.toArray();
                    if (this.skeleton !== undefined) {
                        serialize(meta.skeletons, this.skeleton);
                        object.skeleton = this.skeleton.uuid;
                    }
                }
                if (this.material !== undefined) {
                    if (Array.isArray(this.material)) {
                        var uuids = [];
                        for(var i1 = 0, l1 = this.material.length; i1 < l1; i1++)uuids.push(serialize(meta.materials, this.material[i1]));
                        object.material = uuids;
                    } else object.material = serialize(meta.materials, this.material);
                }
                //
                if (this.children.length > 0) {
                    object.children = [];
                    for(var i2 = 0; i2 < this.children.length; i2++)object.children.push(this.children[i2].toJSON(meta).object);
                }
                //
                if (this.animations.length > 0) {
                    object.animations = [];
                    for(var i3 = 0; i3 < this.animations.length; i3++){
                        var animation = this.animations[i3];
                        object.animations.push(serialize(meta.animations, animation));
                    }
                }
                if (isRootObject) {
                    var geometries = extractFromCache(meta.geometries);
                    var materials = extractFromCache(meta.materials);
                    var textures = extractFromCache(meta.textures);
                    var images = extractFromCache(meta.images);
                    var shapes1 = extractFromCache(meta.shapes);
                    var skeletons = extractFromCache(meta.skeletons);
                    var animations = extractFromCache(meta.animations);
                    if (geometries.length > 0) output.geometries = geometries;
                    if (materials.length > 0) output.materials = materials;
                    if (textures.length > 0) output.textures = textures;
                    if (images.length > 0) output.images = images;
                    if (shapes1.length > 0) output.shapes = shapes1;
                    if (skeletons.length > 0) output.skeletons = skeletons;
                    if (animations.length > 0) output.animations = animations;
                }
                output.object = object;
                return output;
                // extract data from the cache hash
                // remove metadata on each item
                // and return as array
                function extractFromCache(cache) {
                    var values = [];
                    for(var key in cache){
                        var data = cache[key];
                        delete data.metadata;
                        values.push(data);
                    }
                    return values;
                }
            }
        },
        {
            key: "clone",
            value: function clone(recursive) {
                return new this.constructor().copy(this, recursive);
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                var recursive = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                this.name = source.name;
                this.up.copy(source.up);
                this.position.copy(source.position);
                this.rotation.order = source.rotation.order;
                this.quaternion.copy(source.quaternion);
                this.scale.copy(source.scale);
                this.matrix.copy(source.matrix);
                this.matrixWorld.copy(source.matrixWorld);
                this.matrixAutoUpdate = source.matrixAutoUpdate;
                this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;
                this.layers.mask = source.layers.mask;
                this.visible = source.visible;
                this.castShadow = source.castShadow;
                this.receiveShadow = source.receiveShadow;
                this.frustumCulled = source.frustumCulled;
                this.renderOrder = source.renderOrder;
                this.userData = JSON.parse(JSON.stringify(source.userData));
                if (recursive === true) for(var i = 0; i < source.children.length; i++){
                    var child = source.children[i];
                    this.add(child.clone());
                }
                return this;
            }
        }
    ]);
    return Object3D;
}($c702e238df7c5123$export$ec8b666c5fe2c75a);
$c702e238df7c5123$export$e4dd07dff30cc924.DefaultUp = new $c702e238df7c5123$export$64b5c384219d3699(0, 1, 0);
$c702e238df7c5123$export$e4dd07dff30cc924.DefaultMatrixAutoUpdate = true;
$c702e238df7c5123$export$e4dd07dff30cc924.prototype.isObject3D = true;
var $c702e238df7c5123$var$_v0$1 = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_v1$3 = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_v2$2 = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_v3$1 = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_vab = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_vac = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_vbc = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_vap = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_vbp = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_vcp = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$export$5a465592bfe74b48 = /*#__PURE__*/ function() {
    "use strict";
    function Triangle() {
        var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $c702e238df7c5123$export$64b5c384219d3699(), b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $c702e238df7c5123$export$64b5c384219d3699(), c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : new $c702e238df7c5123$export$64b5c384219d3699();
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Triangle);
        this.a = a;
        this.b = b;
        this.c = c;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(Triangle, [
        {
            key: "set",
            value: function set(a, b, c) {
                this.a.copy(a);
                this.b.copy(b);
                this.c.copy(c);
                return this;
            }
        },
        {
            key: "setFromPointsAndIndices",
            value: function setFromPointsAndIndices(points, i0, i1, i2) {
                this.a.copy(points[i0]);
                this.b.copy(points[i1]);
                this.c.copy(points[i2]);
                return this;
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        },
        {
            key: "copy",
            value: function copy(triangle) {
                this.a.copy(triangle.a);
                this.b.copy(triangle.b);
                this.c.copy(triangle.c);
                return this;
            }
        },
        {
            key: "getArea",
            value: function getArea() {
                $c702e238df7c5123$var$_v0$1.subVectors(this.c, this.b);
                $c702e238df7c5123$var$_v1$3.subVectors(this.a, this.b);
                return $c702e238df7c5123$var$_v0$1.cross($c702e238df7c5123$var$_v1$3).length() * 0.5;
            }
        },
        {
            key: "getMidpoint",
            value: function getMidpoint(target) {
                return target.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
            }
        },
        {
            key: "getNormal",
            value: function getNormal(target) {
                return Triangle.getNormal(this.a, this.b, this.c, target);
            }
        },
        {
            key: "getPlane",
            value: function getPlane(target) {
                return target.setFromCoplanarPoints(this.a, this.b, this.c);
            }
        },
        {
            key: "getBarycoord",
            value: function getBarycoord(point, target) {
                return Triangle.getBarycoord(point, this.a, this.b, this.c, target);
            }
        },
        {
            key: "getUV",
            value: function getUV(point, uv1, uv2, uv3, target) {
                return Triangle.getUV(point, this.a, this.b, this.c, uv1, uv2, uv3, target);
            }
        },
        {
            key: "containsPoint",
            value: function containsPoint(point) {
                return Triangle.containsPoint(point, this.a, this.b, this.c);
            }
        },
        {
            key: "isFrontFacing",
            value: function isFrontFacing(direction) {
                return Triangle.isFrontFacing(this.a, this.b, this.c, direction);
            }
        },
        {
            key: "intersectsBox",
            value: function intersectsBox(box) {
                return box.intersectsTriangle(this);
            }
        },
        {
            key: "closestPointToPoint",
            value: function closestPointToPoint(p, target) {
                var a = this.a, b = this.b, c = this.c;
                var v, w;
                // algorithm thanks to Real-Time Collision Detection by Christer Ericson,
                // published by Morgan Kaufmann Publishers, (c) 2005 Elsevier Inc.,
                // under the accompanying license; see chapter 5.1.5 for detailed explanation.
                // basically, we're distinguishing which of the voronoi regions of the triangle
                // the point lies in with the minimum amount of redundant computation.
                $c702e238df7c5123$var$_vab.subVectors(b, a);
                $c702e238df7c5123$var$_vac.subVectors(c, a);
                $c702e238df7c5123$var$_vap.subVectors(p, a);
                var d1 = $c702e238df7c5123$var$_vab.dot($c702e238df7c5123$var$_vap);
                var d2 = $c702e238df7c5123$var$_vac.dot($c702e238df7c5123$var$_vap);
                if (d1 <= 0 && d2 <= 0) // vertex region of A; barycentric coords (1, 0, 0)
                return target.copy(a);
                $c702e238df7c5123$var$_vbp.subVectors(p, b);
                var d3 = $c702e238df7c5123$var$_vab.dot($c702e238df7c5123$var$_vbp);
                var d4 = $c702e238df7c5123$var$_vac.dot($c702e238df7c5123$var$_vbp);
                if (d3 >= 0 && d4 <= d3) // vertex region of B; barycentric coords (0, 1, 0)
                return target.copy(b);
                var vc = d1 * d4 - d3 * d2;
                if (vc <= 0 && d1 >= 0 && d3 <= 0) {
                    v = d1 / (d1 - d3);
                    // edge region of AB; barycentric coords (1-v, v, 0)
                    return target.copy(a).addScaledVector($c702e238df7c5123$var$_vab, v);
                }
                $c702e238df7c5123$var$_vcp.subVectors(p, c);
                var d5 = $c702e238df7c5123$var$_vab.dot($c702e238df7c5123$var$_vcp);
                var d6 = $c702e238df7c5123$var$_vac.dot($c702e238df7c5123$var$_vcp);
                if (d6 >= 0 && d5 <= d6) // vertex region of C; barycentric coords (0, 0, 1)
                return target.copy(c);
                var vb = d5 * d2 - d1 * d6;
                if (vb <= 0 && d2 >= 0 && d6 <= 0) {
                    w = d2 / (d2 - d6);
                    // edge region of AC; barycentric coords (1-w, 0, w)
                    return target.copy(a).addScaledVector($c702e238df7c5123$var$_vac, w);
                }
                var va = d3 * d6 - d5 * d4;
                if (va <= 0 && d4 - d3 >= 0 && d5 - d6 >= 0) {
                    $c702e238df7c5123$var$_vbc.subVectors(c, b);
                    w = (d4 - d3) / (d4 - d3 + (d5 - d6));
                    // edge region of BC; barycentric coords (0, 1-w, w)
                    return target.copy(b).addScaledVector($c702e238df7c5123$var$_vbc, w); // edge region of BC
                }
                // face region
                var denom = 1 / (va + vb + vc);
                // u = va * denom
                v = vb * denom;
                w = vc * denom;
                return target.copy(a).addScaledVector($c702e238df7c5123$var$_vab, v).addScaledVector($c702e238df7c5123$var$_vac, w);
            }
        },
        {
            key: "equals",
            value: function equals(triangle) {
                return triangle.a.equals(this.a) && triangle.b.equals(this.b) && triangle.c.equals(this.c);
            }
        }
    ], [
        {
            key: "getNormal",
            value: function getNormal(a, b, c, target) {
                target.subVectors(c, b);
                $c702e238df7c5123$var$_v0$1.subVectors(a, b);
                target.cross($c702e238df7c5123$var$_v0$1);
                var targetLengthSq = target.lengthSq();
                if (targetLengthSq > 0) return target.multiplyScalar(1 / Math.sqrt(targetLengthSq));
                return target.set(0, 0, 0);
            }
        },
        {
            key: "getBarycoord",
            value: // static/instance method to calculate barycentric coordinates
            // based on: http://www.blackpawn.com/texts/pointinpoly/default.html
            function getBarycoord(point, a, b, c, target) {
                $c702e238df7c5123$var$_v0$1.subVectors(c, a);
                $c702e238df7c5123$var$_v1$3.subVectors(b, a);
                $c702e238df7c5123$var$_v2$2.subVectors(point, a);
                var dot00 = $c702e238df7c5123$var$_v0$1.dot($c702e238df7c5123$var$_v0$1);
                var dot01 = $c702e238df7c5123$var$_v0$1.dot($c702e238df7c5123$var$_v1$3);
                var dot02 = $c702e238df7c5123$var$_v0$1.dot($c702e238df7c5123$var$_v2$2);
                var dot11 = $c702e238df7c5123$var$_v1$3.dot($c702e238df7c5123$var$_v1$3);
                var dot12 = $c702e238df7c5123$var$_v1$3.dot($c702e238df7c5123$var$_v2$2);
                var denom = dot00 * dot11 - dot01 * dot01;
                // collinear or singular triangle
                if (denom === 0) // arbitrary location outside of triangle?
                // not sure if this is the best idea, maybe should be returning undefined
                return target.set(-2, -1, -1);
                var invDenom = 1 / denom;
                var u = (dot11 * dot02 - dot01 * dot12) * invDenom;
                var v = (dot00 * dot12 - dot01 * dot02) * invDenom;
                // barycentric coordinates must always sum to 1
                return target.set(1 - u - v, v, u);
            }
        },
        {
            key: "containsPoint",
            value: function containsPoint(point, a, b, c) {
                this.getBarycoord(point, a, b, c, $c702e238df7c5123$var$_v3$1);
                return $c702e238df7c5123$var$_v3$1.x >= 0 && $c702e238df7c5123$var$_v3$1.y >= 0 && $c702e238df7c5123$var$_v3$1.x + $c702e238df7c5123$var$_v3$1.y <= 1;
            }
        },
        {
            key: "getUV",
            value: function getUV(point, p1, p2, p3, uv1, uv2, uv3, target) {
                this.getBarycoord(point, p1, p2, p3, $c702e238df7c5123$var$_v3$1);
                target.set(0, 0);
                target.addScaledVector(uv1, $c702e238df7c5123$var$_v3$1.x);
                target.addScaledVector(uv2, $c702e238df7c5123$var$_v3$1.y);
                target.addScaledVector(uv3, $c702e238df7c5123$var$_v3$1.z);
                return target;
            }
        },
        {
            key: "isFrontFacing",
            value: function isFrontFacing(a, b, c, direction) {
                $c702e238df7c5123$var$_v0$1.subVectors(c, b);
                $c702e238df7c5123$var$_v1$3.subVectors(a, b);
                // strictly front facing
                return $c702e238df7c5123$var$_v0$1.cross($c702e238df7c5123$var$_v1$3).dot(direction) < 0 ? true : false;
            }
        }
    ]);
    return Triangle;
}();
var $c702e238df7c5123$var$materialId = 0;
var $c702e238df7c5123$export$a2d8b23205c25948 = /*#__PURE__*/ function(EventDispatcher) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(Material, EventDispatcher);
    function Material() {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Material);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, Material);
        Object.defineProperty(_this, 'id', {
            value: $c702e238df7c5123$var$materialId++
        });
        _this.uuid = $c702e238df7c5123$var$generateUUID();
        _this.name = '';
        _this.type = 'Material';
        _this.fog = true;
        _this.blending = $c702e238df7c5123$export$5b29a26d96ee6af0;
        _this.side = $c702e238df7c5123$export$2ede184fc2998901;
        _this.vertexColors = false;
        _this.opacity = 1;
        _this.transparent = false;
        _this.blendSrc = $c702e238df7c5123$export$d5773124e86cf28c;
        _this.blendDst = $c702e238df7c5123$export$11d468cc7f19e971;
        _this.blendEquation = $c702e238df7c5123$export$20183a0484ce21a0;
        _this.blendSrcAlpha = null;
        _this.blendDstAlpha = null;
        _this.blendEquationAlpha = null;
        _this.depthFunc = $c702e238df7c5123$export$296f78a0b892f81a;
        _this.depthTest = true;
        _this.depthWrite = true;
        _this.stencilWriteMask = 0xff;
        _this.stencilFunc = $c702e238df7c5123$export$14cf96713ddd97a8;
        _this.stencilRef = 0;
        _this.stencilFuncMask = 0xff;
        _this.stencilFail = $c702e238df7c5123$export$9f542ae4b5baca34;
        _this.stencilZFail = $c702e238df7c5123$export$9f542ae4b5baca34;
        _this.stencilZPass = $c702e238df7c5123$export$9f542ae4b5baca34;
        _this.stencilWrite = false;
        _this.clippingPlanes = null;
        _this.clipIntersection = false;
        _this.clipShadows = false;
        _this.shadowSide = null;
        _this.colorWrite = true;
        _this.precision = null; // override the renderer's default precision for this material
        _this.polygonOffset = false;
        _this.polygonOffsetFactor = 0;
        _this.polygonOffsetUnits = 0;
        _this.dithering = false;
        _this.alphaTest = 0;
        _this.alphaToCoverage = false;
        _this.premultipliedAlpha = false;
        _this.visible = true;
        _this.toneMapped = true;
        _this.userData = {};
        _this.version = 0;
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(Material, [
        {
            key: "onBuild",
            value: function onBuild() {}
        },
        {
            key: "onBeforeCompile",
            value: function onBeforeCompile() {}
        },
        {
            key: "customProgramCacheKey",
            value: function customProgramCacheKey() {
                return this.onBeforeCompile.toString();
            }
        },
        {
            key: "setValues",
            value: function setValues(values) {
                if (values === undefined) return;
                for(var key in values){
                    var newValue = values[key];
                    if (newValue === undefined) {
                        console.warn('THREE.Material: \'' + key + '\' parameter is undefined.');
                        continue;
                    }
                    // for backward compatability if shading is set in the constructor
                    if (key === 'shading') {
                        console.warn('THREE.' + this.type + ': .shading has been removed. Use the boolean .flatShading instead.');
                        this.flatShading = newValue === $c702e238df7c5123$export$a62047d29c96d8ff ? true : false;
                        continue;
                    }
                    var currentValue = this[key];
                    if (currentValue === undefined) {
                        console.warn('THREE.' + this.type + ': \'' + key + '\' is not a property of this material.');
                        continue;
                    }
                    if (currentValue && currentValue.isColor) currentValue.set(newValue);
                    else if (currentValue && currentValue.isVector3 && newValue && newValue.isVector3) currentValue.copy(newValue);
                    else this[key] = newValue;
                }
            }
        },
        {
            key: "toJSON",
            value: function toJSON(meta) {
                var isRoot = meta === undefined || typeof meta === 'string';
                if (isRoot) meta = {
                    textures: {},
                    images: {}
                };
                var data = {
                    metadata: {
                        version: 4.5,
                        type: 'Material',
                        generator: 'Material.toJSON'
                    }
                };
                // standard Material serialization
                data.uuid = this.uuid;
                data.type = this.type;
                if (this.name !== '') data.name = this.name;
                if (this.color && this.color.isColor) data.color = this.color.getHex();
                if (this.roughness !== undefined) data.roughness = this.roughness;
                if (this.metalness !== undefined) data.metalness = this.metalness;
                if (this.sheen && this.sheen.isColor) data.sheen = this.sheen.getHex();
                if (this.emissive && this.emissive.isColor) data.emissive = this.emissive.getHex();
                if (this.emissiveIntensity && this.emissiveIntensity !== 1) data.emissiveIntensity = this.emissiveIntensity;
                if (this.specular && this.specular.isColor) data.specular = this.specular.getHex();
                if (this.shininess !== undefined) data.shininess = this.shininess;
                if (this.clearcoat !== undefined) data.clearcoat = this.clearcoat;
                if (this.clearcoatRoughness !== undefined) data.clearcoatRoughness = this.clearcoatRoughness;
                if (this.clearcoatMap && this.clearcoatMap.isTexture) data.clearcoatMap = this.clearcoatMap.toJSON(meta).uuid;
                if (this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture) data.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(meta).uuid;
                if (this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture) {
                    data.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(meta).uuid;
                    data.clearcoatNormalScale = this.clearcoatNormalScale.toArray();
                }
                if (this.map && this.map.isTexture) data.map = this.map.toJSON(meta).uuid;
                if (this.matcap && this.matcap.isTexture) data.matcap = this.matcap.toJSON(meta).uuid;
                if (this.alphaMap && this.alphaMap.isTexture) data.alphaMap = this.alphaMap.toJSON(meta).uuid;
                if (this.lightMap && this.lightMap.isTexture) {
                    data.lightMap = this.lightMap.toJSON(meta).uuid;
                    data.lightMapIntensity = this.lightMapIntensity;
                }
                if (this.aoMap && this.aoMap.isTexture) {
                    data.aoMap = this.aoMap.toJSON(meta).uuid;
                    data.aoMapIntensity = this.aoMapIntensity;
                }
                if (this.bumpMap && this.bumpMap.isTexture) {
                    data.bumpMap = this.bumpMap.toJSON(meta).uuid;
                    data.bumpScale = this.bumpScale;
                }
                if (this.normalMap && this.normalMap.isTexture) {
                    data.normalMap = this.normalMap.toJSON(meta).uuid;
                    data.normalMapType = this.normalMapType;
                    data.normalScale = this.normalScale.toArray();
                }
                if (this.displacementMap && this.displacementMap.isTexture) {
                    data.displacementMap = this.displacementMap.toJSON(meta).uuid;
                    data.displacementScale = this.displacementScale;
                    data.displacementBias = this.displacementBias;
                }
                if (this.roughnessMap && this.roughnessMap.isTexture) data.roughnessMap = this.roughnessMap.toJSON(meta).uuid;
                if (this.metalnessMap && this.metalnessMap.isTexture) data.metalnessMap = this.metalnessMap.toJSON(meta).uuid;
                if (this.emissiveMap && this.emissiveMap.isTexture) data.emissiveMap = this.emissiveMap.toJSON(meta).uuid;
                if (this.specularMap && this.specularMap.isTexture) data.specularMap = this.specularMap.toJSON(meta).uuid;
                if (this.envMap && this.envMap.isTexture) {
                    data.envMap = this.envMap.toJSON(meta).uuid;
                    if (this.combine !== undefined) data.combine = this.combine;
                }
                if (this.envMapIntensity !== undefined) data.envMapIntensity = this.envMapIntensity;
                if (this.reflectivity !== undefined) data.reflectivity = this.reflectivity;
                if (this.refractionRatio !== undefined) data.refractionRatio = this.refractionRatio;
                if (this.gradientMap && this.gradientMap.isTexture) data.gradientMap = this.gradientMap.toJSON(meta).uuid;
                if (this.transmission !== undefined) data.transmission = this.transmission;
                if (this.transmissionMap && this.transmissionMap.isTexture) data.transmissionMap = this.transmissionMap.toJSON(meta).uuid;
                if (this.thickness !== undefined) data.thickness = this.thickness;
                if (this.thicknessMap && this.thicknessMap.isTexture) data.thicknessMap = this.thicknessMap.toJSON(meta).uuid;
                if (this.attenuationDistance !== undefined) data.attenuationDistance = this.attenuationDistance;
                if (this.attenuationColor !== undefined) data.attenuationColor = this.attenuationColor.getHex();
                if (this.size !== undefined) data.size = this.size;
                if (this.shadowSide !== null) data.shadowSide = this.shadowSide;
                if (this.sizeAttenuation !== undefined) data.sizeAttenuation = this.sizeAttenuation;
                if (this.blending !== $c702e238df7c5123$export$5b29a26d96ee6af0) data.blending = this.blending;
                if (this.side !== $c702e238df7c5123$export$2ede184fc2998901) data.side = this.side;
                if (this.vertexColors) data.vertexColors = true;
                if (this.opacity < 1) data.opacity = this.opacity;
                if (this.transparent === true) data.transparent = this.transparent;
                data.depthFunc = this.depthFunc;
                data.depthTest = this.depthTest;
                data.depthWrite = this.depthWrite;
                data.colorWrite = this.colorWrite;
                data.stencilWrite = this.stencilWrite;
                data.stencilWriteMask = this.stencilWriteMask;
                data.stencilFunc = this.stencilFunc;
                data.stencilRef = this.stencilRef;
                data.stencilFuncMask = this.stencilFuncMask;
                data.stencilFail = this.stencilFail;
                data.stencilZFail = this.stencilZFail;
                data.stencilZPass = this.stencilZPass;
                // rotation (SpriteMaterial)
                if (this.rotation && this.rotation !== 0) data.rotation = this.rotation;
                if (this.polygonOffset === true) data.polygonOffset = true;
                if (this.polygonOffsetFactor !== 0) data.polygonOffsetFactor = this.polygonOffsetFactor;
                if (this.polygonOffsetUnits !== 0) data.polygonOffsetUnits = this.polygonOffsetUnits;
                if (this.linewidth && this.linewidth !== 1) data.linewidth = this.linewidth;
                if (this.dashSize !== undefined) data.dashSize = this.dashSize;
                if (this.gapSize !== undefined) data.gapSize = this.gapSize;
                if (this.scale !== undefined) data.scale = this.scale;
                if (this.dithering === true) data.dithering = true;
                if (this.alphaTest > 0) data.alphaTest = this.alphaTest;
                if (this.alphaToCoverage === true) data.alphaToCoverage = this.alphaToCoverage;
                if (this.premultipliedAlpha === true) data.premultipliedAlpha = this.premultipliedAlpha;
                if (this.wireframe === true) data.wireframe = this.wireframe;
                if (this.wireframeLinewidth > 1) data.wireframeLinewidth = this.wireframeLinewidth;
                if (this.wireframeLinecap !== 'round') data.wireframeLinecap = this.wireframeLinecap;
                if (this.wireframeLinejoin !== 'round') data.wireframeLinejoin = this.wireframeLinejoin;
                if (this.morphTargets === true) data.morphTargets = true;
                if (this.morphNormals === true) data.morphNormals = true;
                if (this.flatShading === true) data.flatShading = this.flatShading;
                if (this.visible === false) data.visible = false;
                if (this.toneMapped === false) data.toneMapped = false;
                if (JSON.stringify(this.userData) !== '{}') data.userData = this.userData;
                // TODO: Copied from Object3D.toJSON
                function extractFromCache(cache) {
                    var values = [];
                    for(var key in cache){
                        var data = cache[key];
                        delete data.metadata;
                        values.push(data);
                    }
                    return values;
                }
                if (isRoot) {
                    var textures = extractFromCache(meta.textures);
                    var images = extractFromCache(meta.images);
                    if (textures.length > 0) data.textures = textures;
                    if (images.length > 0) data.images = images;
                }
                return data;
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                this.name = source.name;
                this.fog = source.fog;
                this.blending = source.blending;
                this.side = source.side;
                this.vertexColors = source.vertexColors;
                this.opacity = source.opacity;
                this.transparent = source.transparent;
                this.blendSrc = source.blendSrc;
                this.blendDst = source.blendDst;
                this.blendEquation = source.blendEquation;
                this.blendSrcAlpha = source.blendSrcAlpha;
                this.blendDstAlpha = source.blendDstAlpha;
                this.blendEquationAlpha = source.blendEquationAlpha;
                this.depthFunc = source.depthFunc;
                this.depthTest = source.depthTest;
                this.depthWrite = source.depthWrite;
                this.stencilWriteMask = source.stencilWriteMask;
                this.stencilFunc = source.stencilFunc;
                this.stencilRef = source.stencilRef;
                this.stencilFuncMask = source.stencilFuncMask;
                this.stencilFail = source.stencilFail;
                this.stencilZFail = source.stencilZFail;
                this.stencilZPass = source.stencilZPass;
                this.stencilWrite = source.stencilWrite;
                var srcPlanes = source.clippingPlanes;
                var dstPlanes = null;
                if (srcPlanes !== null) {
                    var n = srcPlanes.length;
                    dstPlanes = new Array(n);
                    for(var i = 0; i !== n; ++i)dstPlanes[i] = srcPlanes[i].clone();
                }
                this.clippingPlanes = dstPlanes;
                this.clipIntersection = source.clipIntersection;
                this.clipShadows = source.clipShadows;
                this.shadowSide = source.shadowSide;
                this.colorWrite = source.colorWrite;
                this.precision = source.precision;
                this.polygonOffset = source.polygonOffset;
                this.polygonOffsetFactor = source.polygonOffsetFactor;
                this.polygonOffsetUnits = source.polygonOffsetUnits;
                this.dithering = source.dithering;
                this.alphaTest = source.alphaTest;
                this.alphaToCoverage = source.alphaToCoverage;
                this.premultipliedAlpha = source.premultipliedAlpha;
                this.visible = source.visible;
                this.toneMapped = source.toneMapped;
                this.userData = JSON.parse(JSON.stringify(source.userData));
                return this;
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this.dispatchEvent({
                    type: 'dispose'
                });
            }
        },
        {
            key: "needsUpdate",
            set: function set(value) {
                if (value === true) this.version++;
            }
        }
    ]);
    return Material;
}($c702e238df7c5123$export$ec8b666c5fe2c75a);
$c702e238df7c5123$export$a2d8b23205c25948.prototype.isMaterial = true;
var $c702e238df7c5123$var$_colorKeywords = {
    aliceblue: 0xF0F8FF,
    antiquewhite: 0xFAEBD7,
    aqua: 0x00FFFF,
    aquamarine: 0x7FFFD4,
    azure: 0xF0FFFF,
    beige: 0xF5F5DC,
    bisque: 0xFFE4C4,
    black: 0x000000,
    blanchedalmond: 0xFFEBCD,
    blue: 0x0000FF,
    blueviolet: 0x8A2BE2,
    brown: 0xA52A2A,
    burlywood: 0xDEB887,
    cadetblue: 0x5F9EA0,
    chartreuse: 0x7FFF00,
    chocolate: 0xD2691E,
    coral: 0xFF7F50,
    cornflowerblue: 0x6495ED,
    cornsilk: 0xFFF8DC,
    crimson: 0xDC143C,
    cyan: 0x00FFFF,
    darkblue: 0x00008B,
    darkcyan: 0x008B8B,
    darkgoldenrod: 0xB8860B,
    darkgray: 0xA9A9A9,
    darkgreen: 0x006400,
    darkgrey: 0xA9A9A9,
    darkkhaki: 0xBDB76B,
    darkmagenta: 0x8B008B,
    darkolivegreen: 0x556B2F,
    darkorange: 0xFF8C00,
    darkorchid: 0x9932CC,
    darkred: 0x8B0000,
    darksalmon: 0xE9967A,
    darkseagreen: 0x8FBC8F,
    darkslateblue: 0x483D8B,
    darkslategray: 0x2F4F4F,
    darkslategrey: 0x2F4F4F,
    darkturquoise: 0x00CED1,
    darkviolet: 0x9400D3,
    deeppink: 0xFF1493,
    deepskyblue: 0x00BFFF,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1E90FF,
    firebrick: 0xB22222,
    floralwhite: 0xFFFAF0,
    forestgreen: 0x228B22,
    fuchsia: 0xFF00FF,
    gainsboro: 0xDCDCDC,
    ghostwhite: 0xF8F8FF,
    gold: 0xFFD700,
    goldenrod: 0xDAA520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xADFF2F,
    grey: 0x808080,
    honeydew: 0xF0FFF0,
    hotpink: 0xFF69B4,
    indianred: 0xCD5C5C,
    indigo: 0x4B0082,
    ivory: 0xFFFFF0,
    khaki: 0xF0E68C,
    lavender: 0xE6E6FA,
    lavenderblush: 0xFFF0F5,
    lawngreen: 0x7CFC00,
    lemonchiffon: 0xFFFACD,
    lightblue: 0xADD8E6,
    lightcoral: 0xF08080,
    lightcyan: 0xE0FFFF,
    lightgoldenrodyellow: 0xFAFAD2,
    lightgray: 0xD3D3D3,
    lightgreen: 0x90EE90,
    lightgrey: 0xD3D3D3,
    lightpink: 0xFFB6C1,
    lightsalmon: 0xFFA07A,
    lightseagreen: 0x20B2AA,
    lightskyblue: 0x87CEFA,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xB0C4DE,
    lightyellow: 0xFFFFE0,
    lime: 0x00FF00,
    limegreen: 0x32CD32,
    linen: 0xFAF0E6,
    magenta: 0xFF00FF,
    maroon: 0x800000,
    mediumaquamarine: 0x66CDAA,
    mediumblue: 0x0000CD,
    mediumorchid: 0xBA55D3,
    mediumpurple: 0x9370DB,
    mediumseagreen: 0x3CB371,
    mediumslateblue: 0x7B68EE,
    mediumspringgreen: 0x00FA9A,
    mediumturquoise: 0x48D1CC,
    mediumvioletred: 0xC71585,
    midnightblue: 0x191970,
    mintcream: 0xF5FFFA,
    mistyrose: 0xFFE4E1,
    moccasin: 0xFFE4B5,
    navajowhite: 0xFFDEAD,
    navy: 0x000080,
    oldlace: 0xFDF5E6,
    olive: 0x808000,
    olivedrab: 0x6B8E23,
    orange: 0xFFA500,
    orangered: 0xFF4500,
    orchid: 0xDA70D6,
    palegoldenrod: 0xEEE8AA,
    palegreen: 0x98FB98,
    paleturquoise: 0xAFEEEE,
    palevioletred: 0xDB7093,
    papayawhip: 0xFFEFD5,
    peachpuff: 0xFFDAB9,
    peru: 0xCD853F,
    pink: 0xFFC0CB,
    plum: 0xDDA0DD,
    powderblue: 0xB0E0E6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xFF0000,
    rosybrown: 0xBC8F8F,
    royalblue: 0x4169E1,
    saddlebrown: 0x8B4513,
    salmon: 0xFA8072,
    sandybrown: 0xF4A460,
    seagreen: 0x2E8B57,
    seashell: 0xFFF5EE,
    sienna: 0xA0522D,
    silver: 0xC0C0C0,
    skyblue: 0x87CEEB,
    slateblue: 0x6A5ACD,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xFFFAFA,
    springgreen: 0x00FF7F,
    steelblue: 0x4682B4,
    tan: 0xD2B48C,
    teal: 0x008080,
    thistle: 0xD8BFD8,
    tomato: 0xFF6347,
    turquoise: 0x40E0D0,
    violet: 0xEE82EE,
    wheat: 0xF5DEB3,
    white: 0xFFFFFF,
    whitesmoke: 0xF5F5F5,
    yellow: 0xFFFF00,
    yellowgreen: 0x9ACD32
};
var $c702e238df7c5123$var$_hslA = {
    h: 0,
    s: 0,
    l: 0
};
var $c702e238df7c5123$var$_hslB = {
    h: 0,
    s: 0,
    l: 0
};
function $c702e238df7c5123$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * 6 * (2 / 3 - t);
    return p;
}
function $c702e238df7c5123$var$SRGBToLinear(c) {
    return c < 0.04045 ? c * 0.0773993808 : Math.pow(c * 0.9478672986 + 0.0521327014, 2.4);
}
function $c702e238df7c5123$var$LinearToSRGB(c) {
    return c < 0.0031308 ? c * 12.92 : 1.055 * Math.pow(c, 0.41666) - 0.055;
}
var $c702e238df7c5123$export$892596cec99bc70e = /*#__PURE__*/ function() {
    "use strict";
    function Color(r, g, b) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Color);
        if (g === undefined && b === undefined) // r is THREE.Color, hex or string
        return this.set(r);
        return this.setRGB(r, g, b);
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(Color, [
        {
            key: "set",
            value: function set(value) {
                if (value && value.isColor) this.copy(value);
                else if (typeof value === 'number') this.setHex(value);
                else if (typeof value === 'string') this.setStyle(value);
                return this;
            }
        },
        {
            key: "setScalar",
            value: function setScalar(scalar) {
                this.r = scalar;
                this.g = scalar;
                this.b = scalar;
                return this;
            }
        },
        {
            key: "setHex",
            value: function setHex(hex) {
                hex = Math.floor(hex);
                this.r = (hex >> 16 & 255) / 255;
                this.g = (hex >> 8 & 255) / 255;
                this.b = (hex & 255) / 255;
                return this;
            }
        },
        {
            key: "setRGB",
            value: function setRGB(r, g, b) {
                this.r = r;
                this.g = g;
                this.b = b;
                return this;
            }
        },
        {
            key: "setHSL",
            value: function setHSL(h, s, l) {
                // h,s,l ranges are in 0.0 - 1.0
                h = $c702e238df7c5123$var$euclideanModulo(h, 1);
                s = $c702e238df7c5123$var$clamp(s, 0, 1);
                l = $c702e238df7c5123$var$clamp(l, 0, 1);
                if (s === 0) this.r = this.g = this.b = l;
                else {
                    var p = l <= 0.5 ? l * (1 + s) : l + s - l * s;
                    var q = 2 * l - p;
                    this.r = $c702e238df7c5123$var$hue2rgb(q, p, h + 1 / 3);
                    this.g = $c702e238df7c5123$var$hue2rgb(q, p, h);
                    this.b = $c702e238df7c5123$var$hue2rgb(q, p, h - 1 / 3);
                }
                return this;
            }
        },
        {
            key: "setStyle",
            value: function setStyle(style) {
                function handleAlpha(string) {
                    if (string === undefined) return;
                    if (parseFloat(string) < 1) console.warn('THREE.Color: Alpha component of ' + style + ' will be ignored.');
                }
                var m;
                if (m = /^((?:rgb|hsl)a?)\(([^\)]*)\)/.exec(style)) {
                    // rgb / hsl
                    var color;
                    var name = m[1];
                    var components = m[2];
                    switch(name){
                        case 'rgb':
                        case 'rgba':
                            if (color = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                                // rgb(255,0,0) rgba(255,0,0,0.5)
                                this.r = Math.min(255, parseInt(color[1], 10)) / 255;
                                this.g = Math.min(255, parseInt(color[2], 10)) / 255;
                                this.b = Math.min(255, parseInt(color[3], 10)) / 255;
                                handleAlpha(color[4]);
                                return this;
                            }
                            if (color = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                                // rgb(100%,0%,0%) rgba(100%,0%,0%,0.5)
                                this.r = Math.min(100, parseInt(color[1], 10)) / 100;
                                this.g = Math.min(100, parseInt(color[2], 10)) / 100;
                                this.b = Math.min(100, parseInt(color[3], 10)) / 100;
                                handleAlpha(color[4]);
                                return this;
                            }
                            break;
                        case 'hsl':
                        case 'hsla':
                            if (color = /^\s*(\d*\.?\d+)\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                                // hsl(120,50%,50%) hsla(120,50%,50%,0.5)
                                var h = parseFloat(color[1]) / 360;
                                var s = parseInt(color[2], 10) / 100;
                                var l = parseInt(color[3], 10) / 100;
                                handleAlpha(color[4]);
                                return this.setHSL(h, s, l);
                            }
                            break;
                    }
                } else if (m = /^\#([A-Fa-f\d]+)$/.exec(style)) {
                    // hex color
                    var hex = m[1];
                    var size = hex.length;
                    if (size === 3) {
                        // #ff0
                        this.r = parseInt(hex.charAt(0) + hex.charAt(0), 16) / 255;
                        this.g = parseInt(hex.charAt(1) + hex.charAt(1), 16) / 255;
                        this.b = parseInt(hex.charAt(2) + hex.charAt(2), 16) / 255;
                        return this;
                    } else if (size === 6) {
                        // #ff0000
                        this.r = parseInt(hex.charAt(0) + hex.charAt(1), 16) / 255;
                        this.g = parseInt(hex.charAt(2) + hex.charAt(3), 16) / 255;
                        this.b = parseInt(hex.charAt(4) + hex.charAt(5), 16) / 255;
                        return this;
                    }
                }
                if (style && style.length > 0) return this.setColorName(style);
                return this;
            }
        },
        {
            key: "setColorName",
            value: function setColorName(style) {
                // color keywords
                var hex = $c702e238df7c5123$var$_colorKeywords[style.toLowerCase()];
                if (hex !== undefined) // red
                this.setHex(hex);
                else // unknown color
                console.warn('THREE.Color: Unknown color ' + style);
                return this;
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor(this.r, this.g, this.b);
            }
        },
        {
            key: "copy",
            value: function copy(color) {
                this.r = color.r;
                this.g = color.g;
                this.b = color.b;
                return this;
            }
        },
        {
            key: "copyGammaToLinear",
            value: function copyGammaToLinear(color) {
                var gammaFactor = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2.0;
                this.r = Math.pow(color.r, gammaFactor);
                this.g = Math.pow(color.g, gammaFactor);
                this.b = Math.pow(color.b, gammaFactor);
                return this;
            }
        },
        {
            key: "copyLinearToGamma",
            value: function copyLinearToGamma(color) {
                var gammaFactor = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2.0;
                var safeInverse = gammaFactor > 0 ? 1.0 / gammaFactor : 1.0;
                this.r = Math.pow(color.r, safeInverse);
                this.g = Math.pow(color.g, safeInverse);
                this.b = Math.pow(color.b, safeInverse);
                return this;
            }
        },
        {
            key: "convertGammaToLinear",
            value: function convertGammaToLinear(gammaFactor) {
                this.copyGammaToLinear(this, gammaFactor);
                return this;
            }
        },
        {
            key: "convertLinearToGamma",
            value: function convertLinearToGamma(gammaFactor) {
                this.copyLinearToGamma(this, gammaFactor);
                return this;
            }
        },
        {
            key: "copySRGBToLinear",
            value: function copySRGBToLinear(color) {
                this.r = $c702e238df7c5123$var$SRGBToLinear(color.r);
                this.g = $c702e238df7c5123$var$SRGBToLinear(color.g);
                this.b = $c702e238df7c5123$var$SRGBToLinear(color.b);
                return this;
            }
        },
        {
            key: "copyLinearToSRGB",
            value: function copyLinearToSRGB(color) {
                this.r = $c702e238df7c5123$var$LinearToSRGB(color.r);
                this.g = $c702e238df7c5123$var$LinearToSRGB(color.g);
                this.b = $c702e238df7c5123$var$LinearToSRGB(color.b);
                return this;
            }
        },
        {
            key: "convertSRGBToLinear",
            value: function convertSRGBToLinear() {
                this.copySRGBToLinear(this);
                return this;
            }
        },
        {
            key: "convertLinearToSRGB",
            value: function convertLinearToSRGB() {
                this.copyLinearToSRGB(this);
                return this;
            }
        },
        {
            key: "getHex",
            value: function getHex() {
                return this.r * 255 << 16 ^ this.g * 255 << 8 ^ this.b * 255 << 0;
            }
        },
        {
            key: "getHexString",
            value: function getHexString() {
                return ('000000' + this.getHex().toString(16)).slice(-6);
            }
        },
        {
            key: "getHSL",
            value: function getHSL(target) {
                // h,s,l ranges are in 0.0 - 1.0
                var r = this.r, g = this.g, b = this.b;
                var max = Math.max(r, g, b);
                var min = Math.min(r, g, b);
                var hue, saturation;
                var lightness = (min + max) / 2.0;
                if (min === max) {
                    hue = 0;
                    saturation = 0;
                } else {
                    var delta = max - min;
                    saturation = lightness <= 0.5 ? delta / (max + min) : delta / (2 - max - min);
                    switch(max){
                        case r:
                            hue = (g - b) / delta + (g < b ? 6 : 0);
                            break;
                        case g:
                            hue = (b - r) / delta + 2;
                            break;
                        case b:
                            hue = (r - g) / delta + 4;
                            break;
                    }
                    hue /= 6;
                }
                target.h = hue;
                target.s = saturation;
                target.l = lightness;
                return target;
            }
        },
        {
            key: "getStyle",
            value: function getStyle() {
                return 'rgb(' + (this.r * 255 | 0) + ',' + (this.g * 255 | 0) + ',' + (this.b * 255 | 0) + ')';
            }
        },
        {
            key: "offsetHSL",
            value: function offsetHSL(h, s, l) {
                this.getHSL($c702e238df7c5123$var$_hslA);
                $c702e238df7c5123$var$_hslA.h += h;
                $c702e238df7c5123$var$_hslA.s += s;
                $c702e238df7c5123$var$_hslA.l += l;
                this.setHSL($c702e238df7c5123$var$_hslA.h, $c702e238df7c5123$var$_hslA.s, $c702e238df7c5123$var$_hslA.l);
                return this;
            }
        },
        {
            key: "add",
            value: function add(color) {
                this.r += color.r;
                this.g += color.g;
                this.b += color.b;
                return this;
            }
        },
        {
            key: "addColors",
            value: function addColors(color1, color2) {
                this.r = color1.r + color2.r;
                this.g = color1.g + color2.g;
                this.b = color1.b + color2.b;
                return this;
            }
        },
        {
            key: "addScalar",
            value: function addScalar(s) {
                this.r += s;
                this.g += s;
                this.b += s;
                return this;
            }
        },
        {
            key: "sub",
            value: function sub(color) {
                this.r = Math.max(0, this.r - color.r);
                this.g = Math.max(0, this.g - color.g);
                this.b = Math.max(0, this.b - color.b);
                return this;
            }
        },
        {
            key: "multiply",
            value: function multiply(color) {
                this.r *= color.r;
                this.g *= color.g;
                this.b *= color.b;
                return this;
            }
        },
        {
            key: "multiplyScalar",
            value: function multiplyScalar(s) {
                this.r *= s;
                this.g *= s;
                this.b *= s;
                return this;
            }
        },
        {
            key: "lerp",
            value: function lerp(color, alpha) {
                this.r += (color.r - this.r) * alpha;
                this.g += (color.g - this.g) * alpha;
                this.b += (color.b - this.b) * alpha;
                return this;
            }
        },
        {
            key: "lerpColors",
            value: function lerpColors(color1, color2, alpha) {
                this.r = color1.r + (color2.r - color1.r) * alpha;
                this.g = color1.g + (color2.g - color1.g) * alpha;
                this.b = color1.b + (color2.b - color1.b) * alpha;
                return this;
            }
        },
        {
            key: "lerpHSL",
            value: function lerpHSL(color, alpha) {
                this.getHSL($c702e238df7c5123$var$_hslA);
                color.getHSL($c702e238df7c5123$var$_hslB);
                var h = $c702e238df7c5123$var$lerp($c702e238df7c5123$var$_hslA.h, $c702e238df7c5123$var$_hslB.h, alpha);
                var s = $c702e238df7c5123$var$lerp($c702e238df7c5123$var$_hslA.s, $c702e238df7c5123$var$_hslB.s, alpha);
                var l = $c702e238df7c5123$var$lerp($c702e238df7c5123$var$_hslA.l, $c702e238df7c5123$var$_hslB.l, alpha);
                this.setHSL(h, s, l);
                return this;
            }
        },
        {
            key: "equals",
            value: function equals(c) {
                return c.r === this.r && c.g === this.g && c.b === this.b;
            }
        },
        {
            key: "fromArray",
            value: function fromArray(array) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                this.r = array[offset];
                this.g = array[offset + 1];
                this.b = array[offset + 2];
                return this;
            }
        },
        {
            key: "toArray",
            value: function toArray() {
                var array = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                array[offset] = this.r;
                array[offset + 1] = this.g;
                array[offset + 2] = this.b;
                return array;
            }
        },
        {
            key: "fromBufferAttribute",
            value: function fromBufferAttribute(attribute, index) {
                this.r = attribute.getX(index);
                this.g = attribute.getY(index);
                this.b = attribute.getZ(index);
                if (attribute.normalized === true) {
                    // assuming Uint8Array
                    this.r /= 255;
                    this.g /= 255;
                    this.b /= 255;
                }
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return this.getHex();
            }
        }
    ]);
    return Color;
}();
$c702e238df7c5123$export$892596cec99bc70e.NAMES = $c702e238df7c5123$var$_colorKeywords;
$c702e238df7c5123$export$892596cec99bc70e.prototype.isColor = true;
$c702e238df7c5123$export$892596cec99bc70e.prototype.r = 1;
$c702e238df7c5123$export$892596cec99bc70e.prototype.g = 1;
$c702e238df7c5123$export$892596cec99bc70e.prototype.b = 1;
/**
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *  map: new THREE.Texture( <Image> ),
 *
 *  lightMap: new THREE.Texture( <Image> ),
 *  lightMapIntensity: <float>
 *
 *  aoMap: new THREE.Texture( <Image> ),
 *  aoMapIntensity: <float>
 *
 *  specularMap: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  envMap: new THREE.CubeTexture( [posx, negx, posy, negy, posz, negz] ),
 *  combine: THREE.Multiply,
 *  reflectivity: <float>,
 *  refractionRatio: <float>,
 *
 *  depthTest: <bool>,
 *  depthWrite: <bool>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 *  morphTargets: <bool>
 * }
 */ var $c702e238df7c5123$export$55cbcc9b622fe1f5 = /*#__PURE__*/ function(Material) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(MeshBasicMaterial, Material);
    function MeshBasicMaterial(parameters) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, MeshBasicMaterial);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, MeshBasicMaterial);
        _this.type = 'MeshBasicMaterial';
        _this.color = new $c702e238df7c5123$export$892596cec99bc70e(0xffffff); // emissive
        _this.map = null;
        _this.lightMap = null;
        _this.lightMapIntensity = 1.0;
        _this.aoMap = null;
        _this.aoMapIntensity = 1.0;
        _this.specularMap = null;
        _this.alphaMap = null;
        _this.envMap = null;
        _this.combine = $c702e238df7c5123$export$e50ac29801f1774d;
        _this.reflectivity = 1;
        _this.refractionRatio = 0.98;
        _this.wireframe = false;
        _this.wireframeLinewidth = 1;
        _this.wireframeLinecap = 'round';
        _this.wireframeLinejoin = 'round';
        _this.morphTargets = false;
        _this.setValues(parameters);
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(MeshBasicMaterial, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(MeshBasicMaterial.prototype), "copy", this).call(this, source);
                this.color.copy(source.color);
                this.map = source.map;
                this.lightMap = source.lightMap;
                this.lightMapIntensity = source.lightMapIntensity;
                this.aoMap = source.aoMap;
                this.aoMapIntensity = source.aoMapIntensity;
                this.specularMap = source.specularMap;
                this.alphaMap = source.alphaMap;
                this.envMap = source.envMap;
                this.combine = source.combine;
                this.reflectivity = source.reflectivity;
                this.refractionRatio = source.refractionRatio;
                this.wireframe = source.wireframe;
                this.wireframeLinewidth = source.wireframeLinewidth;
                this.wireframeLinecap = source.wireframeLinecap;
                this.wireframeLinejoin = source.wireframeLinejoin;
                this.morphTargets = source.morphTargets;
                return this;
            }
        }
    ]);
    return MeshBasicMaterial;
}($c702e238df7c5123$export$a2d8b23205c25948);
$c702e238df7c5123$export$55cbcc9b622fe1f5.prototype.isMeshBasicMaterial = true;
var $c702e238df7c5123$var$_vector$9 = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_vector2$1 = /*@__PURE__*/ new $c702e238df7c5123$export$c977b3e384af9ae1();
var $c702e238df7c5123$export$8dea267bd6bde117 = /*#__PURE__*/ function() {
    "use strict";
    function BufferAttribute(array, itemSize, normalized) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, BufferAttribute);
        if (Array.isArray(array)) throw new TypeError('THREE.BufferAttribute: array should be a Typed Array.');
        this.name = '';
        this.array = array;
        this.itemSize = itemSize;
        this.count = array !== undefined ? array.length / itemSize : 0;
        this.normalized = normalized === true;
        this.usage = $c702e238df7c5123$export$763e8360f4d7f77d;
        this.updateRange = {
            offset: 0,
            count: -1
        };
        this.version = 0;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(BufferAttribute, [
        {
            key: "onUploadCallback",
            value: function onUploadCallback() {}
        },
        {
            key: "needsUpdate",
            set: function set(value) {
                if (value === true) this.version++;
            }
        },
        {
            key: "setUsage",
            value: function setUsage(value) {
                this.usage = value;
                return this;
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                this.name = source.name;
                this.array = new source.array.constructor(source.array);
                this.itemSize = source.itemSize;
                this.count = source.count;
                this.normalized = source.normalized;
                this.usage = source.usage;
                return this;
            }
        },
        {
            key: "copyAt",
            value: function copyAt(index1, attribute, index2) {
                index1 *= this.itemSize;
                index2 *= attribute.itemSize;
                for(var i = 0, l = this.itemSize; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
                return this;
            }
        },
        {
            key: "copyArray",
            value: function copyArray(array) {
                this.array.set(array);
                return this;
            }
        },
        {
            key: "copyColorsArray",
            value: function copyColorsArray(colors) {
                var array = this.array;
                var offset = 0;
                for(var i = 0, l = colors.length; i < l; i++){
                    var color = colors[i];
                    if (color === undefined) {
                        console.warn('THREE.BufferAttribute.copyColorsArray(): color is undefined', i);
                        color = new $c702e238df7c5123$export$892596cec99bc70e();
                    }
                    array[offset++] = color.r;
                    array[offset++] = color.g;
                    array[offset++] = color.b;
                }
                return this;
            }
        },
        {
            key: "copyVector2sArray",
            value: function copyVector2sArray(vectors) {
                var array = this.array;
                var offset = 0;
                for(var i = 0, l = vectors.length; i < l; i++){
                    var vector = vectors[i];
                    if (vector === undefined) {
                        console.warn('THREE.BufferAttribute.copyVector2sArray(): vector is undefined', i);
                        vector = new $c702e238df7c5123$export$c977b3e384af9ae1();
                    }
                    array[offset++] = vector.x;
                    array[offset++] = vector.y;
                }
                return this;
            }
        },
        {
            key: "copyVector3sArray",
            value: function copyVector3sArray(vectors) {
                var array = this.array;
                var offset = 0;
                for(var i = 0, l = vectors.length; i < l; i++){
                    var vector = vectors[i];
                    if (vector === undefined) {
                        console.warn('THREE.BufferAttribute.copyVector3sArray(): vector is undefined', i);
                        vector = new $c702e238df7c5123$export$64b5c384219d3699();
                    }
                    array[offset++] = vector.x;
                    array[offset++] = vector.y;
                    array[offset++] = vector.z;
                }
                return this;
            }
        },
        {
            key: "copyVector4sArray",
            value: function copyVector4sArray(vectors) {
                var array = this.array;
                var offset = 0;
                for(var i = 0, l = vectors.length; i < l; i++){
                    var vector = vectors[i];
                    if (vector === undefined) {
                        console.warn('THREE.BufferAttribute.copyVector4sArray(): vector is undefined', i);
                        vector = new $c702e238df7c5123$export$fa7daccca11cdbe3();
                    }
                    array[offset++] = vector.x;
                    array[offset++] = vector.y;
                    array[offset++] = vector.z;
                    array[offset++] = vector.w;
                }
                return this;
            }
        },
        {
            key: "applyMatrix3",
            value: function applyMatrix3(m) {
                if (this.itemSize === 2) for(var i = 0, l = this.count; i < l; i++){
                    $c702e238df7c5123$var$_vector2$1.fromBufferAttribute(this, i);
                    $c702e238df7c5123$var$_vector2$1.applyMatrix3(m);
                    this.setXY(i, $c702e238df7c5123$var$_vector2$1.x, $c702e238df7c5123$var$_vector2$1.y);
                }
                else if (this.itemSize === 3) for(var i1 = 0, l1 = this.count; i1 < l1; i1++){
                    $c702e238df7c5123$var$_vector$9.fromBufferAttribute(this, i1);
                    $c702e238df7c5123$var$_vector$9.applyMatrix3(m);
                    this.setXYZ(i1, $c702e238df7c5123$var$_vector$9.x, $c702e238df7c5123$var$_vector$9.y, $c702e238df7c5123$var$_vector$9.z);
                }
                return this;
            }
        },
        {
            key: "applyMatrix4",
            value: function applyMatrix4(m) {
                for(var i = 0, l = this.count; i < l; i++){
                    $c702e238df7c5123$var$_vector$9.x = this.getX(i);
                    $c702e238df7c5123$var$_vector$9.y = this.getY(i);
                    $c702e238df7c5123$var$_vector$9.z = this.getZ(i);
                    $c702e238df7c5123$var$_vector$9.applyMatrix4(m);
                    this.setXYZ(i, $c702e238df7c5123$var$_vector$9.x, $c702e238df7c5123$var$_vector$9.y, $c702e238df7c5123$var$_vector$9.z);
                }
                return this;
            }
        },
        {
            key: "applyNormalMatrix",
            value: function applyNormalMatrix(m) {
                for(var i = 0, l = this.count; i < l; i++){
                    $c702e238df7c5123$var$_vector$9.x = this.getX(i);
                    $c702e238df7c5123$var$_vector$9.y = this.getY(i);
                    $c702e238df7c5123$var$_vector$9.z = this.getZ(i);
                    $c702e238df7c5123$var$_vector$9.applyNormalMatrix(m);
                    this.setXYZ(i, $c702e238df7c5123$var$_vector$9.x, $c702e238df7c5123$var$_vector$9.y, $c702e238df7c5123$var$_vector$9.z);
                }
                return this;
            }
        },
        {
            key: "transformDirection",
            value: function transformDirection(m) {
                for(var i = 0, l = this.count; i < l; i++){
                    $c702e238df7c5123$var$_vector$9.x = this.getX(i);
                    $c702e238df7c5123$var$_vector$9.y = this.getY(i);
                    $c702e238df7c5123$var$_vector$9.z = this.getZ(i);
                    $c702e238df7c5123$var$_vector$9.transformDirection(m);
                    this.setXYZ(i, $c702e238df7c5123$var$_vector$9.x, $c702e238df7c5123$var$_vector$9.y, $c702e238df7c5123$var$_vector$9.z);
                }
                return this;
            }
        },
        {
            key: "set",
            value: function set(value) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                this.array.set(value, offset);
                return this;
            }
        },
        {
            key: "getX",
            value: function getX(index) {
                return this.array[index * this.itemSize];
            }
        },
        {
            key: "setX",
            value: function setX(index, x) {
                this.array[index * this.itemSize] = x;
                return this;
            }
        },
        {
            key: "getY",
            value: function getY(index) {
                return this.array[index * this.itemSize + 1];
            }
        },
        {
            key: "setY",
            value: function setY(index, y) {
                this.array[index * this.itemSize + 1] = y;
                return this;
            }
        },
        {
            key: "getZ",
            value: function getZ(index) {
                return this.array[index * this.itemSize + 2];
            }
        },
        {
            key: "setZ",
            value: function setZ(index, z) {
                this.array[index * this.itemSize + 2] = z;
                return this;
            }
        },
        {
            key: "getW",
            value: function getW(index) {
                return this.array[index * this.itemSize + 3];
            }
        },
        {
            key: "setW",
            value: function setW(index, w) {
                this.array[index * this.itemSize + 3] = w;
                return this;
            }
        },
        {
            key: "setXY",
            value: function setXY(index, x, y) {
                index *= this.itemSize;
                this.array[index + 0] = x;
                this.array[index + 1] = y;
                return this;
            }
        },
        {
            key: "setXYZ",
            value: function setXYZ(index, x, y, z) {
                index *= this.itemSize;
                this.array[index + 0] = x;
                this.array[index + 1] = y;
                this.array[index + 2] = z;
                return this;
            }
        },
        {
            key: "setXYZW",
            value: function setXYZW(index, x, y, z, w) {
                index *= this.itemSize;
                this.array[index + 0] = x;
                this.array[index + 1] = y;
                this.array[index + 2] = z;
                this.array[index + 3] = w;
                return this;
            }
        },
        {
            key: "onUpload",
            value: function onUpload(callback) {
                this.onUploadCallback = callback;
                return this;
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor(this.array, this.itemSize).copy(this);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = {
                    itemSize: this.itemSize,
                    type: this.array.constructor.name,
                    array: Array.prototype.slice.call(this.array),
                    normalized: this.normalized
                };
                if (this.name !== '') data.name = this.name;
                if (this.usage !== $c702e238df7c5123$export$763e8360f4d7f77d) data.usage = this.usage;
                if (this.updateRange.offset !== 0 || this.updateRange.count !== -1) data.updateRange = this.updateRange;
                return data;
            }
        }
    ]);
    return BufferAttribute;
}();
$c702e238df7c5123$export$8dea267bd6bde117.prototype.isBufferAttribute = true;
//
var $c702e238df7c5123$export$f9ff2d6a20248cbf = /*#__PURE__*/ function(BufferAttribute) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(Int8BufferAttribute, BufferAttribute);
    function Int8BufferAttribute(array, itemSize, normalized) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Int8BufferAttribute);
        return (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, Int8BufferAttribute, [
            new Int8Array(array),
            itemSize,
            normalized
        ]);
    }
    return Int8BufferAttribute;
}($c702e238df7c5123$export$8dea267bd6bde117);
var $c702e238df7c5123$export$cacc90cf35d11cdd = /*#__PURE__*/ function(BufferAttribute) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(Uint8BufferAttribute, BufferAttribute);
    function Uint8BufferAttribute(array, itemSize, normalized) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Uint8BufferAttribute);
        return (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, Uint8BufferAttribute, [
            new Uint8Array(array),
            itemSize,
            normalized
        ]);
    }
    return Uint8BufferAttribute;
}($c702e238df7c5123$export$8dea267bd6bde117);
var $c702e238df7c5123$export$baaa85a1a812c157 = /*#__PURE__*/ function(BufferAttribute) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(Uint8ClampedBufferAttribute, BufferAttribute);
    function Uint8ClampedBufferAttribute(array, itemSize, normalized) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Uint8ClampedBufferAttribute);
        return (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, Uint8ClampedBufferAttribute, [
            new Uint8ClampedArray(array),
            itemSize,
            normalized
        ]);
    }
    return Uint8ClampedBufferAttribute;
}($c702e238df7c5123$export$8dea267bd6bde117);
var $c702e238df7c5123$export$2b755a102ccdcefe = /*#__PURE__*/ function(BufferAttribute) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(Int16BufferAttribute, BufferAttribute);
    function Int16BufferAttribute(array, itemSize, normalized) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Int16BufferAttribute);
        return (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, Int16BufferAttribute, [
            new Int16Array(array),
            itemSize,
            normalized
        ]);
    }
    return Int16BufferAttribute;
}($c702e238df7c5123$export$8dea267bd6bde117);
var $c702e238df7c5123$export$640a853f68025f2e = /*#__PURE__*/ function(BufferAttribute) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(Uint16BufferAttribute, BufferAttribute);
    function Uint16BufferAttribute(array, itemSize, normalized) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Uint16BufferAttribute);
        return (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, Uint16BufferAttribute, [
            new Uint16Array(array),
            itemSize,
            normalized
        ]);
    }
    return Uint16BufferAttribute;
}($c702e238df7c5123$export$8dea267bd6bde117);
var $c702e238df7c5123$export$46b369aed2968a0a = /*#__PURE__*/ function(BufferAttribute) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(Int32BufferAttribute, BufferAttribute);
    function Int32BufferAttribute(array, itemSize, normalized) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Int32BufferAttribute);
        return (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, Int32BufferAttribute, [
            new Int32Array(array),
            itemSize,
            normalized
        ]);
    }
    return Int32BufferAttribute;
}($c702e238df7c5123$export$8dea267bd6bde117);
var $c702e238df7c5123$export$7eb8c9fa25cd5bd6 = /*#__PURE__*/ function(BufferAttribute) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(Uint32BufferAttribute, BufferAttribute);
    function Uint32BufferAttribute(array, itemSize, normalized) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Uint32BufferAttribute);
        return (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, Uint32BufferAttribute, [
            new Uint32Array(array),
            itemSize,
            normalized
        ]);
    }
    return Uint32BufferAttribute;
}($c702e238df7c5123$export$8dea267bd6bde117);
var $c702e238df7c5123$export$dbd3698c64958d69 = /*#__PURE__*/ function(BufferAttribute) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(Float16BufferAttribute, BufferAttribute);
    function Float16BufferAttribute(array, itemSize, normalized) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Float16BufferAttribute);
        return (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, Float16BufferAttribute, [
            new Uint16Array(array),
            itemSize,
            normalized
        ]);
    }
    return Float16BufferAttribute;
}($c702e238df7c5123$export$8dea267bd6bde117);
$c702e238df7c5123$export$dbd3698c64958d69.prototype.isFloat16BufferAttribute = true;
var $c702e238df7c5123$export$cbe7a62641830ebd = /*#__PURE__*/ function(BufferAttribute) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(Float32BufferAttribute, BufferAttribute);
    function Float32BufferAttribute(array, itemSize, normalized) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Float32BufferAttribute);
        return (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, Float32BufferAttribute, [
            new Float32Array(array),
            itemSize,
            normalized
        ]);
    }
    return Float32BufferAttribute;
}($c702e238df7c5123$export$8dea267bd6bde117);
var $c702e238df7c5123$export$9e0ade74842adbb8 = /*#__PURE__*/ function(BufferAttribute) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(Float64BufferAttribute, BufferAttribute);
    function Float64BufferAttribute(array, itemSize, normalized) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Float64BufferAttribute);
        return (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, Float64BufferAttribute, [
            new Float64Array(array),
            itemSize,
            normalized
        ]);
    }
    return Float64BufferAttribute;
}($c702e238df7c5123$export$8dea267bd6bde117);
function $c702e238df7c5123$var$arrayMax(array) {
    if (array.length === 0) return -Infinity;
    var max = array[0];
    for(var i = 1, l = array.length; i < l; ++i)if (array[i] > max) max = array[i];
    return max;
}
var $c702e238df7c5123$var$TYPED_ARRAYS = {
    Int8Array: Int8Array,
    Uint8Array: Uint8Array,
    Uint8ClampedArray: Uint8ClampedArray,
    Int16Array: Int16Array,
    Uint16Array: Uint16Array,
    Int32Array: Int32Array,
    Uint32Array: Uint32Array,
    Float32Array: Float32Array,
    Float64Array: Float64Array
};
function $c702e238df7c5123$var$getTypedArray(type, buffer) {
    return new $c702e238df7c5123$var$TYPED_ARRAYS[type](buffer);
}
var $c702e238df7c5123$var$_id = 0;
var $c702e238df7c5123$var$_m1 = /*@__PURE__*/ new $c702e238df7c5123$export$2ae72fc923e5eb5();
var $c702e238df7c5123$var$_obj = /*@__PURE__*/ new $c702e238df7c5123$export$e4dd07dff30cc924();
var $c702e238df7c5123$var$_offset = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_box$1 = /*@__PURE__*/ new $c702e238df7c5123$export$6f7d5a9418ab2aa3();
var $c702e238df7c5123$var$_boxMorphTargets = /*@__PURE__*/ new $c702e238df7c5123$export$6f7d5a9418ab2aa3();
var $c702e238df7c5123$var$_vector$8 = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$export$b7be63a67df8959 = /*#__PURE__*/ function(EventDispatcher) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(BufferGeometry, EventDispatcher);
    function BufferGeometry() {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, BufferGeometry);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, BufferGeometry);
        Object.defineProperty(_this, 'id', {
            value: $c702e238df7c5123$var$_id++
        });
        _this.uuid = $c702e238df7c5123$var$generateUUID();
        _this.name = '';
        _this.type = 'BufferGeometry';
        _this.index = null;
        _this.attributes = {};
        _this.morphAttributes = {};
        _this.morphTargetsRelative = false;
        _this.groups = [];
        _this.boundingBox = null;
        _this.boundingSphere = null;
        _this.drawRange = {
            start: 0,
            count: Infinity
        };
        _this.userData = {};
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(BufferGeometry, [
        {
            key: "getIndex",
            value: function getIndex() {
                return this.index;
            }
        },
        {
            key: "setIndex",
            value: function setIndex(index) {
                if (Array.isArray(index)) this.index = new ($c702e238df7c5123$var$arrayMax(index) > 65535 ? $c702e238df7c5123$export$7eb8c9fa25cd5bd6 : $c702e238df7c5123$export$640a853f68025f2e)(index, 1);
                else this.index = index;
                return this;
            }
        },
        {
            key: "getAttribute",
            value: function getAttribute(name) {
                return this.attributes[name];
            }
        },
        {
            key: "setAttribute",
            value: function setAttribute(name, attribute) {
                this.attributes[name] = attribute;
                return this;
            }
        },
        {
            key: "deleteAttribute",
            value: function deleteAttribute(name) {
                delete this.attributes[name];
                return this;
            }
        },
        {
            key: "hasAttribute",
            value: function hasAttribute(name) {
                return this.attributes[name] !== undefined;
            }
        },
        {
            key: "addGroup",
            value: function addGroup(start, count) {
                var materialIndex = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                this.groups.push({
                    start: start,
                    count: count,
                    materialIndex: materialIndex
                });
            }
        },
        {
            key: "clearGroups",
            value: function clearGroups() {
                this.groups = [];
            }
        },
        {
            key: "setDrawRange",
            value: function setDrawRange(start, count) {
                this.drawRange.start = start;
                this.drawRange.count = count;
            }
        },
        {
            key: "applyMatrix4",
            value: function applyMatrix4(matrix) {
                var position = this.attributes.position;
                if (position !== undefined) {
                    position.applyMatrix4(matrix);
                    position.needsUpdate = true;
                }
                var normal = this.attributes.normal;
                if (normal !== undefined) {
                    var normalMatrix = new $c702e238df7c5123$export$8ff26dafa08918().getNormalMatrix(matrix);
                    normal.applyNormalMatrix(normalMatrix);
                    normal.needsUpdate = true;
                }
                var tangent = this.attributes.tangent;
                if (tangent !== undefined) {
                    tangent.transformDirection(matrix);
                    tangent.needsUpdate = true;
                }
                if (this.boundingBox !== null) this.computeBoundingBox();
                if (this.boundingSphere !== null) this.computeBoundingSphere();
                return this;
            }
        },
        {
            key: "applyQuaternion",
            value: function applyQuaternion(q) {
                $c702e238df7c5123$var$_m1.makeRotationFromQuaternion(q);
                this.applyMatrix4($c702e238df7c5123$var$_m1);
                return this;
            }
        },
        {
            key: "rotateX",
            value: function rotateX(angle) {
                // rotate geometry around world x-axis
                $c702e238df7c5123$var$_m1.makeRotationX(angle);
                this.applyMatrix4($c702e238df7c5123$var$_m1);
                return this;
            }
        },
        {
            key: "rotateY",
            value: function rotateY(angle) {
                // rotate geometry around world y-axis
                $c702e238df7c5123$var$_m1.makeRotationY(angle);
                this.applyMatrix4($c702e238df7c5123$var$_m1);
                return this;
            }
        },
        {
            key: "rotateZ",
            value: function rotateZ(angle) {
                // rotate geometry around world z-axis
                $c702e238df7c5123$var$_m1.makeRotationZ(angle);
                this.applyMatrix4($c702e238df7c5123$var$_m1);
                return this;
            }
        },
        {
            key: "translate",
            value: function translate(x, y, z) {
                // translate geometry
                $c702e238df7c5123$var$_m1.makeTranslation(x, y, z);
                this.applyMatrix4($c702e238df7c5123$var$_m1);
                return this;
            }
        },
        {
            key: "scale",
            value: function scale(x, y, z) {
                // scale geometry
                $c702e238df7c5123$var$_m1.makeScale(x, y, z);
                this.applyMatrix4($c702e238df7c5123$var$_m1);
                return this;
            }
        },
        {
            key: "lookAt",
            value: function lookAt(vector) {
                $c702e238df7c5123$var$_obj.lookAt(vector);
                $c702e238df7c5123$var$_obj.updateMatrix();
                this.applyMatrix4($c702e238df7c5123$var$_obj.matrix);
                return this;
            }
        },
        {
            key: "center",
            value: function center() {
                this.computeBoundingBox();
                this.boundingBox.getCenter($c702e238df7c5123$var$_offset).negate();
                this.translate($c702e238df7c5123$var$_offset.x, $c702e238df7c5123$var$_offset.y, $c702e238df7c5123$var$_offset.z);
                return this;
            }
        },
        {
            key: "setFromPoints",
            value: function setFromPoints(points) {
                var position = [];
                for(var i = 0, l = points.length; i < l; i++){
                    var point = points[i];
                    position.push(point.x, point.y, point.z || 0);
                }
                this.setAttribute('position', new $c702e238df7c5123$export$cbe7a62641830ebd(position, 3));
                return this;
            }
        },
        {
            key: "computeBoundingBox",
            value: function computeBoundingBox() {
                if (this.boundingBox === null) this.boundingBox = new $c702e238df7c5123$export$6f7d5a9418ab2aa3();
                var position = this.attributes.position;
                var morphAttributesPosition = this.morphAttributes.position;
                if (position && position.isGLBufferAttribute) {
                    console.error('THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box. Alternatively set "mesh.frustumCulled" to "false".', this);
                    this.boundingBox.set(new $c702e238df7c5123$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity), new $c702e238df7c5123$export$64b5c384219d3699(Infinity, Infinity, Infinity));
                    return;
                }
                if (position !== undefined) {
                    this.boundingBox.setFromBufferAttribute(position);
                    // process morph attributes if present
                    if (morphAttributesPosition) for(var i = 0, il = morphAttributesPosition.length; i < il; i++){
                        var morphAttribute = morphAttributesPosition[i];
                        $c702e238df7c5123$var$_box$1.setFromBufferAttribute(morphAttribute);
                        if (this.morphTargetsRelative) {
                            $c702e238df7c5123$var$_vector$8.addVectors(this.boundingBox.min, $c702e238df7c5123$var$_box$1.min);
                            this.boundingBox.expandByPoint($c702e238df7c5123$var$_vector$8);
                            $c702e238df7c5123$var$_vector$8.addVectors(this.boundingBox.max, $c702e238df7c5123$var$_box$1.max);
                            this.boundingBox.expandByPoint($c702e238df7c5123$var$_vector$8);
                        } else {
                            this.boundingBox.expandByPoint($c702e238df7c5123$var$_box$1.min);
                            this.boundingBox.expandByPoint($c702e238df7c5123$var$_box$1.max);
                        }
                    }
                } else this.boundingBox.makeEmpty();
                if (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
            }
        },
        {
            key: "computeBoundingSphere",
            value: function computeBoundingSphere() {
                if (this.boundingSphere === null) this.boundingSphere = new $c702e238df7c5123$export$805e8b72413ccaba();
                var position = this.attributes.position;
                var morphAttributesPosition = this.morphAttributes.position;
                if (position && position.isGLBufferAttribute) {
                    console.error('THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere. Alternatively set "mesh.frustumCulled" to "false".', this);
                    this.boundingSphere.set(new $c702e238df7c5123$export$64b5c384219d3699(), Infinity);
                    return;
                }
                if (position) {
                    // first, find the center of the bounding sphere
                    var center = this.boundingSphere.center;
                    $c702e238df7c5123$var$_box$1.setFromBufferAttribute(position);
                    // process morph attributes if present
                    if (morphAttributesPosition) for(var i = 0, il = morphAttributesPosition.length; i < il; i++){
                        var morphAttribute = morphAttributesPosition[i];
                        $c702e238df7c5123$var$_boxMorphTargets.setFromBufferAttribute(morphAttribute);
                        if (this.morphTargetsRelative) {
                            $c702e238df7c5123$var$_vector$8.addVectors($c702e238df7c5123$var$_box$1.min, $c702e238df7c5123$var$_boxMorphTargets.min);
                            $c702e238df7c5123$var$_box$1.expandByPoint($c702e238df7c5123$var$_vector$8);
                            $c702e238df7c5123$var$_vector$8.addVectors($c702e238df7c5123$var$_box$1.max, $c702e238df7c5123$var$_boxMorphTargets.max);
                            $c702e238df7c5123$var$_box$1.expandByPoint($c702e238df7c5123$var$_vector$8);
                        } else {
                            $c702e238df7c5123$var$_box$1.expandByPoint($c702e238df7c5123$var$_boxMorphTargets.min);
                            $c702e238df7c5123$var$_box$1.expandByPoint($c702e238df7c5123$var$_boxMorphTargets.max);
                        }
                    }
                    $c702e238df7c5123$var$_box$1.getCenter(center);
                    // second, try to find a boundingSphere with a radius smaller than the
                    // boundingSphere of the boundingBox: sqrt(3) smaller in the best case
                    var maxRadiusSq = 0;
                    for(var i1 = 0, il1 = position.count; i1 < il1; i1++){
                        $c702e238df7c5123$var$_vector$8.fromBufferAttribute(position, i1);
                        maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($c702e238df7c5123$var$_vector$8));
                    }
                    // process morph attributes if present
                    if (morphAttributesPosition) for(var i2 = 0, il2 = morphAttributesPosition.length; i2 < il2; i2++){
                        var morphAttribute1 = morphAttributesPosition[i2];
                        var morphTargetsRelative = this.morphTargetsRelative;
                        for(var j = 0, jl = morphAttribute1.count; j < jl; j++){
                            $c702e238df7c5123$var$_vector$8.fromBufferAttribute(morphAttribute1, j);
                            if (morphTargetsRelative) {
                                $c702e238df7c5123$var$_offset.fromBufferAttribute(position, j);
                                $c702e238df7c5123$var$_vector$8.add($c702e238df7c5123$var$_offset);
                            }
                            maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($c702e238df7c5123$var$_vector$8));
                        }
                    }
                    this.boundingSphere.radius = Math.sqrt(maxRadiusSq);
                    if (isNaN(this.boundingSphere.radius)) console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
                }
            }
        },
        {
            key: "computeFaceNormals",
            value: function computeFaceNormals() {
            // backwards compatibility
            }
        },
        {
            key: "computeTangents",
            value: function computeTangents() {
                var index = this.index;
                var attributes = this.attributes;
                // based on http://www.terathon.com/code/tangent.html
                // (per vertex tangents)
                if (index === null || attributes.position === undefined || attributes.normal === undefined || attributes.uv === undefined) {
                    console.error('THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)');
                    return;
                }
                var indices = index.array;
                var positions = attributes.position.array;
                var normals = attributes.normal.array;
                var uvs = attributes.uv.array;
                var nVertices = positions.length / 3;
                if (attributes.tangent === undefined) this.setAttribute('tangent', new $c702e238df7c5123$export$8dea267bd6bde117(new Float32Array(4 * nVertices), 4));
                var tangents = attributes.tangent.array;
                var tan1 = [], tan2 = [];
                for(var i = 0; i < nVertices; i++){
                    tan1[i] = new $c702e238df7c5123$export$64b5c384219d3699();
                    tan2[i] = new $c702e238df7c5123$export$64b5c384219d3699();
                }
                var vA = new $c702e238df7c5123$export$64b5c384219d3699(), vB = new $c702e238df7c5123$export$64b5c384219d3699(), vC = new $c702e238df7c5123$export$64b5c384219d3699(), uvA = new $c702e238df7c5123$export$c977b3e384af9ae1(), uvB = new $c702e238df7c5123$export$c977b3e384af9ae1(), uvC = new $c702e238df7c5123$export$c977b3e384af9ae1(), sdir = new $c702e238df7c5123$export$64b5c384219d3699(), tdir = new $c702e238df7c5123$export$64b5c384219d3699();
                function handleTriangle(a, b, c) {
                    vA.fromArray(positions, a * 3);
                    vB.fromArray(positions, b * 3);
                    vC.fromArray(positions, c * 3);
                    uvA.fromArray(uvs, a * 2);
                    uvB.fromArray(uvs, b * 2);
                    uvC.fromArray(uvs, c * 2);
                    vB.sub(vA);
                    vC.sub(vA);
                    uvB.sub(uvA);
                    uvC.sub(uvA);
                    var r = 1.0 / (uvB.x * uvC.y - uvC.x * uvB.y);
                    // silently ignore degenerate uv triangles having coincident or colinear vertices
                    if (!isFinite(r)) return;
                    sdir.copy(vB).multiplyScalar(uvC.y).addScaledVector(vC, -uvB.y).multiplyScalar(r);
                    tdir.copy(vC).multiplyScalar(uvB.x).addScaledVector(vB, -uvC.x).multiplyScalar(r);
                    tan1[a].add(sdir);
                    tan1[b].add(sdir);
                    tan1[c].add(sdir);
                    tan2[a].add(tdir);
                    tan2[b].add(tdir);
                    tan2[c].add(tdir);
                }
                var groups = this.groups;
                if (groups.length === 0) groups = [
                    {
                        start: 0,
                        count: indices.length
                    }
                ];
                for(var i1 = 0, il = groups.length; i1 < il; ++i1){
                    var group = groups[i1];
                    var start = group.start;
                    var count = group.count;
                    for(var j = start, jl = start + count; j < jl; j += 3)handleTriangle(indices[j + 0], indices[j + 1], indices[j + 2]);
                }
                var tmp = new $c702e238df7c5123$export$64b5c384219d3699(), tmp2 = new $c702e238df7c5123$export$64b5c384219d3699();
                var n = new $c702e238df7c5123$export$64b5c384219d3699(), n2 = new $c702e238df7c5123$export$64b5c384219d3699();
                function handleVertex(v) {
                    n.fromArray(normals, v * 3);
                    n2.copy(n);
                    var t = tan1[v];
                    // Gram-Schmidt orthogonalize
                    tmp.copy(t);
                    tmp.sub(n.multiplyScalar(n.dot(t))).normalize();
                    // Calculate handedness
                    tmp2.crossVectors(n2, t);
                    var test = tmp2.dot(tan2[v]);
                    var w = test < 0.0 ? -1 : 1.0;
                    tangents[v * 4] = tmp.x;
                    tangents[v * 4 + 1] = tmp.y;
                    tangents[v * 4 + 2] = tmp.z;
                    tangents[v * 4 + 3] = w;
                }
                for(var i2 = 0, il1 = groups.length; i2 < il1; ++i2){
                    var group1 = groups[i2];
                    var start1 = group1.start;
                    var count1 = group1.count;
                    for(var j1 = start1, jl1 = start1 + count1; j1 < jl1; j1 += 3){
                        handleVertex(indices[j1 + 0]);
                        handleVertex(indices[j1 + 1]);
                        handleVertex(indices[j1 + 2]);
                    }
                }
            }
        },
        {
            key: "computeVertexNormals",
            value: function computeVertexNormals() {
                var index = this.index;
                var positionAttribute = this.getAttribute('position');
                if (positionAttribute !== undefined) {
                    var normalAttribute = this.getAttribute('normal');
                    if (normalAttribute === undefined) {
                        normalAttribute = new $c702e238df7c5123$export$8dea267bd6bde117(new Float32Array(positionAttribute.count * 3), 3);
                        this.setAttribute('normal', normalAttribute);
                    } else // reset existing normals to zero
                    for(var i = 0, il = normalAttribute.count; i < il; i++)normalAttribute.setXYZ(i, 0, 0, 0);
                    var pA = new $c702e238df7c5123$export$64b5c384219d3699(), pB = new $c702e238df7c5123$export$64b5c384219d3699(), pC = new $c702e238df7c5123$export$64b5c384219d3699();
                    var nA = new $c702e238df7c5123$export$64b5c384219d3699(), nB = new $c702e238df7c5123$export$64b5c384219d3699(), nC = new $c702e238df7c5123$export$64b5c384219d3699();
                    var cb = new $c702e238df7c5123$export$64b5c384219d3699(), ab = new $c702e238df7c5123$export$64b5c384219d3699();
                    // indexed elements
                    if (index) for(var i1 = 0, il1 = index.count; i1 < il1; i1 += 3){
                        var vA = index.getX(i1 + 0);
                        var vB = index.getX(i1 + 1);
                        var vC = index.getX(i1 + 2);
                        pA.fromBufferAttribute(positionAttribute, vA);
                        pB.fromBufferAttribute(positionAttribute, vB);
                        pC.fromBufferAttribute(positionAttribute, vC);
                        cb.subVectors(pC, pB);
                        ab.subVectors(pA, pB);
                        cb.cross(ab);
                        nA.fromBufferAttribute(normalAttribute, vA);
                        nB.fromBufferAttribute(normalAttribute, vB);
                        nC.fromBufferAttribute(normalAttribute, vC);
                        nA.add(cb);
                        nB.add(cb);
                        nC.add(cb);
                        normalAttribute.setXYZ(vA, nA.x, nA.y, nA.z);
                        normalAttribute.setXYZ(vB, nB.x, nB.y, nB.z);
                        normalAttribute.setXYZ(vC, nC.x, nC.y, nC.z);
                    }
                    else // non-indexed elements (unconnected triangle soup)
                    for(var i2 = 0, il2 = positionAttribute.count; i2 < il2; i2 += 3){
                        pA.fromBufferAttribute(positionAttribute, i2 + 0);
                        pB.fromBufferAttribute(positionAttribute, i2 + 1);
                        pC.fromBufferAttribute(positionAttribute, i2 + 2);
                        cb.subVectors(pC, pB);
                        ab.subVectors(pA, pB);
                        cb.cross(ab);
                        normalAttribute.setXYZ(i2 + 0, cb.x, cb.y, cb.z);
                        normalAttribute.setXYZ(i2 + 1, cb.x, cb.y, cb.z);
                        normalAttribute.setXYZ(i2 + 2, cb.x, cb.y, cb.z);
                    }
                    this.normalizeNormals();
                    normalAttribute.needsUpdate = true;
                }
            }
        },
        {
            key: "merge",
            value: function merge(geometry, offset) {
                if (!(geometry && geometry.isBufferGeometry)) {
                    console.error('THREE.BufferGeometry.merge(): geometry not an instance of THREE.BufferGeometry.', geometry);
                    return;
                }
                if (offset === undefined) {
                    offset = 0;
                    console.warn("THREE.BufferGeometry.merge(): Overwriting original geometry, starting at offset=0. Use BufferGeometryUtils.mergeBufferGeometries() for lossless merge.");
                }
                var attributes = this.attributes;
                for(var key in attributes){
                    if (geometry.attributes[key] === undefined) continue;
                    var attribute1 = attributes[key];
                    var attributeArray1 = attribute1.array;
                    var attribute2 = geometry.attributes[key];
                    var attributeArray2 = attribute2.array;
                    var attributeOffset = attribute2.itemSize * offset;
                    var length = Math.min(attributeArray2.length, attributeArray1.length - attributeOffset);
                    for(var i = 0, j = attributeOffset; i < length; i++, j++)attributeArray1[j] = attributeArray2[i];
                }
                return this;
            }
        },
        {
            key: "normalizeNormals",
            value: function normalizeNormals() {
                var normals = this.attributes.normal;
                for(var i = 0, il = normals.count; i < il; i++){
                    $c702e238df7c5123$var$_vector$8.fromBufferAttribute(normals, i);
                    $c702e238df7c5123$var$_vector$8.normalize();
                    normals.setXYZ(i, $c702e238df7c5123$var$_vector$8.x, $c702e238df7c5123$var$_vector$8.y, $c702e238df7c5123$var$_vector$8.z);
                }
            }
        },
        {
            key: "toNonIndexed",
            value: function toNonIndexed() {
                function convertBufferAttribute(attribute, indices) {
                    var array = attribute.array;
                    var itemSize = attribute.itemSize;
                    var normalized = attribute.normalized;
                    var array2 = new array.constructor(indices.length * itemSize);
                    var index = 0, index2 = 0;
                    for(var i = 0, l = indices.length; i < l; i++){
                        if (attribute.isInterleavedBufferAttribute) index = indices[i] * attribute.data.stride + attribute.offset;
                        else index = indices[i] * itemSize;
                        for(var j = 0; j < itemSize; j++)array2[index2++] = array[index++];
                    }
                    return new $c702e238df7c5123$export$8dea267bd6bde117(array2, itemSize, normalized);
                }
                //
                if (this.index === null) {
                    console.warn('THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.');
                    return this;
                }
                var geometry2 = new BufferGeometry();
                var indices = this.index.array;
                var attributes = this.attributes;
                // attributes
                for(var name in attributes){
                    var attribute = attributes[name];
                    var newAttribute = convertBufferAttribute(attribute, indices);
                    geometry2.setAttribute(name, newAttribute);
                }
                // morph attributes
                var morphAttributes = this.morphAttributes;
                for(var name1 in morphAttributes){
                    var morphArray = [];
                    var morphAttribute = morphAttributes[name1]; // morphAttribute: array of Float32BufferAttributes
                    for(var i = 0, il = morphAttribute.length; i < il; i++){
                        var attribute1 = morphAttribute[i];
                        var newAttribute1 = convertBufferAttribute(attribute1, indices);
                        morphArray.push(newAttribute1);
                    }
                    geometry2.morphAttributes[name1] = morphArray;
                }
                geometry2.morphTargetsRelative = this.morphTargetsRelative;
                // groups
                var groups = this.groups;
                for(var i1 = 0, l = groups.length; i1 < l; i1++){
                    var group = groups[i1];
                    geometry2.addGroup(group.start, group.count, group.materialIndex);
                }
                return geometry2;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = {
                    metadata: {
                        version: 4.5,
                        type: 'BufferGeometry',
                        generator: 'BufferGeometry.toJSON'
                    }
                };
                // standard BufferGeometry serialization
                data.uuid = this.uuid;
                data.type = this.type;
                if (this.name !== '') data.name = this.name;
                if (Object.keys(this.userData).length > 0) data.userData = this.userData;
                if (this.parameters !== undefined) {
                    var parameters = this.parameters;
                    for(var key in parameters)if (parameters[key] !== undefined) data[key] = parameters[key];
                    return data;
                }
                // for simplicity the code assumes attributes are not shared across geometries, see #15811
                data.data = {
                    attributes: {}
                };
                var index = this.index;
                if (index !== null) data.data.index = {
                    type: index.array.constructor.name,
                    array: Array.prototype.slice.call(index.array)
                };
                var attributes = this.attributes;
                for(var key1 in attributes){
                    var attribute = attributes[key1];
                    data.data.attributes[key1] = attribute.toJSON(data.data);
                }
                var morphAttributes = {};
                var hasMorphAttributes = false;
                for(var key2 in this.morphAttributes){
                    var attributeArray = this.morphAttributes[key2];
                    var array = [];
                    for(var i = 0, il = attributeArray.length; i < il; i++){
                        var attribute1 = attributeArray[i];
                        array.push(attribute1.toJSON(data.data));
                    }
                    if (array.length > 0) {
                        morphAttributes[key2] = array;
                        hasMorphAttributes = true;
                    }
                }
                if (hasMorphAttributes) {
                    data.data.morphAttributes = morphAttributes;
                    data.data.morphTargetsRelative = this.morphTargetsRelative;
                }
                var groups = this.groups;
                if (groups.length > 0) data.data.groups = JSON.parse(JSON.stringify(groups));
                var boundingSphere = this.boundingSphere;
                if (boundingSphere !== null) data.data.boundingSphere = {
                    center: boundingSphere.center.toArray(),
                    radius: boundingSphere.radius
                };
                return data;
            }
        },
        {
            key: "clone",
            value: function clone() {
                /*
		 // Handle primitives

		 const parameters = this.parameters;

		 if ( parameters !== undefined ) {

		 const values = [];

		 for ( const key in parameters ) {

		 values.push( parameters[ key ] );

		 }

		 const geometry = Object.create( this.constructor.prototype );
		 this.constructor.apply( geometry, values );
		 return geometry;

		 }

		 return new this.constructor().copy( this );
		 */ return new BufferGeometry().copy(this);
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                // reset
                this.index = null;
                this.attributes = {};
                this.morphAttributes = {};
                this.groups = [];
                this.boundingBox = null;
                this.boundingSphere = null;
                // used for storing cloned, shared data
                var data = {};
                // name
                this.name = source.name;
                // index
                var index = source.index;
                if (index !== null) this.setIndex(index.clone(data));
                // attributes
                var attributes = source.attributes;
                for(var name in attributes){
                    var attribute = attributes[name];
                    this.setAttribute(name, attribute.clone(data));
                }
                // morph attributes
                var morphAttributes = source.morphAttributes;
                for(var name1 in morphAttributes){
                    var array = [];
                    var morphAttribute = morphAttributes[name1]; // morphAttribute: array of Float32BufferAttributes
                    for(var i = 0, l = morphAttribute.length; i < l; i++)array.push(morphAttribute[i].clone(data));
                    this.morphAttributes[name1] = array;
                }
                this.morphTargetsRelative = source.morphTargetsRelative;
                // groups
                var groups = source.groups;
                for(var i1 = 0, l1 = groups.length; i1 < l1; i1++){
                    var group = groups[i1];
                    this.addGroup(group.start, group.count, group.materialIndex);
                }
                // bounding box
                var boundingBox = source.boundingBox;
                if (boundingBox !== null) this.boundingBox = boundingBox.clone();
                // bounding sphere
                var boundingSphere = source.boundingSphere;
                if (boundingSphere !== null) this.boundingSphere = boundingSphere.clone();
                // draw range
                this.drawRange.start = source.drawRange.start;
                this.drawRange.count = source.drawRange.count;
                // user data
                this.userData = source.userData;
                return this;
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this.dispatchEvent({
                    type: 'dispose'
                });
            }
        }
    ]);
    return BufferGeometry;
}($c702e238df7c5123$export$ec8b666c5fe2c75a);
$c702e238df7c5123$export$b7be63a67df8959.prototype.isBufferGeometry = true;
var $c702e238df7c5123$var$_inverseMatrix$2 = /*@__PURE__*/ new $c702e238df7c5123$export$2ae72fc923e5eb5();
var $c702e238df7c5123$var$_ray$2 = /*@__PURE__*/ new $c702e238df7c5123$export$a186db52eed6d40e();
var $c702e238df7c5123$var$_sphere$3 = /*@__PURE__*/ new $c702e238df7c5123$export$805e8b72413ccaba();
var $c702e238df7c5123$var$_vA$1 = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_vB$1 = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_vC$1 = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_tempA = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_tempB = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_tempC = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_morphA = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_morphB = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_morphC = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_uvA$1 = /*@__PURE__*/ new $c702e238df7c5123$export$c977b3e384af9ae1();
var $c702e238df7c5123$var$_uvB$1 = /*@__PURE__*/ new $c702e238df7c5123$export$c977b3e384af9ae1();
var $c702e238df7c5123$var$_uvC$1 = /*@__PURE__*/ new $c702e238df7c5123$export$c977b3e384af9ae1();
var $c702e238df7c5123$var$_intersectionPoint = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_intersectionPointWorld = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$export$e176487c05830cc5 = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(Mesh, Object3D);
    function Mesh() {
        var geometry = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $c702e238df7c5123$export$b7be63a67df8959(), material = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $c702e238df7c5123$export$55cbcc9b622fe1f5();
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Mesh);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, Mesh);
        _this.type = 'Mesh';
        _this.geometry = geometry;
        _this.material = material;
        _this.updateMorphTargets();
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(Mesh, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(Mesh.prototype), "copy", this).call(this, source);
                if (source.morphTargetInfluences !== undefined) this.morphTargetInfluences = source.morphTargetInfluences.slice();
                if (source.morphTargetDictionary !== undefined) this.morphTargetDictionary = Object.assign({}, source.morphTargetDictionary);
                this.material = source.material;
                this.geometry = source.geometry;
                return this;
            }
        },
        {
            key: "updateMorphTargets",
            value: function updateMorphTargets() {
                var geometry = this.geometry;
                if (geometry.isBufferGeometry) {
                    var morphAttributes = geometry.morphAttributes;
                    var keys = Object.keys(morphAttributes);
                    if (keys.length > 0) {
                        var morphAttribute = morphAttributes[keys[0]];
                        if (morphAttribute !== undefined) {
                            this.morphTargetInfluences = [];
                            this.morphTargetDictionary = {};
                            for(var m = 0, ml = morphAttribute.length; m < ml; m++){
                                var name = morphAttribute[m].name || String(m);
                                this.morphTargetInfluences.push(0);
                                this.morphTargetDictionary[name] = m;
                            }
                        }
                    }
                } else {
                    var morphTargets = geometry.morphTargets;
                    if (morphTargets !== undefined && morphTargets.length > 0) console.error('THREE.Mesh.updateMorphTargets() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.');
                }
            }
        },
        {
            key: "raycast",
            value: function raycast(raycaster, intersects) {
                var geometry = this.geometry;
                var material = this.material;
                var matrixWorld = this.matrixWorld;
                if (material === undefined) return;
                // Checking boundingSphere distance to ray
                if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
                $c702e238df7c5123$var$_sphere$3.copy(geometry.boundingSphere);
                $c702e238df7c5123$var$_sphere$3.applyMatrix4(matrixWorld);
                if (raycaster.ray.intersectsSphere($c702e238df7c5123$var$_sphere$3) === false) return;
                //
                $c702e238df7c5123$var$_inverseMatrix$2.copy(matrixWorld).invert();
                $c702e238df7c5123$var$_ray$2.copy(raycaster.ray).applyMatrix4($c702e238df7c5123$var$_inverseMatrix$2);
                // Check boundingBox before continuing
                if (geometry.boundingBox !== null) {
                    if ($c702e238df7c5123$var$_ray$2.intersectsBox(geometry.boundingBox) === false) return;
                }
                var intersection;
                if (geometry.isBufferGeometry) {
                    var index = geometry.index;
                    var position = geometry.attributes.position;
                    var morphPosition = geometry.morphAttributes.position;
                    var morphTargetsRelative = geometry.morphTargetsRelative;
                    var uv = geometry.attributes.uv;
                    var uv2 = geometry.attributes.uv2;
                    var groups = geometry.groups;
                    var drawRange = geometry.drawRange;
                    if (index !== null) {
                        // indexed buffer geometry
                        if (Array.isArray(material)) for(var i = 0, il = groups.length; i < il; i++){
                            var group = groups[i];
                            var groupMaterial = material[group.materialIndex];
                            var start = Math.max(group.start, drawRange.start);
                            var end = Math.min(group.start + group.count, drawRange.start + drawRange.count);
                            for(var j = start, jl = end; j < jl; j += 3){
                                var a = index.getX(j);
                                var b = index.getX(j + 1);
                                var c = index.getX(j + 2);
                                intersection = $c702e238df7c5123$var$checkBufferGeometryIntersection(this, groupMaterial, raycaster, $c702e238df7c5123$var$_ray$2, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c);
                                if (intersection) {
                                    intersection.faceIndex = Math.floor(j / 3); // triangle number in indexed buffer semantics
                                    intersection.face.materialIndex = group.materialIndex;
                                    intersects.push(intersection);
                                }
                            }
                        }
                        else {
                            var start1 = Math.max(0, drawRange.start);
                            var end1 = Math.min(index.count, drawRange.start + drawRange.count);
                            for(var i1 = start1, il1 = end1; i1 < il1; i1 += 3){
                                var a1 = index.getX(i1);
                                var b1 = index.getX(i1 + 1);
                                var c1 = index.getX(i1 + 2);
                                intersection = $c702e238df7c5123$var$checkBufferGeometryIntersection(this, material, raycaster, $c702e238df7c5123$var$_ray$2, position, morphPosition, morphTargetsRelative, uv, uv2, a1, b1, c1);
                                if (intersection) {
                                    intersection.faceIndex = Math.floor(i1 / 3); // triangle number in indexed buffer semantics
                                    intersects.push(intersection);
                                }
                            }
                        }
                    } else if (position !== undefined) {
                        // non-indexed buffer geometry
                        if (Array.isArray(material)) for(var i2 = 0, il2 = groups.length; i2 < il2; i2++){
                            var group1 = groups[i2];
                            var groupMaterial1 = material[group1.materialIndex];
                            var start2 = Math.max(group1.start, drawRange.start);
                            var end2 = Math.min(group1.start + group1.count, drawRange.start + drawRange.count);
                            for(var j1 = start2, jl1 = end2; j1 < jl1; j1 += 3){
                                var a2 = j1;
                                var b2 = j1 + 1;
                                var c2 = j1 + 2;
                                intersection = $c702e238df7c5123$var$checkBufferGeometryIntersection(this, groupMaterial1, raycaster, $c702e238df7c5123$var$_ray$2, position, morphPosition, morphTargetsRelative, uv, uv2, a2, b2, c2);
                                if (intersection) {
                                    intersection.faceIndex = Math.floor(j1 / 3); // triangle number in non-indexed buffer semantics
                                    intersection.face.materialIndex = group1.materialIndex;
                                    intersects.push(intersection);
                                }
                            }
                        }
                        else {
                            var start3 = Math.max(0, drawRange.start);
                            var end3 = Math.min(position.count, drawRange.start + drawRange.count);
                            for(var i3 = start3, il3 = end3; i3 < il3; i3 += 3){
                                var a3 = i3;
                                var b3 = i3 + 1;
                                var c3 = i3 + 2;
                                intersection = $c702e238df7c5123$var$checkBufferGeometryIntersection(this, material, raycaster, $c702e238df7c5123$var$_ray$2, position, morphPosition, morphTargetsRelative, uv, uv2, a3, b3, c3);
                                if (intersection) {
                                    intersection.faceIndex = Math.floor(i3 / 3); // triangle number in non-indexed buffer semantics
                                    intersects.push(intersection);
                                }
                            }
                        }
                    }
                } else if (geometry.isGeometry) console.error('THREE.Mesh.raycast() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.');
            }
        }
    ]);
    return Mesh;
}($c702e238df7c5123$export$e4dd07dff30cc924);
$c702e238df7c5123$export$e176487c05830cc5.prototype.isMesh = true;
function $c702e238df7c5123$var$checkIntersection(object, material, raycaster, ray, pA, pB, pC, point) {
    var intersect;
    if (material.side === $c702e238df7c5123$export$d9f0486e75b5ace) intersect = ray.intersectTriangle(pC, pB, pA, true, point);
    else intersect = ray.intersectTriangle(pA, pB, pC, material.side !== $c702e238df7c5123$export$3b296b6f144d5b03, point);
    if (intersect === null) return null;
    $c702e238df7c5123$var$_intersectionPointWorld.copy(point);
    $c702e238df7c5123$var$_intersectionPointWorld.applyMatrix4(object.matrixWorld);
    var distance = raycaster.ray.origin.distanceTo($c702e238df7c5123$var$_intersectionPointWorld);
    if (distance < raycaster.near || distance > raycaster.far) return null;
    return {
        distance: distance,
        point: $c702e238df7c5123$var$_intersectionPointWorld.clone(),
        object: object
    };
}
function $c702e238df7c5123$var$checkBufferGeometryIntersection(object, material, raycaster, ray, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c) {
    $c702e238df7c5123$var$_vA$1.fromBufferAttribute(position, a);
    $c702e238df7c5123$var$_vB$1.fromBufferAttribute(position, b);
    $c702e238df7c5123$var$_vC$1.fromBufferAttribute(position, c);
    var morphInfluences = object.morphTargetInfluences;
    if (material.morphTargets && morphPosition && morphInfluences) {
        $c702e238df7c5123$var$_morphA.set(0, 0, 0);
        $c702e238df7c5123$var$_morphB.set(0, 0, 0);
        $c702e238df7c5123$var$_morphC.set(0, 0, 0);
        for(var i = 0, il = morphPosition.length; i < il; i++){
            var influence = morphInfluences[i];
            var morphAttribute = morphPosition[i];
            if (influence === 0) continue;
            $c702e238df7c5123$var$_tempA.fromBufferAttribute(morphAttribute, a);
            $c702e238df7c5123$var$_tempB.fromBufferAttribute(morphAttribute, b);
            $c702e238df7c5123$var$_tempC.fromBufferAttribute(morphAttribute, c);
            if (morphTargetsRelative) {
                $c702e238df7c5123$var$_morphA.addScaledVector($c702e238df7c5123$var$_tempA, influence);
                $c702e238df7c5123$var$_morphB.addScaledVector($c702e238df7c5123$var$_tempB, influence);
                $c702e238df7c5123$var$_morphC.addScaledVector($c702e238df7c5123$var$_tempC, influence);
            } else {
                $c702e238df7c5123$var$_morphA.addScaledVector($c702e238df7c5123$var$_tempA.sub($c702e238df7c5123$var$_vA$1), influence);
                $c702e238df7c5123$var$_morphB.addScaledVector($c702e238df7c5123$var$_tempB.sub($c702e238df7c5123$var$_vB$1), influence);
                $c702e238df7c5123$var$_morphC.addScaledVector($c702e238df7c5123$var$_tempC.sub($c702e238df7c5123$var$_vC$1), influence);
            }
        }
        $c702e238df7c5123$var$_vA$1.add($c702e238df7c5123$var$_morphA);
        $c702e238df7c5123$var$_vB$1.add($c702e238df7c5123$var$_morphB);
        $c702e238df7c5123$var$_vC$1.add($c702e238df7c5123$var$_morphC);
    }
    if (object.isSkinnedMesh) {
        object.boneTransform(a, $c702e238df7c5123$var$_vA$1);
        object.boneTransform(b, $c702e238df7c5123$var$_vB$1);
        object.boneTransform(c, $c702e238df7c5123$var$_vC$1);
    }
    var intersection = $c702e238df7c5123$var$checkIntersection(object, material, raycaster, ray, $c702e238df7c5123$var$_vA$1, $c702e238df7c5123$var$_vB$1, $c702e238df7c5123$var$_vC$1, $c702e238df7c5123$var$_intersectionPoint);
    if (intersection) {
        if (uv) {
            $c702e238df7c5123$var$_uvA$1.fromBufferAttribute(uv, a);
            $c702e238df7c5123$var$_uvB$1.fromBufferAttribute(uv, b);
            $c702e238df7c5123$var$_uvC$1.fromBufferAttribute(uv, c);
            intersection.uv = $c702e238df7c5123$export$5a465592bfe74b48.getUV($c702e238df7c5123$var$_intersectionPoint, $c702e238df7c5123$var$_vA$1, $c702e238df7c5123$var$_vB$1, $c702e238df7c5123$var$_vC$1, $c702e238df7c5123$var$_uvA$1, $c702e238df7c5123$var$_uvB$1, $c702e238df7c5123$var$_uvC$1, new $c702e238df7c5123$export$c977b3e384af9ae1());
        }
        if (uv2) {
            $c702e238df7c5123$var$_uvA$1.fromBufferAttribute(uv2, a);
            $c702e238df7c5123$var$_uvB$1.fromBufferAttribute(uv2, b);
            $c702e238df7c5123$var$_uvC$1.fromBufferAttribute(uv2, c);
            intersection.uv2 = $c702e238df7c5123$export$5a465592bfe74b48.getUV($c702e238df7c5123$var$_intersectionPoint, $c702e238df7c5123$var$_vA$1, $c702e238df7c5123$var$_vB$1, $c702e238df7c5123$var$_vC$1, $c702e238df7c5123$var$_uvA$1, $c702e238df7c5123$var$_uvB$1, $c702e238df7c5123$var$_uvC$1, new $c702e238df7c5123$export$c977b3e384af9ae1());
        }
        var face = {
            a: a,
            b: b,
            c: c,
            normal: new $c702e238df7c5123$export$64b5c384219d3699(),
            materialIndex: 0
        };
        $c702e238df7c5123$export$5a465592bfe74b48.getNormal($c702e238df7c5123$var$_vA$1, $c702e238df7c5123$var$_vB$1, $c702e238df7c5123$var$_vC$1, face.normal);
        intersection.face = face;
    }
    return intersection;
}
var $c702e238df7c5123$export$ab3456a079aa7d80 = /*#__PURE__*/ function(BufferGeometry) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(BoxGeometry, BufferGeometry);
    function BoxGeometry() {
        var width = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, height = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, depth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, widthSegments = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1, heightSegments = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 1, depthSegments = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 1;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, BoxGeometry);
        var _this;
        var buildPlane = function buildPlane(u, v, w, udir, vdir, width, height, depth, gridX, gridY, materialIndex) {
            var segmentWidth = width / gridX;
            var segmentHeight = height / gridY;
            var widthHalf = width / 2;
            var heightHalf = height / 2;
            var depthHalf = depth / 2;
            var gridX1 = gridX + 1;
            var gridY1 = gridY + 1;
            var vertexCounter = 0;
            var groupCount = 0;
            var vector = new $c702e238df7c5123$export$64b5c384219d3699();
            // generate vertices, normals and uvs
            for(var iy = 0; iy < gridY1; iy++){
                var y = iy * segmentHeight - heightHalf;
                for(var ix = 0; ix < gridX1; ix++){
                    var x = ix * segmentWidth - widthHalf;
                    // set values to correct vector component
                    vector[u] = x * udir;
                    vector[v] = y * vdir;
                    vector[w] = depthHalf;
                    // now apply vector to vertex buffer
                    vertices.push(vector.x, vector.y, vector.z);
                    // set values to correct vector component
                    vector[u] = 0;
                    vector[v] = 0;
                    vector[w] = depth > 0 ? 1 : -1;
                    // now apply vector to normal buffer
                    normals.push(vector.x, vector.y, vector.z);
                    // uvs
                    uvs.push(ix / gridX);
                    uvs.push(1 - iy / gridY);
                    // counters
                    vertexCounter += 1;
                }
            }
            // indices
            // 1. you need three indices to draw a single face
            // 2. a single segment consists of two faces
            // 3. so we need to generate six (2*3) indices per segment
            for(var iy1 = 0; iy1 < gridY; iy1++)for(var ix1 = 0; ix1 < gridX; ix1++){
                var a = numberOfVertices + ix1 + gridX1 * iy1;
                var b = numberOfVertices + ix1 + gridX1 * (iy1 + 1);
                var c = numberOfVertices + (ix1 + 1) + gridX1 * (iy1 + 1);
                var d = numberOfVertices + (ix1 + 1) + gridX1 * iy1;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // increase counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, materialIndex);
            // calculate new start value for groups
            groupStart += groupCount;
            // update total number of vertices
            numberOfVertices += vertexCounter;
        };
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, BoxGeometry);
        _this.type = 'BoxGeometry';
        _this.parameters = {
            width: width,
            height: height,
            depth: depth,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            depthSegments: depthSegments
        };
        var scope = _this;
        // segments
        widthSegments = Math.floor(widthSegments);
        heightSegments = Math.floor(heightSegments);
        depthSegments = Math.floor(depthSegments);
        // buffers
        var indices = [];
        var vertices = [];
        var normals = [];
        var uvs = [];
        // helper variables
        var numberOfVertices = 0;
        var groupStart = 0;
        // build each side of the box geometry
        buildPlane('z', 'y', 'x', -1, -1, depth, height, width, depthSegments, heightSegments, 0); // px
        buildPlane('z', 'y', 'x', 1, -1, depth, height, -width, depthSegments, heightSegments, 1); // nx
        buildPlane('x', 'z', 'y', 1, 1, width, depth, height, widthSegments, depthSegments, 2); // py
        buildPlane('x', 'z', 'y', 1, -1, width, depth, -height, widthSegments, depthSegments, 3); // ny
        buildPlane('x', 'y', 'z', 1, -1, width, height, depth, widthSegments, heightSegments, 4); // pz
        buildPlane('x', 'y', 'z', -1, -1, width, height, -depth, widthSegments, heightSegments, 5); // nz
        // build geometry
        _this.setIndex(indices);
        _this.setAttribute('position', new $c702e238df7c5123$export$cbe7a62641830ebd(vertices, 3));
        _this.setAttribute('normal', new $c702e238df7c5123$export$cbe7a62641830ebd(normals, 3));
        _this.setAttribute('uv', new $c702e238df7c5123$export$cbe7a62641830ebd(uvs, 2));
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(BoxGeometry, null, [
        {
            key: "fromJSON",
            value: function fromJSON(data) {
                return new BoxGeometry(data.width, data.height, data.depth, data.widthSegments, data.heightSegments, data.depthSegments);
            }
        }
    ]);
    return BoxGeometry;
}($c702e238df7c5123$export$b7be63a67df8959);
/**
 * Uniform Utilities
 */ function $c702e238df7c5123$var$cloneUniforms(src) {
    var dst = {};
    for(var u in src){
        dst[u] = {};
        for(var p in src[u]){
            var property = src[u][p];
            if (property && (property.isColor || property.isMatrix3 || property.isMatrix4 || property.isVector2 || property.isVector3 || property.isVector4 || property.isTexture || property.isQuaternion)) dst[u][p] = property.clone();
            else if (Array.isArray(property)) dst[u][p] = property.slice();
            else dst[u][p] = property;
        }
    }
    return dst;
}
function $c702e238df7c5123$var$mergeUniforms(uniforms) {
    var merged = {};
    for(var u = 0; u < uniforms.length; u++){
        var tmp = $c702e238df7c5123$var$cloneUniforms(uniforms[u]);
        for(var p in tmp)merged[p] = tmp[p];
    }
    return merged;
}
// Legacy
var $c702e238df7c5123$export$d8ecdf8615bfea69 = {
    clone: $c702e238df7c5123$var$cloneUniforms,
    merge: $c702e238df7c5123$var$mergeUniforms
};
var $c702e238df7c5123$var$default_vertex = "void main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}";
var $c702e238df7c5123$var$default_fragment = "void main() {\n\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}";
/**
 * parameters = {
 *  defines: { "label" : "value" },
 *  uniforms: { "parameter1": { value: 1.0 }, "parameter2": { value2: 2 } },
 *
 *  fragmentShader: <string>,
 *  vertexShader: <string>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 *  lights: <bool>,
 *
 *  morphTargets: <bool>,
 *  morphNormals: <bool>
 * }
 */ var $c702e238df7c5123$export$83c7d75d550a8b0d = /*#__PURE__*/ function(Material) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(ShaderMaterial, Material);
    function ShaderMaterial(parameters) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, ShaderMaterial);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, ShaderMaterial);
        _this.type = 'ShaderMaterial';
        _this.defines = {};
        _this.uniforms = {};
        _this.vertexShader = $c702e238df7c5123$var$default_vertex;
        _this.fragmentShader = $c702e238df7c5123$var$default_fragment;
        _this.linewidth = 1;
        _this.wireframe = false;
        _this.wireframeLinewidth = 1;
        _this.fog = false; // set to use scene fog
        _this.lights = false; // set to use scene lights
        _this.clipping = false; // set to use user-defined clipping planes
        _this.morphTargets = false; // set to use morph targets
        _this.morphNormals = false; // set to use morph normals
        _this.extensions = {
            derivatives: false,
            fragDepth: false,
            drawBuffers: false,
            shaderTextureLOD: false // set to use shader texture LOD
        };
        // When rendered geometry doesn't include these attributes but the material does,
        // use these default values in WebGL. This avoids errors when buffer data is missing.
        _this.defaultAttributeValues = {
            color: [
                1,
                1,
                1
            ],
            uv: [
                0,
                0
            ],
            uv2: [
                0,
                0
            ]
        };
        _this.index0AttributeName = undefined;
        _this.uniformsNeedUpdate = false;
        _this.glslVersion = null;
        if (parameters !== undefined) {
            if (parameters.attributes !== undefined) console.error('THREE.ShaderMaterial: attributes should now be defined in THREE.BufferGeometry instead.');
            _this.setValues(parameters);
        }
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(ShaderMaterial, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(ShaderMaterial.prototype), "copy", this).call(this, source);
                this.fragmentShader = source.fragmentShader;
                this.vertexShader = source.vertexShader;
                this.uniforms = $c702e238df7c5123$var$cloneUniforms(source.uniforms);
                this.defines = Object.assign({}, source.defines);
                this.wireframe = source.wireframe;
                this.wireframeLinewidth = source.wireframeLinewidth;
                this.lights = source.lights;
                this.clipping = source.clipping;
                this.morphTargets = source.morphTargets;
                this.morphNormals = source.morphNormals;
                this.extensions = Object.assign({}, source.extensions);
                this.glslVersion = source.glslVersion;
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON(meta) {
                var data = (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(ShaderMaterial.prototype), "toJSON", this).call(this, meta);
                data.glslVersion = this.glslVersion;
                data.uniforms = {};
                for(var name in this.uniforms){
                    var uniform = this.uniforms[name];
                    var value = uniform.value;
                    if (value && value.isTexture) data.uniforms[name] = {
                        type: 't',
                        value: value.toJSON(meta).uuid
                    };
                    else if (value && value.isColor) data.uniforms[name] = {
                        type: 'c',
                        value: value.getHex()
                    };
                    else if (value && value.isVector2) data.uniforms[name] = {
                        type: 'v2',
                        value: value.toArray()
                    };
                    else if (value && value.isVector3) data.uniforms[name] = {
                        type: 'v3',
                        value: value.toArray()
                    };
                    else if (value && value.isVector4) data.uniforms[name] = {
                        type: 'v4',
                        value: value.toArray()
                    };
                    else if (value && value.isMatrix3) data.uniforms[name] = {
                        type: 'm3',
                        value: value.toArray()
                    };
                    else if (value && value.isMatrix4) data.uniforms[name] = {
                        type: 'm4',
                        value: value.toArray()
                    };
                    else data.uniforms[name] = {
                        value: value
                    };
                }
                if (Object.keys(this.defines).length > 0) data.defines = this.defines;
                data.vertexShader = this.vertexShader;
                data.fragmentShader = this.fragmentShader;
                var extensions = {};
                for(var key in this.extensions)if (this.extensions[key] === true) extensions[key] = true;
                if (Object.keys(extensions).length > 0) data.extensions = extensions;
                return data;
            }
        }
    ]);
    return ShaderMaterial;
}($c702e238df7c5123$export$a2d8b23205c25948);
$c702e238df7c5123$export$83c7d75d550a8b0d.prototype.isShaderMaterial = true;
var $c702e238df7c5123$export$79f141de891a5fed = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(Camera, Object3D);
    function Camera() {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Camera);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, Camera);
        _this.type = 'Camera';
        _this.matrixWorldInverse = new $c702e238df7c5123$export$2ae72fc923e5eb5();
        _this.projectionMatrix = new $c702e238df7c5123$export$2ae72fc923e5eb5();
        _this.projectionMatrixInverse = new $c702e238df7c5123$export$2ae72fc923e5eb5();
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(Camera, [
        {
            key: "copy",
            value: function copy(source, recursive) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(Camera.prototype), "copy", this).call(this, source, recursive);
                this.matrixWorldInverse.copy(source.matrixWorldInverse);
                this.projectionMatrix.copy(source.projectionMatrix);
                this.projectionMatrixInverse.copy(source.projectionMatrixInverse);
                return this;
            }
        },
        {
            key: "getWorldDirection",
            value: function getWorldDirection(target) {
                this.updateWorldMatrix(true, false);
                var e = this.matrixWorld.elements;
                return target.set(-e[8], -e[9], -e[10]).normalize();
            }
        },
        {
            key: "updateMatrixWorld",
            value: function updateMatrixWorld(force) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(Camera.prototype), "updateMatrixWorld", this).call(this, force);
                this.matrixWorldInverse.copy(this.matrixWorld).invert();
            }
        },
        {
            key: "updateWorldMatrix",
            value: function updateWorldMatrix(updateParents, updateChildren) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(Camera.prototype), "updateWorldMatrix", this).call(this, updateParents, updateChildren);
                this.matrixWorldInverse.copy(this.matrixWorld).invert();
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        }
    ]);
    return Camera;
}($c702e238df7c5123$export$e4dd07dff30cc924);
$c702e238df7c5123$export$79f141de891a5fed.prototype.isCamera = true;
var $c702e238df7c5123$export$74e4ae24825f68d7 = /*#__PURE__*/ function(Camera) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(PerspectiveCamera, Camera);
    function PerspectiveCamera() {
        var fov = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 50, aspect = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, near = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0.1, far = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 2000;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, PerspectiveCamera);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, PerspectiveCamera);
        _this.type = 'PerspectiveCamera';
        _this.fov = fov;
        _this.zoom = 1;
        _this.near = near;
        _this.far = far;
        _this.focus = 10;
        _this.aspect = aspect;
        _this.view = null;
        _this.filmGauge = 35; // width of the film (default in millimeters)
        _this.filmOffset = 0; // horizontal film offset (same unit as gauge)
        _this.updateProjectionMatrix();
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(PerspectiveCamera, [
        {
            key: "copy",
            value: function copy(source, recursive) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(PerspectiveCamera.prototype), "copy", this).call(this, source, recursive);
                this.fov = source.fov;
                this.zoom = source.zoom;
                this.near = source.near;
                this.far = source.far;
                this.focus = source.focus;
                this.aspect = source.aspect;
                this.view = source.view === null ? null : Object.assign({}, source.view);
                this.filmGauge = source.filmGauge;
                this.filmOffset = source.filmOffset;
                return this;
            }
        },
        {
            /**
	 * Sets the FOV by focal length in respect to the current .filmGauge.
	 *
	 * The default film gauge is 35, so that the focal length can be specified for
	 * a 35mm (full frame) camera.
	 *
	 * Values for focal length and film gauge must have the same unit.
	 */ key: "setFocalLength",
            value: function setFocalLength(focalLength) {
                /** see {@link http://www.bobatkins.com/photography/technical/field_of_view.html} */ var vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;
                this.fov = $c702e238df7c5123$var$RAD2DEG * 2 * Math.atan(vExtentSlope);
                this.updateProjectionMatrix();
            }
        },
        {
            /**
	 * Calculates the focal length from the current .fov and .filmGauge.
	 */ key: "getFocalLength",
            value: function getFocalLength() {
                var vExtentSlope = Math.tan($c702e238df7c5123$var$DEG2RAD * 0.5 * this.fov);
                return 0.5 * this.getFilmHeight() / vExtentSlope;
            }
        },
        {
            key: "getEffectiveFOV",
            value: function getEffectiveFOV() {
                return $c702e238df7c5123$var$RAD2DEG * 2 * Math.atan(Math.tan($c702e238df7c5123$var$DEG2RAD * 0.5 * this.fov) / this.zoom);
            }
        },
        {
            key: "getFilmWidth",
            value: function getFilmWidth() {
                // film not completely covered in portrait format (aspect < 1)
                return this.filmGauge * Math.min(this.aspect, 1);
            }
        },
        {
            key: "getFilmHeight",
            value: function getFilmHeight() {
                // film not completely covered in landscape format (aspect > 1)
                return this.filmGauge / Math.max(this.aspect, 1);
            }
        },
        {
            /**
	 * Sets an offset in a larger frustum. This is useful for multi-window or
	 * multi-monitor/multi-machine setups.
	 *
	 * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
	 * the monitors are in grid like this
	 *
	 *   +---+---+---+
	 *   | A | B | C |
	 *   +---+---+---+
	 *   | D | E | F |
	 *   +---+---+---+
	 *
	 * then for each monitor you would call it like this
	 *
	 *   const w = 1920;
	 *   const h = 1080;
	 *   const fullWidth = w * 3;
	 *   const fullHeight = h * 2;
	 *
	 *   --A--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
	 *   --B--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
	 *   --C--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
	 *   --D--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
	 *   --E--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
	 *   --F--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
	 *
	 *   Note there is no reason monitors have to be the same size or in a grid.
	 */ key: "setViewOffset",
            value: function setViewOffset(fullWidth, fullHeight, x, y, width, height) {
                this.aspect = fullWidth / fullHeight;
                if (this.view === null) this.view = {
                    enabled: true,
                    fullWidth: 1,
                    fullHeight: 1,
                    offsetX: 0,
                    offsetY: 0,
                    width: 1,
                    height: 1
                };
                this.view.enabled = true;
                this.view.fullWidth = fullWidth;
                this.view.fullHeight = fullHeight;
                this.view.offsetX = x;
                this.view.offsetY = y;
                this.view.width = width;
                this.view.height = height;
                this.updateProjectionMatrix();
            }
        },
        {
            key: "clearViewOffset",
            value: function clearViewOffset() {
                if (this.view !== null) this.view.enabled = false;
                this.updateProjectionMatrix();
            }
        },
        {
            key: "updateProjectionMatrix",
            value: function updateProjectionMatrix() {
                var near = this.near;
                var top = near * Math.tan($c702e238df7c5123$var$DEG2RAD * 0.5 * this.fov) / this.zoom;
                var height = 2 * top;
                var width = this.aspect * height;
                var left = -0.5 * width;
                var view = this.view;
                if (this.view !== null && this.view.enabled) {
                    var fullWidth = view.fullWidth, fullHeight = view.fullHeight;
                    left += view.offsetX * width / fullWidth;
                    top -= view.offsetY * height / fullHeight;
                    width *= view.width / fullWidth;
                    height *= view.height / fullHeight;
                }
                var skew = this.filmOffset;
                if (skew !== 0) left += near * skew / this.getFilmWidth();
                this.projectionMatrix.makePerspective(left, left + width, top, top - height, near, this.far);
                this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
            }
        },
        {
            key: "toJSON",
            value: function toJSON(meta) {
                var data = (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(PerspectiveCamera.prototype), "toJSON", this).call(this, meta);
                data.object.fov = this.fov;
                data.object.zoom = this.zoom;
                data.object.near = this.near;
                data.object.far = this.far;
                data.object.focus = this.focus;
                data.object.aspect = this.aspect;
                if (this.view !== null) data.object.view = Object.assign({}, this.view);
                data.object.filmGauge = this.filmGauge;
                data.object.filmOffset = this.filmOffset;
                return data;
            }
        }
    ]);
    return PerspectiveCamera;
}($c702e238df7c5123$export$79f141de891a5fed);
$c702e238df7c5123$export$74e4ae24825f68d7.prototype.isPerspectiveCamera = true;
var $c702e238df7c5123$var$fov = 90, $c702e238df7c5123$var$aspect = 1;
var $c702e238df7c5123$export$d0cdd0bd804995de = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(CubeCamera, Object3D);
    function CubeCamera(near, far, renderTarget) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, CubeCamera);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, CubeCamera);
        _this.type = 'CubeCamera';
        if (renderTarget.isWebGLCubeRenderTarget !== true) {
            console.error('THREE.CubeCamera: The constructor now expects an instance of WebGLCubeRenderTarget as third parameter.');
            return (0, $aa137087616882c2$export$71511d61b312f219)(_this);
        }
        _this.renderTarget = renderTarget;
        var cameraPX = new $c702e238df7c5123$export$74e4ae24825f68d7($c702e238df7c5123$var$fov, $c702e238df7c5123$var$aspect, near, far);
        cameraPX.layers = _this.layers;
        cameraPX.up.set(0, -1, 0);
        cameraPX.lookAt(new $c702e238df7c5123$export$64b5c384219d3699(1, 0, 0));
        _this.add(cameraPX);
        var cameraNX = new $c702e238df7c5123$export$74e4ae24825f68d7($c702e238df7c5123$var$fov, $c702e238df7c5123$var$aspect, near, far);
        cameraNX.layers = _this.layers;
        cameraNX.up.set(0, -1, 0);
        cameraNX.lookAt(new $c702e238df7c5123$export$64b5c384219d3699(-1, 0, 0));
        _this.add(cameraNX);
        var cameraPY = new $c702e238df7c5123$export$74e4ae24825f68d7($c702e238df7c5123$var$fov, $c702e238df7c5123$var$aspect, near, far);
        cameraPY.layers = _this.layers;
        cameraPY.up.set(0, 0, 1);
        cameraPY.lookAt(new $c702e238df7c5123$export$64b5c384219d3699(0, 1, 0));
        _this.add(cameraPY);
        var cameraNY = new $c702e238df7c5123$export$74e4ae24825f68d7($c702e238df7c5123$var$fov, $c702e238df7c5123$var$aspect, near, far);
        cameraNY.layers = _this.layers;
        cameraNY.up.set(0, 0, -1);
        cameraNY.lookAt(new $c702e238df7c5123$export$64b5c384219d3699(0, -1, 0));
        _this.add(cameraNY);
        var cameraPZ = new $c702e238df7c5123$export$74e4ae24825f68d7($c702e238df7c5123$var$fov, $c702e238df7c5123$var$aspect, near, far);
        cameraPZ.layers = _this.layers;
        cameraPZ.up.set(0, -1, 0);
        cameraPZ.lookAt(new $c702e238df7c5123$export$64b5c384219d3699(0, 0, 1));
        _this.add(cameraPZ);
        var cameraNZ = new $c702e238df7c5123$export$74e4ae24825f68d7($c702e238df7c5123$var$fov, $c702e238df7c5123$var$aspect, near, far);
        cameraNZ.layers = _this.layers;
        cameraNZ.up.set(0, -1, 0);
        cameraNZ.lookAt(new $c702e238df7c5123$export$64b5c384219d3699(0, 0, -1));
        _this.add(cameraNZ);
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(CubeCamera, [
        {
            key: "update",
            value: function update(renderer, scene) {
                if (this.parent === null) this.updateMatrixWorld();
                var renderTarget = this.renderTarget;
                var _this_children = (0, $de8f2615c12e293b$export$71511d61b312f219)(this.children, 6), cameraPX = _this_children[0], cameraNX = _this_children[1], cameraPY = _this_children[2], cameraNY = _this_children[3], cameraPZ = _this_children[4], cameraNZ = _this_children[5];
                var currentXrEnabled = renderer.xr.enabled;
                var currentRenderTarget = renderer.getRenderTarget();
                renderer.xr.enabled = false;
                var generateMipmaps = renderTarget.texture.generateMipmaps;
                renderTarget.texture.generateMipmaps = false;
                renderer.setRenderTarget(renderTarget, 0);
                renderer.render(scene, cameraPX);
                renderer.setRenderTarget(renderTarget, 1);
                renderer.render(scene, cameraNX);
                renderer.setRenderTarget(renderTarget, 2);
                renderer.render(scene, cameraPY);
                renderer.setRenderTarget(renderTarget, 3);
                renderer.render(scene, cameraNY);
                renderer.setRenderTarget(renderTarget, 4);
                renderer.render(scene, cameraPZ);
                renderTarget.texture.generateMipmaps = generateMipmaps;
                renderer.setRenderTarget(renderTarget, 5);
                renderer.render(scene, cameraNZ);
                renderer.setRenderTarget(currentRenderTarget);
                renderer.xr.enabled = currentXrEnabled;
            }
        }
    ]);
    return CubeCamera;
}($c702e238df7c5123$export$e4dd07dff30cc924);
var $c702e238df7c5123$export$ee2e5a18258a4049 = /*#__PURE__*/ function(Texture) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(CubeTexture, Texture);
    function CubeTexture(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, CubeTexture);
        var _this;
        images = images !== undefined ? images : [];
        mapping = mapping !== undefined ? mapping : $c702e238df7c5123$export$8759762a6477f2c4;
        format = format !== undefined ? format : $c702e238df7c5123$export$7c67423a5ee6f5eb;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, CubeTexture, [
            images,
            mapping,
            wrapS,
            wrapT,
            magFilter,
            minFilter,
            format,
            type,
            anisotropy,
            encoding
        ]);
        // Why CubeTexture._needsFlipEnvMap is necessary:
        //
        // By convention -- likely based on the RenderMan spec from the 1990's -- cube maps are specified by WebGL (and three.js)
        // in a coordinate system in which positive-x is to the right when looking up the positive-z axis -- in other words,
        // in a left-handed coordinate system. By continuing this convention, preexisting cube maps continued to render correctly.
        // three.js uses a right-handed coordinate system. So environment maps used in three.js appear to have px and nx swapped
        // and the flag _needsFlipEnvMap controls this conversion. The flip is not required (and thus _needsFlipEnvMap is set to false)
        // when using WebGLCubeRenderTarget.texture as a cube texture.
        _this._needsFlipEnvMap = true;
        _this.flipY = false;
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(CubeTexture, [
        {
            key: "images",
            get: function get() {
                return this.image;
            },
            set: function set(value) {
                this.image = value;
            }
        }
    ]);
    return CubeTexture;
}($c702e238df7c5123$export$5431306cf43de24a);
$c702e238df7c5123$export$ee2e5a18258a4049.prototype.isCubeTexture = true;
var $c702e238df7c5123$export$ac386671d651941e = /*#__PURE__*/ function(WebGLRenderTarget) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(WebGLCubeRenderTarget, WebGLRenderTarget);
    function WebGLCubeRenderTarget(size, options, dummy) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, WebGLCubeRenderTarget);
        var _this;
        if (Number.isInteger(options)) {
            console.warn('THREE.WebGLCubeRenderTarget: constructor signature is now WebGLCubeRenderTarget( size, options )');
            options = dummy;
        }
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, WebGLCubeRenderTarget, [
            size,
            size,
            options
        ]);
        options = options || {};
        _this.texture = new $c702e238df7c5123$export$ee2e5a18258a4049(undefined, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.encoding);
        _this.texture.generateMipmaps = options.generateMipmaps !== undefined ? options.generateMipmaps : false;
        _this.texture.minFilter = options.minFilter !== undefined ? options.minFilter : $c702e238df7c5123$export$8a72f490b25c56c8;
        _this.texture._needsFlipEnvMap = false;
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(WebGLCubeRenderTarget, [
        {
            key: "fromEquirectangularTexture",
            value: function fromEquirectangularTexture(renderer, texture) {
                this.texture.type = texture.type;
                this.texture.format = $c702e238df7c5123$export$3f8bb04b555a363c; // see #18859
                this.texture.encoding = texture.encoding;
                this.texture.generateMipmaps = texture.generateMipmaps;
                this.texture.minFilter = texture.minFilter;
                this.texture.magFilter = texture.magFilter;
                var shader = {
                    uniforms: {
                        tEquirect: {
                            value: null
                        }
                    },
                    vertexShader: "\n\n				varying vec3 vWorldDirection;\n\n				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\n					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n\n				}\n\n				void main() {\n\n					vWorldDirection = transformDirection( position, modelMatrix );\n\n					#include <begin_vertex>\n					#include <project_vertex>\n\n				}\n			",
                    fragmentShader: "\n\n				uniform sampler2D tEquirect;\n\n				varying vec3 vWorldDirection;\n\n				#include <common>\n\n				void main() {\n\n					vec3 direction = normalize( vWorldDirection );\n\n					vec2 sampleUV = equirectUv( direction );\n\n					gl_FragColor = texture2D( tEquirect, sampleUV );\n\n				}\n			"
                };
                var geometry = new $c702e238df7c5123$export$ab3456a079aa7d80(5, 5, 5);
                var material = new $c702e238df7c5123$export$83c7d75d550a8b0d({
                    name: 'CubemapFromEquirect',
                    uniforms: $c702e238df7c5123$var$cloneUniforms(shader.uniforms),
                    vertexShader: shader.vertexShader,
                    fragmentShader: shader.fragmentShader,
                    side: $c702e238df7c5123$export$d9f0486e75b5ace,
                    blending: $c702e238df7c5123$export$63b8d6b580fc65ba
                });
                material.uniforms.tEquirect.value = texture;
                var mesh = new $c702e238df7c5123$export$e176487c05830cc5(geometry, material);
                var currentMinFilter = texture.minFilter;
                // Avoid blurred poles
                if (texture.minFilter === $c702e238df7c5123$export$5d8599b6a933fb1b) texture.minFilter = $c702e238df7c5123$export$8a72f490b25c56c8;
                var camera = new $c702e238df7c5123$export$d0cdd0bd804995de(1, 10, this);
                camera.update(renderer, mesh);
                texture.minFilter = currentMinFilter;
                mesh.geometry.dispose();
                mesh.material.dispose();
                return this;
            }
        },
        {
            key: "clear",
            value: function clear(renderer, color, depth, stencil) {
                var currentRenderTarget = renderer.getRenderTarget();
                for(var i = 0; i < 6; i++){
                    renderer.setRenderTarget(this, i);
                    renderer.clear(color, depth, stencil);
                }
                renderer.setRenderTarget(currentRenderTarget);
            }
        }
    ]);
    return WebGLCubeRenderTarget;
}($c702e238df7c5123$export$3c052beb2e51e23f);
$c702e238df7c5123$export$ac386671d651941e.prototype.isWebGLCubeRenderTarget = true;
var $c702e238df7c5123$var$_vector1 = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_vector2 = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_normalMatrix = /*@__PURE__*/ new $c702e238df7c5123$export$8ff26dafa08918();
var $c702e238df7c5123$export$7ff5ac152ef991b0 = /*#__PURE__*/ function() {
    "use strict";
    function Plane() {
        var normal = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $c702e238df7c5123$export$64b5c384219d3699(1, 0, 0), constant = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Plane);
        // normal is assumed to be normalized
        this.normal = normal;
        this.constant = constant;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(Plane, [
        {
            key: "set",
            value: function set(normal, constant) {
                this.normal.copy(normal);
                this.constant = constant;
                return this;
            }
        },
        {
            key: "setComponents",
            value: function setComponents(x, y, z, w) {
                this.normal.set(x, y, z);
                this.constant = w;
                return this;
            }
        },
        {
            key: "setFromNormalAndCoplanarPoint",
            value: function setFromNormalAndCoplanarPoint(normal, point) {
                this.normal.copy(normal);
                this.constant = -point.dot(this.normal);
                return this;
            }
        },
        {
            key: "setFromCoplanarPoints",
            value: function setFromCoplanarPoints(a, b, c) {
                var normal = $c702e238df7c5123$var$_vector1.subVectors(c, b).cross($c702e238df7c5123$var$_vector2.subVectors(a, b)).normalize();
                // Q: should an error be thrown if normal is zero (e.g. degenerate plane)?
                this.setFromNormalAndCoplanarPoint(normal, a);
                return this;
            }
        },
        {
            key: "copy",
            value: function copy(plane) {
                this.normal.copy(plane.normal);
                this.constant = plane.constant;
                return this;
            }
        },
        {
            key: "normalize",
            value: function normalize() {
                // Note: will lead to a divide by zero if the plane is invalid.
                var inverseNormalLength = 1.0 / this.normal.length();
                this.normal.multiplyScalar(inverseNormalLength);
                this.constant *= inverseNormalLength;
                return this;
            }
        },
        {
            key: "negate",
            value: function negate() {
                this.constant *= -1;
                this.normal.negate();
                return this;
            }
        },
        {
            key: "distanceToPoint",
            value: function distanceToPoint(point) {
                return this.normal.dot(point) + this.constant;
            }
        },
        {
            key: "distanceToSphere",
            value: function distanceToSphere(sphere) {
                return this.distanceToPoint(sphere.center) - sphere.radius;
            }
        },
        {
            key: "projectPoint",
            value: function projectPoint(point, target) {
                return target.copy(this.normal).multiplyScalar(-this.distanceToPoint(point)).add(point);
            }
        },
        {
            key: "intersectLine",
            value: function intersectLine(line, target) {
                var direction = line.delta($c702e238df7c5123$var$_vector1);
                var denominator = this.normal.dot(direction);
                if (denominator === 0) {
                    // line is coplanar, return origin
                    if (this.distanceToPoint(line.start) === 0) return target.copy(line.start);
                    // Unsure if this is the correct method to handle this case.
                    return null;
                }
                var t = -(line.start.dot(this.normal) + this.constant) / denominator;
                if (t < 0 || t > 1) return null;
                return target.copy(direction).multiplyScalar(t).add(line.start);
            }
        },
        {
            key: "intersectsLine",
            value: function intersectsLine(line) {
                // Note: this tests if a line intersects the plane, not whether it (or its end-points) are coplanar with it.
                var startSign = this.distanceToPoint(line.start);
                var endSign = this.distanceToPoint(line.end);
                return startSign < 0 && endSign > 0 || endSign < 0 && startSign > 0;
            }
        },
        {
            key: "intersectsBox",
            value: function intersectsBox(box) {
                return box.intersectsPlane(this);
            }
        },
        {
            key: "intersectsSphere",
            value: function intersectsSphere(sphere) {
                return sphere.intersectsPlane(this);
            }
        },
        {
            key: "coplanarPoint",
            value: function coplanarPoint(target) {
                return target.copy(this.normal).multiplyScalar(-this.constant);
            }
        },
        {
            key: "applyMatrix4",
            value: function applyMatrix4(matrix, optionalNormalMatrix) {
                var normalMatrix = optionalNormalMatrix || $c702e238df7c5123$var$_normalMatrix.getNormalMatrix(matrix);
                var referencePoint = this.coplanarPoint($c702e238df7c5123$var$_vector1).applyMatrix4(matrix);
                var normal = this.normal.applyMatrix3(normalMatrix).normalize();
                this.constant = -referencePoint.dot(normal);
                return this;
            }
        },
        {
            key: "translate",
            value: function translate(offset) {
                this.constant -= offset.dot(this.normal);
                return this;
            }
        },
        {
            key: "equals",
            value: function equals(plane) {
                return plane.normal.equals(this.normal) && plane.constant === this.constant;
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        }
    ]);
    return Plane;
}();
$c702e238df7c5123$export$7ff5ac152ef991b0.prototype.isPlane = true;
var $c702e238df7c5123$var$_sphere$2 = /*@__PURE__*/ new $c702e238df7c5123$export$805e8b72413ccaba();
var $c702e238df7c5123$var$_vector$7 = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$export$35efe6f4c85463d2 = /*#__PURE__*/ function() {
    "use strict";
    function Frustum() {
        var p0 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $c702e238df7c5123$export$7ff5ac152ef991b0(), p1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $c702e238df7c5123$export$7ff5ac152ef991b0(), p2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : new $c702e238df7c5123$export$7ff5ac152ef991b0(), p3 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : new $c702e238df7c5123$export$7ff5ac152ef991b0(), p4 = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : new $c702e238df7c5123$export$7ff5ac152ef991b0(), p5 = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : new $c702e238df7c5123$export$7ff5ac152ef991b0();
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Frustum);
        this.planes = [
            p0,
            p1,
            p2,
            p3,
            p4,
            p5
        ];
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(Frustum, [
        {
            key: "set",
            value: function set(p0, p1, p2, p3, p4, p5) {
                var planes = this.planes;
                planes[0].copy(p0);
                planes[1].copy(p1);
                planes[2].copy(p2);
                planes[3].copy(p3);
                planes[4].copy(p4);
                planes[5].copy(p5);
                return this;
            }
        },
        {
            key: "copy",
            value: function copy(frustum) {
                var planes = this.planes;
                for(var i = 0; i < 6; i++)planes[i].copy(frustum.planes[i]);
                return this;
            }
        },
        {
            key: "setFromProjectionMatrix",
            value: function setFromProjectionMatrix(m) {
                var planes = this.planes;
                var me = m.elements;
                var me0 = me[0], me1 = me[1], me2 = me[2], me3 = me[3];
                var me4 = me[4], me5 = me[5], me6 = me[6], me7 = me[7];
                var me8 = me[8], me9 = me[9], me10 = me[10], me11 = me[11];
                var me12 = me[12], me13 = me[13], me14 = me[14], me15 = me[15];
                planes[0].setComponents(me3 - me0, me7 - me4, me11 - me8, me15 - me12).normalize();
                planes[1].setComponents(me3 + me0, me7 + me4, me11 + me8, me15 + me12).normalize();
                planes[2].setComponents(me3 + me1, me7 + me5, me11 + me9, me15 + me13).normalize();
                planes[3].setComponents(me3 - me1, me7 - me5, me11 - me9, me15 - me13).normalize();
                planes[4].setComponents(me3 - me2, me7 - me6, me11 - me10, me15 - me14).normalize();
                planes[5].setComponents(me3 + me2, me7 + me6, me11 + me10, me15 + me14).normalize();
                return this;
            }
        },
        {
            key: "intersectsObject",
            value: function intersectsObject(object) {
                var geometry = object.geometry;
                if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
                $c702e238df7c5123$var$_sphere$2.copy(geometry.boundingSphere).applyMatrix4(object.matrixWorld);
                return this.intersectsSphere($c702e238df7c5123$var$_sphere$2);
            }
        },
        {
            key: "intersectsSprite",
            value: function intersectsSprite(sprite) {
                $c702e238df7c5123$var$_sphere$2.center.set(0, 0, 0);
                $c702e238df7c5123$var$_sphere$2.radius = 0.7071067811865476;
                $c702e238df7c5123$var$_sphere$2.applyMatrix4(sprite.matrixWorld);
                return this.intersectsSphere($c702e238df7c5123$var$_sphere$2);
            }
        },
        {
            key: "intersectsSphere",
            value: function intersectsSphere(sphere) {
                var planes = this.planes;
                var center = sphere.center;
                var negRadius = -sphere.radius;
                for(var i = 0; i < 6; i++){
                    var distance = planes[i].distanceToPoint(center);
                    if (distance < negRadius) return false;
                }
                return true;
            }
        },
        {
            key: "intersectsBox",
            value: function intersectsBox(box) {
                var planes = this.planes;
                for(var i = 0; i < 6; i++){
                    var plane = planes[i];
                    // corner at max distance
                    $c702e238df7c5123$var$_vector$7.x = plane.normal.x > 0 ? box.max.x : box.min.x;
                    $c702e238df7c5123$var$_vector$7.y = plane.normal.y > 0 ? box.max.y : box.min.y;
                    $c702e238df7c5123$var$_vector$7.z = plane.normal.z > 0 ? box.max.z : box.min.z;
                    if (plane.distanceToPoint($c702e238df7c5123$var$_vector$7) < 0) return false;
                }
                return true;
            }
        },
        {
            key: "containsPoint",
            value: function containsPoint(point) {
                var planes = this.planes;
                for(var i = 0; i < 6; i++){
                    if (planes[i].distanceToPoint(point) < 0) return false;
                }
                return true;
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        }
    ]);
    return Frustum;
}();
function $c702e238df7c5123$var$WebGLAnimation() {
    var context = null;
    var isAnimating = false;
    var animationLoop = null;
    var requestId = null;
    function onAnimationFrame(time, frame) {
        animationLoop(time, frame);
        requestId = context.requestAnimationFrame(onAnimationFrame);
    }
    return {
        start: function start() {
            if (isAnimating === true) return;
            if (animationLoop === null) return;
            requestId = context.requestAnimationFrame(onAnimationFrame);
            isAnimating = true;
        },
        stop: function stop() {
            context.cancelAnimationFrame(requestId);
            isAnimating = false;
        },
        setAnimationLoop: function setAnimationLoop(callback) {
            animationLoop = callback;
        },
        setContext: function setContext(value) {
            context = value;
        }
    };
}
function $c702e238df7c5123$var$WebGLAttributes(gl, capabilities) {
    var isWebGL2 = capabilities.isWebGL2;
    var buffers = new WeakMap();
    function createBuffer(attribute, bufferType) {
        var array = attribute.array;
        var usage = attribute.usage;
        var buffer = gl.createBuffer();
        gl.bindBuffer(bufferType, buffer);
        gl.bufferData(bufferType, array, usage);
        attribute.onUploadCallback();
        var type = 5126;
        if (array instanceof Float32Array) type = 5126;
        else if (array instanceof Float64Array) console.warn('THREE.WebGLAttributes: Unsupported data buffer format: Float64Array.');
        else if (array instanceof Uint16Array) {
            if (attribute.isFloat16BufferAttribute) {
                if (isWebGL2) type = 5131;
                else console.warn('THREE.WebGLAttributes: Usage of Float16BufferAttribute requires WebGL2.');
            } else type = 5123;
        } else if (array instanceof Int16Array) type = 5122;
        else if (array instanceof Uint32Array) type = 5125;
        else if (array instanceof Int32Array) type = 5124;
        else if (array instanceof Int8Array) type = 5120;
        else if (array instanceof Uint8Array) type = 5121;
        else if (array instanceof Uint8ClampedArray) type = 5121;
        return {
            buffer: buffer,
            type: type,
            bytesPerElement: array.BYTES_PER_ELEMENT,
            version: attribute.version
        };
    }
    function updateBuffer(buffer, attribute, bufferType) {
        var array = attribute.array;
        var updateRange = attribute.updateRange;
        gl.bindBuffer(bufferType, buffer);
        if (updateRange.count === -1) // Not using update ranges
        gl.bufferSubData(bufferType, 0, array);
        else {
            if (isWebGL2) gl.bufferSubData(bufferType, updateRange.offset * array.BYTES_PER_ELEMENT, array, updateRange.offset, updateRange.count);
            else gl.bufferSubData(bufferType, updateRange.offset * array.BYTES_PER_ELEMENT, array.subarray(updateRange.offset, updateRange.offset + updateRange.count));
            updateRange.count = -1; // reset range
        }
    }
    //
    function get(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        return buffers.get(attribute);
    }
    function remove(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        var data = buffers.get(attribute);
        if (data) {
            gl.deleteBuffer(data.buffer);
            buffers["delete"](attribute);
        }
    }
    function update(attribute, bufferType) {
        if (attribute.isGLBufferAttribute) {
            var cached = buffers.get(attribute);
            if (!cached || cached.version < attribute.version) buffers.set(attribute, {
                buffer: attribute.buffer,
                type: attribute.type,
                bytesPerElement: attribute.elementSize,
                version: attribute.version
            });
            return;
        }
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        var data = buffers.get(attribute);
        if (data === undefined) buffers.set(attribute, createBuffer(attribute, bufferType));
        else if (data.version < attribute.version) {
            updateBuffer(data.buffer, attribute, bufferType);
            data.version = attribute.version;
        }
    }
    return {
        get: get,
        remove: remove,
        update: update
    };
}
var $c702e238df7c5123$export$e789a11a194ca4e0 = /*#__PURE__*/ function(BufferGeometry) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(PlaneGeometry, BufferGeometry);
    function PlaneGeometry() {
        var width = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, height = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, widthSegments = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, heightSegments = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, PlaneGeometry);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, PlaneGeometry);
        _this.type = 'PlaneGeometry';
        _this.parameters = {
            width: width,
            height: height,
            widthSegments: widthSegments,
            heightSegments: heightSegments
        };
        var width_half = width / 2;
        var height_half = height / 2;
        var gridX = Math.floor(widthSegments);
        var gridY = Math.floor(heightSegments);
        var gridX1 = gridX + 1;
        var gridY1 = gridY + 1;
        var segment_width = width / gridX;
        var segment_height = height / gridY;
        //
        var indices = [];
        var vertices = [];
        var normals = [];
        var uvs = [];
        for(var iy = 0; iy < gridY1; iy++){
            var y = iy * segment_height - height_half;
            for(var ix = 0; ix < gridX1; ix++){
                var x = ix * segment_width - width_half;
                vertices.push(x, -y, 0);
                normals.push(0, 0, 1);
                uvs.push(ix / gridX);
                uvs.push(1 - iy / gridY);
            }
        }
        for(var iy1 = 0; iy1 < gridY; iy1++)for(var ix1 = 0; ix1 < gridX; ix1++){
            var a = ix1 + gridX1 * iy1;
            var b = ix1 + gridX1 * (iy1 + 1);
            var c = ix1 + 1 + gridX1 * (iy1 + 1);
            var d = ix1 + 1 + gridX1 * iy1;
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        _this.setIndex(indices);
        _this.setAttribute('position', new $c702e238df7c5123$export$cbe7a62641830ebd(vertices, 3));
        _this.setAttribute('normal', new $c702e238df7c5123$export$cbe7a62641830ebd(normals, 3));
        _this.setAttribute('uv', new $c702e238df7c5123$export$cbe7a62641830ebd(uvs, 2));
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(PlaneGeometry, null, [
        {
            key: "fromJSON",
            value: function fromJSON(data) {
                return new PlaneGeometry(data.width, data.height, data.widthSegments, data.heightSegments);
            }
        }
    ]);
    return PlaneGeometry;
}($c702e238df7c5123$export$b7be63a67df8959);
var $c702e238df7c5123$var$alphamap_fragment = "#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, vUv ).g;\n#endif";
var $c702e238df7c5123$var$alphamap_pars_fragment = "#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";
var $c702e238df7c5123$var$alphatest_fragment = "#ifdef ALPHATEST\n\tif ( diffuseColor.a < ALPHATEST ) discard;\n#endif";
var $c702e238df7c5123$var$aomap_fragment = "#ifdef USE_AOMAP\n\tfloat ambientOcclusion = ( texture2D( aoMap, vUv2 ).r - 1.0 ) * aoMapIntensity + 1.0;\n\treflectedLight.indirectDiffuse *= ambientOcclusion;\n\t#if defined( USE_ENVMAP ) && defined( STANDARD )\n\t\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\t\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.specularRoughness );\n\t#endif\n#endif";
var $c702e238df7c5123$var$aomap_pars_fragment = "#ifdef USE_AOMAP\n\tuniform sampler2D aoMap;\n\tuniform float aoMapIntensity;\n#endif";
var $c702e238df7c5123$var$begin_vertex = "vec3 transformed = vec3( position );";
var $c702e238df7c5123$var$beginnormal_vertex = "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n\tvec3 objectTangent = vec3( tangent.xyz );\n#endif";
var $c702e238df7c5123$var$bsdfs = "vec2 integrateSpecularBRDF( const in float dotNV, const in float roughness ) {\n\tconst vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n\tconst vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n\tvec4 r = roughness * c0 + c1;\n\tfloat a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n\treturn vec2( -1.04, 1.04 ) * a004 + r.zw;\n}\nfloat punctualLightIntensityToIrradianceFactor( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n#if defined ( PHYSICALLY_CORRECT_LIGHTS )\n\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n\tif( cutoffDistance > 0.0 ) {\n\t\tdistanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n\t}\n\treturn distanceFalloff;\n#else\n\tif( cutoffDistance > 0.0 && decayExponent > 0.0 ) {\n\t\treturn pow( saturate( -lightDistance / cutoffDistance + 1.0 ), decayExponent );\n\t}\n\treturn 1.0;\n#endif\n}\nvec3 BRDF_Diffuse_Lambert( const in vec3 diffuseColor ) {\n\treturn RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 specularColor, const in float dotVH ) {\n\tfloat fresnel = exp2( ( -5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn ( 1.0 - specularColor ) * fresnel + specularColor;\n}\nvec3 F_Schlick_RoughnessDependent( const in vec3 F0, const in float dotNV, const in float roughness ) {\n\tfloat fresnel = exp2( ( -5.55473 * dotNV - 6.98316 ) * dotNV );\n\tvec3 Fr = max( vec3( 1.0 - roughness ), F0 ) - F0;\n\treturn Fr * fresnel + F0;\n}\nfloat G_GGX_Smith( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gl = dotNL + sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\tfloat gv = dotNV + sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\treturn 1.0 / ( gl * gv );\n}\nfloat G_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\treturn 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n\tfloat a2 = pow2( alpha );\n\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n\treturn RECIPROCAL_PI * a2 / pow2( denom );\n}\nvec3 BRDF_Specular_GGX( const in IncidentLight incidentLight, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float roughness ) {\n\tfloat alpha = pow2( roughness );\n\tvec3 halfDir = normalize( incidentLight.direction + viewDir );\n\tfloat dotNL = saturate( dot( normal, incidentLight.direction ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotLH = saturate( dot( incidentLight.direction, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, dotLH );\n\tfloat G = G_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\tfloat D = D_GGX( alpha, dotNH );\n\treturn F * ( G * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n\tconst float LUT_SIZE = 64.0;\n\tconst float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n\tconst float LUT_BIAS = 0.5 / LUT_SIZE;\n\tfloat dotNV = saturate( dot( N, V ) );\n\tvec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n\tuv = uv * LUT_SCALE + LUT_BIAS;\n\treturn uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n\tfloat l = length( f );\n\treturn max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n\tfloat x = dot( v1, v2 );\n\tfloat y = abs( x );\n\tfloat a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n\tfloat b = 3.4175940 + ( 4.1616724 + y ) * y;\n\tfloat v = a / b;\n\tfloat theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n\treturn cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n\tvec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n\tvec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n\tvec3 lightNormal = cross( v1, v2 );\n\tif( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n\tvec3 T1, T2;\n\tT1 = normalize( V - N * dot( V, N ) );\n\tT2 = - cross( N, T1 );\n\tmat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n\tvec3 coords[ 4 ];\n\tcoords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n\tcoords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n\tcoords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n\tcoords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n\tcoords[ 0 ] = normalize( coords[ 0 ] );\n\tcoords[ 1 ] = normalize( coords[ 1 ] );\n\tcoords[ 2 ] = normalize( coords[ 2 ] );\n\tcoords[ 3 ] = normalize( coords[ 3 ] );\n\tvec3 vectorFormFactor = vec3( 0.0 );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n\tfloat result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n\treturn vec3( result );\n}\nvec3 BRDF_Specular_GGX_Environment( const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tvec2 brdf = integrateSpecularBRDF( dotNV, roughness );\n\treturn specularColor * brdf.x + brdf.y;\n}\nvoid BRDF_Specular_Multiscattering_Environment( const in GeometricContext geometry, const in vec3 specularColor, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\tvec3 F = F_Schlick_RoughnessDependent( specularColor, dotNV, roughness );\n\tvec2 brdf = integrateSpecularBRDF( dotNV, roughness );\n\tvec3 FssEss = F * brdf.x + brdf.y;\n\tfloat Ess = brdf.x + brdf.y;\n\tfloat Ems = 1.0 - Ess;\n\tvec3 Favg = specularColor + ( 1.0 - specularColor ) * 0.047619;\tvec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n\tsingleScatter += FssEss;\n\tmultiScatter += Fms * Ems;\n}\nfloat G_BlinnPhong_Implicit( ) {\n\treturn 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_Specular_BlinnPhong( const in IncidentLight incidentLight, const in GeometricContext geometry, const in vec3 specularColor, const in float shininess ) {\n\tvec3 halfDir = normalize( incidentLight.direction + geometry.viewDir );\n\tfloat dotNH = saturate( dot( geometry.normal, halfDir ) );\n\tfloat dotLH = saturate( dot( incidentLight.direction, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, dotLH );\n\tfloat G = G_BlinnPhong_Implicit( );\n\tfloat D = D_BlinnPhong( shininess, dotNH );\n\treturn F * ( G * D );\n}\nfloat GGXRoughnessToBlinnExponent( const in float ggxRoughness ) {\n\treturn ( 2.0 / pow2( ggxRoughness + 0.0001 ) - 2.0 );\n}\nfloat BlinnExponentToGGXRoughness( const in float blinnExponent ) {\n\treturn sqrt( 2.0 / ( blinnExponent + 2.0 ) );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie(float roughness, float NoH) {\n\tfloat invAlpha = 1.0 / roughness;\n\tfloat cos2h = NoH * NoH;\n\tfloat sin2h = max(1.0 - cos2h, 0.0078125);\treturn (2.0 + invAlpha) * pow(sin2h, invAlpha * 0.5) / (2.0 * PI);\n}\nfloat V_Neubelt(float NoV, float NoL) {\n\treturn saturate(1.0 / (4.0 * (NoL + NoV - NoL * NoV)));\n}\nvec3 BRDF_Specular_Sheen( const in float roughness, const in vec3 L, const in GeometricContext geometry, vec3 specularColor ) {\n\tvec3 N = geometry.normal;\n\tvec3 V = geometry.viewDir;\n\tvec3 H = normalize( V + L );\n\tfloat dotNH = saturate( dot( N, H ) );\n\treturn specularColor * D_Charlie( roughness, dotNH ) * V_Neubelt( dot(N, V), dot(N, L) );\n}\n#endif";
var $c702e238df7c5123$var$bumpmap_pars_fragment = "#ifdef USE_BUMPMAP\n\tuniform sampler2D bumpMap;\n\tuniform float bumpScale;\n\tvec2 dHdxy_fwd() {\n\t\tvec2 dSTdx = dFdx( vUv );\n\t\tvec2 dSTdy = dFdy( vUv );\n\t\tfloat Hll = bumpScale * texture2D( bumpMap, vUv ).x;\n\t\tfloat dBx = bumpScale * texture2D( bumpMap, vUv + dSTdx ).x - Hll;\n\t\tfloat dBy = bumpScale * texture2D( bumpMap, vUv + dSTdy ).x - Hll;\n\t\treturn vec2( dBx, dBy );\n\t}\n\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n\t\tvec3 vSigmaX = vec3( dFdx( surf_pos.x ), dFdx( surf_pos.y ), dFdx( surf_pos.z ) );\n\t\tvec3 vSigmaY = vec3( dFdy( surf_pos.x ), dFdy( surf_pos.y ), dFdy( surf_pos.z ) );\n\t\tvec3 vN = surf_norm;\n\t\tvec3 R1 = cross( vSigmaY, vN );\n\t\tvec3 R2 = cross( vN, vSigmaX );\n\t\tfloat fDet = dot( vSigmaX, R1 ) * faceDirection;\n\t\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n\t\treturn normalize( abs( fDet ) * surf_norm - vGrad );\n\t}\n#endif";
var $c702e238df7c5123$var$clipping_planes_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvec4 plane;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\tplane = clippingPlanes[ i ];\n\t\tif ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n\t}\n\t#pragma unroll_loop_end\n\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\tbool clipped = true;\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tclipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\tif ( clipped ) discard;\n\t#endif\n#endif";
var $c702e238df7c5123$var$clipping_planes_pars_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif";
var $c702e238df7c5123$var$clipping_planes_pars_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n#endif";
var $c702e238df7c5123$var$clipping_planes_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvClipPosition = - mvPosition.xyz;\n#endif";
var $c702e238df7c5123$var$color_fragment = "#if defined( USE_COLOR_ALPHA )\n\tdiffuseColor *= vColor;\n#elif defined( USE_COLOR )\n\tdiffuseColor.rgb *= vColor;\n#endif";
var $c702e238df7c5123$var$color_pars_fragment = "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR )\n\tvarying vec3 vColor;\n#endif";
var $c702e238df7c5123$var$color_pars_vertex = "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n\tvarying vec3 vColor;\n#endif";
var $c702e238df7c5123$var$color_vertex = "#if defined( USE_COLOR_ALPHA )\n\tvColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n\tvColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n\tvColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n\tvColor.xyz *= instanceColor.xyz;\n#endif";
var $c702e238df7c5123$var$common = "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate(a) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement(a) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat average( const in vec3 color ) { return dot( color, vec3( 0.3333 ) ); }\nhighp float rand( const in vec2 uv ) {\n\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\n\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n\treturn fract(sin(sn) * c);\n}\n#ifdef HIGH_PRECISION\n\tfloat precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n\tfloat max3( vec3 v ) { return max( max( v.x, v.y ), v.z ); }\n\tfloat precisionSafeLength( vec3 v ) {\n\t\tfloat maxComponent = max3( abs( v ) );\n\t\treturn length( v / maxComponent ) * maxComponent;\n\t}\n#endif\nstruct IncidentLight {\n\tvec3 color;\n\tvec3 direction;\n\tbool visible;\n};\nstruct ReflectedLight {\n\tvec3 directDiffuse;\n\tvec3 directSpecular;\n\tvec3 indirectDiffuse;\n\tvec3 indirectSpecular;\n};\nstruct GeometricContext {\n\tvec3 position;\n\tvec3 normal;\n\tvec3 viewDir;\n#ifdef CLEARCOAT\n\tvec3 clearcoatNormal;\n#endif\n};\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nvec3 projectOnPlane(in vec3 point, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\tfloat distance = dot( planeNormal, point - pointOnPlane );\n\treturn - distance * planeNormal + point;\n}\nfloat sideOfPlane( in vec3 point, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\treturn sign( dot( point - pointOnPlane, planeNormal ) );\n}\nvec3 linePlaneIntersect( in vec3 pointOnLine, in vec3 lineDirection, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\treturn lineDirection * ( dot( planeNormal, pointOnPlane - pointOnLine ) / dot( planeNormal, lineDirection ) ) + pointOnLine;\n}\nmat3 transposeMat3( const in mat3 m ) {\n\tmat3 tmp;\n\ttmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n\ttmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n\ttmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n\treturn tmp;\n}\nfloat linearToRelativeLuminance( const in vec3 color ) {\n\tvec3 weights = vec3( 0.2126, 0.7152, 0.0722 );\n\treturn dot( weights, color.rgb );\n}\nbool isPerspectiveMatrix( mat4 m ) {\n\treturn m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n\tfloat u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n\tfloat v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\treturn vec2( u, v );\n}";
var $c702e238df7c5123$var$cube_uv_reflection_fragment = "#ifdef ENVMAP_TYPE_CUBE_UV\n\t#define cubeUV_maxMipLevel 8.0\n\t#define cubeUV_minMipLevel 4.0\n\t#define cubeUV_maxTileSize 256.0\n\t#define cubeUV_minTileSize 16.0\n\tfloat getFace( vec3 direction ) {\n\t\tvec3 absDirection = abs( direction );\n\t\tfloat face = - 1.0;\n\t\tif ( absDirection.x > absDirection.z ) {\n\t\t\tif ( absDirection.x > absDirection.y )\n\t\t\t\tface = direction.x > 0.0 ? 0.0 : 3.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t} else {\n\t\t\tif ( absDirection.z > absDirection.y )\n\t\t\t\tface = direction.z > 0.0 ? 2.0 : 5.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t}\n\t\treturn face;\n\t}\n\tvec2 getUV( vec3 direction, float face ) {\n\t\tvec2 uv;\n\t\tif ( face == 0.0 ) {\n\t\t\tuv = vec2( direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 1.0 ) {\n\t\t\tuv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n\t\t} else if ( face == 2.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.y ) / abs( direction.z );\n\t\t} else if ( face == 3.0 ) {\n\t\t\tuv = vec2( - direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 4.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.z ) / abs( direction.y );\n\t\t} else {\n\t\t\tuv = vec2( direction.x, direction.y ) / abs( direction.z );\n\t\t}\n\t\treturn 0.5 * ( uv + 1.0 );\n\t}\n\tvec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n\t\tfloat face = getFace( direction );\n\t\tfloat filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n\t\tmipInt = max( mipInt, cubeUV_minMipLevel );\n\t\tfloat faceSize = exp2( mipInt );\n\t\tfloat texelSize = 1.0 / ( 3.0 * cubeUV_maxTileSize );\n\t\tvec2 uv = getUV( direction, face ) * ( faceSize - 1.0 );\n\t\tvec2 f = fract( uv );\n\t\tuv += 0.5 - f;\n\t\tif ( face > 2.0 ) {\n\t\t\tuv.y += faceSize;\n\t\t\tface -= 3.0;\n\t\t}\n\t\tuv.x += face * faceSize;\n\t\tif ( mipInt < cubeUV_maxMipLevel ) {\n\t\t\tuv.y += 2.0 * cubeUV_maxTileSize;\n\t\t}\n\t\tuv.y += filterInt * 2.0 * cubeUV_minTileSize;\n\t\tuv.x += 3.0 * max( 0.0, cubeUV_maxTileSize - 2.0 * faceSize );\n\t\tuv *= texelSize;\n\t\tvec3 tl = envMapTexelToLinear( texture2D( envMap, uv ) ).rgb;\n\t\tuv.x += texelSize;\n\t\tvec3 tr = envMapTexelToLinear( texture2D( envMap, uv ) ).rgb;\n\t\tuv.y += texelSize;\n\t\tvec3 br = envMapTexelToLinear( texture2D( envMap, uv ) ).rgb;\n\t\tuv.x -= texelSize;\n\t\tvec3 bl = envMapTexelToLinear( texture2D( envMap, uv ) ).rgb;\n\t\tvec3 tm = mix( tl, tr, f.x );\n\t\tvec3 bm = mix( bl, br, f.x );\n\t\treturn mix( tm, bm, f.y );\n\t}\n\t#define r0 1.0\n\t#define v0 0.339\n\t#define m0 - 2.0\n\t#define r1 0.8\n\t#define v1 0.276\n\t#define m1 - 1.0\n\t#define r4 0.4\n\t#define v4 0.046\n\t#define m4 2.0\n\t#define r5 0.305\n\t#define v5 0.016\n\t#define m5 3.0\n\t#define r6 0.21\n\t#define v6 0.0038\n\t#define m6 4.0\n\tfloat roughnessToMip( float roughness ) {\n\t\tfloat mip = 0.0;\n\t\tif ( roughness >= r1 ) {\n\t\t\tmip = ( r0 - roughness ) * ( m1 - m0 ) / ( r0 - r1 ) + m0;\n\t\t} else if ( roughness >= r4 ) {\n\t\t\tmip = ( r1 - roughness ) * ( m4 - m1 ) / ( r1 - r4 ) + m1;\n\t\t} else if ( roughness >= r5 ) {\n\t\t\tmip = ( r4 - roughness ) * ( m5 - m4 ) / ( r4 - r5 ) + m4;\n\t\t} else if ( roughness >= r6 ) {\n\t\t\tmip = ( r5 - roughness ) * ( m6 - m5 ) / ( r5 - r6 ) + m5;\n\t\t} else {\n\t\t\tmip = - 2.0 * log2( 1.16 * roughness );\t\t}\n\t\treturn mip;\n\t}\n\tvec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n\t\tfloat mip = clamp( roughnessToMip( roughness ), m0, cubeUV_maxMipLevel );\n\t\tfloat mipF = fract( mip );\n\t\tfloat mipInt = floor( mip );\n\t\tvec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n\t\tif ( mipF == 0.0 ) {\n\t\t\treturn vec4( color0, 1.0 );\n\t\t} else {\n\t\t\tvec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n\t\t\treturn vec4( mix( color0, color1, mipF ), 1.0 );\n\t\t}\n\t}\n#endif";
var $c702e238df7c5123$var$defaultnormal_vertex = "vec3 transformedNormal = objectNormal;\n#ifdef USE_INSTANCING\n\tmat3 m = mat3( instanceMatrix );\n\ttransformedNormal /= vec3( dot( m[ 0 ], m[ 0 ] ), dot( m[ 1 ], m[ 1 ] ), dot( m[ 2 ], m[ 2 ] ) );\n\ttransformedNormal = m * transformedNormal;\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n\ttransformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n\tvec3 transformedTangent = ( modelViewMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#ifdef FLIP_SIDED\n\t\ttransformedTangent = - transformedTangent;\n\t#endif\n#endif";
var $c702e238df7c5123$var$displacementmap_pars_vertex = "#ifdef USE_DISPLACEMENTMAP\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n#endif";
var $c702e238df7c5123$var$displacementmap_vertex = "#ifdef USE_DISPLACEMENTMAP\n\ttransformed += normalize( objectNormal ) * ( texture2D( displacementMap, vUv ).x * displacementScale + displacementBias );\n#endif";
var $c702e238df7c5123$var$emissivemap_fragment = "#ifdef USE_EMISSIVEMAP\n\tvec4 emissiveColor = texture2D( emissiveMap, vUv );\n\temissiveColor.rgb = emissiveMapTexelToLinear( emissiveColor ).rgb;\n\ttotalEmissiveRadiance *= emissiveColor.rgb;\n#endif";
var $c702e238df7c5123$var$emissivemap_pars_fragment = "#ifdef USE_EMISSIVEMAP\n\tuniform sampler2D emissiveMap;\n#endif";
var $c702e238df7c5123$var$encodings_fragment = "gl_FragColor = linearToOutputTexel( gl_FragColor );";
var $c702e238df7c5123$var$encodings_pars_fragment = "\nvec4 LinearToLinear( in vec4 value ) {\n\treturn value;\n}\nvec4 GammaToLinear( in vec4 value, in float gammaFactor ) {\n\treturn vec4( pow( value.rgb, vec3( gammaFactor ) ), value.a );\n}\nvec4 LinearToGamma( in vec4 value, in float gammaFactor ) {\n\treturn vec4( pow( value.rgb, vec3( 1.0 / gammaFactor ) ), value.a );\n}\nvec4 sRGBToLinear( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.a );\n}\nvec4 LinearTosRGB( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}\nvec4 RGBEToLinear( in vec4 value ) {\n\treturn vec4( value.rgb * exp2( value.a * 255.0 - 128.0 ), 1.0 );\n}\nvec4 LinearToRGBE( in vec4 value ) {\n\tfloat maxComponent = max( max( value.r, value.g ), value.b );\n\tfloat fExp = clamp( ceil( log2( maxComponent ) ), -128.0, 127.0 );\n\treturn vec4( value.rgb / exp2( fExp ), ( fExp + 128.0 ) / 255.0 );\n}\nvec4 RGBMToLinear( in vec4 value, in float maxRange ) {\n\treturn vec4( value.rgb * value.a * maxRange, 1.0 );\n}\nvec4 LinearToRGBM( in vec4 value, in float maxRange ) {\n\tfloat maxRGB = max( value.r, max( value.g, value.b ) );\n\tfloat M = clamp( maxRGB / maxRange, 0.0, 1.0 );\n\tM = ceil( M * 255.0 ) / 255.0;\n\treturn vec4( value.rgb / ( M * maxRange ), M );\n}\nvec4 RGBDToLinear( in vec4 value, in float maxRange ) {\n\treturn vec4( value.rgb * ( ( maxRange / 255.0 ) / value.a ), 1.0 );\n}\nvec4 LinearToRGBD( in vec4 value, in float maxRange ) {\n\tfloat maxRGB = max( value.r, max( value.g, value.b ) );\n\tfloat D = max( maxRange / maxRGB, 1.0 );\n\tD = clamp( floor( D ) / 255.0, 0.0, 1.0 );\n\treturn vec4( value.rgb * ( D * ( 255.0 / maxRange ) ), D );\n}\nconst mat3 cLogLuvM = mat3( 0.2209, 0.3390, 0.4184, 0.1138, 0.6780, 0.7319, 0.0102, 0.1130, 0.2969 );\nvec4 LinearToLogLuv( in vec4 value ) {\n\tvec3 Xp_Y_XYZp = cLogLuvM * value.rgb;\n\tXp_Y_XYZp = max( Xp_Y_XYZp, vec3( 1e-6, 1e-6, 1e-6 ) );\n\tvec4 vResult;\n\tvResult.xy = Xp_Y_XYZp.xy / Xp_Y_XYZp.z;\n\tfloat Le = 2.0 * log2(Xp_Y_XYZp.y) + 127.0;\n\tvResult.w = fract( Le );\n\tvResult.z = ( Le - ( floor( vResult.w * 255.0 ) ) / 255.0 ) / 255.0;\n\treturn vResult;\n}\nconst mat3 cLogLuvInverseM = mat3( 6.0014, -2.7008, -1.7996, -1.3320, 3.1029, -5.7721, 0.3008, -1.0882, 5.6268 );\nvec4 LogLuvToLinear( in vec4 value ) {\n\tfloat Le = value.z * 255.0 + value.w;\n\tvec3 Xp_Y_XYZp;\n\tXp_Y_XYZp.y = exp2( ( Le - 127.0 ) / 2.0 );\n\tXp_Y_XYZp.z = Xp_Y_XYZp.y / value.y;\n\tXp_Y_XYZp.x = value.x * Xp_Y_XYZp.z;\n\tvec3 vRGB = cLogLuvInverseM * Xp_Y_XYZp.rgb;\n\treturn vec4( max( vRGB, 0.0 ), 1.0 );\n}";
var $c702e238df7c5123$var$envmap_fragment = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvec3 cameraToFrag;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToFrag = normalize( vWorldPosition - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( cameraToFrag, worldNormal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n\t\t#endif\n\t#else\n\t\tvec3 reflectVec = vReflect;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\tvec4 envColor = textureCubeUV( envMap, reflectVec, 0.0 );\n\t#else\n\t\tvec4 envColor = vec4( 0.0 );\n\t#endif\n\t#ifndef ENVMAP_TYPE_CUBE_UV\n\t\tenvColor = envMapTexelToLinear( envColor );\n\t#endif\n\t#ifdef ENVMAP_BLENDING_MULTIPLY\n\t\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_MIX )\n\t\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_ADD )\n\t\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\n\t#endif\n#endif";
var $c702e238df7c5123$var$envmap_common_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float envMapIntensity;\n\tuniform float flipEnvMap;\n\tuniform int maxMipLevel;\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tuniform samplerCube envMap;\n\t#else\n\t\tuniform sampler2D envMap;\n\t#endif\n\t\n#endif";
var $c702e238df7c5123$var$envmap_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float reflectivity;\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\tvarying vec3 vWorldPosition;\n\t\tuniform float refractionRatio;\n\t#else\n\t\tvarying vec3 vReflect;\n\t#endif\n#endif";
var $c702e238df7c5123$var$envmap_pars_vertex = "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) ||defined( PHONG )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\t\n\t\tvarying vec3 vWorldPosition;\n\t#else\n\t\tvarying vec3 vReflect;\n\t\tuniform float refractionRatio;\n\t#endif\n#endif";
var $c702e238df7c5123$var$envmap_vertex = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvWorldPosition = worldPosition.xyz;\n\t#else\n\t\tvec3 cameraToVertex;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvReflect = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#endif\n#endif";
var $c702e238df7c5123$var$fog_vertex = "#ifdef USE_FOG\n\tfogDepth = - mvPosition.z;\n#endif";
var $c702e238df7c5123$var$fog_pars_vertex = "#ifdef USE_FOG\n\tvarying float fogDepth;\n#endif";
var $c702e238df7c5123$var$fog_fragment = "#ifdef USE_FOG\n\t#ifdef FOG_EXP2\n\t\tfloat fogFactor = 1.0 - exp( - fogDensity * fogDensity * fogDepth * fogDepth );\n\t#else\n\t\tfloat fogFactor = smoothstep( fogNear, fogFar, fogDepth );\n\t#endif\n\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif";
var $c702e238df7c5123$var$fog_pars_fragment = "#ifdef USE_FOG\n\tuniform vec3 fogColor;\n\tvarying float fogDepth;\n\t#ifdef FOG_EXP2\n\t\tuniform float fogDensity;\n\t#else\n\t\tuniform float fogNear;\n\t\tuniform float fogFar;\n\t#endif\n#endif";
var $c702e238df7c5123$var$gradientmap_pars_fragment = "#ifdef USE_GRADIENTMAP\n\tuniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n\tfloat dotNL = dot( normal, lightDirection );\n\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n\t#ifdef USE_GRADIENTMAP\n\t\treturn texture2D( gradientMap, coord ).rgb;\n\t#else\n\t\treturn ( coord.x < 0.7 ) ? vec3( 0.7 ) : vec3( 1.0 );\n\t#endif\n}";
var $c702e238df7c5123$var$lightmap_fragment = "#ifdef USE_LIGHTMAP\n\tvec4 lightMapTexel= texture2D( lightMap, vUv2 );\n\treflectedLight.indirectDiffuse += PI * lightMapTexelToLinear( lightMapTexel ).rgb * lightMapIntensity;\n#endif";
var $c702e238df7c5123$var$lightmap_pars_fragment = "#ifdef USE_LIGHTMAP\n\tuniform sampler2D lightMap;\n\tuniform float lightMapIntensity;\n#endif";
var $c702e238df7c5123$var$lights_lambert_vertex = "vec3 diffuse = vec3( 1.0 );\nGeometricContext geometry;\ngeometry.position = mvPosition.xyz;\ngeometry.normal = normalize( transformedNormal );\ngeometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( -mvPosition.xyz );\nGeometricContext backGeometry;\nbackGeometry.position = geometry.position;\nbackGeometry.normal = -geometry.normal;\nbackGeometry.viewDir = geometry.viewDir;\nvLightFront = vec3( 0.0 );\nvIndirectFront = vec3( 0.0 );\n#ifdef DOUBLE_SIDED\n\tvLightBack = vec3( 0.0 );\n\tvIndirectBack = vec3( 0.0 );\n#endif\nIncidentLight directLight;\nfloat dotNL;\nvec3 directLightColor_Diffuse;\nvIndirectFront += getAmbientLightIrradiance( ambientLightColor );\nvIndirectFront += getLightProbeIrradiance( lightProbe, geometry );\n#ifdef DOUBLE_SIDED\n\tvIndirectBack += getAmbientLightIrradiance( ambientLightColor );\n\tvIndirectBack += getLightProbeIrradiance( lightProbe, backGeometry );\n#endif\n#if NUM_POINT_LIGHTS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tgetPointDirectLightIrradiance( pointLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = PI * directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tgetSpotDirectLightIrradiance( spotLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = PI * directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if NUM_DIR_LIGHTS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tgetDirectionalDirectLightIrradiance( directionalLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = PI * directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\tvIndirectFront += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry );\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvIndirectBack += getHemisphereLightIrradiance( hemisphereLights[ i ], backGeometry );\n\t\t#endif\n\t}\n\t#pragma unroll_loop_end\n#endif";
var $c702e238df7c5123$var$lights_pars_begin = "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\nuniform vec3 lightProbe[ 9 ];\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n\tfloat x = normal.x, y = normal.y, z = normal.z;\n\tvec3 result = shCoefficients[ 0 ] * 0.886227;\n\tresult += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n\tresult += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n\tresult += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n\tresult += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n\tresult += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n\tresult += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n\tresult += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n\tresult += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n\treturn result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in GeometricContext geometry ) {\n\tvec3 worldNormal = inverseTransformDirection( geometry.normal, viewMatrix );\n\tvec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n\treturn irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n\tvec3 irradiance = ambientLightColor;\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\treturn irradiance;\n}\n#if NUM_DIR_LIGHTS > 0\n\tstruct DirectionalLight {\n\t\tvec3 direction;\n\t\tvec3 color;\n\t};\n\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n\tvoid getDirectionalDirectLightIrradiance( const in DirectionalLight directionalLight, const in GeometricContext geometry, out IncidentLight directLight ) {\n\t\tdirectLight.color = directionalLight.color;\n\t\tdirectLight.direction = directionalLight.direction;\n\t\tdirectLight.visible = true;\n\t}\n#endif\n#if NUM_POINT_LIGHTS > 0\n\tstruct PointLight {\n\t\tvec3 position;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t};\n\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n\tvoid getPointDirectLightIrradiance( const in PointLight pointLight, const in GeometricContext geometry, out IncidentLight directLight ) {\n\t\tvec3 lVector = pointLight.position - geometry.position;\n\t\tdirectLight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tdirectLight.color = pointLight.color;\n\t\tdirectLight.color *= punctualLightIntensityToIrradianceFactor( lightDistance, pointLight.distance, pointLight.decay );\n\t\tdirectLight.visible = ( directLight.color != vec3( 0.0 ) );\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tstruct SpotLight {\n\t\tvec3 position;\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tfloat coneCos;\n\t\tfloat penumbraCos;\n\t};\n\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n\tvoid getSpotDirectLightIrradiance( const in SpotLight spotLight, const in GeometricContext geometry, out IncidentLight directLight ) {\n\t\tvec3 lVector = spotLight.position - geometry.position;\n\t\tdirectLight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tfloat angleCos = dot( directLight.direction, spotLight.direction );\n\t\tif ( angleCos > spotLight.coneCos ) {\n\t\t\tfloat spotEffect = smoothstep( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n\t\t\tdirectLight.color = spotLight.color;\n\t\t\tdirectLight.color *= spotEffect * punctualLightIntensityToIrradianceFactor( lightDistance, spotLight.distance, spotLight.decay );\n\t\t\tdirectLight.visible = true;\n\t\t} else {\n\t\t\tdirectLight.color = vec3( 0.0 );\n\t\t\tdirectLight.visible = false;\n\t\t}\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tstruct RectAreaLight {\n\t\tvec3 color;\n\t\tvec3 position;\n\t\tvec3 halfWidth;\n\t\tvec3 halfHeight;\n\t};\n\tuniform sampler2D ltc_1;\tuniform sampler2D ltc_2;\n\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tstruct HemisphereLight {\n\t\tvec3 direction;\n\t\tvec3 skyColor;\n\t\tvec3 groundColor;\n\t};\n\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in GeometricContext geometry ) {\n\t\tfloat dotNL = dot( geometry.normal, hemiLight.direction );\n\t\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n\t\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n\t\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\t\tirradiance *= PI;\n\t\t#endif\n\t\treturn irradiance;\n\t}\n#endif";
var $c702e238df7c5123$var$envmap_physical_pars_fragment = "#if defined( USE_ENVMAP )\n\t#ifdef ENVMAP_MODE_REFRACTION\n\t\tuniform float refractionRatio;\n\t#endif\n\tvec3 getLightProbeIndirectIrradiance( const in GeometricContext geometry, const in int maxMIPLevel ) {\n\t\tvec3 worldNormal = inverseTransformDirection( geometry.normal, viewMatrix );\n\t\t#ifdef ENVMAP_TYPE_CUBE\n\t\t\tvec3 queryVec = vec3( flipEnvMap * worldNormal.x, worldNormal.yz );\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = textureCubeLodEXT( envMap, queryVec, float( maxMIPLevel ) );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = textureCube( envMap, queryVec, float( maxMIPLevel ) );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, worldNormal, 1.0 );\n\t\t#else\n\t\t\tvec4 envMapColor = vec4( 0.0 );\n\t\t#endif\n\t\treturn PI * envMapColor.rgb * envMapIntensity;\n\t}\n\tfloat getSpecularMIPLevel( const in float roughness, const in int maxMIPLevel ) {\n\t\tfloat maxMIPLevelScalar = float( maxMIPLevel );\n\t\tfloat sigma = PI * roughness * roughness / ( 1.0 + roughness );\n\t\tfloat desiredMIPLevel = maxMIPLevelScalar + log2( sigma );\n\t\treturn clamp( desiredMIPLevel, 0.0, maxMIPLevelScalar );\n\t}\n\tvec3 getLightProbeIndirectRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in int maxMIPLevel ) {\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( -viewDir, normal );\n\t\t\treflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( -viewDir, normal, refractionRatio );\n\t\t#endif\n\t\treflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n\t\tfloat specularMIPLevel = getSpecularMIPLevel( roughness, maxMIPLevel );\n\t\t#ifdef ENVMAP_TYPE_CUBE\n\t\t\tvec3 queryReflectVec = vec3( flipEnvMap * reflectVec.x, reflectVec.yz );\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = textureCubeLodEXT( envMap, queryReflectVec, specularMIPLevel );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = textureCube( envMap, queryReflectVec, specularMIPLevel );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, reflectVec, roughness );\n\t\t#endif\n\t\treturn envMapColor.rgb * envMapIntensity;\n\t}\n#endif";
var $c702e238df7c5123$var$lights_toon_fragment = "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;";
var $c702e238df7c5123$var$lights_toon_pars_fragment = "varying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\nstruct ToonMaterial {\n\tvec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\tvec3 irradiance = getGradientIrradiance( geometry.normal, directLight.direction ) * directLight.color;\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\treflectedLight.directDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Toon\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Toon\n#define Material_LightProbeLOD( material )\t(0)";
var $c702e238df7c5123$var$lights_phong_fragment = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;";
var $c702e238df7c5123$var$lights_phong_pars_fragment = "varying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\nstruct BlinnPhongMaterial {\n\tvec3 diffuseColor;\n\tvec3 specularColor;\n\tfloat specularShininess;\n\tfloat specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\treflectedLight.directDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n\treflectedLight.directSpecular += irradiance * BRDF_Specular_BlinnPhong( directLight, geometry, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_BlinnPhong\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_BlinnPhong\n#define Material_LightProbeLOD( material )\t(0)";
var $c702e238df7c5123$var$lights_physical_fragment = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( geometryNormal ) ), abs( dFdy( geometryNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.specularRoughness = max( roughnessFactor, 0.0525 );material.specularRoughness += geometryRoughness;\nmaterial.specularRoughness = min( material.specularRoughness, 1.0 );\n#ifdef REFLECTIVITY\n\tmaterial.specularColor = mix( vec3( MAXIMUM_SPECULAR_COEFFICIENT * pow2( reflectivity ) ), diffuseColor.rgb, metalnessFactor );\n#else\n\tmaterial.specularColor = mix( vec3( DEFAULT_SPECULAR_COEFFICIENT ), diffuseColor.rgb, metalnessFactor );\n#endif\n#ifdef CLEARCOAT\n\tmaterial.clearcoat = clearcoat;\n\tmaterial.clearcoatRoughness = clearcoatRoughness;\n\t#ifdef USE_CLEARCOATMAP\n\t\tmaterial.clearcoat *= texture2D( clearcoatMap, vUv ).x;\n\t#endif\n\t#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\t\tmaterial.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vUv ).y;\n\t#endif\n\tmaterial.clearcoat = saturate( material.clearcoat );\tmaterial.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n\tmaterial.clearcoatRoughness += geometryRoughness;\n\tmaterial.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_SHEEN\n\tmaterial.sheenColor = sheen;\n#endif";
var $c702e238df7c5123$var$lights_physical_pars_fragment = "struct PhysicalMaterial {\n\tvec3 diffuseColor;\n\tfloat specularRoughness;\n\tvec3 specularColor;\n#ifdef CLEARCOAT\n\tfloat clearcoat;\n\tfloat clearcoatRoughness;\n#endif\n#ifdef USE_SHEEN\n\tvec3 sheenColor;\n#endif\n};\n#define MAXIMUM_SPECULAR_COEFFICIENT 0.16\n#define DEFAULT_SPECULAR_COEFFICIENT 0.04\nfloat clearcoatDHRApprox( const in float roughness, const in float dotNL ) {\n\treturn DEFAULT_SPECULAR_COEFFICIENT + ( 1.0 - DEFAULT_SPECULAR_COEFFICIENT ) * ( pow( 1.0 - dotNL, 5.0 ) * pow( 1.0 - roughness, 2.0 ) );\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n\tvoid RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t\tvec3 normal = geometry.normal;\n\t\tvec3 viewDir = geometry.viewDir;\n\t\tvec3 position = geometry.position;\n\t\tvec3 lightPos = rectAreaLight.position;\n\t\tvec3 halfWidth = rectAreaLight.halfWidth;\n\t\tvec3 halfHeight = rectAreaLight.halfHeight;\n\t\tvec3 lightColor = rectAreaLight.color;\n\t\tfloat roughness = material.specularRoughness;\n\t\tvec3 rectCoords[ 4 ];\n\t\trectCoords[ 0 ] = lightPos + halfWidth - halfHeight;\t\trectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n\t\trectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n\t\trectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n\t\tvec2 uv = LTC_Uv( normal, viewDir, roughness );\n\t\tvec4 t1 = texture2D( ltc_1, uv );\n\t\tvec4 t2 = texture2D( ltc_2, uv );\n\t\tmat3 mInv = mat3(\n\t\t\tvec3( t1.x, 0, t1.y ),\n\t\t\tvec3(    0, 1,    0 ),\n\t\t\tvec3( t1.z, 0, t1.w )\n\t\t);\n\t\tvec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n\t\treflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n\t\treflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n\t}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\t#ifdef CLEARCOAT\n\t\tfloat ccDotNL = saturate( dot( geometry.clearcoatNormal, directLight.direction ) );\n\t\tvec3 ccIrradiance = ccDotNL * directLight.color;\n\t\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\t\tccIrradiance *= PI;\n\t\t#endif\n\t\tfloat clearcoatDHR = material.clearcoat * clearcoatDHRApprox( material.clearcoatRoughness, ccDotNL );\n\t\treflectedLight.directSpecular += ccIrradiance * material.clearcoat * BRDF_Specular_GGX( directLight, geometry.viewDir, geometry.clearcoatNormal, vec3( DEFAULT_SPECULAR_COEFFICIENT ), material.clearcoatRoughness );\n\t#else\n\t\tfloat clearcoatDHR = 0.0;\n\t#endif\n\t#ifdef USE_SHEEN\n\t\treflectedLight.directSpecular += ( 1.0 - clearcoatDHR ) * irradiance * BRDF_Specular_Sheen(\n\t\t\tmaterial.specularRoughness,\n\t\t\tdirectLight.direction,\n\t\t\tgeometry,\n\t\t\tmaterial.sheenColor\n\t\t);\n\t#else\n\t\treflectedLight.directSpecular += ( 1.0 - clearcoatDHR ) * irradiance * BRDF_Specular_GGX( directLight, geometry.viewDir, geometry.normal, material.specularColor, material.specularRoughness);\n\t#endif\n\treflectedLight.directDiffuse += ( 1.0 - clearcoatDHR ) * irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n\t#ifdef CLEARCOAT\n\t\tfloat ccDotNV = saturate( dot( geometry.clearcoatNormal, geometry.viewDir ) );\n\t\treflectedLight.indirectSpecular += clearcoatRadiance * material.clearcoat * BRDF_Specular_GGX_Environment( geometry.viewDir, geometry.clearcoatNormal, vec3( DEFAULT_SPECULAR_COEFFICIENT ), material.clearcoatRoughness );\n\t\tfloat ccDotNL = ccDotNV;\n\t\tfloat clearcoatDHR = material.clearcoat * clearcoatDHRApprox( material.clearcoatRoughness, ccDotNL );\n\t#else\n\t\tfloat clearcoatDHR = 0.0;\n\t#endif\n\tfloat clearcoatInv = 1.0 - clearcoatDHR;\n\tvec3 singleScattering = vec3( 0.0 );\n\tvec3 multiScattering = vec3( 0.0 );\n\tvec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n\tBRDF_Specular_Multiscattering_Environment( geometry, material.specularColor, material.specularRoughness, singleScattering, multiScattering );\n\tvec3 diffuse = material.diffuseColor * ( 1.0 - ( singleScattering + multiScattering ) );\n\treflectedLight.indirectSpecular += clearcoatInv * radiance * singleScattering;\n\treflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n\treflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct\t\t\t\tRE_Direct_Physical\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular\t\tRE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}";
var $c702e238df7c5123$var$lights_fragment_begin = "\nGeometricContext geometry;\ngeometry.position = - vViewPosition;\ngeometry.normal = normal;\ngeometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\n#ifdef CLEARCOAT\n\tgeometry.clearcoatNormal = clearcoatNormal;\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n\tPointLight pointLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tgetPointDirectLightIrradiance( pointLight, geometry, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n\t\tpointLightShadow = pointLightShadows[ i ];\n\t\tdirectLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n\tSpotLight spotLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tgetSpotDirectLightIrradiance( spotLight, geometry, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\tspotLightShadow = spotLightShadows[ i ];\n\t\tdirectLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n\tDirectionalLight directionalLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tgetDirectionalDirectLightIrradiance( directionalLight, geometry, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n\t\tdirectionalLightShadow = directionalLightShadows[ i ];\n\t\tdirectLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n\tRectAreaLight rectAreaLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t\trectAreaLight = rectAreaLights[ i ];\n\t\tRE_Direct_RectArea( rectAreaLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n\tvec3 iblIrradiance = vec3( 0.0 );\n\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n\tirradiance += getLightProbeIrradiance( lightProbe, geometry );\n\t#if ( NUM_HEMI_LIGHTS > 0 )\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\t\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry );\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if defined( RE_IndirectSpecular )\n\tvec3 radiance = vec3( 0.0 );\n\tvec3 clearcoatRadiance = vec3( 0.0 );\n#endif";
var $c702e238df7c5123$var$lights_fragment_maps = "#if defined( RE_IndirectDiffuse )\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel= texture2D( lightMap, vUv2 );\n\t\tvec3 lightMapIrradiance = lightMapTexelToLinear( lightMapTexel ).rgb * lightMapIntensity;\n\t\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\t\tlightMapIrradiance *= PI;\n\t\t#endif\n\t\tirradiance += lightMapIrradiance;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n\t\tiblIrradiance += getLightProbeIndirectIrradiance( geometry, maxMipLevel );\n\t#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n\tradiance += getLightProbeIndirectRadiance( geometry.viewDir, geometry.normal, material.specularRoughness, maxMipLevel );\n\t#ifdef CLEARCOAT\n\t\tclearcoatRadiance += getLightProbeIndirectRadiance( geometry.viewDir, geometry.clearcoatNormal, material.clearcoatRoughness, maxMipLevel );\n\t#endif\n#endif";
var $c702e238df7c5123$var$lights_fragment_end = "#if defined( RE_IndirectDiffuse )\n\tRE_IndirectDiffuse( irradiance, geometry, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n\tRE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometry, material, reflectedLight );\n#endif";
var $c702e238df7c5123$var$logdepthbuf_fragment = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n\tgl_FragDepthEXT = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif";
var $c702e238df7c5123$var$logdepthbuf_pars_fragment = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n\tuniform float logDepthBufFC;\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif";
var $c702e238df7c5123$var$logdepthbuf_pars_vertex = "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvarying float vFragDepth;\n\t\tvarying float vIsPerspective;\n\t#else\n\t\tuniform float logDepthBufFC;\n\t#endif\n#endif";
var $c702e238df7c5123$var$logdepthbuf_vertex = "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvFragDepth = 1.0 + gl_Position.w;\n\t\tvIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n\t#else\n\t\tif ( isPerspectiveMatrix( projectionMatrix ) ) {\n\t\t\tgl_Position.z = log2( max( EPSILON, gl_Position.w + 1.0 ) ) * logDepthBufFC - 1.0;\n\t\t\tgl_Position.z *= gl_Position.w;\n\t\t}\n\t#endif\n#endif";
var $c702e238df7c5123$var$map_fragment = "#ifdef USE_MAP\n\tvec4 texelColor = texture2D( map, vUv );\n\ttexelColor = mapTexelToLinear( texelColor );\n\tdiffuseColor *= texelColor;\n#endif";
var $c702e238df7c5123$var$map_pars_fragment = "#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif";
var $c702e238df7c5123$var$map_particle_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\tvec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n#endif\n#ifdef USE_MAP\n\tvec4 mapTexel = texture2D( map, uv );\n\tdiffuseColor *= mapTexelToLinear( mapTexel );\n#endif\n#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif";
var $c702e238df7c5123$var$map_particle_pars_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\tuniform mat3 uvTransform;\n#endif\n#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";
var $c702e238df7c5123$var$metalnessmap_fragment = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n\tvec4 texelMetalness = texture2D( metalnessMap, vUv );\n\tmetalnessFactor *= texelMetalness.b;\n#endif";
var $c702e238df7c5123$var$metalnessmap_pars_fragment = "#ifdef USE_METALNESSMAP\n\tuniform sampler2D metalnessMap;\n#endif";
var $c702e238df7c5123$var$morphnormal_vertex = "#ifdef USE_MORPHNORMALS\n\tobjectNormal *= morphTargetBaseInfluence;\n\tobjectNormal += morphNormal0 * morphTargetInfluences[ 0 ];\n\tobjectNormal += morphNormal1 * morphTargetInfluences[ 1 ];\n\tobjectNormal += morphNormal2 * morphTargetInfluences[ 2 ];\n\tobjectNormal += morphNormal3 * morphTargetInfluences[ 3 ];\n#endif";
var $c702e238df7c5123$var$morphtarget_pars_vertex = "#ifdef USE_MORPHTARGETS\n\tuniform float morphTargetBaseInfluence;\n\t#ifndef USE_MORPHNORMALS\n\t\tuniform float morphTargetInfluences[ 8 ];\n\t#else\n\t\tuniform float morphTargetInfluences[ 4 ];\n\t#endif\n#endif";
var $c702e238df7c5123$var$morphtarget_vertex = "#ifdef USE_MORPHTARGETS\n\ttransformed *= morphTargetBaseInfluence;\n\ttransformed += morphTarget0 * morphTargetInfluences[ 0 ];\n\ttransformed += morphTarget1 * morphTargetInfluences[ 1 ];\n\ttransformed += morphTarget2 * morphTargetInfluences[ 2 ];\n\ttransformed += morphTarget3 * morphTargetInfluences[ 3 ];\n\t#ifndef USE_MORPHNORMALS\n\t\ttransformed += morphTarget4 * morphTargetInfluences[ 4 ];\n\t\ttransformed += morphTarget5 * morphTargetInfluences[ 5 ];\n\t\ttransformed += morphTarget6 * morphTargetInfluences[ 6 ];\n\t\ttransformed += morphTarget7 * morphTargetInfluences[ 7 ];\n\t#endif\n#endif";
var $c702e238df7c5123$var$normal_fragment_begin = "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n\tvec3 fdx = vec3( dFdx( vViewPosition.x ), dFdx( vViewPosition.y ), dFdx( vViewPosition.z ) );\n\tvec3 fdy = vec3( dFdy( vViewPosition.x ), dFdy( vViewPosition.y ), dFdy( vViewPosition.z ) );\n\tvec3 normal = normalize( cross( fdx, fdy ) );\n#else\n\tvec3 normal = normalize( vNormal );\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * faceDirection;\n\t#endif\n\t#ifdef USE_TANGENT\n\t\tvec3 tangent = normalize( vTangent );\n\t\tvec3 bitangent = normalize( vBitangent );\n\t\t#ifdef DOUBLE_SIDED\n\t\t\ttangent = tangent * faceDirection;\n\t\t\tbitangent = bitangent * faceDirection;\n\t\t#endif\n\t\t#if defined( TANGENTSPACE_NORMALMAP ) || defined( USE_CLEARCOAT_NORMALMAP )\n\t\t\tmat3 vTBN = mat3( tangent, bitangent, normal );\n\t\t#endif\n\t#endif\n#endif\nvec3 geometryNormal = normal;";
var $c702e238df7c5123$var$normal_fragment_maps = "#ifdef OBJECTSPACE_NORMALMAP\n\tnormal = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n\t#ifdef FLIP_SIDED\n\t\tnormal = - normal;\n\t#endif\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * faceDirection;\n\t#endif\n\tnormal = normalize( normalMatrix * normal );\n#elif defined( TANGENTSPACE_NORMALMAP )\n\tvec3 mapN = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n\tmapN.xy *= normalScale;\n\t#ifdef USE_TANGENT\n\t\tnormal = normalize( vTBN * mapN );\n\t#else\n\t\tnormal = perturbNormal2Arb( -vViewPosition, normal, mapN, faceDirection );\n\t#endif\n#elif defined( USE_BUMPMAP )\n\tnormal = perturbNormalArb( -vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif";
var $c702e238df7c5123$var$normalmap_pars_fragment = "#ifdef USE_NORMALMAP\n\tuniform sampler2D normalMap;\n\tuniform vec2 normalScale;\n#endif\n#ifdef OBJECTSPACE_NORMALMAP\n\tuniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( TANGENTSPACE_NORMALMAP ) || defined ( USE_CLEARCOAT_NORMALMAP ) )\n\tvec3 perturbNormal2Arb( vec3 eye_pos, vec3 surf_norm, vec3 mapN, float faceDirection ) {\n\t\tvec3 q0 = vec3( dFdx( eye_pos.x ), dFdx( eye_pos.y ), dFdx( eye_pos.z ) );\n\t\tvec3 q1 = vec3( dFdy( eye_pos.x ), dFdy( eye_pos.y ), dFdy( eye_pos.z ) );\n\t\tvec2 st0 = dFdx( vUv.st );\n\t\tvec2 st1 = dFdy( vUv.st );\n\t\tvec3 N = surf_norm;\n\t\tvec3 q1perp = cross( q1, N );\n\t\tvec3 q0perp = cross( N, q0 );\n\t\tvec3 T = q1perp * st0.x + q0perp * st1.x;\n\t\tvec3 B = q1perp * st0.y + q0perp * st1.y;\n\t\tfloat det = max( dot( T, T ), dot( B, B ) );\n\t\tfloat scale = ( det == 0.0 ) ? 0.0 : faceDirection * inversesqrt( det );\n\t\treturn normalize( T * ( mapN.x * scale ) + B * ( mapN.y * scale ) + N * mapN.z );\n\t}\n#endif";
var $c702e238df7c5123$var$clearcoat_normal_fragment_begin = "#ifdef CLEARCOAT\n\tvec3 clearcoatNormal = geometryNormal;\n#endif";
var $c702e238df7c5123$var$clearcoat_normal_fragment_maps = "#ifdef USE_CLEARCOAT_NORMALMAP\n\tvec3 clearcoatMapN = texture2D( clearcoatNormalMap, vUv ).xyz * 2.0 - 1.0;\n\tclearcoatMapN.xy *= clearcoatNormalScale;\n\t#ifdef USE_TANGENT\n\t\tclearcoatNormal = normalize( vTBN * clearcoatMapN );\n\t#else\n\t\tclearcoatNormal = perturbNormal2Arb( - vViewPosition, clearcoatNormal, clearcoatMapN, faceDirection );\n\t#endif\n#endif";
var $c702e238df7c5123$var$clearcoat_pars_fragment = "#ifdef USE_CLEARCOATMAP\n\tuniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform sampler2D clearcoatRoughnessMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform sampler2D clearcoatNormalMap;\n\tuniform vec2 clearcoatNormalScale;\n#endif";
var $c702e238df7c5123$var$packing = "vec3 packNormalToRGB( const in vec3 normal ) {\n\treturn normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n\treturn 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\nconst float ShiftRight8 = 1. / 256.;\nvec4 packDepthToRGBA( const in float v ) {\n\tvec4 r = vec4( fract( v * PackFactors ), v );\n\tr.yzw -= r.xyz * ShiftRight8;\treturn r * PackUpscale;\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n\treturn dot( v, UnpackFactors );\n}\nvec4 pack2HalfToRGBA( vec2 v ) {\n\tvec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ));\n\treturn vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w);\n}\nvec2 unpackRGBATo2Half( vec4 v ) {\n\treturn vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float linearClipZ, const in float near, const in float far ) {\n\treturn linearClipZ * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn (( near + viewZ ) * far ) / (( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float invClipZ, const in float near, const in float far ) {\n\treturn ( near * far ) / ( ( far - near ) * invClipZ - far );\n}";
var $c702e238df7c5123$var$premultiplied_alpha_fragment = "#ifdef PREMULTIPLIED_ALPHA\n\tgl_FragColor.rgb *= gl_FragColor.a;\n#endif";
var $c702e238df7c5123$var$project_vertex = "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_INSTANCING\n\tmvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;";
var $c702e238df7c5123$var$dithering_fragment = "#ifdef DITHERING\n\tgl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif";
var $c702e238df7c5123$var$dithering_pars_fragment = "#ifdef DITHERING\n\tvec3 dithering( vec3 color ) {\n\t\tfloat grid_position = rand( gl_FragCoord.xy );\n\t\tvec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n\t\tdither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n\t\treturn color + dither_shift_RGB;\n\t}\n#endif";
var $c702e238df7c5123$var$roughnessmap_fragment = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n\tvec4 texelRoughness = texture2D( roughnessMap, vUv );\n\troughnessFactor *= texelRoughness.g;\n#endif";
var $c702e238df7c5123$var$roughnessmap_pars_fragment = "#ifdef USE_ROUGHNESSMAP\n\tuniform sampler2D roughnessMap;\n#endif";
var $c702e238df7c5123$var$shadowmap_pars_fragment = "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n\tfloat texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n\t\treturn step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n\t}\n\tvec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n\t\treturn unpackRGBATo2Half( texture2D( shadow, uv ) );\n\t}\n\tfloat VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n\t\tfloat occlusion = 1.0;\n\t\tvec2 distribution = texture2DDistribution( shadow, uv );\n\t\tfloat hard_shadow = step( compare , distribution.x );\n\t\tif (hard_shadow != 1.0 ) {\n\t\t\tfloat distance = compare - distribution.x ;\n\t\t\tfloat variance = max( 0.00000, distribution.y * distribution.y );\n\t\t\tfloat softness_probability = variance / (variance + distance * distance );\t\t\tsoftness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );\t\t\tocclusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n\t\t}\n\t\treturn occlusion;\n\t}\n\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\tfloat shadow = 1.0;\n\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\tshadowCoord.z += shadowBias;\n\t\tbvec4 inFrustumVec = bvec4 ( shadowCoord.x >= 0.0, shadowCoord.x <= 1.0, shadowCoord.y >= 0.0, shadowCoord.y <= 1.0 );\n\t\tbool inFrustum = all( inFrustumVec );\n\t\tbvec2 frustumTestVec = bvec2( inFrustum, shadowCoord.z <= 1.0 );\n\t\tbool frustumTest = all( frustumTestVec );\n\t\tif ( frustumTest ) {\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\tfloat dx2 = dx0 / 2.0;\n\t\t\tfloat dy2 = dy0 / 2.0;\n\t\t\tfloat dx3 = dx1 / 2.0;\n\t\t\tfloat dy3 = dy1 / 2.0;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 17.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx = texelSize.x;\n\t\t\tfloat dy = texelSize.y;\n\t\t\tvec2 uv = shadowCoord.xy;\n\t\t\tvec2 f = fract( uv * shadowMapSize + 0.5 );\n\t\t\tuv -= f * texelSize;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, uv, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ), \n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ), \n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ), \n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ), \n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ), \n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ), \n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t f.y )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_VSM )\n\t\t\tshadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#else\n\t\t\tshadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#endif\n\t\t}\n\t\treturn shadow;\n\t}\n\tvec2 cubeToUV( vec3 v, float texelSizeY ) {\n\t\tvec3 absV = abs( v );\n\t\tfloat scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n\t\tabsV *= scaleToCube;\n\t\tv *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n\t\tvec2 planar = v.xy;\n\t\tfloat almostATexel = 1.5 * texelSizeY;\n\t\tfloat almostOne = 1.0 - almostATexel;\n\t\tif ( absV.z >= almostOne ) {\n\t\t\tif ( v.z > 0.0 )\n\t\t\t\tplanar.x = 4.0 - v.x;\n\t\t} else if ( absV.x >= almostOne ) {\n\t\t\tfloat signX = sign( v.x );\n\t\t\tplanar.x = v.z * signX + 2.0 * signX;\n\t\t} else if ( absV.y >= almostOne ) {\n\t\t\tfloat signY = sign( v.y );\n\t\t\tplanar.x = v.x + 2.0 * signY + 2.0;\n\t\t\tplanar.y = v.z * signY - 2.0;\n\t\t}\n\t\treturn vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n\t}\n\tfloat getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n\t\tvec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\tfloat dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );\t\tdp += shadowBias;\n\t\tvec3 bd3D = normalize( lightToPosition );\n\t\t#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n\t\t\tvec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n\t\t\treturn (\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#else\n\t\t\treturn texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n\t\t#endif\n\t}\n#endif";
var $c702e238df7c5123$var$shadowmap_pars_vertex = "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tuniform mat4 spotShadowMatrix[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n#endif";
var $c702e238df7c5123$var$shadowmap_vertex = "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0 || NUM_SPOT_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0\n\t\tvec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\tvec4 shadowWorldPosition;\n\t#endif\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n\t\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias, 0 );\n\t\tvSpotShadowCoord[ i ] = spotShadowMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n\t\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n#endif";
var $c702e238df7c5123$var$shadowmask_pars_fragment = "float getShadowMask() {\n\tfloat shadow = 1.0;\n\t#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tdirectionalLight = directionalLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n\t\tspotLight = spotLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tpointLight = pointLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#endif\n\treturn shadow;\n}";
var $c702e238df7c5123$var$skinbase_vertex = "#ifdef USE_SKINNING\n\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\n\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\n\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\n\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";
var $c702e238df7c5123$var$skinning_pars_vertex = "#ifdef USE_SKINNING\n\tuniform mat4 bindMatrix;\n\tuniform mat4 bindMatrixInverse;\n\t#ifdef BONE_TEXTURE\n\t\tuniform highp sampler2D boneTexture;\n\t\tuniform int boneTextureSize;\n\t\tmat4 getBoneMatrix( const in float i ) {\n\t\t\tfloat j = i * 4.0;\n\t\t\tfloat x = mod( j, float( boneTextureSize ) );\n\t\t\tfloat y = floor( j / float( boneTextureSize ) );\n\t\t\tfloat dx = 1.0 / float( boneTextureSize );\n\t\t\tfloat dy = 1.0 / float( boneTextureSize );\n\t\t\ty = dy * ( y + 0.5 );\n\t\t\tvec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );\n\t\t\tvec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );\n\t\t\tvec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );\n\t\t\tvec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );\n\t\t\tmat4 bone = mat4( v1, v2, v3, v4 );\n\t\t\treturn bone;\n\t\t}\n\t#else\n\t\tuniform mat4 boneMatrices[ MAX_BONES ];\n\t\tmat4 getBoneMatrix( const in float i ) {\n\t\t\tmat4 bone = boneMatrices[ int(i) ];\n\t\t\treturn bone;\n\t\t}\n\t#endif\n#endif";
var $c702e238df7c5123$var$skinning_vertex = "#ifdef USE_SKINNING\n\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n\tvec4 skinned = vec4( 0.0 );\n\tskinned += boneMatX * skinVertex * skinWeight.x;\n\tskinned += boneMatY * skinVertex * skinWeight.y;\n\tskinned += boneMatZ * skinVertex * skinWeight.z;\n\tskinned += boneMatW * skinVertex * skinWeight.w;\n\ttransformed = ( bindMatrixInverse * skinned ).xyz;\n#endif";
var $c702e238df7c5123$var$skinnormal_vertex = "#ifdef USE_SKINNING\n\tmat4 skinMatrix = mat4( 0.0 );\n\tskinMatrix += skinWeight.x * boneMatX;\n\tskinMatrix += skinWeight.y * boneMatY;\n\tskinMatrix += skinWeight.z * boneMatZ;\n\tskinMatrix += skinWeight.w * boneMatW;\n\tskinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n\t#ifdef USE_TANGENT\n\t\tobjectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#endif\n#endif";
var $c702e238df7c5123$var$specularmap_fragment = "float specularStrength;\n#ifdef USE_SPECULARMAP\n\tvec4 texelSpecular = texture2D( specularMap, vUv );\n\tspecularStrength = texelSpecular.r;\n#else\n\tspecularStrength = 1.0;\n#endif";
var $c702e238df7c5123$var$specularmap_pars_fragment = "#ifdef USE_SPECULARMAP\n\tuniform sampler2D specularMap;\n#endif";
var $c702e238df7c5123$var$tonemapping_fragment = "#if defined( TONE_MAPPING )\n\tgl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif";
var $c702e238df7c5123$var$tonemapping_pars_fragment = "#ifndef saturate\n#define saturate(a) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n\treturn toneMappingExposure * color;\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 OptimizedCineonToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\tcolor = max( vec3( 0.0 ), color - 0.004 );\n\treturn pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n\tvec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n\tvec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n\treturn a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n\tconst mat3 ACESInputMat = mat3(\n\t\tvec3( 0.59719, 0.07600, 0.02840 ),\t\tvec3( 0.35458, 0.90834, 0.13383 ),\n\t\tvec3( 0.04823, 0.01566, 0.83777 )\n\t);\n\tconst mat3 ACESOutputMat = mat3(\n\t\tvec3(  1.60475, -0.10208, -0.00327 ),\t\tvec3( -0.53108,  1.10813, -0.07276 ),\n\t\tvec3( -0.07367, -0.00605,  1.07602 )\n\t);\n\tcolor *= toneMappingExposure / 0.6;\n\tcolor = ACESInputMat * color;\n\tcolor = RRTAndODTFit( color );\n\tcolor = ACESOutputMat * color;\n\treturn saturate( color );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }";
var $c702e238df7c5123$var$transmission_fragment = "#ifdef USE_TRANSMISSION\n\tfloat transmissionFactor = transmission;\n\tfloat thicknessFactor = thickness;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\ttransmissionFactor *= texture2D( transmissionMap, vUv ).r;\n\t#endif\n\t#ifdef USE_THICKNESSNMAP\n\t\tthicknessFactor *= texture2D( thicknessMap, vUv ).g;\n\t#endif\n\tvec3 pos = vWorldPosition.xyz / vWorldPosition.w;\n\tvec3 v = normalize( cameraPosition - pos );\n\tfloat ior = ( 1.0 + 0.4 * reflectivity ) / ( 1.0 - 0.4 * reflectivity );\n\tvec3 transmission = transmissionFactor * getIBLVolumeRefraction(\n\t\tnormal, v, roughnessFactor, material.diffuseColor, totalSpecular,\n\t\tpos, modelMatrix, viewMatrix, projectionMatrix, ior, thicknessFactor,\n\t\tattenuationColor, attenuationDistance );\n\ttotalDiffuse = mix( totalDiffuse, transmission, transmissionFactor );\n#endif";
var $c702e238df7c5123$var$transmission_pars_fragment = "#ifdef USE_TRANSMISSION\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tuniform sampler2D transmissionMap;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tuniform sampler2D thicknessMap;\n\t#endif\n\tuniform vec2 transmissionSamplerSize;\n\tuniform sampler2D transmissionSamplerMap;\n\tuniform mat4 modelMatrix;\n\tuniform mat4 projectionMatrix;\n\tvarying vec4 vWorldPosition;\n\tvec3 getVolumeTransmissionRay(vec3 n, vec3 v, float thickness, float ior, mat4 modelMatrix) {\n\t\tvec3 refractionVector = refract(-v, normalize(n), 1.0 / ior);\n\t\tvec3 modelScale;\n\t\tmodelScale.x = length(vec3(modelMatrix[0].xyz));\n\t\tmodelScale.y = length(vec3(modelMatrix[1].xyz));\n\t\tmodelScale.z = length(vec3(modelMatrix[2].xyz));\n\t\treturn normalize(refractionVector) * thickness * modelScale;\n\t}\n\tfloat applyIorToRoughness(float roughness, float ior) {\n\t\treturn roughness * clamp(ior * 2.0 - 2.0, 0.0, 1.0);\n\t}\n\tvec3 getTransmissionSample(vec2 fragCoord, float roughness, float ior) {\n\t\tfloat framebufferLod = log2(transmissionSamplerSize.x) * applyIorToRoughness(roughness, ior);\n\t\treturn texture2DLodEXT(transmissionSamplerMap, fragCoord.xy, framebufferLod).rgb;\n\t}\n\tvec3 applyVolumeAttenuation(vec3 radiance, float transmissionDistance, vec3 attenuationColor, float attenuationDistance) {\n\t\tif (attenuationDistance == 0.0) {\n\t\t\treturn radiance;\n\t\t} else {\n\t\t\tvec3 attenuationCoefficient = -log(attenuationColor) / attenuationDistance;\n\t\t\tvec3 transmittance = exp(-attenuationCoefficient * transmissionDistance);\t\t\treturn transmittance * radiance;\n\t\t}\n\t}\n\tvec3 getIBLVolumeRefraction(vec3 n, vec3 v, float perceptualRoughness, vec3 baseColor, vec3 specularColor,\n\t\tvec3 position, mat4 modelMatrix, mat4 viewMatrix, mat4 projMatrix, float ior, float thickness,\n\t\tvec3 attenuationColor, float attenuationDistance) {\n\t\tvec3 transmissionRay = getVolumeTransmissionRay(n, v, thickness, ior, modelMatrix);\n\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4(refractedRayExit, 1.0);\n\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\trefractionCoords += 1.0;\n\t\trefractionCoords /= 2.0;\n\t\tvec3 transmittedLight = getTransmissionSample(refractionCoords, perceptualRoughness, ior);\n\t\tvec3 attenuatedColor = applyVolumeAttenuation(transmittedLight, length(transmissionRay), attenuationColor, attenuationDistance);\n\t\treturn (1.0 - specularColor) * attenuatedColor * baseColor;\n\t}\n#endif";
var $c702e238df7c5123$var$uv_pars_fragment = "#if ( defined( USE_UV ) && ! defined( UVS_VERTEX_ONLY ) )\n\tvarying vec2 vUv;\n#endif";
var $c702e238df7c5123$var$uv_pars_vertex = "#ifdef USE_UV\n\t#ifdef UVS_VERTEX_ONLY\n\t\tvec2 vUv;\n\t#else\n\t\tvarying vec2 vUv;\n\t#endif\n\tuniform mat3 uvTransform;\n#endif";
var $c702e238df7c5123$var$uv_vertex = "#ifdef USE_UV\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n#endif";
var $c702e238df7c5123$var$uv2_pars_fragment = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tvarying vec2 vUv2;\n#endif";
var $c702e238df7c5123$var$uv2_pars_vertex = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tattribute vec2 uv2;\n\tvarying vec2 vUv2;\n\tuniform mat3 uv2Transform;\n#endif";
var $c702e238df7c5123$var$uv2_vertex = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tvUv2 = ( uv2Transform * vec3( uv2, 1 ) ).xy;\n#endif";
var $c702e238df7c5123$var$worldpos_vertex = "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION )\n\tvec4 worldPosition = vec4( transformed, 1.0 );\n\t#ifdef USE_INSTANCING\n\t\tworldPosition = instanceMatrix * worldPosition;\n\t#endif\n\tworldPosition = modelMatrix * worldPosition;\n#endif";
var $c702e238df7c5123$var$background_frag = "uniform sampler2D t2D;\nvarying vec2 vUv;\nvoid main() {\n\tvec4 texColor = texture2D( t2D, vUv );\n\tgl_FragColor = mapTexelToLinear( texColor );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}";
var $c702e238df7c5123$var$background_vert = "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\tgl_Position = vec4( position.xy, 1.0, 1.0 );\n}";
var $c702e238df7c5123$var$cube_frag = "#include <envmap_common_pars_fragment>\nuniform float opacity;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n\tvec3 vReflect = vWorldDirection;\n\t#include <envmap_fragment>\n\tgl_FragColor = envColor;\n\tgl_FragColor.a *= opacity;\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}";
var $c702e238df7c5123$var$cube_vert = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}";
var $c702e238df7c5123$var$depth_frag = "#if DEPTH_PACKING == 3200\n\tuniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#if DEPTH_PACKING == 3200\n\t\tdiffuseColor.a = opacity;\n\t#endif\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <logdepthbuf_fragment>\n\tfloat fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n\t#if DEPTH_PACKING == 3200\n\t\tgl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n\t#elif DEPTH_PACKING == 3201\n\t\tgl_FragColor = packDepthToRGBA( fragCoordZ );\n\t#endif\n}";
var $c702e238df7c5123$var$depth_vert = "#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvHighPrecisionZW = gl_Position.zw;\n}";
var $c702e238df7c5123$var$distanceRGBA_frag = "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\tfloat dist = length( vWorldPosition - referencePosition );\n\tdist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n\tdist = saturate( dist );\n\tgl_FragColor = packDepthToRGBA( dist );\n}";
var $c702e238df7c5123$var$distanceRGBA_vert = "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\tvWorldPosition = worldPosition.xyz;\n}";
var $c702e238df7c5123$var$equirect_frag = "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvec3 direction = normalize( vWorldDirection );\n\tvec2 sampleUV = equirectUv( direction );\n\tvec4 texColor = texture2D( tEquirect, sampleUV );\n\tgl_FragColor = mapTexelToLinear( texColor );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}";
var $c702e238df7c5123$var$equirect_vert = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}";
var $c702e238df7c5123$var$linedashed_frag = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\n\t\tdiscard;\n\t}\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <color_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";
var $c702e238df7c5123$var$linedashed_vert = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\tvLineDistance = scale * lineDistance;\n\t#include <color_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";
var $c702e238df7c5123$var$meshbasic_frag = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\t#ifdef USE_LIGHTMAP\n\t\n\t\tvec4 lightMapTexel= texture2D( lightMap, vUv2 );\n\t\treflectedLight.indirectDiffuse += lightMapTexelToLinear( lightMapTexel ).rgb * lightMapIntensity;\n\t#else\n\t\treflectedLight.indirectDiffuse += vec3( 1.0 );\n\t#endif\n\t#include <aomap_fragment>\n\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\n\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\n\t#include <envmap_fragment>\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
var $c702e238df7c5123$var$meshbasic_vert = "#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_ENVMAP\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <envmap_vertex>\n\t#include <fog_vertex>\n}";
var $c702e238df7c5123$var$meshlambert_frag = "uniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\nvarying vec3 vLightFront;\nvarying vec3 vIndirectFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n\tvarying vec3 vIndirectBack;\n#endif\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <fog_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <emissivemap_fragment>\n\t#ifdef DOUBLE_SIDED\n\t\treflectedLight.indirectDiffuse += ( gl_FrontFacing ) ? vIndirectFront : vIndirectBack;\n\t#else\n\t\treflectedLight.indirectDiffuse += vIndirectFront;\n\t#endif\n\t#include <lightmap_fragment>\n\treflectedLight.indirectDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb );\n\t#ifdef DOUBLE_SIDED\n\t\treflectedLight.directDiffuse = ( gl_FrontFacing ) ? vLightFront : vLightBack;\n\t#else\n\t\treflectedLight.directDiffuse = vLightFront;\n\t#endif\n\treflectedLight.directDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb ) * getShadowMask();\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
var $c702e238df7c5123$var$meshlambert_vert = "#define LAMBERT\nvarying vec3 vLightFront;\nvarying vec3 vIndirectFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n\tvarying vec3 vIndirectBack;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <lights_lambert_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
var $c702e238df7c5123$var$meshmatcap_frag = "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tvec3 viewDir = normalize( vViewPosition );\n\tvec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n\tvec3 y = cross( viewDir, x );\n\tvec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n\t#ifdef USE_MATCAP\n\t\tvec4 matcapColor = texture2D( matcap, uv );\n\t\tmatcapColor = matcapTexelToLinear( matcapColor );\n\t#else\n\t\tvec4 matcapColor = vec4( 1.0 );\n\t#endif\n\tvec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
var $c702e238df7c5123$var$meshmatcap_vert = "#define MATCAP\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#ifndef FLAT_SHADED\n\t\tvNormal = normalize( transformedNormal );\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n\tvViewPosition = - mvPosition.xyz;\n}";
var $c702e238df7c5123$var$meshtoon_frag = "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_toon_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
var $c702e238df7c5123$var$meshtoon_vert = "#define TOON\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
var $c702e238df7c5123$var$meshphong_frag = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_phong_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
var $c702e238df7c5123$var$meshphong_vert = "#define PHONG\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
var $c702e238df7c5123$var$meshphysical_frag = "#define STANDARD\n#ifdef PHYSICAL\n\t#define REFLECTIVITY\n\t#define CLEARCOAT\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef USE_TRANSMISSION\n\tuniform float transmission;\n\tuniform float thickness;\n\tuniform vec3 attenuationColor;\n\tuniform float attenuationDistance;\n#endif\n#ifdef REFLECTIVITY\n\tuniform float reflectivity;\n#endif\n#ifdef CLEARCOAT\n\tuniform float clearcoat;\n\tuniform float clearcoatRoughness;\n#endif\n#ifdef USE_SHEEN\n\tuniform vec3 sheen;\n#endif\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <bsdfs>\n#include <transmission_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <lights_physical_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <roughnessmap_fragment>\n\t#include <metalnessmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <clearcoat_normal_fragment_begin>\n\t#include <clearcoat_normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_physical_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n\tvec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n\t#include <transmission_fragment>\n\tvec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
var $c702e238df7c5123$var$meshphysical_vert = "#define STANDARD\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif\n#ifdef USE_TRANSMISSION\n\tvarying vec4 vWorldPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n\t#ifdef USE_TANGENT\n\t\tvTangent = normalize( transformedTangent );\n\t\tvBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n\t#endif\n#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n\tvWorldPosition = worldPosition;\n#endif\n}";
var $c702e238df7c5123$var$normal_frag = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n\tvarying vec3 vViewPosition;\n#endif\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tgl_FragColor = vec4( packNormalToRGB( normal ), opacity );\n}";
var $c702e238df7c5123$var$normal_vert = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n\tvarying vec3 vViewPosition;\n#endif\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n\t#ifdef USE_TANGENT\n\t\tvTangent = normalize( transformedTangent );\n\t\tvBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n\t#endif\n#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n}";
var $c702e238df7c5123$var$points_frag = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_particle_fragment>\n\t#include <color_fragment>\n\t#include <alphatest_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";
var $c702e238df7c5123$var$points_vert = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <color_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\tgl_PointSize = size;\n\t#ifdef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n\t#endif\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <fog_vertex>\n}";
var $c702e238df7c5123$var$shadow_frag = "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n\tgl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}";
var $c702e238df7c5123$var$shadow_vert = "#include <common>\n#include <fog_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
var $c702e238df7c5123$var$sprite_frag = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}";
var $c702e238df7c5123$var$sprite_vert = "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\tvec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );\n\tvec2 scale;\n\tscale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );\n\tscale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );\n\t#ifndef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) scale *= - mvPosition.z;\n\t#endif\n\tvec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n\tvec2 rotatedPosition;\n\trotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n\trotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n\tmvPosition.xy += rotatedPosition;\n\tgl_Position = projectionMatrix * mvPosition;\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";
var $c702e238df7c5123$export$955f9f2e84c43c8b = {
    alphamap_fragment: $c702e238df7c5123$var$alphamap_fragment,
    alphamap_pars_fragment: $c702e238df7c5123$var$alphamap_pars_fragment,
    alphatest_fragment: $c702e238df7c5123$var$alphatest_fragment,
    aomap_fragment: $c702e238df7c5123$var$aomap_fragment,
    aomap_pars_fragment: $c702e238df7c5123$var$aomap_pars_fragment,
    begin_vertex: $c702e238df7c5123$var$begin_vertex,
    beginnormal_vertex: $c702e238df7c5123$var$beginnormal_vertex,
    bsdfs: $c702e238df7c5123$var$bsdfs,
    bumpmap_pars_fragment: $c702e238df7c5123$var$bumpmap_pars_fragment,
    clipping_planes_fragment: $c702e238df7c5123$var$clipping_planes_fragment,
    clipping_planes_pars_fragment: $c702e238df7c5123$var$clipping_planes_pars_fragment,
    clipping_planes_pars_vertex: $c702e238df7c5123$var$clipping_planes_pars_vertex,
    clipping_planes_vertex: $c702e238df7c5123$var$clipping_planes_vertex,
    color_fragment: $c702e238df7c5123$var$color_fragment,
    color_pars_fragment: $c702e238df7c5123$var$color_pars_fragment,
    color_pars_vertex: $c702e238df7c5123$var$color_pars_vertex,
    color_vertex: $c702e238df7c5123$var$color_vertex,
    common: $c702e238df7c5123$var$common,
    cube_uv_reflection_fragment: $c702e238df7c5123$var$cube_uv_reflection_fragment,
    defaultnormal_vertex: $c702e238df7c5123$var$defaultnormal_vertex,
    displacementmap_pars_vertex: $c702e238df7c5123$var$displacementmap_pars_vertex,
    displacementmap_vertex: $c702e238df7c5123$var$displacementmap_vertex,
    emissivemap_fragment: $c702e238df7c5123$var$emissivemap_fragment,
    emissivemap_pars_fragment: $c702e238df7c5123$var$emissivemap_pars_fragment,
    encodings_fragment: $c702e238df7c5123$var$encodings_fragment,
    encodings_pars_fragment: $c702e238df7c5123$var$encodings_pars_fragment,
    envmap_fragment: $c702e238df7c5123$var$envmap_fragment,
    envmap_common_pars_fragment: $c702e238df7c5123$var$envmap_common_pars_fragment,
    envmap_pars_fragment: $c702e238df7c5123$var$envmap_pars_fragment,
    envmap_pars_vertex: $c702e238df7c5123$var$envmap_pars_vertex,
    envmap_physical_pars_fragment: $c702e238df7c5123$var$envmap_physical_pars_fragment,
    envmap_vertex: $c702e238df7c5123$var$envmap_vertex,
    fog_vertex: $c702e238df7c5123$var$fog_vertex,
    fog_pars_vertex: $c702e238df7c5123$var$fog_pars_vertex,
    fog_fragment: $c702e238df7c5123$var$fog_fragment,
    fog_pars_fragment: $c702e238df7c5123$var$fog_pars_fragment,
    gradientmap_pars_fragment: $c702e238df7c5123$var$gradientmap_pars_fragment,
    lightmap_fragment: $c702e238df7c5123$var$lightmap_fragment,
    lightmap_pars_fragment: $c702e238df7c5123$var$lightmap_pars_fragment,
    lights_lambert_vertex: $c702e238df7c5123$var$lights_lambert_vertex,
    lights_pars_begin: $c702e238df7c5123$var$lights_pars_begin,
    lights_toon_fragment: $c702e238df7c5123$var$lights_toon_fragment,
    lights_toon_pars_fragment: $c702e238df7c5123$var$lights_toon_pars_fragment,
    lights_phong_fragment: $c702e238df7c5123$var$lights_phong_fragment,
    lights_phong_pars_fragment: $c702e238df7c5123$var$lights_phong_pars_fragment,
    lights_physical_fragment: $c702e238df7c5123$var$lights_physical_fragment,
    lights_physical_pars_fragment: $c702e238df7c5123$var$lights_physical_pars_fragment,
    lights_fragment_begin: $c702e238df7c5123$var$lights_fragment_begin,
    lights_fragment_maps: $c702e238df7c5123$var$lights_fragment_maps,
    lights_fragment_end: $c702e238df7c5123$var$lights_fragment_end,
    logdepthbuf_fragment: $c702e238df7c5123$var$logdepthbuf_fragment,
    logdepthbuf_pars_fragment: $c702e238df7c5123$var$logdepthbuf_pars_fragment,
    logdepthbuf_pars_vertex: $c702e238df7c5123$var$logdepthbuf_pars_vertex,
    logdepthbuf_vertex: $c702e238df7c5123$var$logdepthbuf_vertex,
    map_fragment: $c702e238df7c5123$var$map_fragment,
    map_pars_fragment: $c702e238df7c5123$var$map_pars_fragment,
    map_particle_fragment: $c702e238df7c5123$var$map_particle_fragment,
    map_particle_pars_fragment: $c702e238df7c5123$var$map_particle_pars_fragment,
    metalnessmap_fragment: $c702e238df7c5123$var$metalnessmap_fragment,
    metalnessmap_pars_fragment: $c702e238df7c5123$var$metalnessmap_pars_fragment,
    morphnormal_vertex: $c702e238df7c5123$var$morphnormal_vertex,
    morphtarget_pars_vertex: $c702e238df7c5123$var$morphtarget_pars_vertex,
    morphtarget_vertex: $c702e238df7c5123$var$morphtarget_vertex,
    normal_fragment_begin: $c702e238df7c5123$var$normal_fragment_begin,
    normal_fragment_maps: $c702e238df7c5123$var$normal_fragment_maps,
    normalmap_pars_fragment: $c702e238df7c5123$var$normalmap_pars_fragment,
    clearcoat_normal_fragment_begin: $c702e238df7c5123$var$clearcoat_normal_fragment_begin,
    clearcoat_normal_fragment_maps: $c702e238df7c5123$var$clearcoat_normal_fragment_maps,
    clearcoat_pars_fragment: $c702e238df7c5123$var$clearcoat_pars_fragment,
    packing: $c702e238df7c5123$var$packing,
    premultiplied_alpha_fragment: $c702e238df7c5123$var$premultiplied_alpha_fragment,
    project_vertex: $c702e238df7c5123$var$project_vertex,
    dithering_fragment: $c702e238df7c5123$var$dithering_fragment,
    dithering_pars_fragment: $c702e238df7c5123$var$dithering_pars_fragment,
    roughnessmap_fragment: $c702e238df7c5123$var$roughnessmap_fragment,
    roughnessmap_pars_fragment: $c702e238df7c5123$var$roughnessmap_pars_fragment,
    shadowmap_pars_fragment: $c702e238df7c5123$var$shadowmap_pars_fragment,
    shadowmap_pars_vertex: $c702e238df7c5123$var$shadowmap_pars_vertex,
    shadowmap_vertex: $c702e238df7c5123$var$shadowmap_vertex,
    shadowmask_pars_fragment: $c702e238df7c5123$var$shadowmask_pars_fragment,
    skinbase_vertex: $c702e238df7c5123$var$skinbase_vertex,
    skinning_pars_vertex: $c702e238df7c5123$var$skinning_pars_vertex,
    skinning_vertex: $c702e238df7c5123$var$skinning_vertex,
    skinnormal_vertex: $c702e238df7c5123$var$skinnormal_vertex,
    specularmap_fragment: $c702e238df7c5123$var$specularmap_fragment,
    specularmap_pars_fragment: $c702e238df7c5123$var$specularmap_pars_fragment,
    tonemapping_fragment: $c702e238df7c5123$var$tonemapping_fragment,
    tonemapping_pars_fragment: $c702e238df7c5123$var$tonemapping_pars_fragment,
    transmission_fragment: $c702e238df7c5123$var$transmission_fragment,
    transmission_pars_fragment: $c702e238df7c5123$var$transmission_pars_fragment,
    uv_pars_fragment: $c702e238df7c5123$var$uv_pars_fragment,
    uv_pars_vertex: $c702e238df7c5123$var$uv_pars_vertex,
    uv_vertex: $c702e238df7c5123$var$uv_vertex,
    uv2_pars_fragment: $c702e238df7c5123$var$uv2_pars_fragment,
    uv2_pars_vertex: $c702e238df7c5123$var$uv2_pars_vertex,
    uv2_vertex: $c702e238df7c5123$var$uv2_vertex,
    worldpos_vertex: $c702e238df7c5123$var$worldpos_vertex,
    background_frag: $c702e238df7c5123$var$background_frag,
    background_vert: $c702e238df7c5123$var$background_vert,
    cube_frag: $c702e238df7c5123$var$cube_frag,
    cube_vert: $c702e238df7c5123$var$cube_vert,
    depth_frag: $c702e238df7c5123$var$depth_frag,
    depth_vert: $c702e238df7c5123$var$depth_vert,
    distanceRGBA_frag: $c702e238df7c5123$var$distanceRGBA_frag,
    distanceRGBA_vert: $c702e238df7c5123$var$distanceRGBA_vert,
    equirect_frag: $c702e238df7c5123$var$equirect_frag,
    equirect_vert: $c702e238df7c5123$var$equirect_vert,
    linedashed_frag: $c702e238df7c5123$var$linedashed_frag,
    linedashed_vert: $c702e238df7c5123$var$linedashed_vert,
    meshbasic_frag: $c702e238df7c5123$var$meshbasic_frag,
    meshbasic_vert: $c702e238df7c5123$var$meshbasic_vert,
    meshlambert_frag: $c702e238df7c5123$var$meshlambert_frag,
    meshlambert_vert: $c702e238df7c5123$var$meshlambert_vert,
    meshmatcap_frag: $c702e238df7c5123$var$meshmatcap_frag,
    meshmatcap_vert: $c702e238df7c5123$var$meshmatcap_vert,
    meshtoon_frag: $c702e238df7c5123$var$meshtoon_frag,
    meshtoon_vert: $c702e238df7c5123$var$meshtoon_vert,
    meshphong_frag: $c702e238df7c5123$var$meshphong_frag,
    meshphong_vert: $c702e238df7c5123$var$meshphong_vert,
    meshphysical_frag: $c702e238df7c5123$var$meshphysical_frag,
    meshphysical_vert: $c702e238df7c5123$var$meshphysical_vert,
    normal_frag: $c702e238df7c5123$var$normal_frag,
    normal_vert: $c702e238df7c5123$var$normal_vert,
    points_frag: $c702e238df7c5123$var$points_frag,
    points_vert: $c702e238df7c5123$var$points_vert,
    shadow_frag: $c702e238df7c5123$var$shadow_frag,
    shadow_vert: $c702e238df7c5123$var$shadow_vert,
    sprite_frag: $c702e238df7c5123$var$sprite_frag,
    sprite_vert: $c702e238df7c5123$var$sprite_vert
};
/**
 * Uniforms library for shared webgl shaders
 */ var $c702e238df7c5123$export$6643083551874bf5 = {
    common: {
        diffuse: {
            value: new $c702e238df7c5123$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        map: {
            value: null
        },
        uvTransform: {
            value: new $c702e238df7c5123$export$8ff26dafa08918()
        },
        uv2Transform: {
            value: new $c702e238df7c5123$export$8ff26dafa08918()
        },
        alphaMap: {
            value: null
        }
    },
    specularmap: {
        specularMap: {
            value: null
        }
    },
    envmap: {
        envMap: {
            value: null
        },
        flipEnvMap: {
            value: -1
        },
        reflectivity: {
            value: 1.0
        },
        refractionRatio: {
            value: 0.98
        },
        maxMipLevel: {
            value: 0
        }
    },
    aomap: {
        aoMap: {
            value: null
        },
        aoMapIntensity: {
            value: 1
        }
    },
    lightmap: {
        lightMap: {
            value: null
        },
        lightMapIntensity: {
            value: 1
        }
    },
    emissivemap: {
        emissiveMap: {
            value: null
        }
    },
    bumpmap: {
        bumpMap: {
            value: null
        },
        bumpScale: {
            value: 1
        }
    },
    normalmap: {
        normalMap: {
            value: null
        },
        normalScale: {
            value: new $c702e238df7c5123$export$c977b3e384af9ae1(1, 1)
        }
    },
    displacementmap: {
        displacementMap: {
            value: null
        },
        displacementScale: {
            value: 1
        },
        displacementBias: {
            value: 0
        }
    },
    roughnessmap: {
        roughnessMap: {
            value: null
        }
    },
    metalnessmap: {
        metalnessMap: {
            value: null
        }
    },
    gradientmap: {
        gradientMap: {
            value: null
        }
    },
    fog: {
        fogDensity: {
            value: 0.00025
        },
        fogNear: {
            value: 1
        },
        fogFar: {
            value: 2000
        },
        fogColor: {
            value: new $c702e238df7c5123$export$892596cec99bc70e(0xffffff)
        }
    },
    lights: {
        ambientLightColor: {
            value: []
        },
        lightProbe: {
            value: []
        },
        directionalLights: {
            value: [],
            properties: {
                direction: {},
                color: {}
            }
        },
        directionalLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        directionalShadowMap: {
            value: []
        },
        directionalShadowMatrix: {
            value: []
        },
        spotLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                direction: {},
                distance: {},
                coneCos: {},
                penumbraCos: {},
                decay: {}
            }
        },
        spotLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        spotShadowMap: {
            value: []
        },
        spotShadowMatrix: {
            value: []
        },
        pointLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                decay: {},
                distance: {}
            }
        },
        pointLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {},
                shadowCameraNear: {},
                shadowCameraFar: {}
            }
        },
        pointShadowMap: {
            value: []
        },
        pointShadowMatrix: {
            value: []
        },
        hemisphereLights: {
            value: [],
            properties: {
                direction: {},
                skyColor: {},
                groundColor: {}
            }
        },
        // TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
        rectAreaLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                width: {},
                height: {}
            }
        },
        ltc_1: {
            value: null
        },
        ltc_2: {
            value: null
        }
    },
    points: {
        diffuse: {
            value: new $c702e238df7c5123$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        size: {
            value: 1.0
        },
        scale: {
            value: 1.0
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        uvTransform: {
            value: new $c702e238df7c5123$export$8ff26dafa08918()
        }
    },
    sprite: {
        diffuse: {
            value: new $c702e238df7c5123$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        center: {
            value: new $c702e238df7c5123$export$c977b3e384af9ae1(0.5, 0.5)
        },
        rotation: {
            value: 0.0
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        uvTransform: {
            value: new $c702e238df7c5123$export$8ff26dafa08918()
        }
    }
};
var $c702e238df7c5123$export$bee4a7d47f8f5014 = {
    basic: {
        uniforms: $c702e238df7c5123$var$mergeUniforms([
            $c702e238df7c5123$export$6643083551874bf5.common,
            $c702e238df7c5123$export$6643083551874bf5.specularmap,
            $c702e238df7c5123$export$6643083551874bf5.envmap,
            $c702e238df7c5123$export$6643083551874bf5.aomap,
            $c702e238df7c5123$export$6643083551874bf5.lightmap,
            $c702e238df7c5123$export$6643083551874bf5.fog
        ]),
        vertexShader: $c702e238df7c5123$export$955f9f2e84c43c8b.meshbasic_vert,
        fragmentShader: $c702e238df7c5123$export$955f9f2e84c43c8b.meshbasic_frag
    },
    lambert: {
        uniforms: $c702e238df7c5123$var$mergeUniforms([
            $c702e238df7c5123$export$6643083551874bf5.common,
            $c702e238df7c5123$export$6643083551874bf5.specularmap,
            $c702e238df7c5123$export$6643083551874bf5.envmap,
            $c702e238df7c5123$export$6643083551874bf5.aomap,
            $c702e238df7c5123$export$6643083551874bf5.lightmap,
            $c702e238df7c5123$export$6643083551874bf5.emissivemap,
            $c702e238df7c5123$export$6643083551874bf5.fog,
            $c702e238df7c5123$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: new $c702e238df7c5123$export$892596cec99bc70e(0x000000)
                }
            }
        ]),
        vertexShader: $c702e238df7c5123$export$955f9f2e84c43c8b.meshlambert_vert,
        fragmentShader: $c702e238df7c5123$export$955f9f2e84c43c8b.meshlambert_frag
    },
    phong: {
        uniforms: $c702e238df7c5123$var$mergeUniforms([
            $c702e238df7c5123$export$6643083551874bf5.common,
            $c702e238df7c5123$export$6643083551874bf5.specularmap,
            $c702e238df7c5123$export$6643083551874bf5.envmap,
            $c702e238df7c5123$export$6643083551874bf5.aomap,
            $c702e238df7c5123$export$6643083551874bf5.lightmap,
            $c702e238df7c5123$export$6643083551874bf5.emissivemap,
            $c702e238df7c5123$export$6643083551874bf5.bumpmap,
            $c702e238df7c5123$export$6643083551874bf5.normalmap,
            $c702e238df7c5123$export$6643083551874bf5.displacementmap,
            $c702e238df7c5123$export$6643083551874bf5.fog,
            $c702e238df7c5123$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: new $c702e238df7c5123$export$892596cec99bc70e(0x000000)
                },
                specular: {
                    value: new $c702e238df7c5123$export$892596cec99bc70e(0x111111)
                },
                shininess: {
                    value: 30
                }
            }
        ]),
        vertexShader: $c702e238df7c5123$export$955f9f2e84c43c8b.meshphong_vert,
        fragmentShader: $c702e238df7c5123$export$955f9f2e84c43c8b.meshphong_frag
    },
    standard: {
        uniforms: $c702e238df7c5123$var$mergeUniforms([
            $c702e238df7c5123$export$6643083551874bf5.common,
            $c702e238df7c5123$export$6643083551874bf5.envmap,
            $c702e238df7c5123$export$6643083551874bf5.aomap,
            $c702e238df7c5123$export$6643083551874bf5.lightmap,
            $c702e238df7c5123$export$6643083551874bf5.emissivemap,
            $c702e238df7c5123$export$6643083551874bf5.bumpmap,
            $c702e238df7c5123$export$6643083551874bf5.normalmap,
            $c702e238df7c5123$export$6643083551874bf5.displacementmap,
            $c702e238df7c5123$export$6643083551874bf5.roughnessmap,
            $c702e238df7c5123$export$6643083551874bf5.metalnessmap,
            $c702e238df7c5123$export$6643083551874bf5.fog,
            $c702e238df7c5123$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: new $c702e238df7c5123$export$892596cec99bc70e(0x000000)
                },
                roughness: {
                    value: 1.0
                },
                metalness: {
                    value: 0.0
                },
                envMapIntensity: {
                    value: 1
                } // temporary
            }
        ]),
        vertexShader: $c702e238df7c5123$export$955f9f2e84c43c8b.meshphysical_vert,
        fragmentShader: $c702e238df7c5123$export$955f9f2e84c43c8b.meshphysical_frag
    },
    toon: {
        uniforms: $c702e238df7c5123$var$mergeUniforms([
            $c702e238df7c5123$export$6643083551874bf5.common,
            $c702e238df7c5123$export$6643083551874bf5.aomap,
            $c702e238df7c5123$export$6643083551874bf5.lightmap,
            $c702e238df7c5123$export$6643083551874bf5.emissivemap,
            $c702e238df7c5123$export$6643083551874bf5.bumpmap,
            $c702e238df7c5123$export$6643083551874bf5.normalmap,
            $c702e238df7c5123$export$6643083551874bf5.displacementmap,
            $c702e238df7c5123$export$6643083551874bf5.gradientmap,
            $c702e238df7c5123$export$6643083551874bf5.fog,
            $c702e238df7c5123$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: new $c702e238df7c5123$export$892596cec99bc70e(0x000000)
                }
            }
        ]),
        vertexShader: $c702e238df7c5123$export$955f9f2e84c43c8b.meshtoon_vert,
        fragmentShader: $c702e238df7c5123$export$955f9f2e84c43c8b.meshtoon_frag
    },
    matcap: {
        uniforms: $c702e238df7c5123$var$mergeUniforms([
            $c702e238df7c5123$export$6643083551874bf5.common,
            $c702e238df7c5123$export$6643083551874bf5.bumpmap,
            $c702e238df7c5123$export$6643083551874bf5.normalmap,
            $c702e238df7c5123$export$6643083551874bf5.displacementmap,
            $c702e238df7c5123$export$6643083551874bf5.fog,
            {
                matcap: {
                    value: null
                }
            }
        ]),
        vertexShader: $c702e238df7c5123$export$955f9f2e84c43c8b.meshmatcap_vert,
        fragmentShader: $c702e238df7c5123$export$955f9f2e84c43c8b.meshmatcap_frag
    },
    points: {
        uniforms: $c702e238df7c5123$var$mergeUniforms([
            $c702e238df7c5123$export$6643083551874bf5.points,
            $c702e238df7c5123$export$6643083551874bf5.fog
        ]),
        vertexShader: $c702e238df7c5123$export$955f9f2e84c43c8b.points_vert,
        fragmentShader: $c702e238df7c5123$export$955f9f2e84c43c8b.points_frag
    },
    dashed: {
        uniforms: $c702e238df7c5123$var$mergeUniforms([
            $c702e238df7c5123$export$6643083551874bf5.common,
            $c702e238df7c5123$export$6643083551874bf5.fog,
            {
                scale: {
                    value: 1
                },
                dashSize: {
                    value: 1
                },
                totalSize: {
                    value: 2
                }
            }
        ]),
        vertexShader: $c702e238df7c5123$export$955f9f2e84c43c8b.linedashed_vert,
        fragmentShader: $c702e238df7c5123$export$955f9f2e84c43c8b.linedashed_frag
    },
    depth: {
        uniforms: $c702e238df7c5123$var$mergeUniforms([
            $c702e238df7c5123$export$6643083551874bf5.common,
            $c702e238df7c5123$export$6643083551874bf5.displacementmap
        ]),
        vertexShader: $c702e238df7c5123$export$955f9f2e84c43c8b.depth_vert,
        fragmentShader: $c702e238df7c5123$export$955f9f2e84c43c8b.depth_frag
    },
    normal: {
        uniforms: $c702e238df7c5123$var$mergeUniforms([
            $c702e238df7c5123$export$6643083551874bf5.common,
            $c702e238df7c5123$export$6643083551874bf5.bumpmap,
            $c702e238df7c5123$export$6643083551874bf5.normalmap,
            $c702e238df7c5123$export$6643083551874bf5.displacementmap,
            {
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $c702e238df7c5123$export$955f9f2e84c43c8b.normal_vert,
        fragmentShader: $c702e238df7c5123$export$955f9f2e84c43c8b.normal_frag
    },
    sprite: {
        uniforms: $c702e238df7c5123$var$mergeUniforms([
            $c702e238df7c5123$export$6643083551874bf5.sprite,
            $c702e238df7c5123$export$6643083551874bf5.fog
        ]),
        vertexShader: $c702e238df7c5123$export$955f9f2e84c43c8b.sprite_vert,
        fragmentShader: $c702e238df7c5123$export$955f9f2e84c43c8b.sprite_frag
    },
    background: {
        uniforms: {
            uvTransform: {
                value: new $c702e238df7c5123$export$8ff26dafa08918()
            },
            t2D: {
                value: null
            }
        },
        vertexShader: $c702e238df7c5123$export$955f9f2e84c43c8b.background_vert,
        fragmentShader: $c702e238df7c5123$export$955f9f2e84c43c8b.background_frag
    },
    /* -------------------------------------------------------------------------
	//	Cube map shader
	 ------------------------------------------------------------------------- */ cube: {
        uniforms: $c702e238df7c5123$var$mergeUniforms([
            $c702e238df7c5123$export$6643083551874bf5.envmap,
            {
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $c702e238df7c5123$export$955f9f2e84c43c8b.cube_vert,
        fragmentShader: $c702e238df7c5123$export$955f9f2e84c43c8b.cube_frag
    },
    equirect: {
        uniforms: {
            tEquirect: {
                value: null
            }
        },
        vertexShader: $c702e238df7c5123$export$955f9f2e84c43c8b.equirect_vert,
        fragmentShader: $c702e238df7c5123$export$955f9f2e84c43c8b.equirect_frag
    },
    distanceRGBA: {
        uniforms: $c702e238df7c5123$var$mergeUniforms([
            $c702e238df7c5123$export$6643083551874bf5.common,
            $c702e238df7c5123$export$6643083551874bf5.displacementmap,
            {
                referencePosition: {
                    value: new $c702e238df7c5123$export$64b5c384219d3699()
                },
                nearDistance: {
                    value: 1
                },
                farDistance: {
                    value: 1000
                }
            }
        ]),
        vertexShader: $c702e238df7c5123$export$955f9f2e84c43c8b.distanceRGBA_vert,
        fragmentShader: $c702e238df7c5123$export$955f9f2e84c43c8b.distanceRGBA_frag
    },
    shadow: {
        uniforms: $c702e238df7c5123$var$mergeUniforms([
            $c702e238df7c5123$export$6643083551874bf5.lights,
            $c702e238df7c5123$export$6643083551874bf5.fog,
            {
                color: {
                    value: new $c702e238df7c5123$export$892596cec99bc70e(0x00000)
                },
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $c702e238df7c5123$export$955f9f2e84c43c8b.shadow_vert,
        fragmentShader: $c702e238df7c5123$export$955f9f2e84c43c8b.shadow_frag
    }
};
$c702e238df7c5123$export$bee4a7d47f8f5014.physical = {
    uniforms: $c702e238df7c5123$var$mergeUniforms([
        $c702e238df7c5123$export$bee4a7d47f8f5014.standard.uniforms,
        {
            clearcoat: {
                value: 0
            },
            clearcoatMap: {
                value: null
            },
            clearcoatRoughness: {
                value: 0
            },
            clearcoatRoughnessMap: {
                value: null
            },
            clearcoatNormalScale: {
                value: new $c702e238df7c5123$export$c977b3e384af9ae1(1, 1)
            },
            clearcoatNormalMap: {
                value: null
            },
            sheen: {
                value: new $c702e238df7c5123$export$892596cec99bc70e(0x000000)
            },
            transmission: {
                value: 0
            },
            transmissionMap: {
                value: null
            },
            transmissionSamplerSize: {
                value: new $c702e238df7c5123$export$c977b3e384af9ae1()
            },
            transmissionSamplerMap: {
                value: null
            },
            thickness: {
                value: 0
            },
            thicknessMap: {
                value: null
            },
            attenuationDistance: {
                value: 0
            },
            attenuationColor: {
                value: new $c702e238df7c5123$export$892596cec99bc70e(0x000000)
            }
        }
    ]),
    vertexShader: $c702e238df7c5123$export$955f9f2e84c43c8b.meshphysical_vert,
    fragmentShader: $c702e238df7c5123$export$955f9f2e84c43c8b.meshphysical_frag
};
function $c702e238df7c5123$var$WebGLBackground(renderer, cubemaps, state, objects, premultipliedAlpha) {
    var clearColor = new $c702e238df7c5123$export$892596cec99bc70e(0x000000);
    var clearAlpha = 0;
    var planeMesh;
    var boxMesh;
    var currentBackground = null;
    var currentBackgroundVersion = 0;
    var currentTonemapping = null;
    function render(renderList, scene) {
        var forceClear = false;
        var background = scene.isScene === true ? scene.background : null;
        if (background && background.isTexture) background = cubemaps.get(background);
        // Ignore background in AR
        // TODO: Reconsider this.
        var xr = renderer.xr;
        var session = xr.getSession && xr.getSession();
        if (session && session.environmentBlendMode === 'additive') background = null;
        if (background === null) setClear(clearColor, clearAlpha);
        else if (background && background.isColor) {
            setClear(background, 1);
            forceClear = true;
        }
        if (renderer.autoClear || forceClear) renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
        if (background && (background.isCubeTexture || background.mapping === $c702e238df7c5123$export$dbf3e70ff37af79)) {
            if (boxMesh === undefined) {
                boxMesh = new $c702e238df7c5123$export$e176487c05830cc5(new $c702e238df7c5123$export$ab3456a079aa7d80(1, 1, 1), new $c702e238df7c5123$export$83c7d75d550a8b0d({
                    name: 'BackgroundCubeMaterial',
                    uniforms: $c702e238df7c5123$var$cloneUniforms($c702e238df7c5123$export$bee4a7d47f8f5014.cube.uniforms),
                    vertexShader: $c702e238df7c5123$export$bee4a7d47f8f5014.cube.vertexShader,
                    fragmentShader: $c702e238df7c5123$export$bee4a7d47f8f5014.cube.fragmentShader,
                    side: $c702e238df7c5123$export$d9f0486e75b5ace,
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                }));
                boxMesh.geometry.deleteAttribute('normal');
                boxMesh.geometry.deleteAttribute('uv');
                boxMesh.onBeforeRender = function(renderer, scene, camera) {
                    this.matrixWorld.copyPosition(camera.matrixWorld);
                };
                // enable code injection for non-built-in material
                Object.defineProperty(boxMesh.material, 'envMap', {
                    get: function get() {
                        return this.uniforms.envMap.value;
                    }
                });
                objects.update(boxMesh);
            }
            boxMesh.material.uniforms.envMap.value = background;
            boxMesh.material.uniforms.flipEnvMap.value = background.isCubeTexture && background._needsFlipEnvMap ? -1 : 1;
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                boxMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            // push to the pre-sorted opaque render list
            renderList.unshift(boxMesh, boxMesh.geometry, boxMesh.material, 0, 0, null);
        } else if (background && background.isTexture) {
            if (planeMesh === undefined) {
                planeMesh = new $c702e238df7c5123$export$e176487c05830cc5(new $c702e238df7c5123$export$e789a11a194ca4e0(2, 2), new $c702e238df7c5123$export$83c7d75d550a8b0d({
                    name: 'BackgroundMaterial',
                    uniforms: $c702e238df7c5123$var$cloneUniforms($c702e238df7c5123$export$bee4a7d47f8f5014.background.uniforms),
                    vertexShader: $c702e238df7c5123$export$bee4a7d47f8f5014.background.vertexShader,
                    fragmentShader: $c702e238df7c5123$export$bee4a7d47f8f5014.background.fragmentShader,
                    side: $c702e238df7c5123$export$2ede184fc2998901,
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                }));
                planeMesh.geometry.deleteAttribute('normal');
                // enable code injection for non-built-in material
                Object.defineProperty(planeMesh.material, 'map', {
                    get: function get() {
                        return this.uniforms.t2D.value;
                    }
                });
                objects.update(planeMesh);
            }
            planeMesh.material.uniforms.t2D.value = background;
            if (background.matrixAutoUpdate === true) background.updateMatrix();
            planeMesh.material.uniforms.uvTransform.value.copy(background.matrix);
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                planeMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            // push to the pre-sorted opaque render list
            renderList.unshift(planeMesh, planeMesh.geometry, planeMesh.material, 0, 0, null);
        }
    }
    function setClear(color, alpha) {
        state.buffers.color.setClear(color.r, color.g, color.b, alpha, premultipliedAlpha);
    }
    return {
        getClearColor: function getClearColor() {
            return clearColor;
        },
        setClearColor: function setClearColor(color) {
            var alpha = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
            clearColor.set(color);
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        getClearAlpha: function getClearAlpha() {
            return clearAlpha;
        },
        setClearAlpha: function setClearAlpha(alpha) {
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        render: render
    };
}
function $c702e238df7c5123$var$WebGLBindingStates(gl, extensions, attributes, capabilities) {
    var maxVertexAttributes = gl.getParameter(34921);
    var extension = capabilities.isWebGL2 ? null : extensions.get('OES_vertex_array_object');
    var vaoAvailable = capabilities.isWebGL2 || extension !== null;
    var bindingStates = {};
    var defaultState = createBindingState(null);
    var currentState = defaultState;
    function setup(object, material, program, geometry, index) {
        var updateBuffers = false;
        if (vaoAvailable) {
            var state = getBindingState(geometry, program, material);
            if (currentState !== state) {
                currentState = state;
                bindVertexArrayObject(currentState.object);
            }
            updateBuffers = needsUpdate(geometry, index);
            if (updateBuffers) saveCache(geometry, index);
        } else {
            var wireframe = material.wireframe === true;
            if (currentState.geometry !== geometry.id || currentState.program !== program.id || currentState.wireframe !== wireframe) {
                currentState.geometry = geometry.id;
                currentState.program = program.id;
                currentState.wireframe = wireframe;
                updateBuffers = true;
            }
        }
        if (object.isInstancedMesh === true) updateBuffers = true;
        if (index !== null) attributes.update(index, 34963);
        if (updateBuffers) {
            setupVertexAttributes(object, material, program, geometry);
            if (index !== null) gl.bindBuffer(34963, attributes.get(index).buffer);
        }
    }
    function createVertexArrayObject() {
        if (capabilities.isWebGL2) return gl.createVertexArray();
        return extension.createVertexArrayOES();
    }
    function bindVertexArrayObject(vao) {
        if (capabilities.isWebGL2) return gl.bindVertexArray(vao);
        return extension.bindVertexArrayOES(vao);
    }
    function deleteVertexArrayObject(vao) {
        if (capabilities.isWebGL2) return gl.deleteVertexArray(vao);
        return extension.deleteVertexArrayOES(vao);
    }
    function getBindingState(geometry, program, material) {
        var wireframe = material.wireframe === true;
        var programMap = bindingStates[geometry.id];
        if (programMap === undefined) {
            programMap = {};
            bindingStates[geometry.id] = programMap;
        }
        var stateMap = programMap[program.id];
        if (stateMap === undefined) {
            stateMap = {};
            programMap[program.id] = stateMap;
        }
        var state = stateMap[wireframe];
        if (state === undefined) {
            state = createBindingState(createVertexArrayObject());
            stateMap[wireframe] = state;
        }
        return state;
    }
    function createBindingState(vao) {
        var newAttributes = [];
        var enabledAttributes = [];
        var attributeDivisors = [];
        for(var i = 0; i < maxVertexAttributes; i++){
            newAttributes[i] = 0;
            enabledAttributes[i] = 0;
            attributeDivisors[i] = 0;
        }
        return {
            // for backward compatibility on non-VAO support browser
            geometry: null,
            program: null,
            wireframe: false,
            newAttributes: newAttributes,
            enabledAttributes: enabledAttributes,
            attributeDivisors: attributeDivisors,
            object: vao,
            attributes: {},
            index: null
        };
    }
    function needsUpdate(geometry, index) {
        var cachedAttributes = currentState.attributes;
        var geometryAttributes = geometry.attributes;
        var attributesNum = 0;
        for(var key in geometryAttributes){
            var cachedAttribute = cachedAttributes[key];
            var geometryAttribute = geometryAttributes[key];
            if (cachedAttribute === undefined) return true;
            if (cachedAttribute.attribute !== geometryAttribute) return true;
            if (cachedAttribute.data !== geometryAttribute.data) return true;
            attributesNum++;
        }
        if (currentState.attributesNum !== attributesNum) return true;
        if (currentState.index !== index) return true;
        return false;
    }
    function saveCache(geometry, index) {
        var cache = {};
        var attributes = geometry.attributes;
        var attributesNum = 0;
        for(var key in attributes){
            var attribute = attributes[key];
            var data = {};
            data.attribute = attribute;
            if (attribute.data) data.data = attribute.data;
            cache[key] = data;
            attributesNum++;
        }
        currentState.attributes = cache;
        currentState.attributesNum = attributesNum;
        currentState.index = index;
    }
    function initAttributes() {
        var newAttributes = currentState.newAttributes;
        for(var i = 0, il = newAttributes.length; i < il; i++)newAttributes[i] = 0;
    }
    function enableAttribute(attribute) {
        enableAttributeAndDivisor(attribute, 0);
    }
    function enableAttributeAndDivisor(attribute, meshPerAttribute) {
        var newAttributes = currentState.newAttributes;
        var enabledAttributes = currentState.enabledAttributes;
        var attributeDivisors = currentState.attributeDivisors;
        newAttributes[attribute] = 1;
        if (enabledAttributes[attribute] === 0) {
            gl.enableVertexAttribArray(attribute);
            enabledAttributes[attribute] = 1;
        }
        if (attributeDivisors[attribute] !== meshPerAttribute) {
            var extension = capabilities.isWebGL2 ? gl : extensions.get('ANGLE_instanced_arrays');
            extension[capabilities.isWebGL2 ? 'vertexAttribDivisor' : 'vertexAttribDivisorANGLE'](attribute, meshPerAttribute);
            attributeDivisors[attribute] = meshPerAttribute;
        }
    }
    function disableUnusedAttributes() {
        var newAttributes = currentState.newAttributes;
        var enabledAttributes = currentState.enabledAttributes;
        for(var i = 0, il = enabledAttributes.length; i < il; i++)if (enabledAttributes[i] !== newAttributes[i]) {
            gl.disableVertexAttribArray(i);
            enabledAttributes[i] = 0;
        }
    }
    function vertexAttribPointer(index, size, type, normalized, stride, offset) {
        if (capabilities.isWebGL2 === true && (type === 5124 || type === 5125)) gl.vertexAttribIPointer(index, size, type, stride, offset);
        else gl.vertexAttribPointer(index, size, type, normalized, stride, offset);
    }
    function setupVertexAttributes(object, material, program, geometry) {
        if (capabilities.isWebGL2 === false && (object.isInstancedMesh || geometry.isInstancedBufferGeometry)) {
            if (extensions.get('ANGLE_instanced_arrays') === null) return;
        }
        initAttributes();
        var geometryAttributes = geometry.attributes;
        var programAttributes = program.getAttributes();
        var materialDefaultAttributeValues = material.defaultAttributeValues;
        for(var name in programAttributes){
            var programAttribute = programAttributes[name];
            if (programAttribute >= 0) {
                var geometryAttribute = geometryAttributes[name];
                if (geometryAttribute !== undefined) {
                    var normalized = geometryAttribute.normalized;
                    var size = geometryAttribute.itemSize;
                    var attribute = attributes.get(geometryAttribute);
                    // TODO Attribute may not be available on context restore
                    if (attribute === undefined) continue;
                    var buffer = attribute.buffer;
                    var type = attribute.type;
                    var bytesPerElement = attribute.bytesPerElement;
                    if (geometryAttribute.isInterleavedBufferAttribute) {
                        var data = geometryAttribute.data;
                        var stride = data.stride;
                        var offset = geometryAttribute.offset;
                        if (data && data.isInstancedInterleavedBuffer) {
                            enableAttributeAndDivisor(programAttribute, data.meshPerAttribute);
                            if (geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = data.meshPerAttribute * data.count;
                        } else enableAttribute(programAttribute);
                        gl.bindBuffer(34962, buffer);
                        vertexAttribPointer(programAttribute, size, type, normalized, stride * bytesPerElement, offset * bytesPerElement);
                    } else {
                        if (geometryAttribute.isInstancedBufferAttribute) {
                            enableAttributeAndDivisor(programAttribute, geometryAttribute.meshPerAttribute);
                            if (geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;
                        } else enableAttribute(programAttribute);
                        gl.bindBuffer(34962, buffer);
                        vertexAttribPointer(programAttribute, size, type, normalized, 0, 0);
                    }
                } else if (name === 'instanceMatrix') {
                    var attribute1 = attributes.get(object.instanceMatrix);
                    // TODO Attribute may not be available on context restore
                    if (attribute1 === undefined) continue;
                    var buffer1 = attribute1.buffer;
                    var type1 = attribute1.type;
                    enableAttributeAndDivisor(programAttribute + 0, 1);
                    enableAttributeAndDivisor(programAttribute + 1, 1);
                    enableAttributeAndDivisor(programAttribute + 2, 1);
                    enableAttributeAndDivisor(programAttribute + 3, 1);
                    gl.bindBuffer(34962, buffer1);
                    gl.vertexAttribPointer(programAttribute + 0, 4, type1, false, 64, 0);
                    gl.vertexAttribPointer(programAttribute + 1, 4, type1, false, 64, 16);
                    gl.vertexAttribPointer(programAttribute + 2, 4, type1, false, 64, 32);
                    gl.vertexAttribPointer(programAttribute + 3, 4, type1, false, 64, 48);
                } else if (name === 'instanceColor') {
                    var attribute2 = attributes.get(object.instanceColor);
                    // TODO Attribute may not be available on context restore
                    if (attribute2 === undefined) continue;
                    var buffer2 = attribute2.buffer;
                    var type2 = attribute2.type;
                    enableAttributeAndDivisor(programAttribute, 1);
                    gl.bindBuffer(34962, buffer2);
                    gl.vertexAttribPointer(programAttribute, 3, type2, false, 12, 0);
                } else if (materialDefaultAttributeValues !== undefined) {
                    var value = materialDefaultAttributeValues[name];
                    if (value !== undefined) switch(value.length){
                        case 2:
                            gl.vertexAttrib2fv(programAttribute, value);
                            break;
                        case 3:
                            gl.vertexAttrib3fv(programAttribute, value);
                            break;
                        case 4:
                            gl.vertexAttrib4fv(programAttribute, value);
                            break;
                        default:
                            gl.vertexAttrib1fv(programAttribute, value);
                    }
                }
            }
        }
        disableUnusedAttributes();
    }
    function dispose() {
        reset();
        for(var geometryId in bindingStates){
            var programMap = bindingStates[geometryId];
            for(var programId in programMap){
                var stateMap = programMap[programId];
                for(var wireframe in stateMap){
                    deleteVertexArrayObject(stateMap[wireframe].object);
                    delete stateMap[wireframe];
                }
                delete programMap[programId];
            }
            delete bindingStates[geometryId];
        }
    }
    function releaseStatesOfGeometry(geometry) {
        if (bindingStates[geometry.id] === undefined) return;
        var programMap = bindingStates[geometry.id];
        for(var programId in programMap){
            var stateMap = programMap[programId];
            for(var wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[programId];
        }
        delete bindingStates[geometry.id];
    }
    function releaseStatesOfProgram(program) {
        for(var geometryId in bindingStates){
            var programMap = bindingStates[geometryId];
            if (programMap[program.id] === undefined) continue;
            var stateMap = programMap[program.id];
            for(var wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[program.id];
        }
    }
    function reset() {
        resetDefaultState();
        if (currentState === defaultState) return;
        currentState = defaultState;
        bindVertexArrayObject(currentState.object);
    }
    // for backward-compatilibity
    function resetDefaultState() {
        defaultState.geometry = null;
        defaultState.program = null;
        defaultState.wireframe = false;
    }
    return {
        setup: setup,
        reset: reset,
        resetDefaultState: resetDefaultState,
        dispose: dispose,
        releaseStatesOfGeometry: releaseStatesOfGeometry,
        releaseStatesOfProgram: releaseStatesOfProgram,
        initAttributes: initAttributes,
        enableAttribute: enableAttribute,
        disableUnusedAttributes: disableUnusedAttributes
    };
}
function $c702e238df7c5123$var$WebGLBufferRenderer(gl, extensions, info, capabilities) {
    var isWebGL2 = capabilities.isWebGL2;
    var mode;
    function setMode(value) {
        mode = value;
    }
    function render(start, count) {
        gl.drawArrays(mode, start, count);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        var extension, methodName;
        if (isWebGL2) {
            extension = gl;
            methodName = 'drawArraysInstanced';
        } else {
            extension = extensions.get('ANGLE_instanced_arrays');
            methodName = 'drawArraysInstancedANGLE';
            if (extension === null) {
                console.error('THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.');
                return;
            }
        }
        extension[methodName](mode, start, count, primcount);
        info.update(count, mode, primcount);
    }
    //
    this.setMode = setMode;
    this.render = render;
    this.renderInstances = renderInstances;
}
function $c702e238df7c5123$var$WebGLCapabilities(gl, extensions, parameters) {
    var maxAnisotropy;
    function getMaxAnisotropy() {
        if (maxAnisotropy !== undefined) return maxAnisotropy;
        if (extensions.has('EXT_texture_filter_anisotropic') === true) {
            var extension = extensions.get('EXT_texture_filter_anisotropic');
            maxAnisotropy = gl.getParameter(extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
        } else maxAnisotropy = 0;
        return maxAnisotropy;
    }
    function getMaxPrecision(precision) {
        if (precision === 'highp') {
            if (gl.getShaderPrecisionFormat(35633, 36338).precision > 0 && gl.getShaderPrecisionFormat(35632, 36338).precision > 0) return 'highp';
            precision = 'mediump';
        }
        if (precision === 'mediump') {
            if (gl.getShaderPrecisionFormat(35633, 36337).precision > 0 && gl.getShaderPrecisionFormat(35632, 36337).precision > 0) return 'mediump';
        }
        return 'lowp';
    }
    /* eslint-disable no-undef */ var isWebGL2 = typeof WebGL2RenderingContext !== 'undefined' && gl instanceof WebGL2RenderingContext || typeof WebGL2ComputeRenderingContext !== 'undefined' && gl instanceof WebGL2ComputeRenderingContext;
    /* eslint-enable no-undef */ var precision = parameters.precision !== undefined ? parameters.precision : 'highp';
    var maxPrecision = getMaxPrecision(precision);
    if (maxPrecision !== precision) {
        console.warn('THREE.WebGLRenderer:', precision, 'not supported, using', maxPrecision, 'instead.');
        precision = maxPrecision;
    }
    var drawBuffers = isWebGL2 || extensions.has('WEBGL_draw_buffers');
    var logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true;
    var maxTextures = gl.getParameter(34930);
    var maxVertexTextures = gl.getParameter(35660);
    var maxTextureSize = gl.getParameter(3379);
    var maxCubemapSize = gl.getParameter(34076);
    var maxAttributes = gl.getParameter(34921);
    var maxVertexUniforms = gl.getParameter(36347);
    var maxVaryings = gl.getParameter(36348);
    var maxFragmentUniforms = gl.getParameter(36349);
    var vertexTextures = maxVertexTextures > 0;
    var floatFragmentTextures = isWebGL2 || extensions.has('OES_texture_float');
    var floatVertexTextures = vertexTextures && floatFragmentTextures;
    var maxSamples = isWebGL2 ? gl.getParameter(36183) : 0;
    return {
        isWebGL2: isWebGL2,
        drawBuffers: drawBuffers,
        getMaxAnisotropy: getMaxAnisotropy,
        getMaxPrecision: getMaxPrecision,
        precision: precision,
        logarithmicDepthBuffer: logarithmicDepthBuffer,
        maxTextures: maxTextures,
        maxVertexTextures: maxVertexTextures,
        maxTextureSize: maxTextureSize,
        maxCubemapSize: maxCubemapSize,
        maxAttributes: maxAttributes,
        maxVertexUniforms: maxVertexUniforms,
        maxVaryings: maxVaryings,
        maxFragmentUniforms: maxFragmentUniforms,
        vertexTextures: vertexTextures,
        floatFragmentTextures: floatFragmentTextures,
        floatVertexTextures: floatVertexTextures,
        maxSamples: maxSamples
    };
}
function $c702e238df7c5123$var$WebGLClipping(properties) {
    var scope = this;
    var globalState = null, numGlobalPlanes = 0, localClippingEnabled = false, renderingShadows = false;
    var plane = new $c702e238df7c5123$export$7ff5ac152ef991b0(), viewNormalMatrix = new $c702e238df7c5123$export$8ff26dafa08918(), uniform = {
        value: null,
        needsUpdate: false
    };
    this.uniform = uniform;
    this.numPlanes = 0;
    this.numIntersection = 0;
    this.init = function(planes, enableLocalClipping, camera) {
        var enabled = planes.length !== 0 || enableLocalClipping || // enable state of previous frame - the clipping code has to
        // run another frame in order to reset the state:
        numGlobalPlanes !== 0 || localClippingEnabled;
        localClippingEnabled = enableLocalClipping;
        globalState = projectPlanes(planes, camera, 0);
        numGlobalPlanes = planes.length;
        return enabled;
    };
    this.beginShadows = function() {
        renderingShadows = true;
        projectPlanes(null);
    };
    this.endShadows = function() {
        renderingShadows = false;
        resetGlobalState();
    };
    this.setState = function(material, camera, useCache) {
        var planes = material.clippingPlanes, clipIntersection = material.clipIntersection, clipShadows = material.clipShadows;
        var materialProperties = properties.get(material);
        if (!localClippingEnabled || planes === null || planes.length === 0 || renderingShadows && !clipShadows) {
            // there's no local clipping
            if (renderingShadows) // there's no global clipping
            projectPlanes(null);
            else resetGlobalState();
        } else {
            var nGlobal = renderingShadows ? 0 : numGlobalPlanes, lGlobal = nGlobal * 4;
            var dstArray = materialProperties.clippingState || null;
            uniform.value = dstArray; // ensure unique state
            dstArray = projectPlanes(planes, camera, lGlobal, useCache);
            for(var i = 0; i !== lGlobal; ++i)dstArray[i] = globalState[i];
            materialProperties.clippingState = dstArray;
            this.numIntersection = clipIntersection ? this.numPlanes : 0;
            this.numPlanes += nGlobal;
        }
    };
    function resetGlobalState() {
        if (uniform.value !== globalState) {
            uniform.value = globalState;
            uniform.needsUpdate = numGlobalPlanes > 0;
        }
        scope.numPlanes = numGlobalPlanes;
        scope.numIntersection = 0;
    }
    function projectPlanes(planes, camera, dstOffset, skipTransform) {
        var nPlanes = planes !== null ? planes.length : 0;
        var dstArray = null;
        if (nPlanes !== 0) {
            dstArray = uniform.value;
            if (skipTransform !== true || dstArray === null) {
                var flatSize = dstOffset + nPlanes * 4, viewMatrix = camera.matrixWorldInverse;
                viewNormalMatrix.getNormalMatrix(viewMatrix);
                if (dstArray === null || dstArray.length < flatSize) dstArray = new Float32Array(flatSize);
                for(var i = 0, i4 = dstOffset; i !== nPlanes; ++i, i4 += 4){
                    plane.copy(planes[i]).applyMatrix4(viewMatrix, viewNormalMatrix);
                    plane.normal.toArray(dstArray, i4);
                    dstArray[i4 + 3] = plane.constant;
                }
            }
            uniform.value = dstArray;
            uniform.needsUpdate = true;
        }
        scope.numPlanes = nPlanes;
        scope.numIntersection = 0;
        return dstArray;
    }
}
function $c702e238df7c5123$var$WebGLCubeMaps(renderer) {
    var cubemaps = new WeakMap();
    function mapTextureMapping(texture, mapping) {
        if (mapping === $c702e238df7c5123$export$d64030b316d3b087) texture.mapping = $c702e238df7c5123$export$8759762a6477f2c4;
        else if (mapping === $c702e238df7c5123$export$ee99d97d46898098) texture.mapping = $c702e238df7c5123$export$dc59f8aed047f61d;
        return texture;
    }
    function get(texture) {
        if (texture && texture.isTexture) {
            var mapping = texture.mapping;
            if (mapping === $c702e238df7c5123$export$d64030b316d3b087 || mapping === $c702e238df7c5123$export$ee99d97d46898098) {
                if (cubemaps.has(texture)) {
                    var cubemap = cubemaps.get(texture).texture;
                    return mapTextureMapping(cubemap, texture.mapping);
                } else {
                    var image = texture.image;
                    if (image && image.height > 0) {
                        var currentRenderTarget = renderer.getRenderTarget();
                        var renderTarget = new $c702e238df7c5123$export$ac386671d651941e(image.height / 2);
                        renderTarget.fromEquirectangularTexture(renderer, texture);
                        cubemaps.set(texture, renderTarget);
                        renderer.setRenderTarget(currentRenderTarget);
                        texture.addEventListener('dispose', onTextureDispose);
                        return mapTextureMapping(renderTarget.texture, texture.mapping);
                    } else // image not yet ready. try the conversion next frame
                    return null;
                }
            }
        }
        return texture;
    }
    function onTextureDispose(event) {
        var texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        var cubemap = cubemaps.get(texture);
        if (cubemap !== undefined) {
            cubemaps["delete"](texture);
            cubemap.dispose();
        }
    }
    function dispose() {
        cubemaps = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $c702e238df7c5123$var$WebGLExtensions(gl) {
    var extensions = {};
    function getExtension(name) {
        if (extensions[name] !== undefined) return extensions[name];
        var extension;
        switch(name){
            case 'WEBGL_depth_texture':
                extension = gl.getExtension('WEBGL_depth_texture') || gl.getExtension('MOZ_WEBGL_depth_texture') || gl.getExtension('WEBKIT_WEBGL_depth_texture');
                break;
            case 'EXT_texture_filter_anisotropic':
                extension = gl.getExtension('EXT_texture_filter_anisotropic') || gl.getExtension('MOZ_EXT_texture_filter_anisotropic') || gl.getExtension('WEBKIT_EXT_texture_filter_anisotropic');
                break;
            case 'WEBGL_compressed_texture_s3tc':
                extension = gl.getExtension('WEBGL_compressed_texture_s3tc') || gl.getExtension('MOZ_WEBGL_compressed_texture_s3tc') || gl.getExtension('WEBKIT_WEBGL_compressed_texture_s3tc');
                break;
            case 'WEBGL_compressed_texture_pvrtc':
                extension = gl.getExtension('WEBGL_compressed_texture_pvrtc') || gl.getExtension('WEBKIT_WEBGL_compressed_texture_pvrtc');
                break;
            default:
                extension = gl.getExtension(name);
        }
        extensions[name] = extension;
        return extension;
    }
    return {
        has: function has(name) {
            return getExtension(name) !== null;
        },
        init: function init(capabilities) {
            if (capabilities.isWebGL2) getExtension('EXT_color_buffer_float');
            else {
                getExtension('WEBGL_depth_texture');
                getExtension('OES_texture_float');
                getExtension('OES_texture_half_float');
                getExtension('OES_texture_half_float_linear');
                getExtension('OES_standard_derivatives');
                getExtension('OES_element_index_uint');
                getExtension('OES_vertex_array_object');
                getExtension('ANGLE_instanced_arrays');
            }
            getExtension('OES_texture_float_linear');
            getExtension('EXT_color_buffer_half_float');
        },
        get: function get(name) {
            var extension = getExtension(name);
            if (extension === null) console.warn('THREE.WebGLRenderer: ' + name + ' extension not supported.');
            return extension;
        }
    };
}
function $c702e238df7c5123$var$WebGLGeometries(gl, attributes, info, bindingStates) {
    var geometries = {};
    var wireframeAttributes = new WeakMap();
    function onGeometryDispose(event) {
        var geometry = event.target;
        if (geometry.index !== null) attributes.remove(geometry.index);
        for(var name in geometry.attributes)attributes.remove(geometry.attributes[name]);
        geometry.removeEventListener('dispose', onGeometryDispose);
        delete geometries[geometry.id];
        var attribute = wireframeAttributes.get(geometry);
        if (attribute) {
            attributes.remove(attribute);
            wireframeAttributes["delete"](geometry);
        }
        bindingStates.releaseStatesOfGeometry(geometry);
        if (geometry.isInstancedBufferGeometry === true) delete geometry._maxInstanceCount;
        //
        info.memory.geometries--;
    }
    function get(object, geometry) {
        if (geometries[geometry.id] === true) return geometry;
        geometry.addEventListener('dispose', onGeometryDispose);
        geometries[geometry.id] = true;
        info.memory.geometries++;
        return geometry;
    }
    function update(geometry) {
        var geometryAttributes = geometry.attributes;
        // Updating index buffer in VAO now. See WebGLBindingStates.
        for(var name in geometryAttributes)attributes.update(geometryAttributes[name], 34962);
        // morph targets
        var morphAttributes = geometry.morphAttributes;
        for(var name1 in morphAttributes){
            var array = morphAttributes[name1];
            for(var i = 0, l = array.length; i < l; i++)attributes.update(array[i], 34962);
        }
    }
    function updateWireframeAttribute(geometry) {
        var indices = [];
        var geometryIndex = geometry.index;
        var geometryPosition = geometry.attributes.position;
        var version = 0;
        if (geometryIndex !== null) {
            var array = geometryIndex.array;
            version = geometryIndex.version;
            for(var i = 0, l = array.length; i < l; i += 3){
                var a = array[i + 0];
                var b = array[i + 1];
                var c = array[i + 2];
                indices.push(a, b, b, c, c, a);
            }
        } else {
            var array1 = geometryPosition.array;
            version = geometryPosition.version;
            for(var i1 = 0, l1 = array1.length / 3 - 1; i1 < l1; i1 += 3){
                var a1 = i1 + 0;
                var b1 = i1 + 1;
                var c1 = i1 + 2;
                indices.push(a1, b1, b1, c1, c1, a1);
            }
        }
        var attribute = new ($c702e238df7c5123$var$arrayMax(indices) > 65535 ? $c702e238df7c5123$export$7eb8c9fa25cd5bd6 : $c702e238df7c5123$export$640a853f68025f2e)(indices, 1);
        attribute.version = version;
        // Updating index buffer in VAO now. See WebGLBindingStates
        //
        var previousAttribute = wireframeAttributes.get(geometry);
        if (previousAttribute) attributes.remove(previousAttribute);
        //
        wireframeAttributes.set(geometry, attribute);
    }
    function getWireframeAttribute(geometry) {
        var currentAttribute = wireframeAttributes.get(geometry);
        if (currentAttribute) {
            var geometryIndex = geometry.index;
            if (geometryIndex !== null) // if the attribute is obsolete, create a new one
            {
                if (currentAttribute.version < geometryIndex.version) updateWireframeAttribute(geometry);
            }
        } else updateWireframeAttribute(geometry);
        return wireframeAttributes.get(geometry);
    }
    return {
        get: get,
        update: update,
        getWireframeAttribute: getWireframeAttribute
    };
}
function $c702e238df7c5123$var$WebGLIndexedBufferRenderer(gl, extensions, info, capabilities) {
    var isWebGL2 = capabilities.isWebGL2;
    var mode;
    function setMode(value) {
        mode = value;
    }
    var type, bytesPerElement;
    function setIndex(value) {
        type = value.type;
        bytesPerElement = value.bytesPerElement;
    }
    function render(start, count) {
        gl.drawElements(mode, count, type, start * bytesPerElement);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        var extension, methodName;
        if (isWebGL2) {
            extension = gl;
            methodName = 'drawElementsInstanced';
        } else {
            extension = extensions.get('ANGLE_instanced_arrays');
            methodName = 'drawElementsInstancedANGLE';
            if (extension === null) {
                console.error('THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.');
                return;
            }
        }
        extension[methodName](mode, count, type, start * bytesPerElement, primcount);
        info.update(count, mode, primcount);
    }
    //
    this.setMode = setMode;
    this.setIndex = setIndex;
    this.render = render;
    this.renderInstances = renderInstances;
}
function $c702e238df7c5123$var$WebGLInfo(gl) {
    var memory = {
        geometries: 0,
        textures: 0
    };
    var render = {
        frame: 0,
        calls: 0,
        triangles: 0,
        points: 0,
        lines: 0
    };
    function update(count, mode, instanceCount) {
        render.calls++;
        switch(mode){
            case 4:
                render.triangles += instanceCount * (count / 3);
                break;
            case 1:
                render.lines += instanceCount * (count / 2);
                break;
            case 3:
                render.lines += instanceCount * (count - 1);
                break;
            case 2:
                render.lines += instanceCount * count;
                break;
            case 0:
                render.points += instanceCount * count;
                break;
            default:
                console.error('THREE.WebGLInfo: Unknown draw mode:', mode);
                break;
        }
    }
    function reset() {
        render.frame++;
        render.calls = 0;
        render.triangles = 0;
        render.points = 0;
        render.lines = 0;
    }
    return {
        memory: memory,
        render: render,
        programs: null,
        autoReset: true,
        reset: reset,
        update: update
    };
}
function $c702e238df7c5123$var$numericalSort(a, b) {
    return a[0] - b[0];
}
function $c702e238df7c5123$var$absNumericalSort(a, b) {
    return Math.abs(b[1]) - Math.abs(a[1]);
}
function $c702e238df7c5123$var$WebGLMorphtargets(gl) {
    var influencesList = {};
    var morphInfluences = new Float32Array(8);
    var workInfluences = [];
    for(var i = 0; i < 8; i++)workInfluences[i] = [
        i,
        0
    ];
    function update(object, geometry, material, program) {
        var objectInfluences = object.morphTargetInfluences;
        // When object doesn't have morph target influences defined, we treat it as a 0-length array
        // This is important to make sure we set up morphTargetBaseInfluence / morphTargetInfluences
        var length = objectInfluences === undefined ? 0 : objectInfluences.length;
        var influences = influencesList[geometry.id];
        if (influences === undefined || influences.length !== length) {
            // initialise list
            influences = [];
            for(var i = 0; i < length; i++)influences[i] = [
                i,
                0
            ];
            influencesList[geometry.id] = influences;
        }
        // Collect influences
        for(var i1 = 0; i1 < length; i1++){
            var influence = influences[i1];
            influence[0] = i1;
            influence[1] = objectInfluences[i1];
        }
        influences.sort($c702e238df7c5123$var$absNumericalSort);
        for(var i2 = 0; i2 < 8; i2++)if (i2 < length && influences[i2][1]) {
            workInfluences[i2][0] = influences[i2][0];
            workInfluences[i2][1] = influences[i2][1];
        } else {
            workInfluences[i2][0] = Number.MAX_SAFE_INTEGER;
            workInfluences[i2][1] = 0;
        }
        workInfluences.sort($c702e238df7c5123$var$numericalSort);
        var morphTargets = material.morphTargets && geometry.morphAttributes.position;
        var morphNormals = material.morphNormals && geometry.morphAttributes.normal;
        var morphInfluencesSum = 0;
        for(var i3 = 0; i3 < 8; i3++){
            var influence1 = workInfluences[i3];
            var index = influence1[0];
            var value = influence1[1];
            if (index !== Number.MAX_SAFE_INTEGER && value) {
                if (morphTargets && geometry.getAttribute('morphTarget' + i3) !== morphTargets[index]) geometry.setAttribute('morphTarget' + i3, morphTargets[index]);
                if (morphNormals && geometry.getAttribute('morphNormal' + i3) !== morphNormals[index]) geometry.setAttribute('morphNormal' + i3, morphNormals[index]);
                morphInfluences[i3] = value;
                morphInfluencesSum += value;
            } else {
                if (morphTargets && geometry.hasAttribute('morphTarget' + i3) === true) geometry.deleteAttribute('morphTarget' + i3);
                if (morphNormals && geometry.hasAttribute('morphNormal' + i3) === true) geometry.deleteAttribute('morphNormal' + i3);
                morphInfluences[i3] = 0;
            }
        }
        // GLSL shader uses formula baseinfluence * base + sum(target * influence)
        // This allows us to switch between absolute morphs and relative morphs without changing shader code
        // When baseinfluence = 1 - sum(influence), the above is equivalent to sum((target - base) * influence)
        var morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
        program.getUniforms().setValue(gl, 'morphTargetBaseInfluence', morphBaseInfluence);
        program.getUniforms().setValue(gl, 'morphTargetInfluences', morphInfluences);
    }
    return {
        update: update
    };
}
function $c702e238df7c5123$var$WebGLObjects(gl, geometries, attributes, info) {
    var updateMap = new WeakMap();
    function update(object) {
        var frame = info.render.frame;
        var geometry = object.geometry;
        var buffergeometry = geometries.get(object, geometry);
        // Update once per frame
        if (updateMap.get(buffergeometry) !== frame) {
            geometries.update(buffergeometry);
            updateMap.set(buffergeometry, frame);
        }
        if (object.isInstancedMesh) {
            if (object.hasEventListener('dispose', onInstancedMeshDispose) === false) object.addEventListener('dispose', onInstancedMeshDispose);
            attributes.update(object.instanceMatrix, 34962);
            if (object.instanceColor !== null) attributes.update(object.instanceColor, 34962);
        }
        return buffergeometry;
    }
    function dispose() {
        updateMap = new WeakMap();
    }
    function onInstancedMeshDispose(event) {
        var instancedMesh = event.target;
        instancedMesh.removeEventListener('dispose', onInstancedMeshDispose);
        attributes.remove(instancedMesh.instanceMatrix);
        if (instancedMesh.instanceColor !== null) attributes.remove(instancedMesh.instanceColor);
    }
    return {
        update: update,
        dispose: dispose
    };
}
var $c702e238df7c5123$export$e38bf4541665bbbd = /*#__PURE__*/ function(Texture) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(DataTexture2DArray, Texture);
    function DataTexture2DArray() {
        var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, width = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, height = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, depth = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, DataTexture2DArray);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, DataTexture2DArray, [
            null
        ]);
        _this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        _this.magFilter = $c702e238df7c5123$export$727aa5ec3fe39bf0;
        _this.minFilter = $c702e238df7c5123$export$727aa5ec3fe39bf0;
        _this.wrapR = $c702e238df7c5123$export$9d9334239a5a5e06;
        _this.generateMipmaps = false;
        _this.flipY = false;
        _this.unpackAlignment = 1;
        _this.needsUpdate = true;
        return _this;
    }
    return DataTexture2DArray;
}($c702e238df7c5123$export$5431306cf43de24a);
$c702e238df7c5123$export$e38bf4541665bbbd.prototype.isDataTexture2DArray = true;
var $c702e238df7c5123$export$ef03cdc98340bab4 = /*#__PURE__*/ function(Texture) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(DataTexture3D, Texture);
    function DataTexture3D() {
        var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, width = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, height = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, depth = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, DataTexture3D);
        var _this;
        // We're going to add .setXXX() methods for setting properties later.
        // Users can still set in DataTexture3D directly.
        //
        //	const texture = new THREE.DataTexture3D( data, width, height, depth );
        // 	texture.anisotropy = 16;
        //
        // See #14839
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, DataTexture3D, [
            null
        ]);
        _this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        _this.magFilter = $c702e238df7c5123$export$727aa5ec3fe39bf0;
        _this.minFilter = $c702e238df7c5123$export$727aa5ec3fe39bf0;
        _this.wrapR = $c702e238df7c5123$export$9d9334239a5a5e06;
        _this.generateMipmaps = false;
        _this.flipY = false;
        _this.unpackAlignment = 1;
        _this.needsUpdate = true;
        return _this;
    }
    return DataTexture3D;
}($c702e238df7c5123$export$5431306cf43de24a);
$c702e238df7c5123$export$ef03cdc98340bab4.prototype.isDataTexture3D = true;
/**
 * Uniforms of a program.
 * Those form a tree structure with a special top-level container for the root,
 * which you get by calling 'new WebGLUniforms( gl, program )'.
 *
 *
 * Properties of inner nodes including the top-level container:
 *
 * .seq - array of nested uniforms
 * .map - nested uniforms by name
 *
 *
 * Methods of all nodes except the top-level container:
 *
 * .setValue( gl, value, [textures] )
 *
 * 		uploads a uniform value(s)
 *  	the 'textures' parameter is needed for sampler uniforms
 *
 *
 * Static methods of the top-level container (textures factorizations):
 *
 * .upload( gl, seq, values, textures )
 *
 * 		sets uniforms in 'seq' to 'values[id].value'
 *
 * .seqWithValue( seq, values ) : filteredSeq
 *
 * 		filters 'seq' entries with corresponding entry in values
 *
 *
 * Methods of the top-level container (textures factorizations):
 *
 * .setValue( gl, name, value, textures )
 *
 * 		sets uniform with  name 'name' to 'value'
 *
 * .setOptional( gl, obj, prop )
 *
 * 		like .set for an optional property of the object
 *
 */ var $c702e238df7c5123$var$emptyTexture = new $c702e238df7c5123$export$5431306cf43de24a();
var $c702e238df7c5123$var$emptyTexture2dArray = new $c702e238df7c5123$export$e38bf4541665bbbd();
var $c702e238df7c5123$var$emptyTexture3d = new $c702e238df7c5123$export$ef03cdc98340bab4();
var $c702e238df7c5123$var$emptyCubeTexture = new $c702e238df7c5123$export$ee2e5a18258a4049();
// --- Utilities ---
// Array Caches (provide typed arrays for temporary by size)
var $c702e238df7c5123$var$arrayCacheF32 = [];
var $c702e238df7c5123$var$arrayCacheI32 = [];
// Float32Array caches used for uploading Matrix uniforms
var $c702e238df7c5123$var$mat4array = new Float32Array(16);
var $c702e238df7c5123$var$mat3array = new Float32Array(9);
var $c702e238df7c5123$var$mat2array = new Float32Array(4);
// Flattening for arrays of vectors and matrices
function $c702e238df7c5123$var$flatten(array, nBlocks, blockSize) {
    var firstElem = array[0];
    if (firstElem <= 0 || firstElem > 0) return array;
    // unoptimized: ! isNaN( firstElem )
    // see http://jacksondunstan.com/articles/983
    var n = nBlocks * blockSize;
    var r = $c702e238df7c5123$var$arrayCacheF32[n];
    if (r === undefined) {
        r = new Float32Array(n);
        $c702e238df7c5123$var$arrayCacheF32[n] = r;
    }
    if (nBlocks !== 0) {
        firstElem.toArray(r, 0);
        for(var i = 1, offset = 0; i !== nBlocks; ++i){
            offset += blockSize;
            array[i].toArray(r, offset);
        }
    }
    return r;
}
function $c702e238df7c5123$var$arraysEqual(a, b) {
    if (a.length !== b.length) return false;
    for(var i = 0, l = a.length; i < l; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $c702e238df7c5123$var$copyArray(a, b) {
    for(var i = 0, l = b.length; i < l; i++)a[i] = b[i];
}
// Texture unit allocation
function $c702e238df7c5123$var$allocTexUnits(textures, n) {
    var r = $c702e238df7c5123$var$arrayCacheI32[n];
    if (r === undefined) {
        r = new Int32Array(n);
        $c702e238df7c5123$var$arrayCacheI32[n] = r;
    }
    for(var i = 0; i !== n; ++i)r[i] = textures.allocateTextureUnit();
    return r;
}
// --- Setters ---
// Note: Defining these methods externally, because they come in a bunch
// and this way their names minify.
// Single scalar
function $c702e238df7c5123$var$setValueV1f(gl, v) {
    var cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1f(this.addr, v);
    cache[0] = v;
}
// Single float vector (from flat array or THREE.VectorN)
function $c702e238df7c5123$var$setValueV2f(gl, v) {
    var cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2f(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($c702e238df7c5123$var$arraysEqual(cache, v)) return;
        gl.uniform2fv(this.addr, v);
        $c702e238df7c5123$var$copyArray(cache, v);
    }
}
function $c702e238df7c5123$var$setValueV3f(gl, v) {
    var cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3f(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else if (v.r !== undefined) {
        if (cache[0] !== v.r || cache[1] !== v.g || cache[2] !== v.b) {
            gl.uniform3f(this.addr, v.r, v.g, v.b);
            cache[0] = v.r;
            cache[1] = v.g;
            cache[2] = v.b;
        }
    } else {
        if ($c702e238df7c5123$var$arraysEqual(cache, v)) return;
        gl.uniform3fv(this.addr, v);
        $c702e238df7c5123$var$copyArray(cache, v);
    }
}
function $c702e238df7c5123$var$setValueV4f(gl, v) {
    var cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4f(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($c702e238df7c5123$var$arraysEqual(cache, v)) return;
        gl.uniform4fv(this.addr, v);
        $c702e238df7c5123$var$copyArray(cache, v);
    }
}
// Single matrix (from flat array or THREE.MatrixN)
function $c702e238df7c5123$var$setValueM2(gl, v) {
    var cache = this.cache;
    var elements = v.elements;
    if (elements === undefined) {
        if ($c702e238df7c5123$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix2fv(this.addr, false, v);
        $c702e238df7c5123$var$copyArray(cache, v);
    } else {
        if ($c702e238df7c5123$var$arraysEqual(cache, elements)) return;
        $c702e238df7c5123$var$mat2array.set(elements);
        gl.uniformMatrix2fv(this.addr, false, $c702e238df7c5123$var$mat2array);
        $c702e238df7c5123$var$copyArray(cache, elements);
    }
}
function $c702e238df7c5123$var$setValueM3(gl, v) {
    var cache = this.cache;
    var elements = v.elements;
    if (elements === undefined) {
        if ($c702e238df7c5123$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix3fv(this.addr, false, v);
        $c702e238df7c5123$var$copyArray(cache, v);
    } else {
        if ($c702e238df7c5123$var$arraysEqual(cache, elements)) return;
        $c702e238df7c5123$var$mat3array.set(elements);
        gl.uniformMatrix3fv(this.addr, false, $c702e238df7c5123$var$mat3array);
        $c702e238df7c5123$var$copyArray(cache, elements);
    }
}
function $c702e238df7c5123$var$setValueM4(gl, v) {
    var cache = this.cache;
    var elements = v.elements;
    if (elements === undefined) {
        if ($c702e238df7c5123$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix4fv(this.addr, false, v);
        $c702e238df7c5123$var$copyArray(cache, v);
    } else {
        if ($c702e238df7c5123$var$arraysEqual(cache, elements)) return;
        $c702e238df7c5123$var$mat4array.set(elements);
        gl.uniformMatrix4fv(this.addr, false, $c702e238df7c5123$var$mat4array);
        $c702e238df7c5123$var$copyArray(cache, elements);
    }
}
// Single integer / boolean
function $c702e238df7c5123$var$setValueV1i(gl, v) {
    var cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1i(this.addr, v);
    cache[0] = v;
}
// Single integer / boolean vector (from flat array)
function $c702e238df7c5123$var$setValueV2i(gl, v) {
    var cache = this.cache;
    if ($c702e238df7c5123$var$arraysEqual(cache, v)) return;
    gl.uniform2iv(this.addr, v);
    $c702e238df7c5123$var$copyArray(cache, v);
}
function $c702e238df7c5123$var$setValueV3i(gl, v) {
    var cache = this.cache;
    if ($c702e238df7c5123$var$arraysEqual(cache, v)) return;
    gl.uniform3iv(this.addr, v);
    $c702e238df7c5123$var$copyArray(cache, v);
}
function $c702e238df7c5123$var$setValueV4i(gl, v) {
    var cache = this.cache;
    if ($c702e238df7c5123$var$arraysEqual(cache, v)) return;
    gl.uniform4iv(this.addr, v);
    $c702e238df7c5123$var$copyArray(cache, v);
}
// Single unsigned integer
function $c702e238df7c5123$var$setValueV1ui(gl, v) {
    var cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1ui(this.addr, v);
    cache[0] = v;
}
// Single unsigned integer vector (from flat array)
function $c702e238df7c5123$var$setValueV2ui(gl, v) {
    var cache = this.cache;
    if ($c702e238df7c5123$var$arraysEqual(cache, v)) return;
    gl.uniform2uiv(this.addr, v);
    $c702e238df7c5123$var$copyArray(cache, v);
}
function $c702e238df7c5123$var$setValueV3ui(gl, v) {
    var cache = this.cache;
    if ($c702e238df7c5123$var$arraysEqual(cache, v)) return;
    gl.uniform3uiv(this.addr, v);
    $c702e238df7c5123$var$copyArray(cache, v);
}
function $c702e238df7c5123$var$setValueV4ui(gl, v) {
    var cache = this.cache;
    if ($c702e238df7c5123$var$arraysEqual(cache, v)) return;
    gl.uniform4uiv(this.addr, v);
    $c702e238df7c5123$var$copyArray(cache, v);
}
// Single texture (2D / Cube)
function $c702e238df7c5123$var$setValueT1(gl, v, textures) {
    var cache = this.cache;
    var unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.safeSetTexture2D(v || $c702e238df7c5123$var$emptyTexture, unit);
}
function $c702e238df7c5123$var$setValueT3D1(gl, v, textures) {
    var cache = this.cache;
    var unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture3D(v || $c702e238df7c5123$var$emptyTexture3d, unit);
}
function $c702e238df7c5123$var$setValueT6(gl, v, textures) {
    var cache = this.cache;
    var unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.safeSetTextureCube(v || $c702e238df7c5123$var$emptyCubeTexture, unit);
}
function $c702e238df7c5123$var$setValueT2DArray1(gl, v, textures) {
    var cache = this.cache;
    var unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture2DArray(v || $c702e238df7c5123$var$emptyTexture2dArray, unit);
}
// Helper to pick the right setter for the singular case
function $c702e238df7c5123$var$getSingularSetter(type) {
    switch(type){
        case 0x1406:
            return $c702e238df7c5123$var$setValueV1f; // FLOAT
        case 0x8b50:
            return $c702e238df7c5123$var$setValueV2f; // _VEC2
        case 0x8b51:
            return $c702e238df7c5123$var$setValueV3f; // _VEC3
        case 0x8b52:
            return $c702e238df7c5123$var$setValueV4f; // _VEC4
        case 0x8b5a:
            return $c702e238df7c5123$var$setValueM2; // _MAT2
        case 0x8b5b:
            return $c702e238df7c5123$var$setValueM3; // _MAT3
        case 0x8b5c:
            return $c702e238df7c5123$var$setValueM4; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $c702e238df7c5123$var$setValueV1i; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $c702e238df7c5123$var$setValueV2i; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $c702e238df7c5123$var$setValueV3i; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $c702e238df7c5123$var$setValueV4i; // _VEC4
        case 0x1405:
            return $c702e238df7c5123$var$setValueV1ui; // UINT
        case 0x8dc6:
            return $c702e238df7c5123$var$setValueV2ui; // _VEC2
        case 0x8dc7:
            return $c702e238df7c5123$var$setValueV3ui; // _VEC3
        case 0x8dc8:
            return $c702e238df7c5123$var$setValueV4ui; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $c702e238df7c5123$var$setValueT1;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $c702e238df7c5123$var$setValueT3D1;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $c702e238df7c5123$var$setValueT6;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $c702e238df7c5123$var$setValueT2DArray1;
    }
}
// Array of scalars
function $c702e238df7c5123$var$setValueV1fArray(gl, v) {
    gl.uniform1fv(this.addr, v);
}
// Array of vectors (from flat array or array of THREE.VectorN)
function $c702e238df7c5123$var$setValueV2fArray(gl, v) {
    var data = $c702e238df7c5123$var$flatten(v, this.size, 2);
    gl.uniform2fv(this.addr, data);
}
function $c702e238df7c5123$var$setValueV3fArray(gl, v) {
    var data = $c702e238df7c5123$var$flatten(v, this.size, 3);
    gl.uniform3fv(this.addr, data);
}
function $c702e238df7c5123$var$setValueV4fArray(gl, v) {
    var data = $c702e238df7c5123$var$flatten(v, this.size, 4);
    gl.uniform4fv(this.addr, data);
}
// Array of matrices (from flat array or array of THREE.MatrixN)
function $c702e238df7c5123$var$setValueM2Array(gl, v) {
    var data = $c702e238df7c5123$var$flatten(v, this.size, 4);
    gl.uniformMatrix2fv(this.addr, false, data);
}
function $c702e238df7c5123$var$setValueM3Array(gl, v) {
    var data = $c702e238df7c5123$var$flatten(v, this.size, 9);
    gl.uniformMatrix3fv(this.addr, false, data);
}
function $c702e238df7c5123$var$setValueM4Array(gl, v) {
    var data = $c702e238df7c5123$var$flatten(v, this.size, 16);
    gl.uniformMatrix4fv(this.addr, false, data);
}
// Array of integer / boolean
function $c702e238df7c5123$var$setValueV1iArray(gl, v) {
    gl.uniform1iv(this.addr, v);
}
// Array of integer / boolean vectors (from flat array)
function $c702e238df7c5123$var$setValueV2iArray(gl, v) {
    gl.uniform2iv(this.addr, v);
}
function $c702e238df7c5123$var$setValueV3iArray(gl, v) {
    gl.uniform3iv(this.addr, v);
}
function $c702e238df7c5123$var$setValueV4iArray(gl, v) {
    gl.uniform4iv(this.addr, v);
}
// Array of unsigned integer
function $c702e238df7c5123$var$setValueV1uiArray(gl, v) {
    gl.uniform1uiv(this.addr, v);
}
// Array of unsigned integer vectors (from flat array)
function $c702e238df7c5123$var$setValueV2uiArray(gl, v) {
    gl.uniform2uiv(this.addr, v);
}
function $c702e238df7c5123$var$setValueV3uiArray(gl, v) {
    gl.uniform3uiv(this.addr, v);
}
function $c702e238df7c5123$var$setValueV4uiArray(gl, v) {
    gl.uniform4uiv(this.addr, v);
}
// Array of textures (2D / Cube)
function $c702e238df7c5123$var$setValueT1Array(gl, v, textures) {
    var n = v.length;
    var units = $c702e238df7c5123$var$allocTexUnits(textures, n);
    gl.uniform1iv(this.addr, units);
    for(var i = 0; i !== n; ++i)textures.safeSetTexture2D(v[i] || $c702e238df7c5123$var$emptyTexture, units[i]);
}
function $c702e238df7c5123$var$setValueT6Array(gl, v, textures) {
    var n = v.length;
    var units = $c702e238df7c5123$var$allocTexUnits(textures, n);
    gl.uniform1iv(this.addr, units);
    for(var i = 0; i !== n; ++i)textures.safeSetTextureCube(v[i] || $c702e238df7c5123$var$emptyCubeTexture, units[i]);
}
// Helper to pick the right setter for a pure (bottom-level) array
function $c702e238df7c5123$var$getPureArraySetter(type) {
    switch(type){
        case 0x1406:
            return $c702e238df7c5123$var$setValueV1fArray; // FLOAT
        case 0x8b50:
            return $c702e238df7c5123$var$setValueV2fArray; // _VEC2
        case 0x8b51:
            return $c702e238df7c5123$var$setValueV3fArray; // _VEC3
        case 0x8b52:
            return $c702e238df7c5123$var$setValueV4fArray; // _VEC4
        case 0x8b5a:
            return $c702e238df7c5123$var$setValueM2Array; // _MAT2
        case 0x8b5b:
            return $c702e238df7c5123$var$setValueM3Array; // _MAT3
        case 0x8b5c:
            return $c702e238df7c5123$var$setValueM4Array; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $c702e238df7c5123$var$setValueV1iArray; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $c702e238df7c5123$var$setValueV2iArray; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $c702e238df7c5123$var$setValueV3iArray; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $c702e238df7c5123$var$setValueV4iArray; // _VEC4
        case 0x1405:
            return $c702e238df7c5123$var$setValueV1uiArray; // UINT
        case 0x8dc6:
            return $c702e238df7c5123$var$setValueV2uiArray; // _VEC2
        case 0x8dc7:
            return $c702e238df7c5123$var$setValueV3uiArray; // _VEC3
        case 0x8dc8:
            return $c702e238df7c5123$var$setValueV4uiArray; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $c702e238df7c5123$var$setValueT1Array;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $c702e238df7c5123$var$setValueT6Array;
    }
}
// --- Uniform Classes ---
function $c702e238df7c5123$var$SingleUniform(id, activeInfo, addr) {
    this.id = id;
    this.addr = addr;
    this.cache = [];
    this.setValue = $c702e238df7c5123$var$getSingularSetter(activeInfo.type);
// this.path = activeInfo.name; // DEBUG
}
function $c702e238df7c5123$var$PureArrayUniform(id, activeInfo, addr) {
    this.id = id;
    this.addr = addr;
    this.cache = [];
    this.size = activeInfo.size;
    this.setValue = $c702e238df7c5123$var$getPureArraySetter(activeInfo.type);
// this.path = activeInfo.name; // DEBUG
}
$c702e238df7c5123$var$PureArrayUniform.prototype.updateCache = function(data) {
    var cache = this.cache;
    if (data instanceof Float32Array && cache.length !== data.length) this.cache = new Float32Array(data.length);
    $c702e238df7c5123$var$copyArray(cache, data);
};
function $c702e238df7c5123$var$StructuredUniform(id) {
    this.id = id;
    this.seq = [];
    this.map = {};
}
$c702e238df7c5123$var$StructuredUniform.prototype.setValue = function(gl, value, textures) {
    var seq = this.seq;
    for(var i = 0, n = seq.length; i !== n; ++i){
        var u = seq[i];
        u.setValue(gl, value[u.id], textures);
    }
};
// --- Top-level ---
// Parser - builds up the property tree from the path strings
var $c702e238df7c5123$var$RePathPart = /(\w+)(\])?(\[|\.)?/g;
// extracts
// 	- the identifier (member name or array index)
//  - followed by an optional right bracket (found when array index)
//  - followed by an optional left bracket or dot (type of subscript)
//
// Note: These portions can be read in a non-overlapping fashion and
// allow straightforward parsing of the hierarchy that WebGL encodes
// in the uniform names.
function $c702e238df7c5123$var$addUniform(container, uniformObject) {
    container.seq.push(uniformObject);
    container.map[uniformObject.id] = uniformObject;
}
function $c702e238df7c5123$var$parseUniform(activeInfo, addr, container) {
    var path = activeInfo.name, pathLength = path.length;
    // reset RegExp object, because of the early exit of a previous run
    $c702e238df7c5123$var$RePathPart.lastIndex = 0;
    while(true){
        var match = $c702e238df7c5123$var$RePathPart.exec(path), matchEnd = $c702e238df7c5123$var$RePathPart.lastIndex;
        var id = match[1];
        var idIsIndex = match[2] === ']', subscript = match[3];
        if (idIsIndex) id = id | 0; // convert to integer
        if (subscript === undefined || subscript === '[' && matchEnd + 2 === pathLength) {
            // bare name or "pure" bottom-level array "[0]" suffix
            $c702e238df7c5123$var$addUniform(container, subscript === undefined ? new $c702e238df7c5123$var$SingleUniform(id, activeInfo, addr) : new $c702e238df7c5123$var$PureArrayUniform(id, activeInfo, addr));
            break;
        } else {
            // step into inner node / create it in case it doesn't exist
            var map = container.map;
            var next = map[id];
            if (next === undefined) {
                next = new $c702e238df7c5123$var$StructuredUniform(id);
                $c702e238df7c5123$var$addUniform(container, next);
            }
            container = next;
        }
    }
}
// Root Container
function $c702e238df7c5123$var$WebGLUniforms(gl, program) {
    this.seq = [];
    this.map = {};
    var n = gl.getProgramParameter(program, 35718);
    for(var i = 0; i < n; ++i){
        var info = gl.getActiveUniform(program, i), addr = gl.getUniformLocation(program, info.name);
        $c702e238df7c5123$var$parseUniform(info, addr, this);
    }
}
$c702e238df7c5123$var$WebGLUniforms.prototype.setValue = function(gl, name, value, textures) {
    var u = this.map[name];
    if (u !== undefined) u.setValue(gl, value, textures);
};
$c702e238df7c5123$var$WebGLUniforms.prototype.setOptional = function(gl, object, name) {
    var v = object[name];
    if (v !== undefined) this.setValue(gl, name, v);
};
// Static interface
$c702e238df7c5123$var$WebGLUniforms.upload = function(gl, seq, values, textures) {
    for(var i = 0, n = seq.length; i !== n; ++i){
        var u = seq[i], v = values[u.id];
        if (v.needsUpdate !== false) // note: always updating when .needsUpdate is undefined
        u.setValue(gl, v.value, textures);
    }
};
$c702e238df7c5123$var$WebGLUniforms.seqWithValue = function(seq, values) {
    var r = [];
    for(var i = 0, n = seq.length; i !== n; ++i){
        var u = seq[i];
        if (u.id in values) r.push(u);
    }
    return r;
};
function $c702e238df7c5123$var$WebGLShader(gl, type, string) {
    var shader = gl.createShader(type);
    gl.shaderSource(shader, string);
    gl.compileShader(shader);
    return shader;
}
var $c702e238df7c5123$var$programIdCount = 0;
function $c702e238df7c5123$var$addLineNumbers(string) {
    var lines = string.split('\n');
    for(var i = 0; i < lines.length; i++)lines[i] = i + 1 + ': ' + lines[i];
    return lines.join('\n');
}
function $c702e238df7c5123$var$getEncodingComponents(encoding) {
    switch(encoding){
        case $c702e238df7c5123$export$7207336e4151a112:
            return [
                'Linear',
                '( value )'
            ];
        case $c702e238df7c5123$export$f32388edbb32674:
            return [
                'sRGB',
                '( value )'
            ];
        case $c702e238df7c5123$export$3be4c466a12b5dcf:
            return [
                'RGBE',
                '( value )'
            ];
        case $c702e238df7c5123$export$2c4bdfd76b188654:
            return [
                'RGBM',
                '( value, 7.0 )'
            ];
        case $c702e238df7c5123$export$48a0051d6a5a9b9:
            return [
                'RGBM',
                '( value, 16.0 )'
            ];
        case $c702e238df7c5123$export$ca2f89b13b49d951:
            return [
                'RGBD',
                '( value, 256.0 )'
            ];
        case $c702e238df7c5123$export$eaab32c1bcea1817:
            return [
                'Gamma',
                '( value, float( GAMMA_FACTOR ) )'
            ];
        case $c702e238df7c5123$export$8d4cbbeb1eea9f67:
            return [
                'LogLuv',
                '( value )'
            ];
        default:
            console.warn('THREE.WebGLProgram: Unsupported encoding:', encoding);
            return [
                'Linear',
                '( value )'
            ];
    }
}
function $c702e238df7c5123$var$getShaderErrors(gl, shader, type) {
    var status = gl.getShaderParameter(shader, 35713);
    var log = gl.getShaderInfoLog(shader).trim();
    if (status && log === '') return '';
    // --enable-privileged-webgl-extension
    // console.log( '**' + type + '**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( shader ) );
    var source = gl.getShaderSource(shader);
    return 'THREE.WebGLShader: gl.getShaderInfoLog() ' + type + '\n' + log + $c702e238df7c5123$var$addLineNumbers(source);
}
function $c702e238df7c5123$var$getTexelDecodingFunction(functionName, encoding) {
    var components = $c702e238df7c5123$var$getEncodingComponents(encoding);
    return 'vec4 ' + functionName + '( vec4 value ) { return ' + components[0] + 'ToLinear' + components[1] + '; }';
}
function $c702e238df7c5123$var$getTexelEncodingFunction(functionName, encoding) {
    var components = $c702e238df7c5123$var$getEncodingComponents(encoding);
    return 'vec4 ' + functionName + '( vec4 value ) { return LinearTo' + components[0] + components[1] + '; }';
}
function $c702e238df7c5123$var$getToneMappingFunction(functionName, toneMapping) {
    var toneMappingName;
    switch(toneMapping){
        case $c702e238df7c5123$export$98f52c2a46c598ca:
            toneMappingName = 'Linear';
            break;
        case $c702e238df7c5123$export$74b25e54b3bcd548:
            toneMappingName = 'Reinhard';
            break;
        case $c702e238df7c5123$export$932b3dd283d4a366:
            toneMappingName = 'OptimizedCineon';
            break;
        case $c702e238df7c5123$export$a0d98fe6d7e4af64:
            toneMappingName = 'ACESFilmic';
            break;
        case $c702e238df7c5123$export$2c7b09c1e9abfb5e:
            toneMappingName = 'Custom';
            break;
        default:
            console.warn('THREE.WebGLProgram: Unsupported toneMapping:', toneMapping);
            toneMappingName = 'Linear';
    }
    return 'vec3 ' + functionName + '( vec3 color ) { return ' + toneMappingName + 'ToneMapping( color ); }';
}
function $c702e238df7c5123$var$generateExtensions(parameters) {
    var chunks = [
        parameters.extensionDerivatives || parameters.envMapCubeUV || parameters.bumpMap || parameters.tangentSpaceNormalMap || parameters.clearcoatNormalMap || parameters.flatShading || parameters.shaderID === 'physical' ? '#extension GL_OES_standard_derivatives : enable' : '',
        (parameters.extensionFragDepth || parameters.logarithmicDepthBuffer) && parameters.rendererExtensionFragDepth ? '#extension GL_EXT_frag_depth : enable' : '',
        parameters.extensionDrawBuffers && parameters.rendererExtensionDrawBuffers ? '#extension GL_EXT_draw_buffers : require' : '',
        (parameters.extensionShaderTextureLOD || parameters.envMap || parameters.transmission > 0.0) && parameters.rendererExtensionShaderTextureLod ? '#extension GL_EXT_shader_texture_lod : enable' : ''
    ];
    return chunks.filter($c702e238df7c5123$var$filterEmptyLine).join('\n');
}
function $c702e238df7c5123$var$generateDefines(defines) {
    var chunks = [];
    for(var name in defines){
        var value = defines[name];
        if (value === false) continue;
        chunks.push('#define ' + name + ' ' + value);
    }
    return chunks.join('\n');
}
function $c702e238df7c5123$var$fetchAttributeLocations(gl, program) {
    var attributes = {};
    var n = gl.getProgramParameter(program, 35721);
    for(var i = 0; i < n; i++){
        var info = gl.getActiveAttrib(program, i);
        var name = info.name;
        // console.log( 'THREE.WebGLProgram: ACTIVE VERTEX ATTRIBUTE:', name, i );
        attributes[name] = gl.getAttribLocation(program, name);
    }
    return attributes;
}
function $c702e238df7c5123$var$filterEmptyLine(string) {
    return string !== '';
}
function $c702e238df7c5123$var$replaceLightNums(string, parameters) {
    return string.replace(/NUM_DIR_LIGHTS/g, parameters.numDirLights).replace(/NUM_SPOT_LIGHTS/g, parameters.numSpotLights).replace(/NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, parameters.numPointLights).replace(/NUM_HEMI_LIGHTS/g, parameters.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, parameters.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS/g, parameters.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, parameters.numPointLightShadows);
}
function $c702e238df7c5123$var$replaceClippingPlaneNums(string, parameters) {
    return string.replace(/NUM_CLIPPING_PLANES/g, parameters.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, parameters.numClippingPlanes - parameters.numClipIntersection);
}
// Resolve Includes
var $c702e238df7c5123$var$includePattern = /^[ \t]*#include +<([\w\d./]+)>/gm;
function $c702e238df7c5123$var$resolveIncludes(string) {
    return string.replace($c702e238df7c5123$var$includePattern, $c702e238df7c5123$var$includeReplacer);
}
function $c702e238df7c5123$var$includeReplacer(match, include) {
    var string = $c702e238df7c5123$export$955f9f2e84c43c8b[include];
    if (string === undefined) throw new Error('Can not resolve #include <' + include + '>');
    return $c702e238df7c5123$var$resolveIncludes(string);
}
// Unroll Loops
var $c702e238df7c5123$var$deprecatedUnrollLoopPattern = /#pragma unroll_loop[\s]+?for \( int i \= (\d+)\; i < (\d+)\; i \+\+ \) \{([\s\S]+?)(?=\})\}/g;
var $c702e238df7c5123$var$unrollLoopPattern = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function $c702e238df7c5123$var$unrollLoops(string) {
    return string.replace($c702e238df7c5123$var$unrollLoopPattern, $c702e238df7c5123$var$loopReplacer).replace($c702e238df7c5123$var$deprecatedUnrollLoopPattern, $c702e238df7c5123$var$deprecatedLoopReplacer);
}
function $c702e238df7c5123$var$deprecatedLoopReplacer(match, start, end, snippet) {
    console.warn('WebGLProgram: #pragma unroll_loop shader syntax is deprecated. Please use #pragma unroll_loop_start syntax instead.');
    return $c702e238df7c5123$var$loopReplacer(match, start, end, snippet);
}
function $c702e238df7c5123$var$loopReplacer(match, start, end, snippet) {
    var string = '';
    for(var i = parseInt(start); i < parseInt(end); i++)string += snippet.replace(/\[\s*i\s*\]/g, '[ ' + i + ' ]').replace(/UNROLLED_LOOP_INDEX/g, i);
    return string;
}
//
function $c702e238df7c5123$var$generatePrecision(parameters) {
    var precisionstring = 'precision ' + parameters.precision + ' float;\nprecision ' + parameters.precision + ' int;';
    if (parameters.precision === 'highp') precisionstring += '\n#define HIGH_PRECISION';
    else if (parameters.precision === 'mediump') precisionstring += '\n#define MEDIUM_PRECISION';
    else if (parameters.precision === 'lowp') precisionstring += '\n#define LOW_PRECISION';
    return precisionstring;
}
function $c702e238df7c5123$var$generateShadowMapTypeDefine(parameters) {
    var shadowMapTypeDefine = 'SHADOWMAP_TYPE_BASIC';
    if (parameters.shadowMapType === $c702e238df7c5123$export$5813f879eee7cd88) shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF';
    else if (parameters.shadowMapType === $c702e238df7c5123$export$a47c4b43a1be34f0) shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF_SOFT';
    else if (parameters.shadowMapType === $c702e238df7c5123$export$896ae1ade6c829c4) shadowMapTypeDefine = 'SHADOWMAP_TYPE_VSM';
    return shadowMapTypeDefine;
}
function $c702e238df7c5123$var$generateEnvMapTypeDefine(parameters) {
    var envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
    if (parameters.envMap) switch(parameters.envMapMode){
        case $c702e238df7c5123$export$8759762a6477f2c4:
        case $c702e238df7c5123$export$dc59f8aed047f61d:
            envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
            break;
        case $c702e238df7c5123$export$dbf3e70ff37af79:
        case $c702e238df7c5123$export$76a9f4355364345c:
            envMapTypeDefine = 'ENVMAP_TYPE_CUBE_UV';
            break;
    }
    return envMapTypeDefine;
}
function $c702e238df7c5123$var$generateEnvMapModeDefine(parameters) {
    var envMapModeDefine = 'ENVMAP_MODE_REFLECTION';
    if (parameters.envMap) switch(parameters.envMapMode){
        case $c702e238df7c5123$export$dc59f8aed047f61d:
        case $c702e238df7c5123$export$76a9f4355364345c:
            envMapModeDefine = 'ENVMAP_MODE_REFRACTION';
            break;
    }
    return envMapModeDefine;
}
function $c702e238df7c5123$var$generateEnvMapBlendingDefine(parameters) {
    var envMapBlendingDefine = 'ENVMAP_BLENDING_NONE';
    if (parameters.envMap) switch(parameters.combine){
        case $c702e238df7c5123$export$e50ac29801f1774d:
            envMapBlendingDefine = 'ENVMAP_BLENDING_MULTIPLY';
            break;
        case $c702e238df7c5123$export$9f9d94f963c85479:
            envMapBlendingDefine = 'ENVMAP_BLENDING_MIX';
            break;
        case $c702e238df7c5123$export$e641dc52bc3494aa:
            envMapBlendingDefine = 'ENVMAP_BLENDING_ADD';
            break;
    }
    return envMapBlendingDefine;
}
function $c702e238df7c5123$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates) {
    var gl = renderer.getContext();
    var defines = parameters.defines;
    var vertexShader = parameters.vertexShader;
    var fragmentShader = parameters.fragmentShader;
    var shadowMapTypeDefine = $c702e238df7c5123$var$generateShadowMapTypeDefine(parameters);
    var envMapTypeDefine = $c702e238df7c5123$var$generateEnvMapTypeDefine(parameters);
    var envMapModeDefine = $c702e238df7c5123$var$generateEnvMapModeDefine(parameters);
    var envMapBlendingDefine = $c702e238df7c5123$var$generateEnvMapBlendingDefine(parameters);
    var gammaFactorDefine = renderer.gammaFactor > 0 ? renderer.gammaFactor : 1.0;
    var customExtensions = parameters.isWebGL2 ? '' : $c702e238df7c5123$var$generateExtensions(parameters);
    var customDefines = $c702e238df7c5123$var$generateDefines(defines);
    var program = gl.createProgram();
    var prefixVertex, prefixFragment;
    var versionString = parameters.glslVersion ? '#version ' + parameters.glslVersion + '\n' : '';
    if (parameters.isRawShaderMaterial) {
        prefixVertex = [
            customDefines
        ].filter($c702e238df7c5123$var$filterEmptyLine).join('\n');
        if (prefixVertex.length > 0) prefixVertex += '\n';
        prefixFragment = [
            customExtensions,
            customDefines
        ].filter($c702e238df7c5123$var$filterEmptyLine).join('\n');
        if (prefixFragment.length > 0) prefixFragment += '\n';
    } else {
        prefixVertex = [
            $c702e238df7c5123$var$generatePrecision(parameters),
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines,
            parameters.instancing ? '#define USE_INSTANCING' : '',
            parameters.instancingColor ? '#define USE_INSTANCING_COLOR' : '',
            parameters.supportsVertexTextures ? '#define VERTEX_TEXTURES' : '',
            '#define GAMMA_FACTOR ' + gammaFactorDefine,
            '#define MAX_BONES ' + parameters.maxBones,
            parameters.useFog && parameters.fog ? '#define USE_FOG' : '',
            parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '',
            parameters.map ? '#define USE_MAP' : '',
            parameters.envMap ? '#define USE_ENVMAP' : '',
            parameters.envMap ? '#define ' + envMapModeDefine : '',
            parameters.lightMap ? '#define USE_LIGHTMAP' : '',
            parameters.aoMap ? '#define USE_AOMAP' : '',
            parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
            parameters.bumpMap ? '#define USE_BUMPMAP' : '',
            parameters.normalMap ? '#define USE_NORMALMAP' : '',
            parameters.normalMap && parameters.objectSpaceNormalMap ? '#define OBJECTSPACE_NORMALMAP' : '',
            parameters.normalMap && parameters.tangentSpaceNormalMap ? '#define TANGENTSPACE_NORMALMAP' : '',
            parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
            parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
            parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',
            parameters.displacementMap && parameters.supportsVertexTextures ? '#define USE_DISPLACEMENTMAP' : '',
            parameters.specularMap ? '#define USE_SPECULARMAP' : '',
            parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
            parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
            parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
            parameters.transmission ? '#define USE_TRANSMISSION' : '',
            parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
            parameters.thicknessMap ? '#define USE_THICKNESSMAP' : '',
            parameters.vertexTangents ? '#define USE_TANGENT' : '',
            parameters.vertexColors ? '#define USE_COLOR' : '',
            parameters.vertexAlphas ? '#define USE_COLOR_ALPHA' : '',
            parameters.vertexUvs ? '#define USE_UV' : '',
            parameters.uvsVertexOnly ? '#define UVS_VERTEX_ONLY' : '',
            parameters.flatShading ? '#define FLAT_SHADED' : '',
            parameters.skinning ? '#define USE_SKINNING' : '',
            parameters.useVertexTexture ? '#define BONE_TEXTURE' : '',
            parameters.morphTargets ? '#define USE_MORPHTARGETS' : '',
            parameters.morphNormals && parameters.flatShading === false ? '#define USE_MORPHNORMALS' : '',
            parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
            parameters.flipSided ? '#define FLIP_SIDED' : '',
            parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
            parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',
            parameters.sizeAttenuation ? '#define USE_SIZEATTENUATION' : '',
            parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',
            parameters.logarithmicDepthBuffer && parameters.rendererExtensionFragDepth ? '#define USE_LOGDEPTHBUF_EXT' : '',
            'uniform mat4 modelMatrix;',
            'uniform mat4 modelViewMatrix;',
            'uniform mat4 projectionMatrix;',
            'uniform mat4 viewMatrix;',
            'uniform mat3 normalMatrix;',
            'uniform vec3 cameraPosition;',
            'uniform bool isOrthographic;',
            '#ifdef USE_INSTANCING',
            '	attribute mat4 instanceMatrix;',
            '#endif',
            '#ifdef USE_INSTANCING_COLOR',
            '	attribute vec3 instanceColor;',
            '#endif',
            'attribute vec3 position;',
            'attribute vec3 normal;',
            'attribute vec2 uv;',
            '#ifdef USE_TANGENT',
            '	attribute vec4 tangent;',
            '#endif',
            '#if defined( USE_COLOR_ALPHA )',
            '	attribute vec4 color;',
            '#elif defined( USE_COLOR )',
            '	attribute vec3 color;',
            '#endif',
            '#ifdef USE_MORPHTARGETS',
            '	attribute vec3 morphTarget0;',
            '	attribute vec3 morphTarget1;',
            '	attribute vec3 morphTarget2;',
            '	attribute vec3 morphTarget3;',
            '	#ifdef USE_MORPHNORMALS',
            '		attribute vec3 morphNormal0;',
            '		attribute vec3 morphNormal1;',
            '		attribute vec3 morphNormal2;',
            '		attribute vec3 morphNormal3;',
            '	#else',
            '		attribute vec3 morphTarget4;',
            '		attribute vec3 morphTarget5;',
            '		attribute vec3 morphTarget6;',
            '		attribute vec3 morphTarget7;',
            '	#endif',
            '#endif',
            '#ifdef USE_SKINNING',
            '	attribute vec4 skinIndex;',
            '	attribute vec4 skinWeight;',
            '#endif',
            '\n'
        ].filter($c702e238df7c5123$var$filterEmptyLine).join('\n');
        prefixFragment = [
            customExtensions,
            $c702e238df7c5123$var$generatePrecision(parameters),
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines,
            parameters.alphaTest ? '#define ALPHATEST ' + parameters.alphaTest + (parameters.alphaTest % 1 ? '' : '.0') : '',
            '#define GAMMA_FACTOR ' + gammaFactorDefine,
            parameters.useFog && parameters.fog ? '#define USE_FOG' : '',
            parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '',
            parameters.map ? '#define USE_MAP' : '',
            parameters.matcap ? '#define USE_MATCAP' : '',
            parameters.envMap ? '#define USE_ENVMAP' : '',
            parameters.envMap ? '#define ' + envMapTypeDefine : '',
            parameters.envMap ? '#define ' + envMapModeDefine : '',
            parameters.envMap ? '#define ' + envMapBlendingDefine : '',
            parameters.lightMap ? '#define USE_LIGHTMAP' : '',
            parameters.aoMap ? '#define USE_AOMAP' : '',
            parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
            parameters.bumpMap ? '#define USE_BUMPMAP' : '',
            parameters.normalMap ? '#define USE_NORMALMAP' : '',
            parameters.normalMap && parameters.objectSpaceNormalMap ? '#define OBJECTSPACE_NORMALMAP' : '',
            parameters.normalMap && parameters.tangentSpaceNormalMap ? '#define TANGENTSPACE_NORMALMAP' : '',
            parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
            parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
            parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',
            parameters.specularMap ? '#define USE_SPECULARMAP' : '',
            parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
            parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
            parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
            parameters.sheen ? '#define USE_SHEEN' : '',
            parameters.transmission ? '#define USE_TRANSMISSION' : '',
            parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
            parameters.thicknessMap ? '#define USE_THICKNESSMAP' : '',
            parameters.vertexTangents ? '#define USE_TANGENT' : '',
            parameters.vertexColors || parameters.instancingColor ? '#define USE_COLOR' : '',
            parameters.vertexAlphas ? '#define USE_COLOR_ALPHA' : '',
            parameters.vertexUvs ? '#define USE_UV' : '',
            parameters.uvsVertexOnly ? '#define UVS_VERTEX_ONLY' : '',
            parameters.gradientMap ? '#define USE_GRADIENTMAP' : '',
            parameters.flatShading ? '#define FLAT_SHADED' : '',
            parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
            parameters.flipSided ? '#define FLIP_SIDED' : '',
            parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
            parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',
            parameters.premultipliedAlpha ? '#define PREMULTIPLIED_ALPHA' : '',
            parameters.physicallyCorrectLights ? '#define PHYSICALLY_CORRECT_LIGHTS' : '',
            parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',
            parameters.logarithmicDepthBuffer && parameters.rendererExtensionFragDepth ? '#define USE_LOGDEPTHBUF_EXT' : '',
            (parameters.extensionShaderTextureLOD || parameters.envMap) && parameters.rendererExtensionShaderTextureLod ? '#define TEXTURE_LOD_EXT' : '',
            'uniform mat4 viewMatrix;',
            'uniform vec3 cameraPosition;',
            'uniform bool isOrthographic;',
            parameters.toneMapping !== $c702e238df7c5123$export$9fcb6b4294603b2 ? '#define TONE_MAPPING' : '',
            parameters.toneMapping !== $c702e238df7c5123$export$9fcb6b4294603b2 ? $c702e238df7c5123$export$955f9f2e84c43c8b['tonemapping_pars_fragment'] : '',
            parameters.toneMapping !== $c702e238df7c5123$export$9fcb6b4294603b2 ? $c702e238df7c5123$var$getToneMappingFunction('toneMapping', parameters.toneMapping) : '',
            parameters.dithering ? '#define DITHERING' : '',
            $c702e238df7c5123$export$955f9f2e84c43c8b['encodings_pars_fragment'],
            parameters.map ? $c702e238df7c5123$var$getTexelDecodingFunction('mapTexelToLinear', parameters.mapEncoding) : '',
            parameters.matcap ? $c702e238df7c5123$var$getTexelDecodingFunction('matcapTexelToLinear', parameters.matcapEncoding) : '',
            parameters.envMap ? $c702e238df7c5123$var$getTexelDecodingFunction('envMapTexelToLinear', parameters.envMapEncoding) : '',
            parameters.emissiveMap ? $c702e238df7c5123$var$getTexelDecodingFunction('emissiveMapTexelToLinear', parameters.emissiveMapEncoding) : '',
            parameters.lightMap ? $c702e238df7c5123$var$getTexelDecodingFunction('lightMapTexelToLinear', parameters.lightMapEncoding) : '',
            $c702e238df7c5123$var$getTexelEncodingFunction('linearToOutputTexel', parameters.outputEncoding),
            parameters.depthPacking ? '#define DEPTH_PACKING ' + parameters.depthPacking : '',
            '\n'
        ].filter($c702e238df7c5123$var$filterEmptyLine).join('\n');
    }
    vertexShader = $c702e238df7c5123$var$resolveIncludes(vertexShader);
    vertexShader = $c702e238df7c5123$var$replaceLightNums(vertexShader, parameters);
    vertexShader = $c702e238df7c5123$var$replaceClippingPlaneNums(vertexShader, parameters);
    fragmentShader = $c702e238df7c5123$var$resolveIncludes(fragmentShader);
    fragmentShader = $c702e238df7c5123$var$replaceLightNums(fragmentShader, parameters);
    fragmentShader = $c702e238df7c5123$var$replaceClippingPlaneNums(fragmentShader, parameters);
    vertexShader = $c702e238df7c5123$var$unrollLoops(vertexShader);
    fragmentShader = $c702e238df7c5123$var$unrollLoops(fragmentShader);
    if (parameters.isWebGL2 && parameters.isRawShaderMaterial !== true) {
        // GLSL 3.0 conversion for built-in materials and ShaderMaterial
        versionString = '#version 300 es\n';
        prefixVertex = [
            '#define attribute in',
            '#define varying out',
            '#define texture2D texture'
        ].join('\n') + '\n' + prefixVertex;
        prefixFragment = [
            '#define varying in',
            parameters.glslVersion === $c702e238df7c5123$export$f63012db5506e7dd ? '' : 'out highp vec4 pc_fragColor;',
            parameters.glslVersion === $c702e238df7c5123$export$f63012db5506e7dd ? '' : '#define gl_FragColor pc_fragColor',
            '#define gl_FragDepthEXT gl_FragDepth',
            '#define texture2D texture',
            '#define textureCube texture',
            '#define texture2DProj textureProj',
            '#define texture2DLodEXT textureLod',
            '#define texture2DProjLodEXT textureProjLod',
            '#define textureCubeLodEXT textureLod',
            '#define texture2DGradEXT textureGrad',
            '#define texture2DProjGradEXT textureProjGrad',
            '#define textureCubeGradEXT textureGrad'
        ].join('\n') + '\n' + prefixFragment;
    }
    var vertexGlsl = versionString + prefixVertex + vertexShader;
    var fragmentGlsl = versionString + prefixFragment + fragmentShader;
    // console.log( '*VERTEX*', vertexGlsl );
    // console.log( '*FRAGMENT*', fragmentGlsl );
    var glVertexShader = $c702e238df7c5123$var$WebGLShader(gl, 35633, vertexGlsl);
    var glFragmentShader = $c702e238df7c5123$var$WebGLShader(gl, 35632, fragmentGlsl);
    gl.attachShader(program, glVertexShader);
    gl.attachShader(program, glFragmentShader);
    // Force a particular attribute to index 0.
    if (parameters.index0AttributeName !== undefined) gl.bindAttribLocation(program, 0, parameters.index0AttributeName);
    else if (parameters.morphTargets === true) // programs with morphTargets displace position out of attribute 0
    gl.bindAttribLocation(program, 0, 'position');
    gl.linkProgram(program);
    // check for link errors
    if (renderer.debug.checkShaderErrors) {
        var programLog = gl.getProgramInfoLog(program).trim();
        var vertexLog = gl.getShaderInfoLog(glVertexShader).trim();
        var fragmentLog = gl.getShaderInfoLog(glFragmentShader).trim();
        var runnable = true;
        var haveDiagnostics = true;
        if (gl.getProgramParameter(program, 35714) === false) {
            runnable = false;
            var vertexErrors = $c702e238df7c5123$var$getShaderErrors(gl, glVertexShader, 'vertex');
            var fragmentErrors = $c702e238df7c5123$var$getShaderErrors(gl, glFragmentShader, 'fragment');
            console.error('THREE.WebGLProgram: shader error: ', gl.getError(), '35715', gl.getProgramParameter(program, 35715), 'gl.getProgramInfoLog', programLog, vertexErrors, fragmentErrors);
        } else if (programLog !== '') console.warn('THREE.WebGLProgram: gl.getProgramInfoLog()', programLog);
        else if (vertexLog === '' || fragmentLog === '') haveDiagnostics = false;
        if (haveDiagnostics) this.diagnostics = {
            runnable: runnable,
            programLog: programLog,
            vertexShader: {
                log: vertexLog,
                prefix: prefixVertex
            },
            fragmentShader: {
                log: fragmentLog,
                prefix: prefixFragment
            }
        };
    }
    // Clean up
    // Crashes in iOS9 and iOS10. #18402
    // gl.detachShader( program, glVertexShader );
    // gl.detachShader( program, glFragmentShader );
    gl.deleteShader(glVertexShader);
    gl.deleteShader(glFragmentShader);
    // set up caching for uniform locations
    var cachedUniforms;
    this.getUniforms = function() {
        if (cachedUniforms === undefined) cachedUniforms = new $c702e238df7c5123$var$WebGLUniforms(gl, program);
        return cachedUniforms;
    };
    // set up caching for attribute locations
    var cachedAttributes;
    this.getAttributes = function() {
        if (cachedAttributes === undefined) cachedAttributes = $c702e238df7c5123$var$fetchAttributeLocations(gl, program);
        return cachedAttributes;
    };
    // free resource
    this.destroy = function() {
        bindingStates.releaseStatesOfProgram(this);
        gl.deleteProgram(program);
        this.program = undefined;
    };
    //
    this.name = parameters.shaderName;
    this.id = $c702e238df7c5123$var$programIdCount++;
    this.cacheKey = cacheKey;
    this.usedTimes = 1;
    this.program = program;
    this.vertexShader = glVertexShader;
    this.fragmentShader = glFragmentShader;
    return this;
}
function $c702e238df7c5123$var$WebGLPrograms(renderer, cubemaps, extensions, capabilities, bindingStates, clipping) {
    var programs = [];
    var isWebGL2 = capabilities.isWebGL2;
    var logarithmicDepthBuffer = capabilities.logarithmicDepthBuffer;
    var floatVertexTextures = capabilities.floatVertexTextures;
    var maxVertexUniforms = capabilities.maxVertexUniforms;
    var vertexTextures = capabilities.vertexTextures;
    var precision = capabilities.precision;
    var shaderIDs = {
        MeshDepthMaterial: 'depth',
        MeshDistanceMaterial: 'distanceRGBA',
        MeshNormalMaterial: 'normal',
        MeshBasicMaterial: 'basic',
        MeshLambertMaterial: 'lambert',
        MeshPhongMaterial: 'phong',
        MeshToonMaterial: 'toon',
        MeshStandardMaterial: 'physical',
        MeshPhysicalMaterial: 'physical',
        MeshMatcapMaterial: 'matcap',
        LineBasicMaterial: 'basic',
        LineDashedMaterial: 'dashed',
        PointsMaterial: 'points',
        ShadowMaterial: 'shadow',
        SpriteMaterial: 'sprite'
    };
    var parameterNames = [
        'precision',
        'isWebGL2',
        'supportsVertexTextures',
        'outputEncoding',
        'instancing',
        'instancingColor',
        'map',
        'mapEncoding',
        'matcap',
        'matcapEncoding',
        'envMap',
        'envMapMode',
        'envMapEncoding',
        'envMapCubeUV',
        'lightMap',
        'lightMapEncoding',
        'aoMap',
        'emissiveMap',
        'emissiveMapEncoding',
        'bumpMap',
        'normalMap',
        'objectSpaceNormalMap',
        'tangentSpaceNormalMap',
        'clearcoatMap',
        'clearcoatRoughnessMap',
        'clearcoatNormalMap',
        'displacementMap',
        'specularMap',
        'roughnessMap',
        'metalnessMap',
        'gradientMap',
        'alphaMap',
        'combine',
        'vertexColors',
        'vertexAlphas',
        'vertexTangents',
        'vertexUvs',
        'uvsVertexOnly',
        'fog',
        'useFog',
        'fogExp2',
        'flatShading',
        'sizeAttenuation',
        'logarithmicDepthBuffer',
        'skinning',
        'maxBones',
        'useVertexTexture',
        'morphTargets',
        'morphNormals',
        'premultipliedAlpha',
        'numDirLights',
        'numPointLights',
        'numSpotLights',
        'numHemiLights',
        'numRectAreaLights',
        'numDirLightShadows',
        'numPointLightShadows',
        'numSpotLightShadows',
        'shadowMapEnabled',
        'shadowMapType',
        'toneMapping',
        'physicallyCorrectLights',
        'alphaTest',
        'doubleSided',
        'flipSided',
        'numClippingPlanes',
        'numClipIntersection',
        'depthPacking',
        'dithering',
        'sheen',
        'transmission',
        'transmissionMap',
        'thicknessMap'
    ];
    function getMaxBones(object) {
        var skeleton = object.skeleton;
        var bones = skeleton.bones;
        if (floatVertexTextures) return 1024;
        else {
            // default for when object is not specified
            // ( for example when prebuilding shader to be used with multiple objects )
            //
            //  - leave some extra space for other uniforms
            //  - limit here is ANGLE's 254 max uniform vectors
            //    (up to 54 should be safe)
            var nVertexUniforms = maxVertexUniforms;
            var nVertexMatrices = Math.floor((nVertexUniforms - 20) / 4);
            var maxBones = Math.min(nVertexMatrices, bones.length);
            if (maxBones < bones.length) {
                console.warn('THREE.WebGLRenderer: Skeleton has ' + bones.length + ' bones. This GPU supports ' + maxBones + '.');
                return 0;
            }
            return maxBones;
        }
    }
    function getTextureEncodingFromMap(map) {
        var encoding;
        if (map && map.isTexture) encoding = map.encoding;
        else if (map && map.isWebGLRenderTarget) {
            console.warn('THREE.WebGLPrograms.getTextureEncodingFromMap: don\'t use render targets as textures. Use their .texture property instead.');
            encoding = map.texture.encoding;
        } else encoding = $c702e238df7c5123$export$7207336e4151a112;
        return encoding;
    }
    function getParameters(material, lights, shadows, scene, object) {
        var fog = scene.fog;
        var environment = material.isMeshStandardMaterial ? scene.environment : null;
        var envMap = cubemaps.get(material.envMap || environment);
        var shaderID = shaderIDs[material.type];
        // heuristics to create shader parameters according to lights in the scene
        // (not to blow over maxLights budget)
        var maxBones = object.isSkinnedMesh ? getMaxBones(object) : 0;
        if (material.precision !== null) {
            precision = capabilities.getMaxPrecision(material.precision);
            if (precision !== material.precision) console.warn('THREE.WebGLProgram.getParameters:', material.precision, 'not supported, using', precision, 'instead.');
        }
        var vertexShader, fragmentShader;
        if (shaderID) {
            var shader = $c702e238df7c5123$export$bee4a7d47f8f5014[shaderID];
            vertexShader = shader.vertexShader;
            fragmentShader = shader.fragmentShader;
        } else {
            vertexShader = material.vertexShader;
            fragmentShader = material.fragmentShader;
        }
        var currentRenderTarget = renderer.getRenderTarget();
        var parameters = {
            isWebGL2: isWebGL2,
            shaderID: shaderID,
            shaderName: material.type,
            vertexShader: vertexShader,
            fragmentShader: fragmentShader,
            defines: material.defines,
            isRawShaderMaterial: material.isRawShaderMaterial === true,
            glslVersion: material.glslVersion,
            precision: precision,
            instancing: object.isInstancedMesh === true,
            instancingColor: object.isInstancedMesh === true && object.instanceColor !== null,
            supportsVertexTextures: vertexTextures,
            outputEncoding: currentRenderTarget !== null ? getTextureEncodingFromMap(currentRenderTarget.texture) : renderer.outputEncoding,
            map: !!material.map,
            mapEncoding: getTextureEncodingFromMap(material.map),
            matcap: !!material.matcap,
            matcapEncoding: getTextureEncodingFromMap(material.matcap),
            envMap: !!envMap,
            envMapMode: envMap && envMap.mapping,
            envMapEncoding: getTextureEncodingFromMap(envMap),
            envMapCubeUV: !!envMap && (envMap.mapping === $c702e238df7c5123$export$dbf3e70ff37af79 || envMap.mapping === $c702e238df7c5123$export$76a9f4355364345c),
            lightMap: !!material.lightMap,
            lightMapEncoding: getTextureEncodingFromMap(material.lightMap),
            aoMap: !!material.aoMap,
            emissiveMap: !!material.emissiveMap,
            emissiveMapEncoding: getTextureEncodingFromMap(material.emissiveMap),
            bumpMap: !!material.bumpMap,
            normalMap: !!material.normalMap,
            objectSpaceNormalMap: material.normalMapType === $c702e238df7c5123$export$9990ad26f9db5b2c,
            tangentSpaceNormalMap: material.normalMapType === $c702e238df7c5123$export$2852a58ebdac27b8,
            clearcoatMap: !!material.clearcoatMap,
            clearcoatRoughnessMap: !!material.clearcoatRoughnessMap,
            clearcoatNormalMap: !!material.clearcoatNormalMap,
            displacementMap: !!material.displacementMap,
            roughnessMap: !!material.roughnessMap,
            metalnessMap: !!material.metalnessMap,
            specularMap: !!material.specularMap,
            alphaMap: !!material.alphaMap,
            gradientMap: !!material.gradientMap,
            sheen: !!material.sheen,
            transmission: !!material.transmission,
            transmissionMap: !!material.transmissionMap,
            thicknessMap: !!material.thicknessMap,
            combine: material.combine,
            vertexTangents: material.normalMap && material.vertexTangents,
            vertexColors: material.vertexColors,
            vertexAlphas: material.vertexColors === true && object.geometry && object.geometry.attributes.color && object.geometry.attributes.color.itemSize === 4,
            vertexUvs: !!material.map || !!material.bumpMap || !!material.normalMap || !!material.specularMap || !!material.alphaMap || !!material.emissiveMap || !!material.roughnessMap || !!material.metalnessMap || !!material.clearcoatMap || !!material.clearcoatRoughnessMap || !!material.clearcoatNormalMap || !!material.displacementMap || !!material.transmissionMap || !!material.thicknessMap,
            uvsVertexOnly: !(!!material.map || !!material.bumpMap || !!material.normalMap || !!material.specularMap || !!material.alphaMap || !!material.emissiveMap || !!material.roughnessMap || !!material.metalnessMap || !!material.clearcoatNormalMap || !!material.transmission || !!material.transmissionMap || !!material.thicknessMap) && !!material.displacementMap,
            fog: !!fog,
            useFog: material.fog,
            fogExp2: fog && fog.isFogExp2,
            flatShading: !!material.flatShading,
            sizeAttenuation: material.sizeAttenuation,
            logarithmicDepthBuffer: logarithmicDepthBuffer,
            skinning: object.isSkinnedMesh === true && maxBones > 0,
            maxBones: maxBones,
            useVertexTexture: floatVertexTextures,
            morphTargets: material.morphTargets,
            morphNormals: material.morphNormals,
            numDirLights: lights.directional.length,
            numPointLights: lights.point.length,
            numSpotLights: lights.spot.length,
            numRectAreaLights: lights.rectArea.length,
            numHemiLights: lights.hemi.length,
            numDirLightShadows: lights.directionalShadowMap.length,
            numPointLightShadows: lights.pointShadowMap.length,
            numSpotLightShadows: lights.spotShadowMap.length,
            numClippingPlanes: clipping.numPlanes,
            numClipIntersection: clipping.numIntersection,
            dithering: material.dithering,
            shadowMapEnabled: renderer.shadowMap.enabled && shadows.length > 0,
            shadowMapType: renderer.shadowMap.type,
            toneMapping: material.toneMapped ? renderer.toneMapping : $c702e238df7c5123$export$9fcb6b4294603b2,
            physicallyCorrectLights: renderer.physicallyCorrectLights,
            premultipliedAlpha: material.premultipliedAlpha,
            alphaTest: material.alphaTest,
            doubleSided: material.side === $c702e238df7c5123$export$3b296b6f144d5b03,
            flipSided: material.side === $c702e238df7c5123$export$d9f0486e75b5ace,
            depthPacking: material.depthPacking !== undefined ? material.depthPacking : false,
            index0AttributeName: material.index0AttributeName,
            extensionDerivatives: material.extensions && material.extensions.derivatives,
            extensionFragDepth: material.extensions && material.extensions.fragDepth,
            extensionDrawBuffers: material.extensions && material.extensions.drawBuffers,
            extensionShaderTextureLOD: material.extensions && material.extensions.shaderTextureLOD,
            rendererExtensionFragDepth: isWebGL2 || extensions.has('EXT_frag_depth'),
            rendererExtensionDrawBuffers: isWebGL2 || extensions.has('WEBGL_draw_buffers'),
            rendererExtensionShaderTextureLod: isWebGL2 || extensions.has('EXT_shader_texture_lod'),
            customProgramCacheKey: material.customProgramCacheKey()
        };
        return parameters;
    }
    function getProgramCacheKey(parameters) {
        var array = [];
        if (parameters.shaderID) array.push(parameters.shaderID);
        else {
            array.push(parameters.fragmentShader);
            array.push(parameters.vertexShader);
        }
        if (parameters.defines !== undefined) for(var name in parameters.defines){
            array.push(name);
            array.push(parameters.defines[name]);
        }
        if (parameters.isRawShaderMaterial === false) {
            for(var i = 0; i < parameterNames.length; i++)array.push(parameters[parameterNames[i]]);
            array.push(renderer.outputEncoding);
            array.push(renderer.gammaFactor);
        }
        array.push(parameters.customProgramCacheKey);
        return array.join();
    }
    function getUniforms(material) {
        var shaderID = shaderIDs[material.type];
        var uniforms;
        if (shaderID) {
            var shader = $c702e238df7c5123$export$bee4a7d47f8f5014[shaderID];
            uniforms = $c702e238df7c5123$export$d8ecdf8615bfea69.clone(shader.uniforms);
        } else uniforms = material.uniforms;
        return uniforms;
    }
    function acquireProgram(parameters, cacheKey) {
        var program;
        // Check if code has been already compiled
        for(var p = 0, pl = programs.length; p < pl; p++){
            var preexistingProgram = programs[p];
            if (preexistingProgram.cacheKey === cacheKey) {
                program = preexistingProgram;
                ++program.usedTimes;
                break;
            }
        }
        if (program === undefined) {
            program = new $c702e238df7c5123$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates);
            programs.push(program);
        }
        return program;
    }
    function releaseProgram(program) {
        if (--program.usedTimes === 0) {
            // Remove from unordered set
            var i = programs.indexOf(program);
            programs[i] = programs[programs.length - 1];
            programs.pop();
            // Free WebGL resources
            program.destroy();
        }
    }
    return {
        getParameters: getParameters,
        getProgramCacheKey: getProgramCacheKey,
        getUniforms: getUniforms,
        acquireProgram: acquireProgram,
        releaseProgram: releaseProgram,
        // Exposed for resource monitoring & error feedback via renderer.info:
        programs: programs
    };
}
function $c702e238df7c5123$var$WebGLProperties() {
    var properties = new WeakMap();
    function get(object) {
        var map = properties.get(object);
        if (map === undefined) {
            map = {};
            properties.set(object, map);
        }
        return map;
    }
    function remove(object) {
        properties["delete"](object);
    }
    function update(object, key, value) {
        properties.get(object)[key] = value;
    }
    function dispose() {
        properties = new WeakMap();
    }
    return {
        get: get,
        remove: remove,
        update: update,
        dispose: dispose
    };
}
function $c702e238df7c5123$var$painterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.program !== b.program) return a.program.id - b.program.id;
    else if (a.material.id !== b.material.id) return a.material.id - b.material.id;
    else if (a.z !== b.z) return a.z - b.z;
    else return a.id - b.id;
}
function $c702e238df7c5123$var$reversePainterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.z !== b.z) return b.z - a.z;
    else return a.id - b.id;
}
function $c702e238df7c5123$var$WebGLRenderList(properties) {
    var renderItems = [];
    var renderItemsIndex = 0;
    var opaque = [];
    var transmissive = [];
    var transparent = [];
    var defaultProgram = {
        id: -1
    };
    function init() {
        renderItemsIndex = 0;
        opaque.length = 0;
        transmissive.length = 0;
        transparent.length = 0;
    }
    function getNextRenderItem(object, geometry, material, groupOrder, z, group) {
        var renderItem = renderItems[renderItemsIndex];
        var materialProperties = properties.get(material);
        if (renderItem === undefined) {
            renderItem = {
                id: object.id,
                object: object,
                geometry: geometry,
                material: material,
                program: materialProperties.program || defaultProgram,
                groupOrder: groupOrder,
                renderOrder: object.renderOrder,
                z: z,
                group: group
            };
            renderItems[renderItemsIndex] = renderItem;
        } else {
            renderItem.id = object.id;
            renderItem.object = object;
            renderItem.geometry = geometry;
            renderItem.material = material;
            renderItem.program = materialProperties.program || defaultProgram;
            renderItem.groupOrder = groupOrder;
            renderItem.renderOrder = object.renderOrder;
            renderItem.z = z;
            renderItem.group = group;
        }
        renderItemsIndex++;
        return renderItem;
    }
    function push(object, geometry, material, groupOrder, z, group) {
        var renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.push(renderItem);
        else if (material.transparent === true) transparent.push(renderItem);
        else opaque.push(renderItem);
    }
    function unshift(object, geometry, material, groupOrder, z, group) {
        var renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.unshift(renderItem);
        else if (material.transparent === true) transparent.unshift(renderItem);
        else opaque.unshift(renderItem);
    }
    function sort(customOpaqueSort, customTransparentSort) {
        if (opaque.length > 1) opaque.sort(customOpaqueSort || $c702e238df7c5123$var$painterSortStable);
        if (transmissive.length > 1) transmissive.sort(customTransparentSort || $c702e238df7c5123$var$reversePainterSortStable);
        if (transparent.length > 1) transparent.sort(customTransparentSort || $c702e238df7c5123$var$reversePainterSortStable);
    }
    function finish() {
        // Clear references from inactive renderItems in the list
        for(var i = renderItemsIndex, il = renderItems.length; i < il; i++){
            var renderItem = renderItems[i];
            if (renderItem.id === null) break;
            renderItem.id = null;
            renderItem.object = null;
            renderItem.geometry = null;
            renderItem.material = null;
            renderItem.program = null;
            renderItem.group = null;
        }
    }
    return {
        opaque: opaque,
        transmissive: transmissive,
        transparent: transparent,
        init: init,
        push: push,
        unshift: unshift,
        finish: finish,
        sort: sort
    };
}
function $c702e238df7c5123$var$WebGLRenderLists(properties) {
    var lists = new WeakMap();
    function get(scene, renderCallDepth) {
        var list;
        if (lists.has(scene) === false) {
            list = new $c702e238df7c5123$var$WebGLRenderList(properties);
            lists.set(scene, [
                list
            ]);
        } else if (renderCallDepth >= lists.get(scene).length) {
            list = new $c702e238df7c5123$var$WebGLRenderList(properties);
            lists.get(scene).push(list);
        } else list = lists.get(scene)[renderCallDepth];
        return list;
    }
    function dispose() {
        lists = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $c702e238df7c5123$var$UniformsCache() {
    var lights = {};
    return {
        get: function get(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            var uniforms;
            switch(light.type){
                case 'DirectionalLight':
                    uniforms = {
                        direction: new $c702e238df7c5123$export$64b5c384219d3699(),
                        color: new $c702e238df7c5123$export$892596cec99bc70e()
                    };
                    break;
                case 'SpotLight':
                    uniforms = {
                        position: new $c702e238df7c5123$export$64b5c384219d3699(),
                        direction: new $c702e238df7c5123$export$64b5c384219d3699(),
                        color: new $c702e238df7c5123$export$892596cec99bc70e(),
                        distance: 0,
                        coneCos: 0,
                        penumbraCos: 0,
                        decay: 0
                    };
                    break;
                case 'PointLight':
                    uniforms = {
                        position: new $c702e238df7c5123$export$64b5c384219d3699(),
                        color: new $c702e238df7c5123$export$892596cec99bc70e(),
                        distance: 0,
                        decay: 0
                    };
                    break;
                case 'HemisphereLight':
                    uniforms = {
                        direction: new $c702e238df7c5123$export$64b5c384219d3699(),
                        skyColor: new $c702e238df7c5123$export$892596cec99bc70e(),
                        groundColor: new $c702e238df7c5123$export$892596cec99bc70e()
                    };
                    break;
                case 'RectAreaLight':
                    uniforms = {
                        color: new $c702e238df7c5123$export$892596cec99bc70e(),
                        position: new $c702e238df7c5123$export$64b5c384219d3699(),
                        halfWidth: new $c702e238df7c5123$export$64b5c384219d3699(),
                        halfHeight: new $c702e238df7c5123$export$64b5c384219d3699()
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
function $c702e238df7c5123$var$ShadowUniformsCache() {
    var lights = {};
    return {
        get: function get(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            var uniforms;
            switch(light.type){
                case 'DirectionalLight':
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $c702e238df7c5123$export$c977b3e384af9ae1()
                    };
                    break;
                case 'SpotLight':
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $c702e238df7c5123$export$c977b3e384af9ae1()
                    };
                    break;
                case 'PointLight':
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $c702e238df7c5123$export$c977b3e384af9ae1(),
                        shadowCameraNear: 1,
                        shadowCameraFar: 1000
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
var $c702e238df7c5123$var$nextVersion = 0;
function $c702e238df7c5123$var$shadowCastingLightsFirst(lightA, lightB) {
    return (lightB.castShadow ? 1 : 0) - (lightA.castShadow ? 1 : 0);
}
function $c702e238df7c5123$var$WebGLLights(extensions, capabilities) {
    var cache = new $c702e238df7c5123$var$UniformsCache();
    var shadowCache = $c702e238df7c5123$var$ShadowUniformsCache();
    var state = {
        version: 0,
        hash: {
            directionalLength: -1,
            pointLength: -1,
            spotLength: -1,
            rectAreaLength: -1,
            hemiLength: -1,
            numDirectionalShadows: -1,
            numPointShadows: -1,
            numSpotShadows: -1
        },
        ambient: [
            0,
            0,
            0
        ],
        probe: [],
        directional: [],
        directionalShadow: [],
        directionalShadowMap: [],
        directionalShadowMatrix: [],
        spot: [],
        spotShadow: [],
        spotShadowMap: [],
        spotShadowMatrix: [],
        rectArea: [],
        rectAreaLTC1: null,
        rectAreaLTC2: null,
        point: [],
        pointShadow: [],
        pointShadowMap: [],
        pointShadowMatrix: [],
        hemi: []
    };
    for(var i = 0; i < 9; i++)state.probe.push(new $c702e238df7c5123$export$64b5c384219d3699());
    var vector3 = new $c702e238df7c5123$export$64b5c384219d3699();
    var matrix4 = new $c702e238df7c5123$export$2ae72fc923e5eb5();
    var matrix42 = new $c702e238df7c5123$export$2ae72fc923e5eb5();
    function setup(lights) {
        var r = 0, g = 0, b = 0;
        for(var i = 0; i < 9; i++)state.probe[i].set(0, 0, 0);
        var directionalLength = 0;
        var pointLength = 0;
        var spotLength = 0;
        var rectAreaLength = 0;
        var hemiLength = 0;
        var numDirectionalShadows = 0;
        var numPointShadows = 0;
        var numSpotShadows = 0;
        lights.sort($c702e238df7c5123$var$shadowCastingLightsFirst);
        for(var i1 = 0, l = lights.length; i1 < l; i1++){
            var light = lights[i1];
            var color = light.color;
            var intensity = light.intensity;
            var distance = light.distance;
            var shadowMap = light.shadow && light.shadow.map ? light.shadow.map.texture : null;
            if (light.isAmbientLight) {
                r += color.r * intensity;
                g += color.g * intensity;
                b += color.b * intensity;
            } else if (light.isLightProbe) for(var j = 0; j < 9; j++)state.probe[j].addScaledVector(light.sh.coefficients[j], intensity);
            else if (light.isDirectionalLight) {
                var uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity);
                if (light.castShadow) {
                    var shadow = light.shadow;
                    var shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.directionalShadow[directionalLength] = shadowUniforms;
                    state.directionalShadowMap[directionalLength] = shadowMap;
                    state.directionalShadowMatrix[directionalLength] = light.shadow.matrix;
                    numDirectionalShadows++;
                }
                state.directional[directionalLength] = uniforms;
                directionalLength++;
            } else if (light.isSpotLight) {
                var uniforms1 = cache.get(light);
                uniforms1.position.setFromMatrixPosition(light.matrixWorld);
                uniforms1.color.copy(color).multiplyScalar(intensity);
                uniforms1.distance = distance;
                uniforms1.coneCos = Math.cos(light.angle);
                uniforms1.penumbraCos = Math.cos(light.angle * (1 - light.penumbra));
                uniforms1.decay = light.decay;
                if (light.castShadow) {
                    var shadow1 = light.shadow;
                    var shadowUniforms1 = shadowCache.get(light);
                    shadowUniforms1.shadowBias = shadow1.bias;
                    shadowUniforms1.shadowNormalBias = shadow1.normalBias;
                    shadowUniforms1.shadowRadius = shadow1.radius;
                    shadowUniforms1.shadowMapSize = shadow1.mapSize;
                    state.spotShadow[spotLength] = shadowUniforms1;
                    state.spotShadowMap[spotLength] = shadowMap;
                    state.spotShadowMatrix[spotLength] = light.shadow.matrix;
                    numSpotShadows++;
                }
                state.spot[spotLength] = uniforms1;
                spotLength++;
            } else if (light.isRectAreaLight) {
                var uniforms2 = cache.get(light);
                // (a) intensity is the total visible light emitted
                //uniforms.color.copy( color ).multiplyScalar( intensity / ( light.width * light.height * Math.PI ) );
                // (b) intensity is the brightness of the light
                uniforms2.color.copy(color).multiplyScalar(intensity);
                uniforms2.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms2.halfHeight.set(0.0, light.height * 0.5, 0.0);
                state.rectArea[rectAreaLength] = uniforms2;
                rectAreaLength++;
            } else if (light.isPointLight) {
                var uniforms3 = cache.get(light);
                uniforms3.color.copy(light.color).multiplyScalar(light.intensity);
                uniforms3.distance = light.distance;
                uniforms3.decay = light.decay;
                if (light.castShadow) {
                    var shadow2 = light.shadow;
                    var shadowUniforms2 = shadowCache.get(light);
                    shadowUniforms2.shadowBias = shadow2.bias;
                    shadowUniforms2.shadowNormalBias = shadow2.normalBias;
                    shadowUniforms2.shadowRadius = shadow2.radius;
                    shadowUniforms2.shadowMapSize = shadow2.mapSize;
                    shadowUniforms2.shadowCameraNear = shadow2.camera.near;
                    shadowUniforms2.shadowCameraFar = shadow2.camera.far;
                    state.pointShadow[pointLength] = shadowUniforms2;
                    state.pointShadowMap[pointLength] = shadowMap;
                    state.pointShadowMatrix[pointLength] = light.shadow.matrix;
                    numPointShadows++;
                }
                state.point[pointLength] = uniforms3;
                pointLength++;
            } else if (light.isHemisphereLight) {
                var uniforms4 = cache.get(light);
                uniforms4.skyColor.copy(light.color).multiplyScalar(intensity);
                uniforms4.groundColor.copy(light.groundColor).multiplyScalar(intensity);
                state.hemi[hemiLength] = uniforms4;
                hemiLength++;
            }
        }
        if (rectAreaLength > 0) {
            if (capabilities.isWebGL2) {
                // WebGL 2
                state.rectAreaLTC1 = $c702e238df7c5123$export$6643083551874bf5.LTC_FLOAT_1;
                state.rectAreaLTC2 = $c702e238df7c5123$export$6643083551874bf5.LTC_FLOAT_2;
            } else {
                // WebGL 1
                if (extensions.has('OES_texture_float_linear') === true) {
                    state.rectAreaLTC1 = $c702e238df7c5123$export$6643083551874bf5.LTC_FLOAT_1;
                    state.rectAreaLTC2 = $c702e238df7c5123$export$6643083551874bf5.LTC_FLOAT_2;
                } else if (extensions.has('OES_texture_half_float_linear') === true) {
                    state.rectAreaLTC1 = $c702e238df7c5123$export$6643083551874bf5.LTC_HALF_1;
                    state.rectAreaLTC2 = $c702e238df7c5123$export$6643083551874bf5.LTC_HALF_2;
                } else console.error('THREE.WebGLRenderer: Unable to use RectAreaLight. Missing WebGL extensions.');
            }
        }
        state.ambient[0] = r;
        state.ambient[1] = g;
        state.ambient[2] = b;
        var hash = state.hash;
        if (hash.directionalLength !== directionalLength || hash.pointLength !== pointLength || hash.spotLength !== spotLength || hash.rectAreaLength !== rectAreaLength || hash.hemiLength !== hemiLength || hash.numDirectionalShadows !== numDirectionalShadows || hash.numPointShadows !== numPointShadows || hash.numSpotShadows !== numSpotShadows) {
            state.directional.length = directionalLength;
            state.spot.length = spotLength;
            state.rectArea.length = rectAreaLength;
            state.point.length = pointLength;
            state.hemi.length = hemiLength;
            state.directionalShadow.length = numDirectionalShadows;
            state.directionalShadowMap.length = numDirectionalShadows;
            state.pointShadow.length = numPointShadows;
            state.pointShadowMap.length = numPointShadows;
            state.spotShadow.length = numSpotShadows;
            state.spotShadowMap.length = numSpotShadows;
            state.directionalShadowMatrix.length = numDirectionalShadows;
            state.pointShadowMatrix.length = numPointShadows;
            state.spotShadowMatrix.length = numSpotShadows;
            hash.directionalLength = directionalLength;
            hash.pointLength = pointLength;
            hash.spotLength = spotLength;
            hash.rectAreaLength = rectAreaLength;
            hash.hemiLength = hemiLength;
            hash.numDirectionalShadows = numDirectionalShadows;
            hash.numPointShadows = numPointShadows;
            hash.numSpotShadows = numSpotShadows;
            state.version = $c702e238df7c5123$var$nextVersion++;
        }
    }
    function setupView(lights, camera) {
        var directionalLength = 0;
        var pointLength = 0;
        var spotLength = 0;
        var rectAreaLength = 0;
        var hemiLength = 0;
        var viewMatrix = camera.matrixWorldInverse;
        for(var i = 0, l = lights.length; i < l; i++){
            var light = lights[i];
            if (light.isDirectionalLight) {
                var uniforms = state.directional[directionalLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                directionalLength++;
            } else if (light.isSpotLight) {
                var uniforms1 = state.spot[spotLength];
                uniforms1.position.setFromMatrixPosition(light.matrixWorld);
                uniforms1.position.applyMatrix4(viewMatrix);
                uniforms1.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms1.direction.sub(vector3);
                uniforms1.direction.transformDirection(viewMatrix);
                spotLength++;
            } else if (light.isRectAreaLight) {
                var uniforms2 = state.rectArea[rectAreaLength];
                uniforms2.position.setFromMatrixPosition(light.matrixWorld);
                uniforms2.position.applyMatrix4(viewMatrix);
                // extract local rotation of light to derive width/height half vectors
                matrix42.identity();
                matrix4.copy(light.matrixWorld);
                matrix4.premultiply(viewMatrix);
                matrix42.extractRotation(matrix4);
                uniforms2.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms2.halfHeight.set(0.0, light.height * 0.5, 0.0);
                uniforms2.halfWidth.applyMatrix4(matrix42);
                uniforms2.halfHeight.applyMatrix4(matrix42);
                rectAreaLength++;
            } else if (light.isPointLight) {
                var uniforms3 = state.point[pointLength];
                uniforms3.position.setFromMatrixPosition(light.matrixWorld);
                uniforms3.position.applyMatrix4(viewMatrix);
                pointLength++;
            } else if (light.isHemisphereLight) {
                var uniforms4 = state.hemi[hemiLength];
                uniforms4.direction.setFromMatrixPosition(light.matrixWorld);
                uniforms4.direction.transformDirection(viewMatrix);
                uniforms4.direction.normalize();
                hemiLength++;
            }
        }
    }
    return {
        setup: setup,
        setupView: setupView,
        state: state
    };
}
function $c702e238df7c5123$var$WebGLRenderState(extensions, capabilities) {
    var lights = new $c702e238df7c5123$var$WebGLLights(extensions, capabilities);
    var lightsArray = [];
    var shadowsArray = [];
    function init() {
        lightsArray.length = 0;
        shadowsArray.length = 0;
    }
    function pushLight(light) {
        lightsArray.push(light);
    }
    function pushShadow(shadowLight) {
        shadowsArray.push(shadowLight);
    }
    function setupLights() {
        lights.setup(lightsArray);
    }
    function setupLightsView(camera) {
        lights.setupView(lightsArray, camera);
    }
    var state = {
        lightsArray: lightsArray,
        shadowsArray: shadowsArray,
        lights: lights
    };
    return {
        init: init,
        state: state,
        setupLights: setupLights,
        setupLightsView: setupLightsView,
        pushLight: pushLight,
        pushShadow: pushShadow
    };
}
function $c702e238df7c5123$var$WebGLRenderStates(extensions, capabilities) {
    var renderStates = new WeakMap();
    function get(scene) {
        var renderCallDepth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        var renderState;
        if (renderStates.has(scene) === false) {
            renderState = new $c702e238df7c5123$var$WebGLRenderState(extensions, capabilities);
            renderStates.set(scene, [
                renderState
            ]);
        } else if (renderCallDepth >= renderStates.get(scene).length) {
            renderState = new $c702e238df7c5123$var$WebGLRenderState(extensions, capabilities);
            renderStates.get(scene).push(renderState);
        } else renderState = renderStates.get(scene)[renderCallDepth];
        return renderState;
    }
    function dispose() {
        renderStates = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
/**
 * parameters = {
 *
 *  opacity: <float>,
 *
 *  map: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>
 * }
 */ var $c702e238df7c5123$export$2698c22ec13825db = /*#__PURE__*/ function(Material) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(MeshDepthMaterial, Material);
    function MeshDepthMaterial(parameters) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, MeshDepthMaterial);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, MeshDepthMaterial);
        _this.type = 'MeshDepthMaterial';
        _this.depthPacking = $c702e238df7c5123$export$deeb383078690b50;
        _this.morphTargets = false;
        _this.map = null;
        _this.alphaMap = null;
        _this.displacementMap = null;
        _this.displacementScale = 1;
        _this.displacementBias = 0;
        _this.wireframe = false;
        _this.wireframeLinewidth = 1;
        _this.fog = false;
        _this.setValues(parameters);
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(MeshDepthMaterial, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(MeshDepthMaterial.prototype), "copy", this).call(this, source);
                this.depthPacking = source.depthPacking;
                this.morphTargets = source.morphTargets;
                this.map = source.map;
                this.alphaMap = source.alphaMap;
                this.displacementMap = source.displacementMap;
                this.displacementScale = source.displacementScale;
                this.displacementBias = source.displacementBias;
                this.wireframe = source.wireframe;
                this.wireframeLinewidth = source.wireframeLinewidth;
                return this;
            }
        }
    ]);
    return MeshDepthMaterial;
}($c702e238df7c5123$export$a2d8b23205c25948);
$c702e238df7c5123$export$2698c22ec13825db.prototype.isMeshDepthMaterial = true;
/**
 * parameters = {
 *
 *  referencePosition: <float>,
 *  nearDistance: <float>,
 *  farDistance: <float>,
 *
 *  morphTargets: <bool>,
 *
 *  map: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>
 *
 * }
 */ var $c702e238df7c5123$export$33e187ed002f2a19 = /*#__PURE__*/ function(Material) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(MeshDistanceMaterial, Material);
    function MeshDistanceMaterial(parameters) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, MeshDistanceMaterial);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, MeshDistanceMaterial);
        _this.type = 'MeshDistanceMaterial';
        _this.referencePosition = new $c702e238df7c5123$export$64b5c384219d3699();
        _this.nearDistance = 1;
        _this.farDistance = 1000;
        _this.morphTargets = false;
        _this.map = null;
        _this.alphaMap = null;
        _this.displacementMap = null;
        _this.displacementScale = 1;
        _this.displacementBias = 0;
        _this.fog = false;
        _this.setValues(parameters);
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(MeshDistanceMaterial, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(MeshDistanceMaterial.prototype), "copy", this).call(this, source);
                this.referencePosition.copy(source.referencePosition);
                this.nearDistance = source.nearDistance;
                this.farDistance = source.farDistance;
                this.morphTargets = source.morphTargets;
                this.map = source.map;
                this.alphaMap = source.alphaMap;
                this.displacementMap = source.displacementMap;
                this.displacementScale = source.displacementScale;
                this.displacementBias = source.displacementBias;
                return this;
            }
        }
    ]);
    return MeshDistanceMaterial;
}($c702e238df7c5123$export$a2d8b23205c25948);
$c702e238df7c5123$export$33e187ed002f2a19.prototype.isMeshDistanceMaterial = true;
var $c702e238df7c5123$var$vsm_frag = "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n\tfloat mean = 0.0;\n\tfloat squared_mean = 0.0;\n\tfloat depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy ) / resolution ) );\n\tfor ( float i = -1.0; i < 1.0 ; i += SAMPLE_RATE) {\n\t\t#ifdef HORIZONTAL_PASS\n\t\t\tvec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( i, 0.0 ) * radius ) / resolution ) );\n\t\t\tmean += distribution.x;\n\t\t\tsquared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n\t\t#else\n\t\t\tfloat depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, i ) * radius ) / resolution ) );\n\t\t\tmean += depth;\n\t\t\tsquared_mean += depth * depth;\n\t\t#endif\n\t}\n\tmean = mean * HALF_SAMPLE_RATE;\n\tsquared_mean = squared_mean * HALF_SAMPLE_RATE;\n\tfloat std_dev = sqrt( squared_mean - mean * mean );\n\tgl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}";
var $c702e238df7c5123$var$vsm_vert = "void main() {\n\tgl_Position = vec4( position, 1.0 );\n}";
function $c702e238df7c5123$var$WebGLShadowMap(_renderer, _objects, _capabilities) {
    var _frustum = new $c702e238df7c5123$export$35efe6f4c85463d2();
    var _shadowMapSize = new $c702e238df7c5123$export$c977b3e384af9ae1(), _viewportSize = new $c702e238df7c5123$export$c977b3e384af9ae1(), _viewport = new $c702e238df7c5123$export$fa7daccca11cdbe3(), _depthMaterials = [], _distanceMaterials = [], _materialCache = {}, _maxTextureSize = _capabilities.maxTextureSize;
    var shadowSide = {
        0: $c702e238df7c5123$export$d9f0486e75b5ace,
        1: $c702e238df7c5123$export$2ede184fc2998901,
        2: $c702e238df7c5123$export$3b296b6f144d5b03
    };
    var shadowMaterialVertical = new $c702e238df7c5123$export$83c7d75d550a8b0d({
        defines: {
            SAMPLE_RATE: 0.25,
            HALF_SAMPLE_RATE: 0.125
        },
        uniforms: {
            shadow_pass: {
                value: null
            },
            resolution: {
                value: new $c702e238df7c5123$export$c977b3e384af9ae1()
            },
            radius: {
                value: 4.0
            }
        },
        vertexShader: $c702e238df7c5123$var$vsm_vert,
        fragmentShader: $c702e238df7c5123$var$vsm_frag
    });
    var shadowMaterialHorizontal = shadowMaterialVertical.clone();
    shadowMaterialHorizontal.defines.HORIZONTAL_PASS = 1;
    var fullScreenTri = new $c702e238df7c5123$export$b7be63a67df8959();
    fullScreenTri.setAttribute('position', new $c702e238df7c5123$export$8dea267bd6bde117(new Float32Array([
        -1,
        -1,
        0.5,
        3,
        -1,
        0.5,
        -1,
        3,
        0.5
    ]), 3));
    var fullScreenMesh = new $c702e238df7c5123$export$e176487c05830cc5(fullScreenTri, shadowMaterialVertical);
    var scope = this;
    this.enabled = false;
    this.autoUpdate = true;
    this.needsUpdate = false;
    this.type = $c702e238df7c5123$export$5813f879eee7cd88;
    this.render = function(lights, scene, camera) {
        if (scope.enabled === false) return;
        if (scope.autoUpdate === false && scope.needsUpdate === false) return;
        if (lights.length === 0) return;
        var currentRenderTarget = _renderer.getRenderTarget();
        var activeCubeFace = _renderer.getActiveCubeFace();
        var activeMipmapLevel = _renderer.getActiveMipmapLevel();
        var _state = _renderer.state;
        // Set GL state for depth map.
        _state.setBlending($c702e238df7c5123$export$63b8d6b580fc65ba);
        _state.buffers.color.setClear(1, 1, 1, 1);
        _state.buffers.depth.setTest(true);
        _state.setScissorTest(false);
        // render depth map
        for(var i = 0, il = lights.length; i < il; i++){
            var light = lights[i];
            var shadow = light.shadow;
            if (shadow === undefined) {
                console.warn('THREE.WebGLShadowMap:', light, 'has no shadow.');
                continue;
            }
            if (shadow.autoUpdate === false && shadow.needsUpdate === false) continue;
            _shadowMapSize.copy(shadow.mapSize);
            var shadowFrameExtents = shadow.getFrameExtents();
            _shadowMapSize.multiply(shadowFrameExtents);
            _viewportSize.copy(shadow.mapSize);
            if (_shadowMapSize.x > _maxTextureSize || _shadowMapSize.y > _maxTextureSize) {
                if (_shadowMapSize.x > _maxTextureSize) {
                    _viewportSize.x = Math.floor(_maxTextureSize / shadowFrameExtents.x);
                    _shadowMapSize.x = _viewportSize.x * shadowFrameExtents.x;
                    shadow.mapSize.x = _viewportSize.x;
                }
                if (_shadowMapSize.y > _maxTextureSize) {
                    _viewportSize.y = Math.floor(_maxTextureSize / shadowFrameExtents.y);
                    _shadowMapSize.y = _viewportSize.y * shadowFrameExtents.y;
                    shadow.mapSize.y = _viewportSize.y;
                }
            }
            if (shadow.map === null && !shadow.isPointLightShadow && this.type === $c702e238df7c5123$export$896ae1ade6c829c4) {
                var pars = {
                    minFilter: $c702e238df7c5123$export$8a72f490b25c56c8,
                    magFilter: $c702e238df7c5123$export$8a72f490b25c56c8,
                    format: $c702e238df7c5123$export$3f8bb04b555a363c
                };
                shadow.map = new $c702e238df7c5123$export$3c052beb2e51e23f(_shadowMapSize.x, _shadowMapSize.y, pars);
                shadow.map.texture.name = light.name + '.shadowMap';
                shadow.mapPass = new $c702e238df7c5123$export$3c052beb2e51e23f(_shadowMapSize.x, _shadowMapSize.y, pars);
                shadow.camera.updateProjectionMatrix();
            }
            if (shadow.map === null) {
                var pars1 = {
                    minFilter: $c702e238df7c5123$export$727aa5ec3fe39bf0,
                    magFilter: $c702e238df7c5123$export$727aa5ec3fe39bf0,
                    format: $c702e238df7c5123$export$3f8bb04b555a363c
                };
                shadow.map = new $c702e238df7c5123$export$3c052beb2e51e23f(_shadowMapSize.x, _shadowMapSize.y, pars1);
                shadow.map.texture.name = light.name + '.shadowMap';
                shadow.camera.updateProjectionMatrix();
            }
            _renderer.setRenderTarget(shadow.map);
            _renderer.clear();
            var viewportCount = shadow.getViewportCount();
            for(var vp = 0; vp < viewportCount; vp++){
                var viewport = shadow.getViewport(vp);
                _viewport.set(_viewportSize.x * viewport.x, _viewportSize.y * viewport.y, _viewportSize.x * viewport.z, _viewportSize.y * viewport.w);
                _state.viewport(_viewport);
                shadow.updateMatrices(light, vp);
                _frustum = shadow.getFrustum();
                renderObject(scene, camera, shadow.camera, light, this.type);
            }
            // do blur pass for VSM
            if (!shadow.isPointLightShadow && this.type === $c702e238df7c5123$export$896ae1ade6c829c4) VSMPass(shadow, camera);
            shadow.needsUpdate = false;
        }
        scope.needsUpdate = false;
        _renderer.setRenderTarget(currentRenderTarget, activeCubeFace, activeMipmapLevel);
    };
    function VSMPass(shadow, camera) {
        var geometry = _objects.update(fullScreenMesh);
        // vertical pass
        shadowMaterialVertical.uniforms.shadow_pass.value = shadow.map.texture;
        shadowMaterialVertical.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialVertical.uniforms.radius.value = shadow.radius;
        _renderer.setRenderTarget(shadow.mapPass);
        _renderer.clear();
        _renderer.renderBufferDirect(camera, null, geometry, shadowMaterialVertical, fullScreenMesh, null);
        // horizontal pass
        shadowMaterialHorizontal.uniforms.shadow_pass.value = shadow.mapPass.texture;
        shadowMaterialHorizontal.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialHorizontal.uniforms.radius.value = shadow.radius;
        _renderer.setRenderTarget(shadow.map);
        _renderer.clear();
        _renderer.renderBufferDirect(camera, null, geometry, shadowMaterialHorizontal, fullScreenMesh, null);
    }
    function getDepthMaterialVariant(useMorphing) {
        var index = useMorphing << 0;
        var material = _depthMaterials[index];
        if (material === undefined) {
            material = new $c702e238df7c5123$export$2698c22ec13825db({
                depthPacking: $c702e238df7c5123$export$8f910f4c4f73df11,
                morphTargets: useMorphing
            });
            _depthMaterials[index] = material;
        }
        return material;
    }
    function getDistanceMaterialVariant(useMorphing) {
        var index = useMorphing << 0;
        var material = _distanceMaterials[index];
        if (material === undefined) {
            material = new $c702e238df7c5123$export$33e187ed002f2a19({
                morphTargets: useMorphing
            });
            _distanceMaterials[index] = material;
        }
        return material;
    }
    function getDepthMaterial(object, geometry, material, light, shadowCameraNear, shadowCameraFar, type) {
        var result = null;
        var getMaterialVariant = getDepthMaterialVariant;
        var customMaterial = object.customDepthMaterial;
        if (light.isPointLight === true) {
            getMaterialVariant = getDistanceMaterialVariant;
            customMaterial = object.customDistanceMaterial;
        }
        if (customMaterial === undefined) {
            var useMorphing = false;
            if (material.morphTargets === true) useMorphing = geometry.morphAttributes && geometry.morphAttributes.position && geometry.morphAttributes.position.length > 0;
            result = getMaterialVariant(useMorphing);
        } else result = customMaterial;
        if (_renderer.localClippingEnabled && material.clipShadows === true && material.clippingPlanes.length !== 0) {
            // in this case we need a unique material instance reflecting the
            // appropriate state
            var keyA = result.uuid, keyB = material.uuid;
            var materialsForVariant = _materialCache[keyA];
            if (materialsForVariant === undefined) {
                materialsForVariant = {};
                _materialCache[keyA] = materialsForVariant;
            }
            var cachedMaterial = materialsForVariant[keyB];
            if (cachedMaterial === undefined) {
                cachedMaterial = result.clone();
                materialsForVariant[keyB] = cachedMaterial;
            }
            result = cachedMaterial;
        }
        result.visible = material.visible;
        result.wireframe = material.wireframe;
        if (type === $c702e238df7c5123$export$896ae1ade6c829c4) result.side = material.shadowSide !== null ? material.shadowSide : material.side;
        else result.side = material.shadowSide !== null ? material.shadowSide : shadowSide[material.side];
        result.clipShadows = material.clipShadows;
        result.clippingPlanes = material.clippingPlanes;
        result.clipIntersection = material.clipIntersection;
        result.wireframeLinewidth = material.wireframeLinewidth;
        result.linewidth = material.linewidth;
        if (light.isPointLight === true && result.isMeshDistanceMaterial === true) {
            result.referencePosition.setFromMatrixPosition(light.matrixWorld);
            result.nearDistance = shadowCameraNear;
            result.farDistance = shadowCameraFar;
        }
        return result;
    }
    function renderObject(object, camera, shadowCamera, light, type) {
        if (object.visible === false) return;
        var visible = object.layers.test(camera.layers);
        if (visible && (object.isMesh || object.isLine || object.isPoints)) {
            if ((object.castShadow || object.receiveShadow && type === $c702e238df7c5123$export$896ae1ade6c829c4) && (!object.frustumCulled || _frustum.intersectsObject(object))) {
                object.modelViewMatrix.multiplyMatrices(shadowCamera.matrixWorldInverse, object.matrixWorld);
                var geometry = _objects.update(object);
                var material = object.material;
                if (Array.isArray(material)) {
                    var groups = geometry.groups;
                    for(var k = 0, kl = groups.length; k < kl; k++){
                        var group = groups[k];
                        var groupMaterial = material[group.materialIndex];
                        if (groupMaterial && groupMaterial.visible) {
                            var depthMaterial = getDepthMaterial(object, geometry, groupMaterial, light, shadowCamera.near, shadowCamera.far, type);
                            _renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, group);
                        }
                    }
                } else if (material.visible) {
                    var depthMaterial1 = getDepthMaterial(object, geometry, material, light, shadowCamera.near, shadowCamera.far, type);
                    _renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial1, object, null);
                }
            }
        }
        var children = object.children;
        for(var i = 0, l = children.length; i < l; i++)renderObject(children[i], camera, shadowCamera, light, type);
    }
}
function $c702e238df7c5123$var$WebGLState(gl, extensions, capabilities) {
    var isWebGL2 = capabilities.isWebGL2;
    function ColorBuffer() {
        var locked = false;
        var color = new $c702e238df7c5123$export$fa7daccca11cdbe3();
        var currentColorMask = null;
        var currentColorClear = new $c702e238df7c5123$export$fa7daccca11cdbe3(0, 0, 0, 0);
        return {
            setMask: function setMask(colorMask) {
                if (currentColorMask !== colorMask && !locked) {
                    gl.colorMask(colorMask, colorMask, colorMask, colorMask);
                    currentColorMask = colorMask;
                }
            },
            setLocked: function setLocked(lock) {
                locked = lock;
            },
            setClear: function setClear(r, g, b, a, premultipliedAlpha) {
                if (premultipliedAlpha === true) {
                    r *= a;
                    g *= a;
                    b *= a;
                }
                color.set(r, g, b, a);
                if (currentColorClear.equals(color) === false) {
                    gl.clearColor(r, g, b, a);
                    currentColorClear.copy(color);
                }
            },
            reset: function reset() {
                locked = false;
                currentColorMask = null;
                currentColorClear.set(-1, 0, 0, 0); // set to invalid state
            }
        };
    }
    function DepthBuffer() {
        var locked = false;
        var currentDepthMask = null;
        var currentDepthFunc = null;
        var currentDepthClear = null;
        return {
            setTest: function setTest(depthTest) {
                if (depthTest) enable(2929);
                else disable(2929);
            },
            setMask: function setMask(depthMask) {
                if (currentDepthMask !== depthMask && !locked) {
                    gl.depthMask(depthMask);
                    currentDepthMask = depthMask;
                }
            },
            setFunc: function setFunc(depthFunc) {
                if (currentDepthFunc !== depthFunc) {
                    if (depthFunc) switch(depthFunc){
                        case $c702e238df7c5123$export$69025ce147cee220:
                            gl.depthFunc(512);
                            break;
                        case $c702e238df7c5123$export$7182eb52ea3b3f04:
                            gl.depthFunc(519);
                            break;
                        case $c702e238df7c5123$export$eedccec66ab7ebe:
                            gl.depthFunc(513);
                            break;
                        case $c702e238df7c5123$export$296f78a0b892f81a:
                            gl.depthFunc(515);
                            break;
                        case $c702e238df7c5123$export$a60d398fc7b7590e:
                            gl.depthFunc(514);
                            break;
                        case $c702e238df7c5123$export$7d7234c1240a1fc4:
                            gl.depthFunc(518);
                            break;
                        case $c702e238df7c5123$export$c5e2c52991f30937:
                            gl.depthFunc(516);
                            break;
                        case $c702e238df7c5123$export$2f843afa843d8916:
                            gl.depthFunc(517);
                            break;
                        default:
                            gl.depthFunc(515);
                    }
                    else gl.depthFunc(515);
                    currentDepthFunc = depthFunc;
                }
            },
            setLocked: function setLocked(lock) {
                locked = lock;
            },
            setClear: function setClear(depth) {
                if (currentDepthClear !== depth) {
                    gl.clearDepth(depth);
                    currentDepthClear = depth;
                }
            },
            reset: function reset() {
                locked = false;
                currentDepthMask = null;
                currentDepthFunc = null;
                currentDepthClear = null;
            }
        };
    }
    function StencilBuffer() {
        var locked = false;
        var currentStencilMask = null;
        var currentStencilFunc = null;
        var currentStencilRef = null;
        var currentStencilFuncMask = null;
        var currentStencilFail = null;
        var currentStencilZFail = null;
        var currentStencilZPass = null;
        var currentStencilClear = null;
        return {
            setTest: function setTest(stencilTest) {
                if (!locked) {
                    if (stencilTest) enable(2960);
                    else disable(2960);
                }
            },
            setMask: function setMask(stencilMask) {
                if (currentStencilMask !== stencilMask && !locked) {
                    gl.stencilMask(stencilMask);
                    currentStencilMask = stencilMask;
                }
            },
            setFunc: function setFunc(stencilFunc, stencilRef, stencilMask) {
                if (currentStencilFunc !== stencilFunc || currentStencilRef !== stencilRef || currentStencilFuncMask !== stencilMask) {
                    gl.stencilFunc(stencilFunc, stencilRef, stencilMask);
                    currentStencilFunc = stencilFunc;
                    currentStencilRef = stencilRef;
                    currentStencilFuncMask = stencilMask;
                }
            },
            setOp: function setOp(stencilFail, stencilZFail, stencilZPass) {
                if (currentStencilFail !== stencilFail || currentStencilZFail !== stencilZFail || currentStencilZPass !== stencilZPass) {
                    gl.stencilOp(stencilFail, stencilZFail, stencilZPass);
                    currentStencilFail = stencilFail;
                    currentStencilZFail = stencilZFail;
                    currentStencilZPass = stencilZPass;
                }
            },
            setLocked: function setLocked(lock) {
                locked = lock;
            },
            setClear: function setClear(stencil) {
                if (currentStencilClear !== stencil) {
                    gl.clearStencil(stencil);
                    currentStencilClear = stencil;
                }
            },
            reset: function reset() {
                locked = false;
                currentStencilMask = null;
                currentStencilFunc = null;
                currentStencilRef = null;
                currentStencilFuncMask = null;
                currentStencilFail = null;
                currentStencilZFail = null;
                currentStencilZPass = null;
                currentStencilClear = null;
            }
        };
    }
    //
    var colorBuffer = new ColorBuffer();
    var depthBuffer = new DepthBuffer();
    var stencilBuffer = new StencilBuffer();
    var enabledCapabilities = {};
    var xrFramebuffer = null;
    var currentBoundFramebuffers = {};
    var currentProgram = null;
    var currentBlendingEnabled = false;
    var currentBlending = null;
    var currentBlendEquation = null;
    var currentBlendSrc = null;
    var currentBlendDst = null;
    var currentBlendEquationAlpha = null;
    var currentBlendSrcAlpha = null;
    var currentBlendDstAlpha = null;
    var currentPremultipledAlpha = false;
    var currentFlipSided = null;
    var currentCullFace = null;
    var currentLineWidth = null;
    var currentPolygonOffsetFactor = null;
    var currentPolygonOffsetUnits = null;
    var maxTextures = gl.getParameter(35661);
    var lineWidthAvailable = false;
    var version = 0;
    var glVersion = gl.getParameter(7938);
    if (glVersion.indexOf('WebGL') !== -1) {
        version = parseFloat(/^WebGL (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 1.0;
    } else if (glVersion.indexOf('OpenGL ES') !== -1) {
        version = parseFloat(/^OpenGL ES (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 2.0;
    }
    var currentTextureSlot = null;
    var currentBoundTextures = {};
    var scissorParam = gl.getParameter(3088);
    var viewportParam = gl.getParameter(2978);
    var currentScissor = new $c702e238df7c5123$export$fa7daccca11cdbe3().fromArray(scissorParam);
    var currentViewport = new $c702e238df7c5123$export$fa7daccca11cdbe3().fromArray(viewportParam);
    function createTexture(type, target, count) {
        var data = new Uint8Array(4); // 4 is required to match default unpack alignment of 4.
        var texture = gl.createTexture();
        gl.bindTexture(type, texture);
        gl.texParameteri(type, 10241, 9728);
        gl.texParameteri(type, 10240, 9728);
        for(var i = 0; i < count; i++)gl.texImage2D(target + i, 0, 6408, 1, 1, 0, 6408, 5121, data);
        return texture;
    }
    var emptyTextures = {};
    emptyTextures[3553] = createTexture(3553, 3553, 1);
    emptyTextures[34067] = createTexture(34067, 34069, 6);
    // init
    colorBuffer.setClear(0, 0, 0, 1);
    depthBuffer.setClear(1);
    stencilBuffer.setClear(0);
    enable(2929);
    depthBuffer.setFunc($c702e238df7c5123$export$296f78a0b892f81a);
    setFlipSided(false);
    setCullFace($c702e238df7c5123$export$b9a7b4fc5cb15f9b);
    enable(2884);
    setBlending($c702e238df7c5123$export$63b8d6b580fc65ba);
    //
    function enable(id) {
        if (enabledCapabilities[id] !== true) {
            gl.enable(id);
            enabledCapabilities[id] = true;
        }
    }
    function disable(id) {
        if (enabledCapabilities[id] !== false) {
            gl.disable(id);
            enabledCapabilities[id] = false;
        }
    }
    function bindXRFramebuffer(framebuffer) {
        if (framebuffer !== xrFramebuffer) {
            gl.bindFramebuffer(36160, framebuffer);
            xrFramebuffer = framebuffer;
        }
    }
    function bindFramebuffer(target, framebuffer) {
        if (framebuffer === null && xrFramebuffer !== null) framebuffer = xrFramebuffer; // use active XR framebuffer if available
        if (currentBoundFramebuffers[target] !== framebuffer) {
            gl.bindFramebuffer(target, framebuffer);
            currentBoundFramebuffers[target] = framebuffer;
            if (isWebGL2) {
                // 36009 is equivalent to 36160
                if (target === 36009) currentBoundFramebuffers[36160] = framebuffer;
                if (target === 36160) currentBoundFramebuffers[36009] = framebuffer;
            }
            return true;
        }
        return false;
    }
    function useProgram(program) {
        if (currentProgram !== program) {
            gl.useProgram(program);
            currentProgram = program;
            return true;
        }
        return false;
    }
    var _obj;
    var equationToGL = (_obj = {}, (0, $c83f3a938e737400$export$71511d61b312f219)(_obj, $c702e238df7c5123$export$20183a0484ce21a0, 32774), (0, $c83f3a938e737400$export$71511d61b312f219)(_obj, $c702e238df7c5123$export$73e0df5177988548, 32778), (0, $c83f3a938e737400$export$71511d61b312f219)(_obj, $c702e238df7c5123$export$28e582859cbec660, 32779), _obj);
    if (isWebGL2) {
        equationToGL[$c702e238df7c5123$export$c8c1508da8d0600c] = 32775;
        equationToGL[$c702e238df7c5123$export$99948c02fb51055f] = 32776;
    } else {
        var extension = extensions.get('EXT_blend_minmax');
        if (extension !== null) {
            equationToGL[$c702e238df7c5123$export$c8c1508da8d0600c] = extension.MIN_EXT;
            equationToGL[$c702e238df7c5123$export$99948c02fb51055f] = extension.MAX_EXT;
        }
    }
    var _obj1;
    var factorToGL = (_obj1 = {}, (0, $c83f3a938e737400$export$71511d61b312f219)(_obj1, $c702e238df7c5123$export$2110f05edf778d3d, 0), (0, $c83f3a938e737400$export$71511d61b312f219)(_obj1, $c702e238df7c5123$export$8805bad65e24940e, 1), (0, $c83f3a938e737400$export$71511d61b312f219)(_obj1, $c702e238df7c5123$export$7fbe15b28d28cf52, 768), (0, $c83f3a938e737400$export$71511d61b312f219)(_obj1, $c702e238df7c5123$export$d5773124e86cf28c, 770), (0, $c83f3a938e737400$export$71511d61b312f219)(_obj1, $c702e238df7c5123$export$c05e2a1fc8609506, 776), (0, $c83f3a938e737400$export$71511d61b312f219)(_obj1, $c702e238df7c5123$export$ef5f2dd8ffac5574, 774), (0, $c83f3a938e737400$export$71511d61b312f219)(_obj1, $c702e238df7c5123$export$a78aed1ca2a87192, 772), (0, $c83f3a938e737400$export$71511d61b312f219)(_obj1, $c702e238df7c5123$export$947829af9f2c17f6, 769), (0, $c83f3a938e737400$export$71511d61b312f219)(_obj1, $c702e238df7c5123$export$11d468cc7f19e971, 771), (0, $c83f3a938e737400$export$71511d61b312f219)(_obj1, $c702e238df7c5123$export$56b85b2686ab16, 775), (0, $c83f3a938e737400$export$71511d61b312f219)(_obj1, $c702e238df7c5123$export$5d0fe17fd8773bac, 773), _obj1);
    function setBlending(blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, premultipliedAlpha) {
        if (blending === $c702e238df7c5123$export$63b8d6b580fc65ba) {
            if (currentBlendingEnabled === true) {
                disable(3042);
                currentBlendingEnabled = false;
            }
            return;
        }
        if (currentBlendingEnabled === false) {
            enable(3042);
            currentBlendingEnabled = true;
        }
        if (blending !== $c702e238df7c5123$export$eda4864c68df1fa2) {
            if (blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha) {
                if (currentBlendEquation !== $c702e238df7c5123$export$20183a0484ce21a0 || currentBlendEquationAlpha !== $c702e238df7c5123$export$20183a0484ce21a0) {
                    gl.blendEquation(32774);
                    currentBlendEquation = $c702e238df7c5123$export$20183a0484ce21a0;
                    currentBlendEquationAlpha = $c702e238df7c5123$export$20183a0484ce21a0;
                }
                if (premultipliedAlpha) switch(blending){
                    case $c702e238df7c5123$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(1, 771, 1, 771);
                        break;
                    case $c702e238df7c5123$export$777d8f9551c2216b:
                        gl.blendFunc(1, 1);
                        break;
                    case $c702e238df7c5123$export$cdfa06f868e2e467:
                        gl.blendFuncSeparate(0, 0, 769, 771);
                        break;
                    case $c702e238df7c5123$export$4138e1c684b46a20:
                        gl.blendFuncSeparate(0, 768, 0, 770);
                        break;
                    default:
                        console.error('THREE.WebGLState: Invalid blending: ', blending);
                        break;
                }
                else switch(blending){
                    case $c702e238df7c5123$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(770, 771, 1, 771);
                        break;
                    case $c702e238df7c5123$export$777d8f9551c2216b:
                        gl.blendFunc(770, 1);
                        break;
                    case $c702e238df7c5123$export$cdfa06f868e2e467:
                        gl.blendFunc(0, 769);
                        break;
                    case $c702e238df7c5123$export$4138e1c684b46a20:
                        gl.blendFunc(0, 768);
                        break;
                    default:
                        console.error('THREE.WebGLState: Invalid blending: ', blending);
                        break;
                }
                currentBlendSrc = null;
                currentBlendDst = null;
                currentBlendSrcAlpha = null;
                currentBlendDstAlpha = null;
                currentBlending = blending;
                currentPremultipledAlpha = premultipliedAlpha;
            }
            return;
        }
        // custom blending
        blendEquationAlpha = blendEquationAlpha || blendEquation;
        blendSrcAlpha = blendSrcAlpha || blendSrc;
        blendDstAlpha = blendDstAlpha || blendDst;
        if (blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha) {
            gl.blendEquationSeparate(equationToGL[blendEquation], equationToGL[blendEquationAlpha]);
            currentBlendEquation = blendEquation;
            currentBlendEquationAlpha = blendEquationAlpha;
        }
        if (blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha) {
            gl.blendFuncSeparate(factorToGL[blendSrc], factorToGL[blendDst], factorToGL[blendSrcAlpha], factorToGL[blendDstAlpha]);
            currentBlendSrc = blendSrc;
            currentBlendDst = blendDst;
            currentBlendSrcAlpha = blendSrcAlpha;
            currentBlendDstAlpha = blendDstAlpha;
        }
        currentBlending = blending;
        currentPremultipledAlpha = null;
    }
    function setMaterial(material, frontFaceCW) {
        material.side === $c702e238df7c5123$export$3b296b6f144d5b03 ? disable(2884) : enable(2884);
        var flipSided = material.side === $c702e238df7c5123$export$d9f0486e75b5ace;
        if (frontFaceCW) flipSided = !flipSided;
        setFlipSided(flipSided);
        material.blending === $c702e238df7c5123$export$5b29a26d96ee6af0 && material.transparent === false ? setBlending($c702e238df7c5123$export$63b8d6b580fc65ba) : setBlending(material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.premultipliedAlpha);
        depthBuffer.setFunc(material.depthFunc);
        depthBuffer.setTest(material.depthTest);
        depthBuffer.setMask(material.depthWrite);
        colorBuffer.setMask(material.colorWrite);
        var stencilWrite = material.stencilWrite;
        stencilBuffer.setTest(stencilWrite);
        if (stencilWrite) {
            stencilBuffer.setMask(material.stencilWriteMask);
            stencilBuffer.setFunc(material.stencilFunc, material.stencilRef, material.stencilFuncMask);
            stencilBuffer.setOp(material.stencilFail, material.stencilZFail, material.stencilZPass);
        }
        setPolygonOffset(material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits);
        material.alphaToCoverage === true ? enable(32926) : disable(32926);
    }
    //
    function setFlipSided(flipSided) {
        if (currentFlipSided !== flipSided) {
            if (flipSided) gl.frontFace(2304);
            else gl.frontFace(2305);
            currentFlipSided = flipSided;
        }
    }
    function setCullFace(cullFace) {
        if (cullFace !== $c702e238df7c5123$export$3237e1f2c1ea1f44) {
            enable(2884);
            if (cullFace !== currentCullFace) {
                if (cullFace === $c702e238df7c5123$export$b9a7b4fc5cb15f9b) gl.cullFace(1029);
                else if (cullFace === $c702e238df7c5123$export$b8058bcc7037d3f3) gl.cullFace(1028);
                else gl.cullFace(1032);
            }
        } else disable(2884);
        currentCullFace = cullFace;
    }
    function setLineWidth(width) {
        if (width !== currentLineWidth) {
            if (lineWidthAvailable) gl.lineWidth(width);
            currentLineWidth = width;
        }
    }
    function setPolygonOffset(polygonOffset, factor, units) {
        if (polygonOffset) {
            enable(32823);
            if (currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units) {
                gl.polygonOffset(factor, units);
                currentPolygonOffsetFactor = factor;
                currentPolygonOffsetUnits = units;
            }
        } else disable(32823);
    }
    function setScissorTest(scissorTest) {
        if (scissorTest) enable(3089);
        else disable(3089);
    }
    // texture
    function activeTexture(webglSlot) {
        if (webglSlot === undefined) webglSlot = 33984 + maxTextures - 1;
        if (currentTextureSlot !== webglSlot) {
            gl.activeTexture(webglSlot);
            currentTextureSlot = webglSlot;
        }
    }
    function bindTexture(webglType, webglTexture) {
        if (currentTextureSlot === null) activeTexture();
        var boundTexture = currentBoundTextures[currentTextureSlot];
        if (boundTexture === undefined) {
            boundTexture = {
                type: undefined,
                texture: undefined
            };
            currentBoundTextures[currentTextureSlot] = boundTexture;
        }
        if (boundTexture.type !== webglType || boundTexture.texture !== webglTexture) {
            gl.bindTexture(webglType, webglTexture || emptyTextures[webglType]);
            boundTexture.type = webglType;
            boundTexture.texture = webglTexture;
        }
    }
    function unbindTexture() {
        var boundTexture = currentBoundTextures[currentTextureSlot];
        if (boundTexture !== undefined && boundTexture.type !== undefined) {
            gl.bindTexture(boundTexture.type, null);
            boundTexture.type = undefined;
            boundTexture.texture = undefined;
        }
    }
    function compressedTexImage2D() {
        try {
            gl.compressedTexImage2D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texImage2D() {
        try {
            gl.texImage2D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texImage3D() {
        try {
            gl.texImage3D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    //
    function scissor(scissor) {
        if (currentScissor.equals(scissor) === false) {
            gl.scissor(scissor.x, scissor.y, scissor.z, scissor.w);
            currentScissor.copy(scissor);
        }
    }
    function viewport(viewport) {
        if (currentViewport.equals(viewport) === false) {
            gl.viewport(viewport.x, viewport.y, viewport.z, viewport.w);
            currentViewport.copy(viewport);
        }
    }
    //
    function reset() {
        // reset state
        gl.disable(3042);
        gl.disable(2884);
        gl.disable(2929);
        gl.disable(32823);
        gl.disable(3089);
        gl.disable(2960);
        gl.disable(32926);
        gl.blendEquation(32774);
        gl.blendFunc(1, 0);
        gl.blendFuncSeparate(1, 0, 1, 0);
        gl.colorMask(true, true, true, true);
        gl.clearColor(0, 0, 0, 0);
        gl.depthMask(true);
        gl.depthFunc(513);
        gl.clearDepth(1);
        gl.stencilMask(0xffffffff);
        gl.stencilFunc(519, 0, 0xffffffff);
        gl.stencilOp(7680, 7680, 7680);
        gl.clearStencil(0);
        gl.cullFace(1029);
        gl.frontFace(2305);
        gl.polygonOffset(0, 0);
        gl.activeTexture(33984);
        gl.bindFramebuffer(36160, null);
        if (isWebGL2 === true) {
            gl.bindFramebuffer(36009, null);
            gl.bindFramebuffer(36008, null);
        }
        gl.useProgram(null);
        gl.lineWidth(1);
        gl.scissor(0, 0, gl.canvas.width, gl.canvas.height);
        gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
        // reset internals
        enabledCapabilities = {};
        currentTextureSlot = null;
        currentBoundTextures = {};
        xrFramebuffer = null;
        currentBoundFramebuffers = {};
        currentProgram = null;
        currentBlendingEnabled = false;
        currentBlending = null;
        currentBlendEquation = null;
        currentBlendSrc = null;
        currentBlendDst = null;
        currentBlendEquationAlpha = null;
        currentBlendSrcAlpha = null;
        currentBlendDstAlpha = null;
        currentPremultipledAlpha = false;
        currentFlipSided = null;
        currentCullFace = null;
        currentLineWidth = null;
        currentPolygonOffsetFactor = null;
        currentPolygonOffsetUnits = null;
        currentScissor.set(0, 0, gl.canvas.width, gl.canvas.height);
        currentViewport.set(0, 0, gl.canvas.width, gl.canvas.height);
        colorBuffer.reset();
        depthBuffer.reset();
        stencilBuffer.reset();
    }
    return {
        buffers: {
            color: colorBuffer,
            depth: depthBuffer,
            stencil: stencilBuffer
        },
        enable: enable,
        disable: disable,
        bindFramebuffer: bindFramebuffer,
        bindXRFramebuffer: bindXRFramebuffer,
        useProgram: useProgram,
        setBlending: setBlending,
        setMaterial: setMaterial,
        setFlipSided: setFlipSided,
        setCullFace: setCullFace,
        setLineWidth: setLineWidth,
        setPolygonOffset: setPolygonOffset,
        setScissorTest: setScissorTest,
        activeTexture: activeTexture,
        bindTexture: bindTexture,
        unbindTexture: unbindTexture,
        compressedTexImage2D: compressedTexImage2D,
        texImage2D: texImage2D,
        texImage3D: texImage3D,
        scissor: scissor,
        viewport: viewport,
        reset: reset
    };
}
function $c702e238df7c5123$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info) {
    var isWebGL2 = capabilities.isWebGL2;
    var maxTextures = capabilities.maxTextures;
    var maxCubemapSize = capabilities.maxCubemapSize;
    var maxTextureSize = capabilities.maxTextureSize;
    var maxSamples = capabilities.maxSamples;
    var _videoTextures = new WeakMap();
    var _canvas;
    // cordova iOS (as of 5.0) still uses UIWebView, which provides OffscreenCanvas,
    // also OffscreenCanvas.getContext("webgl"), but not OffscreenCanvas.getContext("2d")!
    // Some implementations may only implement OffscreenCanvas partially (e.g. lacking 2d).
    var useOffscreenCanvas = false;
    try {
        useOffscreenCanvas = typeof OffscreenCanvas !== 'undefined' && new OffscreenCanvas(1, 1).getContext('2d') !== null;
    } catch (err) {
    // Ignore any errors
    }
    function createCanvas(width, height) {
        // Use OffscreenCanvas when available. Specially needed in web workers
        return useOffscreenCanvas ? new OffscreenCanvas(width, height) : document.createElementNS('http://www.w3.org/1999/xhtml', 'canvas');
    }
    function resizeImage(image, needsPowerOfTwo, needsNewCanvas, maxSize) {
        var scale = 1;
        // handle case if texture exceeds max size
        if (image.width > maxSize || image.height > maxSize) scale = maxSize / Math.max(image.width, image.height);
        // only perform resize if necessary
        if (scale < 1 || needsPowerOfTwo === true) {
            // only perform resize for certain image types
            if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) {
                var floor = needsPowerOfTwo ? $c702e238df7c5123$var$floorPowerOfTwo : Math.floor;
                var width = floor(scale * image.width);
                var height = floor(scale * image.height);
                if (_canvas === undefined) _canvas = createCanvas(width, height);
                // cube textures can't reuse the same canvas
                var canvas = needsNewCanvas ? createCanvas(width, height) : _canvas;
                canvas.width = width;
                canvas.height = height;
                var context = canvas.getContext('2d');
                context.drawImage(image, 0, 0, width, height);
                console.warn('THREE.WebGLRenderer: Texture has been resized from (' + image.width + 'x' + image.height + ') to (' + width + 'x' + height + ').');
                return canvas;
            } else {
                if ('data' in image) console.warn('THREE.WebGLRenderer: Image in DataTexture is too big (' + image.width + 'x' + image.height + ').');
                return image;
            }
        }
        return image;
    }
    function isPowerOfTwo$1(image) {
        return $c702e238df7c5123$var$isPowerOfTwo(image.width) && $c702e238df7c5123$var$isPowerOfTwo(image.height);
    }
    function textureNeedsPowerOfTwo(texture) {
        if (isWebGL2) return false;
        return texture.wrapS !== $c702e238df7c5123$export$9d9334239a5a5e06 || texture.wrapT !== $c702e238df7c5123$export$9d9334239a5a5e06 || texture.minFilter !== $c702e238df7c5123$export$727aa5ec3fe39bf0 && texture.minFilter !== $c702e238df7c5123$export$8a72f490b25c56c8;
    }
    function textureNeedsGenerateMipmaps(texture, supportsMips) {
        return texture.generateMipmaps && supportsMips && texture.minFilter !== $c702e238df7c5123$export$727aa5ec3fe39bf0 && texture.minFilter !== $c702e238df7c5123$export$8a72f490b25c56c8;
    }
    function generateMipmap(target, texture, width, height) {
        var depth = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 1;
        _gl.generateMipmap(target);
        var textureProperties = properties.get(texture);
        textureProperties.__maxMipLevel = Math.log2(Math.max(width, height, depth));
    }
    function getInternalFormat(internalFormatName, glFormat, glType) {
        if (isWebGL2 === false) return glFormat;
        if (internalFormatName !== null) {
            if (_gl[internalFormatName] !== undefined) return _gl[internalFormatName];
            console.warn('THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format \'' + internalFormatName + '\'');
        }
        var internalFormat = glFormat;
        if (glFormat === 6403) {
            if (glType === 5126) internalFormat = 33326;
            if (glType === 5131) internalFormat = 33325;
            if (glType === 5121) internalFormat = 33321;
        }
        if (glFormat === 6407) {
            if (glType === 5126) internalFormat = 34837;
            if (glType === 5131) internalFormat = 34843;
            if (glType === 5121) internalFormat = 32849;
        }
        if (glFormat === 6408) {
            if (glType === 5126) internalFormat = 34836;
            if (glType === 5131) internalFormat = 34842;
            if (glType === 5121) internalFormat = 32856;
        }
        if (internalFormat === 33325 || internalFormat === 33326 || internalFormat === 34842 || internalFormat === 34836) extensions.get('EXT_color_buffer_float');
        return internalFormat;
    }
    // Fallback filters for non-power-of-2 textures
    function filterFallback(f) {
        if (f === $c702e238df7c5123$export$727aa5ec3fe39bf0 || f === $c702e238df7c5123$export$d129e38cf6feaa8c || f === $c702e238df7c5123$export$d2327c1afe5bfdf2) return 9728;
        return 9729;
    }
    //
    function onTextureDispose(event) {
        var texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        deallocateTexture(texture);
        if (texture.isVideoTexture) _videoTextures["delete"](texture);
        info.memory.textures--;
    }
    function onRenderTargetDispose(event) {
        var renderTarget = event.target;
        renderTarget.removeEventListener('dispose', onRenderTargetDispose);
        deallocateRenderTarget(renderTarget);
    }
    //
    function deallocateTexture(texture) {
        var textureProperties = properties.get(texture);
        if (textureProperties.__webglInit === undefined) return;
        _gl.deleteTexture(textureProperties.__webglTexture);
        properties.remove(texture);
    }
    function deallocateRenderTarget(renderTarget) {
        var texture = renderTarget.texture;
        var renderTargetProperties = properties.get(renderTarget);
        var textureProperties = properties.get(texture);
        if (!renderTarget) return;
        if (textureProperties.__webglTexture !== undefined) {
            _gl.deleteTexture(textureProperties.__webglTexture);
            info.memory.textures--;
        }
        if (renderTarget.depthTexture) renderTarget.depthTexture.dispose();
        if (renderTarget.isWebGLCubeRenderTarget) for(var i = 0; i < 6; i++){
            _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i]);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer[i]);
        }
        else {
            _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer);
            if (renderTargetProperties.__webglMultisampledFramebuffer) _gl.deleteFramebuffer(renderTargetProperties.__webglMultisampledFramebuffer);
            if (renderTargetProperties.__webglColorRenderbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglColorRenderbuffer);
            if (renderTargetProperties.__webglDepthRenderbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthRenderbuffer);
        }
        if (renderTarget.isWebGLMultipleRenderTargets) for(var i1 = 0, il = texture.length; i1 < il; i1++){
            var attachmentProperties = properties.get(texture[i1]);
            if (attachmentProperties.__webglTexture) {
                _gl.deleteTexture(attachmentProperties.__webglTexture);
                info.memory.textures--;
            }
            properties.remove(texture[i1]);
        }
        properties.remove(texture);
        properties.remove(renderTarget);
    }
    //
    var textureUnits = 0;
    function resetTextureUnits() {
        textureUnits = 0;
    }
    function allocateTextureUnit() {
        var textureUnit = textureUnits;
        if (textureUnit >= maxTextures) console.warn('THREE.WebGLTextures: Trying to use ' + textureUnit + ' texture units while this GPU supports only ' + maxTextures);
        textureUnits += 1;
        return textureUnit;
    }
    //
    function setTexture2D(texture, slot) {
        var textureProperties = properties.get(texture);
        if (texture.isVideoTexture) updateVideoTexture(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            var image = texture.image;
            if (image === undefined) console.warn('THREE.WebGLRenderer: Texture marked for update but image is undefined');
            else if (image.complete === false) console.warn('THREE.WebGLRenderer: Texture marked for update but image is incomplete');
            else {
                uploadTexture(textureProperties, texture, slot);
                return;
            }
        }
        state.activeTexture(33984 + slot);
        state.bindTexture(3553, textureProperties.__webglTexture);
    }
    function setTexture2DArray(texture, slot) {
        var textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.activeTexture(33984 + slot);
        state.bindTexture(35866, textureProperties.__webglTexture);
    }
    function setTexture3D(texture, slot) {
        var textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.activeTexture(33984 + slot);
        state.bindTexture(32879, textureProperties.__webglTexture);
    }
    function setTextureCube(texture, slot) {
        var textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadCubeTexture(textureProperties, texture, slot);
            return;
        }
        state.activeTexture(33984 + slot);
        state.bindTexture(34067, textureProperties.__webglTexture);
    }
    var _obj;
    var wrappingToGL = (_obj = {}, (0, $c83f3a938e737400$export$71511d61b312f219)(_obj, $c702e238df7c5123$export$533346c8e8dac0f5, 10497), (0, $c83f3a938e737400$export$71511d61b312f219)(_obj, $c702e238df7c5123$export$9d9334239a5a5e06, 33071), (0, $c83f3a938e737400$export$71511d61b312f219)(_obj, $c702e238df7c5123$export$c7e7c00b14f51a4f, 33648), _obj);
    var _obj1;
    var filterToGL = (_obj1 = {}, (0, $c83f3a938e737400$export$71511d61b312f219)(_obj1, $c702e238df7c5123$export$727aa5ec3fe39bf0, 9728), (0, $c83f3a938e737400$export$71511d61b312f219)(_obj1, $c702e238df7c5123$export$d129e38cf6feaa8c, 9984), (0, $c83f3a938e737400$export$71511d61b312f219)(_obj1, $c702e238df7c5123$export$d2327c1afe5bfdf2, 9986), (0, $c83f3a938e737400$export$71511d61b312f219)(_obj1, $c702e238df7c5123$export$8a72f490b25c56c8, 9729), (0, $c83f3a938e737400$export$71511d61b312f219)(_obj1, $c702e238df7c5123$export$19a719f377145a13, 9985), (0, $c83f3a938e737400$export$71511d61b312f219)(_obj1, $c702e238df7c5123$export$5d8599b6a933fb1b, 9987), _obj1);
    function setTextureParameters(textureType, texture, supportsMips) {
        if (supportsMips) {
            _gl.texParameteri(textureType, 10242, wrappingToGL[texture.wrapS]);
            _gl.texParameteri(textureType, 10243, wrappingToGL[texture.wrapT]);
            if (textureType === 32879 || textureType === 35866) _gl.texParameteri(textureType, 32882, wrappingToGL[texture.wrapR]);
            _gl.texParameteri(textureType, 10240, filterToGL[texture.magFilter]);
            _gl.texParameteri(textureType, 10241, filterToGL[texture.minFilter]);
        } else {
            _gl.texParameteri(textureType, 10242, 33071);
            _gl.texParameteri(textureType, 10243, 33071);
            if (textureType === 32879 || textureType === 35866) _gl.texParameteri(textureType, 32882, 33071);
            if (texture.wrapS !== $c702e238df7c5123$export$9d9334239a5a5e06 || texture.wrapT !== $c702e238df7c5123$export$9d9334239a5a5e06) console.warn('THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping.');
            _gl.texParameteri(textureType, 10240, filterFallback(texture.magFilter));
            _gl.texParameteri(textureType, 10241, filterFallback(texture.minFilter));
            if (texture.minFilter !== $c702e238df7c5123$export$727aa5ec3fe39bf0 && texture.minFilter !== $c702e238df7c5123$export$8a72f490b25c56c8) console.warn('THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.');
        }
        if (extensions.has('EXT_texture_filter_anisotropic') === true) {
            var extension = extensions.get('EXT_texture_filter_anisotropic');
            if (texture.type === $c702e238df7c5123$export$f6d331659b644596 && extensions.has('OES_texture_float_linear') === false) return; // verify extension for WebGL 1 and WebGL 2
            if (isWebGL2 === false && texture.type === $c702e238df7c5123$export$2697304443f382bc && extensions.has('OES_texture_half_float_linear') === false) return; // verify extension for WebGL 1 only
            if (texture.anisotropy > 1 || properties.get(texture).__currentAnisotropy) {
                _gl.texParameterf(textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(texture.anisotropy, capabilities.getMaxAnisotropy()));
                properties.get(texture).__currentAnisotropy = texture.anisotropy;
            }
        }
    }
    function initTexture(textureProperties, texture) {
        if (textureProperties.__webglInit === undefined) {
            textureProperties.__webglInit = true;
            texture.addEventListener('dispose', onTextureDispose);
            textureProperties.__webglTexture = _gl.createTexture();
            info.memory.textures++;
        }
    }
    function uploadTexture(textureProperties, texture, slot) {
        var textureType = 3553;
        if (texture.isDataTexture2DArray) textureType = 35866;
        if (texture.isDataTexture3D) textureType = 32879;
        initTexture(textureProperties, texture);
        state.activeTexture(33984 + slot);
        state.bindTexture(textureType, textureProperties.__webglTexture);
        _gl.pixelStorei(37440, texture.flipY);
        _gl.pixelStorei(37441, texture.premultiplyAlpha);
        _gl.pixelStorei(3317, texture.unpackAlignment);
        _gl.pixelStorei(37443, 0);
        var needsPowerOfTwo = textureNeedsPowerOfTwo(texture) && isPowerOfTwo$1(texture.image) === false;
        var image = resizeImage(texture.image, needsPowerOfTwo, false, maxTextureSize);
        var supportsMips = isPowerOfTwo$1(image) || isWebGL2, glFormat = utils.convert(texture.format);
        var glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType);
        setTextureParameters(textureType, texture, supportsMips);
        var mipmap;
        var mipmaps = texture.mipmaps;
        if (texture.isDepthTexture) {
            // populate depth texture with dummy data
            glInternalFormat = 6402;
            if (isWebGL2) {
                if (texture.type === $c702e238df7c5123$export$f6d331659b644596) glInternalFormat = 36012;
                else if (texture.type === $c702e238df7c5123$export$c3c7fc4518ebba96) glInternalFormat = 33190;
                else if (texture.type === $c702e238df7c5123$export$6c8ea339bfab1301) glInternalFormat = 35056;
                else glInternalFormat = 33189; // WebGL2 requires sized internalformat for glTexImage2D
            } else if (texture.type === $c702e238df7c5123$export$f6d331659b644596) console.error('WebGLRenderer: Floating point depth texture requires WebGL2.');
            // validation checks for WebGL 1
            if (texture.format === $c702e238df7c5123$export$c1b6b5136be58045 && glInternalFormat === 6402) // The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
            // DEPTH_COMPONENT and type is not UNSIGNED_SHORT or UNSIGNED_INT
            // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
            {
                if (texture.type !== $c702e238df7c5123$export$c63dc51868b06a9d && texture.type !== $c702e238df7c5123$export$c3c7fc4518ebba96) {
                    console.warn('THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture.');
                    texture.type = $c702e238df7c5123$export$c63dc51868b06a9d;
                    glType = utils.convert(texture.type);
                }
            }
            if (texture.format === $c702e238df7c5123$export$1e113ac2d0905829 && glInternalFormat === 6402) {
                // Depth stencil textures need the DEPTH_STENCIL internal format
                // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
                glInternalFormat = 34041;
                // The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
                // DEPTH_STENCIL and type is not UNSIGNED_INT_24_8_WEBGL.
                // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
                if (texture.type !== $c702e238df7c5123$export$6c8ea339bfab1301) {
                    console.warn('THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture.');
                    texture.type = $c702e238df7c5123$export$6c8ea339bfab1301;
                    glType = utils.convert(texture.type);
                }
            }
            //
            state.texImage2D(3553, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, null);
        } else if (texture.isDataTexture) {
            // use manually created mipmaps if available
            // if there are no manual mipmaps
            // set 0 level mipmap and then use GL to generate other mipmap levels
            if (mipmaps.length > 0 && supportsMips) {
                for(var i = 0, il = mipmaps.length; i < il; i++){
                    mipmap = mipmaps[i];
                    state.texImage2D(3553, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                }
                texture.generateMipmaps = false;
                textureProperties.__maxMipLevel = mipmaps.length - 1;
            } else {
                state.texImage2D(3553, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, image.data);
                textureProperties.__maxMipLevel = 0;
            }
        } else if (texture.isCompressedTexture) {
            for(var i1 = 0, il1 = mipmaps.length; i1 < il1; i1++){
                mipmap = mipmaps[i1];
                if (texture.format !== $c702e238df7c5123$export$3f8bb04b555a363c && texture.format !== $c702e238df7c5123$export$7c67423a5ee6f5eb) {
                    if (glFormat !== null) state.compressedTexImage2D(3553, i1, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                    else console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()');
                } else state.texImage2D(3553, i1, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
            }
            textureProperties.__maxMipLevel = mipmaps.length - 1;
        } else if (texture.isDataTexture2DArray) {
            state.texImage3D(35866, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            textureProperties.__maxMipLevel = 0;
        } else if (texture.isDataTexture3D) {
            state.texImage3D(32879, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            textureProperties.__maxMipLevel = 0;
        } else // regular Texture (image, video, canvas)
        // use manually created mipmaps if available
        // if there are no manual mipmaps
        // set 0 level mipmap and then use GL to generate other mipmap levels
        if (mipmaps.length > 0 && supportsMips) {
            for(var i2 = 0, il2 = mipmaps.length; i2 < il2; i2++){
                mipmap = mipmaps[i2];
                state.texImage2D(3553, i2, glInternalFormat, glFormat, glType, mipmap);
            }
            texture.generateMipmaps = false;
            textureProperties.__maxMipLevel = mipmaps.length - 1;
        } else {
            state.texImage2D(3553, 0, glInternalFormat, glFormat, glType, image);
            textureProperties.__maxMipLevel = 0;
        }
        if (textureNeedsGenerateMipmaps(texture, supportsMips)) generateMipmap(textureType, texture, image.width, image.height);
        textureProperties.__version = texture.version;
        if (texture.onUpdate) texture.onUpdate(texture);
    }
    function uploadCubeTexture(textureProperties, texture, slot) {
        if (texture.image.length !== 6) return;
        initTexture(textureProperties, texture);
        state.activeTexture(33984 + slot);
        state.bindTexture(34067, textureProperties.__webglTexture);
        _gl.pixelStorei(37440, texture.flipY);
        _gl.pixelStorei(37441, texture.premultiplyAlpha);
        _gl.pixelStorei(3317, texture.unpackAlignment);
        _gl.pixelStorei(37443, 0);
        var isCompressed = texture && (texture.isCompressedTexture || texture.image[0].isCompressedTexture);
        var isDataTexture = texture.image[0] && texture.image[0].isDataTexture;
        var cubeImage = [];
        for(var i = 0; i < 6; i++)if (!isCompressed && !isDataTexture) cubeImage[i] = resizeImage(texture.image[i], false, true, maxCubemapSize);
        else cubeImage[i] = isDataTexture ? texture.image[i].image : texture.image[i];
        var image = cubeImage[0], supportsMips = isPowerOfTwo$1(image) || isWebGL2, glFormat = utils.convert(texture.format), glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType);
        setTextureParameters(34067, texture, supportsMips);
        var mipmaps;
        if (isCompressed) {
            for(var i1 = 0; i1 < 6; i1++){
                mipmaps = cubeImage[i1].mipmaps;
                for(var j = 0; j < mipmaps.length; j++){
                    var mipmap = mipmaps[j];
                    if (texture.format !== $c702e238df7c5123$export$3f8bb04b555a363c && texture.format !== $c702e238df7c5123$export$7c67423a5ee6f5eb) {
                        if (glFormat !== null) state.compressedTexImage2D(34069 + i1, j, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                        else console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()');
                    } else state.texImage2D(34069 + i1, j, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                }
            }
            textureProperties.__maxMipLevel = mipmaps.length - 1;
        } else {
            mipmaps = texture.mipmaps;
            for(var i2 = 0; i2 < 6; i2++)if (isDataTexture) {
                state.texImage2D(34069 + i2, 0, glInternalFormat, cubeImage[i2].width, cubeImage[i2].height, 0, glFormat, glType, cubeImage[i2].data);
                for(var j1 = 0; j1 < mipmaps.length; j1++){
                    var mipmap1 = mipmaps[j1];
                    var mipmapImage = mipmap1.image[i2].image;
                    state.texImage2D(34069 + i2, j1 + 1, glInternalFormat, mipmapImage.width, mipmapImage.height, 0, glFormat, glType, mipmapImage.data);
                }
            } else {
                state.texImage2D(34069 + i2, 0, glInternalFormat, glFormat, glType, cubeImage[i2]);
                for(var j2 = 0; j2 < mipmaps.length; j2++){
                    var mipmap2 = mipmaps[j2];
                    state.texImage2D(34069 + i2, j2 + 1, glInternalFormat, glFormat, glType, mipmap2.image[i2]);
                }
            }
            textureProperties.__maxMipLevel = mipmaps.length;
        }
        if (textureNeedsGenerateMipmaps(texture, supportsMips)) // We assume images for cube map have the same size.
        generateMipmap(34067, texture, image.width, image.height);
        textureProperties.__version = texture.version;
        if (texture.onUpdate) texture.onUpdate(texture);
    }
    // Render targets
    // Setup storage for target texture and bind it to correct framebuffer
    function setupFrameBufferTexture(framebuffer, renderTarget, texture, attachment, textureTarget) {
        var glFormat = utils.convert(texture.format);
        var glType = utils.convert(texture.type);
        var glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType);
        if (textureTarget === 32879 || textureTarget === 35866) state.texImage3D(textureTarget, 0, glInternalFormat, renderTarget.width, renderTarget.height, renderTarget.depth, 0, glFormat, glType, null);
        else state.texImage2D(textureTarget, 0, glInternalFormat, renderTarget.width, renderTarget.height, 0, glFormat, glType, null);
        state.bindFramebuffer(36160, framebuffer);
        _gl.framebufferTexture2D(36160, attachment, textureTarget, properties.get(texture).__webglTexture, 0);
        state.bindFramebuffer(36160, null);
    }
    // Setup storage for internal depth/stencil buffers and bind to correct framebuffer
    function setupRenderBufferStorage(renderbuffer, renderTarget, isMultisample) {
        _gl.bindRenderbuffer(36161, renderbuffer);
        if (renderTarget.depthBuffer && !renderTarget.stencilBuffer) {
            var glInternalFormat = 33189;
            if (isMultisample) {
                var depthTexture = renderTarget.depthTexture;
                if (depthTexture && depthTexture.isDepthTexture) {
                    if (depthTexture.type === $c702e238df7c5123$export$f6d331659b644596) glInternalFormat = 36012;
                    else if (depthTexture.type === $c702e238df7c5123$export$c3c7fc4518ebba96) glInternalFormat = 33190;
                }
                var samples = getRenderTargetSamples(renderTarget);
                _gl.renderbufferStorageMultisample(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
            } else _gl.renderbufferStorage(36161, glInternalFormat, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(36160, 36096, 36161, renderbuffer);
        } else if (renderTarget.depthBuffer && renderTarget.stencilBuffer) {
            if (isMultisample) {
                var samples1 = getRenderTargetSamples(renderTarget);
                _gl.renderbufferStorageMultisample(36161, samples1, 35056, renderTarget.width, renderTarget.height);
            } else _gl.renderbufferStorage(36161, 34041, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(36160, 33306, 36161, renderbuffer);
        } else {
            // Use the first texture for MRT so far
            var texture = renderTarget.isWebGLMultipleRenderTargets === true ? renderTarget.texture[0] : renderTarget.texture;
            var glFormat = utils.convert(texture.format);
            var glType = utils.convert(texture.type);
            var glInternalFormat1 = getInternalFormat(texture.internalFormat, glFormat, glType);
            if (isMultisample) {
                var samples2 = getRenderTargetSamples(renderTarget);
                _gl.renderbufferStorageMultisample(36161, samples2, glInternalFormat1, renderTarget.width, renderTarget.height);
            } else _gl.renderbufferStorage(36161, glInternalFormat1, renderTarget.width, renderTarget.height);
        }
        _gl.bindRenderbuffer(36161, null);
    }
    // Setup resources for a Depth Texture for a FBO (needs an extension)
    function setupDepthTexture(framebuffer, renderTarget) {
        var isCube = renderTarget && renderTarget.isWebGLCubeRenderTarget;
        if (isCube) throw new Error('Depth Texture with cube render targets is not supported');
        state.bindFramebuffer(36160, framebuffer);
        if (!(renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture)) throw new Error('renderTarget.depthTexture must be an instance of THREE.DepthTexture');
        // upload an empty depth texture with framebuffer size
        if (!properties.get(renderTarget.depthTexture).__webglTexture || renderTarget.depthTexture.image.width !== renderTarget.width || renderTarget.depthTexture.image.height !== renderTarget.height) {
            renderTarget.depthTexture.image.width = renderTarget.width;
            renderTarget.depthTexture.image.height = renderTarget.height;
            renderTarget.depthTexture.needsUpdate = true;
        }
        setTexture2D(renderTarget.depthTexture, 0);
        var webglDepthTexture = properties.get(renderTarget.depthTexture).__webglTexture;
        if (renderTarget.depthTexture.format === $c702e238df7c5123$export$c1b6b5136be58045) _gl.framebufferTexture2D(36160, 36096, 3553, webglDepthTexture, 0);
        else if (renderTarget.depthTexture.format === $c702e238df7c5123$export$1e113ac2d0905829) _gl.framebufferTexture2D(36160, 33306, 3553, webglDepthTexture, 0);
        else throw new Error('Unknown depthTexture format');
    }
    // Setup GL resources for a non-texture depth buffer
    function setupDepthRenderbuffer(renderTarget) {
        var renderTargetProperties = properties.get(renderTarget);
        var isCube = renderTarget.isWebGLCubeRenderTarget === true;
        if (renderTarget.depthTexture) {
            if (isCube) throw new Error('target.depthTexture not supported in Cube render targets');
            setupDepthTexture(renderTargetProperties.__webglFramebuffer, renderTarget);
        } else if (isCube) {
            renderTargetProperties.__webglDepthbuffer = [];
            for(var i = 0; i < 6; i++){
                state.bindFramebuffer(36160, renderTargetProperties.__webglFramebuffer[i]);
                renderTargetProperties.__webglDepthbuffer[i] = _gl.createRenderbuffer();
                setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer[i], renderTarget, false);
            }
        } else {
            state.bindFramebuffer(36160, renderTargetProperties.__webglFramebuffer);
            renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
            setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer, renderTarget, false);
        }
        state.bindFramebuffer(36160, null);
    }
    // Set up GL resources for the render target
    function setupRenderTarget(renderTarget) {
        var texture = renderTarget.texture;
        var renderTargetProperties = properties.get(renderTarget);
        var textureProperties = properties.get(texture);
        renderTarget.addEventListener('dispose', onRenderTargetDispose);
        if (renderTarget.isWebGLMultipleRenderTargets !== true) {
            textureProperties.__webglTexture = _gl.createTexture();
            textureProperties.__version = texture.version;
            info.memory.textures++;
        }
        var isCube = renderTarget.isWebGLCubeRenderTarget === true;
        var isMultipleRenderTargets = renderTarget.isWebGLMultipleRenderTargets === true;
        var isMultisample = renderTarget.isWebGLMultisampleRenderTarget === true;
        var isRenderTarget3D = texture.isDataTexture3D || texture.isDataTexture2DArray;
        var supportsMips = isPowerOfTwo$1(renderTarget) || isWebGL2;
        // Handles WebGL2 RGBFormat fallback - #18858
        if (isWebGL2 && texture.format === $c702e238df7c5123$export$7c67423a5ee6f5eb && (texture.type === $c702e238df7c5123$export$f6d331659b644596 || texture.type === $c702e238df7c5123$export$2697304443f382bc)) {
            texture.format = $c702e238df7c5123$export$3f8bb04b555a363c;
            console.warn('THREE.WebGLRenderer: Rendering to textures with RGB format is not supported. Using RGBA format instead.');
        }
        // Setup framebuffer
        if (isCube) {
            renderTargetProperties.__webglFramebuffer = [];
            for(var i = 0; i < 6; i++)renderTargetProperties.__webglFramebuffer[i] = _gl.createFramebuffer();
        } else {
            renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();
            if (isMultipleRenderTargets) {
                if (capabilities.drawBuffers) {
                    var textures = renderTarget.texture;
                    for(var i1 = 0, il = textures.length; i1 < il; i1++){
                        var attachmentProperties = properties.get(textures[i1]);
                        if (attachmentProperties.__webglTexture === undefined) {
                            attachmentProperties.__webglTexture = _gl.createTexture();
                            info.memory.textures++;
                        }
                    }
                } else console.warn('THREE.WebGLRenderer: WebGLMultipleRenderTargets can only be used with WebGL2 or WEBGL_draw_buffers extension.');
            } else if (isMultisample) {
                if (isWebGL2) {
                    renderTargetProperties.__webglMultisampledFramebuffer = _gl.createFramebuffer();
                    renderTargetProperties.__webglColorRenderbuffer = _gl.createRenderbuffer();
                    _gl.bindRenderbuffer(36161, renderTargetProperties.__webglColorRenderbuffer);
                    var glFormat = utils.convert(texture.format);
                    var glType = utils.convert(texture.type);
                    var glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType);
                    var samples = getRenderTargetSamples(renderTarget);
                    _gl.renderbufferStorageMultisample(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                    state.bindFramebuffer(36160, renderTargetProperties.__webglMultisampledFramebuffer);
                    _gl.framebufferRenderbuffer(36160, 36064, 36161, renderTargetProperties.__webglColorRenderbuffer);
                    _gl.bindRenderbuffer(36161, null);
                    if (renderTarget.depthBuffer) {
                        renderTargetProperties.__webglDepthRenderbuffer = _gl.createRenderbuffer();
                        setupRenderBufferStorage(renderTargetProperties.__webglDepthRenderbuffer, renderTarget, true);
                    }
                    state.bindFramebuffer(36160, null);
                } else console.warn('THREE.WebGLRenderer: WebGLMultisampleRenderTarget can only be used with WebGL2.');
            }
        }
        // Setup color buffer
        if (isCube) {
            state.bindTexture(34067, textureProperties.__webglTexture);
            setTextureParameters(34067, texture, supportsMips);
            for(var i2 = 0; i2 < 6; i2++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i2], renderTarget, texture, 36064, 34069 + i2);
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) generateMipmap(34067, texture, renderTarget.width, renderTarget.height);
            state.bindTexture(34067, null);
        } else if (isMultipleRenderTargets) {
            var textures1 = renderTarget.texture;
            for(var i3 = 0, il1 = textures1.length; i3 < il1; i3++){
                var attachment = textures1[i3];
                var attachmentProperties1 = properties.get(attachment);
                state.bindTexture(3553, attachmentProperties1.__webglTexture);
                setTextureParameters(3553, attachment, supportsMips);
                setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, attachment, 36064 + i3, 3553);
                if (textureNeedsGenerateMipmaps(attachment, supportsMips)) generateMipmap(3553, attachment, renderTarget.width, renderTarget.height);
            }
            state.bindTexture(3553, null);
        } else {
            var glTextureType = 3553;
            if (isRenderTarget3D) {
                // Render targets containing layers, i.e: Texture 3D and 2d arrays
                if (isWebGL2) {
                    var isTexture3D = texture.isDataTexture3D;
                    glTextureType = isTexture3D ? 32879 : 35866;
                } else console.warn('THREE.DataTexture3D and THREE.DataTexture2DArray only supported with WebGL2.');
            }
            state.bindTexture(glTextureType, textureProperties.__webglTexture);
            setTextureParameters(glTextureType, texture, supportsMips);
            setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, texture, 36064, glTextureType);
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) generateMipmap(glTextureType, texture, renderTarget.width, renderTarget.height, renderTarget.depth);
            state.bindTexture(glTextureType, null);
        }
        // Setup depth and stencil buffers
        if (renderTarget.depthBuffer) setupDepthRenderbuffer(renderTarget);
    }
    function updateRenderTargetMipmap(renderTarget) {
        var supportsMips = isPowerOfTwo$1(renderTarget) || isWebGL2;
        var textures = renderTarget.isWebGLMultipleRenderTargets === true ? renderTarget.texture : [
            renderTarget.texture
        ];
        for(var i = 0, il = textures.length; i < il; i++){
            var texture = textures[i];
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) {
                var target = renderTarget.isWebGLCubeRenderTarget ? 34067 : 3553;
                var webglTexture = properties.get(texture).__webglTexture;
                state.bindTexture(target, webglTexture);
                generateMipmap(target, texture, renderTarget.width, renderTarget.height);
                state.bindTexture(target, null);
            }
        }
    }
    function updateMultisampleRenderTarget(renderTarget) {
        if (renderTarget.isWebGLMultisampleRenderTarget) {
            if (isWebGL2) {
                var width = renderTarget.width;
                var height = renderTarget.height;
                var mask = 16384;
                if (renderTarget.depthBuffer) mask |= 256;
                if (renderTarget.stencilBuffer) mask |= 1024;
                var renderTargetProperties = properties.get(renderTarget);
                state.bindFramebuffer(36008, renderTargetProperties.__webglMultisampledFramebuffer);
                state.bindFramebuffer(36009, renderTargetProperties.__webglFramebuffer);
                _gl.blitFramebuffer(0, 0, width, height, 0, 0, width, height, mask, 9728);
                state.bindFramebuffer(36008, null);
                state.bindFramebuffer(36009, renderTargetProperties.__webglMultisampledFramebuffer);
            } else console.warn('THREE.WebGLRenderer: WebGLMultisampleRenderTarget can only be used with WebGL2.');
        }
    }
    function getRenderTargetSamples(renderTarget) {
        return isWebGL2 && renderTarget.isWebGLMultisampleRenderTarget ? Math.min(maxSamples, renderTarget.samples) : 0;
    }
    function updateVideoTexture(texture) {
        var frame = info.render.frame;
        // Check the last frame we updated the VideoTexture
        if (_videoTextures.get(texture) !== frame) {
            _videoTextures.set(texture, frame);
            texture.update();
        }
    }
    // backwards compatibility
    var warnedTexture2D = false;
    var warnedTextureCube = false;
    function safeSetTexture2D(texture, slot) {
        if (texture && texture.isWebGLRenderTarget) {
            if (warnedTexture2D === false) {
                console.warn('THREE.WebGLTextures.safeSetTexture2D: don\'t use render targets as textures. Use their .texture property instead.');
                warnedTexture2D = true;
            }
            texture = texture.texture;
        }
        setTexture2D(texture, slot);
    }
    function safeSetTextureCube(texture, slot) {
        if (texture && texture.isWebGLCubeRenderTarget) {
            if (warnedTextureCube === false) {
                console.warn('THREE.WebGLTextures.safeSetTextureCube: don\'t use cube render targets as textures. Use their .texture property instead.');
                warnedTextureCube = true;
            }
            texture = texture.texture;
        }
        setTextureCube(texture, slot);
    }
    //
    this.allocateTextureUnit = allocateTextureUnit;
    this.resetTextureUnits = resetTextureUnits;
    this.setTexture2D = setTexture2D;
    this.setTexture2DArray = setTexture2DArray;
    this.setTexture3D = setTexture3D;
    this.setTextureCube = setTextureCube;
    this.setupRenderTarget = setupRenderTarget;
    this.updateRenderTargetMipmap = updateRenderTargetMipmap;
    this.updateMultisampleRenderTarget = updateMultisampleRenderTarget;
    this.safeSetTexture2D = safeSetTexture2D;
    this.safeSetTextureCube = safeSetTextureCube;
}
function $c702e238df7c5123$export$ddaebcad857649a8(gl, extensions, capabilities) {
    var isWebGL2 = capabilities.isWebGL2;
    function convert(p) {
        var extension;
        if (p === $c702e238df7c5123$export$2e8ce08d3f6f5e10) return 5121;
        if (p === $c702e238df7c5123$export$b3969b01faf587f2) return 32819;
        if (p === $c702e238df7c5123$export$18886f8ae33e90de) return 32820;
        if (p === $c702e238df7c5123$export$cb1fa50553eb14c4) return 33635;
        if (p === $c702e238df7c5123$export$545fce0311a9796a) return 5120;
        if (p === $c702e238df7c5123$export$88572337f312435f) return 5122;
        if (p === $c702e238df7c5123$export$c63dc51868b06a9d) return 5123;
        if (p === $c702e238df7c5123$export$5c612977753abe2) return 5124;
        if (p === $c702e238df7c5123$export$c3c7fc4518ebba96) return 5125;
        if (p === $c702e238df7c5123$export$f6d331659b644596) return 5126;
        if (p === $c702e238df7c5123$export$2697304443f382bc) {
            if (isWebGL2) return 5131;
            extension = extensions.get('OES_texture_half_float');
            if (extension !== null) return extension.HALF_FLOAT_OES;
            else return null;
        }
        if (p === $c702e238df7c5123$export$988473390501ed4b) return 6406;
        if (p === $c702e238df7c5123$export$7c67423a5ee6f5eb) return 6407;
        if (p === $c702e238df7c5123$export$3f8bb04b555a363c) return 6408;
        if (p === $c702e238df7c5123$export$cc09ccbf6d1ed449) return 6409;
        if (p === $c702e238df7c5123$export$9053a81c4a69c289) return 6410;
        if (p === $c702e238df7c5123$export$c1b6b5136be58045) return 6402;
        if (p === $c702e238df7c5123$export$1e113ac2d0905829) return 34041;
        if (p === $c702e238df7c5123$export$4e041a7967d15c4b) return 6403;
        // WebGL2 formats.
        if (p === $c702e238df7c5123$export$aa92e870a709d190) return 36244;
        if (p === $c702e238df7c5123$export$6cdf0b461c7ce8a0) return 33319;
        if (p === $c702e238df7c5123$export$1ba1c45f9f77d4d7) return 33320;
        if (p === $c702e238df7c5123$export$d1fd40c11bfa798e) return 36248;
        if (p === $c702e238df7c5123$export$c200e7d26f592f21) return 36249;
        if (p === $c702e238df7c5123$export$21d1799c6d552fc0 || p === $c702e238df7c5123$export$afa304c3e981b668 || p === $c702e238df7c5123$export$d2a1a68024a3e56c || p === $c702e238df7c5123$export$9a79c424327dacf9) {
            extension = extensions.get('WEBGL_compressed_texture_s3tc');
            if (extension !== null) {
                if (p === $c702e238df7c5123$export$21d1799c6d552fc0) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
                if (p === $c702e238df7c5123$export$afa304c3e981b668) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                if (p === $c702e238df7c5123$export$d2a1a68024a3e56c) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                if (p === $c702e238df7c5123$export$9a79c424327dacf9) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;
            } else return null;
        }
        if (p === $c702e238df7c5123$export$19ada9bbb1af3573 || p === $c702e238df7c5123$export$d0f0355bb3d948e4 || p === $c702e238df7c5123$export$b82296714358084c || p === $c702e238df7c5123$export$b71692456c47b6c3) {
            extension = extensions.get('WEBGL_compressed_texture_pvrtc');
            if (extension !== null) {
                if (p === $c702e238df7c5123$export$19ada9bbb1af3573) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                if (p === $c702e238df7c5123$export$d0f0355bb3d948e4) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                if (p === $c702e238df7c5123$export$b82296714358084c) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                if (p === $c702e238df7c5123$export$b71692456c47b6c3) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
            } else return null;
        }
        if (p === $c702e238df7c5123$export$6ab91af2d757aee7) {
            extension = extensions.get('WEBGL_compressed_texture_etc1');
            if (extension !== null) return extension.COMPRESSED_RGB_ETC1_WEBGL;
            else return null;
        }
        if (p === $c702e238df7c5123$export$7800993ef8106a6a || p === $c702e238df7c5123$export$23ed8300a860e7d8) {
            extension = extensions.get('WEBGL_compressed_texture_etc');
            if (extension !== null) {
                if (p === $c702e238df7c5123$export$7800993ef8106a6a) return extension.COMPRESSED_RGB8_ETC2;
                if (p === $c702e238df7c5123$export$23ed8300a860e7d8) return extension.COMPRESSED_RGBA8_ETC2_EAC;
            }
        }
        if (p === $c702e238df7c5123$export$dc5570b4a2b92d48 || p === $c702e238df7c5123$export$68880cd325f8b2fb || p === $c702e238df7c5123$export$7d2c0be323373d95 || p === $c702e238df7c5123$export$22b52da301fc3a3e || p === $c702e238df7c5123$export$c009e2cb4a66485e || p === $c702e238df7c5123$export$118fff5afa255b63 || p === $c702e238df7c5123$export$120713c829ae0667 || p === $c702e238df7c5123$export$c79eeabbf53313e9 || p === $c702e238df7c5123$export$443cf6567cdd6424 || p === $c702e238df7c5123$export$6573984fc9840780 || p === $c702e238df7c5123$export$e7aee563f30091de || p === $c702e238df7c5123$export$2eb8634622ddeab7 || p === $c702e238df7c5123$export$202b1ce7b5d25742 || p === $c702e238df7c5123$export$18ab77abd087e467 || p === $c702e238df7c5123$export$4487000d1baf578b || p === $c702e238df7c5123$export$4a1746c7512b1ea1 || p === $c702e238df7c5123$export$4208debc782f5653 || p === $c702e238df7c5123$export$82c5f9d3037aaea3 || p === $c702e238df7c5123$export$64e357a152723eb9 || p === $c702e238df7c5123$export$1b7711037f5e380e || p === $c702e238df7c5123$export$eb234716dfb52c31 || p === $c702e238df7c5123$export$8041d2df79c555f || p === $c702e238df7c5123$export$27d2c8c0fcc7b83a || p === $c702e238df7c5123$export$27b9de07b84a1334 || p === $c702e238df7c5123$export$5c2b31a31ccc15c8 || p === $c702e238df7c5123$export$5c4d4b335786f8f3 || p === $c702e238df7c5123$export$e0c50c800e38be11 || p === $c702e238df7c5123$export$9b0442bae422b2db) {
            extension = extensions.get('WEBGL_compressed_texture_astc');
            if (extension !== null) // TODO Complete?
            return p;
            else return null;
        }
        if (p === $c702e238df7c5123$export$ce40b115e188bc81) {
            extension = extensions.get('EXT_texture_compression_bptc');
            if (extension !== null) // TODO Complete?
            return p;
            else return null;
        }
        if (p === $c702e238df7c5123$export$6c8ea339bfab1301) {
            if (isWebGL2) return 34042;
            extension = extensions.get('WEBGL_depth_texture');
            if (extension !== null) return extension.UNSIGNED_INT_24_8_WEBGL;
            else return null;
        }
    }
    return {
        convert: convert
    };
}
var $c702e238df7c5123$export$56b937d9e5581166 = /*#__PURE__*/ function(PerspectiveCamera) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(ArrayCamera, PerspectiveCamera);
    function ArrayCamera() {
        var array = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, ArrayCamera);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, ArrayCamera);
        _this.cameras = array;
        return _this;
    }
    return ArrayCamera;
}($c702e238df7c5123$export$74e4ae24825f68d7);
$c702e238df7c5123$export$56b937d9e5581166.prototype.isArrayCamera = true;
var $c702e238df7c5123$export$eb2fcfdbd7ba97d4 = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(Group, Object3D);
    function Group() {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Group);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, Group);
        _this.type = 'Group';
        return _this;
    }
    return Group;
}($c702e238df7c5123$export$e4dd07dff30cc924);
$c702e238df7c5123$export$eb2fcfdbd7ba97d4.prototype.isGroup = true;
var $c702e238df7c5123$var$_moveEvent = {
    type: 'move'
};
var $c702e238df7c5123$var$WebXRController = /*#__PURE__*/ function() {
    "use strict";
    function WebXRController() {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, WebXRController);
        this._targetRay = null;
        this._grip = null;
        this._hand = null;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(WebXRController, [
        {
            key: "getHandSpace",
            value: function getHandSpace() {
                if (this._hand === null) {
                    this._hand = new $c702e238df7c5123$export$eb2fcfdbd7ba97d4();
                    this._hand.matrixAutoUpdate = false;
                    this._hand.visible = false;
                    this._hand.joints = {};
                    this._hand.inputState = {
                        pinching: false
                    };
                }
                return this._hand;
            }
        },
        {
            key: "getTargetRaySpace",
            value: function getTargetRaySpace() {
                if (this._targetRay === null) {
                    this._targetRay = new $c702e238df7c5123$export$eb2fcfdbd7ba97d4();
                    this._targetRay.matrixAutoUpdate = false;
                    this._targetRay.visible = false;
                    this._targetRay.hasLinearVelocity = false;
                    this._targetRay.linearVelocity = new $c702e238df7c5123$export$64b5c384219d3699();
                    this._targetRay.hasAngularVelocity = false;
                    this._targetRay.angularVelocity = new $c702e238df7c5123$export$64b5c384219d3699();
                }
                return this._targetRay;
            }
        },
        {
            key: "getGripSpace",
            value: function getGripSpace() {
                if (this._grip === null) {
                    this._grip = new $c702e238df7c5123$export$eb2fcfdbd7ba97d4();
                    this._grip.matrixAutoUpdate = false;
                    this._grip.visible = false;
                    this._grip.hasLinearVelocity = false;
                    this._grip.linearVelocity = new $c702e238df7c5123$export$64b5c384219d3699();
                    this._grip.hasAngularVelocity = false;
                    this._grip.angularVelocity = new $c702e238df7c5123$export$64b5c384219d3699();
                }
                return this._grip;
            }
        },
        {
            key: "dispatchEvent",
            value: function dispatchEvent(event) {
                if (this._targetRay !== null) this._targetRay.dispatchEvent(event);
                if (this._grip !== null) this._grip.dispatchEvent(event);
                if (this._hand !== null) this._hand.dispatchEvent(event);
                return this;
            }
        },
        {
            key: "disconnect",
            value: function disconnect(inputSource) {
                this.dispatchEvent({
                    type: 'disconnected',
                    data: inputSource
                });
                if (this._targetRay !== null) this._targetRay.visible = false;
                if (this._grip !== null) this._grip.visible = false;
                if (this._hand !== null) this._hand.visible = false;
                return this;
            }
        },
        {
            key: "update",
            value: function update(inputSource, frame, referenceSpace) {
                var inputPose = null;
                var gripPose = null;
                var handPose = null;
                var targetRay = this._targetRay;
                var grip = this._grip;
                var hand = this._hand;
                if (inputSource && frame.session.visibilityState !== 'visible-blurred') {
                    if (targetRay !== null) {
                        inputPose = frame.getPose(inputSource.targetRaySpace, referenceSpace);
                        if (inputPose !== null) {
                            targetRay.matrix.fromArray(inputPose.transform.matrix);
                            targetRay.matrix.decompose(targetRay.position, targetRay.rotation, targetRay.scale);
                            if (inputPose.linearVelocity) {
                                targetRay.hasLinearVelocity = true;
                                targetRay.linearVelocity.copy(inputPose.linearVelocity);
                            } else targetRay.hasLinearVelocity = false;
                            if (inputPose.angularVelocity) {
                                targetRay.hasAngularVelocity = true;
                                targetRay.angularVelocity.copy(inputPose.angularVelocity);
                            } else targetRay.hasAngularVelocity = false;
                            this.dispatchEvent($c702e238df7c5123$var$_moveEvent);
                        }
                    }
                    if (hand && inputSource.hand) {
                        handPose = true;
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = inputSource.hand.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var inputjoint = _step.value;
                                // Update the joints groups with the XRJoint poses
                                var jointPose = frame.getJointPose(inputjoint, referenceSpace);
                                if (hand.joints[inputjoint.jointName] === undefined) {
                                    // The transform of this joint will be updated with the joint pose on each frame
                                    var joint = new $c702e238df7c5123$export$eb2fcfdbd7ba97d4();
                                    joint.matrixAutoUpdate = false;
                                    joint.visible = false;
                                    hand.joints[inputjoint.jointName] = joint;
                                    // ??
                                    hand.add(joint);
                                }
                                var joint1 = hand.joints[inputjoint.jointName];
                                if (jointPose !== null) {
                                    joint1.matrix.fromArray(jointPose.transform.matrix);
                                    joint1.matrix.decompose(joint1.position, joint1.rotation, joint1.scale);
                                    joint1.jointRadius = jointPose.radius;
                                }
                                joint1.visible = jointPose !== null;
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        // Custom events
                        // Check pinchz
                        var indexTip = hand.joints['index-finger-tip'];
                        var thumbTip = hand.joints['thumb-tip'];
                        var distance = indexTip.position.distanceTo(thumbTip.position);
                        var distanceToPinch = 0.02;
                        var threshold = 0.005;
                        if (hand.inputState.pinching && distance > distanceToPinch + threshold) {
                            hand.inputState.pinching = false;
                            this.dispatchEvent({
                                type: 'pinchend',
                                handedness: inputSource.handedness,
                                target: this
                            });
                        } else if (!hand.inputState.pinching && distance <= distanceToPinch - threshold) {
                            hand.inputState.pinching = true;
                            this.dispatchEvent({
                                type: 'pinchstart',
                                handedness: inputSource.handedness,
                                target: this
                            });
                        }
                    } else if (grip !== null && inputSource.gripSpace) {
                        gripPose = frame.getPose(inputSource.gripSpace, referenceSpace);
                        if (gripPose !== null) {
                            grip.matrix.fromArray(gripPose.transform.matrix);
                            grip.matrix.decompose(grip.position, grip.rotation, grip.scale);
                            if (gripPose.linearVelocity) {
                                grip.hasLinearVelocity = true;
                                grip.linearVelocity.copy(gripPose.linearVelocity);
                            } else grip.hasLinearVelocity = false;
                            if (gripPose.angularVelocity) {
                                grip.hasAngularVelocity = true;
                                grip.angularVelocity.copy(gripPose.angularVelocity);
                            } else grip.hasAngularVelocity = false;
                        }
                    }
                }
                if (targetRay !== null) targetRay.visible = inputPose !== null;
                if (grip !== null) grip.visible = gripPose !== null;
                if (hand !== null) hand.visible = handPose !== null;
                return this;
            }
        }
    ]);
    return WebXRController;
}();
var $c702e238df7c5123$var$WebXRManager = /*#__PURE__*/ function(EventDispatcher) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(WebXRManager, EventDispatcher);
    function WebXRManager(renderer, gl) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, WebXRManager);
        var _this;
        var onSessionEvent = //
        function onSessionEvent(event) {
            var controller = inputSourcesMap.get(event.inputSource);
            if (controller) controller.dispatchEvent({
                type: event.type,
                data: event.inputSource
            });
        };
        var onSessionEnd = function onSessionEnd() {
            inputSourcesMap.forEach(function(controller, inputSource) {
                controller.disconnect(inputSource);
            });
            inputSourcesMap.clear();
            _currentDepthNear = null;
            _currentDepthFar = null;
            // restore framebuffer/rendering state
            state.bindXRFramebuffer(null);
            renderer.setRenderTarget(renderer.getRenderTarget());
            //
            animation.stop();
            scope.isPresenting = false;
            scope.dispatchEvent({
                type: 'sessionend'
            });
        };
        var onInputSourcesChange = function onInputSourcesChange(event) {
            var inputSources = session.inputSources;
            // Assign inputSources to available controllers
            for(var i = 0; i < controllers.length; i++)inputSourcesMap.set(inputSources[i], controllers[i]);
            // Notify disconnected
            for(var i1 = 0; i1 < event.removed.length; i1++){
                var inputSource = event.removed[i1];
                var controller = inputSourcesMap.get(inputSource);
                if (controller) {
                    controller.dispatchEvent({
                        type: 'disconnected',
                        data: inputSource
                    });
                    inputSourcesMap["delete"](inputSource);
                }
            }
            // Notify connected
            for(var i2 = 0; i2 < event.added.length; i2++){
                var inputSource1 = event.added[i2];
                var controller1 = inputSourcesMap.get(inputSource1);
                if (controller1) controller1.dispatchEvent({
                    type: 'connected',
                    data: inputSource1
                });
            }
        };
        var setProjectionFromUnion = /**
		 * Assumes 2 cameras that are parallel and share an X-axis, and that
		 * the cameras' projection and world matrices have already been set.
		 * And that near and far planes are identical for both cameras.
		 * Visualization of this technique: https://computergraphics.stackexchange.com/a/4765
		 */ function setProjectionFromUnion(camera, cameraL, cameraR) {
            cameraLPos.setFromMatrixPosition(cameraL.matrixWorld);
            cameraRPos.setFromMatrixPosition(cameraR.matrixWorld);
            var ipd = cameraLPos.distanceTo(cameraRPos);
            var projL = cameraL.projectionMatrix.elements;
            var projR = cameraR.projectionMatrix.elements;
            // VR systems will have identical far and near planes, and
            // most likely identical top and bottom frustum extents.
            // Use the left camera for these values.
            var near = projL[14] / (projL[10] - 1);
            var far = projL[14] / (projL[10] + 1);
            var topFov = (projL[9] + 1) / projL[5];
            var bottomFov = (projL[9] - 1) / projL[5];
            var leftFov = (projL[8] - 1) / projL[0];
            var rightFov = (projR[8] + 1) / projR[0];
            var left = near * leftFov;
            var right = near * rightFov;
            // Calculate the new camera's position offset from the
            // left camera. xOffset should be roughly half `ipd`.
            var zOffset = ipd / (-leftFov + rightFov);
            var xOffset = zOffset * -leftFov;
            // TODO: Better way to apply this offset?
            cameraL.matrixWorld.decompose(camera.position, camera.quaternion, camera.scale);
            camera.translateX(xOffset);
            camera.translateZ(zOffset);
            camera.matrixWorld.compose(camera.position, camera.quaternion, camera.scale);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
            // Find the union of the frustum values of the cameras and scale
            // the values so that the near plane's position does not change in world space,
            // although must now be relative to the new union camera.
            var near2 = near + zOffset;
            var far2 = far + zOffset;
            var left2 = left - xOffset;
            var right2 = right + (ipd - xOffset);
            var top2 = topFov * far / far2 * near2;
            var bottom2 = bottomFov * far / far2 * near2;
            camera.projectionMatrix.makePerspective(left2, right2, top2, bottom2, near2, far2);
        };
        var updateCamera = function updateCamera(camera, parent) {
            if (parent === null) camera.matrixWorld.copy(camera.matrix);
            else camera.matrixWorld.multiplyMatrices(parent.matrixWorld, camera.matrix);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
        };
        var onAnimationFrame = function onAnimationFrame(time, frame) {
            pose = frame.getViewerPose(referenceSpace);
            if (pose !== null) {
                var views = pose.views;
                var baseLayer = session.renderState.baseLayer;
                if (session.renderState.layers === undefined) state.bindXRFramebuffer(baseLayer.framebuffer);
                var cameraVRNeedsUpdate = false;
                // check if it's necessary to rebuild cameraVR's camera list
                if (views.length !== cameraVR.cameras.length) {
                    cameraVR.cameras.length = 0;
                    cameraVRNeedsUpdate = true;
                }
                for(var i = 0; i < views.length; i++){
                    var view = views[i];
                    var viewport = null;
                    if (session.renderState.layers === undefined) viewport = baseLayer.getViewport(view);
                    else {
                        var glSubImage = glBinding.getViewSubImage(glProjLayer, view);
                        state.bindXRFramebuffer(glFramebuffer);
                        gl.framebufferTexture2D(36160, 36064, 3553, glSubImage.colorTexture, 0);
                        if (glSubImage.depthStencilTexture !== undefined) gl.framebufferTexture2D(36160, 36096, 3553, glSubImage.depthStencilTexture, 0);
                        viewport = glSubImage.viewport;
                    }
                    var camera = cameras[i];
                    camera.matrix.fromArray(view.transform.matrix);
                    camera.projectionMatrix.fromArray(view.projectionMatrix);
                    camera.viewport.set(viewport.x, viewport.y, viewport.width, viewport.height);
                    if (i === 0) cameraVR.matrix.copy(camera.matrix);
                    if (cameraVRNeedsUpdate === true) cameraVR.cameras.push(camera);
                }
            }
            //
            var inputSources = session.inputSources;
            for(var i1 = 0; i1 < controllers.length; i1++){
                var controller = controllers[i1];
                var inputSource = inputSources[i1];
                controller.update(inputSource, frame, referenceSpace);
            }
            if (onAnimationFrameCallback) onAnimationFrameCallback(time, frame);
        };
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, WebXRManager);
        var scope = _this;
        var state = renderer.state;
        var session = null;
        var framebufferScaleFactor = 1.0;
        var referenceSpace = null;
        var referenceSpaceType = 'local-floor';
        var pose = null;
        var glBinding = null;
        var glFramebuffer = null;
        var glProjLayer = null;
        var controllers = [];
        var inputSourcesMap = new Map();
        //
        var cameraL = new $c702e238df7c5123$export$74e4ae24825f68d7();
        cameraL.layers.enable(1);
        cameraL.viewport = new $c702e238df7c5123$export$fa7daccca11cdbe3();
        var cameraR = new $c702e238df7c5123$export$74e4ae24825f68d7();
        cameraR.layers.enable(2);
        cameraR.viewport = new $c702e238df7c5123$export$fa7daccca11cdbe3();
        var cameras = [
            cameraL,
            cameraR
        ];
        var cameraVR = new $c702e238df7c5123$export$56b937d9e5581166();
        cameraVR.layers.enable(1);
        cameraVR.layers.enable(2);
        var _currentDepthNear = null;
        var _currentDepthFar = null;
        //
        _this.cameraAutoUpdate = true;
        _this.enabled = false;
        _this.isPresenting = false;
        _this.getController = function(index) {
            var controller = controllers[index];
            if (controller === undefined) {
                controller = new $c702e238df7c5123$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getTargetRaySpace();
        };
        _this.getControllerGrip = function(index) {
            var controller = controllers[index];
            if (controller === undefined) {
                controller = new $c702e238df7c5123$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getGripSpace();
        };
        _this.getHand = function(index) {
            var controller = controllers[index];
            if (controller === undefined) {
                controller = new $c702e238df7c5123$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getHandSpace();
        };
        _this.setFramebufferScaleFactor = function(value) {
            framebufferScaleFactor = value;
            if (scope.isPresenting === true) console.warn('THREE.WebXRManager: Cannot change framebuffer scale while presenting.');
        };
        _this.setReferenceSpaceType = function(value) {
            referenceSpaceType = value;
            if (scope.isPresenting === true) console.warn('THREE.WebXRManager: Cannot change reference space type while presenting.');
        };
        _this.getReferenceSpace = function() {
            return referenceSpace;
        };
        _this.getSession = function() {
            return session;
        };
        _this.setSession = /*#__PURE__*/ function() {
            var _ref = (0, $ba14d604d8d555ce$export$71511d61b312f219)(function(value) {
                var attributes, layerInit, baseLayer, depthFormat, projectionlayerInit;
                return (0, $b602c7a134484286$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            session = value;
                            if (!(session !== null)) return [
                                3,
                                4
                            ];
                            session.addEventListener('select', onSessionEvent);
                            session.addEventListener('selectstart', onSessionEvent);
                            session.addEventListener('selectend', onSessionEvent);
                            session.addEventListener('squeeze', onSessionEvent);
                            session.addEventListener('squeezestart', onSessionEvent);
                            session.addEventListener('squeezeend', onSessionEvent);
                            session.addEventListener('end', onSessionEnd);
                            session.addEventListener('inputsourceschange', onInputSourcesChange);
                            attributes = gl.getContextAttributes();
                            if (!(attributes.xrCompatible !== true)) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                gl.makeXRCompatible()
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            if (session.renderState.layers === undefined) {
                                layerInit = {
                                    antialias: attributes.antialias,
                                    alpha: attributes.alpha,
                                    depth: attributes.depth,
                                    stencil: attributes.stencil,
                                    framebufferScaleFactor: framebufferScaleFactor
                                };
                                // eslint-disable-next-line no-undef
                                baseLayer = new XRWebGLLayer(session, gl, layerInit);
                                session.updateRenderState({
                                    baseLayer: baseLayer
                                });
                            } else {
                                depthFormat = 0;
                                if (attributes.depth) depthFormat = attributes.stencil ? 34041 : 6402;
                                projectionlayerInit = {
                                    colorFormat: attributes.alpha ? 6408 : 6407,
                                    depthFormat: depthFormat,
                                    scaleFactor: framebufferScaleFactor
                                };
                                // eslint-disable-next-line no-undef
                                glBinding = new XRWebGLBinding(session, gl);
                                glProjLayer = glBinding.createProjectionLayer(projectionlayerInit);
                                glFramebuffer = gl.createFramebuffer();
                                session.updateRenderState({
                                    layers: [
                                        glProjLayer
                                    ]
                                });
                            }
                            return [
                                4,
                                session.requestReferenceSpace(referenceSpaceType)
                            ];
                        case 3:
                            referenceSpace = _state.sent();
                            animation.setContext(session);
                            animation.start();
                            scope.isPresenting = true;
                            scope.dispatchEvent({
                                type: 'sessionstart'
                            });
                            _state.label = 4;
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(value) {
                return _ref.apply(this, arguments);
            };
        }();
        //
        var cameraLPos = new $c702e238df7c5123$export$64b5c384219d3699();
        var cameraRPos = new $c702e238df7c5123$export$64b5c384219d3699();
        _this.updateCamera = function(camera) {
            if (session === null) return;
            cameraVR.near = cameraR.near = cameraL.near = camera.near;
            cameraVR.far = cameraR.far = cameraL.far = camera.far;
            if (_currentDepthNear !== cameraVR.near || _currentDepthFar !== cameraVR.far) {
                // Note that the new renderState won't apply until the next frame. See #18320
                session.updateRenderState({
                    depthNear: cameraVR.near,
                    depthFar: cameraVR.far
                });
                _currentDepthNear = cameraVR.near;
                _currentDepthFar = cameraVR.far;
            }
            var parent = camera.parent;
            var cameras = cameraVR.cameras;
            updateCamera(cameraVR, parent);
            for(var i = 0; i < cameras.length; i++)updateCamera(cameras[i], parent);
            cameraVR.matrixWorld.decompose(cameraVR.position, cameraVR.quaternion, cameraVR.scale);
            // update user camera and its children
            camera.position.copy(cameraVR.position);
            camera.quaternion.copy(cameraVR.quaternion);
            camera.scale.copy(cameraVR.scale);
            camera.matrix.copy(cameraVR.matrix);
            camera.matrixWorld.copy(cameraVR.matrixWorld);
            var children = camera.children;
            for(var i1 = 0, l = children.length; i1 < l; i1++)children[i1].updateMatrixWorld(true);
            // update projection matrix for proper view frustum culling
            if (cameras.length === 2) setProjectionFromUnion(cameraVR, cameraL, cameraR);
            else // assume single camera setup (AR)
            cameraVR.projectionMatrix.copy(cameraL.projectionMatrix);
        };
        _this.getCamera = function() {
            return cameraVR;
        };
        // Animation Loop
        var onAnimationFrameCallback = null;
        var animation = new $c702e238df7c5123$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        _this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
        };
        _this.dispose = function() {};
        return _this;
    }
    return WebXRManager;
}($c702e238df7c5123$export$ec8b666c5fe2c75a);
function $c702e238df7c5123$var$WebGLMaterials(properties) {
    function refreshFogUniforms(uniforms, fog) {
        uniforms.fogColor.value.copy(fog.color);
        if (fog.isFog) {
            uniforms.fogNear.value = fog.near;
            uniforms.fogFar.value = fog.far;
        } else if (fog.isFogExp2) uniforms.fogDensity.value = fog.density;
    }
    function refreshMaterialUniforms(uniforms, material, pixelRatio, height, transmissionRenderTarget) {
        if (material.isMeshBasicMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshLambertMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsLambert(uniforms, material);
        } else if (material.isMeshToonMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsToon(uniforms, material);
        } else if (material.isMeshPhongMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsPhong(uniforms, material);
        } else if (material.isMeshStandardMaterial) {
            refreshUniformsCommon(uniforms, material);
            if (material.isMeshPhysicalMaterial) refreshUniformsPhysical(uniforms, material, transmissionRenderTarget);
            else refreshUniformsStandard(uniforms, material);
        } else if (material.isMeshMatcapMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsMatcap(uniforms, material);
        } else if (material.isMeshDepthMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsDepth(uniforms, material);
        } else if (material.isMeshDistanceMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsDistance(uniforms, material);
        } else if (material.isMeshNormalMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsNormal(uniforms, material);
        } else if (material.isLineBasicMaterial) {
            refreshUniformsLine(uniforms, material);
            if (material.isLineDashedMaterial) refreshUniformsDash(uniforms, material);
        } else if (material.isPointsMaterial) refreshUniformsPoints(uniforms, material, pixelRatio, height);
        else if (material.isSpriteMaterial) refreshUniformsSprites(uniforms, material);
        else if (material.isShadowMaterial) {
            uniforms.color.value.copy(material.color);
            uniforms.opacity.value = material.opacity;
        } else if (material.isShaderMaterial) material.uniformsNeedUpdate = false; // #15581
    }
    function refreshUniformsCommon(uniforms, material) {
        uniforms.opacity.value = material.opacity;
        if (material.color) uniforms.diffuse.value.copy(material.color);
        if (material.emissive) uniforms.emissive.value.copy(material.emissive).multiplyScalar(material.emissiveIntensity);
        if (material.map) uniforms.map.value = material.map;
        if (material.alphaMap) uniforms.alphaMap.value = material.alphaMap;
        if (material.specularMap) uniforms.specularMap.value = material.specularMap;
        var envMap = properties.get(material).envMap;
        if (envMap) {
            uniforms.envMap.value = envMap;
            uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap._needsFlipEnvMap ? -1 : 1;
            uniforms.reflectivity.value = material.reflectivity;
            uniforms.refractionRatio.value = material.refractionRatio;
            var maxMipLevel = properties.get(envMap).__maxMipLevel;
            if (maxMipLevel !== undefined) uniforms.maxMipLevel.value = maxMipLevel;
        }
        if (material.lightMap) {
            uniforms.lightMap.value = material.lightMap;
            uniforms.lightMapIntensity.value = material.lightMapIntensity;
        }
        if (material.aoMap) {
            uniforms.aoMap.value = material.aoMap;
            uniforms.aoMapIntensity.value = material.aoMapIntensity;
        }
        // uv repeat and offset setting priorities
        // 1. color map
        // 2. specular map
        // 3. displacementMap map
        // 4. normal map
        // 5. bump map
        // 6. roughnessMap map
        // 7. metalnessMap map
        // 8. alphaMap map
        // 9. emissiveMap map
        // 10. clearcoat map
        // 11. clearcoat normal map
        // 12. clearcoat roughnessMap map
        var uvScaleMap;
        if (material.map) uvScaleMap = material.map;
        else if (material.specularMap) uvScaleMap = material.specularMap;
        else if (material.displacementMap) uvScaleMap = material.displacementMap;
        else if (material.normalMap) uvScaleMap = material.normalMap;
        else if (material.bumpMap) uvScaleMap = material.bumpMap;
        else if (material.roughnessMap) uvScaleMap = material.roughnessMap;
        else if (material.metalnessMap) uvScaleMap = material.metalnessMap;
        else if (material.alphaMap) uvScaleMap = material.alphaMap;
        else if (material.emissiveMap) uvScaleMap = material.emissiveMap;
        else if (material.clearcoatMap) uvScaleMap = material.clearcoatMap;
        else if (material.clearcoatNormalMap) uvScaleMap = material.clearcoatNormalMap;
        else if (material.clearcoatRoughnessMap) uvScaleMap = material.clearcoatRoughnessMap;
        if (uvScaleMap !== undefined) {
            // backwards compatibility
            if (uvScaleMap.isWebGLRenderTarget) uvScaleMap = uvScaleMap.texture;
            if (uvScaleMap.matrixAutoUpdate === true) uvScaleMap.updateMatrix();
            uniforms.uvTransform.value.copy(uvScaleMap.matrix);
        }
        // uv repeat and offset setting priorities for uv2
        // 1. ao map
        // 2. light map
        var uv2ScaleMap;
        if (material.aoMap) uv2ScaleMap = material.aoMap;
        else if (material.lightMap) uv2ScaleMap = material.lightMap;
        if (uv2ScaleMap !== undefined) {
            // backwards compatibility
            if (uv2ScaleMap.isWebGLRenderTarget) uv2ScaleMap = uv2ScaleMap.texture;
            if (uv2ScaleMap.matrixAutoUpdate === true) uv2ScaleMap.updateMatrix();
            uniforms.uv2Transform.value.copy(uv2ScaleMap.matrix);
        }
    }
    function refreshUniformsLine(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
    }
    function refreshUniformsDash(uniforms, material) {
        uniforms.dashSize.value = material.dashSize;
        uniforms.totalSize.value = material.dashSize + material.gapSize;
        uniforms.scale.value = material.scale;
    }
    function refreshUniformsPoints(uniforms, material, pixelRatio, height) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.size.value = material.size * pixelRatio;
        uniforms.scale.value = height * 0.5;
        if (material.map) uniforms.map.value = material.map;
        if (material.alphaMap) uniforms.alphaMap.value = material.alphaMap;
        // uv repeat and offset setting priorities
        // 1. color map
        // 2. alpha map
        var uvScaleMap;
        if (material.map) uvScaleMap = material.map;
        else if (material.alphaMap) uvScaleMap = material.alphaMap;
        if (uvScaleMap !== undefined) {
            if (uvScaleMap.matrixAutoUpdate === true) uvScaleMap.updateMatrix();
            uniforms.uvTransform.value.copy(uvScaleMap.matrix);
        }
    }
    function refreshUniformsSprites(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.rotation.value = material.rotation;
        if (material.map) uniforms.map.value = material.map;
        if (material.alphaMap) uniforms.alphaMap.value = material.alphaMap;
        // uv repeat and offset setting priorities
        // 1. color map
        // 2. alpha map
        var uvScaleMap;
        if (material.map) uvScaleMap = material.map;
        else if (material.alphaMap) uvScaleMap = material.alphaMap;
        if (uvScaleMap !== undefined) {
            if (uvScaleMap.matrixAutoUpdate === true) uvScaleMap.updateMatrix();
            uniforms.uvTransform.value.copy(uvScaleMap.matrix);
        }
    }
    function refreshUniformsLambert(uniforms, material) {
        if (material.emissiveMap) uniforms.emissiveMap.value = material.emissiveMap;
    }
    function refreshUniformsPhong(uniforms, material) {
        uniforms.specular.value.copy(material.specular);
        uniforms.shininess.value = Math.max(material.shininess, 1e-4); // to prevent pow( 0.0, 0.0 )
        if (material.emissiveMap) uniforms.emissiveMap.value = material.emissiveMap;
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === $c702e238df7c5123$export$d9f0486e75b5ace) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === $c702e238df7c5123$export$d9f0486e75b5ace) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
    }
    function refreshUniformsToon(uniforms, material) {
        if (material.gradientMap) uniforms.gradientMap.value = material.gradientMap;
        if (material.emissiveMap) uniforms.emissiveMap.value = material.emissiveMap;
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === $c702e238df7c5123$export$d9f0486e75b5ace) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === $c702e238df7c5123$export$d9f0486e75b5ace) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
    }
    function refreshUniformsStandard(uniforms, material) {
        uniforms.roughness.value = material.roughness;
        uniforms.metalness.value = material.metalness;
        if (material.roughnessMap) uniforms.roughnessMap.value = material.roughnessMap;
        if (material.metalnessMap) uniforms.metalnessMap.value = material.metalnessMap;
        if (material.emissiveMap) uniforms.emissiveMap.value = material.emissiveMap;
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === $c702e238df7c5123$export$d9f0486e75b5ace) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === $c702e238df7c5123$export$d9f0486e75b5ace) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
        var envMap = properties.get(material).envMap;
        if (envMap) //uniforms.envMap.value = material.envMap; // part of uniforms common
        uniforms.envMapIntensity.value = material.envMapIntensity;
    }
    function refreshUniformsPhysical(uniforms, material, transmissionRenderTarget) {
        refreshUniformsStandard(uniforms, material);
        uniforms.reflectivity.value = material.reflectivity; // also part of uniforms common
        uniforms.clearcoat.value = material.clearcoat;
        uniforms.clearcoatRoughness.value = material.clearcoatRoughness;
        if (material.sheen) uniforms.sheen.value.copy(material.sheen);
        if (material.clearcoatMap) uniforms.clearcoatMap.value = material.clearcoatMap;
        if (material.clearcoatRoughnessMap) uniforms.clearcoatRoughnessMap.value = material.clearcoatRoughnessMap;
        if (material.clearcoatNormalMap) {
            uniforms.clearcoatNormalScale.value.copy(material.clearcoatNormalScale);
            uniforms.clearcoatNormalMap.value = material.clearcoatNormalMap;
            if (material.side === $c702e238df7c5123$export$d9f0486e75b5ace) uniforms.clearcoatNormalScale.value.negate();
        }
        uniforms.transmission.value = material.transmission;
        if (material.transmissionMap) uniforms.transmissionMap.value = material.transmissionMap;
        if (material.transmission > 0.0) {
            uniforms.transmissionSamplerMap.value = transmissionRenderTarget.texture;
            uniforms.transmissionSamplerSize.value.set(transmissionRenderTarget.width, transmissionRenderTarget.height);
        }
        uniforms.thickness.value = material.thickness;
        if (material.thicknessMap) uniforms.thicknessMap.value = material.thicknessMap;
        uniforms.attenuationDistance.value = material.attenuationDistance;
        uniforms.attenuationColor.value.copy(material.attenuationColor);
    }
    function refreshUniformsMatcap(uniforms, material) {
        if (material.matcap) uniforms.matcap.value = material.matcap;
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === $c702e238df7c5123$export$d9f0486e75b5ace) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === $c702e238df7c5123$export$d9f0486e75b5ace) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
    }
    function refreshUniformsDepth(uniforms, material) {
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
    }
    function refreshUniformsDistance(uniforms, material) {
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
        uniforms.referencePosition.value.copy(material.referencePosition);
        uniforms.nearDistance.value = material.nearDistance;
        uniforms.farDistance.value = material.farDistance;
    }
    function refreshUniformsNormal(uniforms, material) {
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === $c702e238df7c5123$export$d9f0486e75b5ace) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === $c702e238df7c5123$export$d9f0486e75b5ace) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
    }
    return {
        refreshFogUniforms: refreshFogUniforms,
        refreshMaterialUniforms: refreshMaterialUniforms
    };
}
function $c702e238df7c5123$var$createCanvasElement() {
    var canvas = document.createElementNS('http://www.w3.org/1999/xhtml', 'canvas');
    canvas.style.display = 'block';
    return canvas;
}
function $c702e238df7c5123$export$f6cc00ef28d7cf97() {
    var parameters = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _canvas = parameters.canvas !== undefined ? parameters.canvas : $c702e238df7c5123$var$createCanvasElement(), _context = parameters.context !== undefined ? parameters.context : null, _alpha = parameters.alpha !== undefined ? parameters.alpha : false, _depth = parameters.depth !== undefined ? parameters.depth : true, _stencil = parameters.stencil !== undefined ? parameters.stencil : true, _antialias = parameters.antialias !== undefined ? parameters.antialias : false, _premultipliedAlpha = parameters.premultipliedAlpha !== undefined ? parameters.premultipliedAlpha : true, _preserveDrawingBuffer = parameters.preserveDrawingBuffer !== undefined ? parameters.preserveDrawingBuffer : false, _powerPreference = parameters.powerPreference !== undefined ? parameters.powerPreference : 'default', _failIfMajorPerformanceCaveat = parameters.failIfMajorPerformanceCaveat !== undefined ? parameters.failIfMajorPerformanceCaveat : false;
    var currentRenderList = null;
    var currentRenderState = null;
    // render() can be called from within a callback triggered by another render.
    // We track this so that the nested render call gets its list and state isolated from the parent render call.
    var renderListStack = [];
    var renderStateStack = [];
    // public properties
    this.domElement = _canvas;
    // Debug configuration container
    this.debug = {
        /**
		 * Enables error checking and reporting when shader programs are being compiled
		 * @type {boolean}
		 */ checkShaderErrors: true
    };
    // clearing
    this.autoClear = true;
    this.autoClearColor = true;
    this.autoClearDepth = true;
    this.autoClearStencil = true;
    // scene graph
    this.sortObjects = true;
    // user-defined clipping
    this.clippingPlanes = [];
    this.localClippingEnabled = false;
    // physically based shading
    this.gammaFactor = 2.0; // for backwards compatibility
    this.outputEncoding = $c702e238df7c5123$export$7207336e4151a112;
    // physical lights
    this.physicallyCorrectLights = false;
    // tone mapping
    this.toneMapping = $c702e238df7c5123$export$9fcb6b4294603b2;
    this.toneMappingExposure = 1.0;
    // internal properties
    var _this = this;
    var _isContextLost = false;
    // internal state cache
    var _currentActiveCubeFace = 0;
    var _currentActiveMipmapLevel = 0;
    var _currentRenderTarget = null;
    var _currentMaterialId = -1;
    var _currentCamera = null;
    var _currentViewport = new $c702e238df7c5123$export$fa7daccca11cdbe3();
    var _currentScissor = new $c702e238df7c5123$export$fa7daccca11cdbe3();
    var _currentScissorTest = null;
    //
    var _width = _canvas.width;
    var _height = _canvas.height;
    var _pixelRatio = 1;
    var _opaqueSort = null;
    var _transparentSort = null;
    var _viewport = new $c702e238df7c5123$export$fa7daccca11cdbe3(0, 0, _width, _height);
    var _scissor = new $c702e238df7c5123$export$fa7daccca11cdbe3(0, 0, _width, _height);
    var _scissorTest = false;
    //
    var _currentDrawBuffers = [];
    // frustum
    var _frustum = new $c702e238df7c5123$export$35efe6f4c85463d2();
    // clipping
    var _clippingEnabled = false;
    var _localClippingEnabled = false;
    // transmission
    var _transmissionRenderTarget = null;
    // camera matrices cache
    var _projScreenMatrix = new $c702e238df7c5123$export$2ae72fc923e5eb5();
    var _vector3 = new $c702e238df7c5123$export$64b5c384219d3699();
    var _emptyScene = {
        background: null,
        fog: null,
        environment: null,
        overrideMaterial: null,
        isScene: true
    };
    function getTargetPixelRatio() {
        return _currentRenderTarget === null ? _pixelRatio : 1;
    }
    // initialize
    var _gl = _context;
    function getContext(contextNames, contextAttributes) {
        for(var i = 0; i < contextNames.length; i++){
            var contextName = contextNames[i];
            var context = _canvas.getContext(contextName, contextAttributes);
            if (context !== null) return context;
        }
        return null;
    }
    try {
        var contextAttributes = {
            alpha: _alpha,
            depth: _depth,
            stencil: _stencil,
            antialias: _antialias,
            premultipliedAlpha: _premultipliedAlpha,
            preserveDrawingBuffer: _preserveDrawingBuffer,
            powerPreference: _powerPreference,
            failIfMajorPerformanceCaveat: _failIfMajorPerformanceCaveat
        };
        // event listeners must be registered before WebGL context is created, see #12753
        _canvas.addEventListener('webglcontextlost', onContextLost, false);
        _canvas.addEventListener('webglcontextrestored', onContextRestore, false);
        if (_gl === null) {
            var contextNames = [
                'webgl2',
                'webgl',
                'experimental-webgl'
            ];
            if (_this.isWebGL1Renderer === true) contextNames.shift();
            _gl = getContext(contextNames, contextAttributes);
            if (_gl === null) {
                if (getContext(contextNames)) throw new Error('Error creating WebGL context with your selected attributes.');
                else throw new Error('Error creating WebGL context.');
            }
        }
        // Some experimental-webgl implementations do not have getShaderPrecisionFormat
        if (_gl.getShaderPrecisionFormat === undefined) _gl.getShaderPrecisionFormat = function() {
            return {
                rangeMin: 1,
                rangeMax: 1,
                precision: 1
            };
        };
    } catch (error) {
        console.error('THREE.WebGLRenderer: ' + error.message);
        throw error;
    }
    var extensions, capabilities, state, info;
    var properties, textures, cubemaps, attributes, geometries, objects;
    var programCache, materials, renderLists, renderStates, clipping, shadowMap;
    var background, morphtargets, bufferRenderer, indexedBufferRenderer;
    var utils, bindingStates;
    function initGLContext() {
        extensions = new $c702e238df7c5123$var$WebGLExtensions(_gl);
        capabilities = new $c702e238df7c5123$var$WebGLCapabilities(_gl, extensions, parameters);
        extensions.init(capabilities);
        utils = new $c702e238df7c5123$export$ddaebcad857649a8(_gl, extensions, capabilities);
        state = new $c702e238df7c5123$var$WebGLState(_gl, extensions, capabilities);
        _currentDrawBuffers[0] = 1029;
        info = new $c702e238df7c5123$var$WebGLInfo(_gl);
        properties = new $c702e238df7c5123$var$WebGLProperties();
        textures = new $c702e238df7c5123$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info);
        cubemaps = new $c702e238df7c5123$var$WebGLCubeMaps(_this);
        attributes = new $c702e238df7c5123$var$WebGLAttributes(_gl, capabilities);
        bindingStates = new $c702e238df7c5123$var$WebGLBindingStates(_gl, extensions, attributes, capabilities);
        geometries = new $c702e238df7c5123$var$WebGLGeometries(_gl, attributes, info, bindingStates);
        objects = new $c702e238df7c5123$var$WebGLObjects(_gl, geometries, attributes, info);
        morphtargets = new $c702e238df7c5123$var$WebGLMorphtargets(_gl);
        clipping = new $c702e238df7c5123$var$WebGLClipping(properties);
        programCache = new $c702e238df7c5123$var$WebGLPrograms(_this, cubemaps, extensions, capabilities, bindingStates, clipping);
        materials = new $c702e238df7c5123$var$WebGLMaterials(properties);
        renderLists = new $c702e238df7c5123$var$WebGLRenderLists(properties);
        renderStates = new $c702e238df7c5123$var$WebGLRenderStates(extensions, capabilities);
        background = new $c702e238df7c5123$var$WebGLBackground(_this, cubemaps, state, objects, _premultipliedAlpha);
        shadowMap = new $c702e238df7c5123$var$WebGLShadowMap(_this, objects, capabilities);
        bufferRenderer = new $c702e238df7c5123$var$WebGLBufferRenderer(_gl, extensions, info, capabilities);
        indexedBufferRenderer = new $c702e238df7c5123$var$WebGLIndexedBufferRenderer(_gl, extensions, info, capabilities);
        info.programs = programCache.programs;
        _this.capabilities = capabilities;
        _this.extensions = extensions;
        _this.properties = properties;
        _this.renderLists = renderLists;
        _this.shadowMap = shadowMap;
        _this.state = state;
        _this.info = info;
    }
    initGLContext();
    // xr
    var xr = new $c702e238df7c5123$var$WebXRManager(_this, _gl);
    this.xr = xr;
    // API
    this.getContext = function() {
        return _gl;
    };
    this.getContextAttributes = function() {
        return _gl.getContextAttributes();
    };
    this.forceContextLoss = function() {
        var extension = extensions.get('WEBGL_lose_context');
        if (extension) extension.loseContext();
    };
    this.forceContextRestore = function() {
        var extension = extensions.get('WEBGL_lose_context');
        if (extension) extension.restoreContext();
    };
    this.getPixelRatio = function() {
        return _pixelRatio;
    };
    this.setPixelRatio = function(value) {
        if (value === undefined) return;
        _pixelRatio = value;
        this.setSize(_width, _height, false);
    };
    this.getSize = function(target) {
        return target.set(_width, _height);
    };
    this.setSize = function(width, height, updateStyle) {
        if (xr.isPresenting) {
            console.warn('THREE.WebGLRenderer: Can\'t change size while VR device is presenting.');
            return;
        }
        _width = width;
        _height = height;
        _canvas.width = Math.floor(width * _pixelRatio);
        _canvas.height = Math.floor(height * _pixelRatio);
        if (updateStyle !== false) {
            _canvas.style.width = width + 'px';
            _canvas.style.height = height + 'px';
        }
        this.setViewport(0, 0, width, height);
    };
    this.getDrawingBufferSize = function(target) {
        return target.set(_width * _pixelRatio, _height * _pixelRatio).floor();
    };
    this.setDrawingBufferSize = function(width, height, pixelRatio) {
        _width = width;
        _height = height;
        _pixelRatio = pixelRatio;
        _canvas.width = Math.floor(width * pixelRatio);
        _canvas.height = Math.floor(height * pixelRatio);
        this.setViewport(0, 0, width, height);
    };
    this.getCurrentViewport = function(target) {
        return target.copy(_currentViewport);
    };
    this.getViewport = function(target) {
        return target.copy(_viewport);
    };
    this.setViewport = function(x, y, width, height) {
        if (x.isVector4) _viewport.set(x.x, x.y, x.z, x.w);
        else _viewport.set(x, y, width, height);
        state.viewport(_currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor());
    };
    this.getScissor = function(target) {
        return target.copy(_scissor);
    };
    this.setScissor = function(x, y, width, height) {
        if (x.isVector4) _scissor.set(x.x, x.y, x.z, x.w);
        else _scissor.set(x, y, width, height);
        state.scissor(_currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor());
    };
    this.getScissorTest = function() {
        return _scissorTest;
    };
    this.setScissorTest = function(_boolean) {
        state.setScissorTest(_scissorTest = _boolean);
    };
    this.setOpaqueSort = function(method) {
        _opaqueSort = method;
    };
    this.setTransparentSort = function(method) {
        _transparentSort = method;
    };
    // Clearing
    this.getClearColor = function(target) {
        return target.copy(background.getClearColor());
    };
    this.setClearColor = function() {
        background.setClearColor.apply(background, arguments);
    };
    this.getClearAlpha = function() {
        return background.getClearAlpha();
    };
    this.setClearAlpha = function() {
        background.setClearAlpha.apply(background, arguments);
    };
    this.clear = function(color, depth, stencil) {
        var bits = 0;
        if (color === undefined || color) bits |= 16384;
        if (depth === undefined || depth) bits |= 256;
        if (stencil === undefined || stencil) bits |= 1024;
        _gl.clear(bits);
    };
    this.clearColor = function() {
        this.clear(true, false, false);
    };
    this.clearDepth = function() {
        this.clear(false, true, false);
    };
    this.clearStencil = function() {
        this.clear(false, false, true);
    };
    //
    this.dispose = function() {
        _canvas.removeEventListener('webglcontextlost', onContextLost, false);
        _canvas.removeEventListener('webglcontextrestored', onContextRestore, false);
        renderLists.dispose();
        renderStates.dispose();
        properties.dispose();
        cubemaps.dispose();
        objects.dispose();
        bindingStates.dispose();
        xr.dispose();
        xr.removeEventListener('sessionstart', onXRSessionStart);
        xr.removeEventListener('sessionend', onXRSessionEnd);
        if (_transmissionRenderTarget) {
            _transmissionRenderTarget.dispose();
            _transmissionRenderTarget = null;
        }
        animation.stop();
    };
    // Events
    function onContextLost(event) {
        event.preventDefault();
        console.log('THREE.WebGLRenderer: Context Lost.');
        _isContextLost = true;
    }
    function onContextRestore() {
        console.log('THREE.WebGLRenderer: Context Restored.');
        _isContextLost = false;
        var infoAutoReset = info.autoReset;
        var shadowMapEnabled = shadowMap.enabled;
        var shadowMapAutoUpdate = shadowMap.autoUpdate;
        var shadowMapNeedsUpdate = shadowMap.needsUpdate;
        var shadowMapType = shadowMap.type;
        initGLContext();
        info.autoReset = infoAutoReset;
        shadowMap.enabled = shadowMapEnabled;
        shadowMap.autoUpdate = shadowMapAutoUpdate;
        shadowMap.needsUpdate = shadowMapNeedsUpdate;
        shadowMap.type = shadowMapType;
    }
    function onMaterialDispose(event) {
        var material = event.target;
        material.removeEventListener('dispose', onMaterialDispose);
        deallocateMaterial(material);
    }
    // Buffer deallocation
    function deallocateMaterial(material) {
        releaseMaterialProgramReferences(material);
        properties.remove(material);
    }
    function releaseMaterialProgramReferences(material) {
        var programs = properties.get(material).programs;
        if (programs !== undefined) programs.forEach(function(program) {
            programCache.releaseProgram(program);
        });
    }
    // Buffer rendering
    function renderObjectImmediate(object, program) {
        object.render(function(object) {
            _this.renderBufferImmediate(object, program);
        });
    }
    this.renderBufferImmediate = function(object, program) {
        bindingStates.initAttributes();
        var buffers = properties.get(object);
        if (object.hasPositions && !buffers.position) buffers.position = _gl.createBuffer();
        if (object.hasNormals && !buffers.normal) buffers.normal = _gl.createBuffer();
        if (object.hasUvs && !buffers.uv) buffers.uv = _gl.createBuffer();
        if (object.hasColors && !buffers.color) buffers.color = _gl.createBuffer();
        var programAttributes = program.getAttributes();
        if (object.hasPositions) {
            _gl.bindBuffer(34962, buffers.position);
            _gl.bufferData(34962, object.positionArray, 35048);
            bindingStates.enableAttribute(programAttributes.position);
            _gl.vertexAttribPointer(programAttributes.position, 3, 5126, false, 0, 0);
        }
        if (object.hasNormals) {
            _gl.bindBuffer(34962, buffers.normal);
            _gl.bufferData(34962, object.normalArray, 35048);
            bindingStates.enableAttribute(programAttributes.normal);
            _gl.vertexAttribPointer(programAttributes.normal, 3, 5126, false, 0, 0);
        }
        if (object.hasUvs) {
            _gl.bindBuffer(34962, buffers.uv);
            _gl.bufferData(34962, object.uvArray, 35048);
            bindingStates.enableAttribute(programAttributes.uv);
            _gl.vertexAttribPointer(programAttributes.uv, 2, 5126, false, 0, 0);
        }
        if (object.hasColors) {
            _gl.bindBuffer(34962, buffers.color);
            _gl.bufferData(34962, object.colorArray, 35048);
            bindingStates.enableAttribute(programAttributes.color);
            _gl.vertexAttribPointer(programAttributes.color, 3, 5126, false, 0, 0);
        }
        bindingStates.disableUnusedAttributes();
        _gl.drawArrays(4, 0, object.count);
        object.count = 0;
    };
    this.renderBufferDirect = function(camera, scene, geometry, material, object, group) {
        if (scene === null) scene = _emptyScene; // renderBufferDirect second parameter used to be fog (could be null)
        var frontFaceCW = object.isMesh && object.matrixWorld.determinant() < 0;
        var program = setProgram(camera, scene, material, object);
        state.setMaterial(material, frontFaceCW);
        //
        var index = geometry.index;
        var position = geometry.attributes.position;
        //
        if (index === null) {
            if (position === undefined || position.count === 0) return;
        } else if (index.count === 0) return;
        //
        var rangeFactor = 1;
        if (material.wireframe === true) {
            index = geometries.getWireframeAttribute(geometry);
            rangeFactor = 2;
        }
        if (material.morphTargets || material.morphNormals) morphtargets.update(object, geometry, material, program);
        bindingStates.setup(object, material, program, geometry, index);
        var attribute;
        var renderer = bufferRenderer;
        if (index !== null) {
            attribute = attributes.get(index);
            renderer = indexedBufferRenderer;
            renderer.setIndex(attribute);
        }
        //
        var dataCount = index !== null ? index.count : position.count;
        var rangeStart = geometry.drawRange.start * rangeFactor;
        var rangeCount = geometry.drawRange.count * rangeFactor;
        var groupStart = group !== null ? group.start * rangeFactor : 0;
        var groupCount = group !== null ? group.count * rangeFactor : Infinity;
        var drawStart = Math.max(rangeStart, groupStart);
        var drawEnd = Math.min(dataCount, rangeStart + rangeCount, groupStart + groupCount) - 1;
        var drawCount = Math.max(0, drawEnd - drawStart + 1);
        if (drawCount === 0) return;
        //
        if (object.isMesh) {
            if (material.wireframe === true) {
                state.setLineWidth(material.wireframeLinewidth * getTargetPixelRatio());
                renderer.setMode(1);
            } else renderer.setMode(4);
        } else if (object.isLine) {
            var lineWidth = material.linewidth;
            if (lineWidth === undefined) lineWidth = 1; // Not using Line*Material
            state.setLineWidth(lineWidth * getTargetPixelRatio());
            if (object.isLineSegments) renderer.setMode(1);
            else if (object.isLineLoop) renderer.setMode(2);
            else renderer.setMode(3);
        } else if (object.isPoints) renderer.setMode(0);
        else if (object.isSprite) renderer.setMode(4);
        if (object.isInstancedMesh) renderer.renderInstances(drawStart, drawCount, object.count);
        else if (geometry.isInstancedBufferGeometry) {
            var instanceCount = Math.min(geometry.instanceCount, geometry._maxInstanceCount);
            renderer.renderInstances(drawStart, drawCount, instanceCount);
        } else renderer.render(drawStart, drawCount);
    };
    // Compile
    this.compile = function(scene, camera) {
        currentRenderState = renderStates.get(scene);
        currentRenderState.init();
        scene.traverseVisible(function(object) {
            if (object.isLight && object.layers.test(camera.layers)) {
                currentRenderState.pushLight(object);
                if (object.castShadow) currentRenderState.pushShadow(object);
            }
        });
        currentRenderState.setupLights();
        scene.traverse(function(object) {
            var material = object.material;
            if (material) {
                if (Array.isArray(material)) for(var i = 0; i < material.length; i++){
                    var material2 = material[i];
                    getProgram(material2, scene, object);
                }
                else getProgram(material, scene, object);
            }
        });
    };
    // Animation Loop
    var onAnimationFrameCallback = null;
    function onAnimationFrame(time) {
        if (onAnimationFrameCallback) onAnimationFrameCallback(time);
    }
    function onXRSessionStart() {
        animation.stop();
    }
    function onXRSessionEnd() {
        animation.start();
    }
    var animation = new $c702e238df7c5123$var$WebGLAnimation();
    animation.setAnimationLoop(onAnimationFrame);
    if (typeof window !== 'undefined') animation.setContext(window);
    this.setAnimationLoop = function(callback) {
        onAnimationFrameCallback = callback;
        xr.setAnimationLoop(callback);
        callback === null ? animation.stop() : animation.start();
    };
    xr.addEventListener('sessionstart', onXRSessionStart);
    xr.addEventListener('sessionend', onXRSessionEnd);
    // Rendering
    this.render = function(scene, camera) {
        if (camera !== undefined && camera.isCamera !== true) {
            console.error('THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.');
            return;
        }
        if (_isContextLost === true) return;
        // update scene graph
        if (scene.autoUpdate === true) scene.updateMatrixWorld();
        // update camera matrices and frustum
        if (camera.parent === null) camera.updateMatrixWorld();
        if (xr.enabled === true && xr.isPresenting === true) {
            if (xr.cameraAutoUpdate === true) xr.updateCamera(camera);
            camera = xr.getCamera(); // use XR camera for rendering
        }
        //
        if (scene.isScene === true) scene.onBeforeRender(_this, scene, camera, _currentRenderTarget);
        currentRenderState = renderStates.get(scene, renderStateStack.length);
        currentRenderState.init();
        renderStateStack.push(currentRenderState);
        _projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
        _frustum.setFromProjectionMatrix(_projScreenMatrix);
        _localClippingEnabled = this.localClippingEnabled;
        _clippingEnabled = clipping.init(this.clippingPlanes, _localClippingEnabled, camera);
        currentRenderList = renderLists.get(scene, renderListStack.length);
        currentRenderList.init();
        renderListStack.push(currentRenderList);
        projectObject(scene, camera, 0, _this.sortObjects);
        currentRenderList.finish();
        if (_this.sortObjects === true) currentRenderList.sort(_opaqueSort, _transparentSort);
        //
        if (_clippingEnabled === true) clipping.beginShadows();
        var shadowsArray = currentRenderState.state.shadowsArray;
        shadowMap.render(shadowsArray, scene, camera);
        currentRenderState.setupLights();
        currentRenderState.setupLightsView(camera);
        if (_clippingEnabled === true) clipping.endShadows();
        //
        if (this.info.autoReset === true) this.info.reset();
        //
        background.render(currentRenderList, scene);
        // render scene
        var opaqueObjects = currentRenderList.opaque;
        var transmissiveObjects = currentRenderList.transmissive;
        var transparentObjects = currentRenderList.transparent;
        if (opaqueObjects.length > 0) renderObjects(opaqueObjects, scene, camera);
        if (transmissiveObjects.length > 0) renderTransmissiveObjects(opaqueObjects, transmissiveObjects, scene, camera);
        if (transparentObjects.length > 0) renderObjects(transparentObjects, scene, camera);
        //
        if (_currentRenderTarget !== null) {
            // resolve multisample renderbuffers to a single-sample texture if necessary
            textures.updateMultisampleRenderTarget(_currentRenderTarget);
            // Generate mipmap if we're using any kind of mipmap filtering
            textures.updateRenderTargetMipmap(_currentRenderTarget);
        }
        //
        if (scene.isScene === true) scene.onAfterRender(_this, scene, camera);
        // Ensure depth buffer writing is enabled so it can be cleared on next render
        state.buffers.depth.setTest(true);
        state.buffers.depth.setMask(true);
        state.buffers.color.setMask(true);
        state.setPolygonOffset(false);
        // _gl.finish();
        bindingStates.resetDefaultState();
        _currentMaterialId = -1;
        _currentCamera = null;
        renderStateStack.pop();
        if (renderStateStack.length > 0) currentRenderState = renderStateStack[renderStateStack.length - 1];
        else currentRenderState = null;
        renderListStack.pop();
        if (renderListStack.length > 0) currentRenderList = renderListStack[renderListStack.length - 1];
        else currentRenderList = null;
    };
    function projectObject(object, camera, groupOrder, sortObjects) {
        if (object.visible === false) return;
        var visible = object.layers.test(camera.layers);
        if (visible) {
            if (object.isGroup) groupOrder = object.renderOrder;
            else if (object.isLOD) {
                if (object.autoUpdate === true) object.update(camera);
            } else if (object.isLight) {
                currentRenderState.pushLight(object);
                if (object.castShadow) currentRenderState.pushShadow(object);
            } else if (object.isSprite) {
                if (!object.frustumCulled || _frustum.intersectsSprite(object)) {
                    if (sortObjects) _vector3.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                    var geometry = objects.update(object);
                    var material = object.material;
                    if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector3.z, null);
                }
            } else if (object.isImmediateRenderObject) {
                if (sortObjects) _vector3.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                currentRenderList.push(object, null, object.material, groupOrder, _vector3.z, null);
            } else if (object.isMesh || object.isLine || object.isPoints) {
                if (object.isSkinnedMesh) // update skeleton only once in a frame
                {
                    if (object.skeleton.frame !== info.render.frame) {
                        object.skeleton.update();
                        object.skeleton.frame = info.render.frame;
                    }
                }
                if (!object.frustumCulled || _frustum.intersectsObject(object)) {
                    if (sortObjects) _vector3.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                    var geometry1 = objects.update(object);
                    var material1 = object.material;
                    if (Array.isArray(material1)) {
                        var groups = geometry1.groups;
                        for(var i = 0, l = groups.length; i < l; i++){
                            var group = groups[i];
                            var groupMaterial = material1[group.materialIndex];
                            if (groupMaterial && groupMaterial.visible) currentRenderList.push(object, geometry1, groupMaterial, groupOrder, _vector3.z, group);
                        }
                    } else if (material1.visible) currentRenderList.push(object, geometry1, material1, groupOrder, _vector3.z, null);
                }
            }
        }
        var children = object.children;
        for(var i1 = 0, l1 = children.length; i1 < l1; i1++)projectObject(children[i1], camera, groupOrder, sortObjects);
    }
    function renderTransmissiveObjects(opaqueObjects, transmissiveObjects, scene, camera) {
        if (_transmissionRenderTarget === null) {
            var needsAntialias = _antialias === true && capabilities.isWebGL2 === true;
            var renderTargetType = needsAntialias ? $c702e238df7c5123$export$cb2022643d3c928d : $c702e238df7c5123$export$3c052beb2e51e23f;
            _transmissionRenderTarget = new renderTargetType(1024, 1024, {
                generateMipmaps: true,
                type: utils.convert($c702e238df7c5123$export$2697304443f382bc) !== null ? $c702e238df7c5123$export$2697304443f382bc : $c702e238df7c5123$export$2e8ce08d3f6f5e10,
                minFilter: $c702e238df7c5123$export$5d8599b6a933fb1b,
                magFilter: $c702e238df7c5123$export$727aa5ec3fe39bf0,
                wrapS: $c702e238df7c5123$export$9d9334239a5a5e06,
                wrapT: $c702e238df7c5123$export$9d9334239a5a5e06
            });
        }
        var currentRenderTarget = _this.getRenderTarget();
        _this.setRenderTarget(_transmissionRenderTarget);
        _this.clear();
        // Turn off the features which can affect the frag color for opaque objects pass.
        // Otherwise they are applied twice in opaque objects pass and transmission objects pass.
        var currentToneMapping = _this.toneMapping;
        _this.toneMapping = $c702e238df7c5123$export$9fcb6b4294603b2;
        renderObjects(opaqueObjects, scene, camera);
        _this.toneMapping = currentToneMapping;
        textures.updateMultisampleRenderTarget(_transmissionRenderTarget);
        textures.updateRenderTargetMipmap(_transmissionRenderTarget);
        _this.setRenderTarget(currentRenderTarget);
        renderObjects(transmissiveObjects, scene, camera);
    }
    function renderObjects(renderList, scene, camera) {
        var overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
        for(var i = 0, l = renderList.length; i < l; i++){
            var renderItem = renderList[i];
            var object = renderItem.object;
            var geometry = renderItem.geometry;
            var material = overrideMaterial === null ? renderItem.material : overrideMaterial;
            var group = renderItem.group;
            if (camera.isArrayCamera) {
                var cameras = camera.cameras;
                for(var j = 0, jl = cameras.length; j < jl; j++){
                    var camera2 = cameras[j];
                    if (object.layers.test(camera2.layers)) {
                        state.viewport(_currentViewport.copy(camera2.viewport));
                        currentRenderState.setupLightsView(camera2);
                        renderObject(object, scene, camera2, geometry, material, group);
                    }
                }
            } else renderObject(object, scene, camera, geometry, material, group);
        }
    }
    function renderObject(object, scene, camera, geometry, material, group) {
        object.onBeforeRender(_this, scene, camera, geometry, material, group);
        object.modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse, object.matrixWorld);
        object.normalMatrix.getNormalMatrix(object.modelViewMatrix);
        if (object.isImmediateRenderObject) {
            var program = setProgram(camera, scene, material, object);
            state.setMaterial(material);
            bindingStates.reset();
            renderObjectImmediate(object, program);
        } else if (material.transparent === true && material.side === $c702e238df7c5123$export$3b296b6f144d5b03) {
            material.side = $c702e238df7c5123$export$d9f0486e75b5ace;
            material.needsUpdate = true;
            _this.renderBufferDirect(camera, scene, geometry, material, object, group);
            material.side = $c702e238df7c5123$export$2ede184fc2998901;
            material.needsUpdate = true;
            _this.renderBufferDirect(camera, scene, geometry, material, object, group);
            material.side = $c702e238df7c5123$export$3b296b6f144d5b03;
        } else _this.renderBufferDirect(camera, scene, geometry, material, object, group);
        object.onAfterRender(_this, scene, camera, geometry, material, group);
    }
    function getProgram(material, scene, object) {
        if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
        var materialProperties = properties.get(material);
        var lights = currentRenderState.state.lights;
        var shadowsArray = currentRenderState.state.shadowsArray;
        var lightsStateVersion = lights.state.version;
        var parameters = programCache.getParameters(material, lights.state, shadowsArray, scene, object);
        var programCacheKey = programCache.getProgramCacheKey(parameters);
        var programs = materialProperties.programs;
        // always update environment and fog - changing these trigger an getProgram call, but it's possible that the program doesn't change
        materialProperties.environment = material.isMeshStandardMaterial ? scene.environment : null;
        materialProperties.fog = scene.fog;
        materialProperties.envMap = cubemaps.get(material.envMap || materialProperties.environment);
        if (programs === undefined) {
            // new material
            material.addEventListener('dispose', onMaterialDispose);
            programs = new Map();
            materialProperties.programs = programs;
        }
        var program = programs.get(programCacheKey);
        if (program !== undefined) // early out if program and light state is identical
        {
            if (materialProperties.currentProgram === program && materialProperties.lightsStateVersion === lightsStateVersion) {
                updateCommonMaterialProperties(material, parameters);
                return program;
            }
        } else {
            parameters.uniforms = programCache.getUniforms(material);
            material.onBuild(parameters, _this);
            material.onBeforeCompile(parameters, _this);
            program = programCache.acquireProgram(parameters, programCacheKey);
            programs.set(programCacheKey, program);
            materialProperties.uniforms = parameters.uniforms;
        }
        var uniforms = materialProperties.uniforms;
        if (!material.isShaderMaterial && !material.isRawShaderMaterial || material.clipping === true) uniforms.clippingPlanes = clipping.uniform;
        updateCommonMaterialProperties(material, parameters);
        // store the light setup it was created for
        materialProperties.needsLights = materialNeedsLights(material);
        materialProperties.lightsStateVersion = lightsStateVersion;
        if (materialProperties.needsLights) {
            // wire up the material to this renderer's lighting state
            uniforms.ambientLightColor.value = lights.state.ambient;
            uniforms.lightProbe.value = lights.state.probe;
            uniforms.directionalLights.value = lights.state.directional;
            uniforms.directionalLightShadows.value = lights.state.directionalShadow;
            uniforms.spotLights.value = lights.state.spot;
            uniforms.spotLightShadows.value = lights.state.spotShadow;
            uniforms.rectAreaLights.value = lights.state.rectArea;
            uniforms.ltc_1.value = lights.state.rectAreaLTC1;
            uniforms.ltc_2.value = lights.state.rectAreaLTC2;
            uniforms.pointLights.value = lights.state.point;
            uniforms.pointLightShadows.value = lights.state.pointShadow;
            uniforms.hemisphereLights.value = lights.state.hemi;
            uniforms.directionalShadowMap.value = lights.state.directionalShadowMap;
            uniforms.directionalShadowMatrix.value = lights.state.directionalShadowMatrix;
            uniforms.spotShadowMap.value = lights.state.spotShadowMap;
            uniforms.spotShadowMatrix.value = lights.state.spotShadowMatrix;
            uniforms.pointShadowMap.value = lights.state.pointShadowMap;
            uniforms.pointShadowMatrix.value = lights.state.pointShadowMatrix;
        // TODO (abelnation): add area lights shadow info to uniforms
        }
        var progUniforms = program.getUniforms();
        var uniformsList = $c702e238df7c5123$var$WebGLUniforms.seqWithValue(progUniforms.seq, uniforms);
        materialProperties.currentProgram = program;
        materialProperties.uniformsList = uniformsList;
        return program;
    }
    function updateCommonMaterialProperties(material, parameters) {
        var materialProperties = properties.get(material);
        materialProperties.outputEncoding = parameters.outputEncoding;
        materialProperties.instancing = parameters.instancing;
        materialProperties.skinning = parameters.skinning;
        materialProperties.numClippingPlanes = parameters.numClippingPlanes;
        materialProperties.numIntersection = parameters.numClipIntersection;
        materialProperties.vertexAlphas = parameters.vertexAlphas;
    }
    function setProgram(camera, scene, material, object) {
        if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
        textures.resetTextureUnits();
        var fog = scene.fog;
        var environment = material.isMeshStandardMaterial ? scene.environment : null;
        var encoding = _currentRenderTarget === null ? _this.outputEncoding : _currentRenderTarget.texture.encoding;
        var envMap = cubemaps.get(material.envMap || environment);
        var vertexAlphas = material.vertexColors === true && object.geometry && object.geometry.attributes.color && object.geometry.attributes.color.itemSize === 4;
        var materialProperties = properties.get(material);
        var lights = currentRenderState.state.lights;
        if (_clippingEnabled === true) {
            if (_localClippingEnabled === true || camera !== _currentCamera) {
                var useCache = camera === _currentCamera && material.id === _currentMaterialId;
                // we might want to call this function with some ClippingGroup
                // object instead of the material, once it becomes feasible
                // (#8465, #8379)
                clipping.setState(material, camera, useCache);
            }
        }
        //
        var needsProgramChange = false;
        if (material.version === materialProperties.__version) {
            if (materialProperties.needsLights && materialProperties.lightsStateVersion !== lights.state.version) needsProgramChange = true;
            else if (materialProperties.outputEncoding !== encoding) needsProgramChange = true;
            else if (object.isInstancedMesh && materialProperties.instancing === false) needsProgramChange = true;
            else if (!object.isInstancedMesh && materialProperties.instancing === true) needsProgramChange = true;
            else if (object.isSkinnedMesh && materialProperties.skinning === false) needsProgramChange = true;
            else if (!object.isSkinnedMesh && materialProperties.skinning === true) needsProgramChange = true;
            else if (materialProperties.envMap !== envMap) needsProgramChange = true;
            else if (material.fog && materialProperties.fog !== fog) needsProgramChange = true;
            else if (materialProperties.numClippingPlanes !== undefined && (materialProperties.numClippingPlanes !== clipping.numPlanes || materialProperties.numIntersection !== clipping.numIntersection)) needsProgramChange = true;
            else if (materialProperties.vertexAlphas !== vertexAlphas) needsProgramChange = true;
        } else {
            needsProgramChange = true;
            materialProperties.__version = material.version;
        }
        //
        var program = materialProperties.currentProgram;
        if (needsProgramChange === true) program = getProgram(material, scene, object);
        var refreshProgram = false;
        var refreshMaterial = false;
        var refreshLights = false;
        var p_uniforms = program.getUniforms(), m_uniforms = materialProperties.uniforms;
        if (state.useProgram(program.program)) {
            refreshProgram = true;
            refreshMaterial = true;
            refreshLights = true;
        }
        if (material.id !== _currentMaterialId) {
            _currentMaterialId = material.id;
            refreshMaterial = true;
        }
        if (refreshProgram || _currentCamera !== camera) {
            p_uniforms.setValue(_gl, 'projectionMatrix', camera.projectionMatrix);
            if (capabilities.logarithmicDepthBuffer) p_uniforms.setValue(_gl, 'logDepthBufFC', 2.0 / (Math.log(camera.far + 1.0) / Math.LN2));
            if (_currentCamera !== camera) {
                _currentCamera = camera;
                // lighting uniforms depend on the camera so enforce an update
                // now, in case this material supports lights - or later, when
                // the next material that does gets activated:
                refreshMaterial = true; // set to true on material change
                refreshLights = true; // remains set until update done
            }
            // load material specific uniforms
            // (shader material also gets them for the sake of genericity)
            if (material.isShaderMaterial || material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshStandardMaterial || material.envMap) {
                var uCamPos = p_uniforms.map.cameraPosition;
                if (uCamPos !== undefined) uCamPos.setValue(_gl, _vector3.setFromMatrixPosition(camera.matrixWorld));
            }
            if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial) p_uniforms.setValue(_gl, 'isOrthographic', camera.isOrthographicCamera === true);
            if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial || material.isShadowMaterial || object.isSkinnedMesh) p_uniforms.setValue(_gl, 'viewMatrix', camera.matrixWorldInverse);
        }
        // skinning uniforms must be set even if material didn't change
        // auto-setting of texture unit for bone texture must go before other textures
        // otherwise textures used for skinning can take over texture units reserved for other material textures
        if (object.isSkinnedMesh) {
            p_uniforms.setOptional(_gl, object, 'bindMatrix');
            p_uniforms.setOptional(_gl, object, 'bindMatrixInverse');
            var skeleton = object.skeleton;
            if (skeleton) {
                if (capabilities.floatVertexTextures) {
                    if (skeleton.boneTexture === null) skeleton.computeBoneTexture();
                    p_uniforms.setValue(_gl, 'boneTexture', skeleton.boneTexture, textures);
                    p_uniforms.setValue(_gl, 'boneTextureSize', skeleton.boneTextureSize);
                } else p_uniforms.setOptional(_gl, skeleton, 'boneMatrices');
            }
        }
        if (refreshMaterial || materialProperties.receiveShadow !== object.receiveShadow) {
            materialProperties.receiveShadow = object.receiveShadow;
            p_uniforms.setValue(_gl, 'receiveShadow', object.receiveShadow);
        }
        if (refreshMaterial) {
            p_uniforms.setValue(_gl, 'toneMappingExposure', _this.toneMappingExposure);
            if (materialProperties.needsLights) // the current material requires lighting info
            // note: all lighting uniforms are always set correctly
            // they simply reference the renderer's state for their
            // values
            //
            // use the current material's .needsUpdate flags to set
            // the GL state when required
            markUniformsLightsNeedsUpdate(m_uniforms, refreshLights);
            // refresh uniforms common to several materials
            if (fog && material.fog) materials.refreshFogUniforms(m_uniforms, fog);
            materials.refreshMaterialUniforms(m_uniforms, material, _pixelRatio, _height, _transmissionRenderTarget);
            $c702e238df7c5123$var$WebGLUniforms.upload(_gl, materialProperties.uniformsList, m_uniforms, textures);
        }
        if (material.isShaderMaterial && material.uniformsNeedUpdate === true) {
            $c702e238df7c5123$var$WebGLUniforms.upload(_gl, materialProperties.uniformsList, m_uniforms, textures);
            material.uniformsNeedUpdate = false;
        }
        if (material.isSpriteMaterial) p_uniforms.setValue(_gl, 'center', object.center);
        // common matrices
        p_uniforms.setValue(_gl, 'modelViewMatrix', object.modelViewMatrix);
        p_uniforms.setValue(_gl, 'normalMatrix', object.normalMatrix);
        p_uniforms.setValue(_gl, 'modelMatrix', object.matrixWorld);
        return program;
    }
    // If uniforms are marked as clean, they don't need to be loaded to the GPU.
    function markUniformsLightsNeedsUpdate(uniforms, value) {
        uniforms.ambientLightColor.needsUpdate = value;
        uniforms.lightProbe.needsUpdate = value;
        uniforms.directionalLights.needsUpdate = value;
        uniforms.directionalLightShadows.needsUpdate = value;
        uniforms.pointLights.needsUpdate = value;
        uniforms.pointLightShadows.needsUpdate = value;
        uniforms.spotLights.needsUpdate = value;
        uniforms.spotLightShadows.needsUpdate = value;
        uniforms.rectAreaLights.needsUpdate = value;
        uniforms.hemisphereLights.needsUpdate = value;
    }
    function materialNeedsLights(material) {
        return material.isMeshLambertMaterial || material.isMeshToonMaterial || material.isMeshPhongMaterial || material.isMeshStandardMaterial || material.isShadowMaterial || material.isShaderMaterial && material.lights === true;
    }
    this.getActiveCubeFace = function() {
        return _currentActiveCubeFace;
    };
    this.getActiveMipmapLevel = function() {
        return _currentActiveMipmapLevel;
    };
    this.getRenderTarget = function() {
        return _currentRenderTarget;
    };
    this.setRenderTarget = function(renderTarget) {
        var activeCubeFace = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, activeMipmapLevel = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
        _currentRenderTarget = renderTarget;
        _currentActiveCubeFace = activeCubeFace;
        _currentActiveMipmapLevel = activeMipmapLevel;
        if (renderTarget && properties.get(renderTarget).__webglFramebuffer === undefined) textures.setupRenderTarget(renderTarget);
        var framebuffer = null;
        var isCube = false;
        var isRenderTarget3D = false;
        if (renderTarget) {
            var texture = renderTarget.texture;
            if (texture.isDataTexture3D || texture.isDataTexture2DArray) isRenderTarget3D = true;
            var __webglFramebuffer = properties.get(renderTarget).__webglFramebuffer;
            if (renderTarget.isWebGLCubeRenderTarget) {
                framebuffer = __webglFramebuffer[activeCubeFace];
                isCube = true;
            } else if (renderTarget.isWebGLMultisampleRenderTarget) framebuffer = properties.get(renderTarget).__webglMultisampledFramebuffer;
            else framebuffer = __webglFramebuffer;
            _currentViewport.copy(renderTarget.viewport);
            _currentScissor.copy(renderTarget.scissor);
            _currentScissorTest = renderTarget.scissorTest;
        } else {
            _currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor();
            _currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor();
            _currentScissorTest = _scissorTest;
        }
        var framebufferBound = state.bindFramebuffer(36160, framebuffer);
        if (framebufferBound && capabilities.drawBuffers) {
            var needsUpdate = false;
            if (renderTarget) {
                if (renderTarget.isWebGLMultipleRenderTargets) {
                    var textures1 = renderTarget.texture;
                    if (_currentDrawBuffers.length !== textures1.length || _currentDrawBuffers[0] !== 36064) {
                        for(var i = 0, il = textures1.length; i < il; i++)_currentDrawBuffers[i] = 36064 + i;
                        _currentDrawBuffers.length = textures1.length;
                        needsUpdate = true;
                    }
                } else if (_currentDrawBuffers.length !== 1 || _currentDrawBuffers[0] !== 36064) {
                    _currentDrawBuffers[0] = 36064;
                    _currentDrawBuffers.length = 1;
                    needsUpdate = true;
                }
            } else if (_currentDrawBuffers.length !== 1 || _currentDrawBuffers[0] !== 1029) {
                _currentDrawBuffers[0] = 1029;
                _currentDrawBuffers.length = 1;
                needsUpdate = true;
            }
            if (needsUpdate) {
                if (capabilities.isWebGL2) _gl.drawBuffers(_currentDrawBuffers);
                else extensions.get('WEBGL_draw_buffers').drawBuffersWEBGL(_currentDrawBuffers);
            }
        }
        state.viewport(_currentViewport);
        state.scissor(_currentScissor);
        state.setScissorTest(_currentScissorTest);
        if (isCube) {
            var textureProperties = properties.get(renderTarget.texture);
            _gl.framebufferTexture2D(36160, 36064, 34069 + activeCubeFace, textureProperties.__webglTexture, activeMipmapLevel);
        } else if (isRenderTarget3D) {
            var textureProperties1 = properties.get(renderTarget.texture);
            var layer = activeCubeFace || 0;
            _gl.framebufferTextureLayer(36160, 36064, textureProperties1.__webglTexture, activeMipmapLevel || 0, layer);
        }
    };
    this.readRenderTargetPixels = function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex) {
        if (!(renderTarget && renderTarget.isWebGLRenderTarget)) {
            console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.');
            return;
        }
        var framebuffer = properties.get(renderTarget).__webglFramebuffer;
        if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined) framebuffer = framebuffer[activeCubeFaceIndex];
        if (framebuffer) {
            state.bindFramebuffer(36160, framebuffer);
            try {
                var texture = renderTarget.texture;
                var textureFormat = texture.format;
                var textureType = texture.type;
                if (textureFormat !== $c702e238df7c5123$export$3f8bb04b555a363c && utils.convert(textureFormat) !== _gl.getParameter(35739)) {
                    console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.');
                    return;
                }
                var halfFloatSupportedByExt = textureType === $c702e238df7c5123$export$2697304443f382bc && (extensions.has('EXT_color_buffer_half_float') || capabilities.isWebGL2 && extensions.has('EXT_color_buffer_float'));
                if (textureType !== $c702e238df7c5123$export$2e8ce08d3f6f5e10 && utils.convert(textureType) !== _gl.getParameter(35738) && // Edge and Chrome Mac < 52 (#9513)
                !(textureType === $c702e238df7c5123$export$f6d331659b644596 && (capabilities.isWebGL2 || extensions.has('OES_texture_float') || extensions.has('WEBGL_color_buffer_float'))) && // Chrome Mac >= 52 and Firefox
                !halfFloatSupportedByExt) {
                    console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.');
                    return;
                }
                if (_gl.checkFramebufferStatus(36160) === 36053) // the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)
                {
                    if (x >= 0 && x <= renderTarget.width - width && y >= 0 && y <= renderTarget.height - height) _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), buffer);
                } else console.error('THREE.WebGLRenderer.readRenderTargetPixels: readPixels from renderTarget failed. Framebuffer not complete.');
            } finally{
                // restore framebuffer of current render target if necessary
                var framebuffer1 = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
                state.bindFramebuffer(36160, framebuffer1);
            }
        }
    };
    this.copyFramebufferToTexture = function(position, texture) {
        var level = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
        var levelScale = Math.pow(2, -level);
        var width = Math.floor(texture.image.width * levelScale);
        var height = Math.floor(texture.image.height * levelScale);
        var glFormat = utils.convert(texture.format);
        if (capabilities.isWebGL2) {
            // Workaround for https://bugs.chromium.org/p/chromium/issues/detail?id=1120100
            // Not needed in Chrome 93+
            if (glFormat === 6407) glFormat = 32849;
            if (glFormat === 6408) glFormat = 32856;
        }
        textures.setTexture2D(texture, 0);
        _gl.copyTexImage2D(3553, level, glFormat, position.x, position.y, width, height, 0);
        state.unbindTexture();
    };
    this.copyTextureToTexture = function(position, srcTexture, dstTexture) {
        var level = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
        var width = srcTexture.image.width;
        var height = srcTexture.image.height;
        var glFormat = utils.convert(dstTexture.format);
        var glType = utils.convert(dstTexture.type);
        textures.setTexture2D(dstTexture, 0);
        // As another texture upload may have changed pixelStorei
        // parameters, make sure they are correct for the dstTexture
        _gl.pixelStorei(37440, dstTexture.flipY);
        _gl.pixelStorei(37441, dstTexture.premultiplyAlpha);
        _gl.pixelStorei(3317, dstTexture.unpackAlignment);
        if (srcTexture.isDataTexture) _gl.texSubImage2D(3553, level, position.x, position.y, width, height, glFormat, glType, srcTexture.image.data);
        else if (srcTexture.isCompressedTexture) _gl.compressedTexSubImage2D(3553, level, position.x, position.y, srcTexture.mipmaps[0].width, srcTexture.mipmaps[0].height, glFormat, srcTexture.mipmaps[0].data);
        else _gl.texSubImage2D(3553, level, position.x, position.y, glFormat, glType, srcTexture.image);
        // Generate mipmaps only when copying level 0
        if (level === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(3553);
        state.unbindTexture();
    };
    this.copyTextureToTexture3D = function(sourceBox, position, srcTexture, dstTexture) {
        var level = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
        if (_this.isWebGL1Renderer) {
            console.warn('THREE.WebGLRenderer.copyTextureToTexture3D: can only be used with WebGL2.');
            return;
        }
        var width = sourceBox.max.x - sourceBox.min.x + 1;
        var height = sourceBox.max.y - sourceBox.min.y + 1;
        var depth = sourceBox.max.z - sourceBox.min.z + 1;
        var glFormat = utils.convert(dstTexture.format);
        var glType = utils.convert(dstTexture.type);
        var glTarget;
        if (dstTexture.isDataTexture3D) {
            textures.setTexture3D(dstTexture, 0);
            glTarget = 32879;
        } else if (dstTexture.isDataTexture2DArray) {
            textures.setTexture2DArray(dstTexture, 0);
            glTarget = 35866;
        } else {
            console.warn('THREE.WebGLRenderer.copyTextureToTexture3D: only supports THREE.DataTexture3D and THREE.DataTexture2DArray.');
            return;
        }
        _gl.pixelStorei(37440, dstTexture.flipY);
        _gl.pixelStorei(37441, dstTexture.premultiplyAlpha);
        _gl.pixelStorei(3317, dstTexture.unpackAlignment);
        var unpackRowLen = _gl.getParameter(3314);
        var unpackImageHeight = _gl.getParameter(32878);
        var unpackSkipPixels = _gl.getParameter(3316);
        var unpackSkipRows = _gl.getParameter(3315);
        var unpackSkipImages = _gl.getParameter(32877);
        var image = srcTexture.isCompressedTexture ? srcTexture.mipmaps[0] : srcTexture.image;
        _gl.pixelStorei(3314, image.width);
        _gl.pixelStorei(32878, image.height);
        _gl.pixelStorei(3316, sourceBox.min.x);
        _gl.pixelStorei(3315, sourceBox.min.y);
        _gl.pixelStorei(32877, sourceBox.min.z);
        if (srcTexture.isDataTexture || srcTexture.isDataTexture3D) _gl.texSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, glType, image.data);
        else if (srcTexture.isCompressedTexture) {
            console.warn('THREE.WebGLRenderer.copyTextureToTexture3D: untested support for compressed srcTexture.');
            _gl.compressedTexSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, image.data);
        } else _gl.texSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, glType, image);
        _gl.pixelStorei(3314, unpackRowLen);
        _gl.pixelStorei(32878, unpackImageHeight);
        _gl.pixelStorei(3316, unpackSkipPixels);
        _gl.pixelStorei(3315, unpackSkipRows);
        _gl.pixelStorei(32877, unpackSkipImages);
        // Generate mipmaps only when copying level 0
        if (level === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(glTarget);
        state.unbindTexture();
    };
    this.initTexture = function(texture) {
        textures.setTexture2D(texture, 0);
        state.unbindTexture();
    };
    this.resetState = function() {
        _currentActiveCubeFace = 0;
        _currentActiveMipmapLevel = 0;
        _currentRenderTarget = null;
        state.reset();
        bindingStates.reset();
    };
    if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
        detail: this
    })); // eslint-disable-line no-undef
}
var $c702e238df7c5123$export$a2f65229194348f9 = /*#__PURE__*/ function(WebGLRenderer) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(WebGL1Renderer, WebGLRenderer);
    function WebGL1Renderer() {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, WebGL1Renderer);
        return (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, WebGL1Renderer, arguments);
    }
    return WebGL1Renderer;
}($c702e238df7c5123$export$f6cc00ef28d7cf97);
$c702e238df7c5123$export$a2f65229194348f9.prototype.isWebGL1Renderer = true;
var $c702e238df7c5123$export$6f1519f023b8d0f6 = /*#__PURE__*/ function() {
    "use strict";
    function FogExp2(color) {
        var density = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0.00025;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, FogExp2);
        this.name = '';
        this.color = new $c702e238df7c5123$export$892596cec99bc70e(color);
        this.density = density;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(FogExp2, [
        {
            key: "clone",
            value: function clone() {
                return new FogExp2(this.color, this.density);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    type: 'FogExp2',
                    color: this.color.getHex(),
                    density: this.density
                };
            }
        }
    ]);
    return FogExp2;
}();
$c702e238df7c5123$export$6f1519f023b8d0f6.prototype.isFogExp2 = true;
var $c702e238df7c5123$export$3c890837b09508d4 = /*#__PURE__*/ function() {
    "use strict";
    function Fog(color) {
        var near = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, far = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1000;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Fog);
        this.name = '';
        this.color = new $c702e238df7c5123$export$892596cec99bc70e(color);
        this.near = near;
        this.far = far;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(Fog, [
        {
            key: "clone",
            value: function clone() {
                return new Fog(this.color, this.near, this.far);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    type: 'Fog',
                    color: this.color.getHex(),
                    near: this.near,
                    far: this.far
                };
            }
        }
    ]);
    return Fog;
}();
$c702e238df7c5123$export$3c890837b09508d4.prototype.isFog = true;
var $c702e238df7c5123$export$38af1803e3442a7f = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(Scene, Object3D);
    function Scene() {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Scene);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, Scene);
        _this.type = 'Scene';
        _this.background = null;
        _this.environment = null;
        _this.fog = null;
        _this.overrideMaterial = null;
        _this.autoUpdate = true; // checked by the renderer
        if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
            detail: _this
        })); // eslint-disable-line no-undef
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(Scene, [
        {
            key: "copy",
            value: function copy(source, recursive) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(Scene.prototype), "copy", this).call(this, source, recursive);
                if (source.background !== null) this.background = source.background.clone();
                if (source.environment !== null) this.environment = source.environment.clone();
                if (source.fog !== null) this.fog = source.fog.clone();
                if (source.overrideMaterial !== null) this.overrideMaterial = source.overrideMaterial.clone();
                this.autoUpdate = source.autoUpdate;
                this.matrixAutoUpdate = source.matrixAutoUpdate;
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON(meta) {
                var data = (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(Scene.prototype), "toJSON", this).call(this, meta);
                if (this.fog !== null) data.object.fog = this.fog.toJSON();
                return data;
            }
        }
    ]);
    return Scene;
}($c702e238df7c5123$export$e4dd07dff30cc924);
$c702e238df7c5123$export$38af1803e3442a7f.prototype.isScene = true;
var $c702e238df7c5123$export$3d5cd879f108f53f = /*#__PURE__*/ function() {
    "use strict";
    function InterleavedBuffer(array, stride) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, InterleavedBuffer);
        this.array = array;
        this.stride = stride;
        this.count = array !== undefined ? array.length / stride : 0;
        this.usage = $c702e238df7c5123$export$763e8360f4d7f77d;
        this.updateRange = {
            offset: 0,
            count: -1
        };
        this.version = 0;
        this.uuid = $c702e238df7c5123$var$generateUUID();
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(InterleavedBuffer, [
        {
            key: "onUploadCallback",
            value: function onUploadCallback() {}
        },
        {
            key: "needsUpdate",
            set: function set(value) {
                if (value === true) this.version++;
            }
        },
        {
            key: "setUsage",
            value: function setUsage(value) {
                this.usage = value;
                return this;
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                this.array = new source.array.constructor(source.array);
                this.count = source.count;
                this.stride = source.stride;
                this.usage = source.usage;
                return this;
            }
        },
        {
            key: "copyAt",
            value: function copyAt(index1, attribute, index2) {
                index1 *= this.stride;
                index2 *= attribute.stride;
                for(var i = 0, l = this.stride; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
                return this;
            }
        },
        {
            key: "set",
            value: function set(value) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                this.array.set(value, offset);
                return this;
            }
        },
        {
            key: "clone",
            value: function clone(data) {
                if (data.arrayBuffers === undefined) data.arrayBuffers = {};
                if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $c702e238df7c5123$var$generateUUID();
                if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer;
                var array = new this.array.constructor(data.arrayBuffers[this.array.buffer._uuid]);
                var ib = new this.constructor(array, this.stride);
                ib.setUsage(this.usage);
                return ib;
            }
        },
        {
            key: "onUpload",
            value: function onUpload(callback) {
                this.onUploadCallback = callback;
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON(data) {
                if (data.arrayBuffers === undefined) data.arrayBuffers = {};
                // generate UUID for array buffer if necessary
                if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $c702e238df7c5123$var$generateUUID();
                if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = Array.prototype.slice.call(new Uint32Array(this.array.buffer));
                //
                return {
                    uuid: this.uuid,
                    buffer: this.array.buffer._uuid,
                    type: this.array.constructor.name,
                    stride: this.stride
                };
            }
        }
    ]);
    return InterleavedBuffer;
}();
$c702e238df7c5123$export$3d5cd879f108f53f.prototype.isInterleavedBuffer = true;
var $c702e238df7c5123$var$_vector$6 = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$export$920b6d07334599c7 = /*#__PURE__*/ function() {
    "use strict";
    function InterleavedBufferAttribute(interleavedBuffer, itemSize, offset) {
        var normalized = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, InterleavedBufferAttribute);
        this.name = '';
        this.data = interleavedBuffer;
        this.itemSize = itemSize;
        this.offset = offset;
        this.normalized = normalized === true;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(InterleavedBufferAttribute, [
        {
            key: "count",
            get: function get() {
                return this.data.count;
            }
        },
        {
            key: "array",
            get: function get() {
                return this.data.array;
            }
        },
        {
            key: "needsUpdate",
            set: function set(value) {
                this.data.needsUpdate = value;
            }
        },
        {
            key: "applyMatrix4",
            value: function applyMatrix4(m) {
                for(var i = 0, l = this.data.count; i < l; i++){
                    $c702e238df7c5123$var$_vector$6.x = this.getX(i);
                    $c702e238df7c5123$var$_vector$6.y = this.getY(i);
                    $c702e238df7c5123$var$_vector$6.z = this.getZ(i);
                    $c702e238df7c5123$var$_vector$6.applyMatrix4(m);
                    this.setXYZ(i, $c702e238df7c5123$var$_vector$6.x, $c702e238df7c5123$var$_vector$6.y, $c702e238df7c5123$var$_vector$6.z);
                }
                return this;
            }
        },
        {
            key: "applyNormalMatrix",
            value: function applyNormalMatrix(m) {
                for(var i = 0, l = this.count; i < l; i++){
                    $c702e238df7c5123$var$_vector$6.x = this.getX(i);
                    $c702e238df7c5123$var$_vector$6.y = this.getY(i);
                    $c702e238df7c5123$var$_vector$6.z = this.getZ(i);
                    $c702e238df7c5123$var$_vector$6.applyNormalMatrix(m);
                    this.setXYZ(i, $c702e238df7c5123$var$_vector$6.x, $c702e238df7c5123$var$_vector$6.y, $c702e238df7c5123$var$_vector$6.z);
                }
                return this;
            }
        },
        {
            key: "transformDirection",
            value: function transformDirection(m) {
                for(var i = 0, l = this.count; i < l; i++){
                    $c702e238df7c5123$var$_vector$6.x = this.getX(i);
                    $c702e238df7c5123$var$_vector$6.y = this.getY(i);
                    $c702e238df7c5123$var$_vector$6.z = this.getZ(i);
                    $c702e238df7c5123$var$_vector$6.transformDirection(m);
                    this.setXYZ(i, $c702e238df7c5123$var$_vector$6.x, $c702e238df7c5123$var$_vector$6.y, $c702e238df7c5123$var$_vector$6.z);
                }
                return this;
            }
        },
        {
            key: "setX",
            value: function setX(index, x) {
                this.data.array[index * this.data.stride + this.offset] = x;
                return this;
            }
        },
        {
            key: "setY",
            value: function setY(index, y) {
                this.data.array[index * this.data.stride + this.offset + 1] = y;
                return this;
            }
        },
        {
            key: "setZ",
            value: function setZ(index, z) {
                this.data.array[index * this.data.stride + this.offset + 2] = z;
                return this;
            }
        },
        {
            key: "setW",
            value: function setW(index, w) {
                this.data.array[index * this.data.stride + this.offset + 3] = w;
                return this;
            }
        },
        {
            key: "getX",
            value: function getX(index) {
                return this.data.array[index * this.data.stride + this.offset];
            }
        },
        {
            key: "getY",
            value: function getY(index) {
                return this.data.array[index * this.data.stride + this.offset + 1];
            }
        },
        {
            key: "getZ",
            value: function getZ(index) {
                return this.data.array[index * this.data.stride + this.offset + 2];
            }
        },
        {
            key: "getW",
            value: function getW(index) {
                return this.data.array[index * this.data.stride + this.offset + 3];
            }
        },
        {
            key: "setXY",
            value: function setXY(index, x, y) {
                index = index * this.data.stride + this.offset;
                this.data.array[index + 0] = x;
                this.data.array[index + 1] = y;
                return this;
            }
        },
        {
            key: "setXYZ",
            value: function setXYZ(index, x, y, z) {
                index = index * this.data.stride + this.offset;
                this.data.array[index + 0] = x;
                this.data.array[index + 1] = y;
                this.data.array[index + 2] = z;
                return this;
            }
        },
        {
            key: "setXYZW",
            value: function setXYZW(index, x, y, z, w) {
                index = index * this.data.stride + this.offset;
                this.data.array[index + 0] = x;
                this.data.array[index + 1] = y;
                this.data.array[index + 2] = z;
                this.data.array[index + 3] = w;
                return this;
            }
        },
        {
            key: "clone",
            value: function clone(data) {
                if (data === undefined) {
                    console.log('THREE.InterleavedBufferAttribute.clone(): Cloning an interlaved buffer attribute will deinterleave buffer data.');
                    var array = [];
                    for(var i = 0; i < this.count; i++){
                        var index = i * this.data.stride + this.offset;
                        for(var j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
                    }
                    return new $c702e238df7c5123$export$8dea267bd6bde117(new this.array.constructor(array), this.itemSize, this.normalized);
                } else {
                    if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
                    if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.clone(data);
                    return new InterleavedBufferAttribute(data.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
                }
            }
        },
        {
            key: "toJSON",
            value: function toJSON(data) {
                if (data === undefined) {
                    console.log('THREE.InterleavedBufferAttribute.toJSON(): Serializing an interlaved buffer attribute will deinterleave buffer data.');
                    var array = [];
                    for(var i = 0; i < this.count; i++){
                        var index = i * this.data.stride + this.offset;
                        for(var j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
                    }
                    // deinterleave data and save it as an ordinary buffer attribute for now
                    return {
                        itemSize: this.itemSize,
                        type: this.array.constructor.name,
                        array: array,
                        normalized: this.normalized
                    };
                } else {
                    // save as true interlaved attribtue
                    if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
                    if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.toJSON(data);
                    return {
                        isInterleavedBufferAttribute: true,
                        itemSize: this.itemSize,
                        data: this.data.uuid,
                        offset: this.offset,
                        normalized: this.normalized
                    };
                }
            }
        }
    ]);
    return InterleavedBufferAttribute;
}();
$c702e238df7c5123$export$920b6d07334599c7.prototype.isInterleavedBufferAttribute = true;
/**
 * parameters = {
 *  color: <hex>,
 *  map: new THREE.Texture( <Image> ),
 *  alphaMap: new THREE.Texture( <Image> ),
 *  rotation: <float>,
 *  sizeAttenuation: <bool>
 * }
 */ var $c702e238df7c5123$export$5ec7dd1c6994bf8e = /*#__PURE__*/ function(Material) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(SpriteMaterial, Material);
    function SpriteMaterial(parameters) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, SpriteMaterial);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, SpriteMaterial);
        _this.type = 'SpriteMaterial';
        _this.color = new $c702e238df7c5123$export$892596cec99bc70e(0xffffff);
        _this.map = null;
        _this.alphaMap = null;
        _this.rotation = 0;
        _this.sizeAttenuation = true;
        _this.transparent = true;
        _this.setValues(parameters);
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(SpriteMaterial, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(SpriteMaterial.prototype), "copy", this).call(this, source);
                this.color.copy(source.color);
                this.map = source.map;
                this.alphaMap = source.alphaMap;
                this.rotation = source.rotation;
                this.sizeAttenuation = source.sizeAttenuation;
                return this;
            }
        }
    ]);
    return SpriteMaterial;
}($c702e238df7c5123$export$a2d8b23205c25948);
$c702e238df7c5123$export$5ec7dd1c6994bf8e.prototype.isSpriteMaterial = true;
var $c702e238df7c5123$var$_geometry;
var $c702e238df7c5123$var$_intersectPoint = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_worldScale = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_mvPosition = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_alignedPosition = /*@__PURE__*/ new $c702e238df7c5123$export$c977b3e384af9ae1();
var $c702e238df7c5123$var$_rotatedPosition = /*@__PURE__*/ new $c702e238df7c5123$export$c977b3e384af9ae1();
var $c702e238df7c5123$var$_viewWorldMatrix = /*@__PURE__*/ new $c702e238df7c5123$export$2ae72fc923e5eb5();
var $c702e238df7c5123$var$_vA = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_vB = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_vC = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_uvA = /*@__PURE__*/ new $c702e238df7c5123$export$c977b3e384af9ae1();
var $c702e238df7c5123$var$_uvB = /*@__PURE__*/ new $c702e238df7c5123$export$c977b3e384af9ae1();
var $c702e238df7c5123$var$_uvC = /*@__PURE__*/ new $c702e238df7c5123$export$c977b3e384af9ae1();
var $c702e238df7c5123$export$3075603db8e6204c = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(Sprite, Object3D);
    function Sprite(material) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Sprite);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, Sprite);
        _this.type = 'Sprite';
        if ($c702e238df7c5123$var$_geometry === undefined) {
            $c702e238df7c5123$var$_geometry = new $c702e238df7c5123$export$b7be63a67df8959();
            var float32Array = new Float32Array([
                -0.5,
                -0.5,
                0,
                0,
                0,
                0.5,
                -0.5,
                0,
                1,
                0,
                0.5,
                0.5,
                0,
                1,
                1,
                -0.5,
                0.5,
                0,
                0,
                1
            ]);
            var interleavedBuffer = new $c702e238df7c5123$export$3d5cd879f108f53f(float32Array, 5);
            $c702e238df7c5123$var$_geometry.setIndex([
                0,
                1,
                2,
                0,
                2,
                3
            ]);
            $c702e238df7c5123$var$_geometry.setAttribute('position', new $c702e238df7c5123$export$920b6d07334599c7(interleavedBuffer, 3, 0, false));
            $c702e238df7c5123$var$_geometry.setAttribute('uv', new $c702e238df7c5123$export$920b6d07334599c7(interleavedBuffer, 2, 3, false));
        }
        _this.geometry = $c702e238df7c5123$var$_geometry;
        _this.material = material !== undefined ? material : new $c702e238df7c5123$export$5ec7dd1c6994bf8e();
        _this.center = new $c702e238df7c5123$export$c977b3e384af9ae1(0.5, 0.5);
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(Sprite, [
        {
            key: "raycast",
            value: function raycast(raycaster, intersects) {
                if (raycaster.camera === null) console.error('THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.');
                $c702e238df7c5123$var$_worldScale.setFromMatrixScale(this.matrixWorld);
                $c702e238df7c5123$var$_viewWorldMatrix.copy(raycaster.camera.matrixWorld);
                this.modelViewMatrix.multiplyMatrices(raycaster.camera.matrixWorldInverse, this.matrixWorld);
                $c702e238df7c5123$var$_mvPosition.setFromMatrixPosition(this.modelViewMatrix);
                if (raycaster.camera.isPerspectiveCamera && this.material.sizeAttenuation === false) $c702e238df7c5123$var$_worldScale.multiplyScalar(-$c702e238df7c5123$var$_mvPosition.z);
                var rotation = this.material.rotation;
                var sin, cos;
                if (rotation !== 0) {
                    cos = Math.cos(rotation);
                    sin = Math.sin(rotation);
                }
                var center = this.center;
                $c702e238df7c5123$var$transformVertex($c702e238df7c5123$var$_vA.set(-0.5, -0.5, 0), $c702e238df7c5123$var$_mvPosition, center, $c702e238df7c5123$var$_worldScale, sin, cos);
                $c702e238df7c5123$var$transformVertex($c702e238df7c5123$var$_vB.set(0.5, -0.5, 0), $c702e238df7c5123$var$_mvPosition, center, $c702e238df7c5123$var$_worldScale, sin, cos);
                $c702e238df7c5123$var$transformVertex($c702e238df7c5123$var$_vC.set(0.5, 0.5, 0), $c702e238df7c5123$var$_mvPosition, center, $c702e238df7c5123$var$_worldScale, sin, cos);
                $c702e238df7c5123$var$_uvA.set(0, 0);
                $c702e238df7c5123$var$_uvB.set(1, 0);
                $c702e238df7c5123$var$_uvC.set(1, 1);
                // check first triangle
                var intersect = raycaster.ray.intersectTriangle($c702e238df7c5123$var$_vA, $c702e238df7c5123$var$_vB, $c702e238df7c5123$var$_vC, false, $c702e238df7c5123$var$_intersectPoint);
                if (intersect === null) {
                    // check second triangle
                    $c702e238df7c5123$var$transformVertex($c702e238df7c5123$var$_vB.set(-0.5, 0.5, 0), $c702e238df7c5123$var$_mvPosition, center, $c702e238df7c5123$var$_worldScale, sin, cos);
                    $c702e238df7c5123$var$_uvB.set(0, 1);
                    intersect = raycaster.ray.intersectTriangle($c702e238df7c5123$var$_vA, $c702e238df7c5123$var$_vC, $c702e238df7c5123$var$_vB, false, $c702e238df7c5123$var$_intersectPoint);
                    if (intersect === null) return;
                }
                var distance = raycaster.ray.origin.distanceTo($c702e238df7c5123$var$_intersectPoint);
                if (distance < raycaster.near || distance > raycaster.far) return;
                intersects.push({
                    distance: distance,
                    point: $c702e238df7c5123$var$_intersectPoint.clone(),
                    uv: $c702e238df7c5123$export$5a465592bfe74b48.getUV($c702e238df7c5123$var$_intersectPoint, $c702e238df7c5123$var$_vA, $c702e238df7c5123$var$_vB, $c702e238df7c5123$var$_vC, $c702e238df7c5123$var$_uvA, $c702e238df7c5123$var$_uvB, $c702e238df7c5123$var$_uvC, new $c702e238df7c5123$export$c977b3e384af9ae1()),
                    face: null,
                    object: this
                });
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(Sprite.prototype), "copy", this).call(this, source);
                if (source.center !== undefined) this.center.copy(source.center);
                this.material = source.material;
                return this;
            }
        }
    ]);
    return Sprite;
}($c702e238df7c5123$export$e4dd07dff30cc924);
$c702e238df7c5123$export$3075603db8e6204c.prototype.isSprite = true;
function $c702e238df7c5123$var$transformVertex(vertexPosition, mvPosition, center, scale, sin, cos) {
    // compute position in camera space
    $c702e238df7c5123$var$_alignedPosition.subVectors(vertexPosition, center).addScalar(0.5).multiply(scale);
    // to check if rotation is not zero
    if (sin !== undefined) {
        $c702e238df7c5123$var$_rotatedPosition.x = cos * $c702e238df7c5123$var$_alignedPosition.x - sin * $c702e238df7c5123$var$_alignedPosition.y;
        $c702e238df7c5123$var$_rotatedPosition.y = sin * $c702e238df7c5123$var$_alignedPosition.x + cos * $c702e238df7c5123$var$_alignedPosition.y;
    } else $c702e238df7c5123$var$_rotatedPosition.copy($c702e238df7c5123$var$_alignedPosition);
    vertexPosition.copy(mvPosition);
    vertexPosition.x += $c702e238df7c5123$var$_rotatedPosition.x;
    vertexPosition.y += $c702e238df7c5123$var$_rotatedPosition.y;
    // transform to world space
    vertexPosition.applyMatrix4($c702e238df7c5123$var$_viewWorldMatrix);
}
var $c702e238df7c5123$var$_v1$2 = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_v2$1 = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$export$112e7237be0c5f30 = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(LOD, Object3D);
    function LOD() {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, LOD);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, LOD);
        _this._currentLevel = 0;
        _this.type = 'LOD';
        Object.defineProperties(_this, {
            levels: {
                enumerable: true,
                value: []
            },
            isLOD: {
                value: true
            }
        });
        _this.autoUpdate = true;
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(LOD, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(LOD.prototype), "copy", this).call(this, source, false);
                var levels = source.levels;
                for(var i = 0, l = levels.length; i < l; i++){
                    var level = levels[i];
                    this.addLevel(level.object.clone(), level.distance);
                }
                this.autoUpdate = source.autoUpdate;
                return this;
            }
        },
        {
            key: "addLevel",
            value: function addLevel(object) {
                var distance = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                distance = Math.abs(distance);
                var levels = this.levels;
                var l;
                for(l = 0; l < levels.length; l++){
                    if (distance < levels[l].distance) break;
                }
                levels.splice(l, 0, {
                    distance: distance,
                    object: object
                });
                this.add(object);
                return this;
            }
        },
        {
            key: "getCurrentLevel",
            value: function getCurrentLevel() {
                return this._currentLevel;
            }
        },
        {
            key: "getObjectForDistance",
            value: function getObjectForDistance(distance) {
                var levels = this.levels;
                if (levels.length > 0) {
                    var i, l;
                    for(i = 1, l = levels.length; i < l; i++){
                        if (distance < levels[i].distance) break;
                    }
                    return levels[i - 1].object;
                }
                return null;
            }
        },
        {
            key: "raycast",
            value: function raycast(raycaster, intersects) {
                var levels = this.levels;
                if (levels.length > 0) {
                    $c702e238df7c5123$var$_v1$2.setFromMatrixPosition(this.matrixWorld);
                    var distance = raycaster.ray.origin.distanceTo($c702e238df7c5123$var$_v1$2);
                    this.getObjectForDistance(distance).raycast(raycaster, intersects);
                }
            }
        },
        {
            key: "update",
            value: function update(camera) {
                var levels = this.levels;
                if (levels.length > 1) {
                    $c702e238df7c5123$var$_v1$2.setFromMatrixPosition(camera.matrixWorld);
                    $c702e238df7c5123$var$_v2$1.setFromMatrixPosition(this.matrixWorld);
                    var distance = $c702e238df7c5123$var$_v1$2.distanceTo($c702e238df7c5123$var$_v2$1) / camera.zoom;
                    levels[0].object.visible = true;
                    var i, l;
                    for(i = 1, l = levels.length; i < l; i++){
                        if (distance >= levels[i].distance) {
                            levels[i - 1].object.visible = false;
                            levels[i].object.visible = true;
                        } else break;
                    }
                    this._currentLevel = i - 1;
                    for(; i < l; i++)levels[i].object.visible = false;
                }
            }
        },
        {
            key: "toJSON",
            value: function toJSON(meta) {
                var data = (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(LOD.prototype), "toJSON", this).call(this, meta);
                if (this.autoUpdate === false) data.object.autoUpdate = false;
                data.object.levels = [];
                var levels = this.levels;
                for(var i = 0, l = levels.length; i < l; i++){
                    var level = levels[i];
                    data.object.levels.push({
                        object: level.object.uuid,
                        distance: level.distance
                    });
                }
                return data;
            }
        }
    ]);
    return LOD;
}($c702e238df7c5123$export$e4dd07dff30cc924);
var $c702e238df7c5123$var$_basePosition = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_skinIndex = /*@__PURE__*/ new $c702e238df7c5123$export$fa7daccca11cdbe3();
var $c702e238df7c5123$var$_skinWeight = /*@__PURE__*/ new $c702e238df7c5123$export$fa7daccca11cdbe3();
var $c702e238df7c5123$var$_vector$5 = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_matrix = /*@__PURE__*/ new $c702e238df7c5123$export$2ae72fc923e5eb5();
var $c702e238df7c5123$export$b303577035157ecf = /*#__PURE__*/ function(Mesh) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(SkinnedMesh, Mesh);
    function SkinnedMesh(geometry, material) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, SkinnedMesh);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, SkinnedMesh, [
            geometry,
            material
        ]);
        _this.type = 'SkinnedMesh';
        _this.bindMode = 'attached';
        _this.bindMatrix = new $c702e238df7c5123$export$2ae72fc923e5eb5();
        _this.bindMatrixInverse = new $c702e238df7c5123$export$2ae72fc923e5eb5();
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(SkinnedMesh, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(SkinnedMesh.prototype), "copy", this).call(this, source);
                this.bindMode = source.bindMode;
                this.bindMatrix.copy(source.bindMatrix);
                this.bindMatrixInverse.copy(source.bindMatrixInverse);
                this.skeleton = source.skeleton;
                return this;
            }
        },
        {
            key: "bind",
            value: function bind(skeleton, bindMatrix) {
                this.skeleton = skeleton;
                if (bindMatrix === undefined) {
                    this.updateMatrixWorld(true);
                    this.skeleton.calculateInverses();
                    bindMatrix = this.matrixWorld;
                }
                this.bindMatrix.copy(bindMatrix);
                this.bindMatrixInverse.copy(bindMatrix).invert();
            }
        },
        {
            key: "pose",
            value: function pose() {
                this.skeleton.pose();
            }
        },
        {
            key: "normalizeSkinWeights",
            value: function normalizeSkinWeights() {
                var vector = new $c702e238df7c5123$export$fa7daccca11cdbe3();
                var skinWeight = this.geometry.attributes.skinWeight;
                for(var i = 0, l = skinWeight.count; i < l; i++){
                    vector.x = skinWeight.getX(i);
                    vector.y = skinWeight.getY(i);
                    vector.z = skinWeight.getZ(i);
                    vector.w = skinWeight.getW(i);
                    var scale = 1.0 / vector.manhattanLength();
                    if (scale !== Infinity) vector.multiplyScalar(scale);
                    else vector.set(1, 0, 0, 0); // do something reasonable
                    skinWeight.setXYZW(i, vector.x, vector.y, vector.z, vector.w);
                }
            }
        },
        {
            key: "updateMatrixWorld",
            value: function updateMatrixWorld(force) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(SkinnedMesh.prototype), "updateMatrixWorld", this).call(this, force);
                if (this.bindMode === 'attached') this.bindMatrixInverse.copy(this.matrixWorld).invert();
                else if (this.bindMode === 'detached') this.bindMatrixInverse.copy(this.bindMatrix).invert();
                else console.warn('THREE.SkinnedMesh: Unrecognized bindMode: ' + this.bindMode);
            }
        },
        {
            key: "boneTransform",
            value: function boneTransform(index, target) {
                var skeleton = this.skeleton;
                var geometry = this.geometry;
                $c702e238df7c5123$var$_skinIndex.fromBufferAttribute(geometry.attributes.skinIndex, index);
                $c702e238df7c5123$var$_skinWeight.fromBufferAttribute(geometry.attributes.skinWeight, index);
                $c702e238df7c5123$var$_basePosition.fromBufferAttribute(geometry.attributes.position, index).applyMatrix4(this.bindMatrix);
                target.set(0, 0, 0);
                for(var i = 0; i < 4; i++){
                    var weight = $c702e238df7c5123$var$_skinWeight.getComponent(i);
                    if (weight !== 0) {
                        var boneIndex = $c702e238df7c5123$var$_skinIndex.getComponent(i);
                        $c702e238df7c5123$var$_matrix.multiplyMatrices(skeleton.bones[boneIndex].matrixWorld, skeleton.boneInverses[boneIndex]);
                        target.addScaledVector($c702e238df7c5123$var$_vector$5.copy($c702e238df7c5123$var$_basePosition).applyMatrix4($c702e238df7c5123$var$_matrix), weight);
                    }
                }
                return target.applyMatrix4(this.bindMatrixInverse);
            }
        }
    ]);
    return SkinnedMesh;
}($c702e238df7c5123$export$e176487c05830cc5);
$c702e238df7c5123$export$b303577035157ecf.prototype.isSkinnedMesh = true;
var $c702e238df7c5123$export$b127726e56765aa4 = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(Bone, Object3D);
    function Bone() {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Bone);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, Bone);
        _this.type = 'Bone';
        return _this;
    }
    return Bone;
}($c702e238df7c5123$export$e4dd07dff30cc924);
$c702e238df7c5123$export$b127726e56765aa4.prototype.isBone = true;
var $c702e238df7c5123$export$b691f601014eabe1 = /*#__PURE__*/ function(Texture) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(DataTexture, Texture);
    function DataTexture() {
        var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, width = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, height = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, format = arguments.length > 3 ? arguments[3] : void 0, type = arguments.length > 4 ? arguments[4] : void 0, mapping = arguments.length > 5 ? arguments[5] : void 0, wrapS = arguments.length > 6 ? arguments[6] : void 0, wrapT = arguments.length > 7 ? arguments[7] : void 0, magFilter = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : $c702e238df7c5123$export$727aa5ec3fe39bf0, minFilter = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : $c702e238df7c5123$export$727aa5ec3fe39bf0, anisotropy = arguments.length > 10 ? arguments[10] : void 0, encoding = arguments.length > 11 ? arguments[11] : void 0;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, DataTexture);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, DataTexture, [
            null,
            mapping,
            wrapS,
            wrapT,
            magFilter,
            minFilter,
            format,
            type,
            anisotropy,
            encoding
        ]);
        _this.image = {
            data: data,
            width: width,
            height: height
        };
        _this.magFilter = magFilter;
        _this.minFilter = minFilter;
        _this.generateMipmaps = false;
        _this.flipY = false;
        _this.unpackAlignment = 1;
        _this.needsUpdate = true;
        return _this;
    }
    return DataTexture;
}($c702e238df7c5123$export$5431306cf43de24a);
$c702e238df7c5123$export$b691f601014eabe1.prototype.isDataTexture = true;
var $c702e238df7c5123$var$_offsetMatrix = /*@__PURE__*/ new $c702e238df7c5123$export$2ae72fc923e5eb5();
var $c702e238df7c5123$var$_identityMatrix = /*@__PURE__*/ new $c702e238df7c5123$export$2ae72fc923e5eb5();
var $c702e238df7c5123$export$8f31e4c4a37b8e9c = /*#__PURE__*/ function() {
    "use strict";
    function Skeleton() {
        var bones = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], boneInverses = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Skeleton);
        this.uuid = $c702e238df7c5123$var$generateUUID();
        this.bones = bones.slice(0);
        this.boneInverses = boneInverses;
        this.boneMatrices = null;
        this.boneTexture = null;
        this.boneTextureSize = 0;
        this.frame = -1;
        this.init();
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(Skeleton, [
        {
            key: "init",
            value: function init() {
                var bones = this.bones;
                var boneInverses = this.boneInverses;
                this.boneMatrices = new Float32Array(bones.length * 16);
                // calculate inverse bone matrices if necessary
                if (boneInverses.length === 0) this.calculateInverses();
                else // handle special case
                if (bones.length !== boneInverses.length) {
                    console.warn('THREE.Skeleton: Number of inverse bone matrices does not match amount of bones.');
                    this.boneInverses = [];
                    for(var i = 0, il = this.bones.length; i < il; i++)this.boneInverses.push(new $c702e238df7c5123$export$2ae72fc923e5eb5());
                }
            }
        },
        {
            key: "calculateInverses",
            value: function calculateInverses() {
                this.boneInverses.length = 0;
                for(var i = 0, il = this.bones.length; i < il; i++){
                    var inverse = new $c702e238df7c5123$export$2ae72fc923e5eb5();
                    if (this.bones[i]) inverse.copy(this.bones[i].matrixWorld).invert();
                    this.boneInverses.push(inverse);
                }
            }
        },
        {
            key: "pose",
            value: function pose() {
                // recover the bind-time world matrices
                for(var i = 0, il = this.bones.length; i < il; i++){
                    var bone = this.bones[i];
                    if (bone) bone.matrixWorld.copy(this.boneInverses[i]).invert();
                }
                // compute the local matrices, positions, rotations and scales
                for(var i1 = 0, il1 = this.bones.length; i1 < il1; i1++){
                    var bone1 = this.bones[i1];
                    if (bone1) {
                        if (bone1.parent && bone1.parent.isBone) {
                            bone1.matrix.copy(bone1.parent.matrixWorld).invert();
                            bone1.matrix.multiply(bone1.matrixWorld);
                        } else bone1.matrix.copy(bone1.matrixWorld);
                        bone1.matrix.decompose(bone1.position, bone1.quaternion, bone1.scale);
                    }
                }
            }
        },
        {
            key: "update",
            value: function update() {
                var bones = this.bones;
                var boneInverses = this.boneInverses;
                var boneMatrices = this.boneMatrices;
                var boneTexture = this.boneTexture;
                // flatten bone matrices to array
                for(var i = 0, il = bones.length; i < il; i++){
                    // compute the offset between the current and the original transform
                    var matrix = bones[i] ? bones[i].matrixWorld : $c702e238df7c5123$var$_identityMatrix;
                    $c702e238df7c5123$var$_offsetMatrix.multiplyMatrices(matrix, boneInverses[i]);
                    $c702e238df7c5123$var$_offsetMatrix.toArray(boneMatrices, i * 16);
                }
                if (boneTexture !== null) boneTexture.needsUpdate = true;
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new Skeleton(this.bones, this.boneInverses);
            }
        },
        {
            key: "computeBoneTexture",
            value: function computeBoneTexture() {
                // layout (1 matrix = 4 pixels)
                //      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
                //  with  8x8  pixel texture max   16 bones * 4 pixels =  (8 * 8)
                //       16x16 pixel texture max   64 bones * 4 pixels = (16 * 16)
                //       32x32 pixel texture max  256 bones * 4 pixels = (32 * 32)
                //       64x64 pixel texture max 1024 bones * 4 pixels = (64 * 64)
                var size = Math.sqrt(this.bones.length * 4); // 4 pixels needed for 1 matrix
                size = $c702e238df7c5123$var$ceilPowerOfTwo(size);
                size = Math.max(size, 4);
                var boneMatrices = new Float32Array(size * size * 4); // 4 floats per RGBA pixel
                boneMatrices.set(this.boneMatrices); // copy current values
                var boneTexture = new $c702e238df7c5123$export$b691f601014eabe1(boneMatrices, size, size, $c702e238df7c5123$export$3f8bb04b555a363c, $c702e238df7c5123$export$f6d331659b644596);
                this.boneMatrices = boneMatrices;
                this.boneTexture = boneTexture;
                this.boneTextureSize = size;
                return this;
            }
        },
        {
            key: "getBoneByName",
            value: function getBoneByName(name) {
                for(var i = 0, il = this.bones.length; i < il; i++){
                    var bone = this.bones[i];
                    if (bone.name === name) return bone;
                }
                return undefined;
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                if (this.boneTexture !== null) {
                    this.boneTexture.dispose();
                    this.boneTexture = null;
                }
            }
        },
        {
            key: "fromJSON",
            value: function fromJSON(json, bones) {
                this.uuid = json.uuid;
                for(var i = 0, l = json.bones.length; i < l; i++){
                    var uuid = json.bones[i];
                    var bone = bones[uuid];
                    if (bone === undefined) {
                        console.warn('THREE.Skeleton: No bone found with UUID:', uuid);
                        bone = new $c702e238df7c5123$export$b127726e56765aa4();
                    }
                    this.bones.push(bone);
                    this.boneInverses.push(new $c702e238df7c5123$export$2ae72fc923e5eb5().fromArray(json.boneInverses[i]));
                }
                this.init();
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = {
                    metadata: {
                        version: 4.5,
                        type: 'Skeleton',
                        generator: 'Skeleton.toJSON'
                    },
                    bones: [],
                    boneInverses: []
                };
                data.uuid = this.uuid;
                var bones = this.bones;
                var boneInverses = this.boneInverses;
                for(var i = 0, l = bones.length; i < l; i++){
                    var bone = bones[i];
                    data.bones.push(bone.uuid);
                    var boneInverse = boneInverses[i];
                    data.boneInverses.push(boneInverse.toArray());
                }
                return data;
            }
        }
    ]);
    return Skeleton;
}();
var $c702e238df7c5123$var$_instanceLocalMatrix = /*@__PURE__*/ new $c702e238df7c5123$export$2ae72fc923e5eb5();
var $c702e238df7c5123$var$_instanceWorldMatrix = /*@__PURE__*/ new $c702e238df7c5123$export$2ae72fc923e5eb5();
var $c702e238df7c5123$var$_instanceIntersects = [];
var $c702e238df7c5123$var$_mesh = /*@__PURE__*/ new $c702e238df7c5123$export$e176487c05830cc5();
var $c702e238df7c5123$export$f3c979c331175ad7 = /*#__PURE__*/ function(Mesh) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(InstancedMesh, Mesh);
    function InstancedMesh(geometry, material, count) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, InstancedMesh);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, InstancedMesh, [
            geometry,
            material
        ]);
        _this.instanceMatrix = new $c702e238df7c5123$export$8dea267bd6bde117(new Float32Array(count * 16), 16);
        _this.instanceColor = null;
        _this.count = count;
        _this.frustumCulled = false;
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(InstancedMesh, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(InstancedMesh.prototype), "copy", this).call(this, source);
                this.instanceMatrix.copy(source.instanceMatrix);
                if (source.instanceColor !== null) this.instanceColor = source.instanceColor.clone();
                this.count = source.count;
                return this;
            }
        },
        {
            key: "getColorAt",
            value: function getColorAt(index, color) {
                color.fromArray(this.instanceColor.array, index * 3);
            }
        },
        {
            key: "getMatrixAt",
            value: function getMatrixAt(index, matrix) {
                matrix.fromArray(this.instanceMatrix.array, index * 16);
            }
        },
        {
            key: "raycast",
            value: function raycast(raycaster, intersects) {
                var matrixWorld = this.matrixWorld;
                var raycastTimes = this.count;
                $c702e238df7c5123$var$_mesh.geometry = this.geometry;
                $c702e238df7c5123$var$_mesh.material = this.material;
                if ($c702e238df7c5123$var$_mesh.material === undefined) return;
                for(var instanceId = 0; instanceId < raycastTimes; instanceId++){
                    // calculate the world matrix for each instance
                    this.getMatrixAt(instanceId, $c702e238df7c5123$var$_instanceLocalMatrix);
                    $c702e238df7c5123$var$_instanceWorldMatrix.multiplyMatrices(matrixWorld, $c702e238df7c5123$var$_instanceLocalMatrix);
                    // the mesh represents this single instance
                    $c702e238df7c5123$var$_mesh.matrixWorld = $c702e238df7c5123$var$_instanceWorldMatrix;
                    $c702e238df7c5123$var$_mesh.raycast(raycaster, $c702e238df7c5123$var$_instanceIntersects);
                    // process the result of raycast
                    for(var i = 0, l = $c702e238df7c5123$var$_instanceIntersects.length; i < l; i++){
                        var intersect = $c702e238df7c5123$var$_instanceIntersects[i];
                        intersect.instanceId = instanceId;
                        intersect.object = this;
                        intersects.push(intersect);
                    }
                    $c702e238df7c5123$var$_instanceIntersects.length = 0;
                }
            }
        },
        {
            key: "setColorAt",
            value: function setColorAt(index, color) {
                if (this.instanceColor === null) this.instanceColor = new $c702e238df7c5123$export$8dea267bd6bde117(new Float32Array(this.count * 3), 3);
                color.toArray(this.instanceColor.array, index * 3);
            }
        },
        {
            key: "setMatrixAt",
            value: function setMatrixAt(index, matrix) {
                matrix.toArray(this.instanceMatrix.array, index * 16);
            }
        },
        {
            key: "updateMorphTargets",
            value: function updateMorphTargets() {}
        },
        {
            key: "dispose",
            value: function dispose() {
                this.dispatchEvent({
                    type: 'dispose'
                });
            }
        }
    ]);
    return InstancedMesh;
}($c702e238df7c5123$export$e176487c05830cc5);
$c702e238df7c5123$export$f3c979c331175ad7.prototype.isInstancedMesh = true;
/**
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *
 *  linewidth: <float>,
 *  linecap: "round",
 *  linejoin: "round"
 * }
 */ var $c702e238df7c5123$export$fbaaa33907730a0c = /*#__PURE__*/ function(Material) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(LineBasicMaterial, Material);
    function LineBasicMaterial(parameters) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, LineBasicMaterial);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, LineBasicMaterial);
        _this.type = 'LineBasicMaterial';
        _this.color = new $c702e238df7c5123$export$892596cec99bc70e(0xffffff);
        _this.linewidth = 1;
        _this.linecap = 'round';
        _this.linejoin = 'round';
        _this.morphTargets = false;
        _this.setValues(parameters);
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(LineBasicMaterial, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(LineBasicMaterial.prototype), "copy", this).call(this, source);
                this.color.copy(source.color);
                this.linewidth = source.linewidth;
                this.linecap = source.linecap;
                this.linejoin = source.linejoin;
                this.morphTargets = source.morphTargets;
                return this;
            }
        }
    ]);
    return LineBasicMaterial;
}($c702e238df7c5123$export$a2d8b23205c25948);
$c702e238df7c5123$export$fbaaa33907730a0c.prototype.isLineBasicMaterial = true;
var $c702e238df7c5123$var$_start$1 = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_end$1 = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_inverseMatrix$1 = /*@__PURE__*/ new $c702e238df7c5123$export$2ae72fc923e5eb5();
var $c702e238df7c5123$var$_ray$1 = /*@__PURE__*/ new $c702e238df7c5123$export$a186db52eed6d40e();
var $c702e238df7c5123$var$_sphere$1 = /*@__PURE__*/ new $c702e238df7c5123$export$805e8b72413ccaba();
var $c702e238df7c5123$export$17d680238e50603e = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(Line, Object3D);
    function Line() {
        var geometry = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $c702e238df7c5123$export$b7be63a67df8959(), material = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $c702e238df7c5123$export$fbaaa33907730a0c();
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Line);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, Line);
        _this.type = 'Line';
        _this.geometry = geometry;
        _this.material = material;
        _this.updateMorphTargets();
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(Line, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(Line.prototype), "copy", this).call(this, source);
                this.material = source.material;
                this.geometry = source.geometry;
                return this;
            }
        },
        {
            key: "computeLineDistances",
            value: function computeLineDistances() {
                var geometry = this.geometry;
                if (geometry.isBufferGeometry) {
                    // we assume non-indexed geometry
                    if (geometry.index === null) {
                        var positionAttribute = geometry.attributes.position;
                        var lineDistances = [
                            0
                        ];
                        for(var i = 1, l = positionAttribute.count; i < l; i++){
                            $c702e238df7c5123$var$_start$1.fromBufferAttribute(positionAttribute, i - 1);
                            $c702e238df7c5123$var$_end$1.fromBufferAttribute(positionAttribute, i);
                            lineDistances[i] = lineDistances[i - 1];
                            lineDistances[i] += $c702e238df7c5123$var$_start$1.distanceTo($c702e238df7c5123$var$_end$1);
                        }
                        geometry.setAttribute('lineDistance', new $c702e238df7c5123$export$cbe7a62641830ebd(lineDistances, 1));
                    } else console.warn('THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.');
                } else if (geometry.isGeometry) console.error('THREE.Line.computeLineDistances() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.');
                return this;
            }
        },
        {
            key: "raycast",
            value: function raycast(raycaster, intersects) {
                var geometry = this.geometry;
                var matrixWorld = this.matrixWorld;
                var threshold = raycaster.params.Line.threshold;
                var drawRange = geometry.drawRange;
                // Checking boundingSphere distance to ray
                if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
                $c702e238df7c5123$var$_sphere$1.copy(geometry.boundingSphere);
                $c702e238df7c5123$var$_sphere$1.applyMatrix4(matrixWorld);
                $c702e238df7c5123$var$_sphere$1.radius += threshold;
                if (raycaster.ray.intersectsSphere($c702e238df7c5123$var$_sphere$1) === false) return;
                //
                $c702e238df7c5123$var$_inverseMatrix$1.copy(matrixWorld).invert();
                $c702e238df7c5123$var$_ray$1.copy(raycaster.ray).applyMatrix4($c702e238df7c5123$var$_inverseMatrix$1);
                var localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
                var localThresholdSq = localThreshold * localThreshold;
                var vStart = new $c702e238df7c5123$export$64b5c384219d3699();
                var vEnd = new $c702e238df7c5123$export$64b5c384219d3699();
                var interSegment = new $c702e238df7c5123$export$64b5c384219d3699();
                var interRay = new $c702e238df7c5123$export$64b5c384219d3699();
                var step = this.isLineSegments ? 2 : 1;
                if (geometry.isBufferGeometry) {
                    var index = geometry.index;
                    var attributes = geometry.attributes;
                    var positionAttribute = attributes.position;
                    if (index !== null) {
                        var start = Math.max(0, drawRange.start);
                        var end = Math.min(index.count, drawRange.start + drawRange.count);
                        for(var i = start, l = end - 1; i < l; i += step){
                            var a = index.getX(i);
                            var b = index.getX(i + 1);
                            vStart.fromBufferAttribute(positionAttribute, a);
                            vEnd.fromBufferAttribute(positionAttribute, b);
                            var distSq = $c702e238df7c5123$var$_ray$1.distanceSqToSegment(vStart, vEnd, interRay, interSegment);
                            if (distSq > localThresholdSq) continue;
                            interRay.applyMatrix4(this.matrixWorld); //Move back to world space for distance calculation
                            var distance = raycaster.ray.origin.distanceTo(interRay);
                            if (distance < raycaster.near || distance > raycaster.far) continue;
                            intersects.push({
                                distance: distance,
                                // What do we want? intersection point on the ray or on the segment??
                                // point: raycaster.ray.at( distance ),
                                point: interSegment.clone().applyMatrix4(this.matrixWorld),
                                index: i,
                                face: null,
                                faceIndex: null,
                                object: this
                            });
                        }
                    } else {
                        var start1 = Math.max(0, drawRange.start);
                        var end1 = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
                        for(var i1 = start1, l1 = end1 - 1; i1 < l1; i1 += step){
                            vStart.fromBufferAttribute(positionAttribute, i1);
                            vEnd.fromBufferAttribute(positionAttribute, i1 + 1);
                            var distSq1 = $c702e238df7c5123$var$_ray$1.distanceSqToSegment(vStart, vEnd, interRay, interSegment);
                            if (distSq1 > localThresholdSq) continue;
                            interRay.applyMatrix4(this.matrixWorld); //Move back to world space for distance calculation
                            var distance1 = raycaster.ray.origin.distanceTo(interRay);
                            if (distance1 < raycaster.near || distance1 > raycaster.far) continue;
                            intersects.push({
                                distance: distance1,
                                // What do we want? intersection point on the ray or on the segment??
                                // point: raycaster.ray.at( distance ),
                                point: interSegment.clone().applyMatrix4(this.matrixWorld),
                                index: i1,
                                face: null,
                                faceIndex: null,
                                object: this
                            });
                        }
                    }
                } else if (geometry.isGeometry) console.error('THREE.Line.raycast() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.');
            }
        },
        {
            key: "updateMorphTargets",
            value: function updateMorphTargets() {
                var geometry = this.geometry;
                if (geometry.isBufferGeometry) {
                    var morphAttributes = geometry.morphAttributes;
                    var keys = Object.keys(morphAttributes);
                    if (keys.length > 0) {
                        var morphAttribute = morphAttributes[keys[0]];
                        if (morphAttribute !== undefined) {
                            this.morphTargetInfluences = [];
                            this.morphTargetDictionary = {};
                            for(var m = 0, ml = morphAttribute.length; m < ml; m++){
                                var name = morphAttribute[m].name || String(m);
                                this.morphTargetInfluences.push(0);
                                this.morphTargetDictionary[name] = m;
                            }
                        }
                    }
                } else {
                    var morphTargets = geometry.morphTargets;
                    if (morphTargets !== undefined && morphTargets.length > 0) console.error('THREE.Line.updateMorphTargets() does not support THREE.Geometry. Use THREE.BufferGeometry instead.');
                }
            }
        }
    ]);
    return Line;
}($c702e238df7c5123$export$e4dd07dff30cc924);
$c702e238df7c5123$export$17d680238e50603e.prototype.isLine = true;
var $c702e238df7c5123$var$_start = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_end = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$export$ff1ed10fedfdd604 = /*#__PURE__*/ function(Line) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(LineSegments, Line);
    function LineSegments(geometry, material) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, LineSegments);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, LineSegments, [
            geometry,
            material
        ]);
        _this.type = 'LineSegments';
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(LineSegments, [
        {
            key: "computeLineDistances",
            value: function computeLineDistances() {
                var geometry = this.geometry;
                if (geometry.isBufferGeometry) {
                    // we assume non-indexed geometry
                    if (geometry.index === null) {
                        var positionAttribute = geometry.attributes.position;
                        var lineDistances = [];
                        for(var i = 0, l = positionAttribute.count; i < l; i += 2){
                            $c702e238df7c5123$var$_start.fromBufferAttribute(positionAttribute, i);
                            $c702e238df7c5123$var$_end.fromBufferAttribute(positionAttribute, i + 1);
                            lineDistances[i] = i === 0 ? 0 : lineDistances[i - 1];
                            lineDistances[i + 1] = lineDistances[i] + $c702e238df7c5123$var$_start.distanceTo($c702e238df7c5123$var$_end);
                        }
                        geometry.setAttribute('lineDistance', new $c702e238df7c5123$export$cbe7a62641830ebd(lineDistances, 1));
                    } else console.warn('THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.');
                } else if (geometry.isGeometry) console.error('THREE.LineSegments.computeLineDistances() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.');
                return this;
            }
        }
    ]);
    return LineSegments;
}($c702e238df7c5123$export$17d680238e50603e);
$c702e238df7c5123$export$ff1ed10fedfdd604.prototype.isLineSegments = true;
var $c702e238df7c5123$export$f85a24d745e4f17d = /*#__PURE__*/ function(Line) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(LineLoop, Line);
    function LineLoop(geometry, material) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, LineLoop);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, LineLoop, [
            geometry,
            material
        ]);
        _this.type = 'LineLoop';
        return _this;
    }
    return LineLoop;
}($c702e238df7c5123$export$17d680238e50603e);
$c702e238df7c5123$export$f85a24d745e4f17d.prototype.isLineLoop = true;
/**
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *  map: new THREE.Texture( <Image> ),
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  size: <float>,
 *  sizeAttenuation: <bool>
 *
 *  morphTargets: <bool>
 * }
 */ var $c702e238df7c5123$export$a178c45366ce5d6b = /*#__PURE__*/ function(Material) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(PointsMaterial, Material);
    function PointsMaterial(parameters) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, PointsMaterial);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, PointsMaterial);
        _this.type = 'PointsMaterial';
        _this.color = new $c702e238df7c5123$export$892596cec99bc70e(0xffffff);
        _this.map = null;
        _this.alphaMap = null;
        _this.size = 1;
        _this.sizeAttenuation = true;
        _this.morphTargets = false;
        _this.setValues(parameters);
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(PointsMaterial, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(PointsMaterial.prototype), "copy", this).call(this, source);
                this.color.copy(source.color);
                this.map = source.map;
                this.alphaMap = source.alphaMap;
                this.size = source.size;
                this.sizeAttenuation = source.sizeAttenuation;
                this.morphTargets = source.morphTargets;
                return this;
            }
        }
    ]);
    return PointsMaterial;
}($c702e238df7c5123$export$a2d8b23205c25948);
$c702e238df7c5123$export$a178c45366ce5d6b.prototype.isPointsMaterial = true;
var $c702e238df7c5123$var$_inverseMatrix = /*@__PURE__*/ new $c702e238df7c5123$export$2ae72fc923e5eb5();
var $c702e238df7c5123$var$_ray = /*@__PURE__*/ new $c702e238df7c5123$export$a186db52eed6d40e();
var $c702e238df7c5123$var$_sphere = /*@__PURE__*/ new $c702e238df7c5123$export$805e8b72413ccaba();
var $c702e238df7c5123$var$_position$2 = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$export$1c787534cb11aa3e = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(Points, Object3D);
    function Points() {
        var geometry = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $c702e238df7c5123$export$b7be63a67df8959(), material = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $c702e238df7c5123$export$a178c45366ce5d6b();
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Points);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, Points);
        _this.type = 'Points';
        _this.geometry = geometry;
        _this.material = material;
        _this.updateMorphTargets();
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(Points, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(Points.prototype), "copy", this).call(this, source);
                this.material = source.material;
                this.geometry = source.geometry;
                return this;
            }
        },
        {
            key: "raycast",
            value: function raycast(raycaster, intersects) {
                var geometry = this.geometry;
                var matrixWorld = this.matrixWorld;
                var threshold = raycaster.params.Points.threshold;
                var drawRange = geometry.drawRange;
                // Checking boundingSphere distance to ray
                if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
                $c702e238df7c5123$var$_sphere.copy(geometry.boundingSphere);
                $c702e238df7c5123$var$_sphere.applyMatrix4(matrixWorld);
                $c702e238df7c5123$var$_sphere.radius += threshold;
                if (raycaster.ray.intersectsSphere($c702e238df7c5123$var$_sphere) === false) return;
                //
                $c702e238df7c5123$var$_inverseMatrix.copy(matrixWorld).invert();
                $c702e238df7c5123$var$_ray.copy(raycaster.ray).applyMatrix4($c702e238df7c5123$var$_inverseMatrix);
                var localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
                var localThresholdSq = localThreshold * localThreshold;
                if (geometry.isBufferGeometry) {
                    var index = geometry.index;
                    var attributes = geometry.attributes;
                    var positionAttribute = attributes.position;
                    if (index !== null) {
                        var start = Math.max(0, drawRange.start);
                        var end = Math.min(index.count, drawRange.start + drawRange.count);
                        for(var i = start, il = end; i < il; i++){
                            var a = index.getX(i);
                            $c702e238df7c5123$var$_position$2.fromBufferAttribute(positionAttribute, a);
                            $c702e238df7c5123$var$testPoint($c702e238df7c5123$var$_position$2, a, localThresholdSq, matrixWorld, raycaster, intersects, this);
                        }
                    } else {
                        var start1 = Math.max(0, drawRange.start);
                        var end1 = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
                        for(var i1 = start1, l = end1; i1 < l; i1++){
                            $c702e238df7c5123$var$_position$2.fromBufferAttribute(positionAttribute, i1);
                            $c702e238df7c5123$var$testPoint($c702e238df7c5123$var$_position$2, i1, localThresholdSq, matrixWorld, raycaster, intersects, this);
                        }
                    }
                } else console.error('THREE.Points.raycast() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.');
            }
        },
        {
            key: "updateMorphTargets",
            value: function updateMorphTargets() {
                var geometry = this.geometry;
                if (geometry.isBufferGeometry) {
                    var morphAttributes = geometry.morphAttributes;
                    var keys = Object.keys(morphAttributes);
                    if (keys.length > 0) {
                        var morphAttribute = morphAttributes[keys[0]];
                        if (morphAttribute !== undefined) {
                            this.morphTargetInfluences = [];
                            this.morphTargetDictionary = {};
                            for(var m = 0, ml = morphAttribute.length; m < ml; m++){
                                var name = morphAttribute[m].name || String(m);
                                this.morphTargetInfluences.push(0);
                                this.morphTargetDictionary[name] = m;
                            }
                        }
                    }
                } else {
                    var morphTargets = geometry.morphTargets;
                    if (morphTargets !== undefined && morphTargets.length > 0) console.error('THREE.Points.updateMorphTargets() does not support THREE.Geometry. Use THREE.BufferGeometry instead.');
                }
            }
        }
    ]);
    return Points;
}($c702e238df7c5123$export$e4dd07dff30cc924);
$c702e238df7c5123$export$1c787534cb11aa3e.prototype.isPoints = true;
function $c702e238df7c5123$var$testPoint(point, index, localThresholdSq, matrixWorld, raycaster, intersects, object) {
    var rayPointDistanceSq = $c702e238df7c5123$var$_ray.distanceSqToPoint(point);
    if (rayPointDistanceSq < localThresholdSq) {
        var intersectPoint = new $c702e238df7c5123$export$64b5c384219d3699();
        $c702e238df7c5123$var$_ray.closestPointToPoint(point, intersectPoint);
        intersectPoint.applyMatrix4(matrixWorld);
        var distance = raycaster.ray.origin.distanceTo(intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            distanceToRay: Math.sqrt(rayPointDistanceSq),
            point: intersectPoint,
            index: index,
            face: null,
            object: object
        });
    }
}
var $c702e238df7c5123$export$6e09d1edf8d5a25c = /*#__PURE__*/ function(Texture) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(VideoTexture, Texture);
    function VideoTexture(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, VideoTexture);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, VideoTexture, [
            video,
            mapping,
            wrapS,
            wrapT,
            magFilter,
            minFilter,
            format,
            type,
            anisotropy
        ]);
        _this.format = format !== undefined ? format : $c702e238df7c5123$export$7c67423a5ee6f5eb;
        _this.minFilter = minFilter !== undefined ? minFilter : $c702e238df7c5123$export$8a72f490b25c56c8;
        _this.magFilter = magFilter !== undefined ? magFilter : $c702e238df7c5123$export$8a72f490b25c56c8;
        _this.generateMipmaps = false;
        var scope = _this;
        function updateVideo() {
            scope.needsUpdate = true;
            video.requestVideoFrameCallback(updateVideo);
        }
        if ('requestVideoFrameCallback' in video) video.requestVideoFrameCallback(updateVideo);
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(VideoTexture, [
        {
            key: "clone",
            value: function clone() {
                return new this.constructor(this.image).copy(this);
            }
        },
        {
            key: "update",
            value: function update() {
                var video = this.image;
                var hasVideoFrameCallback = 'requestVideoFrameCallback' in video;
                if (hasVideoFrameCallback === false && video.readyState >= video.HAVE_CURRENT_DATA) this.needsUpdate = true;
            }
        }
    ]);
    return VideoTexture;
}($c702e238df7c5123$export$5431306cf43de24a);
$c702e238df7c5123$export$6e09d1edf8d5a25c.prototype.isVideoTexture = true;
var $c702e238df7c5123$export$3466bac9141a5cc4 = /*#__PURE__*/ function(Texture) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(CompressedTexture, Texture);
    function CompressedTexture(mipmaps, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, encoding) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, CompressedTexture);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, CompressedTexture, [
            null,
            mapping,
            wrapS,
            wrapT,
            magFilter,
            minFilter,
            format,
            type,
            anisotropy,
            encoding
        ]);
        _this.image = {
            width: width,
            height: height
        };
        _this.mipmaps = mipmaps;
        // no flipping for cube textures
        // (also flipping doesn't work for compressed textures )
        _this.flipY = false;
        // can't generate mipmaps for compressed textures
        // mips must be embedded in DDS files
        _this.generateMipmaps = false;
        return _this;
    }
    return CompressedTexture;
}($c702e238df7c5123$export$5431306cf43de24a);
$c702e238df7c5123$export$3466bac9141a5cc4.prototype.isCompressedTexture = true;
var $c702e238df7c5123$export$f7189e49152d1c13 = /*#__PURE__*/ function(Texture) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(CanvasTexture, Texture);
    function CanvasTexture(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, CanvasTexture);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, CanvasTexture, [
            canvas,
            mapping,
            wrapS,
            wrapT,
            magFilter,
            minFilter,
            format,
            type,
            anisotropy
        ]);
        _this.needsUpdate = true;
        return _this;
    }
    return CanvasTexture;
}($c702e238df7c5123$export$5431306cf43de24a);
$c702e238df7c5123$export$f7189e49152d1c13.prototype.isCanvasTexture = true;
var $c702e238df7c5123$export$fc830aa069cc8c2f = /*#__PURE__*/ function(Texture) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(DepthTexture, Texture);
    function DepthTexture(width, height, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, format) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, DepthTexture);
        var _this;
        format = format !== undefined ? format : $c702e238df7c5123$export$c1b6b5136be58045;
        if (format !== $c702e238df7c5123$export$c1b6b5136be58045 && format !== $c702e238df7c5123$export$1e113ac2d0905829) throw new Error('DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat');
        if (type === undefined && format === $c702e238df7c5123$export$c1b6b5136be58045) type = $c702e238df7c5123$export$c63dc51868b06a9d;
        if (type === undefined && format === $c702e238df7c5123$export$1e113ac2d0905829) type = $c702e238df7c5123$export$6c8ea339bfab1301;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, DepthTexture, [
            null,
            mapping,
            wrapS,
            wrapT,
            magFilter,
            minFilter,
            format,
            type,
            anisotropy
        ]);
        _this.image = {
            width: width,
            height: height
        };
        _this.magFilter = magFilter !== undefined ? magFilter : $c702e238df7c5123$export$727aa5ec3fe39bf0;
        _this.minFilter = minFilter !== undefined ? minFilter : $c702e238df7c5123$export$727aa5ec3fe39bf0;
        _this.flipY = false;
        _this.generateMipmaps = false;
        return _this;
    }
    return DepthTexture;
}($c702e238df7c5123$export$5431306cf43de24a);
$c702e238df7c5123$export$fc830aa069cc8c2f.prototype.isDepthTexture = true;
var $c702e238df7c5123$export$3f74fe60decf7462 = /*#__PURE__*/ function(BufferGeometry) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(CircleGeometry, BufferGeometry);
    function CircleGeometry() {
        var radius = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, segments = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 8, thetaStart = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, thetaLength = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Math.PI * 2;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, CircleGeometry);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, CircleGeometry);
        _this.type = 'CircleGeometry';
        _this.parameters = {
            radius: radius,
            segments: segments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        segments = Math.max(3, segments);
        // buffers
        var indices = [];
        var vertices = [];
        var normals = [];
        var uvs = [];
        // helper variables
        var vertex = new $c702e238df7c5123$export$64b5c384219d3699();
        var uv = new $c702e238df7c5123$export$c977b3e384af9ae1();
        // center point
        vertices.push(0, 0, 0);
        normals.push(0, 0, 1);
        uvs.push(0.5, 0.5);
        for(var s = 0, i = 3; s <= segments; s++, i += 3){
            var segment = thetaStart + s / segments * thetaLength;
            // vertex
            vertex.x = radius * Math.cos(segment);
            vertex.y = radius * Math.sin(segment);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            normals.push(0, 0, 1);
            // uvs
            uv.x = (vertices[i] / radius + 1) / 2;
            uv.y = (vertices[i + 1] / radius + 1) / 2;
            uvs.push(uv.x, uv.y);
        }
        // indices
        for(var i1 = 1; i1 <= segments; i1++)indices.push(i1, i1 + 1, 0);
        // build geometry
        _this.setIndex(indices);
        _this.setAttribute('position', new $c702e238df7c5123$export$cbe7a62641830ebd(vertices, 3));
        _this.setAttribute('normal', new $c702e238df7c5123$export$cbe7a62641830ebd(normals, 3));
        _this.setAttribute('uv', new $c702e238df7c5123$export$cbe7a62641830ebd(uvs, 2));
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(CircleGeometry, null, [
        {
            key: "fromJSON",
            value: function fromJSON(data) {
                return new CircleGeometry(data.radius, data.segments, data.thetaStart, data.thetaLength);
            }
        }
    ]);
    return CircleGeometry;
}($c702e238df7c5123$export$b7be63a67df8959);
var $c702e238df7c5123$export$d4345c83207d7c68 = /*#__PURE__*/ function(BufferGeometry) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(CylinderGeometry, BufferGeometry);
    function CylinderGeometry() {
        var radiusTop = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, radiusBottom = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, height = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, radialSegments = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 8, heightSegments = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 1, openEnded = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false, thetaStart = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : 0, thetaLength = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : Math.PI * 2;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, CylinderGeometry);
        var _this;
        var generateTorso = function generateTorso() {
            var normal = new $c702e238df7c5123$export$64b5c384219d3699();
            var vertex = new $c702e238df7c5123$export$64b5c384219d3699();
            var groupCount = 0;
            // this will be used to calculate the normal
            var slope = (radiusBottom - radiusTop) / height;
            // generate vertices, normals and uvs
            for(var y = 0; y <= heightSegments; y++){
                var indexRow = [];
                var v = y / heightSegments;
                // calculate the radius of the current row
                var radius = v * (radiusBottom - radiusTop) + radiusTop;
                for(var x = 0; x <= radialSegments; x++){
                    var u = x / radialSegments;
                    var theta = u * thetaLength + thetaStart;
                    var sinTheta = Math.sin(theta);
                    var cosTheta = Math.cos(theta);
                    // vertex
                    vertex.x = radius * sinTheta;
                    vertex.y = -v * height + halfHeight;
                    vertex.z = radius * cosTheta;
                    vertices.push(vertex.x, vertex.y, vertex.z);
                    // normal
                    normal.set(sinTheta, slope, cosTheta).normalize();
                    normals.push(normal.x, normal.y, normal.z);
                    // uv
                    uvs.push(u, 1 - v);
                    // save index of vertex in respective row
                    indexRow.push(index++);
                }
                // now save vertices of the row in our index array
                indexArray.push(indexRow);
            }
            // generate indices
            for(var x1 = 0; x1 < radialSegments; x1++)for(var y1 = 0; y1 < heightSegments; y1++){
                // we use the index array to access the correct indices
                var a = indexArray[y1][x1];
                var b = indexArray[y1 + 1][x1];
                var c = indexArray[y1 + 1][x1 + 1];
                var d = indexArray[y1][x1 + 1];
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // update group counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, 0);
            // calculate new start value for groups
            groupStart += groupCount;
        };
        var generateCap = function generateCap(top) {
            // save the index of the first center vertex
            var centerIndexStart = index;
            var uv = new $c702e238df7c5123$export$c977b3e384af9ae1();
            var vertex = new $c702e238df7c5123$export$64b5c384219d3699();
            var groupCount = 0;
            var radius = top === true ? radiusTop : radiusBottom;
            var sign = top === true ? 1 : -1;
            // first we generate the center vertex data of the cap.
            // because the geometry needs one set of uvs per face,
            // we must generate a center vertex per face/segment
            for(var x = 1; x <= radialSegments; x++){
                // vertex
                vertices.push(0, halfHeight * sign, 0);
                // normal
                normals.push(0, sign, 0);
                // uv
                uvs.push(0.5, 0.5);
                // increase index
                index++;
            }
            // save the index of the last center vertex
            var centerIndexEnd = index;
            // now we generate the surrounding vertices, normals and uvs
            for(var x1 = 0; x1 <= radialSegments; x1++){
                var u = x1 / radialSegments;
                var theta = u * thetaLength + thetaStart;
                var cosTheta = Math.cos(theta);
                var sinTheta = Math.sin(theta);
                // vertex
                vertex.x = radius * sinTheta;
                vertex.y = halfHeight * sign;
                vertex.z = radius * cosTheta;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, sign, 0);
                // uv
                uv.x = cosTheta * 0.5 + 0.5;
                uv.y = sinTheta * 0.5 * sign + 0.5;
                uvs.push(uv.x, uv.y);
                // increase index
                index++;
            }
            // generate indices
            for(var x2 = 0; x2 < radialSegments; x2++){
                var c = centerIndexStart + x2;
                var i = centerIndexEnd + x2;
                if (top === true) // face top
                indices.push(i, i + 1, c);
                else // face bottom
                indices.push(i + 1, i, c);
                groupCount += 3;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, top === true ? 1 : 2);
            // calculate new start value for groups
            groupStart += groupCount;
        };
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, CylinderGeometry);
        _this.type = 'CylinderGeometry';
        _this.parameters = {
            radiusTop: radiusTop,
            radiusBottom: radiusBottom,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        var scope = _this;
        radialSegments = Math.floor(radialSegments);
        heightSegments = Math.floor(heightSegments);
        // buffers
        var indices = [];
        var vertices = [];
        var normals = [];
        var uvs = [];
        // helper variables
        var index = 0;
        var indexArray = [];
        var halfHeight = height / 2;
        var groupStart = 0;
        // generate geometry
        generateTorso();
        if (openEnded === false) {
            if (radiusTop > 0) generateCap(true);
            if (radiusBottom > 0) generateCap(false);
        }
        // build geometry
        _this.setIndex(indices);
        _this.setAttribute('position', new $c702e238df7c5123$export$cbe7a62641830ebd(vertices, 3));
        _this.setAttribute('normal', new $c702e238df7c5123$export$cbe7a62641830ebd(normals, 3));
        _this.setAttribute('uv', new $c702e238df7c5123$export$cbe7a62641830ebd(uvs, 2));
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(CylinderGeometry, null, [
        {
            key: "fromJSON",
            value: function fromJSON(data) {
                return new CylinderGeometry(data.radiusTop, data.radiusBottom, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
            }
        }
    ]);
    return CylinderGeometry;
}($c702e238df7c5123$export$b7be63a67df8959);
var $c702e238df7c5123$export$59d971120dc8b6e7 = /*#__PURE__*/ function(CylinderGeometry) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(ConeGeometry, CylinderGeometry);
    function ConeGeometry() {
        var radius = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, height = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, radialSegments = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 8, heightSegments = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1, openEnded = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false, thetaStart = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0, thetaLength = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : Math.PI * 2;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, ConeGeometry);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, ConeGeometry, [
            0,
            radius,
            height,
            radialSegments,
            heightSegments,
            openEnded,
            thetaStart,
            thetaLength
        ]);
        _this.type = 'ConeGeometry';
        _this.parameters = {
            radius: radius,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(ConeGeometry, null, [
        {
            key: "fromJSON",
            value: function fromJSON(data) {
                return new ConeGeometry(data.radius, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
            }
        }
    ]);
    return ConeGeometry;
}($c702e238df7c5123$export$d4345c83207d7c68);
var $c702e238df7c5123$export$38789b531813345c = /*#__PURE__*/ function(BufferGeometry) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(PolyhedronGeometry, BufferGeometry);
    function PolyhedronGeometry(vertices, indices) {
        var radius = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, detail = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, PolyhedronGeometry);
        var _this;
        var subdivide = // helper functions
        function subdivide(detail) {
            var a = new $c702e238df7c5123$export$64b5c384219d3699();
            var b = new $c702e238df7c5123$export$64b5c384219d3699();
            var c = new $c702e238df7c5123$export$64b5c384219d3699();
            // iterate over all faces and apply a subdivison with the given detail value
            for(var i = 0; i < indices.length; i += 3){
                // get the vertices of the face
                getVertexByIndex(indices[i + 0], a);
                getVertexByIndex(indices[i + 1], b);
                getVertexByIndex(indices[i + 2], c);
                // perform subdivision
                subdivideFace(a, b, c, detail);
            }
        };
        var subdivideFace = function subdivideFace(a, b, c, detail) {
            var cols = detail + 1;
            // we use this multidimensional array as a data structure for creating the subdivision
            var v = [];
            // construct all of the vertices for this subdivision
            for(var i = 0; i <= cols; i++){
                v[i] = [];
                var aj = a.clone().lerp(c, i / cols);
                var bj = b.clone().lerp(c, i / cols);
                var rows = cols - i;
                for(var j = 0; j <= rows; j++)if (j === 0 && i === cols) v[i][j] = aj;
                else v[i][j] = aj.clone().lerp(bj, j / rows);
            }
            // construct all of the faces
            for(var i1 = 0; i1 < cols; i1++)for(var j1 = 0; j1 < 2 * (cols - i1) - 1; j1++){
                var k = Math.floor(j1 / 2);
                if (j1 % 2 === 0) {
                    pushVertex(v[i1][k + 1]);
                    pushVertex(v[i1 + 1][k]);
                    pushVertex(v[i1][k]);
                } else {
                    pushVertex(v[i1][k + 1]);
                    pushVertex(v[i1 + 1][k + 1]);
                    pushVertex(v[i1 + 1][k]);
                }
            }
        };
        var applyRadius = function applyRadius(radius) {
            var vertex = new $c702e238df7c5123$export$64b5c384219d3699();
            // iterate over the entire buffer and apply the radius to each vertex
            for(var i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                vertex.normalize().multiplyScalar(radius);
                vertexBuffer[i + 0] = vertex.x;
                vertexBuffer[i + 1] = vertex.y;
                vertexBuffer[i + 2] = vertex.z;
            }
        };
        var generateUVs = function generateUVs() {
            var vertex = new $c702e238df7c5123$export$64b5c384219d3699();
            for(var i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                var u = azimuth(vertex) / 2 / Math.PI + 0.5;
                var v = inclination(vertex) / Math.PI + 0.5;
                uvBuffer.push(u, 1 - v);
            }
            correctUVs();
            correctSeam();
        };
        var correctSeam = function correctSeam() {
            // handle case when face straddles the seam, see #3269
            for(var i = 0; i < uvBuffer.length; i += 6){
                // uv data of a single face
                var x0 = uvBuffer[i + 0];
                var x1 = uvBuffer[i + 2];
                var x2 = uvBuffer[i + 4];
                var max = Math.max(x0, x1, x2);
                var min = Math.min(x0, x1, x2);
                // 0.9 is somewhat arbitrary
                if (max > 0.9 && min < 0.1) {
                    if (x0 < 0.2) uvBuffer[i + 0] += 1;
                    if (x1 < 0.2) uvBuffer[i + 2] += 1;
                    if (x2 < 0.2) uvBuffer[i + 4] += 1;
                }
            }
        };
        var pushVertex = function pushVertex(vertex) {
            vertexBuffer.push(vertex.x, vertex.y, vertex.z);
        };
        var getVertexByIndex = function getVertexByIndex(index, vertex) {
            var stride = index * 3;
            vertex.x = vertices[stride + 0];
            vertex.y = vertices[stride + 1];
            vertex.z = vertices[stride + 2];
        };
        var correctUVs = function correctUVs() {
            var a = new $c702e238df7c5123$export$64b5c384219d3699();
            var b = new $c702e238df7c5123$export$64b5c384219d3699();
            var c = new $c702e238df7c5123$export$64b5c384219d3699();
            var centroid = new $c702e238df7c5123$export$64b5c384219d3699();
            var uvA = new $c702e238df7c5123$export$c977b3e384af9ae1();
            var uvB = new $c702e238df7c5123$export$c977b3e384af9ae1();
            var uvC = new $c702e238df7c5123$export$c977b3e384af9ae1();
            for(var i = 0, j = 0; i < vertexBuffer.length; i += 9, j += 6){
                a.set(vertexBuffer[i + 0], vertexBuffer[i + 1], vertexBuffer[i + 2]);
                b.set(vertexBuffer[i + 3], vertexBuffer[i + 4], vertexBuffer[i + 5]);
                c.set(vertexBuffer[i + 6], vertexBuffer[i + 7], vertexBuffer[i + 8]);
                uvA.set(uvBuffer[j + 0], uvBuffer[j + 1]);
                uvB.set(uvBuffer[j + 2], uvBuffer[j + 3]);
                uvC.set(uvBuffer[j + 4], uvBuffer[j + 5]);
                centroid.copy(a).add(b).add(c).divideScalar(3);
                var azi = azimuth(centroid);
                correctUV(uvA, j + 0, a, azi);
                correctUV(uvB, j + 2, b, azi);
                correctUV(uvC, j + 4, c, azi);
            }
        };
        var correctUV = function correctUV(uv, stride, vector, azimuth) {
            if (azimuth < 0 && uv.x === 1) uvBuffer[stride] = uv.x - 1;
            if (vector.x === 0 && vector.z === 0) uvBuffer[stride] = azimuth / 2 / Math.PI + 0.5;
        };
        var azimuth = // Angle around the Y axis, counter-clockwise when looking from above.
        function azimuth(vector) {
            return Math.atan2(vector.z, -vector.x);
        };
        var inclination = // Angle above the XZ plane.
        function inclination(vector) {
            return Math.atan2(-vector.y, Math.sqrt(vector.x * vector.x + vector.z * vector.z));
        };
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, PolyhedronGeometry);
        _this.type = 'PolyhedronGeometry';
        _this.parameters = {
            vertices: vertices,
            indices: indices,
            radius: radius,
            detail: detail
        };
        // default buffer data
        var vertexBuffer = [];
        var uvBuffer = [];
        // the subdivision creates the vertex buffer data
        subdivide(detail);
        // all vertices should lie on a conceptual sphere with a given radius
        applyRadius(radius);
        // finally, create the uv data
        generateUVs();
        // build non-indexed geometry
        _this.setAttribute('position', new $c702e238df7c5123$export$cbe7a62641830ebd(vertexBuffer, 3));
        _this.setAttribute('normal', new $c702e238df7c5123$export$cbe7a62641830ebd(vertexBuffer.slice(), 3));
        _this.setAttribute('uv', new $c702e238df7c5123$export$cbe7a62641830ebd(uvBuffer, 2));
        if (detail === 0) _this.computeVertexNormals(); // flat normals
        else _this.normalizeNormals(); // smooth normals
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(PolyhedronGeometry, null, [
        {
            key: "fromJSON",
            value: function fromJSON(data) {
                return new PolyhedronGeometry(data.vertices, data.indices, data.radius, data.details);
            }
        }
    ]);
    return PolyhedronGeometry;
}($c702e238df7c5123$export$b7be63a67df8959);
var $c702e238df7c5123$export$37cd4e52cce48c4c = /*#__PURE__*/ function(PolyhedronGeometry) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(DodecahedronGeometry, PolyhedronGeometry);
    function DodecahedronGeometry() {
        var radius = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, detail = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, DodecahedronGeometry);
        var _this;
        var t = (1 + Math.sqrt(5)) / 2;
        var r = 1 / t;
        var vertices = [
            // (±1, ±1, ±1)
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            1,
            1,
            1,
            // (0, ±1/φ, ±φ)
            0,
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            // (±1/φ, ±φ, 0)
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            0,
            // (±φ, 0, ±1/φ)
            -t,
            0,
            -r,
            t,
            0,
            -r,
            -t,
            0,
            r,
            t,
            0,
            r
        ];
        var indices = [
            3,
            11,
            7,
            3,
            7,
            15,
            3,
            15,
            13,
            7,
            19,
            17,
            7,
            17,
            6,
            7,
            6,
            15,
            17,
            4,
            8,
            17,
            8,
            10,
            17,
            10,
            6,
            8,
            0,
            16,
            8,
            16,
            2,
            8,
            2,
            10,
            0,
            12,
            1,
            0,
            1,
            18,
            0,
            18,
            16,
            6,
            10,
            2,
            6,
            2,
            13,
            6,
            13,
            15,
            2,
            16,
            18,
            2,
            18,
            3,
            2,
            3,
            13,
            18,
            1,
            9,
            18,
            9,
            11,
            18,
            11,
            3,
            4,
            14,
            12,
            4,
            12,
            0,
            4,
            0,
            8,
            11,
            9,
            5,
            11,
            5,
            19,
            11,
            19,
            7,
            19,
            5,
            14,
            19,
            14,
            4,
            19,
            4,
            17,
            1,
            12,
            14,
            1,
            14,
            5,
            1,
            5,
            9
        ];
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, DodecahedronGeometry, [
            vertices,
            indices,
            radius,
            detail
        ]);
        _this.type = 'DodecahedronGeometry';
        _this.parameters = {
            radius: radius,
            detail: detail
        };
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(DodecahedronGeometry, null, [
        {
            key: "fromJSON",
            value: function fromJSON(data) {
                return new DodecahedronGeometry(data.radius, data.detail);
            }
        }
    ]);
    return DodecahedronGeometry;
}($c702e238df7c5123$export$38789b531813345c);
var $c702e238df7c5123$var$_v0 = new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_v1$1 = new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_normal = new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_triangle = new $c702e238df7c5123$export$5a465592bfe74b48();
var $c702e238df7c5123$export$4730b1542707547f = /*#__PURE__*/ function(BufferGeometry) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(EdgesGeometry, BufferGeometry);
    function EdgesGeometry(geometry, thresholdAngle) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, EdgesGeometry);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, EdgesGeometry);
        _this.type = 'EdgesGeometry';
        _this.parameters = {
            thresholdAngle: thresholdAngle
        };
        thresholdAngle = thresholdAngle !== undefined ? thresholdAngle : 1;
        if (geometry.isGeometry === true) {
            console.error('THREE.EdgesGeometry no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.');
            return (0, $aa137087616882c2$export$71511d61b312f219)(_this);
        }
        var precisionPoints = 4;
        var precision = Math.pow(10, precisionPoints);
        var thresholdDot = Math.cos($c702e238df7c5123$var$DEG2RAD * thresholdAngle);
        var indexAttr = geometry.getIndex();
        var positionAttr = geometry.getAttribute('position');
        var indexCount = indexAttr ? indexAttr.count : positionAttr.count;
        var indexArr = [
            0,
            0,
            0
        ];
        var vertKeys = [
            'a',
            'b',
            'c'
        ];
        var hashes = new Array(3);
        var edgeData = {};
        var vertices = [];
        for(var i = 0; i < indexCount; i += 3){
            if (indexAttr) {
                indexArr[0] = indexAttr.getX(i);
                indexArr[1] = indexAttr.getX(i + 1);
                indexArr[2] = indexAttr.getX(i + 2);
            } else {
                indexArr[0] = i;
                indexArr[1] = i + 1;
                indexArr[2] = i + 2;
            }
            var a = $c702e238df7c5123$var$_triangle.a, b = $c702e238df7c5123$var$_triangle.b, c = $c702e238df7c5123$var$_triangle.c;
            a.fromBufferAttribute(positionAttr, indexArr[0]);
            b.fromBufferAttribute(positionAttr, indexArr[1]);
            c.fromBufferAttribute(positionAttr, indexArr[2]);
            $c702e238df7c5123$var$_triangle.getNormal($c702e238df7c5123$var$_normal);
            // create hashes for the edge from the vertices
            hashes[0] = "".concat(Math.round(a.x * precision), ",").concat(Math.round(a.y * precision), ",").concat(Math.round(a.z * precision));
            hashes[1] = "".concat(Math.round(b.x * precision), ",").concat(Math.round(b.y * precision), ",").concat(Math.round(b.z * precision));
            hashes[2] = "".concat(Math.round(c.x * precision), ",").concat(Math.round(c.y * precision), ",").concat(Math.round(c.z * precision));
            // skip degenerate triangles
            if (hashes[0] === hashes[1] || hashes[1] === hashes[2] || hashes[2] === hashes[0]) continue;
            // iterate over every edge
            for(var j = 0; j < 3; j++){
                // get the first and next vertex making up the edge
                var jNext = (j + 1) % 3;
                var vecHash0 = hashes[j];
                var vecHash1 = hashes[jNext];
                var v0 = $c702e238df7c5123$var$_triangle[vertKeys[j]];
                var v1 = $c702e238df7c5123$var$_triangle[vertKeys[jNext]];
                var hash = "".concat(vecHash0, "_").concat(vecHash1);
                var reverseHash = "".concat(vecHash1, "_").concat(vecHash0);
                if (reverseHash in edgeData && edgeData[reverseHash]) {
                    // if we found a sibling edge add it into the vertex array if
                    // it meets the angle threshold and delete the edge from the map.
                    if ($c702e238df7c5123$var$_normal.dot(edgeData[reverseHash].normal) <= thresholdDot) {
                        vertices.push(v0.x, v0.y, v0.z);
                        vertices.push(v1.x, v1.y, v1.z);
                    }
                    edgeData[reverseHash] = null;
                } else if (!(hash in edgeData)) // if we've already got an edge here then skip adding a new one
                edgeData[hash] = {
                    index0: indexArr[j],
                    index1: indexArr[jNext],
                    normal: $c702e238df7c5123$var$_normal.clone()
                };
            }
        }
        // iterate over all remaining, unmatched edges and add them to the vertex array
        for(var key in edgeData)if (edgeData[key]) {
            var _edgeData_key = edgeData[key], index0 = _edgeData_key.index0, index1 = _edgeData_key.index1;
            $c702e238df7c5123$var$_v0.fromBufferAttribute(positionAttr, index0);
            $c702e238df7c5123$var$_v1$1.fromBufferAttribute(positionAttr, index1);
            vertices.push($c702e238df7c5123$var$_v0.x, $c702e238df7c5123$var$_v0.y, $c702e238df7c5123$var$_v0.z);
            vertices.push($c702e238df7c5123$var$_v1$1.x, $c702e238df7c5123$var$_v1$1.y, $c702e238df7c5123$var$_v1$1.z);
        }
        _this.setAttribute('position', new $c702e238df7c5123$export$cbe7a62641830ebd(vertices, 3));
        return _this;
    }
    return EdgesGeometry;
}($c702e238df7c5123$export$b7be63a67df8959);
/**
 * Extensible curve object.
 *
 * Some common of curve methods:
 * .getPoint( t, optionalTarget ), .getTangent( t, optionalTarget )
 * .getPointAt( u, optionalTarget ), .getTangentAt( u, optionalTarget )
 * .getPoints(), .getSpacedPoints()
 * .getLength()
 * .updateArcLengths()
 *
 * This following curves inherit from THREE.Curve:
 *
 * -- 2D curves --
 * THREE.ArcCurve
 * THREE.CubicBezierCurve
 * THREE.EllipseCurve
 * THREE.LineCurve
 * THREE.QuadraticBezierCurve
 * THREE.SplineCurve
 *
 * -- 3D curves --
 * THREE.CatmullRomCurve3
 * THREE.CubicBezierCurve3
 * THREE.LineCurve3
 * THREE.QuadraticBezierCurve3
 *
 * A series of curves can be represented as a THREE.CurvePath.
 *
 **/ var $c702e238df7c5123$export$b0e83c3ef8d2db1 = /*#__PURE__*/ function() {
    "use strict";
    function Curve() {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Curve);
        this.type = 'Curve';
        this.arcLengthDivisions = 200;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(Curve, [
        {
            // Virtual base class method to overwrite and implement in subclasses
            //	- t [0 .. 1]
            key: "getPoint",
            value: function getPoint() {
                console.warn('THREE.Curve: .getPoint() not implemented.');
                return null;
            }
        },
        {
            // Get point at relative position in curve according to arc length
            // - u [0 .. 1]
            key: "getPointAt",
            value: function getPointAt(u, optionalTarget) {
                var t = this.getUtoTmapping(u);
                return this.getPoint(t, optionalTarget);
            }
        },
        {
            // Get sequence of points using getPoint( t )
            key: "getPoints",
            value: function getPoints() {
                var divisions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 5;
                var points = [];
                for(var d = 0; d <= divisions; d++)points.push(this.getPoint(d / divisions));
                return points;
            }
        },
        {
            // Get sequence of points using getPointAt( u )
            key: "getSpacedPoints",
            value: function getSpacedPoints() {
                var divisions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 5;
                var points = [];
                for(var d = 0; d <= divisions; d++)points.push(this.getPointAt(d / divisions));
                return points;
            }
        },
        {
            // Get total curve arc length
            key: "getLength",
            value: function getLength() {
                var lengths = this.getLengths();
                return lengths[lengths.length - 1];
            }
        },
        {
            // Get list of cumulative segment lengths
            key: "getLengths",
            value: function getLengths() {
                var divisions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.arcLengthDivisions;
                if (this.cacheArcLengths && this.cacheArcLengths.length === divisions + 1 && !this.needsUpdate) return this.cacheArcLengths;
                this.needsUpdate = false;
                var cache = [];
                var current, last = this.getPoint(0);
                var sum = 0;
                cache.push(0);
                for(var p = 1; p <= divisions; p++){
                    current = this.getPoint(p / divisions);
                    sum += current.distanceTo(last);
                    cache.push(sum);
                    last = current;
                }
                this.cacheArcLengths = cache;
                return cache; // { sums: cache, sum: sum }; Sum is in the last element.
            }
        },
        {
            key: "updateArcLengths",
            value: function updateArcLengths() {
                this.needsUpdate = true;
                this.getLengths();
            }
        },
        {
            // Given u ( 0 .. 1 ), get a t to find p. This gives you points which are equidistant
            key: "getUtoTmapping",
            value: function getUtoTmapping(u, distance) {
                var arcLengths = this.getLengths();
                var i = 0;
                var il = arcLengths.length;
                var targetArcLength; // The targeted u distance value to get
                if (distance) targetArcLength = distance;
                else targetArcLength = u * arcLengths[il - 1];
                // binary search for the index with largest value smaller than target u distance
                var low = 0, high = il - 1, comparison;
                while(low <= high){
                    i = Math.floor(low + (high - low) / 2); // less likely to overflow, though probably not issue here, JS doesn't really have integers, all numbers are floats
                    comparison = arcLengths[i] - targetArcLength;
                    if (comparison < 0) low = i + 1;
                    else if (comparison > 0) high = i - 1;
                    else {
                        high = i;
                        break;
                    // DONE
                    }
                }
                i = high;
                if (arcLengths[i] === targetArcLength) return i / (il - 1);
                // we could get finer grain at lengths, or use simple interpolation between two points
                var lengthBefore = arcLengths[i];
                var lengthAfter = arcLengths[i + 1];
                var segmentLength = lengthAfter - lengthBefore;
                // determine where we are between the 'before' and 'after' points
                var segmentFraction = (targetArcLength - lengthBefore) / segmentLength;
                // add that fractional amount to t
                var t = (i + segmentFraction) / (il - 1);
                return t;
            }
        },
        {
            // Returns a unit vector tangent at t
            // In case any sub curve does not implement its tangent derivation,
            // 2 points a small delta apart will be used to find its gradient
            // which seems to give a reasonable approximation
            key: "getTangent",
            value: function getTangent(t, optionalTarget) {
                var delta = 0.0001;
                var t1 = t - delta;
                var t2 = t + delta;
                // Capping in case of danger
                if (t1 < 0) t1 = 0;
                if (t2 > 1) t2 = 1;
                var pt1 = this.getPoint(t1);
                var pt2 = this.getPoint(t2);
                var tangent = optionalTarget || (pt1.isVector2 ? new $c702e238df7c5123$export$c977b3e384af9ae1() : new $c702e238df7c5123$export$64b5c384219d3699());
                tangent.copy(pt2).sub(pt1).normalize();
                return tangent;
            }
        },
        {
            key: "getTangentAt",
            value: function getTangentAt(u, optionalTarget) {
                var t = this.getUtoTmapping(u);
                return this.getTangent(t, optionalTarget);
            }
        },
        {
            key: "computeFrenetFrames",
            value: function computeFrenetFrames(segments, closed) {
                // see http://www.cs.indiana.edu/pub/techreports/TR425.pdf
                var normal = new $c702e238df7c5123$export$64b5c384219d3699();
                var tangents = [];
                var normals = [];
                var binormals = [];
                var vec = new $c702e238df7c5123$export$64b5c384219d3699();
                var mat = new $c702e238df7c5123$export$2ae72fc923e5eb5();
                // compute the tangent vectors for each segment on the curve
                for(var i = 0; i <= segments; i++){
                    var u = i / segments;
                    tangents[i] = this.getTangentAt(u, new $c702e238df7c5123$export$64b5c384219d3699());
                    tangents[i].normalize();
                }
                // select an initial normal vector perpendicular to the first tangent vector,
                // and in the direction of the minimum tangent xyz component
                normals[0] = new $c702e238df7c5123$export$64b5c384219d3699();
                binormals[0] = new $c702e238df7c5123$export$64b5c384219d3699();
                var min = Number.MAX_VALUE;
                var tx = Math.abs(tangents[0].x);
                var ty = Math.abs(tangents[0].y);
                var tz = Math.abs(tangents[0].z);
                if (tx <= min) {
                    min = tx;
                    normal.set(1, 0, 0);
                }
                if (ty <= min) {
                    min = ty;
                    normal.set(0, 1, 0);
                }
                if (tz <= min) normal.set(0, 0, 1);
                vec.crossVectors(tangents[0], normal).normalize();
                normals[0].crossVectors(tangents[0], vec);
                binormals[0].crossVectors(tangents[0], normals[0]);
                // compute the slowly-varying normal and binormal vectors for each segment on the curve
                for(var i1 = 1; i1 <= segments; i1++){
                    normals[i1] = normals[i1 - 1].clone();
                    binormals[i1] = binormals[i1 - 1].clone();
                    vec.crossVectors(tangents[i1 - 1], tangents[i1]);
                    if (vec.length() > Number.EPSILON) {
                        vec.normalize();
                        var theta = Math.acos($c702e238df7c5123$var$clamp(tangents[i1 - 1].dot(tangents[i1]), -1, 1)); // clamp for floating pt errors
                        normals[i1].applyMatrix4(mat.makeRotationAxis(vec, theta));
                    }
                    binormals[i1].crossVectors(tangents[i1], normals[i1]);
                }
                // if the curve is closed, postprocess the vectors so the first and last normal vectors are the same
                if (closed === true) {
                    var theta1 = Math.acos($c702e238df7c5123$var$clamp(normals[0].dot(normals[segments]), -1, 1));
                    theta1 /= segments;
                    if (tangents[0].dot(vec.crossVectors(normals[0], normals[segments])) > 0) theta1 = -theta1;
                    for(var i2 = 1; i2 <= segments; i2++){
                        // twist a little...
                        normals[i2].applyMatrix4(mat.makeRotationAxis(tangents[i2], theta1 * i2));
                        binormals[i2].crossVectors(tangents[i2], normals[i2]);
                    }
                }
                return {
                    tangents: tangents,
                    normals: normals,
                    binormals: binormals
                };
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                this.arcLengthDivisions = source.arcLengthDivisions;
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = {
                    metadata: {
                        version: 4.5,
                        type: 'Curve',
                        generator: 'Curve.toJSON'
                    }
                };
                data.arcLengthDivisions = this.arcLengthDivisions;
                data.type = this.type;
                return data;
            }
        },
        {
            key: "fromJSON",
            value: function fromJSON(json) {
                this.arcLengthDivisions = json.arcLengthDivisions;
                return this;
            }
        }
    ]);
    return Curve;
}();
var $c702e238df7c5123$export$3f87a931616cde04 = /*#__PURE__*/ function(Curve) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(EllipseCurve, Curve);
    function EllipseCurve() {
        var aX = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, aY = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, xRadius = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, yRadius = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1, aStartAngle = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0, aEndAngle = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : Math.PI * 2, aClockwise = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : false, aRotation = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : 0;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, EllipseCurve);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, EllipseCurve);
        _this.type = 'EllipseCurve';
        _this.aX = aX;
        _this.aY = aY;
        _this.xRadius = xRadius;
        _this.yRadius = yRadius;
        _this.aStartAngle = aStartAngle;
        _this.aEndAngle = aEndAngle;
        _this.aClockwise = aClockwise;
        _this.aRotation = aRotation;
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(EllipseCurve, [
        {
            key: "getPoint",
            value: function getPoint(t, optionalTarget) {
                var point = optionalTarget || new $c702e238df7c5123$export$c977b3e384af9ae1();
                var twoPi = Math.PI * 2;
                var deltaAngle = this.aEndAngle - this.aStartAngle;
                var samePoints = Math.abs(deltaAngle) < Number.EPSILON;
                // ensures that deltaAngle is 0 .. 2 PI
                while(deltaAngle < 0)deltaAngle += twoPi;
                while(deltaAngle > twoPi)deltaAngle -= twoPi;
                if (deltaAngle < Number.EPSILON) {
                    if (samePoints) deltaAngle = 0;
                    else deltaAngle = twoPi;
                }
                if (this.aClockwise === true && !samePoints) {
                    if (deltaAngle === twoPi) deltaAngle = -twoPi;
                    else deltaAngle = deltaAngle - twoPi;
                }
                var angle = this.aStartAngle + t * deltaAngle;
                var x = this.aX + this.xRadius * Math.cos(angle);
                var y = this.aY + this.yRadius * Math.sin(angle);
                if (this.aRotation !== 0) {
                    var cos = Math.cos(this.aRotation);
                    var sin = Math.sin(this.aRotation);
                    var tx = x - this.aX;
                    var ty = y - this.aY;
                    // Rotate the point about the center of the ellipse.
                    x = tx * cos - ty * sin + this.aX;
                    y = tx * sin + ty * cos + this.aY;
                }
                return point.set(x, y);
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(EllipseCurve.prototype), "copy", this).call(this, source);
                this.aX = source.aX;
                this.aY = source.aY;
                this.xRadius = source.xRadius;
                this.yRadius = source.yRadius;
                this.aStartAngle = source.aStartAngle;
                this.aEndAngle = source.aEndAngle;
                this.aClockwise = source.aClockwise;
                this.aRotation = source.aRotation;
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(EllipseCurve.prototype), "toJSON", this).call(this);
                data.aX = this.aX;
                data.aY = this.aY;
                data.xRadius = this.xRadius;
                data.yRadius = this.yRadius;
                data.aStartAngle = this.aStartAngle;
                data.aEndAngle = this.aEndAngle;
                data.aClockwise = this.aClockwise;
                data.aRotation = this.aRotation;
                return data;
            }
        },
        {
            key: "fromJSON",
            value: function fromJSON(json) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(EllipseCurve.prototype), "fromJSON", this).call(this, json);
                this.aX = json.aX;
                this.aY = json.aY;
                this.xRadius = json.xRadius;
                this.yRadius = json.yRadius;
                this.aStartAngle = json.aStartAngle;
                this.aEndAngle = json.aEndAngle;
                this.aClockwise = json.aClockwise;
                this.aRotation = json.aRotation;
                return this;
            }
        }
    ]);
    return EllipseCurve;
}($c702e238df7c5123$export$b0e83c3ef8d2db1);
$c702e238df7c5123$export$3f87a931616cde04.prototype.isEllipseCurve = true;
var $c702e238df7c5123$export$b1eedc9aab6300e8 = /*#__PURE__*/ function(EllipseCurve) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(ArcCurve, EllipseCurve);
    function ArcCurve(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, ArcCurve);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, ArcCurve, [
            aX,
            aY,
            aRadius,
            aRadius,
            aStartAngle,
            aEndAngle,
            aClockwise
        ]);
        _this.type = 'ArcCurve';
        return _this;
    }
    return ArcCurve;
}($c702e238df7c5123$export$3f87a931616cde04);
$c702e238df7c5123$export$b1eedc9aab6300e8.prototype.isArcCurve = true;
/**
 * Centripetal CatmullRom Curve - which is useful for avoiding
 * cusps and self-intersections in non-uniform catmull rom curves.
 * http://www.cemyuksel.com/research/catmullrom_param/catmullrom.pdf
 *
 * curve.type accepts centripetal(default), chordal and catmullrom
 * curve.tension is used for catmullrom which defaults to 0.5
 */ /*
Based on an optimized c++ solution in
 - http://stackoverflow.com/questions/9489736/catmull-rom-curve-with-no-cusps-and-no-self-intersections/
 - http://ideone.com/NoEbVM

This CubicPoly class could be used for reusing some variables and calculations,
but for three.js curve use, it could be possible inlined and flatten into a single function call
which can be placed in CurveUtils.
*/ function $c702e238df7c5123$var$CubicPoly() {
    var c0 = 0, c1 = 0, c2 = 0, c3 = 0;
    /*
	 * Compute coefficients for a cubic polynomial
	 *   p(s) = c0 + c1*s + c2*s^2 + c3*s^3
	 * such that
	 *   p(0) = x0, p(1) = x1
	 *  and
	 *   p'(0) = t0, p'(1) = t1.
	 */ function init(x0, x1, t0, t1) {
        c0 = x0;
        c1 = t0;
        c2 = -3 * x0 + 3 * x1 - 2 * t0 - t1;
        c3 = 2 * x0 - 2 * x1 + t0 + t1;
    }
    return {
        initCatmullRom: function initCatmullRom(x0, x1, x2, x3, tension) {
            init(x1, x2, tension * (x2 - x0), tension * (x3 - x1));
        },
        initNonuniformCatmullRom: function initNonuniformCatmullRom(x0, x1, x2, x3, dt0, dt1, dt2) {
            // compute tangents when parameterized in [t1,t2]
            var t1 = (x1 - x0) / dt0 - (x2 - x0) / (dt0 + dt1) + (x2 - x1) / dt1;
            var t2 = (x2 - x1) / dt1 - (x3 - x1) / (dt1 + dt2) + (x3 - x2) / dt2;
            // rescale tangents for parametrization in [0,1]
            t1 *= dt1;
            t2 *= dt1;
            init(x1, x2, t1, t2);
        },
        calc: function calc(t) {
            var t2 = t * t;
            var t3 = t2 * t;
            return c0 + c1 * t + c2 * t2 + c3 * t3;
        }
    };
}
//
var $c702e238df7c5123$var$tmp = new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$px = new $c702e238df7c5123$var$CubicPoly(), $c702e238df7c5123$var$py = new $c702e238df7c5123$var$CubicPoly(), $c702e238df7c5123$var$pz = new $c702e238df7c5123$var$CubicPoly();
var $c702e238df7c5123$export$b9146b27c24b744c = /*#__PURE__*/ function(Curve) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(CatmullRomCurve3, Curve);
    function CatmullRomCurve3() {
        var points = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], closed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, curveType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'centripetal', tension = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0.5;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, CatmullRomCurve3);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, CatmullRomCurve3);
        _this.type = 'CatmullRomCurve3';
        _this.points = points;
        _this.closed = closed;
        _this.curveType = curveType;
        _this.tension = tension;
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(CatmullRomCurve3, [
        {
            key: "getPoint",
            value: function getPoint(t) {
                var optionalTarget = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $c702e238df7c5123$export$64b5c384219d3699();
                var point = optionalTarget;
                var points = this.points;
                var l = points.length;
                var p = (l - (this.closed ? 0 : 1)) * t;
                var intPoint = Math.floor(p);
                var weight = p - intPoint;
                if (this.closed) intPoint += intPoint > 0 ? 0 : (Math.floor(Math.abs(intPoint) / l) + 1) * l;
                else if (weight === 0 && intPoint === l - 1) {
                    intPoint = l - 2;
                    weight = 1;
                }
                var p0, p3; // 4 points (p1 & p2 defined below)
                if (this.closed || intPoint > 0) p0 = points[(intPoint - 1) % l];
                else {
                    // extrapolate first point
                    $c702e238df7c5123$var$tmp.subVectors(points[0], points[1]).add(points[0]);
                    p0 = $c702e238df7c5123$var$tmp;
                }
                var p1 = points[intPoint % l];
                var p2 = points[(intPoint + 1) % l];
                if (this.closed || intPoint + 2 < l) p3 = points[(intPoint + 2) % l];
                else {
                    // extrapolate last point
                    $c702e238df7c5123$var$tmp.subVectors(points[l - 1], points[l - 2]).add(points[l - 1]);
                    p3 = $c702e238df7c5123$var$tmp;
                }
                if (this.curveType === 'centripetal' || this.curveType === 'chordal') {
                    // init Centripetal / Chordal Catmull-Rom
                    var pow = this.curveType === 'chordal' ? 0.5 : 0.25;
                    var dt0 = Math.pow(p0.distanceToSquared(p1), pow);
                    var dt1 = Math.pow(p1.distanceToSquared(p2), pow);
                    var dt2 = Math.pow(p2.distanceToSquared(p3), pow);
                    // safety check for repeated points
                    if (dt1 < 1e-4) dt1 = 1.0;
                    if (dt0 < 1e-4) dt0 = dt1;
                    if (dt2 < 1e-4) dt2 = dt1;
                    $c702e238df7c5123$var$px.initNonuniformCatmullRom(p0.x, p1.x, p2.x, p3.x, dt0, dt1, dt2);
                    $c702e238df7c5123$var$py.initNonuniformCatmullRom(p0.y, p1.y, p2.y, p3.y, dt0, dt1, dt2);
                    $c702e238df7c5123$var$pz.initNonuniformCatmullRom(p0.z, p1.z, p2.z, p3.z, dt0, dt1, dt2);
                } else if (this.curveType === 'catmullrom') {
                    $c702e238df7c5123$var$px.initCatmullRom(p0.x, p1.x, p2.x, p3.x, this.tension);
                    $c702e238df7c5123$var$py.initCatmullRom(p0.y, p1.y, p2.y, p3.y, this.tension);
                    $c702e238df7c5123$var$pz.initCatmullRom(p0.z, p1.z, p2.z, p3.z, this.tension);
                }
                point.set($c702e238df7c5123$var$px.calc(weight), $c702e238df7c5123$var$py.calc(weight), $c702e238df7c5123$var$pz.calc(weight));
                return point;
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(CatmullRomCurve3.prototype), "copy", this).call(this, source);
                this.points = [];
                for(var i = 0, l = source.points.length; i < l; i++){
                    var point = source.points[i];
                    this.points.push(point.clone());
                }
                this.closed = source.closed;
                this.curveType = source.curveType;
                this.tension = source.tension;
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(CatmullRomCurve3.prototype), "toJSON", this).call(this);
                data.points = [];
                for(var i = 0, l = this.points.length; i < l; i++){
                    var point = this.points[i];
                    data.points.push(point.toArray());
                }
                data.closed = this.closed;
                data.curveType = this.curveType;
                data.tension = this.tension;
                return data;
            }
        },
        {
            key: "fromJSON",
            value: function fromJSON(json) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(CatmullRomCurve3.prototype), "fromJSON", this).call(this, json);
                this.points = [];
                for(var i = 0, l = json.points.length; i < l; i++){
                    var point = json.points[i];
                    this.points.push(new $c702e238df7c5123$export$64b5c384219d3699().fromArray(point));
                }
                this.closed = json.closed;
                this.curveType = json.curveType;
                this.tension = json.tension;
                return this;
            }
        }
    ]);
    return CatmullRomCurve3;
}($c702e238df7c5123$export$b0e83c3ef8d2db1);
$c702e238df7c5123$export$b9146b27c24b744c.prototype.isCatmullRomCurve3 = true;
/**
 * Bezier Curves formulas obtained from
 * http://en.wikipedia.org/wiki/Bézier_curve
 */ function $c702e238df7c5123$var$CatmullRom(t, p0, p1, p2, p3) {
    var v0 = (p2 - p0) * 0.5;
    var v1 = (p3 - p1) * 0.5;
    var t2 = t * t;
    var t3 = t * t2;
    return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
}
//
function $c702e238df7c5123$var$QuadraticBezierP0(t, p) {
    var k = 1 - t;
    return k * k * p;
}
function $c702e238df7c5123$var$QuadraticBezierP1(t, p) {
    return 2 * (1 - t) * t * p;
}
function $c702e238df7c5123$var$QuadraticBezierP2(t, p) {
    return t * t * p;
}
function $c702e238df7c5123$var$QuadraticBezier(t, p0, p1, p2) {
    return $c702e238df7c5123$var$QuadraticBezierP0(t, p0) + $c702e238df7c5123$var$QuadraticBezierP1(t, p1) + $c702e238df7c5123$var$QuadraticBezierP2(t, p2);
}
//
function $c702e238df7c5123$var$CubicBezierP0(t, p) {
    var k = 1 - t;
    return k * k * k * p;
}
function $c702e238df7c5123$var$CubicBezierP1(t, p) {
    var k = 1 - t;
    return 3 * k * k * t * p;
}
function $c702e238df7c5123$var$CubicBezierP2(t, p) {
    return 3 * (1 - t) * t * t * p;
}
function $c702e238df7c5123$var$CubicBezierP3(t, p) {
    return t * t * t * p;
}
function $c702e238df7c5123$var$CubicBezier(t, p0, p1, p2, p3) {
    return $c702e238df7c5123$var$CubicBezierP0(t, p0) + $c702e238df7c5123$var$CubicBezierP1(t, p1) + $c702e238df7c5123$var$CubicBezierP2(t, p2) + $c702e238df7c5123$var$CubicBezierP3(t, p3);
}
var $c702e238df7c5123$export$e36650d36468bb39 = /*#__PURE__*/ function(Curve) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(CubicBezierCurve, Curve);
    function CubicBezierCurve() {
        var v0 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $c702e238df7c5123$export$c977b3e384af9ae1(), v1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $c702e238df7c5123$export$c977b3e384af9ae1(), v2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : new $c702e238df7c5123$export$c977b3e384af9ae1(), v3 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : new $c702e238df7c5123$export$c977b3e384af9ae1();
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, CubicBezierCurve);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, CubicBezierCurve);
        _this.type = 'CubicBezierCurve';
        _this.v0 = v0;
        _this.v1 = v1;
        _this.v2 = v2;
        _this.v3 = v3;
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(CubicBezierCurve, [
        {
            key: "getPoint",
            value: function getPoint(t) {
                var optionalTarget = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $c702e238df7c5123$export$c977b3e384af9ae1();
                var point = optionalTarget;
                var v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
                point.set($c702e238df7c5123$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $c702e238df7c5123$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y));
                return point;
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(CubicBezierCurve.prototype), "copy", this).call(this, source);
                this.v0.copy(source.v0);
                this.v1.copy(source.v1);
                this.v2.copy(source.v2);
                this.v3.copy(source.v3);
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(CubicBezierCurve.prototype), "toJSON", this).call(this);
                data.v0 = this.v0.toArray();
                data.v1 = this.v1.toArray();
                data.v2 = this.v2.toArray();
                data.v3 = this.v3.toArray();
                return data;
            }
        },
        {
            key: "fromJSON",
            value: function fromJSON(json) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(CubicBezierCurve.prototype), "fromJSON", this).call(this, json);
                this.v0.fromArray(json.v0);
                this.v1.fromArray(json.v1);
                this.v2.fromArray(json.v2);
                this.v3.fromArray(json.v3);
                return this;
            }
        }
    ]);
    return CubicBezierCurve;
}($c702e238df7c5123$export$b0e83c3ef8d2db1);
$c702e238df7c5123$export$e36650d36468bb39.prototype.isCubicBezierCurve = true;
var $c702e238df7c5123$export$13d5f1c9525f246c = /*#__PURE__*/ function(Curve) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(CubicBezierCurve3, Curve);
    function CubicBezierCurve3() {
        var v0 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $c702e238df7c5123$export$64b5c384219d3699(), v1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $c702e238df7c5123$export$64b5c384219d3699(), v2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : new $c702e238df7c5123$export$64b5c384219d3699(), v3 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : new $c702e238df7c5123$export$64b5c384219d3699();
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, CubicBezierCurve3);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, CubicBezierCurve3);
        _this.type = 'CubicBezierCurve3';
        _this.v0 = v0;
        _this.v1 = v1;
        _this.v2 = v2;
        _this.v3 = v3;
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(CubicBezierCurve3, [
        {
            key: "getPoint",
            value: function getPoint(t) {
                var optionalTarget = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $c702e238df7c5123$export$64b5c384219d3699();
                var point = optionalTarget;
                var v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
                point.set($c702e238df7c5123$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $c702e238df7c5123$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y), $c702e238df7c5123$var$CubicBezier(t, v0.z, v1.z, v2.z, v3.z));
                return point;
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(CubicBezierCurve3.prototype), "copy", this).call(this, source);
                this.v0.copy(source.v0);
                this.v1.copy(source.v1);
                this.v2.copy(source.v2);
                this.v3.copy(source.v3);
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(CubicBezierCurve3.prototype), "toJSON", this).call(this);
                data.v0 = this.v0.toArray();
                data.v1 = this.v1.toArray();
                data.v2 = this.v2.toArray();
                data.v3 = this.v3.toArray();
                return data;
            }
        },
        {
            key: "fromJSON",
            value: function fromJSON(json) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(CubicBezierCurve3.prototype), "fromJSON", this).call(this, json);
                this.v0.fromArray(json.v0);
                this.v1.fromArray(json.v1);
                this.v2.fromArray(json.v2);
                this.v3.fromArray(json.v3);
                return this;
            }
        }
    ]);
    return CubicBezierCurve3;
}($c702e238df7c5123$export$b0e83c3ef8d2db1);
$c702e238df7c5123$export$13d5f1c9525f246c.prototype.isCubicBezierCurve3 = true;
var $c702e238df7c5123$export$ab2e07e76531a47e = /*#__PURE__*/ function(Curve) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(LineCurve, Curve);
    function LineCurve() {
        var v1 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $c702e238df7c5123$export$c977b3e384af9ae1(), v2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $c702e238df7c5123$export$c977b3e384af9ae1();
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, LineCurve);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, LineCurve);
        _this.type = 'LineCurve';
        _this.v1 = v1;
        _this.v2 = v2;
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(LineCurve, [
        {
            key: "getPoint",
            value: function getPoint(t) {
                var optionalTarget = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $c702e238df7c5123$export$c977b3e384af9ae1();
                var point = optionalTarget;
                if (t === 1) point.copy(this.v2);
                else {
                    point.copy(this.v2).sub(this.v1);
                    point.multiplyScalar(t).add(this.v1);
                }
                return point;
            }
        },
        {
            // Line curve is linear, so we can overwrite default getPointAt
            key: "getPointAt",
            value: function getPointAt(u, optionalTarget) {
                return this.getPoint(u, optionalTarget);
            }
        },
        {
            key: "getTangent",
            value: function getTangent(t, optionalTarget) {
                var tangent = optionalTarget || new $c702e238df7c5123$export$c977b3e384af9ae1();
                tangent.copy(this.v2).sub(this.v1).normalize();
                return tangent;
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(LineCurve.prototype), "copy", this).call(this, source);
                this.v1.copy(source.v1);
                this.v2.copy(source.v2);
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(LineCurve.prototype), "toJSON", this).call(this);
                data.v1 = this.v1.toArray();
                data.v2 = this.v2.toArray();
                return data;
            }
        },
        {
            key: "fromJSON",
            value: function fromJSON(json) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(LineCurve.prototype), "fromJSON", this).call(this, json);
                this.v1.fromArray(json.v1);
                this.v2.fromArray(json.v2);
                return this;
            }
        }
    ]);
    return LineCurve;
}($c702e238df7c5123$export$b0e83c3ef8d2db1);
$c702e238df7c5123$export$ab2e07e76531a47e.prototype.isLineCurve = true;
var $c702e238df7c5123$export$1fdfd9d9cf487600 = /*#__PURE__*/ function(Curve) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(LineCurve3, Curve);
    function LineCurve3() {
        var v1 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $c702e238df7c5123$export$64b5c384219d3699(), v2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $c702e238df7c5123$export$64b5c384219d3699();
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, LineCurve3);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, LineCurve3);
        _this.type = 'LineCurve3';
        _this.isLineCurve3 = true;
        _this.v1 = v1;
        _this.v2 = v2;
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(LineCurve3, [
        {
            key: "getPoint",
            value: function getPoint(t) {
                var optionalTarget = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $c702e238df7c5123$export$64b5c384219d3699();
                var point = optionalTarget;
                if (t === 1) point.copy(this.v2);
                else {
                    point.copy(this.v2).sub(this.v1);
                    point.multiplyScalar(t).add(this.v1);
                }
                return point;
            }
        },
        {
            // Line curve is linear, so we can overwrite default getPointAt
            key: "getPointAt",
            value: function getPointAt(u, optionalTarget) {
                return this.getPoint(u, optionalTarget);
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(LineCurve3.prototype), "copy", this).call(this, source);
                this.v1.copy(source.v1);
                this.v2.copy(source.v2);
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(LineCurve3.prototype), "toJSON", this).call(this);
                data.v1 = this.v1.toArray();
                data.v2 = this.v2.toArray();
                return data;
            }
        },
        {
            key: "fromJSON",
            value: function fromJSON(json) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(LineCurve3.prototype), "fromJSON", this).call(this, json);
                this.v1.fromArray(json.v1);
                this.v2.fromArray(json.v2);
                return this;
            }
        }
    ]);
    return LineCurve3;
}($c702e238df7c5123$export$b0e83c3ef8d2db1);
var $c702e238df7c5123$export$5938c4ee491a43ad = /*#__PURE__*/ function(Curve) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(QuadraticBezierCurve, Curve);
    function QuadraticBezierCurve() {
        var v0 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $c702e238df7c5123$export$c977b3e384af9ae1(), v1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $c702e238df7c5123$export$c977b3e384af9ae1(), v2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : new $c702e238df7c5123$export$c977b3e384af9ae1();
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, QuadraticBezierCurve);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, QuadraticBezierCurve);
        _this.type = 'QuadraticBezierCurve';
        _this.v0 = v0;
        _this.v1 = v1;
        _this.v2 = v2;
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(QuadraticBezierCurve, [
        {
            key: "getPoint",
            value: function getPoint(t) {
                var optionalTarget = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $c702e238df7c5123$export$c977b3e384af9ae1();
                var point = optionalTarget;
                var v0 = this.v0, v1 = this.v1, v2 = this.v2;
                point.set($c702e238df7c5123$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $c702e238df7c5123$var$QuadraticBezier(t, v0.y, v1.y, v2.y));
                return point;
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(QuadraticBezierCurve.prototype), "copy", this).call(this, source);
                this.v0.copy(source.v0);
                this.v1.copy(source.v1);
                this.v2.copy(source.v2);
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(QuadraticBezierCurve.prototype), "toJSON", this).call(this);
                data.v0 = this.v0.toArray();
                data.v1 = this.v1.toArray();
                data.v2 = this.v2.toArray();
                return data;
            }
        },
        {
            key: "fromJSON",
            value: function fromJSON(json) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(QuadraticBezierCurve.prototype), "fromJSON", this).call(this, json);
                this.v0.fromArray(json.v0);
                this.v1.fromArray(json.v1);
                this.v2.fromArray(json.v2);
                return this;
            }
        }
    ]);
    return QuadraticBezierCurve;
}($c702e238df7c5123$export$b0e83c3ef8d2db1);
$c702e238df7c5123$export$5938c4ee491a43ad.prototype.isQuadraticBezierCurve = true;
var $c702e238df7c5123$export$bf3f4c7e459f90fc = /*#__PURE__*/ function(Curve) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(QuadraticBezierCurve3, Curve);
    function QuadraticBezierCurve3() {
        var v0 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $c702e238df7c5123$export$64b5c384219d3699(), v1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $c702e238df7c5123$export$64b5c384219d3699(), v2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : new $c702e238df7c5123$export$64b5c384219d3699();
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, QuadraticBezierCurve3);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, QuadraticBezierCurve3);
        _this.type = 'QuadraticBezierCurve3';
        _this.v0 = v0;
        _this.v1 = v1;
        _this.v2 = v2;
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(QuadraticBezierCurve3, [
        {
            key: "getPoint",
            value: function getPoint(t) {
                var optionalTarget = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $c702e238df7c5123$export$64b5c384219d3699();
                var point = optionalTarget;
                var v0 = this.v0, v1 = this.v1, v2 = this.v2;
                point.set($c702e238df7c5123$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $c702e238df7c5123$var$QuadraticBezier(t, v0.y, v1.y, v2.y), $c702e238df7c5123$var$QuadraticBezier(t, v0.z, v1.z, v2.z));
                return point;
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(QuadraticBezierCurve3.prototype), "copy", this).call(this, source);
                this.v0.copy(source.v0);
                this.v1.copy(source.v1);
                this.v2.copy(source.v2);
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(QuadraticBezierCurve3.prototype), "toJSON", this).call(this);
                data.v0 = this.v0.toArray();
                data.v1 = this.v1.toArray();
                data.v2 = this.v2.toArray();
                return data;
            }
        },
        {
            key: "fromJSON",
            value: function fromJSON(json) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(QuadraticBezierCurve3.prototype), "fromJSON", this).call(this, json);
                this.v0.fromArray(json.v0);
                this.v1.fromArray(json.v1);
                this.v2.fromArray(json.v2);
                return this;
            }
        }
    ]);
    return QuadraticBezierCurve3;
}($c702e238df7c5123$export$b0e83c3ef8d2db1);
$c702e238df7c5123$export$bf3f4c7e459f90fc.prototype.isQuadraticBezierCurve3 = true;
var $c702e238df7c5123$export$d3bdd77da77afc1b = /*#__PURE__*/ function(Curve) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(SplineCurve, Curve);
    function SplineCurve() {
        var points = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, SplineCurve);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, SplineCurve);
        _this.type = 'SplineCurve';
        _this.points = points;
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(SplineCurve, [
        {
            key: "getPoint",
            value: function getPoint(t) {
                var optionalTarget = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $c702e238df7c5123$export$c977b3e384af9ae1();
                var point = optionalTarget;
                var points = this.points;
                var p = (points.length - 1) * t;
                var intPoint = Math.floor(p);
                var weight = p - intPoint;
                var p0 = points[intPoint === 0 ? intPoint : intPoint - 1];
                var p1 = points[intPoint];
                var p2 = points[intPoint > points.length - 2 ? points.length - 1 : intPoint + 1];
                var p3 = points[intPoint > points.length - 3 ? points.length - 1 : intPoint + 2];
                point.set($c702e238df7c5123$var$CatmullRom(weight, p0.x, p1.x, p2.x, p3.x), $c702e238df7c5123$var$CatmullRom(weight, p0.y, p1.y, p2.y, p3.y));
                return point;
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(SplineCurve.prototype), "copy", this).call(this, source);
                this.points = [];
                for(var i = 0, l = source.points.length; i < l; i++){
                    var point = source.points[i];
                    this.points.push(point.clone());
                }
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(SplineCurve.prototype), "toJSON", this).call(this);
                data.points = [];
                for(var i = 0, l = this.points.length; i < l; i++){
                    var point = this.points[i];
                    data.points.push(point.toArray());
                }
                return data;
            }
        },
        {
            key: "fromJSON",
            value: function fromJSON(json) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(SplineCurve.prototype), "fromJSON", this).call(this, json);
                this.points = [];
                for(var i = 0, l = json.points.length; i < l; i++){
                    var point = json.points[i];
                    this.points.push(new $c702e238df7c5123$export$c977b3e384af9ae1().fromArray(point));
                }
                return this;
            }
        }
    ]);
    return SplineCurve;
}($c702e238df7c5123$export$b0e83c3ef8d2db1);
$c702e238df7c5123$export$d3bdd77da77afc1b.prototype.isSplineCurve = true;
var $c702e238df7c5123$var$Curves = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcCurve: $c702e238df7c5123$export$b1eedc9aab6300e8,
    CatmullRomCurve3: $c702e238df7c5123$export$b9146b27c24b744c,
    CubicBezierCurve: $c702e238df7c5123$export$e36650d36468bb39,
    CubicBezierCurve3: $c702e238df7c5123$export$13d5f1c9525f246c,
    EllipseCurve: $c702e238df7c5123$export$3f87a931616cde04,
    LineCurve: $c702e238df7c5123$export$ab2e07e76531a47e,
    LineCurve3: $c702e238df7c5123$export$1fdfd9d9cf487600,
    QuadraticBezierCurve: $c702e238df7c5123$export$5938c4ee491a43ad,
    QuadraticBezierCurve3: $c702e238df7c5123$export$bf3f4c7e459f90fc,
    SplineCurve: $c702e238df7c5123$export$d3bdd77da77afc1b
});
/**
 * Port from https://github.com/mapbox/earcut (v2.2.2)
 */ var $c702e238df7c5123$var$Earcut = {
    triangulate: function triangulate(data, holeIndices) {
        var dim = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 2;
        var hasHoles = holeIndices && holeIndices.length;
        var outerLen = hasHoles ? holeIndices[0] * dim : data.length;
        var outerNode = $c702e238df7c5123$var$linkedList(data, 0, outerLen, dim, true);
        var triangles = [];
        if (!outerNode || outerNode.next === outerNode.prev) return triangles;
        var minX, minY, maxX, maxY, x, y, invSize;
        if (hasHoles) outerNode = $c702e238df7c5123$var$eliminateHoles(data, holeIndices, outerNode, dim);
        // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
        if (data.length > 80 * dim) {
            minX = maxX = data[0];
            minY = maxY = data[1];
            for(var i = dim; i < outerLen; i += dim){
                x = data[i];
                y = data[i + 1];
                if (x < minX) minX = x;
                if (y < minY) minY = y;
                if (x > maxX) maxX = x;
                if (y > maxY) maxY = y;
            }
            // minX, minY and invSize are later used to transform coords into integers for z-order calculation
            invSize = Math.max(maxX - minX, maxY - minY);
            invSize = invSize !== 0 ? 1 / invSize : 0;
        }
        $c702e238df7c5123$var$earcutLinked(outerNode, triangles, dim, minX, minY, invSize);
        return triangles;
    }
};
// create a circular doubly linked list from polygon points in the specified winding order
function $c702e238df7c5123$var$linkedList(data, start, end, dim, clockwise) {
    var i, last;
    if (clockwise === $c702e238df7c5123$var$signedArea(data, start, end, dim) > 0) for(i = start; i < end; i += dim)last = $c702e238df7c5123$var$insertNode(i, data[i], data[i + 1], last);
    else for(i = end - dim; i >= start; i -= dim)last = $c702e238df7c5123$var$insertNode(i, data[i], data[i + 1], last);
    if (last && $c702e238df7c5123$var$equals(last, last.next)) {
        $c702e238df7c5123$var$removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function $c702e238df7c5123$var$filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    var p = start, again;
    do {
        again = false;
        if (!p.steiner && ($c702e238df7c5123$var$equals(p, p.next) || $c702e238df7c5123$var$area(p.prev, p, p.next) === 0)) {
            $c702e238df7c5123$var$removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function $c702e238df7c5123$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) $c702e238df7c5123$var$indexCurve(ear, minX, minY, invSize);
    var stop = ear, prev, next;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        prev = ear.prev;
        next = ear.next;
        if (invSize ? $c702e238df7c5123$var$isEarHashed(ear, minX, minY, invSize) : $c702e238df7c5123$var$isEar(ear)) {
            // cut off the triangle
            triangles.push(prev.i / dim);
            triangles.push(ear.i / dim);
            triangles.push(next.i / dim);
            $c702e238df7c5123$var$removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) $c702e238df7c5123$var$earcutLinked($c702e238df7c5123$var$filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = $c702e238df7c5123$var$cureLocalIntersections($c702e238df7c5123$var$filterPoints(ear), triangles, dim);
                $c702e238df7c5123$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) $c702e238df7c5123$var$splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function $c702e238df7c5123$var$isEar(ear) {
    var a = ear.prev, b = ear, c = ear.next;
    if ($c702e238df7c5123$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    var p = ear.next.next;
    while(p !== ear.prev){
        if ($c702e238df7c5123$var$pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && $c702e238df7c5123$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function $c702e238df7c5123$var$isEarHashed(ear, minX, minY, invSize) {
    var a = ear.prev, b = ear, c = ear.next;
    if ($c702e238df7c5123$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // triangle bbox; min & max are calculated like this for speed
    var minTX = a.x < b.x ? a.x < c.x ? a.x : c.x : b.x < c.x ? b.x : c.x, minTY = a.y < b.y ? a.y < c.y ? a.y : c.y : b.y < c.y ? b.y : c.y, maxTX = a.x > b.x ? a.x > c.x ? a.x : c.x : b.x > c.x ? b.x : c.x, maxTY = a.y > b.y ? a.y > c.y ? a.y : c.y : b.y > c.y ? b.y : c.y;
    // z-order range for the current triangle bbox;
    var minZ = $c702e238df7c5123$var$zOrder(minTX, minTY, minX, minY, invSize), maxZ = $c702e238df7c5123$var$zOrder(maxTX, maxTY, minX, minY, invSize);
    var p = ear.prevZ, n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p !== ear.prev && p !== ear.next && $c702e238df7c5123$var$pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && $c702e238df7c5123$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n !== ear.prev && n !== ear.next && $c702e238df7c5123$var$pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) && $c702e238df7c5123$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p !== ear.prev && p !== ear.next && $c702e238df7c5123$var$pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && $c702e238df7c5123$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n !== ear.prev && n !== ear.next && $c702e238df7c5123$var$pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) && $c702e238df7c5123$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function $c702e238df7c5123$var$cureLocalIntersections(start, triangles, dim) {
    var p = start;
    do {
        var a = p.prev, b = p.next.next;
        if (!$c702e238df7c5123$var$equals(a, b) && $c702e238df7c5123$var$intersects(a, p, p.next, b) && $c702e238df7c5123$var$locallyInside(a, b) && $c702e238df7c5123$var$locallyInside(b, a)) {
            triangles.push(a.i / dim);
            triangles.push(p.i / dim);
            triangles.push(b.i / dim);
            // remove two nodes involved
            $c702e238df7c5123$var$removeNode(p);
            $c702e238df7c5123$var$removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return $c702e238df7c5123$var$filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function $c702e238df7c5123$var$splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    var a = start;
    do {
        var b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && $c702e238df7c5123$var$isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                var c = $c702e238df7c5123$var$splitPolygon(a, b);
                // filter colinear points around the cuts
                a = $c702e238df7c5123$var$filterPoints(a, a.next);
                c = $c702e238df7c5123$var$filterPoints(c, c.next);
                // run earcut on each half
                $c702e238df7c5123$var$earcutLinked(a, triangles, dim, minX, minY, invSize);
                $c702e238df7c5123$var$earcutLinked(c, triangles, dim, minX, minY, invSize);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function $c702e238df7c5123$var$eliminateHoles(data, holeIndices, outerNode, dim) {
    var queue = [];
    var i, len, start, end, list;
    for(i = 0, len = holeIndices.length; i < len; i++){
        start = holeIndices[i] * dim;
        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        list = $c702e238df7c5123$var$linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push($c702e238df7c5123$var$getLeftmost(list));
    }
    queue.sort($c702e238df7c5123$var$compareX);
    // process holes from left to right
    for(i = 0; i < queue.length; i++){
        $c702e238df7c5123$var$eliminateHole(queue[i], outerNode);
        outerNode = $c702e238df7c5123$var$filterPoints(outerNode, outerNode.next);
    }
    return outerNode;
}
function $c702e238df7c5123$var$compareX(a, b) {
    return a.x - b.x;
}
// find a bridge between vertices that connects hole with an outer ring and and link it
function $c702e238df7c5123$var$eliminateHole(hole, outerNode) {
    outerNode = $c702e238df7c5123$var$findHoleBridge(hole, outerNode);
    if (outerNode) {
        var b = $c702e238df7c5123$var$splitPolygon(outerNode, hole);
        // filter collinear points around the cuts
        $c702e238df7c5123$var$filterPoints(outerNode, outerNode.next);
        $c702e238df7c5123$var$filterPoints(b, b.next);
    }
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function $c702e238df7c5123$var$findHoleBridge(hole, outerNode) {
    var p = outerNode;
    var hx = hole.x;
    var hy = hole.y;
    var qx = -Infinity, m;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    do {
        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            var x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                if (x === hx) {
                    if (hy === p.y) return p;
                    if (hy === p.next.y) return p.next;
                }
                m = p.x < p.next.x ? p : p.next;
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    if (hx === qx) return m; // hole touches outer segment; pick leftmost endpoint
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    var stop = m, mx = m.x, my = m.y;
    var tanMin = Infinity, tan;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && $c702e238df7c5123$var$pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if ($c702e238df7c5123$var$locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && $c702e238df7c5123$var$sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function $c702e238df7c5123$var$sectorContainsSector(m, p) {
    return $c702e238df7c5123$var$area(m.prev, m, p.prev) < 0 && $c702e238df7c5123$var$area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function $c702e238df7c5123$var$indexCurve(start, minX, minY, invSize) {
    var p = start;
    do {
        if (p.z === null) p.z = $c702e238df7c5123$var$zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    $c702e238df7c5123$var$sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function $c702e238df7c5123$var$sortLinked(list) {
    var i, p, q, e, tail, numMerges, pSize, qSize, inSize = 1;
    do {
        p = list;
        list = null;
        tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            q = p;
            pSize = 0;
            for(i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function $c702e238df7c5123$var$zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = 32767 * (x - minX) * invSize;
    y = 32767 * (y - minY) * invSize;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function $c702e238df7c5123$var$getLeftmost(start) {
    var p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function $c702e238df7c5123$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) - (ax - px) * (cy - py) >= 0 && (ax - px) * (by - py) - (bx - px) * (ay - py) >= 0 && (bx - px) * (cy - py) - (cx - px) * (by - py) >= 0;
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function $c702e238df7c5123$var$isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !$c702e238df7c5123$var$intersectsPolygon(a, b) && // dones't intersect other edges
    ($c702e238df7c5123$var$locallyInside(a, b) && $c702e238df7c5123$var$locallyInside(b, a) && $c702e238df7c5123$var$middleInside(a, b) && // locally visible
    ($c702e238df7c5123$var$area(a.prev, a, b.prev) || $c702e238df7c5123$var$area(a, b.prev, b)) || // does not create opposite-facing sectors
    $c702e238df7c5123$var$equals(a, b) && $c702e238df7c5123$var$area(a.prev, a, a.next) > 0 && $c702e238df7c5123$var$area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function $c702e238df7c5123$var$area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function $c702e238df7c5123$var$equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function $c702e238df7c5123$var$intersects(p1, q1, p2, q2) {
    var o1 = $c702e238df7c5123$var$sign($c702e238df7c5123$var$area(p1, q1, p2));
    var o2 = $c702e238df7c5123$var$sign($c702e238df7c5123$var$area(p1, q1, q2));
    var o3 = $c702e238df7c5123$var$sign($c702e238df7c5123$var$area(p2, q2, p1));
    var o4 = $c702e238df7c5123$var$sign($c702e238df7c5123$var$area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && $c702e238df7c5123$var$onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && $c702e238df7c5123$var$onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && $c702e238df7c5123$var$onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && $c702e238df7c5123$var$onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function $c702e238df7c5123$var$onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function $c702e238df7c5123$var$sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function $c702e238df7c5123$var$intersectsPolygon(a, b) {
    var p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && $c702e238df7c5123$var$intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function $c702e238df7c5123$var$locallyInside(a, b) {
    return $c702e238df7c5123$var$area(a.prev, a, a.next) < 0 ? $c702e238df7c5123$var$area(a, b, a.next) >= 0 && $c702e238df7c5123$var$area(a, a.prev, b) >= 0 : $c702e238df7c5123$var$area(a, b, a.prev) < 0 || $c702e238df7c5123$var$area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function $c702e238df7c5123$var$middleInside(a, b) {
    var p = a, inside = false;
    var px = (a.x + b.x) / 2, py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function $c702e238df7c5123$var$splitPolygon(a, b) {
    var a2 = new $c702e238df7c5123$var$Node(a.i, a.x, a.y), b2 = new $c702e238df7c5123$var$Node(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function $c702e238df7c5123$var$insertNode(i, x, y, last) {
    var p = new $c702e238df7c5123$var$Node(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function $c702e238df7c5123$var$removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function $c702e238df7c5123$var$Node(i, x, y) {
    // vertex index in coordinates array
    this.i = i;
    // vertex coordinates
    this.x = x;
    this.y = y;
    // previous and next vertex nodes in a polygon ring
    this.prev = null;
    this.next = null;
    // z-order curve value
    this.z = null;
    // previous and next nodes in z-order
    this.prevZ = null;
    this.nextZ = null;
    // indicates whether this is a steiner point
    this.steiner = false;
}
function $c702e238df7c5123$var$signedArea(data, start, end, dim) {
    var sum = 0;
    for(var i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
var $c702e238df7c5123$export$96bdf6d9c66d7ba8 = /*#__PURE__*/ function() {
    "use strict";
    function ShapeUtils() {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, ShapeUtils);
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(ShapeUtils, null, [
        {
            key: "area",
            value: // calculate area of the contour polygon
            function area(contour) {
                var n = contour.length;
                var a = 0.0;
                for(var p = n - 1, q = 0; q < n; p = q++)a += contour[p].x * contour[q].y - contour[q].x * contour[p].y;
                return a * 0.5;
            }
        },
        {
            key: "isClockWise",
            value: function isClockWise(pts) {
                return ShapeUtils.area(pts) < 0;
            }
        },
        {
            key: "triangulateShape",
            value: function triangulateShape(contour, holes) {
                var vertices = []; // flat array of vertices like [ x0,y0, x1,y1, x2,y2, ... ]
                var holeIndices = []; // array of hole indices
                var faces = []; // final array of vertex indices like [ [ a,b,d ], [ b,c,d ] ]
                $c702e238df7c5123$var$removeDupEndPts(contour);
                $c702e238df7c5123$var$addContour(vertices, contour);
                //
                var holeIndex = contour.length;
                holes.forEach($c702e238df7c5123$var$removeDupEndPts);
                for(var i = 0; i < holes.length; i++){
                    holeIndices.push(holeIndex);
                    holeIndex += holes[i].length;
                    $c702e238df7c5123$var$addContour(vertices, holes[i]);
                }
                //
                var triangles = $c702e238df7c5123$var$Earcut.triangulate(vertices, holeIndices);
                //
                for(var i1 = 0; i1 < triangles.length; i1 += 3)faces.push(triangles.slice(i1, i1 + 3));
                return faces;
            }
        }
    ]);
    return ShapeUtils;
}();
function $c702e238df7c5123$var$removeDupEndPts(points) {
    var l = points.length;
    if (l > 2 && points[l - 1].equals(points[0])) points.pop();
}
function $c702e238df7c5123$var$addContour(vertices, contour) {
    for(var i = 0; i < contour.length; i++){
        vertices.push(contour[i].x);
        vertices.push(contour[i].y);
    }
}
/**
 * Creates extruded geometry from a path shape.
 *
 * parameters = {
 *
 *  curveSegments: <int>, // number of points on the curves
 *  steps: <int>, // number of points for z-side extrusions / used for subdividing segments of extrude spline too
 *  depth: <float>, // Depth to extrude the shape
 *
 *  bevelEnabled: <bool>, // turn on bevel
 *  bevelThickness: <float>, // how deep into the original shape bevel goes
 *  bevelSize: <float>, // how far from shape outline (including bevelOffset) is bevel
 *  bevelOffset: <float>, // how far from shape outline does bevel start
 *  bevelSegments: <int>, // number of bevel layers
 *
 *  extrudePath: <THREE.Curve> // curve to extrude shape along
 *
 *  UVGenerator: <Object> // object that provides UV generator functions
 *
 * }
 */ var $c702e238df7c5123$export$91836d01b9f75a58 = /*#__PURE__*/ function(BufferGeometry) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(ExtrudeGeometry, BufferGeometry);
    function ExtrudeGeometry(shapes, options) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, ExtrudeGeometry);
        var _this;
        var addShape = // functions
        function addShape(shape) {
            var placeholder = [];
            // options
            var curveSegments = options.curveSegments !== undefined ? options.curveSegments : 12;
            var steps = options.steps !== undefined ? options.steps : 1;
            var depth = options.depth !== undefined ? options.depth : 100;
            var bevelEnabled = options.bevelEnabled !== undefined ? options.bevelEnabled : true;
            var bevelThickness = options.bevelThickness !== undefined ? options.bevelThickness : 6;
            var bevelSize = options.bevelSize !== undefined ? options.bevelSize : bevelThickness - 2;
            var bevelOffset = options.bevelOffset !== undefined ? options.bevelOffset : 0;
            var bevelSegments = options.bevelSegments !== undefined ? options.bevelSegments : 3;
            var extrudePath = options.extrudePath;
            var uvgen = options.UVGenerator !== undefined ? options.UVGenerator : $c702e238df7c5123$var$WorldUVGenerator;
            // deprecated options
            if (options.amount !== undefined) {
                console.warn('THREE.ExtrudeBufferGeometry: amount has been renamed to depth.');
                depth = options.amount;
            }
            //
            var extrudePts, extrudeByPath = false;
            var splineTube, binormal, normal, position2;
            if (extrudePath) {
                extrudePts = extrudePath.getSpacedPoints(steps);
                extrudeByPath = true;
                bevelEnabled = false; // bevels not supported for path extrusion
                // SETUP TNB variables
                // TODO1 - have a .isClosed in spline?
                splineTube = extrudePath.computeFrenetFrames(steps, false);
                // console.log(splineTube, 'splineTube', splineTube.normals.length, 'steps', steps, 'extrudePts', extrudePts.length);
                binormal = new $c702e238df7c5123$export$64b5c384219d3699();
                normal = new $c702e238df7c5123$export$64b5c384219d3699();
                position2 = new $c702e238df7c5123$export$64b5c384219d3699();
            }
            // Safeguards if bevels are not enabled
            if (!bevelEnabled) {
                bevelSegments = 0;
                bevelThickness = 0;
                bevelSize = 0;
                bevelOffset = 0;
            }
            // Variables initialization
            var shapePoints = shape.extractPoints(curveSegments);
            var vertices = shapePoints.shape;
            var holes = shapePoints.holes;
            var reverse = !$c702e238df7c5123$export$96bdf6d9c66d7ba8.isClockWise(vertices);
            if (reverse) {
                vertices = vertices.reverse();
                // Maybe we should also check if holes are in the opposite direction, just to be safe ...
                for(var h = 0, hl = holes.length; h < hl; h++){
                    var ahole = holes[h];
                    if ($c702e238df7c5123$export$96bdf6d9c66d7ba8.isClockWise(ahole)) holes[h] = ahole.reverse();
                }
            }
            var faces = $c702e238df7c5123$export$96bdf6d9c66d7ba8.triangulateShape(vertices, holes);
            /* Vertices */ var contour = vertices; // vertices has all points but contour has only points of circumference
            for(var h1 = 0, hl1 = holes.length; h1 < hl1; h1++){
                var ahole1 = holes[h1];
                vertices = vertices.concat(ahole1);
            }
            function scalePt2(pt, vec, size) {
                if (!vec) console.error('THREE.ExtrudeGeometry: vec does not exist');
                return vec.clone().multiplyScalar(size).add(pt);
            }
            var vlen = vertices.length, flen = faces.length;
            // Find directions for point movement
            function getBevelVec(inPt, inPrev, inNext) {
                // computes for inPt the corresponding point inPt' on a new contour
                //   shifted by 1 unit (length of normalized vector) to the left
                // if we walk along contour clockwise, this new contour is outside the old one
                //
                // inPt' is the intersection of the two lines parallel to the two
                //  adjacent edges of inPt at a distance of 1 unit on the left side.
                var v_trans_x, v_trans_y, shrink_by; // resulting translation vector for inPt
                // good reading for geometry algorithms (here: line-line intersection)
                // http://geomalgorithms.com/a05-_intersect-1.html
                var v_prev_x = inPt.x - inPrev.x, v_prev_y = inPt.y - inPrev.y;
                var v_next_x = inNext.x - inPt.x, v_next_y = inNext.y - inPt.y;
                var v_prev_lensq = v_prev_x * v_prev_x + v_prev_y * v_prev_y;
                // check for collinear edges
                var collinear0 = v_prev_x * v_next_y - v_prev_y * v_next_x;
                if (Math.abs(collinear0) > Number.EPSILON) {
                    // not collinear
                    // length of vectors for normalizing
                    var v_prev_len = Math.sqrt(v_prev_lensq);
                    var v_next_len = Math.sqrt(v_next_x * v_next_x + v_next_y * v_next_y);
                    // shift adjacent points by unit vectors to the left
                    var ptPrevShift_x = inPrev.x - v_prev_y / v_prev_len;
                    var ptPrevShift_y = inPrev.y + v_prev_x / v_prev_len;
                    var ptNextShift_x = inNext.x - v_next_y / v_next_len;
                    var ptNextShift_y = inNext.y + v_next_x / v_next_len;
                    // scaling factor for v_prev to intersection point
                    var sf = ((ptNextShift_x - ptPrevShift_x) * v_next_y - (ptNextShift_y - ptPrevShift_y) * v_next_x) / (v_prev_x * v_next_y - v_prev_y * v_next_x);
                    // vector from inPt to intersection point
                    v_trans_x = ptPrevShift_x + v_prev_x * sf - inPt.x;
                    v_trans_y = ptPrevShift_y + v_prev_y * sf - inPt.y;
                    // Don't normalize!, otherwise sharp corners become ugly
                    //  but prevent crazy spikes
                    var v_trans_lensq = v_trans_x * v_trans_x + v_trans_y * v_trans_y;
                    if (v_trans_lensq <= 2) return new $c702e238df7c5123$export$c977b3e384af9ae1(v_trans_x, v_trans_y);
                    else shrink_by = Math.sqrt(v_trans_lensq / 2);
                } else {
                    // handle special case of collinear edges
                    var direction_eq = false; // assumes: opposite
                    if (v_prev_x > Number.EPSILON) {
                        if (v_next_x > Number.EPSILON) direction_eq = true;
                    } else {
                        if (v_prev_x < -Number.EPSILON) {
                            if (v_next_x < -Number.EPSILON) direction_eq = true;
                        } else if (Math.sign(v_prev_y) === Math.sign(v_next_y)) direction_eq = true;
                    }
                    if (direction_eq) {
                        // console.log("Warning: lines are a straight sequence");
                        v_trans_x = -v_prev_y;
                        v_trans_y = v_prev_x;
                        shrink_by = Math.sqrt(v_prev_lensq);
                    } else {
                        // console.log("Warning: lines are a straight spike");
                        v_trans_x = v_prev_x;
                        v_trans_y = v_prev_y;
                        shrink_by = Math.sqrt(v_prev_lensq / 2);
                    }
                }
                return new $c702e238df7c5123$export$c977b3e384af9ae1(v_trans_x / shrink_by, v_trans_y / shrink_by);
            }
            var contourMovements = [];
            for(var i = 0, il = contour.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                if (j === il) j = 0;
                if (k === il) k = 0;
                //  (j)---(i)---(k)
                // console.log('i,j,k', i, j , k)
                contourMovements[i] = getBevelVec(contour[i], contour[j], contour[k]);
            }
            var holesMovements = [];
            var oneHoleMovements, verticesMovements = contourMovements.concat();
            for(var h2 = 0, hl2 = holes.length; h2 < hl2; h2++){
                var ahole2 = holes[h2];
                oneHoleMovements = [];
                for(var i1 = 0, il1 = ahole2.length, j1 = il1 - 1, k1 = i1 + 1; i1 < il1; i1++, j1++, k1++){
                    if (j1 === il1) j1 = 0;
                    if (k1 === il1) k1 = 0;
                    //  (j)---(i)---(k)
                    oneHoleMovements[i1] = getBevelVec(ahole2[i1], ahole2[j1], ahole2[k1]);
                }
                holesMovements.push(oneHoleMovements);
                verticesMovements = verticesMovements.concat(oneHoleMovements);
            }
            // Loop bevelSegments, 1 for the front, 1 for the back
            for(var b = 0; b < bevelSegments; b++){
                //for ( b = bevelSegments; b > 0; b -- ) {
                var t = b / bevelSegments;
                var z = bevelThickness * Math.cos(t * Math.PI / 2);
                var bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(var i2 = 0, il2 = contour.length; i2 < il2; i2++){
                    var vert = scalePt2(contour[i2], contourMovements[i2], bs);
                    v(vert.x, vert.y, -z);
                }
                // expand holes
                for(var h3 = 0, hl3 = holes.length; h3 < hl3; h3++){
                    var ahole3 = holes[h3];
                    oneHoleMovements = holesMovements[h3];
                    for(var i3 = 0, il3 = ahole3.length; i3 < il3; i3++){
                        var vert1 = scalePt2(ahole3[i3], oneHoleMovements[i3], bs);
                        v(vert1.x, vert1.y, -z);
                    }
                }
            }
            var bs1 = bevelSize + bevelOffset;
            // Back facing vertices
            for(var i4 = 0; i4 < vlen; i4++){
                var vert2 = bevelEnabled ? scalePt2(vertices[i4], verticesMovements[i4], bs1) : vertices[i4];
                if (!extrudeByPath) v(vert2.x, vert2.y, 0);
                else {
                    // v( vert.x, vert.y + extrudePts[ 0 ].y, extrudePts[ 0 ].x );
                    normal.copy(splineTube.normals[0]).multiplyScalar(vert2.x);
                    binormal.copy(splineTube.binormals[0]).multiplyScalar(vert2.y);
                    position2.copy(extrudePts[0]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add stepped vertices...
            // Including front facing vertices
            for(var s = 1; s <= steps; s++)for(var i5 = 0; i5 < vlen; i5++){
                var vert3 = bevelEnabled ? scalePt2(vertices[i5], verticesMovements[i5], bs1) : vertices[i5];
                if (!extrudeByPath) v(vert3.x, vert3.y, depth / steps * s);
                else {
                    // v( vert.x, vert.y + extrudePts[ s - 1 ].y, extrudePts[ s - 1 ].x );
                    normal.copy(splineTube.normals[s]).multiplyScalar(vert3.x);
                    binormal.copy(splineTube.binormals[s]).multiplyScalar(vert3.y);
                    position2.copy(extrudePts[s]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add bevel segments planes
            //for ( b = 1; b <= bevelSegments; b ++ ) {
            for(var b1 = bevelSegments - 1; b1 >= 0; b1--){
                var t1 = b1 / bevelSegments;
                var z1 = bevelThickness * Math.cos(t1 * Math.PI / 2);
                var bs2 = bevelSize * Math.sin(t1 * Math.PI / 2) + bevelOffset;
                // contract shape
                for(var i6 = 0, il4 = contour.length; i6 < il4; i6++){
                    var vert4 = scalePt2(contour[i6], contourMovements[i6], bs2);
                    v(vert4.x, vert4.y, depth + z1);
                }
                // expand holes
                for(var h4 = 0, hl4 = holes.length; h4 < hl4; h4++){
                    var ahole4 = holes[h4];
                    oneHoleMovements = holesMovements[h4];
                    for(var i7 = 0, il5 = ahole4.length; i7 < il5; i7++){
                        var vert5 = scalePt2(ahole4[i7], oneHoleMovements[i7], bs2);
                        if (!extrudeByPath) v(vert5.x, vert5.y, depth + z1);
                        else v(vert5.x, vert5.y + extrudePts[steps - 1].y, extrudePts[steps - 1].x + z1);
                    }
                }
            }
            /* Faces */ // Top and bottom faces
            buildLidFaces();
            // Sides faces
            buildSideFaces();
            /////  Internal functions
            function buildLidFaces() {
                var start = verticesArray.length / 3;
                if (bevelEnabled) {
                    var layer = 0; // steps + 1
                    var offset = vlen * layer;
                    // Bottom faces
                    for(var i = 0; i < flen; i++){
                        var face = faces[i];
                        f3(face[2] + offset, face[1] + offset, face[0] + offset);
                    }
                    layer = steps + bevelSegments * 2;
                    offset = vlen * layer;
                    // Top faces
                    for(var i1 = 0; i1 < flen; i1++){
                        var face1 = faces[i1];
                        f3(face1[0] + offset, face1[1] + offset, face1[2] + offset);
                    }
                } else {
                    // Bottom faces
                    for(var i2 = 0; i2 < flen; i2++){
                        var face2 = faces[i2];
                        f3(face2[2], face2[1], face2[0]);
                    }
                    // Top faces
                    for(var i3 = 0; i3 < flen; i3++){
                        var face3 = faces[i3];
                        f3(face3[0] + vlen * steps, face3[1] + vlen * steps, face3[2] + vlen * steps);
                    }
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 0);
            }
            // Create faces for the z-sides of the shape
            function buildSideFaces() {
                var start = verticesArray.length / 3;
                var layeroffset = 0;
                sidewalls(contour, layeroffset);
                layeroffset += contour.length;
                for(var h = 0, hl = holes.length; h < hl; h++){
                    var ahole = holes[h];
                    sidewalls(ahole, layeroffset);
                    //, true
                    layeroffset += ahole.length;
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 1);
            }
            function sidewalls(contour, layeroffset) {
                var i = contour.length;
                while(--i >= 0){
                    var j = i;
                    var k = i - 1;
                    if (k < 0) k = contour.length - 1;
                    //console.log('b', i,j, i-1, k,vertices.length);
                    for(var s = 0, sl = steps + bevelSegments * 2; s < sl; s++){
                        var slen1 = vlen * s;
                        var slen2 = vlen * (s + 1);
                        var a = layeroffset + j + slen1, b = layeroffset + k + slen1, c = layeroffset + k + slen2, d = layeroffset + j + slen2;
                        f4(a, b, c, d);
                    }
                }
            }
            function v(x, y, z) {
                placeholder.push(x);
                placeholder.push(y);
                placeholder.push(z);
            }
            function f3(a, b, c) {
                addVertex(a);
                addVertex(b);
                addVertex(c);
                var nextIndex = verticesArray.length / 3;
                var uvs = uvgen.generateTopUV(scope, verticesArray, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[2]);
            }
            function f4(a, b, c, d) {
                addVertex(a);
                addVertex(b);
                addVertex(d);
                addVertex(b);
                addVertex(c);
                addVertex(d);
                var nextIndex = verticesArray.length / 3;
                var uvs = uvgen.generateSideWallUV(scope, verticesArray, nextIndex - 6, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[3]);
                addUV(uvs[1]);
                addUV(uvs[2]);
                addUV(uvs[3]);
            }
            function addVertex(index) {
                verticesArray.push(placeholder[index * 3 + 0]);
                verticesArray.push(placeholder[index * 3 + 1]);
                verticesArray.push(placeholder[index * 3 + 2]);
            }
            function addUV(vector2) {
                uvArray.push(vector2.x);
                uvArray.push(vector2.y);
            }
        };
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, ExtrudeGeometry);
        _this.type = 'ExtrudeGeometry';
        _this.parameters = {
            shapes: shapes,
            options: options
        };
        shapes = Array.isArray(shapes) ? shapes : [
            shapes
        ];
        var scope = _this;
        var verticesArray = [];
        var uvArray = [];
        for(var i = 0, l = shapes.length; i < l; i++){
            var shape = shapes[i];
            addShape(shape);
        }
        // build geometry
        _this.setAttribute('position', new $c702e238df7c5123$export$cbe7a62641830ebd(verticesArray, 3));
        _this.setAttribute('uv', new $c702e238df7c5123$export$cbe7a62641830ebd(uvArray, 2));
        _this.computeVertexNormals();
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(ExtrudeGeometry, [
        {
            key: "toJSON",
            value: function toJSON() {
                var data = (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(ExtrudeGeometry.prototype), "toJSON", this).call(this);
                var shapes = this.parameters.shapes;
                var options = this.parameters.options;
                return $c702e238df7c5123$var$toJSON$1(shapes, options, data);
            }
        }
    ], [
        {
            key: "fromJSON",
            value: function fromJSON(data, shapes) {
                var geometryShapes = [];
                for(var j = 0, jl = data.shapes.length; j < jl; j++){
                    var shape = shapes[data.shapes[j]];
                    geometryShapes.push(shape);
                }
                var extrudePath = data.options.extrudePath;
                if (extrudePath !== undefined) data.options.extrudePath = new $c702e238df7c5123$var$Curves[extrudePath.type]().fromJSON(extrudePath);
                return new ExtrudeGeometry(geometryShapes, data.options);
            }
        }
    ]);
    return ExtrudeGeometry;
}($c702e238df7c5123$export$b7be63a67df8959);
var $c702e238df7c5123$var$WorldUVGenerator = {
    generateTopUV: function generateTopUV(geometry, vertices, indexA, indexB, indexC) {
        var a_x = vertices[indexA * 3];
        var a_y = vertices[indexA * 3 + 1];
        var b_x = vertices[indexB * 3];
        var b_y = vertices[indexB * 3 + 1];
        var c_x = vertices[indexC * 3];
        var c_y = vertices[indexC * 3 + 1];
        return [
            new $c702e238df7c5123$export$c977b3e384af9ae1(a_x, a_y),
            new $c702e238df7c5123$export$c977b3e384af9ae1(b_x, b_y),
            new $c702e238df7c5123$export$c977b3e384af9ae1(c_x, c_y)
        ];
    },
    generateSideWallUV: function generateSideWallUV(geometry, vertices, indexA, indexB, indexC, indexD) {
        var a_x = vertices[indexA * 3];
        var a_y = vertices[indexA * 3 + 1];
        var a_z = vertices[indexA * 3 + 2];
        var b_x = vertices[indexB * 3];
        var b_y = vertices[indexB * 3 + 1];
        var b_z = vertices[indexB * 3 + 2];
        var c_x = vertices[indexC * 3];
        var c_y = vertices[indexC * 3 + 1];
        var c_z = vertices[indexC * 3 + 2];
        var d_x = vertices[indexD * 3];
        var d_y = vertices[indexD * 3 + 1];
        var d_z = vertices[indexD * 3 + 2];
        if (Math.abs(a_y - b_y) < Math.abs(a_x - b_x)) return [
            new $c702e238df7c5123$export$c977b3e384af9ae1(a_x, 1 - a_z),
            new $c702e238df7c5123$export$c977b3e384af9ae1(b_x, 1 - b_z),
            new $c702e238df7c5123$export$c977b3e384af9ae1(c_x, 1 - c_z),
            new $c702e238df7c5123$export$c977b3e384af9ae1(d_x, 1 - d_z)
        ];
        else return [
            new $c702e238df7c5123$export$c977b3e384af9ae1(a_y, 1 - a_z),
            new $c702e238df7c5123$export$c977b3e384af9ae1(b_y, 1 - b_z),
            new $c702e238df7c5123$export$c977b3e384af9ae1(c_y, 1 - c_z),
            new $c702e238df7c5123$export$c977b3e384af9ae1(d_y, 1 - d_z)
        ];
    }
};
function $c702e238df7c5123$var$toJSON$1(shapes, options, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(var i = 0, l = shapes.length; i < l; i++){
        var shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    if (options.extrudePath !== undefined) data.options.extrudePath = options.extrudePath.toJSON();
    return data;
}
var $c702e238df7c5123$export$731fd4feef063ea2 = /*#__PURE__*/ function(PolyhedronGeometry) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(IcosahedronGeometry, PolyhedronGeometry);
    function IcosahedronGeometry() {
        var radius = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, detail = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, IcosahedronGeometry);
        var _this;
        var t = (1 + Math.sqrt(5)) / 2;
        var vertices = [
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            0,
            0,
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            t,
            0,
            -1,
            t,
            0,
            1,
            -t,
            0,
            -1,
            -t,
            0,
            1
        ];
        var indices = [
            0,
            11,
            5,
            0,
            5,
            1,
            0,
            1,
            7,
            0,
            7,
            10,
            0,
            10,
            11,
            1,
            5,
            9,
            5,
            11,
            4,
            11,
            10,
            2,
            10,
            7,
            6,
            7,
            1,
            8,
            3,
            9,
            4,
            3,
            4,
            2,
            3,
            2,
            6,
            3,
            6,
            8,
            3,
            8,
            9,
            4,
            9,
            5,
            2,
            4,
            11,
            6,
            2,
            10,
            8,
            6,
            7,
            9,
            8,
            1
        ];
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, IcosahedronGeometry, [
            vertices,
            indices,
            radius,
            detail
        ]);
        _this.type = 'IcosahedronGeometry';
        _this.parameters = {
            radius: radius,
            detail: detail
        };
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(IcosahedronGeometry, null, [
        {
            key: "fromJSON",
            value: function fromJSON(data) {
                return new IcosahedronGeometry(data.radius, data.detail);
            }
        }
    ]);
    return IcosahedronGeometry;
}($c702e238df7c5123$export$38789b531813345c);
var $c702e238df7c5123$export$dc3e1273c1dd9240 = /*#__PURE__*/ function(BufferGeometry) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(LatheGeometry, BufferGeometry);
    function LatheGeometry(points) {
        var segments = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 12, phiStart = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, phiLength = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Math.PI * 2;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, LatheGeometry);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, LatheGeometry);
        _this.type = 'LatheGeometry';
        _this.parameters = {
            points: points,
            segments: segments,
            phiStart: phiStart,
            phiLength: phiLength
        };
        segments = Math.floor(segments);
        // clamp phiLength so it's in range of [ 0, 2PI ]
        phiLength = $c702e238df7c5123$var$clamp(phiLength, 0, Math.PI * 2);
        // buffers
        var indices = [];
        var vertices = [];
        var uvs = [];
        // helper variables
        var inverseSegments = 1.0 / segments;
        var vertex = new $c702e238df7c5123$export$64b5c384219d3699();
        var uv = new $c702e238df7c5123$export$c977b3e384af9ae1();
        // generate vertices and uvs
        for(var i = 0; i <= segments; i++){
            var phi = phiStart + i * inverseSegments * phiLength;
            var sin = Math.sin(phi);
            var cos = Math.cos(phi);
            for(var j = 0; j <= points.length - 1; j++){
                // vertex
                vertex.x = points[j].x * sin;
                vertex.y = points[j].y;
                vertex.z = points[j].x * cos;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // uv
                uv.x = i / segments;
                uv.y = j / (points.length - 1);
                uvs.push(uv.x, uv.y);
            }
        }
        // indices
        for(var i1 = 0; i1 < segments; i1++)for(var j1 = 0; j1 < points.length - 1; j1++){
            var base = j1 + i1 * points.length;
            var a = base;
            var b = base + points.length;
            var c = base + points.length + 1;
            var d = base + 1;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        _this.setIndex(indices);
        _this.setAttribute('position', new $c702e238df7c5123$export$cbe7a62641830ebd(vertices, 3));
        _this.setAttribute('uv', new $c702e238df7c5123$export$cbe7a62641830ebd(uvs, 2));
        // generate normals
        _this.computeVertexNormals();
        // if the geometry is closed, we need to average the normals along the seam.
        // because the corresponding vertices are identical (but still have different UVs).
        if (phiLength === Math.PI * 2) {
            var normals = _this.attributes.normal.array;
            var n1 = new $c702e238df7c5123$export$64b5c384219d3699();
            var n2 = new $c702e238df7c5123$export$64b5c384219d3699();
            var n = new $c702e238df7c5123$export$64b5c384219d3699();
            // this is the buffer offset for the last line of vertices
            var base1 = segments * points.length * 3;
            for(var i2 = 0, j2 = 0; i2 < points.length; i2++, j2 += 3){
                // select the normal of the vertex in the first line
                n1.x = normals[j2 + 0];
                n1.y = normals[j2 + 1];
                n1.z = normals[j2 + 2];
                // select the normal of the vertex in the last line
                n2.x = normals[base1 + j2 + 0];
                n2.y = normals[base1 + j2 + 1];
                n2.z = normals[base1 + j2 + 2];
                // average normals
                n.addVectors(n1, n2).normalize();
                // assign the new values to both normals
                normals[j2 + 0] = normals[base1 + j2 + 0] = n.x;
                normals[j2 + 1] = normals[base1 + j2 + 1] = n.y;
                normals[j2 + 2] = normals[base1 + j2 + 2] = n.z;
            }
        }
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(LatheGeometry, null, [
        {
            key: "fromJSON",
            value: function fromJSON(data) {
                return new LatheGeometry(data.points, data.segments, data.phiStart, data.phiLength);
            }
        }
    ]);
    return LatheGeometry;
}($c702e238df7c5123$export$b7be63a67df8959);
var $c702e238df7c5123$export$8e05fc91596f4752 = /*#__PURE__*/ function(PolyhedronGeometry) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(OctahedronGeometry, PolyhedronGeometry);
    function OctahedronGeometry() {
        var radius = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, detail = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, OctahedronGeometry);
        var _this;
        var vertices = [
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1
        ];
        var indices = [
            0,
            2,
            4,
            0,
            4,
            3,
            0,
            3,
            5,
            0,
            5,
            2,
            1,
            2,
            5,
            1,
            5,
            3,
            1,
            3,
            4,
            1,
            4,
            2
        ];
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, OctahedronGeometry, [
            vertices,
            indices,
            radius,
            detail
        ]);
        _this.type = 'OctahedronGeometry';
        _this.parameters = {
            radius: radius,
            detail: detail
        };
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(OctahedronGeometry, null, [
        {
            key: "fromJSON",
            value: function fromJSON(data) {
                return new OctahedronGeometry(data.radius, data.detail);
            }
        }
    ]);
    return OctahedronGeometry;
}($c702e238df7c5123$export$38789b531813345c);
/**
 * Parametric Surfaces Geometry
 * based on the brilliant article by @prideout https://prideout.net/blog/old/blog/index.html@p=44.html
 */ var $c702e238df7c5123$export$c56b5b5c6f0a7fff = /*#__PURE__*/ function(BufferGeometry) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(ParametricGeometry, BufferGeometry);
    function ParametricGeometry(func, slices, stacks) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, ParametricGeometry);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, ParametricGeometry);
        _this.type = 'ParametricGeometry';
        _this.parameters = {
            func: func,
            slices: slices,
            stacks: stacks
        };
        // buffers
        var indices = [];
        var vertices = [];
        var normals = [];
        var uvs = [];
        var EPS = 0.00001;
        var normal = new $c702e238df7c5123$export$64b5c384219d3699();
        var p0 = new $c702e238df7c5123$export$64b5c384219d3699(), p1 = new $c702e238df7c5123$export$64b5c384219d3699();
        var pu = new $c702e238df7c5123$export$64b5c384219d3699(), pv = new $c702e238df7c5123$export$64b5c384219d3699();
        if (func.length < 3) console.error('THREE.ParametricGeometry: Function must now modify a Vector3 as third parameter.');
        // generate vertices, normals and uvs
        var sliceCount = slices + 1;
        for(var i = 0; i <= stacks; i++){
            var v = i / stacks;
            for(var j = 0; j <= slices; j++){
                var u = j / slices;
                // vertex
                func(u, v, p0);
                vertices.push(p0.x, p0.y, p0.z);
                // normal
                // approximate tangent vectors via finite differences
                if (u - EPS >= 0) {
                    func(u - EPS, v, p1);
                    pu.subVectors(p0, p1);
                } else {
                    func(u + EPS, v, p1);
                    pu.subVectors(p1, p0);
                }
                if (v - EPS >= 0) {
                    func(u, v - EPS, p1);
                    pv.subVectors(p0, p1);
                } else {
                    func(u, v + EPS, p1);
                    pv.subVectors(p1, p0);
                }
                // cross product of tangent vectors returns surface normal
                normal.crossVectors(pu, pv).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(u, v);
            }
        }
        // generate indices
        for(var i1 = 0; i1 < stacks; i1++)for(var j1 = 0; j1 < slices; j1++){
            var a = i1 * sliceCount + j1;
            var b = i1 * sliceCount + j1 + 1;
            var c = (i1 + 1) * sliceCount + j1 + 1;
            var d = (i1 + 1) * sliceCount + j1;
            // faces one and two
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        _this.setIndex(indices);
        _this.setAttribute('position', new $c702e238df7c5123$export$cbe7a62641830ebd(vertices, 3));
        _this.setAttribute('normal', new $c702e238df7c5123$export$cbe7a62641830ebd(normals, 3));
        _this.setAttribute('uv', new $c702e238df7c5123$export$cbe7a62641830ebd(uvs, 2));
        return _this;
    }
    return ParametricGeometry;
}($c702e238df7c5123$export$b7be63a67df8959);
var $c702e238df7c5123$export$ee8b85b34b7d9cad = /*#__PURE__*/ function(BufferGeometry) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(RingGeometry, BufferGeometry);
    function RingGeometry() {
        var innerRadius = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0.5, outerRadius = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, thetaSegments = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 8, phiSegments = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1, thetaStart = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0, thetaLength = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : Math.PI * 2;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, RingGeometry);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, RingGeometry);
        _this.type = 'RingGeometry';
        _this.parameters = {
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            thetaSegments: thetaSegments,
            phiSegments: phiSegments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        thetaSegments = Math.max(3, thetaSegments);
        phiSegments = Math.max(1, phiSegments);
        // buffers
        var indices = [];
        var vertices = [];
        var normals = [];
        var uvs = [];
        // some helper variables
        var radius = innerRadius;
        var radiusStep = (outerRadius - innerRadius) / phiSegments;
        var vertex = new $c702e238df7c5123$export$64b5c384219d3699();
        var uv = new $c702e238df7c5123$export$c977b3e384af9ae1();
        // generate vertices, normals and uvs
        for(var j = 0; j <= phiSegments; j++){
            for(var i = 0; i <= thetaSegments; i++){
                // values are generate from the inside of the ring to the outside
                var segment = thetaStart + i / thetaSegments * thetaLength;
                // vertex
                vertex.x = radius * Math.cos(segment);
                vertex.y = radius * Math.sin(segment);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, 0, 1);
                // uv
                uv.x = (vertex.x / outerRadius + 1) / 2;
                uv.y = (vertex.y / outerRadius + 1) / 2;
                uvs.push(uv.x, uv.y);
            }
            // increase the radius for next row of vertices
            radius += radiusStep;
        }
        // indices
        for(var j1 = 0; j1 < phiSegments; j1++){
            var thetaSegmentLevel = j1 * (thetaSegments + 1);
            for(var i1 = 0; i1 < thetaSegments; i1++){
                var segment1 = i1 + thetaSegmentLevel;
                var a = segment1;
                var b = segment1 + thetaSegments + 1;
                var c = segment1 + thetaSegments + 2;
                var d = segment1 + 1;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        // build geometry
        _this.setIndex(indices);
        _this.setAttribute('position', new $c702e238df7c5123$export$cbe7a62641830ebd(vertices, 3));
        _this.setAttribute('normal', new $c702e238df7c5123$export$cbe7a62641830ebd(normals, 3));
        _this.setAttribute('uv', new $c702e238df7c5123$export$cbe7a62641830ebd(uvs, 2));
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(RingGeometry, null, [
        {
            key: "fromJSON",
            value: function fromJSON(data) {
                return new RingGeometry(data.innerRadius, data.outerRadius, data.thetaSegments, data.phiSegments, data.thetaStart, data.thetaLength);
            }
        }
    ]);
    return RingGeometry;
}($c702e238df7c5123$export$b7be63a67df8959);
var $c702e238df7c5123$export$233afc324766bed8 = /*#__PURE__*/ function(BufferGeometry) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(ShapeGeometry, BufferGeometry);
    function ShapeGeometry(shapes) {
        var curveSegments = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 12;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, ShapeGeometry);
        var _this;
        var addShape = // helper functions
        function addShape(shape) {
            var indexOffset = vertices.length / 3;
            var points = shape.extractPoints(curveSegments);
            var shapeVertices = points.shape;
            var shapeHoles = points.holes;
            // check direction of vertices
            if ($c702e238df7c5123$export$96bdf6d9c66d7ba8.isClockWise(shapeVertices) === false) shapeVertices = shapeVertices.reverse();
            for(var i = 0, l = shapeHoles.length; i < l; i++){
                var shapeHole = shapeHoles[i];
                if ($c702e238df7c5123$export$96bdf6d9c66d7ba8.isClockWise(shapeHole) === true) shapeHoles[i] = shapeHole.reverse();
            }
            var faces = $c702e238df7c5123$export$96bdf6d9c66d7ba8.triangulateShape(shapeVertices, shapeHoles);
            // join vertices of inner and outer paths to a single array
            for(var i1 = 0, l1 = shapeHoles.length; i1 < l1; i1++){
                var shapeHole1 = shapeHoles[i1];
                shapeVertices = shapeVertices.concat(shapeHole1);
            }
            // vertices, normals, uvs
            for(var i2 = 0, l2 = shapeVertices.length; i2 < l2; i2++){
                var vertex = shapeVertices[i2];
                vertices.push(vertex.x, vertex.y, 0);
                normals.push(0, 0, 1);
                uvs.push(vertex.x, vertex.y); // world uvs
            }
            // incides
            for(var i3 = 0, l3 = faces.length; i3 < l3; i3++){
                var face = faces[i3];
                var a = face[0] + indexOffset;
                var b = face[1] + indexOffset;
                var c = face[2] + indexOffset;
                indices.push(a, b, c);
                groupCount += 3;
            }
        };
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, ShapeGeometry);
        _this.type = 'ShapeGeometry';
        _this.parameters = {
            shapes: shapes,
            curveSegments: curveSegments
        };
        // buffers
        var indices = [];
        var vertices = [];
        var normals = [];
        var uvs = [];
        // helper variables
        var groupStart = 0;
        var groupCount = 0;
        // allow single and array values for "shapes" parameter
        if (Array.isArray(shapes) === false) addShape(shapes);
        else for(var i = 0; i < shapes.length; i++){
            addShape(shapes[i]);
            _this.addGroup(groupStart, groupCount, i); // enables MultiMaterial support
            groupStart += groupCount;
            groupCount = 0;
        }
        // build geometry
        _this.setIndex(indices);
        _this.setAttribute('position', new $c702e238df7c5123$export$cbe7a62641830ebd(vertices, 3));
        _this.setAttribute('normal', new $c702e238df7c5123$export$cbe7a62641830ebd(normals, 3));
        _this.setAttribute('uv', new $c702e238df7c5123$export$cbe7a62641830ebd(uvs, 2));
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(ShapeGeometry, [
        {
            key: "toJSON",
            value: function toJSON1() {
                var data = (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(ShapeGeometry.prototype), "toJSON", this).call(this);
                var shapes = this.parameters.shapes;
                return $c702e238df7c5123$var$toJSON(shapes, data);
            }
        }
    ], [
        {
            key: "fromJSON",
            value: function fromJSON(data, shapes) {
                var geometryShapes = [];
                for(var j = 0, jl = data.shapes.length; j < jl; j++){
                    var shape = shapes[data.shapes[j]];
                    geometryShapes.push(shape);
                }
                return new ShapeGeometry(geometryShapes, data.curveSegments);
            }
        }
    ]);
    return ShapeGeometry;
}($c702e238df7c5123$export$b7be63a67df8959);
function $c702e238df7c5123$var$toJSON(shapes, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(var i = 0, l = shapes.length; i < l; i++){
        var shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    return data;
}
var $c702e238df7c5123$export$d5d06a966fec4192 = /*#__PURE__*/ function(BufferGeometry) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(SphereGeometry, BufferGeometry);
    function SphereGeometry() {
        var radius = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, widthSegments = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 8, heightSegments = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 6, phiStart = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, phiLength = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : Math.PI * 2, thetaStart = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0, thetaLength = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : Math.PI;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, SphereGeometry);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, SphereGeometry);
        _this.type = 'SphereGeometry';
        _this.parameters = {
            radius: radius,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            phiStart: phiStart,
            phiLength: phiLength,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        widthSegments = Math.max(3, Math.floor(widthSegments));
        heightSegments = Math.max(2, Math.floor(heightSegments));
        var thetaEnd = Math.min(thetaStart + thetaLength, Math.PI);
        var index = 0;
        var grid = [];
        var vertex = new $c702e238df7c5123$export$64b5c384219d3699();
        var normal = new $c702e238df7c5123$export$64b5c384219d3699();
        // buffers
        var indices = [];
        var vertices = [];
        var normals = [];
        var uvs = [];
        // generate vertices, normals and uvs
        for(var iy = 0; iy <= heightSegments; iy++){
            var verticesRow = [];
            var v = iy / heightSegments;
            // special case for the poles
            var uOffset = 0;
            if (iy == 0 && thetaStart == 0) uOffset = 0.5 / widthSegments;
            else if (iy == heightSegments && thetaEnd == Math.PI) uOffset = -0.5 / widthSegments;
            for(var ix = 0; ix <= widthSegments; ix++){
                var u = ix / widthSegments;
                // vertex
                vertex.x = -radius * Math.cos(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertex.y = radius * Math.cos(thetaStart + v * thetaLength);
                vertex.z = radius * Math.sin(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normal.copy(vertex).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(u + uOffset, 1 - v);
                verticesRow.push(index++);
            }
            grid.push(verticesRow);
        }
        // indices
        for(var iy1 = 0; iy1 < heightSegments; iy1++)for(var ix1 = 0; ix1 < widthSegments; ix1++){
            var a = grid[iy1][ix1 + 1];
            var b = grid[iy1][ix1];
            var c = grid[iy1 + 1][ix1];
            var d = grid[iy1 + 1][ix1 + 1];
            if (iy1 !== 0 || thetaStart > 0) indices.push(a, b, d);
            if (iy1 !== heightSegments - 1 || thetaEnd < Math.PI) indices.push(b, c, d);
        }
        // build geometry
        _this.setIndex(indices);
        _this.setAttribute('position', new $c702e238df7c5123$export$cbe7a62641830ebd(vertices, 3));
        _this.setAttribute('normal', new $c702e238df7c5123$export$cbe7a62641830ebd(normals, 3));
        _this.setAttribute('uv', new $c702e238df7c5123$export$cbe7a62641830ebd(uvs, 2));
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(SphereGeometry, null, [
        {
            key: "fromJSON",
            value: function fromJSON(data) {
                return new SphereGeometry(data.radius, data.widthSegments, data.heightSegments, data.phiStart, data.phiLength, data.thetaStart, data.thetaLength);
            }
        }
    ]);
    return SphereGeometry;
}($c702e238df7c5123$export$b7be63a67df8959);
var $c702e238df7c5123$export$369e08f62a796c65 = /*#__PURE__*/ function(PolyhedronGeometry) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(TetrahedronGeometry, PolyhedronGeometry);
    function TetrahedronGeometry() {
        var radius = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, detail = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, TetrahedronGeometry);
        var _this;
        var vertices = [
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            1,
            -1,
            -1
        ];
        var indices = [
            2,
            1,
            0,
            0,
            3,
            2,
            1,
            3,
            0,
            2,
            3,
            1
        ];
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, TetrahedronGeometry, [
            vertices,
            indices,
            radius,
            detail
        ]);
        _this.type = 'TetrahedronGeometry';
        _this.parameters = {
            radius: radius,
            detail: detail
        };
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(TetrahedronGeometry, null, [
        {
            key: "fromJSON",
            value: function fromJSON(data) {
                return new TetrahedronGeometry(data.radius, data.detail);
            }
        }
    ]);
    return TetrahedronGeometry;
}($c702e238df7c5123$export$38789b531813345c);
/**
 * Text = 3D Text
 *
 * parameters = {
 *  font: <THREE.Font>, // font
 *
 *  size: <float>, // size of the text
 *  height: <float>, // thickness to extrude text
 *  curveSegments: <int>, // number of points on the curves
 *
 *  bevelEnabled: <bool>, // turn on bevel
 *  bevelThickness: <float>, // how deep into text bevel goes
 *  bevelSize: <float>, // how far from text outline (including bevelOffset) is bevel
 *  bevelOffset: <float> // how far from text outline does bevel start
 * }
 */ var $c702e238df7c5123$export$89b83bbad46fe613 = /*#__PURE__*/ function(ExtrudeGeometry) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(TextGeometry, ExtrudeGeometry);
    function TextGeometry(text) {
        var parameters = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, TextGeometry);
        var _this;
        var font = parameters.font;
        if (!(font && font.isFont)) {
            console.error('THREE.TextGeometry: font parameter is not an instance of THREE.Font.');
            return (0, $aa137087616882c2$export$71511d61b312f219)(_this, new $c702e238df7c5123$export$b7be63a67df8959());
        }
        var shapes = font.generateShapes(text, parameters.size);
        // translate parameters to ExtrudeGeometry API
        parameters.depth = parameters.height !== undefined ? parameters.height : 50;
        // defaults
        if (parameters.bevelThickness === undefined) parameters.bevelThickness = 10;
        if (parameters.bevelSize === undefined) parameters.bevelSize = 8;
        if (parameters.bevelEnabled === undefined) parameters.bevelEnabled = false;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, TextGeometry, [
            shapes,
            parameters
        ]);
        _this.type = 'TextGeometry';
        return _this;
    }
    return TextGeometry;
}($c702e238df7c5123$export$91836d01b9f75a58);
var $c702e238df7c5123$export$19d55f905fa4f2cb = /*#__PURE__*/ function(BufferGeometry) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(TorusGeometry, BufferGeometry);
    function TorusGeometry() {
        var radius = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, tube = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0.4, radialSegments = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 8, tubularSegments = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 6, arc = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : Math.PI * 2;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, TorusGeometry);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, TorusGeometry);
        _this.type = 'TorusGeometry';
        _this.parameters = {
            radius: radius,
            tube: tube,
            radialSegments: radialSegments,
            tubularSegments: tubularSegments,
            arc: arc
        };
        radialSegments = Math.floor(radialSegments);
        tubularSegments = Math.floor(tubularSegments);
        // buffers
        var indices = [];
        var vertices = [];
        var normals = [];
        var uvs = [];
        // helper variables
        var center = new $c702e238df7c5123$export$64b5c384219d3699();
        var vertex = new $c702e238df7c5123$export$64b5c384219d3699();
        var normal = new $c702e238df7c5123$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(var j = 0; j <= radialSegments; j++)for(var i = 0; i <= tubularSegments; i++){
            var u = i / tubularSegments * arc;
            var v = j / radialSegments * Math.PI * 2;
            // vertex
            vertex.x = (radius + tube * Math.cos(v)) * Math.cos(u);
            vertex.y = (radius + tube * Math.cos(v)) * Math.sin(u);
            vertex.z = tube * Math.sin(v);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            center.x = radius * Math.cos(u);
            center.y = radius * Math.sin(u);
            normal.subVectors(vertex, center).normalize();
            normals.push(normal.x, normal.y, normal.z);
            // uv
            uvs.push(i / tubularSegments);
            uvs.push(j / radialSegments);
        }
        // generate indices
        for(var j1 = 1; j1 <= radialSegments; j1++)for(var i1 = 1; i1 <= tubularSegments; i1++){
            // indices
            var a = (tubularSegments + 1) * j1 + i1 - 1;
            var b = (tubularSegments + 1) * (j1 - 1) + i1 - 1;
            var c = (tubularSegments + 1) * (j1 - 1) + i1;
            var d = (tubularSegments + 1) * j1 + i1;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        _this.setIndex(indices);
        _this.setAttribute('position', new $c702e238df7c5123$export$cbe7a62641830ebd(vertices, 3));
        _this.setAttribute('normal', new $c702e238df7c5123$export$cbe7a62641830ebd(normals, 3));
        _this.setAttribute('uv', new $c702e238df7c5123$export$cbe7a62641830ebd(uvs, 2));
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(TorusGeometry, null, [
        {
            key: "fromJSON",
            value: function fromJSON(data) {
                return new TorusGeometry(data.radius, data.tube, data.radialSegments, data.tubularSegments, data.arc);
            }
        }
    ]);
    return TorusGeometry;
}($c702e238df7c5123$export$b7be63a67df8959);
var $c702e238df7c5123$export$2b32466f4274fe5c = /*#__PURE__*/ function(BufferGeometry) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(TorusKnotGeometry, BufferGeometry);
    function TorusKnotGeometry() {
        var radius = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, tube = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0.4, tubularSegments = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 64, radialSegments = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 8, p = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 2, q = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 3;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, TorusKnotGeometry);
        var _this;
        var calculatePositionOnCurve = // this function calculates the current position on the torus curve
        function calculatePositionOnCurve(u, p, q, radius, position) {
            var cu = Math.cos(u);
            var su = Math.sin(u);
            var quOverP = q / p * u;
            var cs = Math.cos(quOverP);
            position.x = radius * (2 + cs) * 0.5 * cu;
            position.y = radius * (2 + cs) * su * 0.5;
            position.z = radius * Math.sin(quOverP) * 0.5;
        };
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, TorusKnotGeometry);
        _this.type = 'TorusKnotGeometry';
        _this.parameters = {
            radius: radius,
            tube: tube,
            tubularSegments: tubularSegments,
            radialSegments: radialSegments,
            p: p,
            q: q
        };
        tubularSegments = Math.floor(tubularSegments);
        radialSegments = Math.floor(radialSegments);
        // buffers
        var indices = [];
        var vertices = [];
        var normals = [];
        var uvs = [];
        // helper variables
        var vertex = new $c702e238df7c5123$export$64b5c384219d3699();
        var normal = new $c702e238df7c5123$export$64b5c384219d3699();
        var P1 = new $c702e238df7c5123$export$64b5c384219d3699();
        var P2 = new $c702e238df7c5123$export$64b5c384219d3699();
        var B = new $c702e238df7c5123$export$64b5c384219d3699();
        var T = new $c702e238df7c5123$export$64b5c384219d3699();
        var N = new $c702e238df7c5123$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(var i = 0; i <= tubularSegments; ++i){
            // the radian "u" is used to calculate the position on the torus curve of the current tubular segement
            var u = i / tubularSegments * p * Math.PI * 2;
            // now we calculate two points. P1 is our current position on the curve, P2 is a little farther ahead.
            // these points are used to create a special "coordinate space", which is necessary to calculate the correct vertex positions
            calculatePositionOnCurve(u, p, q, radius, P1);
            calculatePositionOnCurve(u + 0.01, p, q, radius, P2);
            // calculate orthonormal basis
            T.subVectors(P2, P1);
            N.addVectors(P2, P1);
            B.crossVectors(T, N);
            N.crossVectors(B, T);
            // normalize B, N. T can be ignored, we don't use it
            B.normalize();
            N.normalize();
            for(var j = 0; j <= radialSegments; ++j){
                // now calculate the vertices. they are nothing more than an extrusion of the torus curve.
                // because we extrude a shape in the xy-plane, there is no need to calculate a z-value.
                var v = j / radialSegments * Math.PI * 2;
                var cx = -tube * Math.cos(v);
                var cy = tube * Math.sin(v);
                // now calculate the final vertex position.
                // first we orient the extrusion with our basis vectos, then we add it to the current position on the curve
                vertex.x = P1.x + (cx * N.x + cy * B.x);
                vertex.y = P1.y + (cx * N.y + cy * B.y);
                vertex.z = P1.z + (cx * N.z + cy * B.z);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal (P1 is always the center/origin of the extrusion, thus we can use it to calculate the normal)
                normal.subVectors(vertex, P1).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(i / tubularSegments);
                uvs.push(j / radialSegments);
            }
        }
        // generate indices
        for(var j1 = 1; j1 <= tubularSegments; j1++)for(var i1 = 1; i1 <= radialSegments; i1++){
            // indices
            var a = (radialSegments + 1) * (j1 - 1) + (i1 - 1);
            var b = (radialSegments + 1) * j1 + (i1 - 1);
            var c = (radialSegments + 1) * j1 + i1;
            var d = (radialSegments + 1) * (j1 - 1) + i1;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        _this.setIndex(indices);
        _this.setAttribute('position', new $c702e238df7c5123$export$cbe7a62641830ebd(vertices, 3));
        _this.setAttribute('normal', new $c702e238df7c5123$export$cbe7a62641830ebd(normals, 3));
        _this.setAttribute('uv', new $c702e238df7c5123$export$cbe7a62641830ebd(uvs, 2));
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(TorusKnotGeometry, null, [
        {
            key: "fromJSON",
            value: function fromJSON(data) {
                return new TorusKnotGeometry(data.radius, data.tube, data.tubularSegments, data.radialSegments, data.p, data.q);
            }
        }
    ]);
    return TorusKnotGeometry;
}($c702e238df7c5123$export$b7be63a67df8959);
var $c702e238df7c5123$export$d97a193ce44e691b = /*#__PURE__*/ function(BufferGeometry) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(TubeGeometry, BufferGeometry);
    function TubeGeometry(path) {
        var tubularSegments = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 64, radius = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, radialSegments = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 8, closed = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, TubeGeometry);
        var _this;
        var generateBufferData = // functions
        function generateBufferData() {
            for(var i = 0; i < tubularSegments; i++)generateSegment(i);
            // if the geometry is not closed, generate the last row of vertices and normals
            // at the regular position on the given path
            //
            // if the geometry is closed, duplicate the first row of vertices and normals (uvs will differ)
            generateSegment(closed === false ? tubularSegments : 0);
            // uvs are generated in a separate function.
            // this makes it easy compute correct values for closed geometries
            generateUVs();
            // finally create faces
            generateIndices();
        };
        var generateSegment = function generateSegment(i) {
            // we use getPointAt to sample evenly distributed points from the given path
            P = path.getPointAt(i / tubularSegments, P);
            // retrieve corresponding normal and binormal
            var N = frames.normals[i];
            var B = frames.binormals[i];
            // generate normals and vertices for the current segment
            for(var j = 0; j <= radialSegments; j++){
                var v = j / radialSegments * Math.PI * 2;
                var sin = Math.sin(v);
                var cos = -Math.cos(v);
                // normal
                normal.x = cos * N.x + sin * B.x;
                normal.y = cos * N.y + sin * B.y;
                normal.z = cos * N.z + sin * B.z;
                normal.normalize();
                normals.push(normal.x, normal.y, normal.z);
                // vertex
                vertex.x = P.x + radius * normal.x;
                vertex.y = P.y + radius * normal.y;
                vertex.z = P.z + radius * normal.z;
                vertices.push(vertex.x, vertex.y, vertex.z);
            }
        };
        var generateIndices = function generateIndices() {
            for(var j = 1; j <= tubularSegments; j++)for(var i = 1; i <= radialSegments; i++){
                var a = (radialSegments + 1) * (j - 1) + (i - 1);
                var b = (radialSegments + 1) * j + (i - 1);
                var c = (radialSegments + 1) * j + i;
                var d = (radialSegments + 1) * (j - 1) + i;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        };
        var generateUVs = function generateUVs() {
            for(var i = 0; i <= tubularSegments; i++)for(var j = 0; j <= radialSegments; j++){
                uv.x = i / tubularSegments;
                uv.y = j / radialSegments;
                uvs.push(uv.x, uv.y);
            }
        };
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, TubeGeometry);
        _this.type = 'TubeGeometry';
        _this.parameters = {
            path: path,
            tubularSegments: tubularSegments,
            radius: radius,
            radialSegments: radialSegments,
            closed: closed
        };
        var frames = path.computeFrenetFrames(tubularSegments, closed);
        // expose internals
        _this.tangents = frames.tangents;
        _this.normals = frames.normals;
        _this.binormals = frames.binormals;
        // helper variables
        var vertex = new $c702e238df7c5123$export$64b5c384219d3699();
        var normal = new $c702e238df7c5123$export$64b5c384219d3699();
        var uv = new $c702e238df7c5123$export$c977b3e384af9ae1();
        var P = new $c702e238df7c5123$export$64b5c384219d3699();
        // buffer
        var vertices = [];
        var normals = [];
        var uvs = [];
        var indices = [];
        // create buffer data
        generateBufferData();
        // build geometry
        _this.setIndex(indices);
        _this.setAttribute('position', new $c702e238df7c5123$export$cbe7a62641830ebd(vertices, 3));
        _this.setAttribute('normal', new $c702e238df7c5123$export$cbe7a62641830ebd(normals, 3));
        _this.setAttribute('uv', new $c702e238df7c5123$export$cbe7a62641830ebd(uvs, 2));
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(TubeGeometry, [
        {
            key: "toJSON",
            value: function toJSON() {
                var data = (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(TubeGeometry.prototype), "toJSON", this).call(this);
                data.path = this.parameters.path.toJSON();
                return data;
            }
        }
    ], [
        {
            key: "fromJSON",
            value: function fromJSON(data) {
                // This only works for built-in curves (e.g. CatmullRomCurve3).
                // User defined curves or instances of CurvePath will not be deserialized.
                return new TubeGeometry(new $c702e238df7c5123$var$Curves[data.path.type]().fromJSON(data.path), data.tubularSegments, data.radius, data.radialSegments, data.closed);
            }
        }
    ]);
    return TubeGeometry;
}($c702e238df7c5123$export$b7be63a67df8959);
var $c702e238df7c5123$export$4b739da06d24892b = /*#__PURE__*/ function(BufferGeometry) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(WireframeGeometry, BufferGeometry);
    function WireframeGeometry(geometry) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, WireframeGeometry);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, WireframeGeometry);
        _this.type = 'WireframeGeometry';
        if (geometry.isGeometry === true) {
            console.error('THREE.WireframeGeometry no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.');
            return (0, $aa137087616882c2$export$71511d61b312f219)(_this);
        }
        // buffer
        var vertices = [];
        // helper variables
        var edge = [
            0,
            0
        ], edges = {};
        var vertex = new $c702e238df7c5123$export$64b5c384219d3699();
        if (geometry.index !== null) {
            // indexed BufferGeometry
            var position = geometry.attributes.position;
            var indices = geometry.index;
            var groups = geometry.groups;
            if (groups.length === 0) groups = [
                {
                    start: 0,
                    count: indices.count,
                    materialIndex: 0
                }
            ];
            // create a data structure that contains all eges without duplicates
            for(var o = 0, ol = groups.length; o < ol; ++o){
                var group = groups[o];
                var start = group.start;
                var count = group.count;
                for(var i = start, l = start + count; i < l; i += 3)for(var j = 0; j < 3; j++){
                    var edge1 = indices.getX(i + j);
                    var edge2 = indices.getX(i + (j + 1) % 3);
                    edge[0] = Math.min(edge1, edge2); // sorting prevents duplicates
                    edge[1] = Math.max(edge1, edge2);
                    var key = edge[0] + ',' + edge[1];
                    if (edges[key] === undefined) edges[key] = {
                        index1: edge[0],
                        index2: edge[1]
                    };
                }
            }
            // generate vertices
            for(var key1 in edges){
                var e = edges[key1];
                vertex.fromBufferAttribute(position, e.index1);
                vertices.push(vertex.x, vertex.y, vertex.z);
                vertex.fromBufferAttribute(position, e.index2);
                vertices.push(vertex.x, vertex.y, vertex.z);
            }
        } else {
            // non-indexed BufferGeometry
            var position1 = geometry.attributes.position;
            for(var i1 = 0, l1 = position1.count / 3; i1 < l1; i1++)for(var j1 = 0; j1 < 3; j1++){
                // three edges per triangle, an edge is represented as (index1, index2)
                // e.g. the first triangle has the following edges: (0,1),(1,2),(2,0)
                var index1 = 3 * i1 + j1;
                vertex.fromBufferAttribute(position1, index1);
                vertices.push(vertex.x, vertex.y, vertex.z);
                var index2 = 3 * i1 + (j1 + 1) % 3;
                vertex.fromBufferAttribute(position1, index2);
                vertices.push(vertex.x, vertex.y, vertex.z);
            }
        }
        // build geometry
        _this.setAttribute('position', new $c702e238df7c5123$export$cbe7a62641830ebd(vertices, 3));
        return _this;
    }
    return WireframeGeometry;
}($c702e238df7c5123$export$b7be63a67df8959);
var $c702e238df7c5123$var$Geometries = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BoxGeometry: $c702e238df7c5123$export$ab3456a079aa7d80,
    BoxBufferGeometry: $c702e238df7c5123$export$ab3456a079aa7d80,
    CircleGeometry: $c702e238df7c5123$export$3f74fe60decf7462,
    CircleBufferGeometry: $c702e238df7c5123$export$3f74fe60decf7462,
    ConeGeometry: $c702e238df7c5123$export$59d971120dc8b6e7,
    ConeBufferGeometry: $c702e238df7c5123$export$59d971120dc8b6e7,
    CylinderGeometry: $c702e238df7c5123$export$d4345c83207d7c68,
    CylinderBufferGeometry: $c702e238df7c5123$export$d4345c83207d7c68,
    DodecahedronGeometry: $c702e238df7c5123$export$37cd4e52cce48c4c,
    DodecahedronBufferGeometry: $c702e238df7c5123$export$37cd4e52cce48c4c,
    EdgesGeometry: $c702e238df7c5123$export$4730b1542707547f,
    ExtrudeGeometry: $c702e238df7c5123$export$91836d01b9f75a58,
    ExtrudeBufferGeometry: $c702e238df7c5123$export$91836d01b9f75a58,
    IcosahedronGeometry: $c702e238df7c5123$export$731fd4feef063ea2,
    IcosahedronBufferGeometry: $c702e238df7c5123$export$731fd4feef063ea2,
    LatheGeometry: $c702e238df7c5123$export$dc3e1273c1dd9240,
    LatheBufferGeometry: $c702e238df7c5123$export$dc3e1273c1dd9240,
    OctahedronGeometry: $c702e238df7c5123$export$8e05fc91596f4752,
    OctahedronBufferGeometry: $c702e238df7c5123$export$8e05fc91596f4752,
    ParametricGeometry: $c702e238df7c5123$export$c56b5b5c6f0a7fff,
    ParametricBufferGeometry: $c702e238df7c5123$export$c56b5b5c6f0a7fff,
    PlaneGeometry: $c702e238df7c5123$export$e789a11a194ca4e0,
    PlaneBufferGeometry: $c702e238df7c5123$export$e789a11a194ca4e0,
    PolyhedronGeometry: $c702e238df7c5123$export$38789b531813345c,
    PolyhedronBufferGeometry: $c702e238df7c5123$export$38789b531813345c,
    RingGeometry: $c702e238df7c5123$export$ee8b85b34b7d9cad,
    RingBufferGeometry: $c702e238df7c5123$export$ee8b85b34b7d9cad,
    ShapeGeometry: $c702e238df7c5123$export$233afc324766bed8,
    ShapeBufferGeometry: $c702e238df7c5123$export$233afc324766bed8,
    SphereGeometry: $c702e238df7c5123$export$d5d06a966fec4192,
    SphereBufferGeometry: $c702e238df7c5123$export$d5d06a966fec4192,
    TetrahedronGeometry: $c702e238df7c5123$export$369e08f62a796c65,
    TetrahedronBufferGeometry: $c702e238df7c5123$export$369e08f62a796c65,
    TextGeometry: $c702e238df7c5123$export$89b83bbad46fe613,
    TextBufferGeometry: $c702e238df7c5123$export$89b83bbad46fe613,
    TorusGeometry: $c702e238df7c5123$export$19d55f905fa4f2cb,
    TorusBufferGeometry: $c702e238df7c5123$export$19d55f905fa4f2cb,
    TorusKnotGeometry: $c702e238df7c5123$export$2b32466f4274fe5c,
    TorusKnotBufferGeometry: $c702e238df7c5123$export$2b32466f4274fe5c,
    TubeGeometry: $c702e238df7c5123$export$d97a193ce44e691b,
    TubeBufferGeometry: $c702e238df7c5123$export$d97a193ce44e691b,
    WireframeGeometry: $c702e238df7c5123$export$4b739da06d24892b
});
/**
 * parameters = {
 *  color: <THREE.Color>
 * }
 */ var $c702e238df7c5123$export$e8564da406055a3 = /*#__PURE__*/ function(Material) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(ShadowMaterial, Material);
    function ShadowMaterial(parameters) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, ShadowMaterial);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, ShadowMaterial);
        _this.type = 'ShadowMaterial';
        _this.color = new $c702e238df7c5123$export$892596cec99bc70e(0x000000);
        _this.transparent = true;
        _this.setValues(parameters);
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(ShadowMaterial, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(ShadowMaterial.prototype), "copy", this).call(this, source);
                this.color.copy(source.color);
                return this;
            }
        }
    ]);
    return ShadowMaterial;
}($c702e238df7c5123$export$a2d8b23205c25948);
$c702e238df7c5123$export$e8564da406055a3.prototype.isShadowMaterial = true;
var $c702e238df7c5123$export$21c421a2e1df9d22 = /*#__PURE__*/ function(ShaderMaterial) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(RawShaderMaterial, ShaderMaterial);
    function RawShaderMaterial(parameters) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, RawShaderMaterial);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, RawShaderMaterial, [
            parameters
        ]);
        _this.type = 'RawShaderMaterial';
        return _this;
    }
    return RawShaderMaterial;
}($c702e238df7c5123$export$83c7d75d550a8b0d);
$c702e238df7c5123$export$21c421a2e1df9d22.prototype.isRawShaderMaterial = true;
/**
 * parameters = {
 *  color: <hex>,
 *  roughness: <float>,
 *  metalness: <float>,
 *  opacity: <float>,
 *
 *  map: new THREE.Texture( <Image> ),
 *
 *  lightMap: new THREE.Texture( <Image> ),
 *  lightMapIntensity: <float>
 *
 *  aoMap: new THREE.Texture( <Image> ),
 *  aoMapIntensity: <float>
 *
 *  emissive: <hex>,
 *  emissiveIntensity: <float>
 *  emissiveMap: new THREE.Texture( <Image> ),
 *
 *  bumpMap: new THREE.Texture( <Image> ),
 *  bumpScale: <float>,
 *
 *  normalMap: new THREE.Texture( <Image> ),
 *  normalMapType: THREE.TangentSpaceNormalMap,
 *  normalScale: <Vector2>,
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>,
 *
 *  roughnessMap: new THREE.Texture( <Image> ),
 *
 *  metalnessMap: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  envMap: new THREE.CubeTexture( [posx, negx, posy, negy, posz, negz] ),
 *  envMapIntensity: <float>
 *
 *  refractionRatio: <float>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 *  morphTargets: <bool>,
 *  morphNormals: <bool>,
 *
 *  flatShading: <bool>
 * }
 */ var $c702e238df7c5123$export$f2980790215acccd = /*#__PURE__*/ function(Material) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(MeshStandardMaterial, Material);
    function MeshStandardMaterial(parameters) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, MeshStandardMaterial);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, MeshStandardMaterial);
        _this.defines = {
            STANDARD: ''
        };
        _this.type = 'MeshStandardMaterial';
        _this.color = new $c702e238df7c5123$export$892596cec99bc70e(0xffffff); // diffuse
        _this.roughness = 1.0;
        _this.metalness = 0.0;
        _this.map = null;
        _this.lightMap = null;
        _this.lightMapIntensity = 1.0;
        _this.aoMap = null;
        _this.aoMapIntensity = 1.0;
        _this.emissive = new $c702e238df7c5123$export$892596cec99bc70e(0x000000);
        _this.emissiveIntensity = 1.0;
        _this.emissiveMap = null;
        _this.bumpMap = null;
        _this.bumpScale = 1;
        _this.normalMap = null;
        _this.normalMapType = $c702e238df7c5123$export$2852a58ebdac27b8;
        _this.normalScale = new $c702e238df7c5123$export$c977b3e384af9ae1(1, 1);
        _this.displacementMap = null;
        _this.displacementScale = 1;
        _this.displacementBias = 0;
        _this.roughnessMap = null;
        _this.metalnessMap = null;
        _this.alphaMap = null;
        _this.envMap = null;
        _this.envMapIntensity = 1.0;
        _this.refractionRatio = 0.98;
        _this.wireframe = false;
        _this.wireframeLinewidth = 1;
        _this.wireframeLinecap = 'round';
        _this.wireframeLinejoin = 'round';
        _this.morphTargets = false;
        _this.morphNormals = false;
        _this.flatShading = false;
        _this.vertexTangents = false;
        _this.setValues(parameters);
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(MeshStandardMaterial, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(MeshStandardMaterial.prototype), "copy", this).call(this, source);
                this.defines = {
                    STANDARD: ''
                };
                this.color.copy(source.color);
                this.roughness = source.roughness;
                this.metalness = source.metalness;
                this.map = source.map;
                this.lightMap = source.lightMap;
                this.lightMapIntensity = source.lightMapIntensity;
                this.aoMap = source.aoMap;
                this.aoMapIntensity = source.aoMapIntensity;
                this.emissive.copy(source.emissive);
                this.emissiveMap = source.emissiveMap;
                this.emissiveIntensity = source.emissiveIntensity;
                this.bumpMap = source.bumpMap;
                this.bumpScale = source.bumpScale;
                this.normalMap = source.normalMap;
                this.normalMapType = source.normalMapType;
                this.normalScale.copy(source.normalScale);
                this.displacementMap = source.displacementMap;
                this.displacementScale = source.displacementScale;
                this.displacementBias = source.displacementBias;
                this.roughnessMap = source.roughnessMap;
                this.metalnessMap = source.metalnessMap;
                this.alphaMap = source.alphaMap;
                this.envMap = source.envMap;
                this.envMapIntensity = source.envMapIntensity;
                this.refractionRatio = source.refractionRatio;
                this.wireframe = source.wireframe;
                this.wireframeLinewidth = source.wireframeLinewidth;
                this.wireframeLinecap = source.wireframeLinecap;
                this.wireframeLinejoin = source.wireframeLinejoin;
                this.morphTargets = source.morphTargets;
                this.morphNormals = source.morphNormals;
                this.flatShading = source.flatShading;
                this.vertexTangents = source.vertexTangents;
                return this;
            }
        }
    ]);
    return MeshStandardMaterial;
}($c702e238df7c5123$export$a2d8b23205c25948);
$c702e238df7c5123$export$f2980790215acccd.prototype.isMeshStandardMaterial = true;
/**
 * parameters = {
 *  clearcoat: <float>,
 *  clearcoatMap: new THREE.Texture( <Image> ),
 *  clearcoatRoughness: <float>,
 *  clearcoatRoughnessMap: new THREE.Texture( <Image> ),
 *  clearcoatNormalScale: <Vector2>,
 *  clearcoatNormalMap: new THREE.Texture( <Image> ),
 *
 *  reflectivity: <float>,
 *  ior: <float>,
 *
 *  sheen: <Color>,
 *
 *  transmission: <float>,
 *  transmissionMap: new THREE.Texture( <Image> ),
 *
 *  thickness: <float>,
 *  thicknessMap: new THREE.Texture( <Image> ),
 *  attenuationDistance: <float>,
 *  attenuationColor: <Color>
 * }
 */ var $c702e238df7c5123$export$28d04986c4269c9f = /*#__PURE__*/ function(MeshStandardMaterial) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(MeshPhysicalMaterial, MeshStandardMaterial);
    function MeshPhysicalMaterial(parameters) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, MeshPhysicalMaterial);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, MeshPhysicalMaterial);
        _this.defines = {
            STANDARD: '',
            PHYSICAL: ''
        };
        _this.type = 'MeshPhysicalMaterial';
        _this.clearcoat = 0.0;
        _this.clearcoatMap = null;
        _this.clearcoatRoughness = 0.0;
        _this.clearcoatRoughnessMap = null;
        _this.clearcoatNormalScale = new $c702e238df7c5123$export$c977b3e384af9ae1(1, 1);
        _this.clearcoatNormalMap = null;
        _this.reflectivity = 0.5; // maps to F0 = 0.04
        Object.defineProperty(_this, 'ior', {
            get: function get() {
                return (1 + 0.4 * this.reflectivity) / (1 - 0.4 * this.reflectivity);
            },
            set: function set(ior) {
                this.reflectivity = $c702e238df7c5123$var$clamp(2.5 * (ior - 1) / (ior + 1), 0, 1);
            }
        });
        _this.sheen = null; // null will disable sheen bsdf
        _this.transmission = 0.0;
        _this.transmissionMap = null;
        _this.thickness = 0.01;
        _this.thicknessMap = null;
        _this.attenuationDistance = 0.0;
        _this.attenuationColor = new $c702e238df7c5123$export$892596cec99bc70e(1, 1, 1);
        _this.setValues(parameters);
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(MeshPhysicalMaterial, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(MeshPhysicalMaterial.prototype), "copy", this).call(this, source);
                this.defines = {
                    STANDARD: '',
                    PHYSICAL: ''
                };
                this.clearcoat = source.clearcoat;
                this.clearcoatMap = source.clearcoatMap;
                this.clearcoatRoughness = source.clearcoatRoughness;
                this.clearcoatRoughnessMap = source.clearcoatRoughnessMap;
                this.clearcoatNormalMap = source.clearcoatNormalMap;
                this.clearcoatNormalScale.copy(source.clearcoatNormalScale);
                this.reflectivity = source.reflectivity;
                if (source.sheen) this.sheen = (this.sheen || new $c702e238df7c5123$export$892596cec99bc70e()).copy(source.sheen);
                else this.sheen = null;
                this.transmission = source.transmission;
                this.transmissionMap = source.transmissionMap;
                this.thickness = source.thickness;
                this.thicknessMap = source.thicknessMap;
                this.attenuationDistance = source.attenuationDistance;
                this.attenuationColor.copy(source.attenuationColor);
                return this;
            }
        }
    ]);
    return MeshPhysicalMaterial;
}($c702e238df7c5123$export$f2980790215acccd);
$c702e238df7c5123$export$28d04986c4269c9f.prototype.isMeshPhysicalMaterial = true;
/**
 * parameters = {
 *  color: <hex>,
 *  specular: <hex>,
 *  shininess: <float>,
 *  opacity: <float>,
 *
 *  map: new THREE.Texture( <Image> ),
 *
 *  lightMap: new THREE.Texture( <Image> ),
 *  lightMapIntensity: <float>
 *
 *  aoMap: new THREE.Texture( <Image> ),
 *  aoMapIntensity: <float>
 *
 *  emissive: <hex>,
 *  emissiveIntensity: <float>
 *  emissiveMap: new THREE.Texture( <Image> ),
 *
 *  bumpMap: new THREE.Texture( <Image> ),
 *  bumpScale: <float>,
 *
 *  normalMap: new THREE.Texture( <Image> ),
 *  normalMapType: THREE.TangentSpaceNormalMap,
 *  normalScale: <Vector2>,
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>,
 *
 *  specularMap: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  envMap: new THREE.CubeTexture( [posx, negx, posy, negy, posz, negz] ),
 *  combine: THREE.MultiplyOperation,
 *  reflectivity: <float>,
 *  refractionRatio: <float>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 *  morphTargets: <bool>,
 *  morphNormals: <bool>,
 *
 *  flatShading: <bool>
 * }
 */ var $c702e238df7c5123$export$24c72f71cbaf0678 = /*#__PURE__*/ function(Material) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(MeshPhongMaterial, Material);
    function MeshPhongMaterial(parameters) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, MeshPhongMaterial);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, MeshPhongMaterial);
        _this.type = 'MeshPhongMaterial';
        _this.color = new $c702e238df7c5123$export$892596cec99bc70e(0xffffff); // diffuse
        _this.specular = new $c702e238df7c5123$export$892596cec99bc70e(0x111111);
        _this.shininess = 30;
        _this.map = null;
        _this.lightMap = null;
        _this.lightMapIntensity = 1.0;
        _this.aoMap = null;
        _this.aoMapIntensity = 1.0;
        _this.emissive = new $c702e238df7c5123$export$892596cec99bc70e(0x000000);
        _this.emissiveIntensity = 1.0;
        _this.emissiveMap = null;
        _this.bumpMap = null;
        _this.bumpScale = 1;
        _this.normalMap = null;
        _this.normalMapType = $c702e238df7c5123$export$2852a58ebdac27b8;
        _this.normalScale = new $c702e238df7c5123$export$c977b3e384af9ae1(1, 1);
        _this.displacementMap = null;
        _this.displacementScale = 1;
        _this.displacementBias = 0;
        _this.specularMap = null;
        _this.alphaMap = null;
        _this.envMap = null;
        _this.combine = $c702e238df7c5123$export$e50ac29801f1774d;
        _this.reflectivity = 1;
        _this.refractionRatio = 0.98;
        _this.wireframe = false;
        _this.wireframeLinewidth = 1;
        _this.wireframeLinecap = 'round';
        _this.wireframeLinejoin = 'round';
        _this.morphTargets = false;
        _this.morphNormals = false;
        _this.flatShading = false;
        _this.setValues(parameters);
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(MeshPhongMaterial, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(MeshPhongMaterial.prototype), "copy", this).call(this, source);
                this.color.copy(source.color);
                this.specular.copy(source.specular);
                this.shininess = source.shininess;
                this.map = source.map;
                this.lightMap = source.lightMap;
                this.lightMapIntensity = source.lightMapIntensity;
                this.aoMap = source.aoMap;
                this.aoMapIntensity = source.aoMapIntensity;
                this.emissive.copy(source.emissive);
                this.emissiveMap = source.emissiveMap;
                this.emissiveIntensity = source.emissiveIntensity;
                this.bumpMap = source.bumpMap;
                this.bumpScale = source.bumpScale;
                this.normalMap = source.normalMap;
                this.normalMapType = source.normalMapType;
                this.normalScale.copy(source.normalScale);
                this.displacementMap = source.displacementMap;
                this.displacementScale = source.displacementScale;
                this.displacementBias = source.displacementBias;
                this.specularMap = source.specularMap;
                this.alphaMap = source.alphaMap;
                this.envMap = source.envMap;
                this.combine = source.combine;
                this.reflectivity = source.reflectivity;
                this.refractionRatio = source.refractionRatio;
                this.wireframe = source.wireframe;
                this.wireframeLinewidth = source.wireframeLinewidth;
                this.wireframeLinecap = source.wireframeLinecap;
                this.wireframeLinejoin = source.wireframeLinejoin;
                this.morphTargets = source.morphTargets;
                this.morphNormals = source.morphNormals;
                this.flatShading = source.flatShading;
                return this;
            }
        }
    ]);
    return MeshPhongMaterial;
}($c702e238df7c5123$export$a2d8b23205c25948);
$c702e238df7c5123$export$24c72f71cbaf0678.prototype.isMeshPhongMaterial = true;
/**
 * parameters = {
 *  color: <hex>,
 *
 *  map: new THREE.Texture( <Image> ),
 *  gradientMap: new THREE.Texture( <Image> ),
 *
 *  lightMap: new THREE.Texture( <Image> ),
 *  lightMapIntensity: <float>
 *
 *  aoMap: new THREE.Texture( <Image> ),
 *  aoMapIntensity: <float>
 *
 *  emissive: <hex>,
 *  emissiveIntensity: <float>
 *  emissiveMap: new THREE.Texture( <Image> ),
 *
 *  bumpMap: new THREE.Texture( <Image> ),
 *  bumpScale: <float>,
 *
 *  normalMap: new THREE.Texture( <Image> ),
 *  normalMapType: THREE.TangentSpaceNormalMap,
 *  normalScale: <Vector2>,
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>,
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 *  morphTargets: <bool>,
 *  morphNormals: <bool>
 * }
 */ var $c702e238df7c5123$export$df893cf97e765622 = /*#__PURE__*/ function(Material) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(MeshToonMaterial, Material);
    function MeshToonMaterial(parameters) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, MeshToonMaterial);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, MeshToonMaterial);
        _this.defines = {
            TOON: ''
        };
        _this.type = 'MeshToonMaterial';
        _this.color = new $c702e238df7c5123$export$892596cec99bc70e(0xffffff);
        _this.map = null;
        _this.gradientMap = null;
        _this.lightMap = null;
        _this.lightMapIntensity = 1.0;
        _this.aoMap = null;
        _this.aoMapIntensity = 1.0;
        _this.emissive = new $c702e238df7c5123$export$892596cec99bc70e(0x000000);
        _this.emissiveIntensity = 1.0;
        _this.emissiveMap = null;
        _this.bumpMap = null;
        _this.bumpScale = 1;
        _this.normalMap = null;
        _this.normalMapType = $c702e238df7c5123$export$2852a58ebdac27b8;
        _this.normalScale = new $c702e238df7c5123$export$c977b3e384af9ae1(1, 1);
        _this.displacementMap = null;
        _this.displacementScale = 1;
        _this.displacementBias = 0;
        _this.alphaMap = null;
        _this.wireframe = false;
        _this.wireframeLinewidth = 1;
        _this.wireframeLinecap = 'round';
        _this.wireframeLinejoin = 'round';
        _this.morphTargets = false;
        _this.morphNormals = false;
        _this.setValues(parameters);
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(MeshToonMaterial, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(MeshToonMaterial.prototype), "copy", this).call(this, source);
                this.color.copy(source.color);
                this.map = source.map;
                this.gradientMap = source.gradientMap;
                this.lightMap = source.lightMap;
                this.lightMapIntensity = source.lightMapIntensity;
                this.aoMap = source.aoMap;
                this.aoMapIntensity = source.aoMapIntensity;
                this.emissive.copy(source.emissive);
                this.emissiveMap = source.emissiveMap;
                this.emissiveIntensity = source.emissiveIntensity;
                this.bumpMap = source.bumpMap;
                this.bumpScale = source.bumpScale;
                this.normalMap = source.normalMap;
                this.normalMapType = source.normalMapType;
                this.normalScale.copy(source.normalScale);
                this.displacementMap = source.displacementMap;
                this.displacementScale = source.displacementScale;
                this.displacementBias = source.displacementBias;
                this.alphaMap = source.alphaMap;
                this.wireframe = source.wireframe;
                this.wireframeLinewidth = source.wireframeLinewidth;
                this.wireframeLinecap = source.wireframeLinecap;
                this.wireframeLinejoin = source.wireframeLinejoin;
                this.morphTargets = source.morphTargets;
                this.morphNormals = source.morphNormals;
                return this;
            }
        }
    ]);
    return MeshToonMaterial;
}($c702e238df7c5123$export$a2d8b23205c25948);
$c702e238df7c5123$export$df893cf97e765622.prototype.isMeshToonMaterial = true;
/**
 * parameters = {
 *  opacity: <float>,
 *
 *  bumpMap: new THREE.Texture( <Image> ),
 *  bumpScale: <float>,
 *
 *  normalMap: new THREE.Texture( <Image> ),
 *  normalMapType: THREE.TangentSpaceNormalMap,
 *  normalScale: <Vector2>,
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>
 *
 *  morphTargets: <bool>,
 *  morphNormals: <bool>,
 *
 *  flatShading: <bool>
 * }
 */ var $c702e238df7c5123$export$bfe8c0a091f41ae7 = /*#__PURE__*/ function(Material) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(MeshNormalMaterial, Material);
    function MeshNormalMaterial(parameters) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, MeshNormalMaterial);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, MeshNormalMaterial);
        _this.type = 'MeshNormalMaterial';
        _this.bumpMap = null;
        _this.bumpScale = 1;
        _this.normalMap = null;
        _this.normalMapType = $c702e238df7c5123$export$2852a58ebdac27b8;
        _this.normalScale = new $c702e238df7c5123$export$c977b3e384af9ae1(1, 1);
        _this.displacementMap = null;
        _this.displacementScale = 1;
        _this.displacementBias = 0;
        _this.wireframe = false;
        _this.wireframeLinewidth = 1;
        _this.fog = false;
        _this.morphTargets = false;
        _this.morphNormals = false;
        _this.flatShading = false;
        _this.setValues(parameters);
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(MeshNormalMaterial, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(MeshNormalMaterial.prototype), "copy", this).call(this, source);
                this.bumpMap = source.bumpMap;
                this.bumpScale = source.bumpScale;
                this.normalMap = source.normalMap;
                this.normalMapType = source.normalMapType;
                this.normalScale.copy(source.normalScale);
                this.displacementMap = source.displacementMap;
                this.displacementScale = source.displacementScale;
                this.displacementBias = source.displacementBias;
                this.wireframe = source.wireframe;
                this.wireframeLinewidth = source.wireframeLinewidth;
                this.morphTargets = source.morphTargets;
                this.morphNormals = source.morphNormals;
                this.flatShading = source.flatShading;
                return this;
            }
        }
    ]);
    return MeshNormalMaterial;
}($c702e238df7c5123$export$a2d8b23205c25948);
$c702e238df7c5123$export$bfe8c0a091f41ae7.prototype.isMeshNormalMaterial = true;
/**
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *
 *  map: new THREE.Texture( <Image> ),
 *
 *  lightMap: new THREE.Texture( <Image> ),
 *  lightMapIntensity: <float>
 *
 *  aoMap: new THREE.Texture( <Image> ),
 *  aoMapIntensity: <float>
 *
 *  emissive: <hex>,
 *  emissiveIntensity: <float>
 *  emissiveMap: new THREE.Texture( <Image> ),
 *
 *  specularMap: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  envMap: new THREE.CubeTexture( [posx, negx, posy, negy, posz, negz] ),
 *  combine: THREE.Multiply,
 *  reflectivity: <float>,
 *  refractionRatio: <float>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 *  morphTargets: <bool>,
 *  morphNormals: <bool>
 * }
 */ var $c702e238df7c5123$export$5023a9a8114806b8 = /*#__PURE__*/ function(Material) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(MeshLambertMaterial, Material);
    function MeshLambertMaterial(parameters) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, MeshLambertMaterial);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, MeshLambertMaterial);
        _this.type = 'MeshLambertMaterial';
        _this.color = new $c702e238df7c5123$export$892596cec99bc70e(0xffffff); // diffuse
        _this.map = null;
        _this.lightMap = null;
        _this.lightMapIntensity = 1.0;
        _this.aoMap = null;
        _this.aoMapIntensity = 1.0;
        _this.emissive = new $c702e238df7c5123$export$892596cec99bc70e(0x000000);
        _this.emissiveIntensity = 1.0;
        _this.emissiveMap = null;
        _this.specularMap = null;
        _this.alphaMap = null;
        _this.envMap = null;
        _this.combine = $c702e238df7c5123$export$e50ac29801f1774d;
        _this.reflectivity = 1;
        _this.refractionRatio = 0.98;
        _this.wireframe = false;
        _this.wireframeLinewidth = 1;
        _this.wireframeLinecap = 'round';
        _this.wireframeLinejoin = 'round';
        _this.morphTargets = false;
        _this.morphNormals = false;
        _this.setValues(parameters);
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(MeshLambertMaterial, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(MeshLambertMaterial.prototype), "copy", this).call(this, source);
                this.color.copy(source.color);
                this.map = source.map;
                this.lightMap = source.lightMap;
                this.lightMapIntensity = source.lightMapIntensity;
                this.aoMap = source.aoMap;
                this.aoMapIntensity = source.aoMapIntensity;
                this.emissive.copy(source.emissive);
                this.emissiveMap = source.emissiveMap;
                this.emissiveIntensity = source.emissiveIntensity;
                this.specularMap = source.specularMap;
                this.alphaMap = source.alphaMap;
                this.envMap = source.envMap;
                this.combine = source.combine;
                this.reflectivity = source.reflectivity;
                this.refractionRatio = source.refractionRatio;
                this.wireframe = source.wireframe;
                this.wireframeLinewidth = source.wireframeLinewidth;
                this.wireframeLinecap = source.wireframeLinecap;
                this.wireframeLinejoin = source.wireframeLinejoin;
                this.morphTargets = source.morphTargets;
                this.morphNormals = source.morphNormals;
                return this;
            }
        }
    ]);
    return MeshLambertMaterial;
}($c702e238df7c5123$export$a2d8b23205c25948);
$c702e238df7c5123$export$5023a9a8114806b8.prototype.isMeshLambertMaterial = true;
/**
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *
 *  matcap: new THREE.Texture( <Image> ),
 *
 *  map: new THREE.Texture( <Image> ),
 *
 *  bumpMap: new THREE.Texture( <Image> ),
 *  bumpScale: <float>,
 *
 *  normalMap: new THREE.Texture( <Image> ),
 *  normalMapType: THREE.TangentSpaceNormalMap,
 *  normalScale: <Vector2>,
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>,
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  morphTargets: <bool>,
 *  morphNormals: <bool>
 *
 *  flatShading: <bool>
 * }
 */ var $c702e238df7c5123$export$6f5fef6235ec12ee = /*#__PURE__*/ function(Material) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(MeshMatcapMaterial, Material);
    function MeshMatcapMaterial(parameters) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, MeshMatcapMaterial);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, MeshMatcapMaterial);
        _this.defines = {
            MATCAP: ''
        };
        _this.type = 'MeshMatcapMaterial';
        _this.color = new $c702e238df7c5123$export$892596cec99bc70e(0xffffff); // diffuse
        _this.matcap = null;
        _this.map = null;
        _this.bumpMap = null;
        _this.bumpScale = 1;
        _this.normalMap = null;
        _this.normalMapType = $c702e238df7c5123$export$2852a58ebdac27b8;
        _this.normalScale = new $c702e238df7c5123$export$c977b3e384af9ae1(1, 1);
        _this.displacementMap = null;
        _this.displacementScale = 1;
        _this.displacementBias = 0;
        _this.alphaMap = null;
        _this.morphTargets = false;
        _this.morphNormals = false;
        _this.flatShading = false;
        _this.setValues(parameters);
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(MeshMatcapMaterial, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(MeshMatcapMaterial.prototype), "copy", this).call(this, source);
                this.defines = {
                    MATCAP: ''
                };
                this.color.copy(source.color);
                this.matcap = source.matcap;
                this.map = source.map;
                this.bumpMap = source.bumpMap;
                this.bumpScale = source.bumpScale;
                this.normalMap = source.normalMap;
                this.normalMapType = source.normalMapType;
                this.normalScale.copy(source.normalScale);
                this.displacementMap = source.displacementMap;
                this.displacementScale = source.displacementScale;
                this.displacementBias = source.displacementBias;
                this.alphaMap = source.alphaMap;
                this.morphTargets = source.morphTargets;
                this.morphNormals = source.morphNormals;
                this.flatShading = source.flatShading;
                return this;
            }
        }
    ]);
    return MeshMatcapMaterial;
}($c702e238df7c5123$export$a2d8b23205c25948);
$c702e238df7c5123$export$6f5fef6235ec12ee.prototype.isMeshMatcapMaterial = true;
/**
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *
 *  linewidth: <float>,
 *
 *  scale: <float>,
 *  dashSize: <float>,
 *  gapSize: <float>
 * }
 */ var $c702e238df7c5123$export$327886a3efaeaebe = /*#__PURE__*/ function(LineBasicMaterial) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(LineDashedMaterial, LineBasicMaterial);
    function LineDashedMaterial(parameters) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, LineDashedMaterial);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, LineDashedMaterial);
        _this.type = 'LineDashedMaterial';
        _this.scale = 1;
        _this.dashSize = 3;
        _this.gapSize = 1;
        _this.setValues(parameters);
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(LineDashedMaterial, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(LineDashedMaterial.prototype), "copy", this).call(this, source);
                this.scale = source.scale;
                this.dashSize = source.dashSize;
                this.gapSize = source.gapSize;
                return this;
            }
        }
    ]);
    return LineDashedMaterial;
}($c702e238df7c5123$export$fbaaa33907730a0c);
$c702e238df7c5123$export$327886a3efaeaebe.prototype.isLineDashedMaterial = true;
var $c702e238df7c5123$var$Materials = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ShadowMaterial: $c702e238df7c5123$export$e8564da406055a3,
    SpriteMaterial: $c702e238df7c5123$export$5ec7dd1c6994bf8e,
    RawShaderMaterial: $c702e238df7c5123$export$21c421a2e1df9d22,
    ShaderMaterial: $c702e238df7c5123$export$83c7d75d550a8b0d,
    PointsMaterial: $c702e238df7c5123$export$a178c45366ce5d6b,
    MeshPhysicalMaterial: $c702e238df7c5123$export$28d04986c4269c9f,
    MeshStandardMaterial: $c702e238df7c5123$export$f2980790215acccd,
    MeshPhongMaterial: $c702e238df7c5123$export$24c72f71cbaf0678,
    MeshToonMaterial: $c702e238df7c5123$export$df893cf97e765622,
    MeshNormalMaterial: $c702e238df7c5123$export$bfe8c0a091f41ae7,
    MeshLambertMaterial: $c702e238df7c5123$export$5023a9a8114806b8,
    MeshDepthMaterial: $c702e238df7c5123$export$2698c22ec13825db,
    MeshDistanceMaterial: $c702e238df7c5123$export$33e187ed002f2a19,
    MeshBasicMaterial: $c702e238df7c5123$export$55cbcc9b622fe1f5,
    MeshMatcapMaterial: $c702e238df7c5123$export$6f5fef6235ec12ee,
    LineDashedMaterial: $c702e238df7c5123$export$327886a3efaeaebe,
    LineBasicMaterial: $c702e238df7c5123$export$fbaaa33907730a0c,
    Material: $c702e238df7c5123$export$a2d8b23205c25948
});
var $c702e238df7c5123$export$7ee8caa573e71ad1 = {
    // same as Array.prototype.slice, but also works on typed arrays
    arraySlice: function arraySlice(array, from, to) {
        if ($c702e238df7c5123$export$7ee8caa573e71ad1.isTypedArray(array)) // in ios9 array.subarray(from, undefined) will return empty array
        // but array.subarray(from) or array.subarray(from, len) is correct
        return new array.constructor(array.subarray(from, to !== undefined ? to : array.length));
        return array.slice(from, to);
    },
    // converts an array to a specific type
    convertArray: function convertArray(array, type, forceClone) {
        if (!array || // let 'undefined' and 'null' pass
        !forceClone && array.constructor === type) return array;
        if (typeof type.BYTES_PER_ELEMENT === 'number') return new type(array); // create typed array
        return Array.prototype.slice.call(array); // create Array
    },
    isTypedArray: function isTypedArray(object) {
        return ArrayBuffer.isView(object) && !(object instanceof DataView);
    },
    // returns an array by which times and values can be sorted
    getKeyframeOrder: function getKeyframeOrder(times) {
        function compareTime(i, j) {
            return times[i] - times[j];
        }
        var n = times.length;
        var result = new Array(n);
        for(var i = 0; i !== n; ++i)result[i] = i;
        result.sort(compareTime);
        return result;
    },
    // uses the array previously returned by 'getKeyframeOrder' to sort data
    sortedArray: function sortedArray(values, stride, order) {
        var nValues = values.length;
        var result = new values.constructor(nValues);
        for(var i = 0, dstOffset = 0; dstOffset !== nValues; ++i){
            var srcOffset = order[i] * stride;
            for(var j = 0; j !== stride; ++j)result[dstOffset++] = values[srcOffset + j];
        }
        return result;
    },
    // function for parsing AOS keyframe formats
    flattenJSON: function flattenJSON(jsonKeys, times, values, valuePropertyName) {
        var i = 1, key = jsonKeys[0];
        while(key !== undefined && key[valuePropertyName] === undefined)key = jsonKeys[i++];
        if (key === undefined) return; // no data
        var value = key[valuePropertyName];
        if (value === undefined) return; // no data
        if (Array.isArray(value)) do {
            value = key[valuePropertyName];
            if (value !== undefined) {
                times.push(key.time);
                values.push.apply(values, value); // push all elements
            }
            key = jsonKeys[i++];
        }while (key !== undefined);
        else if (value.toArray !== undefined) // ...assume THREE.Math-ish
        do {
            value = key[valuePropertyName];
            if (value !== undefined) {
                times.push(key.time);
                value.toArray(values, values.length);
            }
            key = jsonKeys[i++];
        }while (key !== undefined);
        else // otherwise push as-is
        do {
            value = key[valuePropertyName];
            if (value !== undefined) {
                times.push(key.time);
                values.push(value);
            }
            key = jsonKeys[i++];
        }while (key !== undefined);
    },
    subclip: function subclip(sourceClip, name, startFrame, endFrame) {
        var fps = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 30;
        var clip = sourceClip.clone();
        clip.name = name;
        var tracks = [];
        for(var i = 0; i < clip.tracks.length; ++i){
            var track = clip.tracks[i];
            var valueSize = track.getValueSize();
            var times = [];
            var values = [];
            for(var j = 0; j < track.times.length; ++j){
                var frame = track.times[j] * fps;
                if (frame < startFrame || frame >= endFrame) continue;
                times.push(track.times[j]);
                for(var k = 0; k < valueSize; ++k)values.push(track.values[j * valueSize + k]);
            }
            if (times.length === 0) continue;
            track.times = $c702e238df7c5123$export$7ee8caa573e71ad1.convertArray(times, track.times.constructor);
            track.values = $c702e238df7c5123$export$7ee8caa573e71ad1.convertArray(values, track.values.constructor);
            tracks.push(track);
        }
        clip.tracks = tracks;
        // find minimum .times value across all tracks in the trimmed clip
        var minStartTime = Infinity;
        for(var i1 = 0; i1 < clip.tracks.length; ++i1)if (minStartTime > clip.tracks[i1].times[0]) minStartTime = clip.tracks[i1].times[0];
        // shift all tracks such that clip begins at t=0
        for(var i2 = 0; i2 < clip.tracks.length; ++i2)clip.tracks[i2].shift(-1 * minStartTime);
        clip.resetDuration();
        return clip;
    },
    makeClipAdditive: function makeClipAdditive(targetClip) {
        var _loop = function(i) {
            var referenceTrack = referenceClip.tracks[i];
            var referenceTrackType = referenceTrack.ValueTypeName;
            // Skip this track if it's non-numeric
            if (referenceTrackType === 'bool' || referenceTrackType === 'string') return "continue";
            // Find the track in the target clip whose name and type matches the reference track
            var targetTrack = targetClip.tracks.find(function(track) {
                return track.name === referenceTrack.name && track.ValueTypeName === referenceTrackType;
            });
            if (targetTrack === undefined) return "continue";
            var referenceOffset = 0;
            var referenceValueSize = referenceTrack.getValueSize();
            if (referenceTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) referenceOffset = referenceValueSize / 3;
            var targetOffset = 0;
            var targetValueSize = targetTrack.getValueSize();
            if (targetTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) targetOffset = targetValueSize / 3;
            var lastIndex = referenceTrack.times.length - 1;
            var referenceValue = void 0;
            // Find the value to subtract out of the track
            if (referenceTime <= referenceTrack.times[0]) {
                // Reference frame is earlier than the first keyframe, so just use the first keyframe
                var startIndex = referenceOffset;
                var endIndex = referenceValueSize - referenceOffset;
                referenceValue = $c702e238df7c5123$export$7ee8caa573e71ad1.arraySlice(referenceTrack.values, startIndex, endIndex);
            } else if (referenceTime >= referenceTrack.times[lastIndex]) {
                // Reference frame is after the last keyframe, so just use the last keyframe
                var startIndex1 = lastIndex * referenceValueSize + referenceOffset;
                var endIndex1 = startIndex1 + referenceValueSize - referenceOffset;
                referenceValue = $c702e238df7c5123$export$7ee8caa573e71ad1.arraySlice(referenceTrack.values, startIndex1, endIndex1);
            } else {
                // Interpolate to the reference value
                var interpolant = referenceTrack.createInterpolant();
                var startIndex2 = referenceOffset;
                var endIndex2 = referenceValueSize - referenceOffset;
                interpolant.evaluate(referenceTime);
                referenceValue = $c702e238df7c5123$export$7ee8caa573e71ad1.arraySlice(interpolant.resultBuffer, startIndex2, endIndex2);
            }
            // Conjugate the quaternion
            if (referenceTrackType === 'quaternion') {
                var referenceQuat = new $c702e238df7c5123$export$23d6a54f0bbc85a3().fromArray(referenceValue).normalize().conjugate();
                referenceQuat.toArray(referenceValue);
            }
            // Subtract the reference value from all of the track values
            var numTimes = targetTrack.times.length;
            for(var j = 0; j < numTimes; ++j){
                var valueStart = j * targetValueSize + targetOffset;
                if (referenceTrackType === 'quaternion') // Multiply the conjugate for quaternion track types
                $c702e238df7c5123$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(targetTrack.values, valueStart, referenceValue, 0, targetTrack.values, valueStart);
                else {
                    var valueEnd = targetValueSize - targetOffset * 2;
                    // Subtract each value for all other numeric track types
                    for(var k = 0; k < valueEnd; ++k)targetTrack.values[valueStart + k] -= referenceValue[k];
                }
            }
        };
        var referenceFrame = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, referenceClip = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : targetClip, fps = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 30;
        if (fps <= 0) fps = 30;
        var numTracks = referenceClip.tracks.length;
        var referenceTime = referenceFrame / fps;
        // Make each track's values relative to the values at the reference frame
        for(var i = 0; i < numTracks; ++i)_loop(i);
        targetClip.blendMode = $c702e238df7c5123$export$d875e029ef558d3;
        return targetClip;
    }
};
/**
 * Abstract base class of interpolants over parametric samples.
 *
 * The parameter domain is one dimensional, typically the time or a path
 * along a curve defined by the data.
 *
 * The sample values can have any dimensionality and derived classes may
 * apply special interpretations to the data.
 *
 * This class provides the interval seek in a Template Method, deferring
 * the actual interpolation to derived classes.
 *
 * Time complexity is O(1) for linear access crossing at most two points
 * and O(log N) for random access, where N is the number of positions.
 *
 * References:
 *
 * 		http://www.oodesign.com/template-method-pattern.html
 *
 */ var $c702e238df7c5123$export$b558baee9c0f72d3 = /*#__PURE__*/ function() {
    "use strict";
    function Interpolant(parameterPositions, sampleValues, sampleSize, resultBuffer) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Interpolant);
        this.parameterPositions = parameterPositions;
        this._cachedIndex = 0;
        this.resultBuffer = resultBuffer !== undefined ? resultBuffer : new sampleValues.constructor(sampleSize);
        this.sampleValues = sampleValues;
        this.valueSize = sampleSize;
        this.settings = null;
        this.DefaultSettings_ = {};
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(Interpolant, [
        {
            key: "evaluate",
            value: function evaluate(t) {
                var pp = this.parameterPositions;
                var i1 = this._cachedIndex, t1 = pp[i1], t0 = pp[i1 - 1];
                validate_interval: {
                    seek: {
                        var right;
                        linear_scan: {
                            //- See http://jsperf.com/comparison-to-undefined/3
                            //- slower code:
                            //-
                            //- 				if ( t >= t1 || t1 === undefined ) {
                            forward_scan: if (!(t < t1)) {
                                for(var giveUpAt = i1 + 2;;){
                                    if (t1 === undefined) {
                                        if (t < t0) break forward_scan;
                                        // after end
                                        i1 = pp.length;
                                        this._cachedIndex = i1;
                                        return this.afterEnd_(i1 - 1, t, t0);
                                    }
                                    if (i1 === giveUpAt) break; // this loop
                                    t0 = t1;
                                    t1 = pp[++i1];
                                    if (t < t1) break seek;
                                }
                                // prepare binary search on the right side of the index
                                right = pp.length;
                                break linear_scan;
                            }
                            //- slower code:
                            //-					if ( t < t0 || t0 === undefined ) {
                            if (!(t >= t0)) {
                                // looping?
                                var t1global = pp[1];
                                if (t < t1global) {
                                    i1 = 2; // + 1, using the scan for the details
                                    t0 = t1global;
                                }
                                // linear reverse scan
                                for(var giveUpAt1 = i1 - 2;;){
                                    if (t0 === undefined) {
                                        // before start
                                        this._cachedIndex = 0;
                                        return this.beforeStart_(0, t, t1);
                                    }
                                    if (i1 === giveUpAt1) break; // this loop
                                    t1 = t0;
                                    t0 = pp[--i1 - 1];
                                    if (t >= t0) break seek;
                                }
                                // prepare binary search on the left side of the index
                                right = i1;
                                i1 = 0;
                                break linear_scan;
                            }
                            break validate_interval;
                        } // linear scan
                        // binary search
                        while(i1 < right){
                            var mid = i1 + right >>> 1;
                            if (t < pp[mid]) right = mid;
                            else i1 = mid + 1;
                        }
                        t1 = pp[i1];
                        t0 = pp[i1 - 1];
                        // check boundary cases, again
                        if (t0 === undefined) {
                            this._cachedIndex = 0;
                            return this.beforeStart_(0, t, t1);
                        }
                        if (t1 === undefined) {
                            i1 = pp.length;
                            this._cachedIndex = i1;
                            return this.afterEnd_(i1 - 1, t0, t);
                        }
                    } // seek
                    this._cachedIndex = i1;
                    this.intervalChanged_(i1, t0, t1);
                } // validate_interval
                return this.interpolate_(i1, t0, t, t1);
            }
        },
        {
            key: "getSettings_",
            value: function getSettings_() {
                return this.settings || this.DefaultSettings_;
            }
        },
        {
            key: "copySampleValue_",
            value: function copySampleValue_(index) {
                // copies a sample value to the result buffer
                var result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset = index * stride;
                for(var i = 0; i !== stride; ++i)result[i] = values[offset + i];
                return result;
            }
        },
        {
            // Template methods for derived classes:
            key: "interpolate_",
            value: function interpolate_() {
                throw new Error('call to abstract method');
            // implementations shall return this.resultBuffer
            }
        },
        {
            key: "intervalChanged_",
            value: function intervalChanged_() {
            // empty
            }
        }
    ]);
    return Interpolant;
}();
// ALIAS DEFINITIONS
$c702e238df7c5123$export$b558baee9c0f72d3.prototype.beforeStart_ = $c702e238df7c5123$export$b558baee9c0f72d3.prototype.copySampleValue_;
$c702e238df7c5123$export$b558baee9c0f72d3.prototype.afterEnd_ = $c702e238df7c5123$export$b558baee9c0f72d3.prototype.copySampleValue_;
/**
 * Fast and simple cubic spline interpolant.
 *
 * It was derived from a Hermitian construction setting the first derivative
 * at each sample position to the linear slope between neighboring positions
 * over their parameter interval.
 */ var $c702e238df7c5123$export$3646682e7a3959 = /*#__PURE__*/ function(Interpolant) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(CubicInterpolant, Interpolant);
    function CubicInterpolant(parameterPositions, sampleValues, sampleSize, resultBuffer) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, CubicInterpolant);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, CubicInterpolant, [
            parameterPositions,
            sampleValues,
            sampleSize,
            resultBuffer
        ]);
        _this._weightPrev = -0;
        _this._offsetPrev = -0;
        _this._weightNext = -0;
        _this._offsetNext = -0;
        _this.DefaultSettings_ = {
            endingStart: $c702e238df7c5123$export$7f795934b84ab523,
            endingEnd: $c702e238df7c5123$export$7f795934b84ab523
        };
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(CubicInterpolant, [
        {
            key: "intervalChanged_",
            value: function intervalChanged_(i1, t0, t1) {
                var pp = this.parameterPositions;
                var iPrev = i1 - 2, iNext = i1 + 1, tPrev = pp[iPrev], tNext = pp[iNext];
                if (tPrev === undefined) switch(this.getSettings_().endingStart){
                    case $c702e238df7c5123$export$24a4ccb5099273b5:
                        // f'(t0) = 0
                        iPrev = i1;
                        tPrev = 2 * t0 - t1;
                        break;
                    case $c702e238df7c5123$export$8e8c3ecdcd8e1fee:
                        // use the other end of the curve
                        iPrev = pp.length - 2;
                        tPrev = t0 + pp[iPrev] - pp[iPrev + 1];
                        break;
                    default:
                        // f''(t0) = 0 a.k.a. Natural Spline
                        iPrev = i1;
                        tPrev = t1;
                }
                if (tNext === undefined) switch(this.getSettings_().endingEnd){
                    case $c702e238df7c5123$export$24a4ccb5099273b5:
                        // f'(tN) = 0
                        iNext = i1;
                        tNext = 2 * t1 - t0;
                        break;
                    case $c702e238df7c5123$export$8e8c3ecdcd8e1fee:
                        // use the other end of the curve
                        iNext = 1;
                        tNext = t1 + pp[1] - pp[0];
                        break;
                    default:
                        // f''(tN) = 0, a.k.a. Natural Spline
                        iNext = i1 - 1;
                        tNext = t0;
                }
                var halfDt = (t1 - t0) * 0.5, stride = this.valueSize;
                this._weightPrev = halfDt / (t0 - tPrev);
                this._weightNext = halfDt / (tNext - t1);
                this._offsetPrev = iPrev * stride;
                this._offsetNext = iNext * stride;
            }
        },
        {
            key: "interpolate_",
            value: function interpolate_(i1, t0, t, t1) {
                var result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, o1 = i1 * stride, o0 = o1 - stride, oP = this._offsetPrev, oN = this._offsetNext, wP = this._weightPrev, wN = this._weightNext, p = (t - t0) / (t1 - t0), pp = p * p, ppp = pp * p;
                // evaluate polynomials
                var sP = -wP * ppp + 2 * wP * pp - wP * p;
                var s0 = (1 + wP) * ppp + (-1.5 - 2 * wP) * pp + (-0.5 + wP) * p + 1;
                var s1 = (-1 - wN) * ppp + (1.5 + wN) * pp + 0.5 * p;
                var sN = wN * ppp - wN * pp;
                // combine data linearly
                for(var i = 0; i !== stride; ++i)result[i] = sP * values[oP + i] + s0 * values[o0 + i] + s1 * values[o1 + i] + sN * values[oN + i];
                return result;
            }
        }
    ]);
    return CubicInterpolant;
}($c702e238df7c5123$export$b558baee9c0f72d3);
var $c702e238df7c5123$export$a8e6009059f51e1a = /*#__PURE__*/ function(Interpolant) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(LinearInterpolant, Interpolant);
    function LinearInterpolant(parameterPositions, sampleValues, sampleSize, resultBuffer) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, LinearInterpolant);
        return (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, LinearInterpolant, [
            parameterPositions,
            sampleValues,
            sampleSize,
            resultBuffer
        ]);
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(LinearInterpolant, [
        {
            key: "interpolate_",
            value: function interpolate_(i1, t0, t, t1) {
                var result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset1 = i1 * stride, offset0 = offset1 - stride, weight1 = (t - t0) / (t1 - t0), weight0 = 1 - weight1;
                for(var i = 0; i !== stride; ++i)result[i] = values[offset0 + i] * weight0 + values[offset1 + i] * weight1;
                return result;
            }
        }
    ]);
    return LinearInterpolant;
}($c702e238df7c5123$export$b558baee9c0f72d3);
/**
 *
 * Interpolant that evaluates to the sample value at the position preceeding
 * the parameter.
 */ var $c702e238df7c5123$export$fb9758ef7ef8d5cc = /*#__PURE__*/ function(Interpolant) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(DiscreteInterpolant, Interpolant);
    function DiscreteInterpolant(parameterPositions, sampleValues, sampleSize, resultBuffer) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, DiscreteInterpolant);
        return (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, DiscreteInterpolant, [
            parameterPositions,
            sampleValues,
            sampleSize,
            resultBuffer
        ]);
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(DiscreteInterpolant, [
        {
            key: "interpolate_",
            value: function interpolate_(i1 /*, t0, t, t1 */ ) {
                return this.copySampleValue_(i1 - 1);
            }
        }
    ]);
    return DiscreteInterpolant;
}($c702e238df7c5123$export$b558baee9c0f72d3);
var $c702e238df7c5123$export$b0e479f45b7006d6 = /*#__PURE__*/ function() {
    "use strict";
    function KeyframeTrack(name, times, values, interpolation) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, KeyframeTrack);
        if (name === undefined) throw new Error('THREE.KeyframeTrack: track name is undefined');
        if (times === undefined || times.length === 0) throw new Error('THREE.KeyframeTrack: no keyframes in track named ' + name);
        this.name = name;
        this.times = $c702e238df7c5123$export$7ee8caa573e71ad1.convertArray(times, this.TimeBufferType);
        this.values = $c702e238df7c5123$export$7ee8caa573e71ad1.convertArray(values, this.ValueBufferType);
        this.setInterpolation(interpolation || this.DefaultInterpolation);
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(KeyframeTrack, [
        {
            key: "InterpolantFactoryMethodDiscrete",
            value: function InterpolantFactoryMethodDiscrete(result) {
                return new $c702e238df7c5123$export$fb9758ef7ef8d5cc(this.times, this.values, this.getValueSize(), result);
            }
        },
        {
            key: "InterpolantFactoryMethodLinear",
            value: function InterpolantFactoryMethodLinear(result) {
                return new $c702e238df7c5123$export$a8e6009059f51e1a(this.times, this.values, this.getValueSize(), result);
            }
        },
        {
            key: "InterpolantFactoryMethodSmooth",
            value: function InterpolantFactoryMethodSmooth(result) {
                return new $c702e238df7c5123$export$3646682e7a3959(this.times, this.values, this.getValueSize(), result);
            }
        },
        {
            key: "setInterpolation",
            value: function setInterpolation(interpolation) {
                var factoryMethod;
                switch(interpolation){
                    case $c702e238df7c5123$export$995b32462a65e855:
                        factoryMethod = this.InterpolantFactoryMethodDiscrete;
                        break;
                    case $c702e238df7c5123$export$30fac1aace31cf4d:
                        factoryMethod = this.InterpolantFactoryMethodLinear;
                        break;
                    case $c702e238df7c5123$export$198b11ff4c72bb30:
                        factoryMethod = this.InterpolantFactoryMethodSmooth;
                        break;
                }
                if (factoryMethod === undefined) {
                    var message = 'unsupported interpolation for ' + this.ValueTypeName + ' keyframe track named ' + this.name;
                    if (this.createInterpolant === undefined) {
                        // fall back to default, unless the default itself is messed up
                        if (interpolation !== this.DefaultInterpolation) this.setInterpolation(this.DefaultInterpolation);
                        else throw new Error(message); // fatal, in this case
                    }
                    console.warn('THREE.KeyframeTrack:', message);
                    return this;
                }
                this.createInterpolant = factoryMethod;
                return this;
            }
        },
        {
            key: "getInterpolation",
            value: function getInterpolation() {
                switch(this.createInterpolant){
                    case this.InterpolantFactoryMethodDiscrete:
                        return $c702e238df7c5123$export$995b32462a65e855;
                    case this.InterpolantFactoryMethodLinear:
                        return $c702e238df7c5123$export$30fac1aace31cf4d;
                    case this.InterpolantFactoryMethodSmooth:
                        return $c702e238df7c5123$export$198b11ff4c72bb30;
                }
            }
        },
        {
            key: "getValueSize",
            value: function getValueSize() {
                return this.values.length / this.times.length;
            }
        },
        {
            // move all keyframes either forwards or backwards in time
            key: "shift",
            value: function shift(timeOffset) {
                if (timeOffset !== 0.0) {
                    var times = this.times;
                    for(var i = 0, n = times.length; i !== n; ++i)times[i] += timeOffset;
                }
                return this;
            }
        },
        {
            // scale all keyframe times by a factor (useful for frame <-> seconds conversions)
            key: "scale",
            value: function scale(timeScale) {
                if (timeScale !== 1.0) {
                    var times = this.times;
                    for(var i = 0, n = times.length; i !== n; ++i)times[i] *= timeScale;
                }
                return this;
            }
        },
        {
            // removes keyframes before and after animation without changing any values within the range [startTime, endTime].
            // IMPORTANT: We do not shift around keys to the start of the track time, because for interpolated keys this will change their values
            key: "trim",
            value: function trim(startTime, endTime) {
                var times = this.times, nKeys = times.length;
                var from = 0, to = nKeys - 1;
                while(from !== nKeys && times[from] < startTime)++from;
                while(to !== -1 && times[to] > endTime)--to;
                ++to; // inclusive -> exclusive bound
                if (from !== 0 || to !== nKeys) {
                    // empty tracks are forbidden, so keep at least one keyframe
                    if (from >= to) {
                        to = Math.max(to, 1);
                        from = to - 1;
                    }
                    var stride = this.getValueSize();
                    this.times = $c702e238df7c5123$export$7ee8caa573e71ad1.arraySlice(times, from, to);
                    this.values = $c702e238df7c5123$export$7ee8caa573e71ad1.arraySlice(this.values, from * stride, to * stride);
                }
                return this;
            }
        },
        {
            // ensure we do not get a GarbageInGarbageOut situation, make sure tracks are at least minimally viable
            key: "validate",
            value: function validate() {
                var valid = true;
                var valueSize = this.getValueSize();
                if (valueSize - Math.floor(valueSize) !== 0) {
                    console.error('THREE.KeyframeTrack: Invalid value size in track.', this);
                    valid = false;
                }
                var times = this.times, values = this.values, nKeys = times.length;
                if (nKeys === 0) {
                    console.error('THREE.KeyframeTrack: Track is empty.', this);
                    valid = false;
                }
                var prevTime = null;
                for(var i = 0; i !== nKeys; i++){
                    var currTime = times[i];
                    if (typeof currTime === 'number' && isNaN(currTime)) {
                        console.error('THREE.KeyframeTrack: Time is not a valid number.', this, i, currTime);
                        valid = false;
                        break;
                    }
                    if (prevTime !== null && prevTime > currTime) {
                        console.error('THREE.KeyframeTrack: Out of order keys.', this, i, currTime, prevTime);
                        valid = false;
                        break;
                    }
                    prevTime = currTime;
                }
                if (values !== undefined) {
                    if ($c702e238df7c5123$export$7ee8caa573e71ad1.isTypedArray(values)) for(var i1 = 0, n = values.length; i1 !== n; ++i1){
                        var value = values[i1];
                        if (isNaN(value)) {
                            console.error('THREE.KeyframeTrack: Value is not a valid number.', this, i1, value);
                            valid = false;
                            break;
                        }
                    }
                }
                return valid;
            }
        },
        {
            // removes equivalent sequential keys as common in morph target sequences
            // (0,0,0,0,1,1,1,0,0,0,0,0,0,0) --> (0,0,1,1,0,0)
            key: "optimize",
            value: function optimize() {
                // times or values may be shared with other tracks, so overwriting is unsafe
                var times = $c702e238df7c5123$export$7ee8caa573e71ad1.arraySlice(this.times), values = $c702e238df7c5123$export$7ee8caa573e71ad1.arraySlice(this.values), stride = this.getValueSize(), smoothInterpolation = this.getInterpolation() === $c702e238df7c5123$export$198b11ff4c72bb30, lastIndex = times.length - 1;
                var writeIndex = 1;
                for(var i = 1; i < lastIndex; ++i){
                    var keep = false;
                    var time = times[i];
                    var timeNext = times[i + 1];
                    // remove adjacent keyframes scheduled at the same time
                    if (time !== timeNext && (i !== 1 || time !== times[0])) {
                        if (!smoothInterpolation) {
                            // remove unnecessary keyframes same as their neighbors
                            var offset = i * stride, offsetP = offset - stride, offsetN = offset + stride;
                            for(var j = 0; j !== stride; ++j){
                                var value = values[offset + j];
                                if (value !== values[offsetP + j] || value !== values[offsetN + j]) {
                                    keep = true;
                                    break;
                                }
                            }
                        } else keep = true;
                    }
                    // in-place compaction
                    if (keep) {
                        if (i !== writeIndex) {
                            times[writeIndex] = times[i];
                            var readOffset = i * stride, writeOffset = writeIndex * stride;
                            for(var j1 = 0; j1 !== stride; ++j1)values[writeOffset + j1] = values[readOffset + j1];
                        }
                        ++writeIndex;
                    }
                }
                // flush last keyframe (compaction looks ahead)
                if (lastIndex > 0) {
                    times[writeIndex] = times[lastIndex];
                    for(var readOffset1 = lastIndex * stride, writeOffset1 = writeIndex * stride, j2 = 0; j2 !== stride; ++j2)values[writeOffset1 + j2] = values[readOffset1 + j2];
                    ++writeIndex;
                }
                if (writeIndex !== times.length) {
                    this.times = $c702e238df7c5123$export$7ee8caa573e71ad1.arraySlice(times, 0, writeIndex);
                    this.values = $c702e238df7c5123$export$7ee8caa573e71ad1.arraySlice(values, 0, writeIndex * stride);
                } else {
                    this.times = times;
                    this.values = values;
                }
                return this;
            }
        },
        {
            key: "clone",
            value: function clone() {
                var times = $c702e238df7c5123$export$7ee8caa573e71ad1.arraySlice(this.times, 0);
                var values = $c702e238df7c5123$export$7ee8caa573e71ad1.arraySlice(this.values, 0);
                var TypedKeyframeTrack = this.constructor;
                var track = new TypedKeyframeTrack(this.name, times, values);
                // Interpolant argument to constructor is not saved, so copy the factory method directly.
                track.createInterpolant = this.createInterpolant;
                return track;
            }
        }
    ], [
        {
            key: "toJSON",
            value: // Serialization (in static context, because of constructor invocation
            // and automatic invocation of .toJSON):
            function toJSON(track) {
                var trackType = track.constructor;
                var json;
                // derived classes can define a static toJSON method
                if (trackType.toJSON !== this.toJSON) json = trackType.toJSON(track);
                else {
                    // by default, we assume the data can be serialized as-is
                    json = {
                        name: track.name,
                        times: $c702e238df7c5123$export$7ee8caa573e71ad1.convertArray(track.times, Array),
                        values: $c702e238df7c5123$export$7ee8caa573e71ad1.convertArray(track.values, Array)
                    };
                    var interpolation = track.getInterpolation();
                    if (interpolation !== track.DefaultInterpolation) json.interpolation = interpolation;
                }
                json.type = track.ValueTypeName; // mandatory
                return json;
            }
        }
    ]);
    return KeyframeTrack;
}();
$c702e238df7c5123$export$b0e479f45b7006d6.prototype.TimeBufferType = Float32Array;
$c702e238df7c5123$export$b0e479f45b7006d6.prototype.ValueBufferType = Float32Array;
$c702e238df7c5123$export$b0e479f45b7006d6.prototype.DefaultInterpolation = $c702e238df7c5123$export$30fac1aace31cf4d;
/**
 * A Track of Boolean keyframe values.
 */ var $c702e238df7c5123$export$d3a344b98cf0b775 = /*#__PURE__*/ function(KeyframeTrack) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(BooleanKeyframeTrack, KeyframeTrack);
    function BooleanKeyframeTrack() {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, BooleanKeyframeTrack);
        return (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, BooleanKeyframeTrack, arguments);
    }
    return BooleanKeyframeTrack;
}($c702e238df7c5123$export$b0e479f45b7006d6);
$c702e238df7c5123$export$d3a344b98cf0b775.prototype.ValueTypeName = 'bool';
$c702e238df7c5123$export$d3a344b98cf0b775.prototype.ValueBufferType = Array;
$c702e238df7c5123$export$d3a344b98cf0b775.prototype.DefaultInterpolation = $c702e238df7c5123$export$995b32462a65e855;
$c702e238df7c5123$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodLinear = undefined;
$c702e238df7c5123$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track of keyframe values that represent color.
 */ var $c702e238df7c5123$export$83444c5d885347d8 = /*#__PURE__*/ function(KeyframeTrack) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(ColorKeyframeTrack, KeyframeTrack);
    function ColorKeyframeTrack() {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, ColorKeyframeTrack);
        return (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, ColorKeyframeTrack, arguments);
    }
    return ColorKeyframeTrack;
}($c702e238df7c5123$export$b0e479f45b7006d6);
$c702e238df7c5123$export$83444c5d885347d8.prototype.ValueTypeName = 'color';
/**
 * A Track of numeric keyframe values.
 */ var $c702e238df7c5123$export$d45f0d1a4d9a9314 = /*#__PURE__*/ function(KeyframeTrack) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(NumberKeyframeTrack, KeyframeTrack);
    function NumberKeyframeTrack() {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, NumberKeyframeTrack);
        return (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, NumberKeyframeTrack, arguments);
    }
    return NumberKeyframeTrack;
}($c702e238df7c5123$export$b0e479f45b7006d6);
$c702e238df7c5123$export$d45f0d1a4d9a9314.prototype.ValueTypeName = 'number';
/**
 * Spherical linear unit quaternion interpolant.
 */ var $c702e238df7c5123$export$2db1cfb7923d931e = /*#__PURE__*/ function(Interpolant) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(QuaternionLinearInterpolant, Interpolant);
    function QuaternionLinearInterpolant(parameterPositions, sampleValues, sampleSize, resultBuffer) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, QuaternionLinearInterpolant);
        return (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, QuaternionLinearInterpolant, [
            parameterPositions,
            sampleValues,
            sampleSize,
            resultBuffer
        ]);
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(QuaternionLinearInterpolant, [
        {
            key: "interpolate_",
            value: function interpolate_(i1, t0, t, t1) {
                var result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, alpha = (t - t0) / (t1 - t0);
                var offset = i1 * stride;
                for(var end = offset + stride; offset !== end; offset += 4)$c702e238df7c5123$export$23d6a54f0bbc85a3.slerpFlat(result, 0, values, offset - stride, values, offset, alpha);
                return result;
            }
        }
    ]);
    return QuaternionLinearInterpolant;
}($c702e238df7c5123$export$b558baee9c0f72d3);
/**
 * A Track of quaternion keyframe values.
 */ var $c702e238df7c5123$export$b8043f12b5aafbd7 = /*#__PURE__*/ function(KeyframeTrack) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(QuaternionKeyframeTrack, KeyframeTrack);
    function QuaternionKeyframeTrack() {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, QuaternionKeyframeTrack);
        return (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, QuaternionKeyframeTrack, arguments);
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(QuaternionKeyframeTrack, [
        {
            key: "InterpolantFactoryMethodLinear",
            value: function InterpolantFactoryMethodLinear(result) {
                return new $c702e238df7c5123$export$2db1cfb7923d931e(this.times, this.values, this.getValueSize(), result);
            }
        }
    ]);
    return QuaternionKeyframeTrack;
}($c702e238df7c5123$export$b0e479f45b7006d6);
$c702e238df7c5123$export$b8043f12b5aafbd7.prototype.ValueTypeName = 'quaternion';
// ValueBufferType is inherited
$c702e238df7c5123$export$b8043f12b5aafbd7.prototype.DefaultInterpolation = $c702e238df7c5123$export$30fac1aace31cf4d;
$c702e238df7c5123$export$b8043f12b5aafbd7.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track that interpolates Strings
 */ var $c702e238df7c5123$export$6ce41d4f3a8df9cd = /*#__PURE__*/ function(KeyframeTrack) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(StringKeyframeTrack, KeyframeTrack);
    function StringKeyframeTrack() {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, StringKeyframeTrack);
        return (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, StringKeyframeTrack, arguments);
    }
    return StringKeyframeTrack;
}($c702e238df7c5123$export$b0e479f45b7006d6);
$c702e238df7c5123$export$6ce41d4f3a8df9cd.prototype.ValueTypeName = 'string';
$c702e238df7c5123$export$6ce41d4f3a8df9cd.prototype.ValueBufferType = Array;
$c702e238df7c5123$export$6ce41d4f3a8df9cd.prototype.DefaultInterpolation = $c702e238df7c5123$export$995b32462a65e855;
$c702e238df7c5123$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodLinear = undefined;
$c702e238df7c5123$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track of vectored keyframe values.
 */ var $c702e238df7c5123$export$5ce2dcb4cc9f2bff = /*#__PURE__*/ function(KeyframeTrack) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(VectorKeyframeTrack, KeyframeTrack);
    function VectorKeyframeTrack() {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, VectorKeyframeTrack);
        return (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, VectorKeyframeTrack, arguments);
    }
    return VectorKeyframeTrack;
}($c702e238df7c5123$export$b0e479f45b7006d6);
$c702e238df7c5123$export$5ce2dcb4cc9f2bff.prototype.ValueTypeName = 'vector';
var $c702e238df7c5123$export$d942c706bf23829c = /*#__PURE__*/ function() {
    "use strict";
    function AnimationClip(name) {
        var duration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1, tracks = arguments.length > 2 ? arguments[2] : void 0, blendMode = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $c702e238df7c5123$export$bcfbbdcf8de7f8cd;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, AnimationClip);
        this.name = name;
        this.tracks = tracks;
        this.duration = duration;
        this.blendMode = blendMode;
        this.uuid = $c702e238df7c5123$var$generateUUID();
        // this means it should figure out its duration by scanning the tracks
        if (this.duration < 0) this.resetDuration();
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(AnimationClip, [
        {
            key: "resetDuration",
            value: function resetDuration() {
                var tracks = this.tracks;
                var duration = 0;
                for(var i = 0, n = tracks.length; i !== n; ++i){
                    var track = this.tracks[i];
                    duration = Math.max(duration, track.times[track.times.length - 1]);
                }
                this.duration = duration;
                return this;
            }
        },
        {
            key: "trim",
            value: function trim() {
                for(var i = 0; i < this.tracks.length; i++)this.tracks[i].trim(0, this.duration);
                return this;
            }
        },
        {
            key: "validate",
            value: function validate() {
                var valid = true;
                for(var i = 0; i < this.tracks.length; i++)valid = valid && this.tracks[i].validate();
                return valid;
            }
        },
        {
            key: "optimize",
            value: function optimize() {
                for(var i = 0; i < this.tracks.length; i++)this.tracks[i].optimize();
                return this;
            }
        },
        {
            key: "clone",
            value: function clone() {
                var tracks = [];
                for(var i = 0; i < this.tracks.length; i++)tracks.push(this.tracks[i].clone());
                return new this.constructor(this.name, this.duration, tracks, this.blendMode);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return this.constructor.toJSON(this);
            }
        }
    ], [
        {
            key: "parse",
            value: function parse(json) {
                var tracks = [], jsonTracks = json.tracks, frameTime = 1.0 / (json.fps || 1.0);
                for(var i = 0, n = jsonTracks.length; i !== n; ++i)tracks.push($c702e238df7c5123$var$parseKeyframeTrack(jsonTracks[i]).scale(frameTime));
                var clip = new this(json.name, json.duration, tracks, json.blendMode);
                clip.uuid = json.uuid;
                return clip;
            }
        },
        {
            key: "toJSON",
            value: function toJSON(clip) {
                var tracks = [], clipTracks = clip.tracks;
                var json = {
                    name: clip.name,
                    duration: clip.duration,
                    tracks: tracks,
                    uuid: clip.uuid,
                    blendMode: clip.blendMode
                };
                for(var i = 0, n = clipTracks.length; i !== n; ++i)tracks.push($c702e238df7c5123$export$b0e479f45b7006d6.toJSON(clipTracks[i]));
                return json;
            }
        },
        {
            key: "CreateFromMorphTargetSequence",
            value: function CreateFromMorphTargetSequence(name, morphTargetSequence, fps, noLoop) {
                var numMorphTargets = morphTargetSequence.length;
                var tracks = [];
                for(var i = 0; i < numMorphTargets; i++){
                    var times = [];
                    var values = [];
                    times.push((i + numMorphTargets - 1) % numMorphTargets, i, (i + 1) % numMorphTargets);
                    values.push(0, 1, 0);
                    var order = $c702e238df7c5123$export$7ee8caa573e71ad1.getKeyframeOrder(times);
                    times = $c702e238df7c5123$export$7ee8caa573e71ad1.sortedArray(times, 1, order);
                    values = $c702e238df7c5123$export$7ee8caa573e71ad1.sortedArray(values, 1, order);
                    // if there is a key at the first frame, duplicate it as the
                    // last frame as well for perfect loop.
                    if (!noLoop && times[0] === 0) {
                        times.push(numMorphTargets);
                        values.push(values[0]);
                    }
                    tracks.push(new $c702e238df7c5123$export$d45f0d1a4d9a9314('.morphTargetInfluences[' + morphTargetSequence[i].name + ']', times, values).scale(1.0 / fps));
                }
                return new this(name, -1, tracks);
            }
        },
        {
            key: "findByName",
            value: function findByName(objectOrClipArray, name) {
                var clipArray = objectOrClipArray;
                if (!Array.isArray(objectOrClipArray)) {
                    var o = objectOrClipArray;
                    clipArray = o.geometry && o.geometry.animations || o.animations;
                }
                for(var i = 0; i < clipArray.length; i++){
                    if (clipArray[i].name === name) return clipArray[i];
                }
                return null;
            }
        },
        {
            key: "CreateClipsFromMorphTargetSequences",
            value: function CreateClipsFromMorphTargetSequences(morphTargets, fps, noLoop) {
                var animationToMorphTargets = {};
                // tested with https://regex101.com/ on trick sequences
                // such flamingo_flyA_003, flamingo_run1_003, crdeath0059
                var pattern = /^([\w-]*?)([\d]+)$/;
                // sort morph target names into animation groups based
                // patterns like Walk_001, Walk_002, Run_001, Run_002
                for(var i = 0, il = morphTargets.length; i < il; i++){
                    var morphTarget = morphTargets[i];
                    var parts = morphTarget.name.match(pattern);
                    if (parts && parts.length > 1) {
                        var name = parts[1];
                        var animationMorphTargets = animationToMorphTargets[name];
                        if (!animationMorphTargets) animationToMorphTargets[name] = animationMorphTargets = [];
                        animationMorphTargets.push(morphTarget);
                    }
                }
                var clips = [];
                for(var name1 in animationToMorphTargets)clips.push(this.CreateFromMorphTargetSequence(name1, animationToMorphTargets[name1], fps, noLoop));
                return clips;
            }
        },
        {
            key: "parseAnimation",
            value: // parse the animation.hierarchy format
            function parseAnimation(animation, bones) {
                if (!animation) {
                    console.error('THREE.AnimationClip: No animation in JSONLoader data.');
                    return null;
                }
                var addNonemptyTrack = function addNonemptyTrack(trackType, trackName, animationKeys, propertyName, destTracks) {
                    // only return track if there are actually keys.
                    if (animationKeys.length !== 0) {
                        var times = [];
                        var values = [];
                        $c702e238df7c5123$export$7ee8caa573e71ad1.flattenJSON(animationKeys, times, values, propertyName);
                        // empty keys are filtered out, so check again
                        if (times.length !== 0) destTracks.push(new trackType(trackName, times, values));
                    }
                };
                var tracks = [];
                var clipName = animation.name || 'default';
                var fps = animation.fps || 30;
                var blendMode = animation.blendMode;
                // automatic length determination in AnimationClip.
                var duration = animation.length || -1;
                var hierarchyTracks = animation.hierarchy || [];
                for(var h = 0; h < hierarchyTracks.length; h++){
                    var animationKeys = hierarchyTracks[h].keys;
                    // skip empty tracks
                    if (!animationKeys || animationKeys.length === 0) continue;
                    // process morph targets
                    if (animationKeys[0].morphTargets) {
                        // figure out all morph targets used in this track
                        var morphTargetNames = {};
                        var k = void 0;
                        for(k = 0; k < animationKeys.length; k++){
                            if (animationKeys[k].morphTargets) for(var m = 0; m < animationKeys[k].morphTargets.length; m++)morphTargetNames[animationKeys[k].morphTargets[m]] = -1;
                        }
                        // create a track for each morph target with all zero
                        // morphTargetInfluences except for the keys in which
                        // the morphTarget is named.
                        for(var morphTargetName in morphTargetNames){
                            var times = [];
                            var values = [];
                            for(var m1 = 0; m1 !== animationKeys[k].morphTargets.length; ++m1){
                                var animationKey = animationKeys[k];
                                times.push(animationKey.time);
                                values.push(animationKey.morphTarget === morphTargetName ? 1 : 0);
                            }
                            tracks.push(new $c702e238df7c5123$export$d45f0d1a4d9a9314('.morphTargetInfluence[' + morphTargetName + ']', times, values));
                        }
                        duration = morphTargetNames.length * (fps || 1.0);
                    } else {
                        // ...assume skeletal animation
                        var boneName = '.bones[' + bones[h].name + ']';
                        addNonemptyTrack($c702e238df7c5123$export$5ce2dcb4cc9f2bff, boneName + '.position', animationKeys, 'pos', tracks);
                        addNonemptyTrack($c702e238df7c5123$export$b8043f12b5aafbd7, boneName + '.quaternion', animationKeys, 'rot', tracks);
                        addNonemptyTrack($c702e238df7c5123$export$5ce2dcb4cc9f2bff, boneName + '.scale', animationKeys, 'scl', tracks);
                    }
                }
                if (tracks.length === 0) return null;
                var clip = new this(clipName, duration, tracks, blendMode);
                return clip;
            }
        }
    ]);
    return AnimationClip;
}();
function $c702e238df7c5123$var$getTrackTypeForValueTypeName(typeName) {
    switch(typeName.toLowerCase()){
        case 'scalar':
        case 'double':
        case 'float':
        case 'number':
        case 'integer':
            return $c702e238df7c5123$export$d45f0d1a4d9a9314;
        case 'vector':
        case 'vector2':
        case 'vector3':
        case 'vector4':
            return $c702e238df7c5123$export$5ce2dcb4cc9f2bff;
        case 'color':
            return $c702e238df7c5123$export$83444c5d885347d8;
        case 'quaternion':
            return $c702e238df7c5123$export$b8043f12b5aafbd7;
        case 'bool':
        case 'boolean':
            return $c702e238df7c5123$export$d3a344b98cf0b775;
        case 'string':
            return $c702e238df7c5123$export$6ce41d4f3a8df9cd;
    }
    throw new Error('THREE.KeyframeTrack: Unsupported typeName: ' + typeName);
}
function $c702e238df7c5123$var$parseKeyframeTrack(json) {
    if (json.type === undefined) throw new Error('THREE.KeyframeTrack: track type undefined, can not parse');
    var trackType = $c702e238df7c5123$var$getTrackTypeForValueTypeName(json.type);
    if (json.times === undefined) {
        var times = [], values = [];
        $c702e238df7c5123$export$7ee8caa573e71ad1.flattenJSON(json.keys, times, values, 'value');
        json.times = times;
        json.values = values;
    }
    // derived classes can define a static parse method
    if (trackType.parse !== undefined) return trackType.parse(json);
    else // by default, we assume a constructor compatible with the base
    return new trackType(json.name, json.times, json.values, json.interpolation);
}
var $c702e238df7c5123$export$94affb487e701bf2 = {
    enabled: false,
    files: {},
    add: function add(key, file) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Adding key:', key );
        this.files[key] = file;
    },
    get: function get(key) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Checking key:', key );
        return this.files[key];
    },
    remove: function remove(key) {
        delete this.files[key];
    },
    clear: function clear() {
        this.files = {};
    }
};
var $c702e238df7c5123$export$99cc795e99919eed = function LoadingManager(onLoad, onProgress, onError) {
    "use strict";
    (0, $313db6c3a7373211$export$71511d61b312f219)(this, LoadingManager);
    var scope = this;
    var isLoading = false;
    var itemsLoaded = 0;
    var itemsTotal = 0;
    var urlModifier = undefined;
    var handlers = [];
    // Refer to #5689 for the reason why we don't set .onStart
    // in the constructor
    this.onStart = undefined;
    this.onLoad = onLoad;
    this.onProgress = onProgress;
    this.onError = onError;
    this.itemStart = function(url) {
        itemsTotal++;
        if (isLoading === false) {
            if (scope.onStart !== undefined) scope.onStart(url, itemsLoaded, itemsTotal);
        }
        isLoading = true;
    };
    this.itemEnd = function(url) {
        itemsLoaded++;
        if (scope.onProgress !== undefined) scope.onProgress(url, itemsLoaded, itemsTotal);
        if (itemsLoaded === itemsTotal) {
            isLoading = false;
            if (scope.onLoad !== undefined) scope.onLoad();
        }
    };
    this.itemError = function(url) {
        if (scope.onError !== undefined) scope.onError(url);
    };
    this.resolveURL = function(url) {
        if (urlModifier) return urlModifier(url);
        return url;
    };
    this.setURLModifier = function(transform) {
        urlModifier = transform;
        return this;
    };
    this.addHandler = function(regex, loader) {
        handlers.push(regex, loader);
        return this;
    };
    this.removeHandler = function(regex) {
        var index = handlers.indexOf(regex);
        if (index !== -1) handlers.splice(index, 2);
        return this;
    };
    this.getHandler = function(file) {
        for(var i = 0, l = handlers.length; i < l; i += 2){
            var regex = handlers[i];
            var loader = handlers[i + 1];
            if (regex.global) regex.lastIndex = 0; // see #17920
            if (regex.test(file)) return loader;
        }
        return null;
    };
};
var $c702e238df7c5123$export$b033c3f9a95c6a16 = new $c702e238df7c5123$export$99cc795e99919eed();
var $c702e238df7c5123$export$3b0d6d7590275603 = /*#__PURE__*/ function() {
    "use strict";
    function Loader(manager) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Loader);
        this.manager = manager !== undefined ? manager : $c702e238df7c5123$export$b033c3f9a95c6a16;
        this.crossOrigin = 'anonymous';
        this.withCredentials = false;
        this.path = '';
        this.resourcePath = '';
        this.requestHeader = {};
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(Loader, [
        {
            key: "load",
            value: function load() {}
        },
        {
            key: "loadAsync",
            value: function loadAsync(url, onProgress) {
                var scope = this;
                return new Promise(function(resolve, reject) {
                    scope.load(url, resolve, onProgress, reject);
                });
            }
        },
        {
            key: "parse",
            value: function parse() {}
        },
        {
            key: "setCrossOrigin",
            value: function setCrossOrigin(crossOrigin) {
                this.crossOrigin = crossOrigin;
                return this;
            }
        },
        {
            key: "setWithCredentials",
            value: function setWithCredentials(value) {
                this.withCredentials = value;
                return this;
            }
        },
        {
            key: "setPath",
            value: function setPath(path) {
                this.path = path;
                return this;
            }
        },
        {
            key: "setResourcePath",
            value: function setResourcePath(resourcePath) {
                this.resourcePath = resourcePath;
                return this;
            }
        },
        {
            key: "setRequestHeader",
            value: function setRequestHeader(requestHeader) {
                this.requestHeader = requestHeader;
                return this;
            }
        }
    ]);
    return Loader;
}();
var $c702e238df7c5123$var$loading = {};
var $c702e238df7c5123$export$98435a25b5cf7b2b = /*#__PURE__*/ function(Loader) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(FileLoader, Loader);
    function FileLoader(manager) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, FileLoader);
        return (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, FileLoader, [
            manager
        ]);
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(FileLoader, [
        {
            key: "load",
            value: function load(url, onLoad, onProgress, onError) {
                if (url === undefined) url = '';
                if (this.path !== undefined) url = this.path + url;
                url = this.manager.resolveURL(url);
                var scope = this;
                var cached = $c702e238df7c5123$export$94affb487e701bf2.get(url);
                if (cached !== undefined) {
                    scope.manager.itemStart(url);
                    setTimeout(function() {
                        if (onLoad) onLoad(cached);
                        scope.manager.itemEnd(url);
                    }, 0);
                    return cached;
                }
                // Check if request is duplicate
                if ($c702e238df7c5123$var$loading[url] !== undefined) {
                    $c702e238df7c5123$var$loading[url].push({
                        onLoad: onLoad,
                        onProgress: onProgress,
                        onError: onError
                    });
                    return;
                }
                // Check for data: URI
                var dataUriRegex = /^data:(.*?)(;base64)?,(.*)$/;
                var dataUriRegexResult = url.match(dataUriRegex);
                var request;
                // Safari can not handle Data URIs through XMLHttpRequest so process manually
                if (dataUriRegexResult) {
                    var mimeType = dataUriRegexResult[1];
                    var isBase64 = !!dataUriRegexResult[2];
                    var data = dataUriRegexResult[3];
                    data = decodeURIComponent(data);
                    if (isBase64) data = atob(data);
                    try {
                        var response;
                        var responseType = (this.responseType || '').toLowerCase();
                        switch(responseType){
                            case 'arraybuffer':
                            case 'blob':
                                var view = new Uint8Array(data.length);
                                for(var i = 0; i < data.length; i++)view[i] = data.charCodeAt(i);
                                if (responseType === 'blob') response = new Blob([
                                    view.buffer
                                ], {
                                    type: mimeType
                                });
                                else response = view.buffer;
                                break;
                            case 'document':
                                var parser = new DOMParser();
                                response = parser.parseFromString(data, mimeType);
                                break;
                            case 'json':
                                response = JSON.parse(data);
                                break;
                            default:
                                response = data;
                                break;
                        }
                        // Wait for next browser tick like standard XMLHttpRequest event dispatching does
                        setTimeout(function() {
                            if (onLoad) onLoad(response);
                            scope.manager.itemEnd(url);
                        }, 0);
                    } catch (error) {
                        // Wait for next browser tick like standard XMLHttpRequest event dispatching does
                        setTimeout(function() {
                            if (onError) onError(error);
                            scope.manager.itemError(url);
                            scope.manager.itemEnd(url);
                        }, 0);
                    }
                } else {
                    // Initialise array for duplicate requests
                    $c702e238df7c5123$var$loading[url] = [];
                    $c702e238df7c5123$var$loading[url].push({
                        onLoad: onLoad,
                        onProgress: onProgress,
                        onError: onError
                    });
                    request = new XMLHttpRequest();
                    request.open('GET', url, true);
                    request.addEventListener('load', function(event) {
                        var response = this.response;
                        var callbacks = $c702e238df7c5123$var$loading[url];
                        delete $c702e238df7c5123$var$loading[url];
                        if (this.status === 200 || this.status === 0) {
                            // Some browsers return HTTP Status 0 when using non-http protocol
                            // e.g. 'file://' or 'data://'. Handle as success.
                            if (this.status === 0) console.warn('THREE.FileLoader: HTTP Status 0 received.');
                            // Add to cache only on HTTP success, so that we do not cache
                            // error response bodies as proper responses to requests.
                            $c702e238df7c5123$export$94affb487e701bf2.add(url, response);
                            for(var i = 0, il = callbacks.length; i < il; i++){
                                var callback = callbacks[i];
                                if (callback.onLoad) callback.onLoad(response);
                            }
                            scope.manager.itemEnd(url);
                        } else {
                            for(var i1 = 0, il1 = callbacks.length; i1 < il1; i1++){
                                var callback1 = callbacks[i1];
                                if (callback1.onError) callback1.onError(event);
                            }
                            scope.manager.itemError(url);
                            scope.manager.itemEnd(url);
                        }
                    }, false);
                    request.addEventListener('progress', function(event) {
                        var callbacks = $c702e238df7c5123$var$loading[url];
                        for(var i = 0, il = callbacks.length; i < il; i++){
                            var callback = callbacks[i];
                            if (callback.onProgress) callback.onProgress(event);
                        }
                    }, false);
                    request.addEventListener('error', function(event) {
                        var callbacks = $c702e238df7c5123$var$loading[url];
                        delete $c702e238df7c5123$var$loading[url];
                        for(var i = 0, il = callbacks.length; i < il; i++){
                            var callback = callbacks[i];
                            if (callback.onError) callback.onError(event);
                        }
                        scope.manager.itemError(url);
                        scope.manager.itemEnd(url);
                    }, false);
                    request.addEventListener('abort', function(event) {
                        var callbacks = $c702e238df7c5123$var$loading[url];
                        delete $c702e238df7c5123$var$loading[url];
                        for(var i = 0, il = callbacks.length; i < il; i++){
                            var callback = callbacks[i];
                            if (callback.onError) callback.onError(event);
                        }
                        scope.manager.itemError(url);
                        scope.manager.itemEnd(url);
                    }, false);
                    if (this.responseType !== undefined) request.responseType = this.responseType;
                    if (this.withCredentials !== undefined) request.withCredentials = this.withCredentials;
                    if (request.overrideMimeType) request.overrideMimeType(this.mimeType !== undefined ? this.mimeType : 'text/plain');
                    for(var header in this.requestHeader)request.setRequestHeader(header, this.requestHeader[header]);
                    request.send(null);
                }
                scope.manager.itemStart(url);
                return request;
            }
        },
        {
            key: "setResponseType",
            value: function setResponseType(value) {
                this.responseType = value;
                return this;
            }
        },
        {
            key: "setMimeType",
            value: function setMimeType(value) {
                this.mimeType = value;
                return this;
            }
        }
    ]);
    return FileLoader;
}($c702e238df7c5123$export$3b0d6d7590275603);
var $c702e238df7c5123$export$29711c7e14f61db = /*#__PURE__*/ function(Loader) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(AnimationLoader, Loader);
    function AnimationLoader(manager) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, AnimationLoader);
        return (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, AnimationLoader, [
            manager
        ]);
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(AnimationLoader, [
        {
            key: "load",
            value: function load(url, onLoad, onProgress, onError) {
                var scope = this;
                var loader = new $c702e238df7c5123$export$98435a25b5cf7b2b(this.manager);
                loader.setPath(this.path);
                loader.setRequestHeader(this.requestHeader);
                loader.setWithCredentials(this.withCredentials);
                loader.load(url, function(text) {
                    try {
                        onLoad(scope.parse(JSON.parse(text)));
                    } catch (e) {
                        if (onError) onError(e);
                        else console.error(e);
                        scope.manager.itemError(url);
                    }
                }, onProgress, onError);
            }
        },
        {
            key: "parse",
            value: function parse(json) {
                var animations = [];
                for(var i = 0; i < json.length; i++){
                    var clip = $c702e238df7c5123$export$d942c706bf23829c.parse(json[i]);
                    animations.push(clip);
                }
                return animations;
            }
        }
    ]);
    return AnimationLoader;
}($c702e238df7c5123$export$3b0d6d7590275603);
/**
 * Abstract Base class to block based textures loader (dds, pvr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */ var $c702e238df7c5123$export$bd73ce947a280350 = /*#__PURE__*/ function(Loader) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(CompressedTextureLoader, Loader);
    function CompressedTextureLoader(manager) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, CompressedTextureLoader);
        return (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, CompressedTextureLoader, [
            manager
        ]);
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(CompressedTextureLoader, [
        {
            key: "load",
            value: function load(url, onLoad, onProgress, onError) {
                var scope = this;
                var images = [];
                var texture = new $c702e238df7c5123$export$3466bac9141a5cc4();
                var loader = new $c702e238df7c5123$export$98435a25b5cf7b2b(this.manager);
                loader.setPath(this.path);
                loader.setResponseType('arraybuffer');
                loader.setRequestHeader(this.requestHeader);
                loader.setWithCredentials(scope.withCredentials);
                var loaded = 0;
                function loadTexture(i) {
                    loader.load(url[i], function(buffer) {
                        var texDatas = scope.parse(buffer, true);
                        images[i] = {
                            width: texDatas.width,
                            height: texDatas.height,
                            format: texDatas.format,
                            mipmaps: texDatas.mipmaps
                        };
                        loaded += 1;
                        if (loaded === 6) {
                            if (texDatas.mipmapCount === 1) texture.minFilter = $c702e238df7c5123$export$8a72f490b25c56c8;
                            texture.image = images;
                            texture.format = texDatas.format;
                            texture.needsUpdate = true;
                            if (onLoad) onLoad(texture);
                        }
                    }, onProgress, onError);
                }
                if (Array.isArray(url)) for(var i = 0, il = url.length; i < il; ++i)loadTexture(i);
                else // compressed cubemap texture stored in a single DDS file
                loader.load(url, function(buffer) {
                    var texDatas = scope.parse(buffer, true);
                    if (texDatas.isCubemap) {
                        var faces = texDatas.mipmaps.length / texDatas.mipmapCount;
                        for(var f = 0; f < faces; f++){
                            images[f] = {
                                mipmaps: []
                            };
                            for(var i = 0; i < texDatas.mipmapCount; i++){
                                images[f].mipmaps.push(texDatas.mipmaps[f * texDatas.mipmapCount + i]);
                                images[f].format = texDatas.format;
                                images[f].width = texDatas.width;
                                images[f].height = texDatas.height;
                            }
                        }
                        texture.image = images;
                    } else {
                        texture.image.width = texDatas.width;
                        texture.image.height = texDatas.height;
                        texture.mipmaps = texDatas.mipmaps;
                    }
                    if (texDatas.mipmapCount === 1) texture.minFilter = $c702e238df7c5123$export$8a72f490b25c56c8;
                    texture.format = texDatas.format;
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }, onProgress, onError);
                return texture;
            }
        }
    ]);
    return CompressedTextureLoader;
}($c702e238df7c5123$export$3b0d6d7590275603);
var $c702e238df7c5123$export$8905ce1c7a2464a1 = /*#__PURE__*/ function(Loader) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(ImageLoader, Loader);
    function ImageLoader(manager) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, ImageLoader);
        return (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, ImageLoader, [
            manager
        ]);
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(ImageLoader, [
        {
            key: "load",
            value: function load(url, onLoad, onProgress, onError) {
                if (this.path !== undefined) url = this.path + url;
                url = this.manager.resolveURL(url);
                var scope = this;
                var cached = $c702e238df7c5123$export$94affb487e701bf2.get(url);
                if (cached !== undefined) {
                    scope.manager.itemStart(url);
                    setTimeout(function() {
                        if (onLoad) onLoad(cached);
                        scope.manager.itemEnd(url);
                    }, 0);
                    return cached;
                }
                var image = document.createElementNS('http://www.w3.org/1999/xhtml', 'img');
                function onImageLoad() {
                    image.removeEventListener('load', onImageLoad, false);
                    image.removeEventListener('error', onImageError, false);
                    $c702e238df7c5123$export$94affb487e701bf2.add(url, this);
                    if (onLoad) onLoad(this);
                    scope.manager.itemEnd(url);
                }
                function onImageError(event) {
                    image.removeEventListener('load', onImageLoad, false);
                    image.removeEventListener('error', onImageError, false);
                    if (onError) onError(event);
                    scope.manager.itemError(url);
                    scope.manager.itemEnd(url);
                }
                image.addEventListener('load', onImageLoad, false);
                image.addEventListener('error', onImageError, false);
                if (url.substr(0, 5) !== 'data:') {
                    if (this.crossOrigin !== undefined) image.crossOrigin = this.crossOrigin;
                }
                scope.manager.itemStart(url);
                image.src = url;
                return image;
            }
        }
    ]);
    return ImageLoader;
}($c702e238df7c5123$export$3b0d6d7590275603);
var $c702e238df7c5123$export$2ec114afc2cf6308 = /*#__PURE__*/ function(Loader) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(CubeTextureLoader, Loader);
    function CubeTextureLoader(manager) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, CubeTextureLoader);
        return (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, CubeTextureLoader, [
            manager
        ]);
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(CubeTextureLoader, [
        {
            key: "load",
            value: function load(urls, onLoad, onProgress, onError) {
                var texture = new $c702e238df7c5123$export$ee2e5a18258a4049();
                var loader = new $c702e238df7c5123$export$8905ce1c7a2464a1(this.manager);
                loader.setCrossOrigin(this.crossOrigin);
                loader.setPath(this.path);
                var loaded = 0;
                function loadTexture(i) {
                    loader.load(urls[i], function(image) {
                        texture.images[i] = image;
                        loaded++;
                        if (loaded === 6) {
                            texture.needsUpdate = true;
                            if (onLoad) onLoad(texture);
                        }
                    }, undefined, onError);
                }
                for(var i = 0; i < urls.length; ++i)loadTexture(i);
                return texture;
            }
        }
    ]);
    return CubeTextureLoader;
}($c702e238df7c5123$export$3b0d6d7590275603);
/**
 * Abstract Base class to load generic binary textures formats (rgbe, hdr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */ var $c702e238df7c5123$export$792d8a18f2c55855 = /*#__PURE__*/ function(Loader) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(DataTextureLoader, Loader);
    function DataTextureLoader(manager) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, DataTextureLoader);
        return (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, DataTextureLoader, [
            manager
        ]);
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(DataTextureLoader, [
        {
            key: "load",
            value: function load(url, onLoad, onProgress, onError) {
                var scope = this;
                var texture = new $c702e238df7c5123$export$b691f601014eabe1();
                var loader = new $c702e238df7c5123$export$98435a25b5cf7b2b(this.manager);
                loader.setResponseType('arraybuffer');
                loader.setRequestHeader(this.requestHeader);
                loader.setPath(this.path);
                loader.setWithCredentials(scope.withCredentials);
                loader.load(url, function(buffer) {
                    var texData = scope.parse(buffer);
                    if (!texData) return;
                    if (texData.image !== undefined) texture.image = texData.image;
                    else if (texData.data !== undefined) {
                        texture.image.width = texData.width;
                        texture.image.height = texData.height;
                        texture.image.data = texData.data;
                    }
                    texture.wrapS = texData.wrapS !== undefined ? texData.wrapS : $c702e238df7c5123$export$9d9334239a5a5e06;
                    texture.wrapT = texData.wrapT !== undefined ? texData.wrapT : $c702e238df7c5123$export$9d9334239a5a5e06;
                    texture.magFilter = texData.magFilter !== undefined ? texData.magFilter : $c702e238df7c5123$export$8a72f490b25c56c8;
                    texture.minFilter = texData.minFilter !== undefined ? texData.minFilter : $c702e238df7c5123$export$8a72f490b25c56c8;
                    texture.anisotropy = texData.anisotropy !== undefined ? texData.anisotropy : 1;
                    if (texData.encoding !== undefined) texture.encoding = texData.encoding;
                    if (texData.flipY !== undefined) texture.flipY = texData.flipY;
                    if (texData.format !== undefined) texture.format = texData.format;
                    if (texData.type !== undefined) texture.type = texData.type;
                    if (texData.mipmaps !== undefined) {
                        texture.mipmaps = texData.mipmaps;
                        texture.minFilter = $c702e238df7c5123$export$5d8599b6a933fb1b; // presumably...
                    }
                    if (texData.mipmapCount === 1) texture.minFilter = $c702e238df7c5123$export$8a72f490b25c56c8;
                    if (texData.generateMipmaps !== undefined) texture.generateMipmaps = texData.generateMipmaps;
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture, texData);
                }, onProgress, onError);
                return texture;
            }
        }
    ]);
    return DataTextureLoader;
}($c702e238df7c5123$export$3b0d6d7590275603);
var $c702e238df7c5123$export$fd1bfc71f64c538c = /*#__PURE__*/ function(Loader) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(TextureLoader, Loader);
    function TextureLoader(manager) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, TextureLoader);
        return (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, TextureLoader, [
            manager
        ]);
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(TextureLoader, [
        {
            key: "load",
            value: function load(url, onLoad, onProgress, onError) {
                var texture = new $c702e238df7c5123$export$5431306cf43de24a();
                var loader = new $c702e238df7c5123$export$8905ce1c7a2464a1(this.manager);
                loader.setCrossOrigin(this.crossOrigin);
                loader.setPath(this.path);
                loader.load(url, function(image) {
                    texture.image = image;
                    // JPEGs can't have an alpha channel, so memory can be saved by storing them as RGB.
                    var isJPEG = url.search(/\.jpe?g($|\?)/i) > 0 || url.search(/^data\:image\/jpeg/) === 0;
                    texture.format = isJPEG ? $c702e238df7c5123$export$7c67423a5ee6f5eb : $c702e238df7c5123$export$3f8bb04b555a363c;
                    texture.needsUpdate = true;
                    if (onLoad !== undefined) onLoad(texture);
                }, onProgress, onError);
                return texture;
            }
        }
    ]);
    return TextureLoader;
}($c702e238df7c5123$export$3b0d6d7590275603);
/**************************************************************
 *	Curved Path - a curve path is simply a array of connected
 *  curves, but retains the api of a curve
 **************************************************************/ var $c702e238df7c5123$export$4aaf9b66af1bbf2c = /*#__PURE__*/ function(Curve) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(CurvePath, Curve);
    function CurvePath() {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, CurvePath);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, CurvePath);
        _this.type = 'CurvePath';
        _this.curves = [];
        _this.autoClose = false; // Automatically closes the path
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(CurvePath, [
        {
            key: "add",
            value: function add(curve) {
                this.curves.push(curve);
            }
        },
        {
            key: "closePath",
            value: function closePath() {
                // Add a line curve if start and end of lines are not connected
                var startPoint = this.curves[0].getPoint(0);
                var endPoint = this.curves[this.curves.length - 1].getPoint(1);
                if (!startPoint.equals(endPoint)) this.curves.push(new $c702e238df7c5123$export$ab2e07e76531a47e(endPoint, startPoint));
            }
        },
        {
            // To get accurate point with reference to
            // entire path distance at time t,
            // following has to be done:
            // 1. Length of each sub path have to be known
            // 2. Locate and identify type of curve
            // 3. Get t for the curve
            // 4. Return curve.getPointAt(t')
            key: "getPoint",
            value: function getPoint(t) {
                var d = t * this.getLength();
                var curveLengths = this.getCurveLengths();
                var i = 0;
                // To think about boundaries points.
                while(i < curveLengths.length){
                    if (curveLengths[i] >= d) {
                        var diff = curveLengths[i] - d;
                        var curve = this.curves[i];
                        var segmentLength = curve.getLength();
                        var u = segmentLength === 0 ? 0 : 1 - diff / segmentLength;
                        return curve.getPointAt(u);
                    }
                    i++;
                }
                return null;
            // loop where sum != 0, sum > d , sum+1 <d
            }
        },
        {
            // We cannot use the default THREE.Curve getPoint() with getLength() because in
            // THREE.Curve, getLength() depends on getPoint() but in THREE.CurvePath
            // getPoint() depends on getLength
            key: "getLength",
            value: function getLength() {
                var lens = this.getCurveLengths();
                return lens[lens.length - 1];
            }
        },
        {
            // cacheLengths must be recalculated.
            key: "updateArcLengths",
            value: function updateArcLengths() {
                this.needsUpdate = true;
                this.cacheLengths = null;
                this.getCurveLengths();
            }
        },
        {
            // Compute lengths and cache them
            // We cannot overwrite getLengths() because UtoT mapping uses it.
            key: "getCurveLengths",
            value: function getCurveLengths() {
                // We use cache values if curves and cache array are same length
                if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
                // Get length of sub-curve
                // Push sums into cached array
                var lengths = [];
                var sums = 0;
                for(var i = 0, l = this.curves.length; i < l; i++){
                    sums += this.curves[i].getLength();
                    lengths.push(sums);
                }
                this.cacheLengths = lengths;
                return lengths;
            }
        },
        {
            key: "getSpacedPoints",
            value: function getSpacedPoints() {
                var divisions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 40;
                var points = [];
                for(var i = 0; i <= divisions; i++)points.push(this.getPoint(i / divisions));
                if (this.autoClose) points.push(points[0]);
                return points;
            }
        },
        {
            key: "getPoints",
            value: function getPoints() {
                var divisions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 12;
                var points = [];
                var last;
                for(var i = 0, curves = this.curves; i < curves.length; i++){
                    var curve = curves[i];
                    var resolution = curve && curve.isEllipseCurve ? divisions * 2 : curve && (curve.isLineCurve || curve.isLineCurve3) ? 1 : curve && curve.isSplineCurve ? divisions * curve.points.length : divisions;
                    var pts = curve.getPoints(resolution);
                    for(var j = 0; j < pts.length; j++){
                        var point = pts[j];
                        if (last && last.equals(point)) continue; // ensures no consecutive points are duplicates
                        points.push(point);
                        last = point;
                    }
                }
                if (this.autoClose && points.length > 1 && !points[points.length - 1].equals(points[0])) points.push(points[0]);
                return points;
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(CurvePath.prototype), "copy", this).call(this, source);
                this.curves = [];
                for(var i = 0, l = source.curves.length; i < l; i++){
                    var curve = source.curves[i];
                    this.curves.push(curve.clone());
                }
                this.autoClose = source.autoClose;
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(CurvePath.prototype), "toJSON", this).call(this);
                data.autoClose = this.autoClose;
                data.curves = [];
                for(var i = 0, l = this.curves.length; i < l; i++){
                    var curve = this.curves[i];
                    data.curves.push(curve.toJSON());
                }
                return data;
            }
        },
        {
            key: "fromJSON",
            value: function fromJSON(json) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(CurvePath.prototype), "fromJSON", this).call(this, json);
                this.autoClose = json.autoClose;
                this.curves = [];
                for(var i = 0, l = json.curves.length; i < l; i++){
                    var curve = json.curves[i];
                    this.curves.push(new $c702e238df7c5123$var$Curves[curve.type]().fromJSON(curve));
                }
                return this;
            }
        }
    ]);
    return CurvePath;
}($c702e238df7c5123$export$b0e83c3ef8d2db1);
var $c702e238df7c5123$export$4b2950bdac9b6ee9 = /*#__PURE__*/ function(CurvePath) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(Path, CurvePath);
    function Path(points) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Path);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, Path);
        _this.type = 'Path';
        _this.currentPoint = new $c702e238df7c5123$export$c977b3e384af9ae1();
        if (points) _this.setFromPoints(points);
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(Path, [
        {
            key: "setFromPoints",
            value: function setFromPoints(points) {
                this.moveTo(points[0].x, points[0].y);
                for(var i = 1, l = points.length; i < l; i++)this.lineTo(points[i].x, points[i].y);
                return this;
            }
        },
        {
            key: "moveTo",
            value: function moveTo(x, y) {
                this.currentPoint.set(x, y); // TODO consider referencing vectors instead of copying?
                return this;
            }
        },
        {
            key: "lineTo",
            value: function lineTo(x, y) {
                var curve = new $c702e238df7c5123$export$ab2e07e76531a47e(this.currentPoint.clone(), new $c702e238df7c5123$export$c977b3e384af9ae1(x, y));
                this.curves.push(curve);
                this.currentPoint.set(x, y);
                return this;
            }
        },
        {
            key: "quadraticCurveTo",
            value: function quadraticCurveTo(aCPx, aCPy, aX, aY) {
                var curve = new $c702e238df7c5123$export$5938c4ee491a43ad(this.currentPoint.clone(), new $c702e238df7c5123$export$c977b3e384af9ae1(aCPx, aCPy), new $c702e238df7c5123$export$c977b3e384af9ae1(aX, aY));
                this.curves.push(curve);
                this.currentPoint.set(aX, aY);
                return this;
            }
        },
        {
            key: "bezierCurveTo",
            value: function bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
                var curve = new $c702e238df7c5123$export$e36650d36468bb39(this.currentPoint.clone(), new $c702e238df7c5123$export$c977b3e384af9ae1(aCP1x, aCP1y), new $c702e238df7c5123$export$c977b3e384af9ae1(aCP2x, aCP2y), new $c702e238df7c5123$export$c977b3e384af9ae1(aX, aY));
                this.curves.push(curve);
                this.currentPoint.set(aX, aY);
                return this;
            }
        },
        {
            key: "splineThru",
            value: function splineThru(pts /*Array of Vector*/ ) {
                var npts = [
                    this.currentPoint.clone()
                ].concat(pts);
                var curve = new $c702e238df7c5123$export$d3bdd77da77afc1b(npts);
                this.curves.push(curve);
                this.currentPoint.copy(pts[pts.length - 1]);
                return this;
            }
        },
        {
            key: "arc",
            value: function arc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
                var x0 = this.currentPoint.x;
                var y0 = this.currentPoint.y;
                this.absarc(aX + x0, aY + y0, aRadius, aStartAngle, aEndAngle, aClockwise);
                return this;
            }
        },
        {
            key: "absarc",
            value: function absarc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
                this.absellipse(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
                return this;
            }
        },
        {
            key: "ellipse",
            value: function ellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
                var x0 = this.currentPoint.x;
                var y0 = this.currentPoint.y;
                this.absellipse(aX + x0, aY + y0, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
                return this;
            }
        },
        {
            key: "absellipse",
            value: function absellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
                var curve = new $c702e238df7c5123$export$3f87a931616cde04(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
                if (this.curves.length > 0) {
                    // if a previous curve is present, attempt to join
                    var firstPoint = curve.getPoint(0);
                    if (!firstPoint.equals(this.currentPoint)) this.lineTo(firstPoint.x, firstPoint.y);
                }
                this.curves.push(curve);
                var lastPoint = curve.getPoint(1);
                this.currentPoint.copy(lastPoint);
                return this;
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(Path.prototype), "copy", this).call(this, source);
                this.currentPoint.copy(source.currentPoint);
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(Path.prototype), "toJSON", this).call(this);
                data.currentPoint = this.currentPoint.toArray();
                return data;
            }
        },
        {
            key: "fromJSON",
            value: function fromJSON(json) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(Path.prototype), "fromJSON", this).call(this, json);
                this.currentPoint.fromArray(json.currentPoint);
                return this;
            }
        }
    ]);
    return Path;
}($c702e238df7c5123$export$4aaf9b66af1bbf2c);
var $c702e238df7c5123$export$6428a7f2611ef1fa = /*#__PURE__*/ function(Path1) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(Shape, Path1);
    function Shape(points) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Shape);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, Shape, [
            points
        ]);
        _this.uuid = $c702e238df7c5123$var$generateUUID();
        _this.type = 'Shape';
        _this.holes = [];
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(Shape, [
        {
            key: "getPointsHoles",
            value: function getPointsHoles(divisions) {
                var holesPts = [];
                for(var i = 0, l = this.holes.length; i < l; i++)holesPts[i] = this.holes[i].getPoints(divisions);
                return holesPts;
            }
        },
        {
            // get points of shape and holes (keypoints based on segments parameter)
            key: "extractPoints",
            value: function extractPoints(divisions) {
                return {
                    shape: this.getPoints(divisions),
                    holes: this.getPointsHoles(divisions)
                };
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(Shape.prototype), "copy", this).call(this, source);
                this.holes = [];
                for(var i = 0, l = source.holes.length; i < l; i++){
                    var hole = source.holes[i];
                    this.holes.push(hole.clone());
                }
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(Shape.prototype), "toJSON", this).call(this);
                data.uuid = this.uuid;
                data.holes = [];
                for(var i = 0, l = this.holes.length; i < l; i++){
                    var hole = this.holes[i];
                    data.holes.push(hole.toJSON());
                }
                return data;
            }
        },
        {
            key: "fromJSON",
            value: function fromJSON(json) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(Shape.prototype), "fromJSON", this).call(this, json);
                this.uuid = json.uuid;
                this.holes = [];
                for(var i = 0, l = json.holes.length; i < l; i++){
                    var hole = json.holes[i];
                    this.holes.push(new $c702e238df7c5123$export$4b2950bdac9b6ee9().fromJSON(hole));
                }
                return this;
            }
        }
    ]);
    return Shape;
}($c702e238df7c5123$export$4b2950bdac9b6ee9);
var $c702e238df7c5123$export$6ecadb6ed240d696 = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(Light, Object3D);
    function Light(color) {
        var intensity = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Light);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, Light);
        _this.type = 'Light';
        _this.color = new $c702e238df7c5123$export$892596cec99bc70e(color);
        _this.intensity = intensity;
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(Light, [
        {
            key: "dispose",
            value: function dispose() {
            // Empty here in base class; some subclasses override.
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(Light.prototype), "copy", this).call(this, source);
                this.color.copy(source.color);
                this.intensity = source.intensity;
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON(meta) {
                var data = (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(Light.prototype), "toJSON", this).call(this, meta);
                data.object.color = this.color.getHex();
                data.object.intensity = this.intensity;
                if (this.groundColor !== undefined) data.object.groundColor = this.groundColor.getHex();
                if (this.distance !== undefined) data.object.distance = this.distance;
                if (this.angle !== undefined) data.object.angle = this.angle;
                if (this.decay !== undefined) data.object.decay = this.decay;
                if (this.penumbra !== undefined) data.object.penumbra = this.penumbra;
                if (this.shadow !== undefined) data.object.shadow = this.shadow.toJSON();
                return data;
            }
        }
    ]);
    return Light;
}($c702e238df7c5123$export$e4dd07dff30cc924);
$c702e238df7c5123$export$6ecadb6ed240d696.prototype.isLight = true;
var $c702e238df7c5123$export$8d474f55edbb9624 = /*#__PURE__*/ function(Light1) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(HemisphereLight, Light1);
    function HemisphereLight(skyColor, groundColor, intensity) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, HemisphereLight);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, HemisphereLight, [
            skyColor,
            intensity
        ]);
        _this.type = 'HemisphereLight';
        _this.position.copy($c702e238df7c5123$export$e4dd07dff30cc924.DefaultUp);
        _this.updateMatrix();
        _this.groundColor = new $c702e238df7c5123$export$892596cec99bc70e(groundColor);
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(HemisphereLight, [
        {
            key: "copy",
            value: function copy(source) {
                $c702e238df7c5123$export$6ecadb6ed240d696.prototype.copy.call(this, source);
                this.groundColor.copy(source.groundColor);
                return this;
            }
        }
    ]);
    return HemisphereLight;
}($c702e238df7c5123$export$6ecadb6ed240d696);
$c702e238df7c5123$export$8d474f55edbb9624.prototype.isHemisphereLight = true;
var $c702e238df7c5123$var$_projScreenMatrix$1 = /*@__PURE__*/ new $c702e238df7c5123$export$2ae72fc923e5eb5();
var $c702e238df7c5123$var$_lightPositionWorld$1 = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_lookTarget$1 = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$LightShadow = /*#__PURE__*/ function() {
    "use strict";
    function LightShadow(camera) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, LightShadow);
        this.camera = camera;
        this.bias = 0;
        this.normalBias = 0;
        this.radius = 1;
        this.mapSize = new $c702e238df7c5123$export$c977b3e384af9ae1(512, 512);
        this.map = null;
        this.mapPass = null;
        this.matrix = new $c702e238df7c5123$export$2ae72fc923e5eb5();
        this.autoUpdate = true;
        this.needsUpdate = false;
        this._frustum = new $c702e238df7c5123$export$35efe6f4c85463d2();
        this._frameExtents = new $c702e238df7c5123$export$c977b3e384af9ae1(1, 1);
        this._viewportCount = 1;
        this._viewports = [
            new $c702e238df7c5123$export$fa7daccca11cdbe3(0, 0, 1, 1)
        ];
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(LightShadow, [
        {
            key: "getViewportCount",
            value: function getViewportCount() {
                return this._viewportCount;
            }
        },
        {
            key: "getFrustum",
            value: function getFrustum() {
                return this._frustum;
            }
        },
        {
            key: "updateMatrices",
            value: function updateMatrices(light) {
                var shadowCamera = this.camera;
                var shadowMatrix = this.matrix;
                $c702e238df7c5123$var$_lightPositionWorld$1.setFromMatrixPosition(light.matrixWorld);
                shadowCamera.position.copy($c702e238df7c5123$var$_lightPositionWorld$1);
                $c702e238df7c5123$var$_lookTarget$1.setFromMatrixPosition(light.target.matrixWorld);
                shadowCamera.lookAt($c702e238df7c5123$var$_lookTarget$1);
                shadowCamera.updateMatrixWorld();
                $c702e238df7c5123$var$_projScreenMatrix$1.multiplyMatrices(shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse);
                this._frustum.setFromProjectionMatrix($c702e238df7c5123$var$_projScreenMatrix$1);
                shadowMatrix.set(0.5, 0.0, 0.0, 0.5, 0.0, 0.5, 0.0, 0.5, 0.0, 0.0, 0.5, 0.5, 0.0, 0.0, 0.0, 1.0);
                shadowMatrix.multiply(shadowCamera.projectionMatrix);
                shadowMatrix.multiply(shadowCamera.matrixWorldInverse);
            }
        },
        {
            key: "getViewport",
            value: function getViewport(viewportIndex) {
                return this._viewports[viewportIndex];
            }
        },
        {
            key: "getFrameExtents",
            value: function getFrameExtents() {
                return this._frameExtents;
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                if (this.map) this.map.dispose();
                if (this.mapPass) this.mapPass.dispose();
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                this.camera = source.camera.clone();
                this.bias = source.bias;
                this.radius = source.radius;
                this.mapSize.copy(source.mapSize);
                return this;
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var object = {};
                if (this.bias !== 0) object.bias = this.bias;
                if (this.normalBias !== 0) object.normalBias = this.normalBias;
                if (this.radius !== 1) object.radius = this.radius;
                if (this.mapSize.x !== 512 || this.mapSize.y !== 512) object.mapSize = this.mapSize.toArray();
                object.camera = this.camera.toJSON(false).object;
                delete object.camera.matrix;
                return object;
            }
        }
    ]);
    return LightShadow;
}();
var $c702e238df7c5123$var$SpotLightShadow = /*#__PURE__*/ function(LightShadow) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(SpotLightShadow, LightShadow);
    function SpotLightShadow() {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, SpotLightShadow);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, SpotLightShadow, [
            new $c702e238df7c5123$export$74e4ae24825f68d7(50, 1, 0.5, 500)
        ]);
        _this.focus = 1;
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(SpotLightShadow, [
        {
            key: "updateMatrices",
            value: function updateMatrices(light) {
                var camera = this.camera;
                var fov = $c702e238df7c5123$var$RAD2DEG * 2 * light.angle * this.focus;
                var aspect = this.mapSize.width / this.mapSize.height;
                var far = light.distance || camera.far;
                if (fov !== camera.fov || aspect !== camera.aspect || far !== camera.far) {
                    camera.fov = fov;
                    camera.aspect = aspect;
                    camera.far = far;
                    camera.updateProjectionMatrix();
                }
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(SpotLightShadow.prototype), "updateMatrices", this).call(this, light);
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(SpotLightShadow.prototype), "copy", this).call(this, source);
                this.focus = source.focus;
                return this;
            }
        }
    ]);
    return SpotLightShadow;
}($c702e238df7c5123$var$LightShadow);
$c702e238df7c5123$var$SpotLightShadow.prototype.isSpotLightShadow = true;
var $c702e238df7c5123$export$81495cbb73897362 = /*#__PURE__*/ function(Light) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(SpotLight, Light);
    function SpotLight(color, intensity) {
        var distance = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, angle = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Math.PI / 3, penumbra = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0, decay = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 1;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, SpotLight);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, SpotLight, [
            color,
            intensity
        ]);
        _this.type = 'SpotLight';
        _this.position.copy($c702e238df7c5123$export$e4dd07dff30cc924.DefaultUp);
        _this.updateMatrix();
        _this.target = new $c702e238df7c5123$export$e4dd07dff30cc924();
        _this.distance = distance;
        _this.angle = angle;
        _this.penumbra = penumbra;
        _this.decay = decay; // for physically correct lights, should be 2.
        _this.shadow = new $c702e238df7c5123$var$SpotLightShadow();
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(SpotLight, [
        {
            key: "power",
            get: function get() {
                // intensity = power per solid angle.
                // ref: equation (17) from https://seblagarde.files.wordpress.com/2015/07/course_notes_moving_frostbite_to_pbr_v32.pdf
                return this.intensity * Math.PI;
            },
            set: function set(power) {
                // intensity = power per solid angle.
                // ref: equation (17) from https://seblagarde.files.wordpress.com/2015/07/course_notes_moving_frostbite_to_pbr_v32.pdf
                this.intensity = power / Math.PI;
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this.shadow.dispose();
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(SpotLight.prototype), "copy", this).call(this, source);
                this.distance = source.distance;
                this.angle = source.angle;
                this.penumbra = source.penumbra;
                this.decay = source.decay;
                this.target = source.target.clone();
                this.shadow = source.shadow.clone();
                return this;
            }
        }
    ]);
    return SpotLight;
}($c702e238df7c5123$export$6ecadb6ed240d696);
$c702e238df7c5123$export$81495cbb73897362.prototype.isSpotLight = true;
var $c702e238df7c5123$var$_projScreenMatrix = /*@__PURE__*/ new $c702e238df7c5123$export$2ae72fc923e5eb5();
var $c702e238df7c5123$var$_lightPositionWorld = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_lookTarget = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$PointLightShadow = /*#__PURE__*/ function(LightShadow) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(PointLightShadow, LightShadow);
    function PointLightShadow() {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, PointLightShadow);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, PointLightShadow, [
            new $c702e238df7c5123$export$74e4ae24825f68d7(90, 1, 0.5, 500)
        ]);
        _this._frameExtents = new $c702e238df7c5123$export$c977b3e384af9ae1(4, 2);
        _this._viewportCount = 6;
        _this._viewports = [
            // These viewports map a cube-map onto a 2D texture with the
            // following orientation:
            //
            //  xzXZ
            //   y Y
            //
            // X - Positive x direction
            // x - Negative x direction
            // Y - Positive y direction
            // y - Negative y direction
            // Z - Positive z direction
            // z - Negative z direction
            // positive X
            new $c702e238df7c5123$export$fa7daccca11cdbe3(2, 1, 1, 1),
            // negative X
            new $c702e238df7c5123$export$fa7daccca11cdbe3(0, 1, 1, 1),
            // positive Z
            new $c702e238df7c5123$export$fa7daccca11cdbe3(3, 1, 1, 1),
            // negative Z
            new $c702e238df7c5123$export$fa7daccca11cdbe3(1, 1, 1, 1),
            // positive Y
            new $c702e238df7c5123$export$fa7daccca11cdbe3(3, 0, 1, 1),
            // negative Y
            new $c702e238df7c5123$export$fa7daccca11cdbe3(1, 0, 1, 1)
        ];
        _this._cubeDirections = [
            new $c702e238df7c5123$export$64b5c384219d3699(1, 0, 0),
            new $c702e238df7c5123$export$64b5c384219d3699(-1, 0, 0),
            new $c702e238df7c5123$export$64b5c384219d3699(0, 0, 1),
            new $c702e238df7c5123$export$64b5c384219d3699(0, 0, -1),
            new $c702e238df7c5123$export$64b5c384219d3699(0, 1, 0),
            new $c702e238df7c5123$export$64b5c384219d3699(0, -1, 0)
        ];
        _this._cubeUps = [
            new $c702e238df7c5123$export$64b5c384219d3699(0, 1, 0),
            new $c702e238df7c5123$export$64b5c384219d3699(0, 1, 0),
            new $c702e238df7c5123$export$64b5c384219d3699(0, 1, 0),
            new $c702e238df7c5123$export$64b5c384219d3699(0, 1, 0),
            new $c702e238df7c5123$export$64b5c384219d3699(0, 0, 1),
            new $c702e238df7c5123$export$64b5c384219d3699(0, 0, -1)
        ];
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(PointLightShadow, [
        {
            key: "updateMatrices",
            value: function updateMatrices(light) {
                var viewportIndex = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var camera = this.camera;
                var shadowMatrix = this.matrix;
                var far = light.distance || camera.far;
                if (far !== camera.far) {
                    camera.far = far;
                    camera.updateProjectionMatrix();
                }
                $c702e238df7c5123$var$_lightPositionWorld.setFromMatrixPosition(light.matrixWorld);
                camera.position.copy($c702e238df7c5123$var$_lightPositionWorld);
                $c702e238df7c5123$var$_lookTarget.copy(camera.position);
                $c702e238df7c5123$var$_lookTarget.add(this._cubeDirections[viewportIndex]);
                camera.up.copy(this._cubeUps[viewportIndex]);
                camera.lookAt($c702e238df7c5123$var$_lookTarget);
                camera.updateMatrixWorld();
                shadowMatrix.makeTranslation(-$c702e238df7c5123$var$_lightPositionWorld.x, -$c702e238df7c5123$var$_lightPositionWorld.y, -$c702e238df7c5123$var$_lightPositionWorld.z);
                $c702e238df7c5123$var$_projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
                this._frustum.setFromProjectionMatrix($c702e238df7c5123$var$_projScreenMatrix);
            }
        }
    ]);
    return PointLightShadow;
}($c702e238df7c5123$var$LightShadow);
$c702e238df7c5123$var$PointLightShadow.prototype.isPointLightShadow = true;
var $c702e238df7c5123$export$4c9c1cb3f0b6f455 = /*#__PURE__*/ function(Light) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(PointLight, Light);
    function PointLight(color, intensity) {
        var distance = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, decay = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, PointLight);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, PointLight, [
            color,
            intensity
        ]);
        _this.type = 'PointLight';
        _this.distance = distance;
        _this.decay = decay; // for physically correct lights, should be 2.
        _this.shadow = new $c702e238df7c5123$var$PointLightShadow();
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(PointLight, [
        {
            key: "power",
            get: function get() {
                // intensity = power per solid angle.
                // ref: equation (15) from https://seblagarde.files.wordpress.com/2015/07/course_notes_moving_frostbite_to_pbr_v32.pdf
                return this.intensity * 4 * Math.PI;
            },
            set: function set(power) {
                // intensity = power per solid angle.
                // ref: equation (15) from https://seblagarde.files.wordpress.com/2015/07/course_notes_moving_frostbite_to_pbr_v32.pdf
                this.intensity = power / (4 * Math.PI);
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this.shadow.dispose();
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(PointLight.prototype), "copy", this).call(this, source);
                this.distance = source.distance;
                this.decay = source.decay;
                this.shadow = source.shadow.clone();
                return this;
            }
        }
    ]);
    return PointLight;
}($c702e238df7c5123$export$6ecadb6ed240d696);
$c702e238df7c5123$export$4c9c1cb3f0b6f455.prototype.isPointLight = true;
var $c702e238df7c5123$export$9ebf355ee4ed261b = /*#__PURE__*/ function(Camera) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(OrthographicCamera, Camera);
    function OrthographicCamera() {
        var left = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : -1, right = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, top = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, bottom = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : -1, near = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0.1, far = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 2000;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, OrthographicCamera);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, OrthographicCamera);
        _this.type = 'OrthographicCamera';
        _this.zoom = 1;
        _this.view = null;
        _this.left = left;
        _this.right = right;
        _this.top = top;
        _this.bottom = bottom;
        _this.near = near;
        _this.far = far;
        _this.updateProjectionMatrix();
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(OrthographicCamera, [
        {
            key: "copy",
            value: function copy(source, recursive) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(OrthographicCamera.prototype), "copy", this).call(this, source, recursive);
                this.left = source.left;
                this.right = source.right;
                this.top = source.top;
                this.bottom = source.bottom;
                this.near = source.near;
                this.far = source.far;
                this.zoom = source.zoom;
                this.view = source.view === null ? null : Object.assign({}, source.view);
                return this;
            }
        },
        {
            key: "setViewOffset",
            value: function setViewOffset(fullWidth, fullHeight, x, y, width, height) {
                if (this.view === null) this.view = {
                    enabled: true,
                    fullWidth: 1,
                    fullHeight: 1,
                    offsetX: 0,
                    offsetY: 0,
                    width: 1,
                    height: 1
                };
                this.view.enabled = true;
                this.view.fullWidth = fullWidth;
                this.view.fullHeight = fullHeight;
                this.view.offsetX = x;
                this.view.offsetY = y;
                this.view.width = width;
                this.view.height = height;
                this.updateProjectionMatrix();
            }
        },
        {
            key: "clearViewOffset",
            value: function clearViewOffset() {
                if (this.view !== null) this.view.enabled = false;
                this.updateProjectionMatrix();
            }
        },
        {
            key: "updateProjectionMatrix",
            value: function updateProjectionMatrix() {
                var dx = (this.right - this.left) / (2 * this.zoom);
                var dy = (this.top - this.bottom) / (2 * this.zoom);
                var cx = (this.right + this.left) / 2;
                var cy = (this.top + this.bottom) / 2;
                var left = cx - dx;
                var right = cx + dx;
                var top = cy + dy;
                var bottom = cy - dy;
                if (this.view !== null && this.view.enabled) {
                    var scaleW = (this.right - this.left) / this.view.fullWidth / this.zoom;
                    var scaleH = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
                    left += scaleW * this.view.offsetX;
                    right = left + scaleW * this.view.width;
                    top -= scaleH * this.view.offsetY;
                    bottom = top - scaleH * this.view.height;
                }
                this.projectionMatrix.makeOrthographic(left, right, top, bottom, this.near, this.far);
                this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
            }
        },
        {
            key: "toJSON",
            value: function toJSON(meta) {
                var data = (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(OrthographicCamera.prototype), "toJSON", this).call(this, meta);
                data.object.zoom = this.zoom;
                data.object.left = this.left;
                data.object.right = this.right;
                data.object.top = this.top;
                data.object.bottom = this.bottom;
                data.object.near = this.near;
                data.object.far = this.far;
                if (this.view !== null) data.object.view = Object.assign({}, this.view);
                return data;
            }
        }
    ]);
    return OrthographicCamera;
}($c702e238df7c5123$export$79f141de891a5fed);
$c702e238df7c5123$export$9ebf355ee4ed261b.prototype.isOrthographicCamera = true;
var $c702e238df7c5123$var$DirectionalLightShadow = /*#__PURE__*/ function(LightShadow) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(DirectionalLightShadow, LightShadow);
    function DirectionalLightShadow() {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, DirectionalLightShadow);
        return (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, DirectionalLightShadow, [
            new $c702e238df7c5123$export$9ebf355ee4ed261b(-5, 5, 5, -5, 0.5, 500)
        ]);
    }
    return DirectionalLightShadow;
}($c702e238df7c5123$var$LightShadow);
$c702e238df7c5123$var$DirectionalLightShadow.prototype.isDirectionalLightShadow = true;
var $c702e238df7c5123$export$3fea33cc9972c868 = /*#__PURE__*/ function(Light) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(DirectionalLight, Light);
    function DirectionalLight(color, intensity) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, DirectionalLight);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, DirectionalLight, [
            color,
            intensity
        ]);
        _this.type = 'DirectionalLight';
        _this.position.copy($c702e238df7c5123$export$e4dd07dff30cc924.DefaultUp);
        _this.updateMatrix();
        _this.target = new $c702e238df7c5123$export$e4dd07dff30cc924();
        _this.shadow = new $c702e238df7c5123$var$DirectionalLightShadow();
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(DirectionalLight, [
        {
            key: "dispose",
            value: function dispose() {
                this.shadow.dispose();
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(DirectionalLight.prototype), "copy", this).call(this, source);
                this.target = source.target.clone();
                this.shadow = source.shadow.clone();
                return this;
            }
        }
    ]);
    return DirectionalLight;
}($c702e238df7c5123$export$6ecadb6ed240d696);
$c702e238df7c5123$export$3fea33cc9972c868.prototype.isDirectionalLight = true;
var $c702e238df7c5123$export$af279bfef9ec2c96 = /*#__PURE__*/ function(Light) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(AmbientLight, Light);
    function AmbientLight(color, intensity) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, AmbientLight);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, AmbientLight, [
            color,
            intensity
        ]);
        _this.type = 'AmbientLight';
        return _this;
    }
    return AmbientLight;
}($c702e238df7c5123$export$6ecadb6ed240d696);
$c702e238df7c5123$export$af279bfef9ec2c96.prototype.isAmbientLight = true;
var $c702e238df7c5123$export$61db2d908bbd2429 = /*#__PURE__*/ function(Light) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(RectAreaLight, Light);
    function RectAreaLight(color, intensity) {
        var width = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 10, height = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 10;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, RectAreaLight);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, RectAreaLight, [
            color,
            intensity
        ]);
        _this.type = 'RectAreaLight';
        _this.width = width;
        _this.height = height;
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(RectAreaLight, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(RectAreaLight.prototype), "copy", this).call(this, source);
                this.width = source.width;
                this.height = source.height;
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON(meta) {
                var data = (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(RectAreaLight.prototype), "toJSON", this).call(this, meta);
                data.object.width = this.width;
                data.object.height = this.height;
                return data;
            }
        }
    ]);
    return RectAreaLight;
}($c702e238df7c5123$export$6ecadb6ed240d696);
$c702e238df7c5123$export$61db2d908bbd2429.prototype.isRectAreaLight = true;
/**
 * Primary reference:
 *   https://graphics.stanford.edu/papers/envmap/envmap.pdf
 *
 * Secondary reference:
 *   https://www.ppsloan.org/publications/StupidSH36.pdf
 */ // 3-band SH defined by 9 coefficients
var $c702e238df7c5123$export$ba61ce607e1f405a = /*#__PURE__*/ function() {
    "use strict";
    function SphericalHarmonics3() {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, SphericalHarmonics3);
        this.coefficients = [];
        for(var i = 0; i < 9; i++)this.coefficients.push(new $c702e238df7c5123$export$64b5c384219d3699());
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(SphericalHarmonics3, [
        {
            key: "set",
            value: function set(coefficients) {
                for(var i = 0; i < 9; i++)this.coefficients[i].copy(coefficients[i]);
                return this;
            }
        },
        {
            key: "zero",
            value: function zero() {
                for(var i = 0; i < 9; i++)this.coefficients[i].set(0, 0, 0);
                return this;
            }
        },
        {
            // get the radiance in the direction of the normal
            // target is a Vector3
            key: "getAt",
            value: function getAt(normal, target) {
                // normal is assumed to be unit length
                var x = normal.x, y = normal.y, z = normal.z;
                var coeff = this.coefficients;
                // band 0
                target.copy(coeff[0]).multiplyScalar(0.282095);
                // band 1
                target.addScaledVector(coeff[1], 0.488603 * y);
                target.addScaledVector(coeff[2], 0.488603 * z);
                target.addScaledVector(coeff[3], 0.488603 * x);
                // band 2
                target.addScaledVector(coeff[4], 1.092548 * (x * y));
                target.addScaledVector(coeff[5], 1.092548 * (y * z));
                target.addScaledVector(coeff[6], 0.315392 * (3.0 * z * z - 1.0));
                target.addScaledVector(coeff[7], 1.092548 * (x * z));
                target.addScaledVector(coeff[8], 0.546274 * (x * x - y * y));
                return target;
            }
        },
        {
            // get the irradiance (radiance convolved with cosine lobe) in the direction of the normal
            // target is a Vector3
            // https://graphics.stanford.edu/papers/envmap/envmap.pdf
            key: "getIrradianceAt",
            value: function getIrradianceAt(normal, target) {
                // normal is assumed to be unit length
                var x = normal.x, y = normal.y, z = normal.z;
                var coeff = this.coefficients;
                // band 0
                target.copy(coeff[0]).multiplyScalar(0.886227); // π * 0.282095
                // band 1
                target.addScaledVector(coeff[1], 1.023328 * y); // ( 2 * π / 3 ) * 0.488603
                target.addScaledVector(coeff[2], 1.023328 * z);
                target.addScaledVector(coeff[3], 1.023328 * x);
                // band 2
                target.addScaledVector(coeff[4], 0.858086 * x * y); // ( π / 4 ) * 1.092548
                target.addScaledVector(coeff[5], 0.858086 * y * z);
                target.addScaledVector(coeff[6], 0.743125 * z * z - 0.247708); // ( π / 4 ) * 0.315392 * 3
                target.addScaledVector(coeff[7], 0.858086 * x * z);
                target.addScaledVector(coeff[8], 0.429043 * (x * x - y * y)); // ( π / 4 ) * 0.546274
                return target;
            }
        },
        {
            key: "add",
            value: function add(sh) {
                for(var i = 0; i < 9; i++)this.coefficients[i].add(sh.coefficients[i]);
                return this;
            }
        },
        {
            key: "addScaledSH",
            value: function addScaledSH(sh, s) {
                for(var i = 0; i < 9; i++)this.coefficients[i].addScaledVector(sh.coefficients[i], s);
                return this;
            }
        },
        {
            key: "scale",
            value: function scale(s) {
                for(var i = 0; i < 9; i++)this.coefficients[i].multiplyScalar(s);
                return this;
            }
        },
        {
            key: "lerp",
            value: function lerp(sh, alpha) {
                for(var i = 0; i < 9; i++)this.coefficients[i].lerp(sh.coefficients[i], alpha);
                return this;
            }
        },
        {
            key: "equals",
            value: function equals(sh) {
                for(var i = 0; i < 9; i++){
                    if (!this.coefficients[i].equals(sh.coefficients[i])) return false;
                }
                return true;
            }
        },
        {
            key: "copy",
            value: function copy(sh) {
                return this.set(sh.coefficients);
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        },
        {
            key: "fromArray",
            value: function fromArray(array) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var coefficients = this.coefficients;
                for(var i = 0; i < 9; i++)coefficients[i].fromArray(array, offset + i * 3);
                return this;
            }
        },
        {
            key: "toArray",
            value: function toArray() {
                var array = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var coefficients = this.coefficients;
                for(var i = 0; i < 9; i++)coefficients[i].toArray(array, offset + i * 3);
                return array;
            }
        }
    ], [
        {
            key: "getBasisAt",
            value: // evaluate the basis functions
            // shBasis is an Array[ 9 ]
            function getBasisAt(normal, shBasis) {
                // normal is assumed to be unit length
                var x = normal.x, y = normal.y, z = normal.z;
                // band 0
                shBasis[0] = 0.282095;
                // band 1
                shBasis[1] = 0.488603 * y;
                shBasis[2] = 0.488603 * z;
                shBasis[3] = 0.488603 * x;
                // band 2
                shBasis[4] = 1.092548 * x * y;
                shBasis[5] = 1.092548 * y * z;
                shBasis[6] = 0.315392 * (3 * z * z - 1);
                shBasis[7] = 1.092548 * x * z;
                shBasis[8] = 0.546274 * (x * x - y * y);
            }
        }
    ]);
    return SphericalHarmonics3;
}();
$c702e238df7c5123$export$ba61ce607e1f405a.prototype.isSphericalHarmonics3 = true;
var $c702e238df7c5123$export$e7ef036e309b38d2 = /*#__PURE__*/ function(Light) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(LightProbe, Light);
    function LightProbe() {
        var sh = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $c702e238df7c5123$export$ba61ce607e1f405a(), intensity = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, LightProbe);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, LightProbe, [
            undefined,
            intensity
        ]);
        _this.sh = sh;
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(LightProbe, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(LightProbe.prototype), "copy", this).call(this, source);
                this.sh.copy(source.sh);
                return this;
            }
        },
        {
            key: "fromJSON",
            value: function fromJSON(json) {
                this.intensity = json.intensity; // TODO: Move this bit to Light.fromJSON();
                this.sh.fromArray(json.sh);
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON(meta) {
                var data = (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(LightProbe.prototype), "toJSON", this).call(this, meta);
                data.object.sh = this.sh.toArray();
                return data;
            }
        }
    ]);
    return LightProbe;
}($c702e238df7c5123$export$6ecadb6ed240d696);
$c702e238df7c5123$export$e7ef036e309b38d2.prototype.isLightProbe = true;
var $c702e238df7c5123$export$3bd6d323353dcf96 = /*#__PURE__*/ function(Loader) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(MaterialLoader, Loader);
    function MaterialLoader(manager) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, MaterialLoader);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, MaterialLoader, [
            manager
        ]);
        _this.textures = {};
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(MaterialLoader, [
        {
            key: "load",
            value: function load(url, onLoad, onProgress, onError) {
                var scope = this;
                var loader = new $c702e238df7c5123$export$98435a25b5cf7b2b(scope.manager);
                loader.setPath(scope.path);
                loader.setRequestHeader(scope.requestHeader);
                loader.setWithCredentials(scope.withCredentials);
                loader.load(url, function(text) {
                    try {
                        onLoad(scope.parse(JSON.parse(text)));
                    } catch (e) {
                        if (onError) onError(e);
                        else console.error(e);
                        scope.manager.itemError(url);
                    }
                }, onProgress, onError);
            }
        },
        {
            key: "parse",
            value: function parse(json) {
                var textures = this.textures;
                function getTexture(name) {
                    if (textures[name] === undefined) console.warn('THREE.MaterialLoader: Undefined texture', name);
                    return textures[name];
                }
                var material = new $c702e238df7c5123$var$Materials[json.type]();
                if (json.uuid !== undefined) material.uuid = json.uuid;
                if (json.name !== undefined) material.name = json.name;
                if (json.color !== undefined && material.color !== undefined) material.color.setHex(json.color);
                if (json.roughness !== undefined) material.roughness = json.roughness;
                if (json.metalness !== undefined) material.metalness = json.metalness;
                if (json.sheen !== undefined) material.sheen = new $c702e238df7c5123$export$892596cec99bc70e().setHex(json.sheen);
                if (json.emissive !== undefined && material.emissive !== undefined) material.emissive.setHex(json.emissive);
                if (json.specular !== undefined && material.specular !== undefined) material.specular.setHex(json.specular);
                if (json.shininess !== undefined) material.shininess = json.shininess;
                if (json.clearcoat !== undefined) material.clearcoat = json.clearcoat;
                if (json.clearcoatRoughness !== undefined) material.clearcoatRoughness = json.clearcoatRoughness;
                if (json.transmission !== undefined) material.transmission = json.transmission;
                if (json.thickness !== undefined) material.thickness = json.thickness;
                if (json.attenuationDistance !== undefined) material.attenuationDistance = json.attenuationDistance;
                if (json.attenuationColor !== undefined && material.attenuationColor !== undefined) material.attenuationColor.setHex(json.attenuationColor);
                if (json.fog !== undefined) material.fog = json.fog;
                if (json.flatShading !== undefined) material.flatShading = json.flatShading;
                if (json.blending !== undefined) material.blending = json.blending;
                if (json.combine !== undefined) material.combine = json.combine;
                if (json.side !== undefined) material.side = json.side;
                if (json.shadowSide !== undefined) material.shadowSide = json.shadowSide;
                if (json.opacity !== undefined) material.opacity = json.opacity;
                if (json.transparent !== undefined) material.transparent = json.transparent;
                if (json.alphaTest !== undefined) material.alphaTest = json.alphaTest;
                if (json.depthTest !== undefined) material.depthTest = json.depthTest;
                if (json.depthWrite !== undefined) material.depthWrite = json.depthWrite;
                if (json.colorWrite !== undefined) material.colorWrite = json.colorWrite;
                if (json.stencilWrite !== undefined) material.stencilWrite = json.stencilWrite;
                if (json.stencilWriteMask !== undefined) material.stencilWriteMask = json.stencilWriteMask;
                if (json.stencilFunc !== undefined) material.stencilFunc = json.stencilFunc;
                if (json.stencilRef !== undefined) material.stencilRef = json.stencilRef;
                if (json.stencilFuncMask !== undefined) material.stencilFuncMask = json.stencilFuncMask;
                if (json.stencilFail !== undefined) material.stencilFail = json.stencilFail;
                if (json.stencilZFail !== undefined) material.stencilZFail = json.stencilZFail;
                if (json.stencilZPass !== undefined) material.stencilZPass = json.stencilZPass;
                if (json.wireframe !== undefined) material.wireframe = json.wireframe;
                if (json.wireframeLinewidth !== undefined) material.wireframeLinewidth = json.wireframeLinewidth;
                if (json.wireframeLinecap !== undefined) material.wireframeLinecap = json.wireframeLinecap;
                if (json.wireframeLinejoin !== undefined) material.wireframeLinejoin = json.wireframeLinejoin;
                if (json.rotation !== undefined) material.rotation = json.rotation;
                if (json.linewidth !== 1) material.linewidth = json.linewidth;
                if (json.dashSize !== undefined) material.dashSize = json.dashSize;
                if (json.gapSize !== undefined) material.gapSize = json.gapSize;
                if (json.scale !== undefined) material.scale = json.scale;
                if (json.polygonOffset !== undefined) material.polygonOffset = json.polygonOffset;
                if (json.polygonOffsetFactor !== undefined) material.polygonOffsetFactor = json.polygonOffsetFactor;
                if (json.polygonOffsetUnits !== undefined) material.polygonOffsetUnits = json.polygonOffsetUnits;
                if (json.morphTargets !== undefined) material.morphTargets = json.morphTargets;
                if (json.morphNormals !== undefined) material.morphNormals = json.morphNormals;
                if (json.dithering !== undefined) material.dithering = json.dithering;
                if (json.alphaToCoverage !== undefined) material.alphaToCoverage = json.alphaToCoverage;
                if (json.premultipliedAlpha !== undefined) material.premultipliedAlpha = json.premultipliedAlpha;
                if (json.vertexTangents !== undefined) material.vertexTangents = json.vertexTangents;
                if (json.visible !== undefined) material.visible = json.visible;
                if (json.toneMapped !== undefined) material.toneMapped = json.toneMapped;
                if (json.userData !== undefined) material.userData = json.userData;
                if (json.vertexColors !== undefined) {
                    if (typeof json.vertexColors === 'number') material.vertexColors = json.vertexColors > 0 ? true : false;
                    else material.vertexColors = json.vertexColors;
                }
                // Shader Material
                if (json.uniforms !== undefined) for(var name in json.uniforms){
                    var uniform = json.uniforms[name];
                    material.uniforms[name] = {};
                    switch(uniform.type){
                        case 't':
                            material.uniforms[name].value = getTexture(uniform.value);
                            break;
                        case 'c':
                            material.uniforms[name].value = new $c702e238df7c5123$export$892596cec99bc70e().setHex(uniform.value);
                            break;
                        case 'v2':
                            material.uniforms[name].value = new $c702e238df7c5123$export$c977b3e384af9ae1().fromArray(uniform.value);
                            break;
                        case 'v3':
                            material.uniforms[name].value = new $c702e238df7c5123$export$64b5c384219d3699().fromArray(uniform.value);
                            break;
                        case 'v4':
                            material.uniforms[name].value = new $c702e238df7c5123$export$fa7daccca11cdbe3().fromArray(uniform.value);
                            break;
                        case 'm3':
                            material.uniforms[name].value = new $c702e238df7c5123$export$8ff26dafa08918().fromArray(uniform.value);
                            break;
                        case 'm4':
                            material.uniforms[name].value = new $c702e238df7c5123$export$2ae72fc923e5eb5().fromArray(uniform.value);
                            break;
                        default:
                            material.uniforms[name].value = uniform.value;
                    }
                }
                if (json.defines !== undefined) material.defines = json.defines;
                if (json.vertexShader !== undefined) material.vertexShader = json.vertexShader;
                if (json.fragmentShader !== undefined) material.fragmentShader = json.fragmentShader;
                if (json.extensions !== undefined) for(var key in json.extensions)material.extensions[key] = json.extensions[key];
                // Deprecated
                if (json.shading !== undefined) material.flatShading = json.shading === 1; // THREE.FlatShading
                // for PointsMaterial
                if (json.size !== undefined) material.size = json.size;
                if (json.sizeAttenuation !== undefined) material.sizeAttenuation = json.sizeAttenuation;
                // maps
                if (json.map !== undefined) material.map = getTexture(json.map);
                if (json.matcap !== undefined) material.matcap = getTexture(json.matcap);
                if (json.alphaMap !== undefined) material.alphaMap = getTexture(json.alphaMap);
                if (json.bumpMap !== undefined) material.bumpMap = getTexture(json.bumpMap);
                if (json.bumpScale !== undefined) material.bumpScale = json.bumpScale;
                if (json.normalMap !== undefined) material.normalMap = getTexture(json.normalMap);
                if (json.normalMapType !== undefined) material.normalMapType = json.normalMapType;
                if (json.normalScale !== undefined) {
                    var normalScale = json.normalScale;
                    if (Array.isArray(normalScale) === false) // Blender exporter used to export a scalar. See #7459
                    normalScale = [
                        normalScale,
                        normalScale
                    ];
                    material.normalScale = new $c702e238df7c5123$export$c977b3e384af9ae1().fromArray(normalScale);
                }
                if (json.displacementMap !== undefined) material.displacementMap = getTexture(json.displacementMap);
                if (json.displacementScale !== undefined) material.displacementScale = json.displacementScale;
                if (json.displacementBias !== undefined) material.displacementBias = json.displacementBias;
                if (json.roughnessMap !== undefined) material.roughnessMap = getTexture(json.roughnessMap);
                if (json.metalnessMap !== undefined) material.metalnessMap = getTexture(json.metalnessMap);
                if (json.emissiveMap !== undefined) material.emissiveMap = getTexture(json.emissiveMap);
                if (json.emissiveIntensity !== undefined) material.emissiveIntensity = json.emissiveIntensity;
                if (json.specularMap !== undefined) material.specularMap = getTexture(json.specularMap);
                if (json.envMap !== undefined) material.envMap = getTexture(json.envMap);
                if (json.envMapIntensity !== undefined) material.envMapIntensity = json.envMapIntensity;
                if (json.reflectivity !== undefined) material.reflectivity = json.reflectivity;
                if (json.refractionRatio !== undefined) material.refractionRatio = json.refractionRatio;
                if (json.lightMap !== undefined) material.lightMap = getTexture(json.lightMap);
                if (json.lightMapIntensity !== undefined) material.lightMapIntensity = json.lightMapIntensity;
                if (json.aoMap !== undefined) material.aoMap = getTexture(json.aoMap);
                if (json.aoMapIntensity !== undefined) material.aoMapIntensity = json.aoMapIntensity;
                if (json.gradientMap !== undefined) material.gradientMap = getTexture(json.gradientMap);
                if (json.clearcoatMap !== undefined) material.clearcoatMap = getTexture(json.clearcoatMap);
                if (json.clearcoatRoughnessMap !== undefined) material.clearcoatRoughnessMap = getTexture(json.clearcoatRoughnessMap);
                if (json.clearcoatNormalMap !== undefined) material.clearcoatNormalMap = getTexture(json.clearcoatNormalMap);
                if (json.clearcoatNormalScale !== undefined) material.clearcoatNormalScale = new $c702e238df7c5123$export$c977b3e384af9ae1().fromArray(json.clearcoatNormalScale);
                if (json.transmissionMap !== undefined) material.transmissionMap = getTexture(json.transmissionMap);
                if (json.thicknessMap !== undefined) material.thicknessMap = getTexture(json.thicknessMap);
                return material;
            }
        },
        {
            key: "setTextures",
            value: function setTextures(value) {
                this.textures = value;
                return this;
            }
        }
    ]);
    return MaterialLoader;
}($c702e238df7c5123$export$3b0d6d7590275603);
var $c702e238df7c5123$export$b5d2dc08d867e41a = /*#__PURE__*/ function() {
    "use strict";
    function LoaderUtils() {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, LoaderUtils);
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(LoaderUtils, null, [
        {
            key: "decodeText",
            value: function decodeText(array) {
                if (typeof TextDecoder !== 'undefined') return new TextDecoder().decode(array);
                // Avoid the String.fromCharCode.apply(null, array) shortcut, which
                // throws a "maximum call stack size exceeded" error for large arrays.
                var s = '';
                for(var i = 0, il = array.length; i < il; i++)// Implicitly assumes little-endian.
                s += String.fromCharCode(array[i]);
                try {
                    // merges multi-byte utf-8 characters.
                    return decodeURIComponent(escape(s));
                } catch (e) {
                    return s;
                }
            }
        },
        {
            key: "extractUrlBase",
            value: function extractUrlBase(url) {
                var index = url.lastIndexOf('/');
                if (index === -1) return './';
                return url.substr(0, index + 1);
            }
        }
    ]);
    return LoaderUtils;
}();
var $c702e238df7c5123$export$231f009cbe414146 = /*#__PURE__*/ function(BufferGeometry) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(InstancedBufferGeometry, BufferGeometry);
    function InstancedBufferGeometry() {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, InstancedBufferGeometry);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, InstancedBufferGeometry);
        _this.type = 'InstancedBufferGeometry';
        _this.instanceCount = Infinity;
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(InstancedBufferGeometry, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(InstancedBufferGeometry.prototype), "copy", this).call(this, source);
                this.instanceCount = source.instanceCount;
                return this;
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(InstancedBufferGeometry.prototype), "toJSON", this).call(this, this);
                data.instanceCount = this.instanceCount;
                data.isInstancedBufferGeometry = true;
                return data;
            }
        }
    ]);
    return InstancedBufferGeometry;
}($c702e238df7c5123$export$b7be63a67df8959);
$c702e238df7c5123$export$231f009cbe414146.prototype.isInstancedBufferGeometry = true;
var $c702e238df7c5123$export$32ea87a8b54d744a = /*#__PURE__*/ function(BufferAttribute) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(InstancedBufferAttribute, BufferAttribute);
    function InstancedBufferAttribute(array, itemSize, normalized) {
        var meshPerAttribute = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, InstancedBufferAttribute);
        var _this;
        if (typeof normalized === 'number') {
            meshPerAttribute = normalized;
            normalized = false;
            console.error('THREE.InstancedBufferAttribute: The constructor now expects normalized as the third argument.');
        }
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, InstancedBufferAttribute, [
            array,
            itemSize,
            normalized
        ]);
        _this.meshPerAttribute = meshPerAttribute;
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(InstancedBufferAttribute, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(InstancedBufferAttribute.prototype), "copy", this).call(this, source);
                this.meshPerAttribute = source.meshPerAttribute;
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(InstancedBufferAttribute.prototype), "toJSON", this).call(this);
                data.meshPerAttribute = this.meshPerAttribute;
                data.isInstancedBufferAttribute = true;
                return data;
            }
        }
    ]);
    return InstancedBufferAttribute;
}($c702e238df7c5123$export$8dea267bd6bde117);
$c702e238df7c5123$export$32ea87a8b54d744a.prototype.isInstancedBufferAttribute = true;
var $c702e238df7c5123$export$dc275bb96327833a = /*#__PURE__*/ function(Loader) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(BufferGeometryLoader, Loader);
    function BufferGeometryLoader(manager) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, BufferGeometryLoader);
        return (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, BufferGeometryLoader, [
            manager
        ]);
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(BufferGeometryLoader, [
        {
            key: "load",
            value: function load(url, onLoad, onProgress, onError) {
                var scope = this;
                var loader = new $c702e238df7c5123$export$98435a25b5cf7b2b(scope.manager);
                loader.setPath(scope.path);
                loader.setRequestHeader(scope.requestHeader);
                loader.setWithCredentials(scope.withCredentials);
                loader.load(url, function(text) {
                    try {
                        onLoad(scope.parse(JSON.parse(text)));
                    } catch (e) {
                        if (onError) onError(e);
                        else console.error(e);
                        scope.manager.itemError(url);
                    }
                }, onProgress, onError);
            }
        },
        {
            key: "parse",
            value: function parse(json) {
                var interleavedBufferMap = {};
                var arrayBufferMap = {};
                function getInterleavedBuffer(json, uuid) {
                    if (interleavedBufferMap[uuid] !== undefined) return interleavedBufferMap[uuid];
                    var interleavedBuffers = json.interleavedBuffers;
                    var interleavedBuffer = interleavedBuffers[uuid];
                    var buffer = getArrayBuffer(json, interleavedBuffer.buffer);
                    var array = $c702e238df7c5123$var$getTypedArray(interleavedBuffer.type, buffer);
                    var ib = new $c702e238df7c5123$export$3d5cd879f108f53f(array, interleavedBuffer.stride);
                    ib.uuid = interleavedBuffer.uuid;
                    interleavedBufferMap[uuid] = ib;
                    return ib;
                }
                function getArrayBuffer(json, uuid) {
                    if (arrayBufferMap[uuid] !== undefined) return arrayBufferMap[uuid];
                    var arrayBuffers = json.arrayBuffers;
                    var arrayBuffer = arrayBuffers[uuid];
                    var ab = new Uint32Array(arrayBuffer).buffer;
                    arrayBufferMap[uuid] = ab;
                    return ab;
                }
                var geometry = json.isInstancedBufferGeometry ? new $c702e238df7c5123$export$231f009cbe414146() : new $c702e238df7c5123$export$b7be63a67df8959();
                var index = json.data.index;
                if (index !== undefined) {
                    var typedArray = $c702e238df7c5123$var$getTypedArray(index.type, index.array);
                    geometry.setIndex(new $c702e238df7c5123$export$8dea267bd6bde117(typedArray, 1));
                }
                var attributes = json.data.attributes;
                for(var key in attributes){
                    var attribute = attributes[key];
                    var bufferAttribute = void 0;
                    if (attribute.isInterleavedBufferAttribute) {
                        var interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                        bufferAttribute = new $c702e238df7c5123$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
                    } else {
                        var typedArray1 = $c702e238df7c5123$var$getTypedArray(attribute.type, attribute.array);
                        var bufferAttributeConstr = attribute.isInstancedBufferAttribute ? $c702e238df7c5123$export$32ea87a8b54d744a : $c702e238df7c5123$export$8dea267bd6bde117;
                        bufferAttribute = new bufferAttributeConstr(typedArray1, attribute.itemSize, attribute.normalized);
                    }
                    if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
                    if (attribute.usage !== undefined) bufferAttribute.setUsage(attribute.usage);
                    if (attribute.updateRange !== undefined) {
                        bufferAttribute.updateRange.offset = attribute.updateRange.offset;
                        bufferAttribute.updateRange.count = attribute.updateRange.count;
                    }
                    geometry.setAttribute(key, bufferAttribute);
                }
                var morphAttributes = json.data.morphAttributes;
                if (morphAttributes) for(var key1 in morphAttributes){
                    var attributeArray = morphAttributes[key1];
                    var array = [];
                    for(var i = 0, il = attributeArray.length; i < il; i++){
                        var attribute1 = attributeArray[i];
                        var bufferAttribute1 = void 0;
                        if (attribute1.isInterleavedBufferAttribute) {
                            var interleavedBuffer1 = getInterleavedBuffer(json.data, attribute1.data);
                            bufferAttribute1 = new $c702e238df7c5123$export$920b6d07334599c7(interleavedBuffer1, attribute1.itemSize, attribute1.offset, attribute1.normalized);
                        } else {
                            var typedArray2 = $c702e238df7c5123$var$getTypedArray(attribute1.type, attribute1.array);
                            bufferAttribute1 = new $c702e238df7c5123$export$8dea267bd6bde117(typedArray2, attribute1.itemSize, attribute1.normalized);
                        }
                        if (attribute1.name !== undefined) bufferAttribute1.name = attribute1.name;
                        array.push(bufferAttribute1);
                    }
                    geometry.morphAttributes[key1] = array;
                }
                var morphTargetsRelative = json.data.morphTargetsRelative;
                if (morphTargetsRelative) geometry.morphTargetsRelative = true;
                var groups = json.data.groups || json.data.drawcalls || json.data.offsets;
                if (groups !== undefined) for(var i1 = 0, n = groups.length; i1 !== n; ++i1){
                    var group = groups[i1];
                    geometry.addGroup(group.start, group.count, group.materialIndex);
                }
                var boundingSphere = json.data.boundingSphere;
                if (boundingSphere !== undefined) {
                    var center = new $c702e238df7c5123$export$64b5c384219d3699();
                    if (boundingSphere.center !== undefined) center.fromArray(boundingSphere.center);
                    geometry.boundingSphere = new $c702e238df7c5123$export$805e8b72413ccaba(center, boundingSphere.radius);
                }
                if (json.name) geometry.name = json.name;
                if (json.userData) geometry.userData = json.userData;
                return geometry;
            }
        }
    ]);
    return BufferGeometryLoader;
}($c702e238df7c5123$export$3b0d6d7590275603);
var $c702e238df7c5123$export$40110c8505c5ad19 = /*#__PURE__*/ function(Loader) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(ObjectLoader, Loader);
    function ObjectLoader(manager) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, ObjectLoader);
        return (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, ObjectLoader, [
            manager
        ]);
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(ObjectLoader, [
        {
            key: "load",
            value: function load(url, onLoad, onProgress, onError) {
                var scope = this;
                var path = this.path === '' ? $c702e238df7c5123$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
                this.resourcePath = this.resourcePath || path;
                var loader = new $c702e238df7c5123$export$98435a25b5cf7b2b(this.manager);
                loader.setPath(this.path);
                loader.setRequestHeader(this.requestHeader);
                loader.setWithCredentials(this.withCredentials);
                loader.load(url, function(text) {
                    var json = null;
                    try {
                        json = JSON.parse(text);
                    } catch (error) {
                        if (onError !== undefined) onError(error);
                        console.error('THREE:ObjectLoader: Can\'t parse ' + url + '.', error.message);
                        return;
                    }
                    var metadata = json.metadata;
                    if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry') {
                        console.error('THREE.ObjectLoader: Can\'t load ' + url);
                        return;
                    }
                    scope.parse(json, onLoad);
                }, onProgress, onError);
            }
        },
        {
            key: "loadAsync",
            value: function loadAsync(url, onProgress) {
                var _this = this;
                return (0, $ba14d604d8d555ce$export$71511d61b312f219)(function() {
                    var scope, path, loader, text, json, metadata;
                    return (0, $b602c7a134484286$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                scope = _this;
                                path = _this.path === '' ? $c702e238df7c5123$export$b5d2dc08d867e41a.extractUrlBase(url) : _this.path;
                                _this.resourcePath = _this.resourcePath || path;
                                loader = new $c702e238df7c5123$export$98435a25b5cf7b2b(_this.manager);
                                loader.setPath(_this.path);
                                loader.setRequestHeader(_this.requestHeader);
                                loader.setWithCredentials(_this.withCredentials);
                                return [
                                    4,
                                    loader.loadAsync(url, onProgress)
                                ];
                            case 1:
                                text = _state.sent();
                                json = JSON.parse(text);
                                metadata = json.metadata;
                                if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry') throw new Error('THREE.ObjectLoader: Can\'t load ' + url);
                                return [
                                    4,
                                    scope.parseAsync(json)
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "parse",
            value: function parse(json, onLoad) {
                var animations = this.parseAnimations(json.animations);
                var shapes = this.parseShapes(json.shapes);
                var geometries = this.parseGeometries(json.geometries, shapes);
                var images = this.parseImages(json.images, function() {
                    if (onLoad !== undefined) onLoad(object);
                });
                var textures = this.parseTextures(json.textures, images);
                var materials = this.parseMaterials(json.materials, textures);
                var object = this.parseObject(json.object, geometries, materials, textures, animations);
                var skeletons = this.parseSkeletons(json.skeletons, object);
                this.bindSkeletons(object, skeletons);
                //
                if (onLoad !== undefined) {
                    var hasImages = false;
                    for(var uuid in images)if (images[uuid] instanceof HTMLImageElement) {
                        hasImages = true;
                        break;
                    }
                    if (hasImages === false) onLoad(object);
                }
                return object;
            }
        },
        {
            key: "parseAsync",
            value: function parseAsync(json) {
                var _this = this;
                return (0, $ba14d604d8d555ce$export$71511d61b312f219)(function() {
                    var animations, shapes, geometries, images, textures, materials, object, skeletons;
                    return (0, $b602c7a134484286$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                animations = _this.parseAnimations(json.animations);
                                shapes = _this.parseShapes(json.shapes);
                                geometries = _this.parseGeometries(json.geometries, shapes);
                                return [
                                    4,
                                    _this.parseImagesAsync(json.images)
                                ];
                            case 1:
                                images = _state.sent();
                                textures = _this.parseTextures(json.textures, images);
                                materials = _this.parseMaterials(json.materials, textures);
                                object = _this.parseObject(json.object, geometries, materials, textures, animations);
                                skeletons = _this.parseSkeletons(json.skeletons, object);
                                _this.bindSkeletons(object, skeletons);
                                return [
                                    2,
                                    object
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "parseShapes",
            value: function parseShapes(json) {
                var shapes = {};
                if (json !== undefined) for(var i = 0, l = json.length; i < l; i++){
                    var shape = new $c702e238df7c5123$export$6428a7f2611ef1fa().fromJSON(json[i]);
                    shapes[shape.uuid] = shape;
                }
                return shapes;
            }
        },
        {
            key: "parseSkeletons",
            value: function parseSkeletons(json, object) {
                var skeletons = {};
                var bones = {};
                // generate bone lookup table
                object.traverse(function(child) {
                    if (child.isBone) bones[child.uuid] = child;
                });
                // create skeletons
                if (json !== undefined) for(var i = 0, l = json.length; i < l; i++){
                    var skeleton = new $c702e238df7c5123$export$8f31e4c4a37b8e9c().fromJSON(json[i], bones);
                    skeletons[skeleton.uuid] = skeleton;
                }
                return skeletons;
            }
        },
        {
            key: "parseGeometries",
            value: function parseGeometries(json, shapes) {
                var geometries = {};
                if (json !== undefined) {
                    var bufferGeometryLoader = new $c702e238df7c5123$export$dc275bb96327833a();
                    for(var i = 0, l = json.length; i < l; i++){
                        var geometry = void 0;
                        var data = json[i];
                        switch(data.type){
                            case 'BufferGeometry':
                            case 'InstancedBufferGeometry':
                                geometry = bufferGeometryLoader.parse(data);
                                break;
                            case 'Geometry':
                                console.error('THREE.ObjectLoader: The legacy Geometry type is no longer supported.');
                                break;
                            default:
                                if (data.type in $c702e238df7c5123$var$Geometries) geometry = $c702e238df7c5123$var$Geometries[data.type].fromJSON(data, shapes);
                                else console.warn('THREE.ObjectLoader: Unsupported geometry type "'.concat(data.type, '"'));
                        }
                        geometry.uuid = data.uuid;
                        if (data.name !== undefined) geometry.name = data.name;
                        if (geometry.isBufferGeometry === true && data.userData !== undefined) geometry.userData = data.userData;
                        geometries[data.uuid] = geometry;
                    }
                }
                return geometries;
            }
        },
        {
            key: "parseMaterials",
            value: function parseMaterials(json, textures) {
                var cache = {}; // MultiMaterial
                var materials = {};
                if (json !== undefined) {
                    var loader = new $c702e238df7c5123$export$3bd6d323353dcf96();
                    loader.setTextures(textures);
                    for(var i = 0, l = json.length; i < l; i++){
                        var data = json[i];
                        if (data.type === 'MultiMaterial') {
                            // Deprecated
                            var array = [];
                            for(var j = 0; j < data.materials.length; j++){
                                var material = data.materials[j];
                                if (cache[material.uuid] === undefined) cache[material.uuid] = loader.parse(material);
                                array.push(cache[material.uuid]);
                            }
                            materials[data.uuid] = array;
                        } else {
                            if (cache[data.uuid] === undefined) cache[data.uuid] = loader.parse(data);
                            materials[data.uuid] = cache[data.uuid];
                        }
                    }
                }
                return materials;
            }
        },
        {
            key: "parseAnimations",
            value: function parseAnimations(json) {
                var animations = {};
                if (json !== undefined) for(var i = 0; i < json.length; i++){
                    var data = json[i];
                    var clip = $c702e238df7c5123$export$d942c706bf23829c.parse(data);
                    animations[clip.uuid] = clip;
                }
                return animations;
            }
        },
        {
            key: "parseImages",
            value: function parseImages(json, onLoad) {
                var scope = this;
                var images = {};
                var loader;
                function loadImage(url) {
                    scope.manager.itemStart(url);
                    return loader.load(url, function() {
                        scope.manager.itemEnd(url);
                    }, undefined, function() {
                        scope.manager.itemError(url);
                        scope.manager.itemEnd(url);
                    });
                }
                function deserializeImage(image) {
                    if (typeof image === 'string') {
                        var url = image;
                        var path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                        return loadImage(path);
                    } else {
                        if (image.data) return {
                            data: $c702e238df7c5123$var$getTypedArray(image.type, image.data),
                            width: image.width,
                            height: image.height
                        };
                        else return null;
                    }
                }
                if (json !== undefined && json.length > 0) {
                    var manager = new $c702e238df7c5123$export$99cc795e99919eed(onLoad);
                    loader = new $c702e238df7c5123$export$8905ce1c7a2464a1(manager);
                    loader.setCrossOrigin(this.crossOrigin);
                    for(var i = 0, il = json.length; i < il; i++){
                        var image = json[i];
                        var url = image.url;
                        if (Array.isArray(url)) {
                            // load array of images e.g CubeTexture
                            images[image.uuid] = [];
                            for(var j = 0, jl = url.length; j < jl; j++){
                                var currentUrl = url[j];
                                var deserializedImage = deserializeImage(currentUrl);
                                if (deserializedImage !== null) {
                                    if (deserializedImage instanceof HTMLImageElement) images[image.uuid].push(deserializedImage);
                                    else // special case: handle array of data textures for cube textures
                                    images[image.uuid].push(new $c702e238df7c5123$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                                }
                            }
                        } else {
                            // load single image
                            var deserializedImage1 = deserializeImage(image.url);
                            if (deserializedImage1 !== null) images[image.uuid] = deserializedImage1;
                        }
                    }
                }
                return images;
            }
        },
        {
            key: "parseImagesAsync",
            value: function parseImagesAsync(json) {
                var _this = this;
                return (0, $ba14d604d8d555ce$export$71511d61b312f219)(function() {
                    var scope, images, loader, i, il, image, url, j, jl, currentUrl, deserializedImage, deserializedImage1;
                    function deserializeImage(image) {
                        return _deserializeImage.apply(this, arguments);
                    }
                    function _deserializeImage() {
                        _deserializeImage = (0, $ba14d604d8d555ce$export$71511d61b312f219)(function(image) {
                            var url, path;
                            return (0, $b602c7a134484286$export$67ebef60e6f28a6)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if (!(typeof image === 'string')) return [
                                            3,
                                            2
                                        ];
                                        url = image;
                                        path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                                        return [
                                            4,
                                            loader.loadAsync(path)
                                        ];
                                    case 1:
                                        return [
                                            2,
                                            _state.sent()
                                        ];
                                    case 2:
                                        if (image.data) return [
                                            2,
                                            {
                                                data: $c702e238df7c5123$var$getTypedArray(image.type, image.data),
                                                width: image.width,
                                                height: image.height
                                            }
                                        ];
                                        else return [
                                            2,
                                            null
                                        ];
                                        _state.label = 3;
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return _deserializeImage.apply(this, arguments);
                    }
                    return (0, $b602c7a134484286$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                scope = _this;
                                images = {};
                                if (!(json !== undefined && json.length > 0)) return [
                                    3,
                                    9
                                ];
                                loader = new $c702e238df7c5123$export$8905ce1c7a2464a1(_this.manager);
                                loader.setCrossOrigin(_this.crossOrigin);
                                i = 0, il = json.length;
                                _state.label = 1;
                            case 1:
                                if (!(i < il)) return [
                                    3,
                                    9
                                ];
                                image = json[i];
                                url = image.url;
                                if (!Array.isArray(url)) return [
                                    3,
                                    6
                                ];
                                // load array of images e.g CubeTexture
                                images[image.uuid] = [];
                                j = 0, jl = url.length;
                                _state.label = 2;
                            case 2:
                                if (!(j < jl)) return [
                                    3,
                                    5
                                ];
                                currentUrl = url[j];
                                return [
                                    4,
                                    deserializeImage(currentUrl)
                                ];
                            case 3:
                                deserializedImage = _state.sent();
                                if (deserializedImage !== null) {
                                    if (deserializedImage instanceof HTMLImageElement) images[image.uuid].push(deserializedImage);
                                    else // special case: handle array of data textures for cube textures
                                    images[image.uuid].push(new $c702e238df7c5123$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                                }
                                _state.label = 4;
                            case 4:
                                j++;
                                return [
                                    3,
                                    2
                                ];
                            case 5:
                                return [
                                    3,
                                    8
                                ];
                            case 6:
                                return [
                                    4,
                                    deserializeImage(image.url)
                                ];
                            case 7:
                                deserializedImage1 = _state.sent();
                                if (deserializedImage1 !== null) images[image.uuid] = deserializedImage1;
                                _state.label = 8;
                            case 8:
                                i++;
                                return [
                                    3,
                                    1
                                ];
                            case 9:
                                return [
                                    2,
                                    images
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "parseTextures",
            value: function parseTextures(json, images) {
                function parseConstant(value, type) {
                    if (typeof value === 'number') return value;
                    console.warn('THREE.ObjectLoader.parseTexture: Constant should be in numeric form.', value);
                    return type[value];
                }
                var textures = {};
                if (json !== undefined) for(var i = 0, l = json.length; i < l; i++){
                    var data = json[i];
                    if (data.image === undefined) console.warn('THREE.ObjectLoader: No "image" specified for', data.uuid);
                    if (images[data.image] === undefined) console.warn('THREE.ObjectLoader: Undefined image', data.image);
                    var texture = void 0;
                    var image = images[data.image];
                    if (Array.isArray(image)) {
                        texture = new $c702e238df7c5123$export$ee2e5a18258a4049(image);
                        if (image.length === 6) texture.needsUpdate = true;
                    } else {
                        if (image && image.data) texture = new $c702e238df7c5123$export$b691f601014eabe1(image.data, image.width, image.height);
                        else texture = new $c702e238df7c5123$export$5431306cf43de24a(image);
                        if (image) texture.needsUpdate = true; // textures can have undefined image data
                    }
                    texture.uuid = data.uuid;
                    if (data.name !== undefined) texture.name = data.name;
                    if (data.mapping !== undefined) texture.mapping = parseConstant(data.mapping, $c702e238df7c5123$var$TEXTURE_MAPPING);
                    if (data.offset !== undefined) texture.offset.fromArray(data.offset);
                    if (data.repeat !== undefined) texture.repeat.fromArray(data.repeat);
                    if (data.center !== undefined) texture.center.fromArray(data.center);
                    if (data.rotation !== undefined) texture.rotation = data.rotation;
                    if (data.wrap !== undefined) {
                        texture.wrapS = parseConstant(data.wrap[0], $c702e238df7c5123$var$TEXTURE_WRAPPING);
                        texture.wrapT = parseConstant(data.wrap[1], $c702e238df7c5123$var$TEXTURE_WRAPPING);
                    }
                    if (data.format !== undefined) texture.format = data.format;
                    if (data.type !== undefined) texture.type = data.type;
                    if (data.encoding !== undefined) texture.encoding = data.encoding;
                    if (data.minFilter !== undefined) texture.minFilter = parseConstant(data.minFilter, $c702e238df7c5123$var$TEXTURE_FILTER);
                    if (data.magFilter !== undefined) texture.magFilter = parseConstant(data.magFilter, $c702e238df7c5123$var$TEXTURE_FILTER);
                    if (data.anisotropy !== undefined) texture.anisotropy = data.anisotropy;
                    if (data.flipY !== undefined) texture.flipY = data.flipY;
                    if (data.premultiplyAlpha !== undefined) texture.premultiplyAlpha = data.premultiplyAlpha;
                    if (data.unpackAlignment !== undefined) texture.unpackAlignment = data.unpackAlignment;
                    textures[data.uuid] = texture;
                }
                return textures;
            }
        },
        {
            key: "parseObject",
            value: function parseObject(data, geometries, materials, textures, animations) {
                var object;
                function getGeometry(name) {
                    if (geometries[name] === undefined) console.warn('THREE.ObjectLoader: Undefined geometry', name);
                    return geometries[name];
                }
                function getMaterial(name) {
                    if (name === undefined) return undefined;
                    if (Array.isArray(name)) {
                        var array = [];
                        for(var i = 0, l = name.length; i < l; i++){
                            var uuid = name[i];
                            if (materials[uuid] === undefined) console.warn('THREE.ObjectLoader: Undefined material', uuid);
                            array.push(materials[uuid]);
                        }
                        return array;
                    }
                    if (materials[name] === undefined) console.warn('THREE.ObjectLoader: Undefined material', name);
                    return materials[name];
                }
                function getTexture(uuid) {
                    if (textures[uuid] === undefined) console.warn('THREE.ObjectLoader: Undefined texture', uuid);
                    return textures[uuid];
                }
                var geometry, material;
                switch(data.type){
                    case 'Scene':
                        object = new $c702e238df7c5123$export$38af1803e3442a7f();
                        if (data.background !== undefined) {
                            if (Number.isInteger(data.background)) object.background = new $c702e238df7c5123$export$892596cec99bc70e(data.background);
                            else object.background = getTexture(data.background);
                        }
                        if (data.environment !== undefined) object.environment = getTexture(data.environment);
                        if (data.fog !== undefined) {
                            if (data.fog.type === 'Fog') object.fog = new $c702e238df7c5123$export$3c890837b09508d4(data.fog.color, data.fog.near, data.fog.far);
                            else if (data.fog.type === 'FogExp2') object.fog = new $c702e238df7c5123$export$6f1519f023b8d0f6(data.fog.color, data.fog.density);
                        }
                        break;
                    case 'PerspectiveCamera':
                        object = new $c702e238df7c5123$export$74e4ae24825f68d7(data.fov, data.aspect, data.near, data.far);
                        if (data.focus !== undefined) object.focus = data.focus;
                        if (data.zoom !== undefined) object.zoom = data.zoom;
                        if (data.filmGauge !== undefined) object.filmGauge = data.filmGauge;
                        if (data.filmOffset !== undefined) object.filmOffset = data.filmOffset;
                        if (data.view !== undefined) object.view = Object.assign({}, data.view);
                        break;
                    case 'OrthographicCamera':
                        object = new $c702e238df7c5123$export$9ebf355ee4ed261b(data.left, data.right, data.top, data.bottom, data.near, data.far);
                        if (data.zoom !== undefined) object.zoom = data.zoom;
                        if (data.view !== undefined) object.view = Object.assign({}, data.view);
                        break;
                    case 'AmbientLight':
                        object = new $c702e238df7c5123$export$af279bfef9ec2c96(data.color, data.intensity);
                        break;
                    case 'DirectionalLight':
                        object = new $c702e238df7c5123$export$3fea33cc9972c868(data.color, data.intensity);
                        break;
                    case 'PointLight':
                        object = new $c702e238df7c5123$export$4c9c1cb3f0b6f455(data.color, data.intensity, data.distance, data.decay);
                        break;
                    case 'RectAreaLight':
                        object = new $c702e238df7c5123$export$61db2d908bbd2429(data.color, data.intensity, data.width, data.height);
                        break;
                    case 'SpotLight':
                        object = new $c702e238df7c5123$export$81495cbb73897362(data.color, data.intensity, data.distance, data.angle, data.penumbra, data.decay);
                        break;
                    case 'HemisphereLight':
                        object = new $c702e238df7c5123$export$8d474f55edbb9624(data.color, data.groundColor, data.intensity);
                        break;
                    case 'LightProbe':
                        object = new $c702e238df7c5123$export$e7ef036e309b38d2().fromJSON(data);
                        break;
                    case 'SkinnedMesh':
                        geometry = getGeometry(data.geometry);
                        material = getMaterial(data.material);
                        object = new $c702e238df7c5123$export$b303577035157ecf(geometry, material);
                        if (data.bindMode !== undefined) object.bindMode = data.bindMode;
                        if (data.bindMatrix !== undefined) object.bindMatrix.fromArray(data.bindMatrix);
                        if (data.skeleton !== undefined) object.skeleton = data.skeleton;
                        break;
                    case 'Mesh':
                        geometry = getGeometry(data.geometry);
                        material = getMaterial(data.material);
                        object = new $c702e238df7c5123$export$e176487c05830cc5(geometry, material);
                        break;
                    case 'InstancedMesh':
                        geometry = getGeometry(data.geometry);
                        material = getMaterial(data.material);
                        var count = data.count;
                        var instanceMatrix = data.instanceMatrix;
                        var instanceColor = data.instanceColor;
                        object = new $c702e238df7c5123$export$f3c979c331175ad7(geometry, material, count);
                        object.instanceMatrix = new $c702e238df7c5123$export$8dea267bd6bde117(new Float32Array(instanceMatrix.array), 16);
                        if (instanceColor !== undefined) object.instanceColor = new $c702e238df7c5123$export$8dea267bd6bde117(new Float32Array(instanceColor.array), instanceColor.itemSize);
                        break;
                    case 'LOD':
                        object = new $c702e238df7c5123$export$112e7237be0c5f30();
                        break;
                    case 'Line':
                        object = new $c702e238df7c5123$export$17d680238e50603e(getGeometry(data.geometry), getMaterial(data.material));
                        break;
                    case 'LineLoop':
                        object = new $c702e238df7c5123$export$f85a24d745e4f17d(getGeometry(data.geometry), getMaterial(data.material));
                        break;
                    case 'LineSegments':
                        object = new $c702e238df7c5123$export$ff1ed10fedfdd604(getGeometry(data.geometry), getMaterial(data.material));
                        break;
                    case 'PointCloud':
                    case 'Points':
                        object = new $c702e238df7c5123$export$1c787534cb11aa3e(getGeometry(data.geometry), getMaterial(data.material));
                        break;
                    case 'Sprite':
                        object = new $c702e238df7c5123$export$3075603db8e6204c(getMaterial(data.material));
                        break;
                    case 'Group':
                        object = new $c702e238df7c5123$export$eb2fcfdbd7ba97d4();
                        break;
                    case 'Bone':
                        object = new $c702e238df7c5123$export$b127726e56765aa4();
                        break;
                    default:
                        object = new $c702e238df7c5123$export$e4dd07dff30cc924();
                }
                object.uuid = data.uuid;
                if (data.name !== undefined) object.name = data.name;
                if (data.matrix !== undefined) {
                    object.matrix.fromArray(data.matrix);
                    if (data.matrixAutoUpdate !== undefined) object.matrixAutoUpdate = data.matrixAutoUpdate;
                    if (object.matrixAutoUpdate) object.matrix.decompose(object.position, object.quaternion, object.scale);
                } else {
                    if (data.position !== undefined) object.position.fromArray(data.position);
                    if (data.rotation !== undefined) object.rotation.fromArray(data.rotation);
                    if (data.quaternion !== undefined) object.quaternion.fromArray(data.quaternion);
                    if (data.scale !== undefined) object.scale.fromArray(data.scale);
                }
                if (data.castShadow !== undefined) object.castShadow = data.castShadow;
                if (data.receiveShadow !== undefined) object.receiveShadow = data.receiveShadow;
                if (data.shadow) {
                    if (data.shadow.bias !== undefined) object.shadow.bias = data.shadow.bias;
                    if (data.shadow.normalBias !== undefined) object.shadow.normalBias = data.shadow.normalBias;
                    if (data.shadow.radius !== undefined) object.shadow.radius = data.shadow.radius;
                    if (data.shadow.mapSize !== undefined) object.shadow.mapSize.fromArray(data.shadow.mapSize);
                    if (data.shadow.camera !== undefined) object.shadow.camera = this.parseObject(data.shadow.camera);
                }
                if (data.visible !== undefined) object.visible = data.visible;
                if (data.frustumCulled !== undefined) object.frustumCulled = data.frustumCulled;
                if (data.renderOrder !== undefined) object.renderOrder = data.renderOrder;
                if (data.userData !== undefined) object.userData = data.userData;
                if (data.layers !== undefined) object.layers.mask = data.layers;
                if (data.children !== undefined) {
                    var children = data.children;
                    for(var i = 0; i < children.length; i++)object.add(this.parseObject(children[i], geometries, materials, textures, animations));
                }
                if (data.animations !== undefined) {
                    var objectAnimations = data.animations;
                    for(var i1 = 0; i1 < objectAnimations.length; i1++){
                        var uuid = objectAnimations[i1];
                        object.animations.push(animations[uuid]);
                    }
                }
                if (data.type === 'LOD') {
                    if (data.autoUpdate !== undefined) object.autoUpdate = data.autoUpdate;
                    var levels = data.levels;
                    for(var l = 0; l < levels.length; l++){
                        var level = levels[l];
                        var child = object.getObjectByProperty('uuid', level.object);
                        if (child !== undefined) object.addLevel(child, level.distance);
                    }
                }
                return object;
            }
        },
        {
            key: "bindSkeletons",
            value: function bindSkeletons(object, skeletons) {
                if (Object.keys(skeletons).length === 0) return;
                object.traverse(function(child) {
                    if (child.isSkinnedMesh === true && child.skeleton !== undefined) {
                        var skeleton = skeletons[child.skeleton];
                        if (skeleton === undefined) console.warn('THREE.ObjectLoader: No skeleton found with UUID:', child.skeleton);
                        else child.bind(skeleton, child.bindMatrix);
                    }
                });
            }
        },
        {
            /* DEPRECATED */ key: "setTexturePath",
            value: function setTexturePath(value) {
                console.warn('THREE.ObjectLoader: .setTexturePath() has been renamed to .setResourcePath().');
                return this.setResourcePath(value);
            }
        }
    ]);
    return ObjectLoader;
}($c702e238df7c5123$export$3b0d6d7590275603);
var $c702e238df7c5123$var$TEXTURE_MAPPING = {
    UVMapping: $c702e238df7c5123$export$1beec6768cbb3d2d,
    CubeReflectionMapping: $c702e238df7c5123$export$8759762a6477f2c4,
    CubeRefractionMapping: $c702e238df7c5123$export$dc59f8aed047f61d,
    EquirectangularReflectionMapping: $c702e238df7c5123$export$d64030b316d3b087,
    EquirectangularRefractionMapping: $c702e238df7c5123$export$ee99d97d46898098,
    CubeUVReflectionMapping: $c702e238df7c5123$export$dbf3e70ff37af79,
    CubeUVRefractionMapping: $c702e238df7c5123$export$76a9f4355364345c
};
var $c702e238df7c5123$var$TEXTURE_WRAPPING = {
    RepeatWrapping: $c702e238df7c5123$export$533346c8e8dac0f5,
    ClampToEdgeWrapping: $c702e238df7c5123$export$9d9334239a5a5e06,
    MirroredRepeatWrapping: $c702e238df7c5123$export$c7e7c00b14f51a4f
};
var $c702e238df7c5123$var$TEXTURE_FILTER = {
    NearestFilter: $c702e238df7c5123$export$727aa5ec3fe39bf0,
    NearestMipmapNearestFilter: $c702e238df7c5123$export$d129e38cf6feaa8c,
    NearestMipmapLinearFilter: $c702e238df7c5123$export$d2327c1afe5bfdf2,
    LinearFilter: $c702e238df7c5123$export$8a72f490b25c56c8,
    LinearMipmapNearestFilter: $c702e238df7c5123$export$19a719f377145a13,
    LinearMipmapLinearFilter: $c702e238df7c5123$export$5d8599b6a933fb1b
};
var $c702e238df7c5123$export$52286b55c4a9b51f = /*#__PURE__*/ function(Loader) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(ImageBitmapLoader, Loader);
    function ImageBitmapLoader(manager) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, ImageBitmapLoader);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, ImageBitmapLoader, [
            manager
        ]);
        if (typeof createImageBitmap === 'undefined') console.warn('THREE.ImageBitmapLoader: createImageBitmap() not supported.');
        if (typeof fetch === 'undefined') console.warn('THREE.ImageBitmapLoader: fetch() not supported.');
        _this.options = {
            premultiplyAlpha: 'none'
        };
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(ImageBitmapLoader, [
        {
            key: "setOptions",
            value: function setOptions(options) {
                this.options = options;
                return this;
            }
        },
        {
            key: "load",
            value: function load(url, onLoad, onProgress, onError) {
                if (url === undefined) url = '';
                if (this.path !== undefined) url = this.path + url;
                url = this.manager.resolveURL(url);
                var scope = this;
                var cached = $c702e238df7c5123$export$94affb487e701bf2.get(url);
                if (cached !== undefined) {
                    scope.manager.itemStart(url);
                    setTimeout(function() {
                        if (onLoad) onLoad(cached);
                        scope.manager.itemEnd(url);
                    }, 0);
                    return cached;
                }
                var fetchOptions = {};
                fetchOptions.credentials = this.crossOrigin === 'anonymous' ? 'same-origin' : 'include';
                fetchOptions.headers = this.requestHeader;
                fetch(url, fetchOptions).then(function(res) {
                    return res.blob();
                }).then(function(blob) {
                    return createImageBitmap(blob, Object.assign(scope.options, {
                        colorSpaceConversion: 'none'
                    }));
                }).then(function(imageBitmap) {
                    $c702e238df7c5123$export$94affb487e701bf2.add(url, imageBitmap);
                    if (onLoad) onLoad(imageBitmap);
                    scope.manager.itemEnd(url);
                })["catch"](function(e) {
                    if (onError) onError(e);
                    scope.manager.itemError(url);
                    scope.manager.itemEnd(url);
                });
                scope.manager.itemStart(url);
            }
        }
    ]);
    return ImageBitmapLoader;
}($c702e238df7c5123$export$3b0d6d7590275603);
$c702e238df7c5123$export$52286b55c4a9b51f.prototype.isImageBitmapLoader = true;
var $c702e238df7c5123$export$148534a3c727230b = /*#__PURE__*/ function() {
    "use strict";
    function ShapePath() {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, ShapePath);
        this.type = 'ShapePath';
        this.color = new $c702e238df7c5123$export$892596cec99bc70e();
        this.subPaths = [];
        this.currentPath = null;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(ShapePath, [
        {
            key: "moveTo",
            value: function moveTo(x, y) {
                this.currentPath = new $c702e238df7c5123$export$4b2950bdac9b6ee9();
                this.subPaths.push(this.currentPath);
                this.currentPath.moveTo(x, y);
                return this;
            }
        },
        {
            key: "lineTo",
            value: function lineTo(x, y) {
                this.currentPath.lineTo(x, y);
                return this;
            }
        },
        {
            key: "quadraticCurveTo",
            value: function quadraticCurveTo(aCPx, aCPy, aX, aY) {
                this.currentPath.quadraticCurveTo(aCPx, aCPy, aX, aY);
                return this;
            }
        },
        {
            key: "bezierCurveTo",
            value: function bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
                this.currentPath.bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY);
                return this;
            }
        },
        {
            key: "splineThru",
            value: function splineThru(pts) {
                this.currentPath.splineThru(pts);
                return this;
            }
        },
        {
            key: "toShapes",
            value: function toShapes(isCCW, noHoles) {
                function toShapesNoHoles(inSubpaths) {
                    var shapes = [];
                    for(var i = 0, l = inSubpaths.length; i < l; i++){
                        var tmpPath = inSubpaths[i];
                        var tmpShape = new $c702e238df7c5123$export$6428a7f2611ef1fa();
                        tmpShape.curves = tmpPath.curves;
                        shapes.push(tmpShape);
                    }
                    return shapes;
                }
                function isPointInsidePolygon(inPt, inPolygon) {
                    var polyLen = inPolygon.length;
                    // inPt on polygon contour => immediate success    or
                    // toggling of inside/outside at every single! intersection point of an edge
                    //  with the horizontal line through inPt, left of inPt
                    //  not counting lowerY endpoints of edges and whole edges on that line
                    var inside = false;
                    for(var p = polyLen - 1, q = 0; q < polyLen; p = q++){
                        var edgeLowPt = inPolygon[p];
                        var edgeHighPt = inPolygon[q];
                        var edgeDx = edgeHighPt.x - edgeLowPt.x;
                        var edgeDy = edgeHighPt.y - edgeLowPt.y;
                        if (Math.abs(edgeDy) > Number.EPSILON) {
                            // not parallel
                            if (edgeDy < 0) {
                                edgeLowPt = inPolygon[q];
                                edgeDx = -edgeDx;
                                edgeHighPt = inPolygon[p];
                                edgeDy = -edgeDy;
                            }
                            if (inPt.y < edgeLowPt.y || inPt.y > edgeHighPt.y) continue;
                            if (inPt.y === edgeLowPt.y) {
                                if (inPt.x === edgeLowPt.x) return true; // inPt is on contour ?
                            // continue;				// no intersection or edgeLowPt => doesn't count !!!
                            } else {
                                var perpEdge = edgeDy * (inPt.x - edgeLowPt.x) - edgeDx * (inPt.y - edgeLowPt.y);
                                if (perpEdge === 0) return true; // inPt is on contour ?
                                if (perpEdge < 0) continue;
                                inside = !inside; // true intersection left of inPt
                            }
                        } else {
                            // parallel or collinear
                            if (inPt.y !== edgeLowPt.y) continue; // parallel
                            // edge lies on the same horizontal line as inPt
                            if (edgeHighPt.x <= inPt.x && inPt.x <= edgeLowPt.x || edgeLowPt.x <= inPt.x && inPt.x <= edgeHighPt.x) return true; // inPt: Point on contour !
                        // continue;
                        }
                    }
                    return inside;
                }
                var isClockWise = $c702e238df7c5123$export$96bdf6d9c66d7ba8.isClockWise;
                var subPaths = this.subPaths;
                if (subPaths.length === 0) return [];
                if (noHoles === true) return toShapesNoHoles(subPaths);
                var solid, tmpPath, tmpShape;
                var shapes = [];
                if (subPaths.length === 1) {
                    tmpPath = subPaths[0];
                    tmpShape = new $c702e238df7c5123$export$6428a7f2611ef1fa();
                    tmpShape.curves = tmpPath.curves;
                    shapes.push(tmpShape);
                    return shapes;
                }
                var holesFirst = !isClockWise(subPaths[0].getPoints());
                holesFirst = isCCW ? !holesFirst : holesFirst;
                // console.log("Holes first", holesFirst);
                var betterShapeHoles = [];
                var newShapes = [];
                var newShapeHoles = [];
                var mainIdx = 0;
                var tmpPoints;
                newShapes[mainIdx] = undefined;
                newShapeHoles[mainIdx] = [];
                for(var i = 0, l = subPaths.length; i < l; i++){
                    tmpPath = subPaths[i];
                    tmpPoints = tmpPath.getPoints();
                    solid = isClockWise(tmpPoints);
                    solid = isCCW ? !solid : solid;
                    if (solid) {
                        if (!holesFirst && newShapes[mainIdx]) mainIdx++;
                        newShapes[mainIdx] = {
                            s: new $c702e238df7c5123$export$6428a7f2611ef1fa(),
                            p: tmpPoints
                        };
                        newShapes[mainIdx].s.curves = tmpPath.curves;
                        if (holesFirst) mainIdx++;
                        newShapeHoles[mainIdx] = [];
                    //console.log('cw', i);
                    } else newShapeHoles[mainIdx].push({
                        h: tmpPath,
                        p: tmpPoints[0]
                    });
                }
                // only Holes? -> probably all Shapes with wrong orientation
                if (!newShapes[0]) return toShapesNoHoles(subPaths);
                if (newShapes.length > 1) {
                    var ambiguous = false;
                    var toChange = [];
                    for(var sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++)betterShapeHoles[sIdx] = [];
                    for(var sIdx1 = 0, sLen1 = newShapes.length; sIdx1 < sLen1; sIdx1++){
                        var sho = newShapeHoles[sIdx1];
                        for(var hIdx = 0; hIdx < sho.length; hIdx++){
                            var ho = sho[hIdx];
                            var hole_unassigned = true;
                            for(var s2Idx = 0; s2Idx < newShapes.length; s2Idx++)if (isPointInsidePolygon(ho.p, newShapes[s2Idx].p)) {
                                if (sIdx1 !== s2Idx) toChange.push({
                                    froms: sIdx1,
                                    tos: s2Idx,
                                    hole: hIdx
                                });
                                if (hole_unassigned) {
                                    hole_unassigned = false;
                                    betterShapeHoles[s2Idx].push(ho);
                                } else ambiguous = true;
                            }
                            if (hole_unassigned) betterShapeHoles[sIdx1].push(ho);
                        }
                    }
                    // console.log("ambiguous: ", ambiguous);
                    if (toChange.length > 0) // console.log("to change: ", toChange);
                    {
                        if (!ambiguous) newShapeHoles = betterShapeHoles;
                    }
                }
                var tmpHoles;
                for(var i1 = 0, il = newShapes.length; i1 < il; i1++){
                    tmpShape = newShapes[i1].s;
                    shapes.push(tmpShape);
                    tmpHoles = newShapeHoles[i1];
                    for(var j = 0, jl = tmpHoles.length; j < jl; j++)tmpShape.holes.push(tmpHoles[j].h);
                }
                //console.log("shape", shapes);
                return shapes;
            }
        }
    ]);
    return ShapePath;
}();
var $c702e238df7c5123$export$89abf52a030e56ee = /*#__PURE__*/ function() {
    "use strict";
    function Font(data) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Font);
        this.type = 'Font';
        this.data = data;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(Font, [
        {
            key: "generateShapes",
            value: function generateShapes(text) {
                var size = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100;
                var shapes = [];
                var paths = $c702e238df7c5123$var$createPaths(text, size, this.data);
                for(var p = 0, pl = paths.length; p < pl; p++)Array.prototype.push.apply(shapes, paths[p].toShapes());
                return shapes;
            }
        }
    ]);
    return Font;
}();
function $c702e238df7c5123$var$createPaths(text, size, data) {
    var chars = Array.from(text);
    var scale = size / data.resolution;
    var line_height = (data.boundingBox.yMax - data.boundingBox.yMin + data.underlineThickness) * scale;
    var paths = [];
    var offsetX = 0, offsetY = 0;
    for(var i = 0; i < chars.length; i++){
        var _char = chars[i];
        if (_char === '\n') {
            offsetX = 0;
            offsetY -= line_height;
        } else {
            var ret = $c702e238df7c5123$var$createPath(_char, scale, offsetX, offsetY, data);
            offsetX += ret.offsetX;
            paths.push(ret.path);
        }
    }
    return paths;
}
function $c702e238df7c5123$var$createPath(_char, scale, offsetX, offsetY, data) {
    var glyph = data.glyphs[_char] || data.glyphs['?'];
    if (!glyph) {
        console.error('THREE.Font: character "' + _char + '" does not exists in font family ' + data.familyName + '.');
        return;
    }
    var path = new $c702e238df7c5123$export$148534a3c727230b();
    var x, y, cpx, cpy, cpx1, cpy1, cpx2, cpy2;
    if (glyph.o) {
        var outline = glyph._cachedOutline || (glyph._cachedOutline = glyph.o.split(' '));
        for(var i = 0, l = outline.length; i < l;){
            var action = outline[i++];
            switch(action){
                case 'm':
                    x = outline[i++] * scale + offsetX;
                    y = outline[i++] * scale + offsetY;
                    path.moveTo(x, y);
                    break;
                case 'l':
                    x = outline[i++] * scale + offsetX;
                    y = outline[i++] * scale + offsetY;
                    path.lineTo(x, y);
                    break;
                case 'q':
                    cpx = outline[i++] * scale + offsetX;
                    cpy = outline[i++] * scale + offsetY;
                    cpx1 = outline[i++] * scale + offsetX;
                    cpy1 = outline[i++] * scale + offsetY;
                    path.quadraticCurveTo(cpx1, cpy1, cpx, cpy);
                    break;
                case 'b':
                    cpx = outline[i++] * scale + offsetX;
                    cpy = outline[i++] * scale + offsetY;
                    cpx1 = outline[i++] * scale + offsetX;
                    cpy1 = outline[i++] * scale + offsetY;
                    cpx2 = outline[i++] * scale + offsetX;
                    cpy2 = outline[i++] * scale + offsetY;
                    path.bezierCurveTo(cpx1, cpy1, cpx2, cpy2, cpx, cpy);
                    break;
            }
        }
    }
    return {
        offsetX: glyph.ha * scale,
        path: path
    };
}
$c702e238df7c5123$export$89abf52a030e56ee.prototype.isFont = true;
var $c702e238df7c5123$export$812303d6cad736b3 = /*#__PURE__*/ function(Loader) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(FontLoader, Loader);
    function FontLoader(manager) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, FontLoader);
        return (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, FontLoader, [
            manager
        ]);
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(FontLoader, [
        {
            key: "load",
            value: function load(url, onLoad, onProgress, onError) {
                var scope = this;
                var loader = new $c702e238df7c5123$export$98435a25b5cf7b2b(this.manager);
                loader.setPath(this.path);
                loader.setRequestHeader(this.requestHeader);
                loader.setWithCredentials(scope.withCredentials);
                loader.load(url, function(text) {
                    var json;
                    try {
                        json = JSON.parse(text);
                    } catch (e) {
                        console.warn('THREE.FontLoader: typeface.js support is being deprecated. Use typeface.json instead.');
                        json = JSON.parse(text.substring(65, text.length - 2));
                    }
                    var font = scope.parse(json);
                    if (onLoad) onLoad(font);
                }, onProgress, onError);
            }
        },
        {
            key: "parse",
            value: function parse(json) {
                return new $c702e238df7c5123$export$89abf52a030e56ee(json);
            }
        }
    ]);
    return FontLoader;
}($c702e238df7c5123$export$3b0d6d7590275603);
var $c702e238df7c5123$var$_context;
var $c702e238df7c5123$export$fcbc63750ec2a81f = {
    getContext: function getContext() {
        if ($c702e238df7c5123$var$_context === undefined) $c702e238df7c5123$var$_context = new (window.AudioContext || window.webkitAudioContext)();
        return $c702e238df7c5123$var$_context;
    },
    setContext: function setContext(value) {
        $c702e238df7c5123$var$_context = value;
    }
};
var $c702e238df7c5123$export$d8d5fccfbf47714e = /*#__PURE__*/ function(Loader) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(AudioLoader, Loader);
    function AudioLoader(manager) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, AudioLoader);
        return (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, AudioLoader, [
            manager
        ]);
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(AudioLoader, [
        {
            key: "load",
            value: function load(url, onLoad, onProgress, onError) {
                var scope = this;
                var loader = new $c702e238df7c5123$export$98435a25b5cf7b2b(this.manager);
                loader.setResponseType('arraybuffer');
                loader.setPath(this.path);
                loader.setRequestHeader(this.requestHeader);
                loader.setWithCredentials(this.withCredentials);
                loader.load(url, function(buffer) {
                    try {
                        // Create a copy of the buffer. The `decodeAudioData` method
                        // detaches the buffer when complete, preventing reuse.
                        var bufferCopy = buffer.slice(0);
                        var context = $c702e238df7c5123$export$fcbc63750ec2a81f.getContext();
                        context.decodeAudioData(bufferCopy, function(audioBuffer) {
                            onLoad(audioBuffer);
                        });
                    } catch (e) {
                        if (onError) onError(e);
                        else console.error(e);
                        scope.manager.itemError(url);
                    }
                }, onProgress, onError);
            }
        }
    ]);
    return AudioLoader;
}($c702e238df7c5123$export$3b0d6d7590275603);
var $c702e238df7c5123$export$2f22dadc8bc42820 = /*#__PURE__*/ function(LightProbe) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(HemisphereLightProbe, LightProbe);
    function HemisphereLightProbe(skyColor, groundColor) {
        var intensity = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, HemisphereLightProbe);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, HemisphereLightProbe, [
            undefined,
            intensity
        ]);
        var color1 = new $c702e238df7c5123$export$892596cec99bc70e().set(skyColor);
        var color2 = new $c702e238df7c5123$export$892596cec99bc70e().set(groundColor);
        var sky = new $c702e238df7c5123$export$64b5c384219d3699(color1.r, color1.g, color1.b);
        var ground = new $c702e238df7c5123$export$64b5c384219d3699(color2.r, color2.g, color2.b);
        // without extra factor of PI in the shader, should = 1 / Math.sqrt( Math.PI );
        var c0 = Math.sqrt(Math.PI);
        var c1 = c0 * Math.sqrt(0.75);
        _this.sh.coefficients[0].copy(sky).add(ground).multiplyScalar(c0);
        _this.sh.coefficients[1].copy(sky).sub(ground).multiplyScalar(c1);
        return _this;
    }
    return HemisphereLightProbe;
}($c702e238df7c5123$export$e7ef036e309b38d2);
$c702e238df7c5123$export$2f22dadc8bc42820.prototype.isHemisphereLightProbe = true;
var $c702e238df7c5123$export$afe310a21c86023d = /*#__PURE__*/ function(LightProbe) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(AmbientLightProbe, LightProbe);
    function AmbientLightProbe(color) {
        var intensity = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, AmbientLightProbe);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, AmbientLightProbe, [
            undefined,
            intensity
        ]);
        var color1 = new $c702e238df7c5123$export$892596cec99bc70e().set(color);
        // without extra factor of PI in the shader, would be 2 / Math.sqrt( Math.PI );
        _this.sh.coefficients[0].set(color1.r, color1.g, color1.b).multiplyScalar(2 * Math.sqrt(Math.PI));
        return _this;
    }
    return AmbientLightProbe;
}($c702e238df7c5123$export$e7ef036e309b38d2);
$c702e238df7c5123$export$afe310a21c86023d.prototype.isAmbientLightProbe = true;
var $c702e238df7c5123$var$_eyeRight = /*@__PURE__*/ new $c702e238df7c5123$export$2ae72fc923e5eb5();
var $c702e238df7c5123$var$_eyeLeft = /*@__PURE__*/ new $c702e238df7c5123$export$2ae72fc923e5eb5();
var $c702e238df7c5123$export$bc7f73a1065bee0c = /*#__PURE__*/ function() {
    "use strict";
    function StereoCamera() {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, StereoCamera);
        this.type = 'StereoCamera';
        this.aspect = 1;
        this.eyeSep = 0.064;
        this.cameraL = new $c702e238df7c5123$export$74e4ae24825f68d7();
        this.cameraL.layers.enable(1);
        this.cameraL.matrixAutoUpdate = false;
        this.cameraR = new $c702e238df7c5123$export$74e4ae24825f68d7();
        this.cameraR.layers.enable(2);
        this.cameraR.matrixAutoUpdate = false;
        this._cache = {
            focus: null,
            fov: null,
            aspect: null,
            near: null,
            far: null,
            zoom: null,
            eyeSep: null
        };
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(StereoCamera, [
        {
            key: "update",
            value: function update(camera) {
                var cache = this._cache;
                var needsUpdate = cache.focus !== camera.focus || cache.fov !== camera.fov || cache.aspect !== camera.aspect * this.aspect || cache.near !== camera.near || cache.far !== camera.far || cache.zoom !== camera.zoom || cache.eyeSep !== this.eyeSep;
                if (needsUpdate) {
                    cache.focus = camera.focus;
                    cache.fov = camera.fov;
                    cache.aspect = camera.aspect * this.aspect;
                    cache.near = camera.near;
                    cache.far = camera.far;
                    cache.zoom = camera.zoom;
                    cache.eyeSep = this.eyeSep;
                    // Off-axis stereoscopic effect based on
                    // http://paulbourke.net/stereographics/stereorender/
                    var projectionMatrix = camera.projectionMatrix.clone();
                    var eyeSepHalf = cache.eyeSep / 2;
                    var eyeSepOnProjection = eyeSepHalf * cache.near / cache.focus;
                    var ymax = cache.near * Math.tan($c702e238df7c5123$var$DEG2RAD * cache.fov * 0.5) / cache.zoom;
                    var xmin, xmax;
                    // translate xOffset
                    $c702e238df7c5123$var$_eyeLeft.elements[12] = -eyeSepHalf;
                    $c702e238df7c5123$var$_eyeRight.elements[12] = eyeSepHalf;
                    // for left eye
                    xmin = -ymax * cache.aspect + eyeSepOnProjection;
                    xmax = ymax * cache.aspect + eyeSepOnProjection;
                    projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
                    projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
                    this.cameraL.projectionMatrix.copy(projectionMatrix);
                    // for right eye
                    xmin = -ymax * cache.aspect - eyeSepOnProjection;
                    xmax = ymax * cache.aspect - eyeSepOnProjection;
                    projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
                    projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
                    this.cameraR.projectionMatrix.copy(projectionMatrix);
                }
                this.cameraL.matrixWorld.copy(camera.matrixWorld).multiply($c702e238df7c5123$var$_eyeLeft);
                this.cameraR.matrixWorld.copy(camera.matrixWorld).multiply($c702e238df7c5123$var$_eyeRight);
            }
        }
    ]);
    return StereoCamera;
}();
var $c702e238df7c5123$export$9735c82c4bae3302 = /*#__PURE__*/ function() {
    "use strict";
    function Clock() {
        var autoStart = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Clock);
        this.autoStart = autoStart;
        this.startTime = 0;
        this.oldTime = 0;
        this.elapsedTime = 0;
        this.running = false;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(Clock, [
        {
            key: "start",
            value: function start() {
                this.startTime = $c702e238df7c5123$var$now();
                this.oldTime = this.startTime;
                this.elapsedTime = 0;
                this.running = true;
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.getElapsedTime();
                this.running = false;
                this.autoStart = false;
            }
        },
        {
            key: "getElapsedTime",
            value: function getElapsedTime() {
                this.getDelta();
                return this.elapsedTime;
            }
        },
        {
            key: "getDelta",
            value: function getDelta() {
                var diff = 0;
                if (this.autoStart && !this.running) {
                    this.start();
                    return 0;
                }
                if (this.running) {
                    var newTime = $c702e238df7c5123$var$now();
                    diff = (newTime - this.oldTime) / 1000;
                    this.oldTime = newTime;
                    this.elapsedTime += diff;
                }
                return diff;
            }
        }
    ]);
    return Clock;
}();
function $c702e238df7c5123$var$now() {
    return (typeof performance === 'undefined' ? Date : performance).now(); // see #10732
}
var $c702e238df7c5123$var$_position$1 = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_quaternion$1 = /*@__PURE__*/ new $c702e238df7c5123$export$23d6a54f0bbc85a3();
var $c702e238df7c5123$var$_scale$1 = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_orientation$1 = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$export$8a1b810c6fde8951 = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(AudioListener, Object3D);
    function AudioListener() {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, AudioListener);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, AudioListener);
        _this.type = 'AudioListener';
        _this.context = $c702e238df7c5123$export$fcbc63750ec2a81f.getContext();
        _this.gain = _this.context.createGain();
        _this.gain.connect(_this.context.destination);
        _this.filter = null;
        _this.timeDelta = 0;
        // private
        _this._clock = new $c702e238df7c5123$export$9735c82c4bae3302();
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(AudioListener, [
        {
            key: "getInput",
            value: function getInput() {
                return this.gain;
            }
        },
        {
            key: "removeFilter",
            value: function removeFilter() {
                if (this.filter !== null) {
                    this.gain.disconnect(this.filter);
                    this.filter.disconnect(this.context.destination);
                    this.gain.connect(this.context.destination);
                    this.filter = null;
                }
                return this;
            }
        },
        {
            key: "getFilter",
            value: function getFilter() {
                return this.filter;
            }
        },
        {
            key: "setFilter",
            value: function setFilter(value) {
                if (this.filter !== null) {
                    this.gain.disconnect(this.filter);
                    this.filter.disconnect(this.context.destination);
                } else this.gain.disconnect(this.context.destination);
                this.filter = value;
                this.gain.connect(this.filter);
                this.filter.connect(this.context.destination);
                return this;
            }
        },
        {
            key: "getMasterVolume",
            value: function getMasterVolume() {
                return this.gain.gain.value;
            }
        },
        {
            key: "setMasterVolume",
            value: function setMasterVolume(value) {
                this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
                return this;
            }
        },
        {
            key: "updateMatrixWorld",
            value: function updateMatrixWorld(force) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(AudioListener.prototype), "updateMatrixWorld", this).call(this, force);
                var listener = this.context.listener;
                var up = this.up;
                this.timeDelta = this._clock.getDelta();
                this.matrixWorld.decompose($c702e238df7c5123$var$_position$1, $c702e238df7c5123$var$_quaternion$1, $c702e238df7c5123$var$_scale$1);
                $c702e238df7c5123$var$_orientation$1.set(0, 0, -1).applyQuaternion($c702e238df7c5123$var$_quaternion$1);
                if (listener.positionX) {
                    // code path for Chrome (see #14393)
                    var endTime = this.context.currentTime + this.timeDelta;
                    listener.positionX.linearRampToValueAtTime($c702e238df7c5123$var$_position$1.x, endTime);
                    listener.positionY.linearRampToValueAtTime($c702e238df7c5123$var$_position$1.y, endTime);
                    listener.positionZ.linearRampToValueAtTime($c702e238df7c5123$var$_position$1.z, endTime);
                    listener.forwardX.linearRampToValueAtTime($c702e238df7c5123$var$_orientation$1.x, endTime);
                    listener.forwardY.linearRampToValueAtTime($c702e238df7c5123$var$_orientation$1.y, endTime);
                    listener.forwardZ.linearRampToValueAtTime($c702e238df7c5123$var$_orientation$1.z, endTime);
                    listener.upX.linearRampToValueAtTime(up.x, endTime);
                    listener.upY.linearRampToValueAtTime(up.y, endTime);
                    listener.upZ.linearRampToValueAtTime(up.z, endTime);
                } else {
                    listener.setPosition($c702e238df7c5123$var$_position$1.x, $c702e238df7c5123$var$_position$1.y, $c702e238df7c5123$var$_position$1.z);
                    listener.setOrientation($c702e238df7c5123$var$_orientation$1.x, $c702e238df7c5123$var$_orientation$1.y, $c702e238df7c5123$var$_orientation$1.z, up.x, up.y, up.z);
                }
            }
        }
    ]);
    return AudioListener;
}($c702e238df7c5123$export$e4dd07dff30cc924);
var $c702e238df7c5123$export$153755f98d9861de = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(Audio, Object3D);
    function Audio(listener) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Audio);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, Audio);
        _this.type = 'Audio';
        _this.listener = listener;
        _this.context = listener.context;
        _this.gain = _this.context.createGain();
        _this.gain.connect(listener.getInput());
        _this.autoplay = false;
        _this.buffer = null;
        _this.detune = 0;
        _this.loop = false;
        _this.loopStart = 0;
        _this.loopEnd = 0;
        _this.offset = 0;
        _this.duration = undefined;
        _this.playbackRate = 1;
        _this.isPlaying = false;
        _this.hasPlaybackControl = true;
        _this.source = null;
        _this.sourceType = 'empty';
        _this._startedAt = 0;
        _this._progress = 0;
        _this._connected = false;
        _this.filters = [];
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(Audio, [
        {
            key: "getOutput",
            value: function getOutput() {
                return this.gain;
            }
        },
        {
            key: "setNodeSource",
            value: function setNodeSource(audioNode) {
                this.hasPlaybackControl = false;
                this.sourceType = 'audioNode';
                this.source = audioNode;
                this.connect();
                return this;
            }
        },
        {
            key: "setMediaElementSource",
            value: function setMediaElementSource(mediaElement) {
                this.hasPlaybackControl = false;
                this.sourceType = 'mediaNode';
                this.source = this.context.createMediaElementSource(mediaElement);
                this.connect();
                return this;
            }
        },
        {
            key: "setMediaStreamSource",
            value: function setMediaStreamSource(mediaStream) {
                this.hasPlaybackControl = false;
                this.sourceType = 'mediaStreamNode';
                this.source = this.context.createMediaStreamSource(mediaStream);
                this.connect();
                return this;
            }
        },
        {
            key: "setBuffer",
            value: function setBuffer(audioBuffer) {
                this.buffer = audioBuffer;
                this.sourceType = 'buffer';
                if (this.autoplay) this.play();
                return this;
            }
        },
        {
            key: "play",
            value: function play() {
                var delay = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                if (this.isPlaying === true) {
                    console.warn('THREE.Audio: Audio is already playing.');
                    return;
                }
                if (this.hasPlaybackControl === false) {
                    console.warn('THREE.Audio: this Audio has no playback control.');
                    return;
                }
                this._startedAt = this.context.currentTime + delay;
                var source = this.context.createBufferSource();
                source.buffer = this.buffer;
                source.loop = this.loop;
                source.loopStart = this.loopStart;
                source.loopEnd = this.loopEnd;
                source.onended = this.onEnded.bind(this);
                source.start(this._startedAt, this._progress + this.offset, this.duration);
                this.isPlaying = true;
                this.source = source;
                this.setDetune(this.detune);
                this.setPlaybackRate(this.playbackRate);
                return this.connect();
            }
        },
        {
            key: "pause",
            value: function pause() {
                if (this.hasPlaybackControl === false) {
                    console.warn('THREE.Audio: this Audio has no playback control.');
                    return;
                }
                if (this.isPlaying === true) {
                    // update current progress
                    this._progress += Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate;
                    if (this.loop === true) // ensure _progress does not exceed duration with looped audios
                    this._progress = this._progress % (this.duration || this.buffer.duration);
                    this.source.stop();
                    this.source.onended = null;
                    this.isPlaying = false;
                }
                return this;
            }
        },
        {
            key: "stop",
            value: function stop() {
                if (this.hasPlaybackControl === false) {
                    console.warn('THREE.Audio: this Audio has no playback control.');
                    return;
                }
                this._progress = 0;
                this.source.stop();
                this.source.onended = null;
                this.isPlaying = false;
                return this;
            }
        },
        {
            key: "connect",
            value: function connect() {
                if (this.filters.length > 0) {
                    this.source.connect(this.filters[0]);
                    for(var i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].connect(this.filters[i]);
                    this.filters[this.filters.length - 1].connect(this.getOutput());
                } else this.source.connect(this.getOutput());
                this._connected = true;
                return this;
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.filters.length > 0) {
                    this.source.disconnect(this.filters[0]);
                    for(var i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].disconnect(this.filters[i]);
                    this.filters[this.filters.length - 1].disconnect(this.getOutput());
                } else this.source.disconnect(this.getOutput());
                this._connected = false;
                return this;
            }
        },
        {
            key: "getFilters",
            value: function getFilters() {
                return this.filters;
            }
        },
        {
            key: "setFilters",
            value: function setFilters(value) {
                if (!value) value = [];
                if (this._connected === true) {
                    this.disconnect();
                    this.filters = value.slice();
                    this.connect();
                } else this.filters = value.slice();
                return this;
            }
        },
        {
            key: "setDetune",
            value: function setDetune(value) {
                this.detune = value;
                if (this.source.detune === undefined) return; // only set detune when available
                if (this.isPlaying === true) this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, 0.01);
                return this;
            }
        },
        {
            key: "getDetune",
            value: function getDetune() {
                return this.detune;
            }
        },
        {
            key: "getFilter",
            value: function getFilter() {
                return this.getFilters()[0];
            }
        },
        {
            key: "setFilter",
            value: function setFilter(filter) {
                return this.setFilters(filter ? [
                    filter
                ] : []);
            }
        },
        {
            key: "setPlaybackRate",
            value: function setPlaybackRate(value) {
                if (this.hasPlaybackControl === false) {
                    console.warn('THREE.Audio: this Audio has no playback control.');
                    return;
                }
                this.playbackRate = value;
                if (this.isPlaying === true) this.source.playbackRate.setTargetAtTime(this.playbackRate, this.context.currentTime, 0.01);
                return this;
            }
        },
        {
            key: "getPlaybackRate",
            value: function getPlaybackRate() {
                return this.playbackRate;
            }
        },
        {
            key: "onEnded",
            value: function onEnded() {
                this.isPlaying = false;
            }
        },
        {
            key: "getLoop",
            value: function getLoop() {
                if (this.hasPlaybackControl === false) {
                    console.warn('THREE.Audio: this Audio has no playback control.');
                    return false;
                }
                return this.loop;
            }
        },
        {
            key: "setLoop",
            value: function setLoop(value) {
                if (this.hasPlaybackControl === false) {
                    console.warn('THREE.Audio: this Audio has no playback control.');
                    return;
                }
                this.loop = value;
                if (this.isPlaying === true) this.source.loop = this.loop;
                return this;
            }
        },
        {
            key: "setLoopStart",
            value: function setLoopStart(value) {
                this.loopStart = value;
                return this;
            }
        },
        {
            key: "setLoopEnd",
            value: function setLoopEnd(value) {
                this.loopEnd = value;
                return this;
            }
        },
        {
            key: "getVolume",
            value: function getVolume() {
                return this.gain.gain.value;
            }
        },
        {
            key: "setVolume",
            value: function setVolume(value) {
                this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
                return this;
            }
        }
    ]);
    return Audio;
}($c702e238df7c5123$export$e4dd07dff30cc924);
var $c702e238df7c5123$var$_position = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_quaternion = /*@__PURE__*/ new $c702e238df7c5123$export$23d6a54f0bbc85a3();
var $c702e238df7c5123$var$_scale = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_orientation = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$export$4b3e397ef1832507 = /*#__PURE__*/ function(Audio) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(PositionalAudio, Audio);
    function PositionalAudio(listener) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, PositionalAudio);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, PositionalAudio, [
            listener
        ]);
        _this.panner = _this.context.createPanner();
        _this.panner.panningModel = 'HRTF';
        _this.panner.connect(_this.gain);
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(PositionalAudio, [
        {
            key: "getOutput",
            value: function getOutput() {
                return this.panner;
            }
        },
        {
            key: "getRefDistance",
            value: function getRefDistance() {
                return this.panner.refDistance;
            }
        },
        {
            key: "setRefDistance",
            value: function setRefDistance(value) {
                this.panner.refDistance = value;
                return this;
            }
        },
        {
            key: "getRolloffFactor",
            value: function getRolloffFactor() {
                return this.panner.rolloffFactor;
            }
        },
        {
            key: "setRolloffFactor",
            value: function setRolloffFactor(value) {
                this.panner.rolloffFactor = value;
                return this;
            }
        },
        {
            key: "getDistanceModel",
            value: function getDistanceModel() {
                return this.panner.distanceModel;
            }
        },
        {
            key: "setDistanceModel",
            value: function setDistanceModel(value) {
                this.panner.distanceModel = value;
                return this;
            }
        },
        {
            key: "getMaxDistance",
            value: function getMaxDistance() {
                return this.panner.maxDistance;
            }
        },
        {
            key: "setMaxDistance",
            value: function setMaxDistance(value) {
                this.panner.maxDistance = value;
                return this;
            }
        },
        {
            key: "setDirectionalCone",
            value: function setDirectionalCone(coneInnerAngle, coneOuterAngle, coneOuterGain) {
                this.panner.coneInnerAngle = coneInnerAngle;
                this.panner.coneOuterAngle = coneOuterAngle;
                this.panner.coneOuterGain = coneOuterGain;
                return this;
            }
        },
        {
            key: "updateMatrixWorld",
            value: function updateMatrixWorld(force) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(PositionalAudio.prototype), "updateMatrixWorld", this).call(this, force);
                if (this.hasPlaybackControl === true && this.isPlaying === false) return;
                this.matrixWorld.decompose($c702e238df7c5123$var$_position, $c702e238df7c5123$var$_quaternion, $c702e238df7c5123$var$_scale);
                $c702e238df7c5123$var$_orientation.set(0, 0, 1).applyQuaternion($c702e238df7c5123$var$_quaternion);
                var panner = this.panner;
                if (panner.positionX) {
                    // code path for Chrome and Firefox (see #14393)
                    var endTime = this.context.currentTime + this.listener.timeDelta;
                    panner.positionX.linearRampToValueAtTime($c702e238df7c5123$var$_position.x, endTime);
                    panner.positionY.linearRampToValueAtTime($c702e238df7c5123$var$_position.y, endTime);
                    panner.positionZ.linearRampToValueAtTime($c702e238df7c5123$var$_position.z, endTime);
                    panner.orientationX.linearRampToValueAtTime($c702e238df7c5123$var$_orientation.x, endTime);
                    panner.orientationY.linearRampToValueAtTime($c702e238df7c5123$var$_orientation.y, endTime);
                    panner.orientationZ.linearRampToValueAtTime($c702e238df7c5123$var$_orientation.z, endTime);
                } else {
                    panner.setPosition($c702e238df7c5123$var$_position.x, $c702e238df7c5123$var$_position.y, $c702e238df7c5123$var$_position.z);
                    panner.setOrientation($c702e238df7c5123$var$_orientation.x, $c702e238df7c5123$var$_orientation.y, $c702e238df7c5123$var$_orientation.z);
                }
            }
        }
    ]);
    return PositionalAudio;
}((0, $314aa8324adb934d$export$71511d61b312f219)($c702e238df7c5123$export$153755f98d9861de));
var $c702e238df7c5123$export$d47da1ef3d382827 = /*#__PURE__*/ function() {
    "use strict";
    function AudioAnalyser(audio) {
        var fftSize = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2048;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, AudioAnalyser);
        this.analyser = audio.context.createAnalyser();
        this.analyser.fftSize = fftSize;
        this.data = new Uint8Array(this.analyser.frequencyBinCount);
        audio.getOutput().connect(this.analyser);
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(AudioAnalyser, [
        {
            key: "getFrequencyData",
            value: function getFrequencyData() {
                this.analyser.getByteFrequencyData(this.data);
                return this.data;
            }
        },
        {
            key: "getAverageFrequency",
            value: function getAverageFrequency() {
                var value = 0;
                var data = this.getFrequencyData();
                for(var i = 0; i < data.length; i++)value += data[i];
                return value / data.length;
            }
        }
    ]);
    return AudioAnalyser;
}();
var $c702e238df7c5123$export$dfe0af1ca1acb78a = /*#__PURE__*/ function() {
    "use strict";
    function PropertyMixer(binding, typeName, valueSize) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, PropertyMixer);
        this.binding = binding;
        this.valueSize = valueSize;
        var mixFunction, mixFunctionAdditive, setIdentity;
        // buffer layout: [ incoming | accu0 | accu1 | orig | addAccu | (optional work) ]
        //
        // interpolators can use .buffer as their .result
        // the data then goes to 'incoming'
        //
        // 'accu0' and 'accu1' are used frame-interleaved for
        // the cumulative result and are compared to detect
        // changes
        //
        // 'orig' stores the original state of the property
        //
        // 'add' is used for additive cumulative results
        //
        // 'work' is optional and is only present for quaternion types. It is used
        // to store intermediate quaternion multiplication results
        switch(typeName){
            case 'quaternion':
                mixFunction = this._slerp;
                mixFunctionAdditive = this._slerpAdditive;
                setIdentity = this._setAdditiveIdentityQuaternion;
                this.buffer = new Float64Array(valueSize * 6);
                this._workIndex = 5;
                break;
            case 'string':
            case 'bool':
                mixFunction = this._select;
                // Use the regular mix function and for additive on these types,
                // additive is not relevant for non-numeric types
                mixFunctionAdditive = this._select;
                setIdentity = this._setAdditiveIdentityOther;
                this.buffer = new Array(valueSize * 5);
                break;
            default:
                mixFunction = this._lerp;
                mixFunctionAdditive = this._lerpAdditive;
                setIdentity = this._setAdditiveIdentityNumeric;
                this.buffer = new Float64Array(valueSize * 5);
        }
        this._mixBufferRegion = mixFunction;
        this._mixBufferRegionAdditive = mixFunctionAdditive;
        this._setIdentity = setIdentity;
        this._origIndex = 3;
        this._addIndex = 4;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        this.useCount = 0;
        this.referenceCount = 0;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(PropertyMixer, [
        {
            // accumulate data in the 'incoming' region into 'accu<i>'
            key: "accumulate",
            value: function accumulate(accuIndex, weight) {
                // note: happily accumulating nothing when weight = 0, the caller knows
                // the weight and shouldn't have made the call in the first place
                var buffer = this.buffer, stride = this.valueSize, offset = accuIndex * stride + stride;
                var currentWeight = this.cumulativeWeight;
                if (currentWeight === 0) {
                    // accuN := incoming * weight
                    for(var i = 0; i !== stride; ++i)buffer[offset + i] = buffer[i];
                    currentWeight = weight;
                } else {
                    // accuN := accuN + incoming * weight
                    currentWeight += weight;
                    var mix = weight / currentWeight;
                    this._mixBufferRegion(buffer, offset, 0, mix, stride);
                }
                this.cumulativeWeight = currentWeight;
            }
        },
        {
            // accumulate data in the 'incoming' region into 'add'
            key: "accumulateAdditive",
            value: function accumulateAdditive(weight) {
                var buffer = this.buffer, stride = this.valueSize, offset = stride * this._addIndex;
                if (this.cumulativeWeightAdditive === 0) // add = identity
                this._setIdentity();
                // add := add + incoming * weight
                this._mixBufferRegionAdditive(buffer, offset, 0, weight, stride);
                this.cumulativeWeightAdditive += weight;
            }
        },
        {
            // apply the state of 'accu<i>' to the binding when accus differ
            key: "apply",
            value: function apply(accuIndex) {
                var stride = this.valueSize, buffer = this.buffer, offset = accuIndex * stride + stride, weight = this.cumulativeWeight, weightAdditive = this.cumulativeWeightAdditive, binding = this.binding;
                this.cumulativeWeight = 0;
                this.cumulativeWeightAdditive = 0;
                if (weight < 1) {
                    // accuN := accuN + original * ( 1 - cumulativeWeight )
                    var originalValueOffset = stride * this._origIndex;
                    this._mixBufferRegion(buffer, offset, originalValueOffset, 1 - weight, stride);
                }
                if (weightAdditive > 0) // accuN := accuN + additive accuN
                this._mixBufferRegionAdditive(buffer, offset, this._addIndex * stride, 1, stride);
                for(var i = stride, e = stride + stride; i !== e; ++i)if (buffer[i] !== buffer[i + stride]) {
                    // value has changed -> update scene graph
                    binding.setValue(buffer, offset);
                    break;
                }
            }
        },
        {
            // remember the state of the bound property and copy it to both accus
            key: "saveOriginalState",
            value: function saveOriginalState() {
                var binding = this.binding;
                var buffer = this.buffer, stride = this.valueSize, originalValueOffset = stride * this._origIndex;
                binding.getValue(buffer, originalValueOffset);
                // accu[0..1] := orig -- initially detect changes against the original
                for(var i = stride, e = originalValueOffset; i !== e; ++i)buffer[i] = buffer[originalValueOffset + i % stride];
                // Add to identity for additive
                this._setIdentity();
                this.cumulativeWeight = 0;
                this.cumulativeWeightAdditive = 0;
            }
        },
        {
            // apply the state previously taken via 'saveOriginalState' to the binding
            key: "restoreOriginalState",
            value: function restoreOriginalState() {
                var originalValueOffset = this.valueSize * 3;
                this.binding.setValue(this.buffer, originalValueOffset);
            }
        },
        {
            key: "_setAdditiveIdentityNumeric",
            value: function _setAdditiveIdentityNumeric() {
                var startIndex = this._addIndex * this.valueSize;
                var endIndex = startIndex + this.valueSize;
                for(var i = startIndex; i < endIndex; i++)this.buffer[i] = 0;
            }
        },
        {
            key: "_setAdditiveIdentityQuaternion",
            value: function _setAdditiveIdentityQuaternion() {
                this._setAdditiveIdentityNumeric();
                this.buffer[this._addIndex * this.valueSize + 3] = 1;
            }
        },
        {
            key: "_setAdditiveIdentityOther",
            value: function _setAdditiveIdentityOther() {
                var startIndex = this._origIndex * this.valueSize;
                var targetIndex = this._addIndex * this.valueSize;
                for(var i = 0; i < this.valueSize; i++)this.buffer[targetIndex + i] = this.buffer[startIndex + i];
            }
        },
        {
            // mix functions
            key: "_select",
            value: function _select(buffer, dstOffset, srcOffset, t, stride) {
                if (t >= 0.5) for(var i = 0; i !== stride; ++i)buffer[dstOffset + i] = buffer[srcOffset + i];
            }
        },
        {
            key: "_slerp",
            value: function _slerp(buffer, dstOffset, srcOffset, t) {
                $c702e238df7c5123$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, srcOffset, t);
            }
        },
        {
            key: "_slerpAdditive",
            value: function _slerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
                var workOffset = this._workIndex * stride;
                // Store result in intermediate buffer offset
                $c702e238df7c5123$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(buffer, workOffset, buffer, dstOffset, buffer, srcOffset);
                // Slerp to the intermediate result
                $c702e238df7c5123$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, workOffset, t);
            }
        },
        {
            key: "_lerp",
            value: function _lerp(buffer, dstOffset, srcOffset, t, stride) {
                var s = 1 - t;
                for(var i = 0; i !== stride; ++i){
                    var j = dstOffset + i;
                    buffer[j] = buffer[j] * s + buffer[srcOffset + i] * t;
                }
            }
        },
        {
            key: "_lerpAdditive",
            value: function _lerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
                for(var i = 0; i !== stride; ++i){
                    var j = dstOffset + i;
                    buffer[j] = buffer[j] + buffer[srcOffset + i] * t;
                }
            }
        }
    ]);
    return PropertyMixer;
}();
// Characters [].:/ are reserved for track binding syntax.
var $c702e238df7c5123$var$_RESERVED_CHARS_RE = '\\[\\]\\.:\\/';
var $c702e238df7c5123$var$_reservedRe = new RegExp('[' + $c702e238df7c5123$var$_RESERVED_CHARS_RE + ']', 'g');
// Attempts to allow node names from any language. ES5's `\w` regexp matches
// only latin characters, and the unicode \p{L} is not yet supported. So
// instead, we exclude reserved characters and match everything else.
var $c702e238df7c5123$var$_wordChar = '[^' + $c702e238df7c5123$var$_RESERVED_CHARS_RE + ']';
var $c702e238df7c5123$var$_wordCharOrDot = '[^' + $c702e238df7c5123$var$_RESERVED_CHARS_RE.replace('\\.', '') + ']';
// Parent directories, delimited by '/' or ':'. Currently unused, but must
// be matched to parse the rest of the track name.
var $c702e238df7c5123$var$_directoryRe = /((?:WC+[\/:])*)/.source.replace('WC', $c702e238df7c5123$var$_wordChar);
// Target node. May contain word characters (a-zA-Z0-9_) and '.' or '-'.
var $c702e238df7c5123$var$_nodeRe = /(WCOD+)?/.source.replace('WCOD', $c702e238df7c5123$var$_wordCharOrDot);
// Object on target node, and accessor. May not contain reserved
// characters. Accessor may contain any character except closing bracket.
var $c702e238df7c5123$var$_objectRe = /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace('WC', $c702e238df7c5123$var$_wordChar);
// Property and accessor. May not contain reserved characters. Accessor may
// contain any non-bracket characters.
var $c702e238df7c5123$var$_propertyRe = /\.(WC+)(?:\[(.+)\])?/.source.replace('WC', $c702e238df7c5123$var$_wordChar);
var $c702e238df7c5123$var$_trackRe = new RegExp("^" + $c702e238df7c5123$var$_directoryRe + $c702e238df7c5123$var$_nodeRe + $c702e238df7c5123$var$_objectRe + $c702e238df7c5123$var$_propertyRe + '$');
var $c702e238df7c5123$var$_supportedObjectNames = [
    'material',
    'materials',
    'bones'
];
var $c702e238df7c5123$var$Composite = /*#__PURE__*/ function() {
    "use strict";
    function Composite(targetGroup, path, optionalParsedPath) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Composite);
        var parsedPath = optionalParsedPath || $c702e238df7c5123$export$7bf70fcf9f891893.parseTrackName(path);
        this._targetGroup = targetGroup;
        this._bindings = targetGroup.subscribe_(path, parsedPath);
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(Composite, [
        {
            key: "getValue",
            value: function getValue(array, offset) {
                this.bind(); // bind all binding
                var firstValidIndex = this._targetGroup.nCachedObjects_, binding = this._bindings[firstValidIndex];
                // and only call .getValue on the first
                if (binding !== undefined) binding.getValue(array, offset);
            }
        },
        {
            key: "setValue",
            value: function setValue(array, offset) {
                var bindings = this._bindings;
                for(var i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].setValue(array, offset);
            }
        },
        {
            key: "bind",
            value: function bind() {
                var bindings = this._bindings;
                for(var i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].bind();
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                var bindings = this._bindings;
                for(var i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].unbind();
            }
        }
    ]);
    return Composite;
}();
// Note: This class uses a State pattern on a per-method basis:
// 'bind' sets 'this.getValue' / 'setValue' and shadows the
// prototype version of these methods with one that represents
// the bound state. When the property is not found, the methods
// become no-ops.
var $c702e238df7c5123$export$7bf70fcf9f891893 = /*#__PURE__*/ function() {
    "use strict";
    function PropertyBinding(rootNode, path, parsedPath) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, PropertyBinding);
        this.path = path;
        this.parsedPath = parsedPath || PropertyBinding.parseTrackName(path);
        this.node = PropertyBinding.findNode(rootNode, this.parsedPath.nodeName) || rootNode;
        this.rootNode = rootNode;
        // initial state of these methods that calls 'bind'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(PropertyBinding, [
        {
            // these are used to "bind" a nonexistent property
            key: "_getValue_unavailable",
            value: function _getValue_unavailable() {}
        },
        {
            key: "_setValue_unavailable",
            value: function _setValue_unavailable() {}
        },
        {
            // Getters
            key: "_getValue_direct",
            value: function _getValue_direct(buffer, offset) {
                buffer[offset] = this.node[this.propertyName];
            }
        },
        {
            key: "_getValue_array",
            value: function _getValue_array(buffer, offset) {
                var source = this.resolvedProperty;
                for(var i = 0, n = source.length; i !== n; ++i)buffer[offset++] = source[i];
            }
        },
        {
            key: "_getValue_arrayElement",
            value: function _getValue_arrayElement(buffer, offset) {
                buffer[offset] = this.resolvedProperty[this.propertyIndex];
            }
        },
        {
            key: "_getValue_toArray",
            value: function _getValue_toArray(buffer, offset) {
                this.resolvedProperty.toArray(buffer, offset);
            }
        },
        {
            // Direct
            key: "_setValue_direct",
            value: function _setValue_direct(buffer, offset) {
                this.targetObject[this.propertyName] = buffer[offset];
            }
        },
        {
            key: "_setValue_direct_setNeedsUpdate",
            value: function _setValue_direct_setNeedsUpdate(buffer, offset) {
                this.targetObject[this.propertyName] = buffer[offset];
                this.targetObject.needsUpdate = true;
            }
        },
        {
            key: "_setValue_direct_setMatrixWorldNeedsUpdate",
            value: function _setValue_direct_setMatrixWorldNeedsUpdate(buffer, offset) {
                this.targetObject[this.propertyName] = buffer[offset];
                this.targetObject.matrixWorldNeedsUpdate = true;
            }
        },
        {
            // EntireArray
            key: "_setValue_array",
            value: function _setValue_array(buffer, offset) {
                var dest = this.resolvedProperty;
                for(var i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
            }
        },
        {
            key: "_setValue_array_setNeedsUpdate",
            value: function _setValue_array_setNeedsUpdate(buffer, offset) {
                var dest = this.resolvedProperty;
                for(var i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
                this.targetObject.needsUpdate = true;
            }
        },
        {
            key: "_setValue_array_setMatrixWorldNeedsUpdate",
            value: function _setValue_array_setMatrixWorldNeedsUpdate(buffer, offset) {
                var dest = this.resolvedProperty;
                for(var i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
                this.targetObject.matrixWorldNeedsUpdate = true;
            }
        },
        {
            // ArrayElement
            key: "_setValue_arrayElement",
            value: function _setValue_arrayElement(buffer, offset) {
                this.resolvedProperty[this.propertyIndex] = buffer[offset];
            }
        },
        {
            key: "_setValue_arrayElement_setNeedsUpdate",
            value: function _setValue_arrayElement_setNeedsUpdate(buffer, offset) {
                this.resolvedProperty[this.propertyIndex] = buffer[offset];
                this.targetObject.needsUpdate = true;
            }
        },
        {
            key: "_setValue_arrayElement_setMatrixWorldNeedsUpdate",
            value: function _setValue_arrayElement_setMatrixWorldNeedsUpdate(buffer, offset) {
                this.resolvedProperty[this.propertyIndex] = buffer[offset];
                this.targetObject.matrixWorldNeedsUpdate = true;
            }
        },
        {
            // HasToFromArray
            key: "_setValue_fromArray",
            value: function _setValue_fromArray(buffer, offset) {
                this.resolvedProperty.fromArray(buffer, offset);
            }
        },
        {
            key: "_setValue_fromArray_setNeedsUpdate",
            value: function _setValue_fromArray_setNeedsUpdate(buffer, offset) {
                this.resolvedProperty.fromArray(buffer, offset);
                this.targetObject.needsUpdate = true;
            }
        },
        {
            key: "_setValue_fromArray_setMatrixWorldNeedsUpdate",
            value: function _setValue_fromArray_setMatrixWorldNeedsUpdate(buffer, offset) {
                this.resolvedProperty.fromArray(buffer, offset);
                this.targetObject.matrixWorldNeedsUpdate = true;
            }
        },
        {
            key: "_getValue_unbound",
            value: function _getValue_unbound(targetArray, offset) {
                this.bind();
                this.getValue(targetArray, offset);
            }
        },
        {
            key: "_setValue_unbound",
            value: function _setValue_unbound(sourceArray, offset) {
                this.bind();
                this.setValue(sourceArray, offset);
            }
        },
        {
            // create getter / setter pair for a property in the scene graph
            key: "bind",
            value: function bind() {
                var targetObject = this.node;
                var parsedPath = this.parsedPath;
                var objectName = parsedPath.objectName;
                var propertyName = parsedPath.propertyName;
                var propertyIndex = parsedPath.propertyIndex;
                if (!targetObject) {
                    targetObject = PropertyBinding.findNode(this.rootNode, parsedPath.nodeName) || this.rootNode;
                    this.node = targetObject;
                }
                // set fail state so we can just 'return' on error
                this.getValue = this._getValue_unavailable;
                this.setValue = this._setValue_unavailable;
                // ensure there is a value node
                if (!targetObject) {
                    console.error('THREE.PropertyBinding: Trying to update node for track: ' + this.path + ' but it wasn\'t found.');
                    return;
                }
                if (objectName) {
                    var objectIndex = parsedPath.objectIndex;
                    // special cases were we need to reach deeper into the hierarchy to get the face materials....
                    switch(objectName){
                        case 'materials':
                            if (!targetObject.material) {
                                console.error('THREE.PropertyBinding: Can not bind to material as node does not have a material.', this);
                                return;
                            }
                            if (!targetObject.material.materials) {
                                console.error('THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.', this);
                                return;
                            }
                            targetObject = targetObject.material.materials;
                            break;
                        case 'bones':
                            if (!targetObject.skeleton) {
                                console.error('THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.', this);
                                return;
                            }
                            // potential future optimization: skip this if propertyIndex is already an integer
                            // and convert the integer string to a true integer.
                            targetObject = targetObject.skeleton.bones;
                            // support resolving morphTarget names into indices.
                            for(var i = 0; i < targetObject.length; i++)if (targetObject[i].name === objectIndex) {
                                objectIndex = i;
                                break;
                            }
                            break;
                        default:
                            if (targetObject[objectName] === undefined) {
                                console.error('THREE.PropertyBinding: Can not bind to objectName of node undefined.', this);
                                return;
                            }
                            targetObject = targetObject[objectName];
                    }
                    if (objectIndex !== undefined) {
                        if (targetObject[objectIndex] === undefined) {
                            console.error('THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.', this, targetObject);
                            return;
                        }
                        targetObject = targetObject[objectIndex];
                    }
                }
                // resolve property
                var nodeProperty = targetObject[propertyName];
                if (nodeProperty === undefined) {
                    var nodeName = parsedPath.nodeName;
                    console.error('THREE.PropertyBinding: Trying to update property for track: ' + nodeName + '.' + propertyName + ' but it wasn\'t found.', targetObject);
                    return;
                }
                // determine versioning scheme
                var versioning = this.Versioning.None;
                this.targetObject = targetObject;
                if (targetObject.needsUpdate !== undefined) versioning = this.Versioning.NeedsUpdate;
                else if (targetObject.matrixWorldNeedsUpdate !== undefined) versioning = this.Versioning.MatrixWorldNeedsUpdate;
                // determine how the property gets bound
                var bindingType = this.BindingType.Direct;
                if (propertyIndex !== undefined) {
                    // access a sub element of the property array (only primitives are supported right now)
                    if (propertyName === 'morphTargetInfluences') {
                        // potential optimization, skip this if propertyIndex is already an integer, and convert the integer string to a true integer.
                        // support resolving morphTarget names into indices.
                        if (!targetObject.geometry) {
                            console.error('THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.', this);
                            return;
                        }
                        if (targetObject.geometry.isBufferGeometry) {
                            if (!targetObject.geometry.morphAttributes) {
                                console.error('THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.', this);
                                return;
                            }
                            if (targetObject.morphTargetDictionary[propertyIndex] !== undefined) propertyIndex = targetObject.morphTargetDictionary[propertyIndex];
                        } else {
                            console.error('THREE.PropertyBinding: Can not bind to morphTargetInfluences on THREE.Geometry. Use THREE.BufferGeometry instead.', this);
                            return;
                        }
                    }
                    bindingType = this.BindingType.ArrayElement;
                    this.resolvedProperty = nodeProperty;
                    this.propertyIndex = propertyIndex;
                } else if (nodeProperty.fromArray !== undefined && nodeProperty.toArray !== undefined) {
                    // must use copy for Object3D.Euler/Quaternion
                    bindingType = this.BindingType.HasFromToArray;
                    this.resolvedProperty = nodeProperty;
                } else if (Array.isArray(nodeProperty)) {
                    bindingType = this.BindingType.EntireArray;
                    this.resolvedProperty = nodeProperty;
                } else this.propertyName = propertyName;
                // select getter / setter
                this.getValue = this.GetterByBindingType[bindingType];
                this.setValue = this.SetterByBindingTypeAndVersioning[bindingType][versioning];
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                this.node = null;
                // back to the prototype version of getValue / setValue
                // note: avoiding to mutate the shape of 'this' via 'delete'
                this.getValue = this._getValue_unbound;
                this.setValue = this._setValue_unbound;
            }
        }
    ], [
        {
            key: "create",
            value: function create(root, path, parsedPath) {
                if (!(root && root.isAnimationObjectGroup)) return new PropertyBinding(root, path, parsedPath);
                else return new PropertyBinding.Composite(root, path, parsedPath);
            }
        },
        {
            key: "sanitizeNodeName",
            value: /**
	 * Replaces spaces with underscores and removes unsupported characters from
	 * node names, to ensure compatibility with parseTrackName().
	 *
	 * @param {string} name Node name to be sanitized.
	 * @return {string}
	 */ function sanitizeNodeName(name) {
                return name.replace(/\s/g, '_').replace($c702e238df7c5123$var$_reservedRe, '');
            }
        },
        {
            key: "parseTrackName",
            value: function parseTrackName(trackName) {
                var matches = $c702e238df7c5123$var$_trackRe.exec(trackName);
                if (!matches) throw new Error('PropertyBinding: Cannot parse trackName: ' + trackName);
                var results = {
                    // directoryName: matches[ 1 ], // (tschw) currently unused
                    nodeName: matches[2],
                    objectName: matches[3],
                    objectIndex: matches[4],
                    propertyName: matches[5],
                    propertyIndex: matches[6]
                };
                var lastDot = results.nodeName && results.nodeName.lastIndexOf('.');
                if (lastDot !== undefined && lastDot !== -1) {
                    var objectName = results.nodeName.substring(lastDot + 1);
                    // Object names must be checked against an allowlist. Otherwise, there
                    // is no way to parse 'foo.bar.baz': 'baz' must be a property, but
                    // 'bar' could be the objectName, or part of a nodeName (which can
                    // include '.' characters).
                    if ($c702e238df7c5123$var$_supportedObjectNames.indexOf(objectName) !== -1) {
                        results.nodeName = results.nodeName.substring(0, lastDot);
                        results.objectName = objectName;
                    }
                }
                if (results.propertyName === null || results.propertyName.length === 0) throw new Error('PropertyBinding: can not parse propertyName from trackName: ' + trackName);
                return results;
            }
        },
        {
            key: "findNode",
            value: function findNode(root, nodeName) {
                if (!nodeName || nodeName === '' || nodeName === '.' || nodeName === -1 || nodeName === root.name || nodeName === root.uuid) return root;
                // search into skeleton bones.
                if (root.skeleton) {
                    var bone = root.skeleton.getBoneByName(nodeName);
                    if (bone !== undefined) return bone;
                }
                // search into node subtree.
                if (root.children) {
                    var searchNodeSubtree = function searchNodeSubtree1(children) {
                        for(var i = 0; i < children.length; i++){
                            var childNode = children[i];
                            if (childNode.name === nodeName || childNode.uuid === nodeName) return childNode;
                            var result = searchNodeSubtree(childNode.children);
                            if (result) return result;
                        }
                        return null;
                    };
                    var subTreeNode = searchNodeSubtree(root.children);
                    if (subTreeNode) return subTreeNode;
                }
                return null;
            }
        }
    ]);
    return PropertyBinding;
}();
$c702e238df7c5123$export$7bf70fcf9f891893.Composite = $c702e238df7c5123$var$Composite;
$c702e238df7c5123$export$7bf70fcf9f891893.prototype.BindingType = {
    Direct: 0,
    EntireArray: 1,
    ArrayElement: 2,
    HasFromToArray: 3
};
$c702e238df7c5123$export$7bf70fcf9f891893.prototype.Versioning = {
    None: 0,
    NeedsUpdate: 1,
    MatrixWorldNeedsUpdate: 2
};
$c702e238df7c5123$export$7bf70fcf9f891893.prototype.GetterByBindingType = [
    $c702e238df7c5123$export$7bf70fcf9f891893.prototype._getValue_direct,
    $c702e238df7c5123$export$7bf70fcf9f891893.prototype._getValue_array,
    $c702e238df7c5123$export$7bf70fcf9f891893.prototype._getValue_arrayElement,
    $c702e238df7c5123$export$7bf70fcf9f891893.prototype._getValue_toArray
];
$c702e238df7c5123$export$7bf70fcf9f891893.prototype.SetterByBindingTypeAndVersioning = [
    [
        // Direct
        $c702e238df7c5123$export$7bf70fcf9f891893.prototype._setValue_direct,
        $c702e238df7c5123$export$7bf70fcf9f891893.prototype._setValue_direct_setNeedsUpdate,
        $c702e238df7c5123$export$7bf70fcf9f891893.prototype._setValue_direct_setMatrixWorldNeedsUpdate
    ],
    [
        // EntireArray
        $c702e238df7c5123$export$7bf70fcf9f891893.prototype._setValue_array,
        $c702e238df7c5123$export$7bf70fcf9f891893.prototype._setValue_array_setNeedsUpdate,
        $c702e238df7c5123$export$7bf70fcf9f891893.prototype._setValue_array_setMatrixWorldNeedsUpdate
    ],
    [
        // ArrayElement
        $c702e238df7c5123$export$7bf70fcf9f891893.prototype._setValue_arrayElement,
        $c702e238df7c5123$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setNeedsUpdate,
        $c702e238df7c5123$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
    ],
    [
        // HasToFromArray
        $c702e238df7c5123$export$7bf70fcf9f891893.prototype._setValue_fromArray,
        $c702e238df7c5123$export$7bf70fcf9f891893.prototype._setValue_fromArray_setNeedsUpdate,
        $c702e238df7c5123$export$7bf70fcf9f891893.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
    ]
];
/**
 *
 * A group of objects that receives a shared animation state.
 *
 * Usage:
 *
 *  - Add objects you would otherwise pass as 'root' to the
 *    constructor or the .clipAction method of AnimationMixer.
 *
 *  - Instead pass this object as 'root'.
 *
 *  - You can also add and remove objects later when the mixer
 *    is running.
 *
 * Note:
 *
 *    Objects of this class appear as one object to the mixer,
 *    so cache control of the individual objects must be done
 *    on the group.
 *
 * Limitation:
 *
 *  - The animated properties must be compatible among the
 *    all objects in the group.
 *
 *  - A single property can either be controlled through a
 *    target group or directly, but not both.
 */ var $c702e238df7c5123$export$30619c2afd3f34db = /*#__PURE__*/ function() {
    "use strict";
    function AnimationObjectGroup() {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, AnimationObjectGroup);
        this.uuid = $c702e238df7c5123$var$generateUUID();
        // cached objects followed by the active ones
        this._objects = Array.prototype.slice.call(arguments);
        this.nCachedObjects_ = 0; // threshold
        // note: read by PropertyBinding.Composite
        var indices = {};
        this._indicesByUUID = indices; // for bookkeeping
        for(var i = 0, n = arguments.length; i !== n; ++i)indices[arguments[i].uuid] = i;
        this._paths = []; // inside: string
        this._parsedPaths = []; // inside: { we don't care, here }
        this._bindings = []; // inside: Array< PropertyBinding >
        this._bindingsIndicesByPath = {}; // inside: indices in these arrays
        var scope = this;
        this.stats = {
            objects: {
                get total () {
                    return scope._objects.length;
                },
                get inUse () {
                    return this.total - scope.nCachedObjects_;
                }
            },
            get bindingsPerObject () {
                return scope._bindings.length;
            }
        };
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(AnimationObjectGroup, [
        {
            key: "add",
            value: function add() {
                var objects = this._objects, indicesByUUID = this._indicesByUUID, paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, nBindings = bindings.length;
                var knownObject = undefined, nObjects = objects.length, nCachedObjects = this.nCachedObjects_;
                for(var i = 0, n = arguments.length; i !== n; ++i){
                    var object = arguments[i], uuid = object.uuid;
                    var index = indicesByUUID[uuid];
                    if (index === undefined) {
                        // unknown object -> add it to the ACTIVE region
                        index = nObjects++;
                        indicesByUUID[uuid] = index;
                        objects.push(object);
                        // accounting is done, now do the same for all bindings
                        for(var j = 0, m = nBindings; j !== m; ++j)bindings[j].push(new $c702e238df7c5123$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]));
                    } else if (index < nCachedObjects) {
                        knownObject = objects[index];
                        // move existing object to the ACTIVE region
                        var firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex];
                        indicesByUUID[lastCachedObject.uuid] = index;
                        objects[index] = lastCachedObject;
                        indicesByUUID[uuid] = firstActiveIndex;
                        objects[firstActiveIndex] = object;
                        // accounting is done, now do the same for all bindings
                        for(var j1 = 0, m1 = nBindings; j1 !== m1; ++j1){
                            var bindingsForPath = bindings[j1], lastCached = bindingsForPath[firstActiveIndex];
                            var binding = bindingsForPath[index];
                            bindingsForPath[index] = lastCached;
                            if (binding === undefined) // since we do not bother to create new bindings
                            // for objects that are cached, the binding may
                            // or may not exist
                            binding = new $c702e238df7c5123$export$7bf70fcf9f891893(object, paths[j1], parsedPaths[j1]);
                            bindingsForPath[firstActiveIndex] = binding;
                        }
                    } else if (objects[index] !== knownObject) console.error("THREE.AnimationObjectGroup: Different objects with the same UUID detected. Clean the caches or recreate your infrastructure when reloading scenes.");
                     // else the object is already where we want it to be
                } // for arguments
                this.nCachedObjects_ = nCachedObjects;
            }
        },
        {
            key: "remove",
            value: function remove() {
                var objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
                var nCachedObjects = this.nCachedObjects_;
                for(var i = 0, n = arguments.length; i !== n; ++i){
                    var object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
                    if (index !== undefined && index >= nCachedObjects) {
                        // move existing object into the CACHED region
                        var lastCachedIndex = nCachedObjects++, firstActiveObject = objects[lastCachedIndex];
                        indicesByUUID[firstActiveObject.uuid] = index;
                        objects[index] = firstActiveObject;
                        indicesByUUID[uuid] = lastCachedIndex;
                        objects[lastCachedIndex] = object;
                        // accounting is done, now do the same for all bindings
                        for(var j = 0, m = nBindings; j !== m; ++j){
                            var bindingsForPath = bindings[j], firstActive = bindingsForPath[lastCachedIndex], binding = bindingsForPath[index];
                            bindingsForPath[index] = firstActive;
                            bindingsForPath[lastCachedIndex] = binding;
                        }
                    }
                } // for arguments
                this.nCachedObjects_ = nCachedObjects;
            }
        },
        {
            // remove & forget
            key: "uncache",
            value: function uncache() {
                var objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
                var nCachedObjects = this.nCachedObjects_, nObjects = objects.length;
                for(var i = 0, n = arguments.length; i !== n; ++i){
                    var object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
                    if (index !== undefined) {
                        delete indicesByUUID[uuid];
                        if (index < nCachedObjects) {
                            // object is cached, shrink the CACHED region
                            var firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex], lastIndex = --nObjects, lastObject = objects[lastIndex];
                            // last cached object takes this object's place
                            indicesByUUID[lastCachedObject.uuid] = index;
                            objects[index] = lastCachedObject;
                            // last object goes to the activated slot and pop
                            indicesByUUID[lastObject.uuid] = firstActiveIndex;
                            objects[firstActiveIndex] = lastObject;
                            objects.pop();
                            // accounting is done, now do the same for all bindings
                            for(var j = 0, m = nBindings; j !== m; ++j){
                                var bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex], last = bindingsForPath[lastIndex];
                                bindingsForPath[index] = lastCached;
                                bindingsForPath[firstActiveIndex] = last;
                                bindingsForPath.pop();
                            }
                        } else {
                            // object is active, just swap with the last and pop
                            var lastIndex1 = --nObjects, lastObject1 = objects[lastIndex1];
                            if (lastIndex1 > 0) indicesByUUID[lastObject1.uuid] = index;
                            objects[index] = lastObject1;
                            objects.pop();
                            // accounting is done, now do the same for all bindings
                            for(var j1 = 0, m1 = nBindings; j1 !== m1; ++j1){
                                var bindingsForPath1 = bindings[j1];
                                bindingsForPath1[index] = bindingsForPath1[lastIndex1];
                                bindingsForPath1.pop();
                            }
                        } // cached or active
                    } // if object is known
                } // for arguments
                this.nCachedObjects_ = nCachedObjects;
            }
        },
        {
            // Internal interface used by befriended PropertyBinding.Composite:
            key: "subscribe_",
            value: function subscribe_(path, parsedPath) {
                // returns an array of bindings for the given path that is changed
                // according to the contained objects in the group
                var indicesByPath = this._bindingsIndicesByPath;
                var index = indicesByPath[path];
                var bindings = this._bindings;
                if (index !== undefined) return bindings[index];
                var paths = this._paths, parsedPaths = this._parsedPaths, objects = this._objects, nObjects = objects.length, nCachedObjects = this.nCachedObjects_, bindingsForPath = new Array(nObjects);
                index = bindings.length;
                indicesByPath[path] = index;
                paths.push(path);
                parsedPaths.push(parsedPath);
                bindings.push(bindingsForPath);
                for(var i = nCachedObjects, n = objects.length; i !== n; ++i){
                    var object = objects[i];
                    bindingsForPath[i] = new $c702e238df7c5123$export$7bf70fcf9f891893(object, path, parsedPath);
                }
                return bindingsForPath;
            }
        },
        {
            key: "unsubscribe_",
            value: function unsubscribe_(path) {
                // tells the group to forget about a property path and no longer
                // update the array previously obtained with 'subscribe_'
                var indicesByPath = this._bindingsIndicesByPath, index = indicesByPath[path];
                if (index !== undefined) {
                    var paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, lastBindingsIndex = bindings.length - 1, lastBindings = bindings[lastBindingsIndex], lastBindingsPath = path[lastBindingsIndex];
                    indicesByPath[lastBindingsPath] = index;
                    bindings[index] = lastBindings;
                    bindings.pop();
                    parsedPaths[index] = parsedPaths[lastBindingsIndex];
                    parsedPaths.pop();
                    paths[index] = paths[lastBindingsIndex];
                    paths.pop();
                }
            }
        }
    ]);
    return AnimationObjectGroup;
}();
$c702e238df7c5123$export$30619c2afd3f34db.prototype.isAnimationObjectGroup = true;
var $c702e238df7c5123$var$AnimationAction = /*#__PURE__*/ function() {
    "use strict";
    function AnimationAction(mixer, clip) {
        var localRoot = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, blendMode = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : clip.blendMode;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, AnimationAction);
        this._mixer = mixer;
        this._clip = clip;
        this._localRoot = localRoot;
        this.blendMode = blendMode;
        var tracks = clip.tracks, nTracks = tracks.length, interpolants = new Array(nTracks);
        var interpolantSettings = {
            endingStart: $c702e238df7c5123$export$7f795934b84ab523,
            endingEnd: $c702e238df7c5123$export$7f795934b84ab523
        };
        for(var i = 0; i !== nTracks; ++i){
            var interpolant = tracks[i].createInterpolant(null);
            interpolants[i] = interpolant;
            interpolant.settings = interpolantSettings;
        }
        this._interpolantSettings = interpolantSettings;
        this._interpolants = interpolants; // bound by the mixer
        // inside: PropertyMixer (managed by the mixer)
        this._propertyBindings = new Array(nTracks);
        this._cacheIndex = null; // for the memory manager
        this._byClipCacheIndex = null; // for the memory manager
        this._timeScaleInterpolant = null;
        this._weightInterpolant = null;
        this.loop = $c702e238df7c5123$export$dfaf4422ce096e29;
        this._loopCount = -1;
        // global mixer time when the action is to be started
        // it's set back to 'null' upon start of the action
        this._startTime = null;
        // scaled local time of the action
        // gets clamped or wrapped to 0..clip.duration according to loop
        this.time = 0;
        this.timeScale = 1;
        this._effectiveTimeScale = 1;
        this.weight = 1;
        this._effectiveWeight = 1;
        this.repetitions = Infinity; // no. of repetitions when looping
        this.paused = false; // true -> zero effective time scale
        this.enabled = true; // false -> zero effective weight
        this.clampWhenFinished = false; // keep feeding the last frame?
        this.zeroSlopeAtStart = true; // for smooth interpolation w/o separate
        this.zeroSlopeAtEnd = true; // clips for start, loop and end
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(AnimationAction, [
        {
            // State & Scheduling
            key: "play",
            value: function play() {
                this._mixer._activateAction(this);
                return this;
            }
        },
        {
            key: "stop",
            value: function stop() {
                this._mixer._deactivateAction(this);
                return this.reset();
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.paused = false;
                this.enabled = true;
                this.time = 0; // restart clip
                this._loopCount = -1; // forget previous loops
                this._startTime = null; // forget scheduling
                return this.stopFading().stopWarping();
            }
        },
        {
            key: "isRunning",
            value: function isRunning() {
                return this.enabled && !this.paused && this.timeScale !== 0 && this._startTime === null && this._mixer._isActiveAction(this);
            }
        },
        {
            // return true when play has been called
            key: "isScheduled",
            value: function isScheduled() {
                return this._mixer._isActiveAction(this);
            }
        },
        {
            key: "startAt",
            value: function startAt(time) {
                this._startTime = time;
                return this;
            }
        },
        {
            key: "setLoop",
            value: function setLoop(mode, repetitions) {
                this.loop = mode;
                this.repetitions = repetitions;
                return this;
            }
        },
        {
            // Weight
            // set the weight stopping any scheduled fading
            // although .enabled = false yields an effective weight of zero, this
            // method does *not* change .enabled, because it would be confusing
            key: "setEffectiveWeight",
            value: function setEffectiveWeight(weight) {
                this.weight = weight;
                // note: same logic as when updated at runtime
                this._effectiveWeight = this.enabled ? weight : 0;
                return this.stopFading();
            }
        },
        {
            // return the weight considering fading and .enabled
            key: "getEffectiveWeight",
            value: function getEffectiveWeight() {
                return this._effectiveWeight;
            }
        },
        {
            key: "fadeIn",
            value: function fadeIn(duration) {
                return this._scheduleFading(duration, 0, 1);
            }
        },
        {
            key: "fadeOut",
            value: function fadeOut(duration) {
                return this._scheduleFading(duration, 1, 0);
            }
        },
        {
            key: "crossFadeFrom",
            value: function crossFadeFrom(fadeOutAction, duration, warp) {
                fadeOutAction.fadeOut(duration);
                this.fadeIn(duration);
                if (warp) {
                    var fadeInDuration = this._clip.duration, fadeOutDuration = fadeOutAction._clip.duration, startEndRatio = fadeOutDuration / fadeInDuration, endStartRatio = fadeInDuration / fadeOutDuration;
                    fadeOutAction.warp(1.0, startEndRatio, duration);
                    this.warp(endStartRatio, 1.0, duration);
                }
                return this;
            }
        },
        {
            key: "crossFadeTo",
            value: function crossFadeTo(fadeInAction, duration, warp) {
                return fadeInAction.crossFadeFrom(this, duration, warp);
            }
        },
        {
            key: "stopFading",
            value: function stopFading() {
                var weightInterpolant = this._weightInterpolant;
                if (weightInterpolant !== null) {
                    this._weightInterpolant = null;
                    this._mixer._takeBackControlInterpolant(weightInterpolant);
                }
                return this;
            }
        },
        {
            // Time Scale Control
            // set the time scale stopping any scheduled warping
            // although .paused = true yields an effective time scale of zero, this
            // method does *not* change .paused, because it would be confusing
            key: "setEffectiveTimeScale",
            value: function setEffectiveTimeScale(timeScale) {
                this.timeScale = timeScale;
                this._effectiveTimeScale = this.paused ? 0 : timeScale;
                return this.stopWarping();
            }
        },
        {
            // return the time scale considering warping and .paused
            key: "getEffectiveTimeScale",
            value: function getEffectiveTimeScale() {
                return this._effectiveTimeScale;
            }
        },
        {
            key: "setDuration",
            value: function setDuration(duration) {
                this.timeScale = this._clip.duration / duration;
                return this.stopWarping();
            }
        },
        {
            key: "syncWith",
            value: function syncWith(action) {
                this.time = action.time;
                this.timeScale = action.timeScale;
                return this.stopWarping();
            }
        },
        {
            key: "halt",
            value: function halt(duration) {
                return this.warp(this._effectiveTimeScale, 0, duration);
            }
        },
        {
            key: "warp",
            value: function warp(startTimeScale, endTimeScale, duration) {
                var mixer = this._mixer, now = mixer.time, timeScale = this.timeScale;
                var interpolant = this._timeScaleInterpolant;
                if (interpolant === null) {
                    interpolant = mixer._lendControlInterpolant();
                    this._timeScaleInterpolant = interpolant;
                }
                var times = interpolant.parameterPositions, values = interpolant.sampleValues;
                times[0] = now;
                times[1] = now + duration;
                values[0] = startTimeScale / timeScale;
                values[1] = endTimeScale / timeScale;
                return this;
            }
        },
        {
            key: "stopWarping",
            value: function stopWarping() {
                var timeScaleInterpolant = this._timeScaleInterpolant;
                if (timeScaleInterpolant !== null) {
                    this._timeScaleInterpolant = null;
                    this._mixer._takeBackControlInterpolant(timeScaleInterpolant);
                }
                return this;
            }
        },
        {
            // Object Accessors
            key: "getMixer",
            value: function getMixer() {
                return this._mixer;
            }
        },
        {
            key: "getClip",
            value: function getClip() {
                return this._clip;
            }
        },
        {
            key: "getRoot",
            value: function getRoot() {
                return this._localRoot || this._mixer._root;
            }
        },
        {
            // Interna
            key: "_update",
            value: function _update(time, deltaTime, timeDirection, accuIndex) {
                // called by the mixer
                if (!this.enabled) {
                    // call ._updateWeight() to update ._effectiveWeight
                    this._updateWeight(time);
                    return;
                }
                var startTime = this._startTime;
                if (startTime !== null) {
                    // check for scheduled start of action
                    var timeRunning = (time - startTime) * timeDirection;
                    if (timeRunning < 0 || timeDirection === 0) return; // yet to come / don't decide when delta = 0
                    // start
                    this._startTime = null; // unschedule
                    deltaTime = timeDirection * timeRunning;
                }
                // apply time scale and advance time
                deltaTime *= this._updateTimeScale(time);
                var clipTime = this._updateTime(deltaTime);
                // note: _updateTime may disable the action resulting in
                // an effective weight of 0
                var weight = this._updateWeight(time);
                if (weight > 0) {
                    var interpolants = this._interpolants;
                    var propertyMixers = this._propertyBindings;
                    switch(this.blendMode){
                        case $c702e238df7c5123$export$d875e029ef558d3:
                            for(var j = 0, m = interpolants.length; j !== m; ++j){
                                interpolants[j].evaluate(clipTime);
                                propertyMixers[j].accumulateAdditive(weight);
                            }
                            break;
                        case $c702e238df7c5123$export$bcfbbdcf8de7f8cd:
                        default:
                            for(var j1 = 0, m1 = interpolants.length; j1 !== m1; ++j1){
                                interpolants[j1].evaluate(clipTime);
                                propertyMixers[j1].accumulate(accuIndex, weight);
                            }
                    }
                }
            }
        },
        {
            key: "_updateWeight",
            value: function _updateWeight(time) {
                var weight = 0;
                if (this.enabled) {
                    weight = this.weight;
                    var interpolant = this._weightInterpolant;
                    if (interpolant !== null) {
                        var interpolantValue = interpolant.evaluate(time)[0];
                        weight *= interpolantValue;
                        if (time > interpolant.parameterPositions[1]) {
                            this.stopFading();
                            if (interpolantValue === 0) // faded out, disable
                            this.enabled = false;
                        }
                    }
                }
                this._effectiveWeight = weight;
                return weight;
            }
        },
        {
            key: "_updateTimeScale",
            value: function _updateTimeScale(time) {
                var timeScale = 0;
                if (!this.paused) {
                    timeScale = this.timeScale;
                    var interpolant = this._timeScaleInterpolant;
                    if (interpolant !== null) {
                        var interpolantValue = interpolant.evaluate(time)[0];
                        timeScale *= interpolantValue;
                        if (time > interpolant.parameterPositions[1]) {
                            this.stopWarping();
                            if (timeScale === 0) // motion has halted, pause
                            this.paused = true;
                            else // warp done - apply final time scale
                            this.timeScale = timeScale;
                        }
                    }
                }
                this._effectiveTimeScale = timeScale;
                return timeScale;
            }
        },
        {
            key: "_updateTime",
            value: function _updateTime(deltaTime) {
                var duration = this._clip.duration;
                var loop = this.loop;
                var time = this.time + deltaTime;
                var loopCount = this._loopCount;
                var pingPong = loop === $c702e238df7c5123$export$f8f6f2041b78e210;
                if (deltaTime === 0) {
                    if (loopCount === -1) return time;
                    return pingPong && (loopCount & 1) === 1 ? duration - time : time;
                }
                if (loop === $c702e238df7c5123$export$d62fdc9d1b1cccad) {
                    if (loopCount === -1) {
                        // just started
                        this._loopCount = 0;
                        this._setEndings(true, true, false);
                    }
                    handle_stop: {
                        if (time >= duration) time = duration;
                        else if (time < 0) time = 0;
                        else {
                            this.time = time;
                            break handle_stop;
                        }
                        if (this.clampWhenFinished) this.paused = true;
                        else this.enabled = false;
                        this.time = time;
                        this._mixer.dispatchEvent({
                            type: 'finished',
                            action: this,
                            direction: deltaTime < 0 ? -1 : 1
                        });
                    }
                } else {
                    if (loopCount === -1) {
                        // just started
                        if (deltaTime >= 0) {
                            loopCount = 0;
                            this._setEndings(true, this.repetitions === 0, pingPong);
                        } else // when looping in reverse direction, the initial
                        // transition through zero counts as a repetition,
                        // so leave loopCount at -1
                        this._setEndings(this.repetitions === 0, true, pingPong);
                    }
                    if (time >= duration || time < 0) {
                        // wrap around
                        var loopDelta = Math.floor(time / duration); // signed
                        time -= duration * loopDelta;
                        loopCount += Math.abs(loopDelta);
                        var pending = this.repetitions - loopCount;
                        if (pending <= 0) {
                            // have to stop (switch state, clamp time, fire event)
                            if (this.clampWhenFinished) this.paused = true;
                            else this.enabled = false;
                            time = deltaTime > 0 ? duration : 0;
                            this.time = time;
                            this._mixer.dispatchEvent({
                                type: 'finished',
                                action: this,
                                direction: deltaTime > 0 ? 1 : -1
                            });
                        } else {
                            // keep running
                            if (pending === 1) {
                                // entering the last round
                                var atStart = deltaTime < 0;
                                this._setEndings(atStart, !atStart, pingPong);
                            } else this._setEndings(false, false, pingPong);
                            this._loopCount = loopCount;
                            this.time = time;
                            this._mixer.dispatchEvent({
                                type: 'loop',
                                action: this,
                                loopDelta: loopDelta
                            });
                        }
                    } else this.time = time;
                    if (pingPong && (loopCount & 1) === 1) // invert time for the "pong round"
                    return duration - time;
                }
                return time;
            }
        },
        {
            key: "_setEndings",
            value: function _setEndings(atStart, atEnd, pingPong) {
                var settings = this._interpolantSettings;
                if (pingPong) {
                    settings.endingStart = $c702e238df7c5123$export$24a4ccb5099273b5;
                    settings.endingEnd = $c702e238df7c5123$export$24a4ccb5099273b5;
                } else {
                    // assuming for LoopOnce atStart == atEnd == true
                    if (atStart) settings.endingStart = this.zeroSlopeAtStart ? $c702e238df7c5123$export$24a4ccb5099273b5 : $c702e238df7c5123$export$7f795934b84ab523;
                    else settings.endingStart = $c702e238df7c5123$export$8e8c3ecdcd8e1fee;
                    if (atEnd) settings.endingEnd = this.zeroSlopeAtEnd ? $c702e238df7c5123$export$24a4ccb5099273b5 : $c702e238df7c5123$export$7f795934b84ab523;
                    else settings.endingEnd = $c702e238df7c5123$export$8e8c3ecdcd8e1fee;
                }
            }
        },
        {
            key: "_scheduleFading",
            value: function _scheduleFading(duration, weightNow, weightThen) {
                var mixer = this._mixer, now = mixer.time;
                var interpolant = this._weightInterpolant;
                if (interpolant === null) {
                    interpolant = mixer._lendControlInterpolant();
                    this._weightInterpolant = interpolant;
                }
                var times = interpolant.parameterPositions, values = interpolant.sampleValues;
                times[0] = now;
                values[0] = weightNow;
                times[1] = now + duration;
                values[1] = weightThen;
                return this;
            }
        }
    ]);
    return AnimationAction;
}();
var $c702e238df7c5123$export$fbd77e5aefaa0102 = /*#__PURE__*/ function(EventDispatcher) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(AnimationMixer, EventDispatcher);
    function AnimationMixer(root) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, AnimationMixer);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, AnimationMixer);
        _this._root = root;
        _this._initMemoryManager();
        _this._accuIndex = 0;
        _this.time = 0;
        _this.timeScale = 1.0;
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(AnimationMixer, [
        {
            key: "_bindAction",
            value: function _bindAction(action, prototypeAction) {
                var root = action._localRoot || this._root, tracks = action._clip.tracks, nTracks = tracks.length, bindings = action._propertyBindings, interpolants = action._interpolants, rootUuid = root.uuid, bindingsByRoot = this._bindingsByRootAndName;
                var bindingsByName = bindingsByRoot[rootUuid];
                if (bindingsByName === undefined) {
                    bindingsByName = {};
                    bindingsByRoot[rootUuid] = bindingsByName;
                }
                for(var i = 0; i !== nTracks; ++i){
                    var track = tracks[i], trackName = track.name;
                    var binding = bindingsByName[trackName];
                    if (binding !== undefined) bindings[i] = binding;
                    else {
                        binding = bindings[i];
                        if (binding !== undefined) {
                            // existing binding, make sure the cache knows
                            if (binding._cacheIndex === null) {
                                ++binding.referenceCount;
                                this._addInactiveBinding(binding, rootUuid, trackName);
                            }
                            continue;
                        }
                        var path = prototypeAction && prototypeAction._propertyBindings[i].binding.parsedPath;
                        binding = new $c702e238df7c5123$export$dfe0af1ca1acb78a($c702e238df7c5123$export$7bf70fcf9f891893.create(root, trackName, path), track.ValueTypeName, track.getValueSize());
                        ++binding.referenceCount;
                        this._addInactiveBinding(binding, rootUuid, trackName);
                        bindings[i] = binding;
                    }
                    interpolants[i].resultBuffer = binding.buffer;
                }
            }
        },
        {
            key: "_activateAction",
            value: function _activateAction(action) {
                if (!this._isActiveAction(action)) {
                    if (action._cacheIndex === null) {
                        // this action has been forgotten by the cache, but the user
                        // appears to be still using it -> rebind
                        var rootUuid = (action._localRoot || this._root).uuid, clipUuid = action._clip.uuid, actionsForClip = this._actionsByClip[clipUuid];
                        this._bindAction(action, actionsForClip && actionsForClip.knownActions[0]);
                        this._addInactiveAction(action, clipUuid, rootUuid);
                    }
                    var bindings = action._propertyBindings;
                    // increment reference counts / sort out state
                    for(var i = 0, n = bindings.length; i !== n; ++i){
                        var binding = bindings[i];
                        if (binding.useCount++ === 0) {
                            this._lendBinding(binding);
                            binding.saveOriginalState();
                        }
                    }
                    this._lendAction(action);
                }
            }
        },
        {
            key: "_deactivateAction",
            value: function _deactivateAction(action) {
                if (this._isActiveAction(action)) {
                    var bindings = action._propertyBindings;
                    // decrement reference counts / sort out state
                    for(var i = 0, n = bindings.length; i !== n; ++i){
                        var binding = bindings[i];
                        if (--binding.useCount === 0) {
                            binding.restoreOriginalState();
                            this._takeBackBinding(binding);
                        }
                    }
                    this._takeBackAction(action);
                }
            }
        },
        {
            // Memory manager
            key: "_initMemoryManager",
            value: function _initMemoryManager() {
                this._actions = []; // 'nActiveActions' followed by inactive ones
                this._nActiveActions = 0;
                this._actionsByClip = {};
                // inside:
                // {
                // 	knownActions: Array< AnimationAction > - used as prototypes
                // 	actionByRoot: AnimationAction - lookup
                // }
                this._bindings = []; // 'nActiveBindings' followed by inactive ones
                this._nActiveBindings = 0;
                this._bindingsByRootAndName = {}; // inside: Map< name, PropertyMixer >
                this._controlInterpolants = []; // same game as above
                this._nActiveControlInterpolants = 0;
                var scope = this;
                this.stats = {
                    actions: {
                        get total () {
                            return scope._actions.length;
                        },
                        get inUse () {
                            return scope._nActiveActions;
                        }
                    },
                    bindings: {
                        get total () {
                            return scope._bindings.length;
                        },
                        get inUse () {
                            return scope._nActiveBindings;
                        }
                    },
                    controlInterpolants: {
                        get total () {
                            return scope._controlInterpolants.length;
                        },
                        get inUse () {
                            return scope._nActiveControlInterpolants;
                        }
                    }
                };
            }
        },
        {
            // Memory management for AnimationAction objects
            key: "_isActiveAction",
            value: function _isActiveAction(action) {
                var index = action._cacheIndex;
                return index !== null && index < this._nActiveActions;
            }
        },
        {
            key: "_addInactiveAction",
            value: function _addInactiveAction(action, clipUuid, rootUuid) {
                var actions = this._actions, actionsByClip = this._actionsByClip;
                var actionsForClip = actionsByClip[clipUuid];
                if (actionsForClip === undefined) {
                    actionsForClip = {
                        knownActions: [
                            action
                        ],
                        actionByRoot: {}
                    };
                    action._byClipCacheIndex = 0;
                    actionsByClip[clipUuid] = actionsForClip;
                } else {
                    var knownActions = actionsForClip.knownActions;
                    action._byClipCacheIndex = knownActions.length;
                    knownActions.push(action);
                }
                action._cacheIndex = actions.length;
                actions.push(action);
                actionsForClip.actionByRoot[rootUuid] = action;
            }
        },
        {
            key: "_removeInactiveAction",
            value: function _removeInactiveAction(action) {
                var actions = this._actions, lastInactiveAction = actions[actions.length - 1], cacheIndex = action._cacheIndex;
                lastInactiveAction._cacheIndex = cacheIndex;
                actions[cacheIndex] = lastInactiveAction;
                actions.pop();
                action._cacheIndex = null;
                var clipUuid = action._clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid], knownActionsForClip = actionsForClip.knownActions, lastKnownAction = knownActionsForClip[knownActionsForClip.length - 1], byClipCacheIndex = action._byClipCacheIndex;
                lastKnownAction._byClipCacheIndex = byClipCacheIndex;
                knownActionsForClip[byClipCacheIndex] = lastKnownAction;
                knownActionsForClip.pop();
                action._byClipCacheIndex = null;
                var actionByRoot = actionsForClip.actionByRoot, rootUuid = (action._localRoot || this._root).uuid;
                delete actionByRoot[rootUuid];
                if (knownActionsForClip.length === 0) delete actionsByClip[clipUuid];
                this._removeInactiveBindingsForAction(action);
            }
        },
        {
            key: "_removeInactiveBindingsForAction",
            value: function _removeInactiveBindingsForAction(action) {
                var bindings = action._propertyBindings;
                for(var i = 0, n = bindings.length; i !== n; ++i){
                    var binding = bindings[i];
                    if (--binding.referenceCount === 0) this._removeInactiveBinding(binding);
                }
            }
        },
        {
            key: "_lendAction",
            value: function _lendAction(action) {
                // [ active actions |  inactive actions  ]
                // [  active actions >| inactive actions ]
                //                 s        a
                //                  <-swap->
                //                 a        s
                var actions = this._actions, prevIndex = action._cacheIndex, lastActiveIndex = this._nActiveActions++, firstInactiveAction = actions[lastActiveIndex];
                action._cacheIndex = lastActiveIndex;
                actions[lastActiveIndex] = action;
                firstInactiveAction._cacheIndex = prevIndex;
                actions[prevIndex] = firstInactiveAction;
            }
        },
        {
            key: "_takeBackAction",
            value: function _takeBackAction(action) {
                // [  active actions  | inactive actions ]
                // [ active actions |< inactive actions  ]
                //        a        s
                //         <-swap->
                //        s        a
                var actions = this._actions, prevIndex = action._cacheIndex, firstInactiveIndex = --this._nActiveActions, lastActiveAction = actions[firstInactiveIndex];
                action._cacheIndex = firstInactiveIndex;
                actions[firstInactiveIndex] = action;
                lastActiveAction._cacheIndex = prevIndex;
                actions[prevIndex] = lastActiveAction;
            }
        },
        {
            // Memory management for PropertyMixer objects
            key: "_addInactiveBinding",
            value: function _addInactiveBinding(binding, rootUuid, trackName) {
                var bindingsByRoot = this._bindingsByRootAndName, bindings = this._bindings;
                var bindingByName = bindingsByRoot[rootUuid];
                if (bindingByName === undefined) {
                    bindingByName = {};
                    bindingsByRoot[rootUuid] = bindingByName;
                }
                bindingByName[trackName] = binding;
                binding._cacheIndex = bindings.length;
                bindings.push(binding);
            }
        },
        {
            key: "_removeInactiveBinding",
            value: function _removeInactiveBinding(binding) {
                var bindings = this._bindings, propBinding = binding.binding, rootUuid = propBinding.rootNode.uuid, trackName = propBinding.path, bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid], lastInactiveBinding = bindings[bindings.length - 1], cacheIndex = binding._cacheIndex;
                lastInactiveBinding._cacheIndex = cacheIndex;
                bindings[cacheIndex] = lastInactiveBinding;
                bindings.pop();
                delete bindingByName[trackName];
                if (Object.keys(bindingByName).length === 0) delete bindingsByRoot[rootUuid];
            }
        },
        {
            key: "_lendBinding",
            value: function _lendBinding(binding) {
                var bindings = this._bindings, prevIndex = binding._cacheIndex, lastActiveIndex = this._nActiveBindings++, firstInactiveBinding = bindings[lastActiveIndex];
                binding._cacheIndex = lastActiveIndex;
                bindings[lastActiveIndex] = binding;
                firstInactiveBinding._cacheIndex = prevIndex;
                bindings[prevIndex] = firstInactiveBinding;
            }
        },
        {
            key: "_takeBackBinding",
            value: function _takeBackBinding(binding) {
                var bindings = this._bindings, prevIndex = binding._cacheIndex, firstInactiveIndex = --this._nActiveBindings, lastActiveBinding = bindings[firstInactiveIndex];
                binding._cacheIndex = firstInactiveIndex;
                bindings[firstInactiveIndex] = binding;
                lastActiveBinding._cacheIndex = prevIndex;
                bindings[prevIndex] = lastActiveBinding;
            }
        },
        {
            // Memory management of Interpolants for weight and time scale
            key: "_lendControlInterpolant",
            value: function _lendControlInterpolant() {
                var interpolants = this._controlInterpolants, lastActiveIndex = this._nActiveControlInterpolants++;
                var interpolant = interpolants[lastActiveIndex];
                if (interpolant === undefined) {
                    interpolant = new $c702e238df7c5123$export$a8e6009059f51e1a(new Float32Array(2), new Float32Array(2), 1, this._controlInterpolantsResultBuffer);
                    interpolant.__cacheIndex = lastActiveIndex;
                    interpolants[lastActiveIndex] = interpolant;
                }
                return interpolant;
            }
        },
        {
            key: "_takeBackControlInterpolant",
            value: function _takeBackControlInterpolant(interpolant) {
                var interpolants = this._controlInterpolants, prevIndex = interpolant.__cacheIndex, firstInactiveIndex = --this._nActiveControlInterpolants, lastActiveInterpolant = interpolants[firstInactiveIndex];
                interpolant.__cacheIndex = firstInactiveIndex;
                interpolants[firstInactiveIndex] = interpolant;
                lastActiveInterpolant.__cacheIndex = prevIndex;
                interpolants[prevIndex] = lastActiveInterpolant;
            }
        },
        {
            // return an action for a clip optionally using a custom root target
            // object (this method allocates a lot of dynamic memory in case a
            // previously unknown clip/root combination is specified)
            key: "clipAction",
            value: function clipAction(clip, optionalRoot, blendMode) {
                var root = optionalRoot || this._root, rootUuid = root.uuid;
                var clipObject = typeof clip === 'string' ? $c702e238df7c5123$export$d942c706bf23829c.findByName(root, clip) : clip;
                var clipUuid = clipObject !== null ? clipObject.uuid : clip;
                var actionsForClip = this._actionsByClip[clipUuid];
                var prototypeAction = null;
                if (blendMode === undefined) {
                    if (clipObject !== null) blendMode = clipObject.blendMode;
                    else blendMode = $c702e238df7c5123$export$bcfbbdcf8de7f8cd;
                }
                if (actionsForClip !== undefined) {
                    var existingAction = actionsForClip.actionByRoot[rootUuid];
                    if (existingAction !== undefined && existingAction.blendMode === blendMode) return existingAction;
                    // we know the clip, so we don't have to parse all
                    // the bindings again but can just copy
                    prototypeAction = actionsForClip.knownActions[0];
                    // also, take the clip from the prototype action
                    if (clipObject === null) clipObject = prototypeAction._clip;
                }
                // clip must be known when specified via string
                if (clipObject === null) return null;
                // allocate all resources required to run it
                var newAction = new $c702e238df7c5123$var$AnimationAction(this, clipObject, optionalRoot, blendMode);
                this._bindAction(newAction, prototypeAction);
                // and make the action known to the memory manager
                this._addInactiveAction(newAction, clipUuid, rootUuid);
                return newAction;
            }
        },
        {
            // get an existing action
            key: "existingAction",
            value: function existingAction(clip, optionalRoot) {
                var root = optionalRoot || this._root, rootUuid = root.uuid, clipObject = typeof clip === 'string' ? $c702e238df7c5123$export$d942c706bf23829c.findByName(root, clip) : clip, clipUuid = clipObject ? clipObject.uuid : clip, actionsForClip = this._actionsByClip[clipUuid];
                if (actionsForClip !== undefined) return actionsForClip.actionByRoot[rootUuid] || null;
                return null;
            }
        },
        {
            // deactivates all previously scheduled actions
            key: "stopAllAction",
            value: function stopAllAction() {
                var actions = this._actions, nActions = this._nActiveActions;
                for(var i = nActions - 1; i >= 0; --i)actions[i].stop();
                return this;
            }
        },
        {
            // advance the time and update apply the animation
            key: "update",
            value: function update(deltaTime) {
                deltaTime *= this.timeScale;
                var actions = this._actions, nActions = this._nActiveActions, time = this.time += deltaTime, timeDirection = Math.sign(deltaTime), accuIndex = this._accuIndex ^= 1;
                // run active actions
                for(var i = 0; i !== nActions; ++i){
                    var action = actions[i];
                    action._update(time, deltaTime, timeDirection, accuIndex);
                }
                // update scene graph
                var bindings = this._bindings, nBindings = this._nActiveBindings;
                for(var i1 = 0; i1 !== nBindings; ++i1)bindings[i1].apply(accuIndex);
                return this;
            }
        },
        {
            // Allows you to seek to a specific time in an animation.
            key: "setTime",
            value: function setTime(timeInSeconds) {
                this.time = 0; // Zero out time attribute for AnimationMixer object;
                for(var i = 0; i < this._actions.length; i++)this._actions[i].time = 0; // Zero out time attribute for all associated AnimationAction objects.
                return this.update(timeInSeconds); // Update used to set exact time. Returns "this" AnimationMixer object.
            }
        },
        {
            // return this mixer's root target object
            key: "getRoot",
            value: function getRoot() {
                return this._root;
            }
        },
        {
            // free all resources specific to a particular clip
            key: "uncacheClip",
            value: function uncacheClip(clip) {
                var actions = this._actions, clipUuid = clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid];
                if (actionsForClip !== undefined) {
                    // note: just calling _removeInactiveAction would mess up the
                    // iteration state and also require updating the state we can
                    // just throw away
                    var actionsToRemove = actionsForClip.knownActions;
                    for(var i = 0, n = actionsToRemove.length; i !== n; ++i){
                        var action = actionsToRemove[i];
                        this._deactivateAction(action);
                        var cacheIndex = action._cacheIndex, lastInactiveAction = actions[actions.length - 1];
                        action._cacheIndex = null;
                        action._byClipCacheIndex = null;
                        lastInactiveAction._cacheIndex = cacheIndex;
                        actions[cacheIndex] = lastInactiveAction;
                        actions.pop();
                        this._removeInactiveBindingsForAction(action);
                    }
                    delete actionsByClip[clipUuid];
                }
            }
        },
        {
            // free all resources specific to a particular root target object
            key: "uncacheRoot",
            value: function uncacheRoot(root) {
                var rootUuid = root.uuid, actionsByClip = this._actionsByClip;
                for(var clipUuid in actionsByClip){
                    var actionByRoot = actionsByClip[clipUuid].actionByRoot, action = actionByRoot[rootUuid];
                    if (action !== undefined) {
                        this._deactivateAction(action);
                        this._removeInactiveAction(action);
                    }
                }
                var bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid];
                if (bindingByName !== undefined) for(var trackName in bindingByName){
                    var binding = bindingByName[trackName];
                    binding.restoreOriginalState();
                    this._removeInactiveBinding(binding);
                }
            }
        },
        {
            // remove a targeted clip from the cache
            key: "uncacheAction",
            value: function uncacheAction(clip, optionalRoot) {
                var action = this.existingAction(clip, optionalRoot);
                if (action !== null) {
                    this._deactivateAction(action);
                    this._removeInactiveAction(action);
                }
            }
        }
    ]);
    return AnimationMixer;
}($c702e238df7c5123$export$ec8b666c5fe2c75a);
$c702e238df7c5123$export$fbd77e5aefaa0102.prototype._controlInterpolantsResultBuffer = new Float32Array(1);
var $c702e238df7c5123$export$2947cebfe91c02f8 = /*#__PURE__*/ function() {
    "use strict";
    function Uniform(value) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Uniform);
        if (typeof value === 'string') {
            console.warn('THREE.Uniform: Type parameter is no longer needed.');
            value = arguments[1];
        }
        this.value = value;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(Uniform, [
        {
            key: "clone",
            value: function clone() {
                return new Uniform(this.value.clone === undefined ? this.value : this.value.clone());
            }
        }
    ]);
    return Uniform;
}();
var $c702e238df7c5123$export$25ec0e1af1389358 = /*#__PURE__*/ function(InterleavedBuffer) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(InstancedInterleavedBuffer, InterleavedBuffer);
    function InstancedInterleavedBuffer(array, stride) {
        var meshPerAttribute = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, InstancedInterleavedBuffer);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, InstancedInterleavedBuffer, [
            array,
            stride
        ]);
        _this.meshPerAttribute = meshPerAttribute;
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(InstancedInterleavedBuffer, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(InstancedInterleavedBuffer.prototype), "copy", this).call(this, source);
                this.meshPerAttribute = source.meshPerAttribute;
                return this;
            }
        },
        {
            key: "clone",
            value: function clone(data) {
                var ib = (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(InstancedInterleavedBuffer.prototype), "clone", this).call(this, data);
                ib.meshPerAttribute = this.meshPerAttribute;
                return ib;
            }
        },
        {
            key: "toJSON",
            value: function toJSON(data) {
                var json = (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(InstancedInterleavedBuffer.prototype), "toJSON", this).call(this, data);
                json.isInstancedInterleavedBuffer = true;
                json.meshPerAttribute = this.meshPerAttribute;
                return json;
            }
        }
    ]);
    return InstancedInterleavedBuffer;
}($c702e238df7c5123$export$3d5cd879f108f53f);
$c702e238df7c5123$export$25ec0e1af1389358.prototype.isInstancedInterleavedBuffer = true;
var $c702e238df7c5123$export$6b7339ae8dbddf73 = /*#__PURE__*/ function() {
    "use strict";
    function GLBufferAttribute(buffer, type, itemSize, elementSize, count) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, GLBufferAttribute);
        this.buffer = buffer;
        this.type = type;
        this.itemSize = itemSize;
        this.elementSize = elementSize;
        this.count = count;
        this.version = 0;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(GLBufferAttribute, [
        {
            key: "needsUpdate",
            set: function set(value) {
                if (value === true) this.version++;
            }
        },
        {
            key: "setBuffer",
            value: function setBuffer(buffer) {
                this.buffer = buffer;
                return this;
            }
        },
        {
            key: "setType",
            value: function setType(type, elementSize) {
                this.type = type;
                this.elementSize = elementSize;
                return this;
            }
        },
        {
            key: "setItemSize",
            value: function setItemSize(itemSize) {
                this.itemSize = itemSize;
                return this;
            }
        },
        {
            key: "setCount",
            value: function setCount(count) {
                this.count = count;
                return this;
            }
        }
    ]);
    return GLBufferAttribute;
}();
$c702e238df7c5123$export$6b7339ae8dbddf73.prototype.isGLBufferAttribute = true;
var $c702e238df7c5123$export$8b7aaceff00bd2f = /*#__PURE__*/ function() {
    "use strict";
    function Raycaster(origin, direction) {
        var near = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, far = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Infinity;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Raycaster);
        this.ray = new $c702e238df7c5123$export$a186db52eed6d40e(origin, direction);
        // direction is assumed to be normalized (for accurate distance calculations)
        this.near = near;
        this.far = far;
        this.camera = null;
        this.layers = new $c702e238df7c5123$export$89312ce47c0ca777();
        this.params = {
            Mesh: {},
            Line: {
                threshold: 1
            },
            LOD: {},
            Points: {
                threshold: 1
            },
            Sprite: {}
        };
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(Raycaster, [
        {
            key: "set",
            value: function set(origin, direction) {
                // direction is assumed to be normalized (for accurate distance calculations)
                this.ray.set(origin, direction);
            }
        },
        {
            key: "setFromCamera",
            value: function setFromCamera(coords, camera) {
                if (camera && camera.isPerspectiveCamera) {
                    this.ray.origin.setFromMatrixPosition(camera.matrixWorld);
                    this.ray.direction.set(coords.x, coords.y, 0.5).unproject(camera).sub(this.ray.origin).normalize();
                    this.camera = camera;
                } else if (camera && camera.isOrthographicCamera) {
                    this.ray.origin.set(coords.x, coords.y, (camera.near + camera.far) / (camera.near - camera.far)).unproject(camera); // set origin in plane of camera
                    this.ray.direction.set(0, 0, -1).transformDirection(camera.matrixWorld);
                    this.camera = camera;
                } else console.error('THREE.Raycaster: Unsupported camera type: ' + camera.type);
            }
        },
        {
            key: "intersectObject",
            value: function intersectObject1(object) {
                var recursive = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, intersects = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
                $c702e238df7c5123$var$intersectObject(object, this, intersects, recursive);
                intersects.sort($c702e238df7c5123$var$ascSort);
                return intersects;
            }
        },
        {
            key: "intersectObjects",
            value: function intersectObjects(objects) {
                var recursive = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, intersects = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
                for(var i = 0, l = objects.length; i < l; i++)$c702e238df7c5123$var$intersectObject(objects[i], this, intersects, recursive);
                intersects.sort($c702e238df7c5123$var$ascSort);
                return intersects;
            }
        }
    ]);
    return Raycaster;
}();
function $c702e238df7c5123$var$ascSort(a, b) {
    return a.distance - b.distance;
}
function $c702e238df7c5123$var$intersectObject(object, raycaster, intersects, recursive) {
    if (object.layers.test(raycaster.layers)) object.raycast(raycaster, intersects);
    if (recursive === true) {
        var children = object.children;
        for(var i = 0, l = children.length; i < l; i++)$c702e238df7c5123$var$intersectObject(children[i], raycaster, intersects, true);
    }
}
/**
 * Ref: https://en.wikipedia.org/wiki/Spherical_coordinate_system
 *
 * The polar angle (phi) is measured from the positive y-axis. The positive y-axis is up.
 * The azimuthal angle (theta) is measured from the positive z-axis.
 */ var $c702e238df7c5123$export$d712cd887b4a00f7 = /*#__PURE__*/ function() {
    "use strict";
    function Spherical() {
        var radius = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, phi = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, theta = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Spherical);
        this.radius = radius;
        this.phi = phi; // polar angle
        this.theta = theta; // azimuthal angle
        return this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(Spherical, [
        {
            key: "set",
            value: function set(radius, phi, theta) {
                this.radius = radius;
                this.phi = phi;
                this.theta = theta;
                return this;
            }
        },
        {
            key: "copy",
            value: function copy(other) {
                this.radius = other.radius;
                this.phi = other.phi;
                this.theta = other.theta;
                return this;
            }
        },
        {
            // restrict phi to be betwee EPS and PI-EPS
            key: "makeSafe",
            value: function makeSafe() {
                var EPS = 0.000001;
                this.phi = Math.max(EPS, Math.min(Math.PI - EPS, this.phi));
                return this;
            }
        },
        {
            key: "setFromVector3",
            value: function setFromVector3(v) {
                return this.setFromCartesianCoords(v.x, v.y, v.z);
            }
        },
        {
            key: "setFromCartesianCoords",
            value: function setFromCartesianCoords(x, y, z) {
                this.radius = Math.sqrt(x * x + y * y + z * z);
                if (this.radius === 0) {
                    this.theta = 0;
                    this.phi = 0;
                } else {
                    this.theta = Math.atan2(x, z);
                    this.phi = Math.acos($c702e238df7c5123$var$clamp(y / this.radius, -1, 1));
                }
                return this;
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        }
    ]);
    return Spherical;
}();
/**
 * Ref: https://en.wikipedia.org/wiki/Cylindrical_coordinate_system
 */ var $c702e238df7c5123$export$287165bb2177f4fd = /*#__PURE__*/ function() {
    "use strict";
    function Cylindrical() {
        var radius = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, theta = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, y = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Cylindrical);
        this.radius = radius; // distance from the origin to a point in the x-z plane
        this.theta = theta; // counterclockwise angle in the x-z plane measured in radians from the positive z-axis
        this.y = y; // height above the x-z plane
        return this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(Cylindrical, [
        {
            key: "set",
            value: function set(radius, theta, y) {
                this.radius = radius;
                this.theta = theta;
                this.y = y;
                return this;
            }
        },
        {
            key: "copy",
            value: function copy(other) {
                this.radius = other.radius;
                this.theta = other.theta;
                this.y = other.y;
                return this;
            }
        },
        {
            key: "setFromVector3",
            value: function setFromVector3(v) {
                return this.setFromCartesianCoords(v.x, v.y, v.z);
            }
        },
        {
            key: "setFromCartesianCoords",
            value: function setFromCartesianCoords(x, y, z) {
                this.radius = Math.sqrt(x * x + z * z);
                this.theta = Math.atan2(x, z);
                this.y = y;
                return this;
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        }
    ]);
    return Cylindrical;
}();
var $c702e238df7c5123$var$_vector$4 = /*@__PURE__*/ new $c702e238df7c5123$export$c977b3e384af9ae1();
var $c702e238df7c5123$export$60f553fa130f08b0 = /*#__PURE__*/ function() {
    "use strict";
    function Box2() {
        var min = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $c702e238df7c5123$export$c977b3e384af9ae1(Infinity, Infinity), max = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $c702e238df7c5123$export$c977b3e384af9ae1(-Infinity, -Infinity);
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Box2);
        this.min = min;
        this.max = max;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(Box2, [
        {
            key: "set",
            value: function set(min, max) {
                this.min.copy(min);
                this.max.copy(max);
                return this;
            }
        },
        {
            key: "setFromPoints",
            value: function setFromPoints(points) {
                this.makeEmpty();
                for(var i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
                return this;
            }
        },
        {
            key: "setFromCenterAndSize",
            value: function setFromCenterAndSize(center, size) {
                var halfSize = $c702e238df7c5123$var$_vector$4.copy(size).multiplyScalar(0.5);
                this.min.copy(center).sub(halfSize);
                this.max.copy(center).add(halfSize);
                return this;
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        },
        {
            key: "copy",
            value: function copy(box) {
                this.min.copy(box.min);
                this.max.copy(box.max);
                return this;
            }
        },
        {
            key: "makeEmpty",
            value: function makeEmpty() {
                this.min.x = this.min.y = Infinity;
                this.max.x = this.max.y = -Infinity;
                return this;
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
                return this.max.x < this.min.x || this.max.y < this.min.y;
            }
        },
        {
            key: "getCenter",
            value: function getCenter(target) {
                return this.isEmpty() ? target.set(0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
            }
        },
        {
            key: "getSize",
            value: function getSize(target) {
                return this.isEmpty() ? target.set(0, 0) : target.subVectors(this.max, this.min);
            }
        },
        {
            key: "expandByPoint",
            value: function expandByPoint(point) {
                this.min.min(point);
                this.max.max(point);
                return this;
            }
        },
        {
            key: "expandByVector",
            value: function expandByVector(vector) {
                this.min.sub(vector);
                this.max.add(vector);
                return this;
            }
        },
        {
            key: "expandByScalar",
            value: function expandByScalar(scalar) {
                this.min.addScalar(-scalar);
                this.max.addScalar(scalar);
                return this;
            }
        },
        {
            key: "containsPoint",
            value: function containsPoint(point) {
                return point.x < this.min.x || point.x > this.max.x || point.y < this.min.y || point.y > this.max.y ? false : true;
            }
        },
        {
            key: "containsBox",
            value: function containsBox(box) {
                return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y;
            }
        },
        {
            key: "getParameter",
            value: function getParameter(point, target) {
                // This can potentially have a divide by zero if the box
                // has a size dimension of 0.
                return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y));
            }
        },
        {
            key: "intersectsBox",
            value: function intersectsBox(box) {
                // using 4 splitting planes to rule out intersections
                return box.max.x < this.min.x || box.min.x > this.max.x || box.max.y < this.min.y || box.min.y > this.max.y ? false : true;
            }
        },
        {
            key: "clampPoint",
            value: function clampPoint(point, target) {
                return target.copy(point).clamp(this.min, this.max);
            }
        },
        {
            key: "distanceToPoint",
            value: function distanceToPoint(point) {
                var clampedPoint = $c702e238df7c5123$var$_vector$4.copy(point).clamp(this.min, this.max);
                return clampedPoint.sub(point).length();
            }
        },
        {
            key: "intersect",
            value: function intersect(box) {
                this.min.max(box.min);
                this.max.min(box.max);
                return this;
            }
        },
        {
            key: "union",
            value: function union(box) {
                this.min.min(box.min);
                this.max.max(box.max);
                return this;
            }
        },
        {
            key: "translate",
            value: function translate(offset) {
                this.min.add(offset);
                this.max.add(offset);
                return this;
            }
        },
        {
            key: "equals",
            value: function equals(box) {
                return box.min.equals(this.min) && box.max.equals(this.max);
            }
        }
    ]);
    return Box2;
}();
$c702e238df7c5123$export$60f553fa130f08b0.prototype.isBox2 = true;
var $c702e238df7c5123$var$_startP = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_startEnd = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$export$e0ba6359f1954fd3 = /*#__PURE__*/ function() {
    "use strict";
    function Line3() {
        var start = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $c702e238df7c5123$export$64b5c384219d3699(), end = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $c702e238df7c5123$export$64b5c384219d3699();
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Line3);
        this.start = start;
        this.end = end;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(Line3, [
        {
            key: "set",
            value: function set(start, end) {
                this.start.copy(start);
                this.end.copy(end);
                return this;
            }
        },
        {
            key: "copy",
            value: function copy(line) {
                this.start.copy(line.start);
                this.end.copy(line.end);
                return this;
            }
        },
        {
            key: "getCenter",
            value: function getCenter(target) {
                return target.addVectors(this.start, this.end).multiplyScalar(0.5);
            }
        },
        {
            key: "delta",
            value: function delta(target) {
                return target.subVectors(this.end, this.start);
            }
        },
        {
            key: "distanceSq",
            value: function distanceSq() {
                return this.start.distanceToSquared(this.end);
            }
        },
        {
            key: "distance",
            value: function distance() {
                return this.start.distanceTo(this.end);
            }
        },
        {
            key: "at",
            value: function at(t, target) {
                return this.delta(target).multiplyScalar(t).add(this.start);
            }
        },
        {
            key: "closestPointToPointParameter",
            value: function closestPointToPointParameter(point, clampToLine) {
                $c702e238df7c5123$var$_startP.subVectors(point, this.start);
                $c702e238df7c5123$var$_startEnd.subVectors(this.end, this.start);
                var startEnd2 = $c702e238df7c5123$var$_startEnd.dot($c702e238df7c5123$var$_startEnd);
                var startEnd_startP = $c702e238df7c5123$var$_startEnd.dot($c702e238df7c5123$var$_startP);
                var t = startEnd_startP / startEnd2;
                if (clampToLine) t = $c702e238df7c5123$var$clamp(t, 0, 1);
                return t;
            }
        },
        {
            key: "closestPointToPoint",
            value: function closestPointToPoint(point, clampToLine, target) {
                var t = this.closestPointToPointParameter(point, clampToLine);
                return this.delta(target).multiplyScalar(t).add(this.start);
            }
        },
        {
            key: "applyMatrix4",
            value: function applyMatrix4(matrix) {
                this.start.applyMatrix4(matrix);
                this.end.applyMatrix4(matrix);
                return this;
            }
        },
        {
            key: "equals",
            value: function equals(line) {
                return line.start.equals(this.start) && line.end.equals(this.end);
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        }
    ]);
    return Line3;
}();
var $c702e238df7c5123$export$960665a8431ecff6 = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(ImmediateRenderObject, Object3D);
    function ImmediateRenderObject(material) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, ImmediateRenderObject);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, ImmediateRenderObject);
        _this.material = material;
        _this.render = function() {};
        _this.hasPositions = false;
        _this.hasNormals = false;
        _this.hasColors = false;
        _this.hasUvs = false;
        _this.positionArray = null;
        _this.normalArray = null;
        _this.colorArray = null;
        _this.uvArray = null;
        _this.count = 0;
        return _this;
    }
    return ImmediateRenderObject;
}($c702e238df7c5123$export$e4dd07dff30cc924);
$c702e238df7c5123$export$960665a8431ecff6.prototype.isImmediateRenderObject = true;
var $c702e238df7c5123$var$_vector$3 = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$export$4b14638ffdd81e68 = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(SpotLightHelper, Object3D);
    function SpotLightHelper(light, color) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, SpotLightHelper);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, SpotLightHelper);
        _this.light = light;
        _this.light.updateMatrixWorld();
        _this.matrix = light.matrixWorld;
        _this.matrixAutoUpdate = false;
        _this.color = color;
        var geometry = new $c702e238df7c5123$export$b7be63a67df8959();
        var positions = [
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            1,
            0,
            0,
            0,
            -1,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            1,
            0,
            0,
            0,
            0,
            -1,
            1
        ];
        for(var i = 0, j = 1, l = 32; i < l; i++, j++){
            var p1 = i / l * Math.PI * 2;
            var p2 = j / l * Math.PI * 2;
            positions.push(Math.cos(p1), Math.sin(p1), 1, Math.cos(p2), Math.sin(p2), 1);
        }
        geometry.setAttribute('position', new $c702e238df7c5123$export$cbe7a62641830ebd(positions, 3));
        var material = new $c702e238df7c5123$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        _this.cone = new $c702e238df7c5123$export$ff1ed10fedfdd604(geometry, material);
        _this.add(_this.cone);
        _this.update();
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(SpotLightHelper, [
        {
            key: "dispose",
            value: function dispose() {
                this.cone.geometry.dispose();
                this.cone.material.dispose();
            }
        },
        {
            key: "update",
            value: function update() {
                this.light.updateMatrixWorld();
                var coneLength = this.light.distance ? this.light.distance : 1000;
                var coneWidth = coneLength * Math.tan(this.light.angle);
                this.cone.scale.set(coneWidth, coneWidth, coneLength);
                $c702e238df7c5123$var$_vector$3.setFromMatrixPosition(this.light.target.matrixWorld);
                this.cone.lookAt($c702e238df7c5123$var$_vector$3);
                if (this.color !== undefined) this.cone.material.color.set(this.color);
                else this.cone.material.color.copy(this.light.color);
            }
        }
    ]);
    return SpotLightHelper;
}($c702e238df7c5123$export$e4dd07dff30cc924);
var $c702e238df7c5123$var$_vector$2 = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_boneMatrix = /*@__PURE__*/ new $c702e238df7c5123$export$2ae72fc923e5eb5();
var $c702e238df7c5123$var$_matrixWorldInv = /*@__PURE__*/ new $c702e238df7c5123$export$2ae72fc923e5eb5();
var $c702e238df7c5123$export$5277df3c9e732259 = /*#__PURE__*/ function(LineSegments) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(SkeletonHelper, LineSegments);
    function SkeletonHelper(object) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, SkeletonHelper);
        var _this;
        var bones = $c702e238df7c5123$var$getBoneList(object);
        var geometry = new $c702e238df7c5123$export$b7be63a67df8959();
        var vertices = [];
        var colors = [];
        var color1 = new $c702e238df7c5123$export$892596cec99bc70e(0, 0, 1);
        var color2 = new $c702e238df7c5123$export$892596cec99bc70e(0, 1, 0);
        for(var i = 0; i < bones.length; i++){
            var bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                vertices.push(0, 0, 0);
                vertices.push(0, 0, 0);
                colors.push(color1.r, color1.g, color1.b);
                colors.push(color2.r, color2.g, color2.b);
            }
        }
        geometry.setAttribute('position', new $c702e238df7c5123$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $c702e238df7c5123$export$cbe7a62641830ebd(colors, 3));
        var material = new $c702e238df7c5123$export$fbaaa33907730a0c({
            vertexColors: true,
            depthTest: false,
            depthWrite: false,
            toneMapped: false,
            transparent: true
        });
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, SkeletonHelper, [
            geometry,
            material
        ]);
        _this.type = 'SkeletonHelper';
        _this.isSkeletonHelper = true;
        _this.root = object;
        _this.bones = bones;
        _this.matrix = object.matrixWorld;
        _this.matrixAutoUpdate = false;
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(SkeletonHelper, [
        {
            key: "updateMatrixWorld",
            value: function updateMatrixWorld(force) {
                var bones = this.bones;
                var geometry = this.geometry;
                var position = geometry.getAttribute('position');
                $c702e238df7c5123$var$_matrixWorldInv.copy(this.root.matrixWorld).invert();
                for(var i = 0, j = 0; i < bones.length; i++){
                    var bone = bones[i];
                    if (bone.parent && bone.parent.isBone) {
                        $c702e238df7c5123$var$_boneMatrix.multiplyMatrices($c702e238df7c5123$var$_matrixWorldInv, bone.matrixWorld);
                        $c702e238df7c5123$var$_vector$2.setFromMatrixPosition($c702e238df7c5123$var$_boneMatrix);
                        position.setXYZ(j, $c702e238df7c5123$var$_vector$2.x, $c702e238df7c5123$var$_vector$2.y, $c702e238df7c5123$var$_vector$2.z);
                        $c702e238df7c5123$var$_boneMatrix.multiplyMatrices($c702e238df7c5123$var$_matrixWorldInv, bone.parent.matrixWorld);
                        $c702e238df7c5123$var$_vector$2.setFromMatrixPosition($c702e238df7c5123$var$_boneMatrix);
                        position.setXYZ(j + 1, $c702e238df7c5123$var$_vector$2.x, $c702e238df7c5123$var$_vector$2.y, $c702e238df7c5123$var$_vector$2.z);
                        j += 2;
                    }
                }
                geometry.getAttribute('position').needsUpdate = true;
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(SkeletonHelper.prototype), "updateMatrixWorld", this).call(this, force);
            }
        }
    ]);
    return SkeletonHelper;
}($c702e238df7c5123$export$ff1ed10fedfdd604);
function $c702e238df7c5123$var$getBoneList(object) {
    var boneList = [];
    if (object && object.isBone) boneList.push(object);
    for(var i = 0; i < object.children.length; i++)boneList.push.apply(boneList, $c702e238df7c5123$var$getBoneList(object.children[i]));
    return boneList;
}
var $c702e238df7c5123$export$9a9291685b9e4023 = /*#__PURE__*/ function(Mesh) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(PointLightHelper, Mesh);
    function PointLightHelper(light, sphereSize, color) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, PointLightHelper);
        var _this;
        var geometry = new $c702e238df7c5123$export$d5d06a966fec4192(sphereSize, 4, 2);
        var material = new $c702e238df7c5123$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, PointLightHelper, [
            geometry,
            material
        ]);
        _this.light = light;
        _this.light.updateMatrixWorld();
        _this.color = color;
        _this.type = 'PointLightHelper';
        _this.matrix = _this.light.matrixWorld;
        _this.matrixAutoUpdate = false;
        _this.update();
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(PointLightHelper, [
        {
            key: "dispose",
            value: function dispose() {
                this.geometry.dispose();
                this.material.dispose();
            }
        },
        {
            key: "update",
            value: function update() {
                if (this.color !== undefined) this.material.color.set(this.color);
                else this.material.color.copy(this.light.color);
            /*
		const d = this.light.distance;

		if ( d === 0.0 ) {

			this.lightDistance.visible = false;

		} else {

			this.lightDistance.visible = true;
			this.lightDistance.scale.set( d, d, d );

		}
		*/ }
        }
    ]);
    return PointLightHelper;
}($c702e238df7c5123$export$e176487c05830cc5);
var $c702e238df7c5123$var$_vector$1 = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_color1 = /*@__PURE__*/ new $c702e238df7c5123$export$892596cec99bc70e();
var $c702e238df7c5123$var$_color2 = /*@__PURE__*/ new $c702e238df7c5123$export$892596cec99bc70e();
var $c702e238df7c5123$export$8dca15f13f4f8172 = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(HemisphereLightHelper, Object3D);
    function HemisphereLightHelper(light, size, color) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, HemisphereLightHelper);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, HemisphereLightHelper);
        _this.light = light;
        _this.light.updateMatrixWorld();
        _this.matrix = light.matrixWorld;
        _this.matrixAutoUpdate = false;
        _this.color = color;
        var geometry = new $c702e238df7c5123$export$8e05fc91596f4752(size);
        geometry.rotateY(Math.PI * 0.5);
        _this.material = new $c702e238df7c5123$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        if (_this.color === undefined) _this.material.vertexColors = true;
        var position = geometry.getAttribute('position');
        var colors = new Float32Array(position.count * 3);
        geometry.setAttribute('color', new $c702e238df7c5123$export$8dea267bd6bde117(colors, 3));
        _this.add(new $c702e238df7c5123$export$e176487c05830cc5(geometry, _this.material));
        _this.update();
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(HemisphereLightHelper, [
        {
            key: "dispose",
            value: function dispose() {
                this.children[0].geometry.dispose();
                this.children[0].material.dispose();
            }
        },
        {
            key: "update",
            value: function update() {
                var mesh = this.children[0];
                if (this.color !== undefined) this.material.color.set(this.color);
                else {
                    var colors = mesh.geometry.getAttribute('color');
                    $c702e238df7c5123$var$_color1.copy(this.light.color);
                    $c702e238df7c5123$var$_color2.copy(this.light.groundColor);
                    for(var i = 0, l = colors.count; i < l; i++){
                        var color = i < l / 2 ? $c702e238df7c5123$var$_color1 : $c702e238df7c5123$var$_color2;
                        colors.setXYZ(i, color.r, color.g, color.b);
                    }
                    colors.needsUpdate = true;
                }
                mesh.lookAt($c702e238df7c5123$var$_vector$1.setFromMatrixPosition(this.light.matrixWorld).negate());
            }
        }
    ]);
    return HemisphereLightHelper;
}($c702e238df7c5123$export$e4dd07dff30cc924);
var $c702e238df7c5123$export$3875d39926561055 = /*#__PURE__*/ function(LineSegments) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(GridHelper, LineSegments);
    function GridHelper() {
        var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 10, divisions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 10, color1 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0x444444, color2 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0x888888;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, GridHelper);
        var _this;
        color1 = new $c702e238df7c5123$export$892596cec99bc70e(color1);
        color2 = new $c702e238df7c5123$export$892596cec99bc70e(color2);
        var center = divisions / 2;
        var step = size / divisions;
        var halfSize = size / 2;
        var vertices = [], colors = [];
        for(var i = 0, j = 0, k = -halfSize; i <= divisions; i++, k += step){
            vertices.push(-halfSize, 0, k, halfSize, 0, k);
            vertices.push(k, 0, -halfSize, k, 0, halfSize);
            var color = i === center ? color1 : color2;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
        }
        var geometry = new $c702e238df7c5123$export$b7be63a67df8959();
        geometry.setAttribute('position', new $c702e238df7c5123$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $c702e238df7c5123$export$cbe7a62641830ebd(colors, 3));
        var material = new $c702e238df7c5123$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, GridHelper, [
            geometry,
            material
        ]);
        _this.type = 'GridHelper';
        return _this;
    }
    return GridHelper;
}($c702e238df7c5123$export$ff1ed10fedfdd604);
var $c702e238df7c5123$export$361430a10f533cd3 = /*#__PURE__*/ function(LineSegments) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(PolarGridHelper, LineSegments);
    function PolarGridHelper() {
        var radius = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 10, radials = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 16, circles = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 8, divisions = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 64, color1 = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0x444444, color2 = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0x888888;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, PolarGridHelper);
        var _this;
        color1 = new $c702e238df7c5123$export$892596cec99bc70e(color1);
        color2 = new $c702e238df7c5123$export$892596cec99bc70e(color2);
        var vertices = [];
        var colors = [];
        // create the radials
        for(var i = 0; i <= radials; i++){
            var v = i / radials * (Math.PI * 2);
            var x = Math.sin(v) * radius;
            var z = Math.cos(v) * radius;
            vertices.push(0, 0, 0);
            vertices.push(x, 0, z);
            var color = i & 1 ? color1 : color2;
            colors.push(color.r, color.g, color.b);
            colors.push(color.r, color.g, color.b);
        }
        // create the circles
        for(var i1 = 0; i1 <= circles; i1++){
            var color3 = i1 & 1 ? color1 : color2;
            var r = radius - radius / circles * i1;
            for(var j = 0; j < divisions; j++){
                // first vertex
                var v1 = j / divisions * (Math.PI * 2);
                var x1 = Math.sin(v1) * r;
                var z1 = Math.cos(v1) * r;
                vertices.push(x1, 0, z1);
                colors.push(color3.r, color3.g, color3.b);
                // second vertex
                v1 = (j + 1) / divisions * (Math.PI * 2);
                x1 = Math.sin(v1) * r;
                z1 = Math.cos(v1) * r;
                vertices.push(x1, 0, z1);
                colors.push(color3.r, color3.g, color3.b);
            }
        }
        var geometry = new $c702e238df7c5123$export$b7be63a67df8959();
        geometry.setAttribute('position', new $c702e238df7c5123$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $c702e238df7c5123$export$cbe7a62641830ebd(colors, 3));
        var material = new $c702e238df7c5123$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, PolarGridHelper, [
            geometry,
            material
        ]);
        _this.type = 'PolarGridHelper';
        return _this;
    }
    return PolarGridHelper;
}($c702e238df7c5123$export$ff1ed10fedfdd604);
var $c702e238df7c5123$var$_v1 = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_v2 = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_v3 = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$export$f8e434dc14203e7d = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(DirectionalLightHelper, Object3D);
    function DirectionalLightHelper(light, size, color) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, DirectionalLightHelper);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, DirectionalLightHelper);
        _this.light = light;
        _this.light.updateMatrixWorld();
        _this.matrix = light.matrixWorld;
        _this.matrixAutoUpdate = false;
        _this.color = color;
        if (size === undefined) size = 1;
        var geometry = new $c702e238df7c5123$export$b7be63a67df8959();
        geometry.setAttribute('position', new $c702e238df7c5123$export$cbe7a62641830ebd([
            -size,
            size,
            0,
            size,
            size,
            0,
            size,
            -size,
            0,
            -size,
            -size,
            0,
            -size,
            size,
            0
        ], 3));
        var material = new $c702e238df7c5123$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        _this.lightPlane = new $c702e238df7c5123$export$17d680238e50603e(geometry, material);
        _this.add(_this.lightPlane);
        geometry = new $c702e238df7c5123$export$b7be63a67df8959();
        geometry.setAttribute('position', new $c702e238df7c5123$export$cbe7a62641830ebd([
            0,
            0,
            0,
            0,
            0,
            1
        ], 3));
        _this.targetLine = new $c702e238df7c5123$export$17d680238e50603e(geometry, material);
        _this.add(_this.targetLine);
        _this.update();
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(DirectionalLightHelper, [
        {
            key: "dispose",
            value: function dispose() {
                this.lightPlane.geometry.dispose();
                this.lightPlane.material.dispose();
                this.targetLine.geometry.dispose();
                this.targetLine.material.dispose();
            }
        },
        {
            key: "update",
            value: function update() {
                $c702e238df7c5123$var$_v1.setFromMatrixPosition(this.light.matrixWorld);
                $c702e238df7c5123$var$_v2.setFromMatrixPosition(this.light.target.matrixWorld);
                $c702e238df7c5123$var$_v3.subVectors($c702e238df7c5123$var$_v2, $c702e238df7c5123$var$_v1);
                this.lightPlane.lookAt($c702e238df7c5123$var$_v2);
                if (this.color !== undefined) {
                    this.lightPlane.material.color.set(this.color);
                    this.targetLine.material.color.set(this.color);
                } else {
                    this.lightPlane.material.color.copy(this.light.color);
                    this.targetLine.material.color.copy(this.light.color);
                }
                this.targetLine.lookAt($c702e238df7c5123$var$_v2);
                this.targetLine.scale.z = $c702e238df7c5123$var$_v3.length();
            }
        }
    ]);
    return DirectionalLightHelper;
}($c702e238df7c5123$export$e4dd07dff30cc924);
var $c702e238df7c5123$var$_vector = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_camera = /*@__PURE__*/ new $c702e238df7c5123$export$79f141de891a5fed();
/**
 *	- shows frustum, line of sight and up of the camera
 *	- suitable for fast updates
 * 	- based on frustum visualization in lightgl.js shadowmap example
 *		http://evanw.github.com/lightgl.js/tests/shadowmap.html
 */ var $c702e238df7c5123$export$ed8e93f853cd795 = /*#__PURE__*/ function(LineSegments) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(CameraHelper, LineSegments);
    function CameraHelper(camera) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, CameraHelper);
        var _this;
        var addLine = function addLine(a, b, color) {
            addPoint(a, color);
            addPoint(b, color);
        };
        var addPoint = function addPoint(id, color) {
            vertices.push(0, 0, 0);
            colors.push(color.r, color.g, color.b);
            if (pointMap[id] === undefined) pointMap[id] = [];
            pointMap[id].push(vertices.length / 3 - 1);
        };
        var geometry = new $c702e238df7c5123$export$b7be63a67df8959();
        var material = new $c702e238df7c5123$export$fbaaa33907730a0c({
            color: 0xffffff,
            vertexColors: true,
            toneMapped: false
        });
        var vertices = [];
        var colors = [];
        var pointMap = {};
        // colors
        var colorFrustum = new $c702e238df7c5123$export$892596cec99bc70e(0xffaa00);
        var colorCone = new $c702e238df7c5123$export$892596cec99bc70e(0xff0000);
        var colorUp = new $c702e238df7c5123$export$892596cec99bc70e(0x00aaff);
        var colorTarget = new $c702e238df7c5123$export$892596cec99bc70e(0xffffff);
        var colorCross = new $c702e238df7c5123$export$892596cec99bc70e(0x333333);
        // near
        addLine('n1', 'n2', colorFrustum);
        addLine('n2', 'n4', colorFrustum);
        addLine('n4', 'n3', colorFrustum);
        addLine('n3', 'n1', colorFrustum);
        // far
        addLine('f1', 'f2', colorFrustum);
        addLine('f2', 'f4', colorFrustum);
        addLine('f4', 'f3', colorFrustum);
        addLine('f3', 'f1', colorFrustum);
        // sides
        addLine('n1', 'f1', colorFrustum);
        addLine('n2', 'f2', colorFrustum);
        addLine('n3', 'f3', colorFrustum);
        addLine('n4', 'f4', colorFrustum);
        // cone
        addLine('p', 'n1', colorCone);
        addLine('p', 'n2', colorCone);
        addLine('p', 'n3', colorCone);
        addLine('p', 'n4', colorCone);
        // up
        addLine('u1', 'u2', colorUp);
        addLine('u2', 'u3', colorUp);
        addLine('u3', 'u1', colorUp);
        // target
        addLine('c', 't', colorTarget);
        addLine('p', 'c', colorCross);
        // cross
        addLine('cn1', 'cn2', colorCross);
        addLine('cn3', 'cn4', colorCross);
        addLine('cf1', 'cf2', colorCross);
        addLine('cf3', 'cf4', colorCross);
        geometry.setAttribute('position', new $c702e238df7c5123$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $c702e238df7c5123$export$cbe7a62641830ebd(colors, 3));
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, CameraHelper, [
            geometry,
            material
        ]);
        _this.type = 'CameraHelper';
        _this.camera = camera;
        if (_this.camera.updateProjectionMatrix) _this.camera.updateProjectionMatrix();
        _this.matrix = camera.matrixWorld;
        _this.matrixAutoUpdate = false;
        _this.pointMap = pointMap;
        _this.update();
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(CameraHelper, [
        {
            key: "update",
            value: function update() {
                var geometry = this.geometry;
                var pointMap = this.pointMap;
                var w = 1, h = 1;
                // we need just camera projection matrix inverse
                // world matrix must be identity
                $c702e238df7c5123$var$_camera.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse);
                // center / target
                $c702e238df7c5123$var$setPoint('c', pointMap, geometry, $c702e238df7c5123$var$_camera, 0, 0, -1);
                $c702e238df7c5123$var$setPoint('t', pointMap, geometry, $c702e238df7c5123$var$_camera, 0, 0, 1);
                // near
                $c702e238df7c5123$var$setPoint('n1', pointMap, geometry, $c702e238df7c5123$var$_camera, -w, -h, -1);
                $c702e238df7c5123$var$setPoint('n2', pointMap, geometry, $c702e238df7c5123$var$_camera, w, -h, -1);
                $c702e238df7c5123$var$setPoint('n3', pointMap, geometry, $c702e238df7c5123$var$_camera, -w, h, -1);
                $c702e238df7c5123$var$setPoint('n4', pointMap, geometry, $c702e238df7c5123$var$_camera, w, h, -1);
                // far
                $c702e238df7c5123$var$setPoint('f1', pointMap, geometry, $c702e238df7c5123$var$_camera, -w, -h, 1);
                $c702e238df7c5123$var$setPoint('f2', pointMap, geometry, $c702e238df7c5123$var$_camera, w, -h, 1);
                $c702e238df7c5123$var$setPoint('f3', pointMap, geometry, $c702e238df7c5123$var$_camera, -w, h, 1);
                $c702e238df7c5123$var$setPoint('f4', pointMap, geometry, $c702e238df7c5123$var$_camera, w, h, 1);
                // up
                $c702e238df7c5123$var$setPoint('u1', pointMap, geometry, $c702e238df7c5123$var$_camera, w * 0.7, h * 1.1, -1);
                $c702e238df7c5123$var$setPoint('u2', pointMap, geometry, $c702e238df7c5123$var$_camera, -w * 0.7, h * 1.1, -1);
                $c702e238df7c5123$var$setPoint('u3', pointMap, geometry, $c702e238df7c5123$var$_camera, 0, h * 2, -1);
                // cross
                $c702e238df7c5123$var$setPoint('cf1', pointMap, geometry, $c702e238df7c5123$var$_camera, -w, 0, 1);
                $c702e238df7c5123$var$setPoint('cf2', pointMap, geometry, $c702e238df7c5123$var$_camera, w, 0, 1);
                $c702e238df7c5123$var$setPoint('cf3', pointMap, geometry, $c702e238df7c5123$var$_camera, 0, -h, 1);
                $c702e238df7c5123$var$setPoint('cf4', pointMap, geometry, $c702e238df7c5123$var$_camera, 0, h, 1);
                $c702e238df7c5123$var$setPoint('cn1', pointMap, geometry, $c702e238df7c5123$var$_camera, -w, 0, -1);
                $c702e238df7c5123$var$setPoint('cn2', pointMap, geometry, $c702e238df7c5123$var$_camera, w, 0, -1);
                $c702e238df7c5123$var$setPoint('cn3', pointMap, geometry, $c702e238df7c5123$var$_camera, 0, -h, -1);
                $c702e238df7c5123$var$setPoint('cn4', pointMap, geometry, $c702e238df7c5123$var$_camera, 0, h, -1);
                geometry.getAttribute('position').needsUpdate = true;
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this.geometry.dispose();
                this.material.dispose();
            }
        }
    ]);
    return CameraHelper;
}($c702e238df7c5123$export$ff1ed10fedfdd604);
function $c702e238df7c5123$var$setPoint(point, pointMap, geometry, camera, x, y, z) {
    $c702e238df7c5123$var$_vector.set(x, y, z).unproject(camera);
    var points = pointMap[point];
    if (points !== undefined) {
        var position = geometry.getAttribute('position');
        for(var i = 0, l = points.length; i < l; i++)position.setXYZ(points[i], $c702e238df7c5123$var$_vector.x, $c702e238df7c5123$var$_vector.y, $c702e238df7c5123$var$_vector.z);
    }
}
var $c702e238df7c5123$var$_box = /*@__PURE__*/ new $c702e238df7c5123$export$6f7d5a9418ab2aa3();
var $c702e238df7c5123$export$38a664cc862a6a9d = /*#__PURE__*/ function(LineSegments1) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(BoxHelper, LineSegments1);
    function BoxHelper(object) {
        var color = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0xffff00;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, BoxHelper);
        var _this;
        var indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        var positions = new Float32Array(24);
        var geometry = new $c702e238df7c5123$export$b7be63a67df8959();
        geometry.setIndex(new $c702e238df7c5123$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute('position', new $c702e238df7c5123$export$8dea267bd6bde117(positions, 3));
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, BoxHelper, [
            geometry,
            new $c702e238df7c5123$export$fbaaa33907730a0c({
                color: color,
                toneMapped: false
            })
        ]);
        _this.object = object;
        _this.type = 'BoxHelper';
        _this.matrixAutoUpdate = false;
        _this.update();
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(BoxHelper, [
        {
            key: "update",
            value: function update(object) {
                if (object !== undefined) console.warn('THREE.BoxHelper: .update() has no longer arguments.');
                if (this.object !== undefined) $c702e238df7c5123$var$_box.setFromObject(this.object);
                if ($c702e238df7c5123$var$_box.isEmpty()) return;
                var min = $c702e238df7c5123$var$_box.min;
                var max = $c702e238df7c5123$var$_box.max;
                /*
			5____4
		1/___0/|
		| 6__|_7
		2/___3/

		0: max.x, max.y, max.z
		1: min.x, max.y, max.z
		2: min.x, min.y, max.z
		3: max.x, min.y, max.z
		4: max.x, max.y, min.z
		5: min.x, max.y, min.z
		6: min.x, min.y, min.z
		7: max.x, min.y, min.z
		*/ var position = this.geometry.attributes.position;
                var array = position.array;
                array[0] = max.x;
                array[1] = max.y;
                array[2] = max.z;
                array[3] = min.x;
                array[4] = max.y;
                array[5] = max.z;
                array[6] = min.x;
                array[7] = min.y;
                array[8] = max.z;
                array[9] = max.x;
                array[10] = min.y;
                array[11] = max.z;
                array[12] = max.x;
                array[13] = max.y;
                array[14] = min.z;
                array[15] = min.x;
                array[16] = max.y;
                array[17] = min.z;
                array[18] = min.x;
                array[19] = min.y;
                array[20] = min.z;
                array[21] = max.x;
                array[22] = min.y;
                array[23] = min.z;
                position.needsUpdate = true;
                this.geometry.computeBoundingSphere();
            }
        },
        {
            key: "setFromObject",
            value: function setFromObject(object) {
                this.object = object;
                this.update();
                return this;
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                $c702e238df7c5123$export$ff1ed10fedfdd604.prototype.copy.call(this, source);
                this.object = source.object;
                return this;
            }
        }
    ]);
    return BoxHelper;
}($c702e238df7c5123$export$ff1ed10fedfdd604);
var $c702e238df7c5123$export$ce39f4bb96c9a290 = /*#__PURE__*/ function(LineSegments) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(Box3Helper, LineSegments);
    function Box3Helper(box) {
        var color = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0xffff00;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, Box3Helper);
        var _this;
        var indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        var positions = [
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            -1
        ];
        var geometry = new $c702e238df7c5123$export$b7be63a67df8959();
        geometry.setIndex(new $c702e238df7c5123$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute('position', new $c702e238df7c5123$export$cbe7a62641830ebd(positions, 3));
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, Box3Helper, [
            geometry,
            new $c702e238df7c5123$export$fbaaa33907730a0c({
                color: color,
                toneMapped: false
            })
        ]);
        _this.box = box;
        _this.type = 'Box3Helper';
        _this.geometry.computeBoundingSphere();
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(Box3Helper, [
        {
            key: "updateMatrixWorld",
            value: function updateMatrixWorld(force) {
                var box = this.box;
                if (box.isEmpty()) return;
                box.getCenter(this.position);
                box.getSize(this.scale);
                this.scale.multiplyScalar(0.5);
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(Box3Helper.prototype), "updateMatrixWorld", this).call(this, force);
            }
        }
    ]);
    return Box3Helper;
}($c702e238df7c5123$export$ff1ed10fedfdd604);
var $c702e238df7c5123$export$a34fe8156c66e5d7 = /*#__PURE__*/ function(Line) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(PlaneHelper, Line);
    function PlaneHelper(plane) {
        var size = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, hex = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0xffff00;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, PlaneHelper);
        var _this;
        var color = hex;
        var positions = [
            1,
            -1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1,
            1,
            1,
            1,
            0,
            0,
            1,
            0,
            0,
            0
        ];
        var geometry = new $c702e238df7c5123$export$b7be63a67df8959();
        geometry.setAttribute('position', new $c702e238df7c5123$export$cbe7a62641830ebd(positions, 3));
        geometry.computeBoundingSphere();
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, PlaneHelper, [
            geometry,
            new $c702e238df7c5123$export$fbaaa33907730a0c({
                color: color,
                toneMapped: false
            })
        ]);
        _this.type = 'PlaneHelper';
        _this.plane = plane;
        _this.size = size;
        var positions2 = [
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1
        ];
        var geometry2 = new $c702e238df7c5123$export$b7be63a67df8959();
        geometry2.setAttribute('position', new $c702e238df7c5123$export$cbe7a62641830ebd(positions2, 3));
        geometry2.computeBoundingSphere();
        _this.add(new $c702e238df7c5123$export$e176487c05830cc5(geometry2, new $c702e238df7c5123$export$55cbcc9b622fe1f5({
            color: color,
            opacity: 0.2,
            transparent: true,
            depthWrite: false,
            toneMapped: false
        })));
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(PlaneHelper, [
        {
            key: "updateMatrixWorld",
            value: function updateMatrixWorld(force) {
                var scale = -this.plane.constant;
                if (Math.abs(scale) < 1e-8) scale = 1e-8; // sign does not matter
                this.scale.set(0.5 * this.size, 0.5 * this.size, scale);
                this.children[0].material.side = scale < 0 ? $c702e238df7c5123$export$d9f0486e75b5ace : $c702e238df7c5123$export$2ede184fc2998901; // renderer flips side when determinant < 0; flipping not wanted here
                this.lookAt(this.plane.normal);
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(PlaneHelper.prototype), "updateMatrixWorld", this).call(this, force);
            }
        }
    ]);
    return PlaneHelper;
}($c702e238df7c5123$export$17d680238e50603e);
var $c702e238df7c5123$var$_axis = /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699();
var $c702e238df7c5123$var$_lineGeometry, $c702e238df7c5123$var$_coneGeometry;
var $c702e238df7c5123$export$a3008e7bd8d2cbe7 = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(ArrowHelper, Object3D);
    function ArrowHelper() {
        var dir = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $c702e238df7c5123$export$64b5c384219d3699(0, 0, 1), origin = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $c702e238df7c5123$export$64b5c384219d3699(0, 0, 0), length = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, color = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0xffff00, headLength = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : length * 0.2, headWidth = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : headLength * 0.2;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, ArrowHelper);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, ArrowHelper);
        _this.type = 'ArrowHelper';
        if ($c702e238df7c5123$var$_lineGeometry === undefined) {
            $c702e238df7c5123$var$_lineGeometry = new $c702e238df7c5123$export$b7be63a67df8959();
            $c702e238df7c5123$var$_lineGeometry.setAttribute('position', new $c702e238df7c5123$export$cbe7a62641830ebd([
                0,
                0,
                0,
                0,
                1,
                0
            ], 3));
            $c702e238df7c5123$var$_coneGeometry = new $c702e238df7c5123$export$d4345c83207d7c68(0, 0.5, 1, 5, 1);
            $c702e238df7c5123$var$_coneGeometry.translate(0, -0.5, 0);
        }
        _this.position.copy(origin);
        _this.line = new $c702e238df7c5123$export$17d680238e50603e($c702e238df7c5123$var$_lineGeometry, new $c702e238df7c5123$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        _this.line.matrixAutoUpdate = false;
        _this.add(_this.line);
        _this.cone = new $c702e238df7c5123$export$e176487c05830cc5($c702e238df7c5123$var$_coneGeometry, new $c702e238df7c5123$export$55cbcc9b622fe1f5({
            color: color,
            toneMapped: false
        }));
        _this.cone.matrixAutoUpdate = false;
        _this.add(_this.cone);
        _this.setDirection(dir);
        _this.setLength(length, headLength, headWidth);
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(ArrowHelper, [
        {
            key: "setDirection",
            value: function setDirection(dir) {
                // dir is assumed to be normalized
                if (dir.y > 0.99999) this.quaternion.set(0, 0, 0, 1);
                else if (dir.y < -0.99999) this.quaternion.set(1, 0, 0, 0);
                else {
                    $c702e238df7c5123$var$_axis.set(dir.z, 0, -dir.x).normalize();
                    var radians = Math.acos(dir.y);
                    this.quaternion.setFromAxisAngle($c702e238df7c5123$var$_axis, radians);
                }
            }
        },
        {
            key: "setLength",
            value: function setLength(length) {
                var headLength = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : length * 0.2, headWidth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : headLength * 0.2;
                this.line.scale.set(1, Math.max(0.0001, length - headLength), 1); // see #17458
                this.line.updateMatrix();
                this.cone.scale.set(headWidth, headLength, headWidth);
                this.cone.position.y = length;
                this.cone.updateMatrix();
            }
        },
        {
            key: "setColor",
            value: function setColor(color) {
                this.line.material.color.set(color);
                this.cone.material.color.set(color);
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $7f1320a35f8074b1$export$71511d61b312f219)((0, $dd7760de693fac15$export$71511d61b312f219)(ArrowHelper.prototype), "copy", this).call(this, source, false);
                this.line.copy(source.line);
                this.cone.copy(source.cone);
                return this;
            }
        }
    ]);
    return ArrowHelper;
}($c702e238df7c5123$export$e4dd07dff30cc924);
var $c702e238df7c5123$export$6c8303f35b8578fd = /*#__PURE__*/ function(LineSegments) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(AxesHelper, LineSegments);
    function AxesHelper() {
        var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, AxesHelper);
        var _this;
        var vertices = [
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size
        ];
        var colors = [
            1,
            0,
            0,
            1,
            0.6,
            0,
            0,
            1,
            0,
            0.6,
            1,
            0,
            0,
            0,
            1,
            0,
            0.6,
            1
        ];
        var geometry = new $c702e238df7c5123$export$b7be63a67df8959();
        geometry.setAttribute('position', new $c702e238df7c5123$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $c702e238df7c5123$export$cbe7a62641830ebd(colors, 3));
        var material = new $c702e238df7c5123$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, AxesHelper, [
            geometry,
            material
        ]);
        _this.type = 'AxesHelper';
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(AxesHelper, [
        {
            key: "setColors",
            value: function setColors(xAxisColor, yAxisColor, zAxisColor) {
                var color = new $c702e238df7c5123$export$892596cec99bc70e();
                var array = this.geometry.attributes.color.array;
                color.set(xAxisColor);
                color.toArray(array, 0);
                color.toArray(array, 3);
                color.set(yAxisColor);
                color.toArray(array, 6);
                color.toArray(array, 9);
                color.set(zAxisColor);
                color.toArray(array, 12);
                color.toArray(array, 15);
                this.geometry.attributes.color.needsUpdate = true;
                return this;
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this.geometry.dispose();
                this.material.dispose();
            }
        }
    ]);
    return AxesHelper;
}($c702e238df7c5123$export$ff1ed10fedfdd604);
var $c702e238df7c5123$var$_floatView = new Float32Array(1);
var $c702e238df7c5123$var$_int32View = new Int32Array($c702e238df7c5123$var$_floatView.buffer);
var $c702e238df7c5123$export$11ce8b759162cc80 = /*#__PURE__*/ function() {
    "use strict";
    function DataUtils() {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, DataUtils);
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(DataUtils, null, [
        {
            key: "toHalfFloat",
            value: // Converts float32 to float16 (stored as uint16 value).
            function toHalfFloat(val) {
                // Source: http://gamedev.stackexchange.com/questions/17326/conversion-of-a-number-from-single-precision-floating-point-representation-to-a/17410#17410
                /* This method is faster than the OpenEXR implementation (very often
		* used, eg. in Ogre), with the additional benefit of rounding, inspired
		* by James Tursa?s half-precision code. */ $c702e238df7c5123$var$_floatView[0] = val;
                var x = $c702e238df7c5123$var$_int32View[0];
                var bits = x >> 16 & 0x8000; /* Get the sign */ 
                var m = x >> 12 & 0x07ff; /* Keep one extra bit for rounding */ 
                var e = x >> 23 & 0xff; /* Using int is faster here */ 
                /* If zero, or denormal, or exponent underflows too much for a denormal
			* half, return signed zero. */ if (e < 103) return bits;
                /* If NaN, return NaN. If Inf or exponent overflow, return Inf. */ if (e > 142) {
                    bits |= 0x7c00;
                    /* If exponent was 0xff and one mantissa bit was set, it means NaN,
						* not Inf, so make sure we set one mantissa bit too. */ bits |= (e == 255 ? 0 : 1) && x & 0x007fffff;
                    return bits;
                }
                /* If exponent underflows but not too much, return a denormal */ if (e < 113) {
                    m |= 0x0800;
                    /* Extra rounding may overflow and set mantissa to 0 and exponent
				* to 1, which is OK. */ bits |= (m >> 114 - e) + (m >> 113 - e & 1);
                    return bits;
                }
                bits |= e - 112 << 10 | m >> 1;
                /* Extra rounding. An overflow will set mantissa to 0 and increment
			* the exponent, which is OK. */ bits += m & 1;
                return bits;
            }
        }
    ]);
    return DataUtils;
}();
var $c702e238df7c5123$var$LOD_MIN = 4;
var $c702e238df7c5123$var$LOD_MAX = 8;
var $c702e238df7c5123$var$SIZE_MAX = Math.pow(2, $c702e238df7c5123$var$LOD_MAX);
// The standard deviations (radians) associated with the extra mips. These are
// chosen to approximate a Trowbridge-Reitz distribution function times the
// geometric shadowing function. These sigma values squared must match the
// variance #defines in cube_uv_reflection_fragment.glsl.js.
var $c702e238df7c5123$var$EXTRA_LOD_SIGMA = [
    0.125,
    0.215,
    0.35,
    0.446,
    0.526,
    0.582
];
var $c702e238df7c5123$var$TOTAL_LODS = $c702e238df7c5123$var$LOD_MAX - $c702e238df7c5123$var$LOD_MIN + 1 + $c702e238df7c5123$var$EXTRA_LOD_SIGMA.length;
// The maximum length of the blur for loop. Smaller sigmas will use fewer
// samples and exit early, but not recompile the shader.
var $c702e238df7c5123$var$MAX_SAMPLES = 20;
var $c702e238df7c5123$var$_obj1;
var $c702e238df7c5123$var$ENCODINGS = ($c702e238df7c5123$var$_obj1 = {}, (0, $c83f3a938e737400$export$71511d61b312f219)($c702e238df7c5123$var$_obj1, $c702e238df7c5123$export$7207336e4151a112, 0), (0, $c83f3a938e737400$export$71511d61b312f219)($c702e238df7c5123$var$_obj1, $c702e238df7c5123$export$f32388edbb32674, 1), (0, $c83f3a938e737400$export$71511d61b312f219)($c702e238df7c5123$var$_obj1, $c702e238df7c5123$export$3be4c466a12b5dcf, 2), (0, $c83f3a938e737400$export$71511d61b312f219)($c702e238df7c5123$var$_obj1, $c702e238df7c5123$export$2c4bdfd76b188654, 3), (0, $c83f3a938e737400$export$71511d61b312f219)($c702e238df7c5123$var$_obj1, $c702e238df7c5123$export$48a0051d6a5a9b9, 4), (0, $c83f3a938e737400$export$71511d61b312f219)($c702e238df7c5123$var$_obj1, $c702e238df7c5123$export$ca2f89b13b49d951, 5), (0, $c83f3a938e737400$export$71511d61b312f219)($c702e238df7c5123$var$_obj1, $c702e238df7c5123$export$eaab32c1bcea1817, 6), $c702e238df7c5123$var$_obj1);
var $c702e238df7c5123$var$backgroundMaterial = new $c702e238df7c5123$export$55cbcc9b622fe1f5({
    side: $c702e238df7c5123$export$d9f0486e75b5ace,
    depthWrite: false,
    depthTest: false
});
var $c702e238df7c5123$var$backgroundBox = new $c702e238df7c5123$export$e176487c05830cc5(new $c702e238df7c5123$export$ab3456a079aa7d80(), $c702e238df7c5123$var$backgroundMaterial);
var $c702e238df7c5123$var$_flatCamera = /*@__PURE__*/ new $c702e238df7c5123$export$9ebf355ee4ed261b();
var /*@__PURE__*/ $c702e238df7c5123$var$_$_createPlanes = $c702e238df7c5123$var$_createPlanes(), $c702e238df7c5123$var$_lodPlanes = $c702e238df7c5123$var$_$_createPlanes._lodPlanes, $c702e238df7c5123$var$_sizeLods = $c702e238df7c5123$var$_$_createPlanes._sizeLods, $c702e238df7c5123$var$_sigmas = $c702e238df7c5123$var$_$_createPlanes._sigmas;
var $c702e238df7c5123$var$_clearColor = /*@__PURE__*/ new $c702e238df7c5123$export$892596cec99bc70e();
var $c702e238df7c5123$var$_oldTarget = null;
// Golden Ratio
var $c702e238df7c5123$var$PHI = (1 + Math.sqrt(5)) / 2;
var $c702e238df7c5123$var$INV_PHI = 1 / $c702e238df7c5123$var$PHI;
// Vertices of a dodecahedron (except the opposites, which represent the
// same axis), used as axis directions evenly spread on a sphere.
var $c702e238df7c5123$var$_axisDirections = [
    /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699(1, 1, 1),
    /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699(-1, 1, 1),
    /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699(1, 1, -1),
    /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699(-1, 1, -1),
    /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699(0, $c702e238df7c5123$var$PHI, $c702e238df7c5123$var$INV_PHI),
    /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699(0, $c702e238df7c5123$var$PHI, -$c702e238df7c5123$var$INV_PHI),
    /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699($c702e238df7c5123$var$INV_PHI, 0, $c702e238df7c5123$var$PHI),
    /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699(-$c702e238df7c5123$var$INV_PHI, 0, $c702e238df7c5123$var$PHI),
    /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699($c702e238df7c5123$var$PHI, $c702e238df7c5123$var$INV_PHI, 0),
    /*@__PURE__*/ new $c702e238df7c5123$export$64b5c384219d3699(-$c702e238df7c5123$var$PHI, $c702e238df7c5123$var$INV_PHI, 0)
];
/**
 * This class generates a Prefiltered, Mipmapped Radiance Environment Map
 * (PMREM) from a cubeMap environment texture. This allows different levels of
 * blur to be quickly accessed based on material roughness. It is packed into a
 * special CubeUV format that allows us to perform custom interpolation so that
 * we can support nonlinear formats such as RGBE. Unlike a traditional mipmap
 * chain, it only goes down to the LOD_MIN level (above), and then creates extra
 * even more filtered 'mips' at the same LOD_MIN resolution, associated with
 * higher roughness levels. In this way we maintain resolution to smoothly
 * interpolate diffuse lighting while limiting sampling computation.
 *
 * Paper: Fast, Accurate Image-Based Lighting
 * https://drive.google.com/file/d/15y8r_UpKlU9SvV4ILb0C3qCPecS8pvLz/view
*/ function $c702e238df7c5123$var$convertLinearToRGBE(color) {
    var maxComponent = Math.max(color.r, color.g, color.b);
    var fExp = Math.min(Math.max(Math.ceil(Math.log2(maxComponent)), -128), 127.0);
    color.multiplyScalar(Math.pow(2.0, -fExp));
    var alpha = (fExp + 128.0) / 255.0;
    return alpha;
}
var $c702e238df7c5123$export$6add42717753e221 = /*#__PURE__*/ function() {
    "use strict";
    function PMREMGenerator(renderer) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, PMREMGenerator);
        this._renderer = renderer;
        this._pingPongRenderTarget = null;
        this._blurMaterial = $c702e238df7c5123$var$_getBlurShader($c702e238df7c5123$var$MAX_SAMPLES);
        this._equirectShader = null;
        this._cubemapShader = null;
        this._compileMaterial(this._blurMaterial);
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(PMREMGenerator, [
        {
            /**
	 * Generates a PMREM from a supplied Scene, which can be faster than using an
	 * image if networking bandwidth is low. Optional sigma specifies a blur radius
	 * in radians to be applied to the scene before PMREM generation. Optional near
	 * and far planes ensure the scene is rendered in its entirety (the cubeCamera
	 * is placed at the origin).
	 */ key: "fromScene",
            value: function fromScene(scene) {
                var sigma = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, near = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0.1, far = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 100;
                $c702e238df7c5123$var$_oldTarget = this._renderer.getRenderTarget();
                var cubeUVRenderTarget = this._allocateTargets();
                this._sceneToCubeUV(scene, near, far, cubeUVRenderTarget);
                if (sigma > 0) this._blur(cubeUVRenderTarget, 0, 0, sigma);
                this._applyPMREM(cubeUVRenderTarget);
                this._cleanup(cubeUVRenderTarget);
                return cubeUVRenderTarget;
            }
        },
        {
            /**
	 * Generates a PMREM from an equirectangular texture, which can be either LDR
	 * (RGBFormat) or HDR (RGBEFormat). The ideal input image size is 1k (1024 x 512),
	 * as this matches best with the 256 x 256 cubemap output.
	 */ key: "fromEquirectangular",
            value: function fromEquirectangular(equirectangular) {
                return this._fromTexture(equirectangular);
            }
        },
        {
            /**
	 * Generates a PMREM from an cubemap texture, which can be either LDR
	 * (RGBFormat) or HDR (RGBEFormat). The ideal input cube size is 256 x 256,
	 * as this matches best with the 256 x 256 cubemap output.
	 */ key: "fromCubemap",
            value: function fromCubemap(cubemap) {
                return this._fromTexture(cubemap);
            }
        },
        {
            /**
	 * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ key: "compileCubemapShader",
            value: function compileCubemapShader() {
                if (this._cubemapShader === null) {
                    this._cubemapShader = $c702e238df7c5123$var$_getCubemapShader();
                    this._compileMaterial(this._cubemapShader);
                }
            }
        },
        {
            /**
	 * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ key: "compileEquirectangularShader",
            value: function compileEquirectangularShader() {
                if (this._equirectShader === null) {
                    this._equirectShader = $c702e238df7c5123$var$_getEquirectShader();
                    this._compileMaterial(this._equirectShader);
                }
            }
        },
        {
            /**
	 * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
	 * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
	 * one of them will cause any others to also become unusable.
	 */ key: "dispose",
            value: function dispose() {
                this._blurMaterial.dispose();
                if (this._cubemapShader !== null) this._cubemapShader.dispose();
                if (this._equirectShader !== null) this._equirectShader.dispose();
                for(var i = 0; i < $c702e238df7c5123$var$_lodPlanes.length; i++)$c702e238df7c5123$var$_lodPlanes[i].dispose();
            }
        },
        {
            // private interface
            key: "_cleanup",
            value: function _cleanup(outputTarget) {
                this._pingPongRenderTarget.dispose();
                this._renderer.setRenderTarget($c702e238df7c5123$var$_oldTarget);
                outputTarget.scissorTest = false;
                $c702e238df7c5123$var$_setViewport(outputTarget, 0, 0, outputTarget.width, outputTarget.height);
            }
        },
        {
            key: "_fromTexture",
            value: function _fromTexture(texture) {
                $c702e238df7c5123$var$_oldTarget = this._renderer.getRenderTarget();
                var cubeUVRenderTarget = this._allocateTargets(texture);
                this._textureToCubeUV(texture, cubeUVRenderTarget);
                this._applyPMREM(cubeUVRenderTarget);
                this._cleanup(cubeUVRenderTarget);
                return cubeUVRenderTarget;
            }
        },
        {
            key: "_allocateTargets",
            value: function _allocateTargets(texture) {
                var params = {
                    magFilter: $c702e238df7c5123$export$727aa5ec3fe39bf0,
                    minFilter: $c702e238df7c5123$export$727aa5ec3fe39bf0,
                    generateMipmaps: false,
                    type: $c702e238df7c5123$export$2e8ce08d3f6f5e10,
                    format: $c702e238df7c5123$export$7f419e36e2229a1d,
                    encoding: $c702e238df7c5123$var$_isLDR(texture) ? texture.encoding : $c702e238df7c5123$export$3be4c466a12b5dcf,
                    depthBuffer: false
                };
                var cubeUVRenderTarget = $c702e238df7c5123$var$_createRenderTarget(params);
                cubeUVRenderTarget.depthBuffer = texture ? false : true;
                this._pingPongRenderTarget = $c702e238df7c5123$var$_createRenderTarget(params);
                return cubeUVRenderTarget;
            }
        },
        {
            key: "_compileMaterial",
            value: function _compileMaterial(material) {
                var tmpMesh = new $c702e238df7c5123$export$e176487c05830cc5($c702e238df7c5123$var$_lodPlanes[0], material);
                this._renderer.compile(tmpMesh, $c702e238df7c5123$var$_flatCamera);
            }
        },
        {
            key: "_sceneToCubeUV",
            value: function _sceneToCubeUV(scene, near, far, cubeUVRenderTarget) {
                var fov = 90;
                var aspect = 1;
                var cubeCamera = new $c702e238df7c5123$export$74e4ae24825f68d7(fov, aspect, near, far);
                var upSign = [
                    1,
                    -1,
                    1,
                    1,
                    1,
                    1
                ];
                var forwardSign = [
                    1,
                    1,
                    1,
                    -1,
                    -1,
                    -1
                ];
                var renderer = this._renderer;
                var originalAutoClear = renderer.autoClear;
                var outputEncoding = renderer.outputEncoding;
                var toneMapping = renderer.toneMapping;
                renderer.getClearColor($c702e238df7c5123$var$_clearColor);
                renderer.toneMapping = $c702e238df7c5123$export$9fcb6b4294603b2;
                renderer.outputEncoding = $c702e238df7c5123$export$7207336e4151a112;
                renderer.autoClear = false;
                var useSolidColor = false;
                var background = scene.background;
                if (background) {
                    if (background.isColor) {
                        $c702e238df7c5123$var$backgroundMaterial.color.copy(background).convertSRGBToLinear();
                        scene.background = null;
                        var alpha = $c702e238df7c5123$var$convertLinearToRGBE($c702e238df7c5123$var$backgroundMaterial.color);
                        $c702e238df7c5123$var$backgroundMaterial.opacity = alpha;
                        useSolidColor = true;
                    }
                } else {
                    $c702e238df7c5123$var$backgroundMaterial.color.copy($c702e238df7c5123$var$_clearColor).convertSRGBToLinear();
                    var alpha1 = $c702e238df7c5123$var$convertLinearToRGBE($c702e238df7c5123$var$backgroundMaterial.color);
                    $c702e238df7c5123$var$backgroundMaterial.opacity = alpha1;
                    useSolidColor = true;
                }
                for(var i = 0; i < 6; i++){
                    var col = i % 3;
                    if (col == 0) {
                        cubeCamera.up.set(0, upSign[i], 0);
                        cubeCamera.lookAt(forwardSign[i], 0, 0);
                    } else if (col == 1) {
                        cubeCamera.up.set(0, 0, upSign[i]);
                        cubeCamera.lookAt(0, forwardSign[i], 0);
                    } else {
                        cubeCamera.up.set(0, upSign[i], 0);
                        cubeCamera.lookAt(0, 0, forwardSign[i]);
                    }
                    $c702e238df7c5123$var$_setViewport(cubeUVRenderTarget, col * $c702e238df7c5123$var$SIZE_MAX, i > 2 ? $c702e238df7c5123$var$SIZE_MAX : 0, $c702e238df7c5123$var$SIZE_MAX, $c702e238df7c5123$var$SIZE_MAX);
                    renderer.setRenderTarget(cubeUVRenderTarget);
                    if (useSolidColor) renderer.render($c702e238df7c5123$var$backgroundBox, cubeCamera);
                    renderer.render(scene, cubeCamera);
                }
                renderer.toneMapping = toneMapping;
                renderer.outputEncoding = outputEncoding;
                renderer.autoClear = originalAutoClear;
            }
        },
        {
            key: "_textureToCubeUV",
            value: function _textureToCubeUV(texture, cubeUVRenderTarget) {
                var renderer = this._renderer;
                if (texture.isCubeTexture) {
                    if (this._cubemapShader == null) this._cubemapShader = $c702e238df7c5123$var$_getCubemapShader();
                } else if (this._equirectShader == null) this._equirectShader = $c702e238df7c5123$var$_getEquirectShader();
                var material = texture.isCubeTexture ? this._cubemapShader : this._equirectShader;
                var mesh = new $c702e238df7c5123$export$e176487c05830cc5($c702e238df7c5123$var$_lodPlanes[0], material);
                var uniforms = material.uniforms;
                uniforms['envMap'].value = texture;
                if (!texture.isCubeTexture) uniforms['texelSize'].value.set(1.0 / texture.image.width, 1.0 / texture.image.height);
                uniforms['inputEncoding'].value = $c702e238df7c5123$var$ENCODINGS[texture.encoding];
                uniforms['outputEncoding'].value = $c702e238df7c5123$var$ENCODINGS[cubeUVRenderTarget.texture.encoding];
                $c702e238df7c5123$var$_setViewport(cubeUVRenderTarget, 0, 0, 3 * $c702e238df7c5123$var$SIZE_MAX, 2 * $c702e238df7c5123$var$SIZE_MAX);
                renderer.setRenderTarget(cubeUVRenderTarget);
                renderer.render(mesh, $c702e238df7c5123$var$_flatCamera);
            }
        },
        {
            key: "_applyPMREM",
            value: function _applyPMREM(cubeUVRenderTarget) {
                var renderer = this._renderer;
                var autoClear = renderer.autoClear;
                renderer.autoClear = false;
                for(var i = 1; i < $c702e238df7c5123$var$TOTAL_LODS; i++){
                    var sigma = Math.sqrt($c702e238df7c5123$var$_sigmas[i] * $c702e238df7c5123$var$_sigmas[i] - $c702e238df7c5123$var$_sigmas[i - 1] * $c702e238df7c5123$var$_sigmas[i - 1]);
                    var poleAxis = $c702e238df7c5123$var$_axisDirections[(i - 1) % $c702e238df7c5123$var$_axisDirections.length];
                    this._blur(cubeUVRenderTarget, i - 1, i, sigma, poleAxis);
                }
                renderer.autoClear = autoClear;
            }
        },
        {
            /**
	 * This is a two-pass Gaussian blur for a cubemap. Normally this is done
	 * vertically and horizontally, but this breaks down on a cube. Here we apply
	 * the blur latitudinally (around the poles), and then longitudinally (towards
	 * the poles) to approximate the orthogonally-separable blur. It is least
	 * accurate at the poles, but still does a decent job.
	 */ key: "_blur",
            value: function _blur(cubeUVRenderTarget, lodIn, lodOut, sigma, poleAxis) {
                var pingPongRenderTarget = this._pingPongRenderTarget;
                this._halfBlur(cubeUVRenderTarget, pingPongRenderTarget, lodIn, lodOut, sigma, 'latitudinal', poleAxis);
                this._halfBlur(pingPongRenderTarget, cubeUVRenderTarget, lodOut, lodOut, sigma, 'longitudinal', poleAxis);
            }
        },
        {
            key: "_halfBlur",
            value: function _halfBlur(targetIn, targetOut, lodIn, lodOut, sigmaRadians, direction, poleAxis) {
                var renderer = this._renderer;
                var blurMaterial = this._blurMaterial;
                if (direction !== 'latitudinal' && direction !== 'longitudinal') console.error('blur direction must be either latitudinal or longitudinal!');
                // Number of standard deviations at which to cut off the discrete approximation.
                var STANDARD_DEVIATIONS = 3;
                var blurMesh = new $c702e238df7c5123$export$e176487c05830cc5($c702e238df7c5123$var$_lodPlanes[lodOut], blurMaterial);
                var blurUniforms = blurMaterial.uniforms;
                var pixels = $c702e238df7c5123$var$_sizeLods[lodIn] - 1;
                var radiansPerPixel = isFinite(sigmaRadians) ? Math.PI / (2 * pixels) : 2 * Math.PI / (2 * $c702e238df7c5123$var$MAX_SAMPLES - 1);
                var sigmaPixels = sigmaRadians / radiansPerPixel;
                var samples = isFinite(sigmaRadians) ? 1 + Math.floor(STANDARD_DEVIATIONS * sigmaPixels) : $c702e238df7c5123$var$MAX_SAMPLES;
                if (samples > $c702e238df7c5123$var$MAX_SAMPLES) console.warn("sigmaRadians, ".concat(sigmaRadians, ", is too large and will clip, as it requested ").concat(samples, " samples when the maximum is set to ").concat($c702e238df7c5123$var$MAX_SAMPLES));
                var weights = [];
                var sum = 0;
                for(var i = 0; i < $c702e238df7c5123$var$MAX_SAMPLES; ++i){
                    var x = i / sigmaPixels;
                    var weight = Math.exp(-x * x / 2);
                    weights.push(weight);
                    if (i == 0) sum += weight;
                    else if (i < samples) sum += 2 * weight;
                }
                for(var i1 = 0; i1 < weights.length; i1++)weights[i1] = weights[i1] / sum;
                blurUniforms['envMap'].value = targetIn.texture;
                blurUniforms['samples'].value = samples;
                blurUniforms['weights'].value = weights;
                blurUniforms['latitudinal'].value = direction === 'latitudinal';
                if (poleAxis) blurUniforms['poleAxis'].value = poleAxis;
                blurUniforms['dTheta'].value = radiansPerPixel;
                blurUniforms['mipInt'].value = $c702e238df7c5123$var$LOD_MAX - lodIn;
                blurUniforms['inputEncoding'].value = $c702e238df7c5123$var$ENCODINGS[targetIn.texture.encoding];
                blurUniforms['outputEncoding'].value = $c702e238df7c5123$var$ENCODINGS[targetIn.texture.encoding];
                var outputSize = $c702e238df7c5123$var$_sizeLods[lodOut];
                var x1 = 3 * Math.max(0, $c702e238df7c5123$var$SIZE_MAX - 2 * outputSize);
                var y = (lodOut === 0 ? 0 : 2 * $c702e238df7c5123$var$SIZE_MAX) + 2 * outputSize * (lodOut > $c702e238df7c5123$var$LOD_MAX - $c702e238df7c5123$var$LOD_MIN ? lodOut - $c702e238df7c5123$var$LOD_MAX + $c702e238df7c5123$var$LOD_MIN : 0);
                $c702e238df7c5123$var$_setViewport(targetOut, x1, y, 3 * outputSize, 2 * outputSize);
                renderer.setRenderTarget(targetOut);
                renderer.render(blurMesh, $c702e238df7c5123$var$_flatCamera);
            }
        }
    ]);
    return PMREMGenerator;
}();
function $c702e238df7c5123$var$_isLDR(texture) {
    if (texture === undefined || texture.type !== $c702e238df7c5123$export$2e8ce08d3f6f5e10) return false;
    return texture.encoding === $c702e238df7c5123$export$7207336e4151a112 || texture.encoding === $c702e238df7c5123$export$f32388edbb32674 || texture.encoding === $c702e238df7c5123$export$eaab32c1bcea1817;
}
function $c702e238df7c5123$var$_createPlanes() {
    var _lodPlanes = [];
    var _sizeLods = [];
    var _sigmas = [];
    var lod = $c702e238df7c5123$var$LOD_MAX;
    for(var i = 0; i < $c702e238df7c5123$var$TOTAL_LODS; i++){
        var sizeLod = Math.pow(2, lod);
        _sizeLods.push(sizeLod);
        var sigma = 1.0 / sizeLod;
        if (i > $c702e238df7c5123$var$LOD_MAX - $c702e238df7c5123$var$LOD_MIN) sigma = $c702e238df7c5123$var$EXTRA_LOD_SIGMA[i - $c702e238df7c5123$var$LOD_MAX + $c702e238df7c5123$var$LOD_MIN - 1];
        else if (i == 0) sigma = 0;
        _sigmas.push(sigma);
        var texelSize = 1.0 / (sizeLod - 1);
        var min = -texelSize / 2;
        var max = 1 + texelSize / 2;
        var uv1 = [
            min,
            min,
            max,
            min,
            max,
            max,
            min,
            min,
            max,
            max,
            min,
            max
        ];
        var cubeFaces = 6;
        var vertices = 6;
        var positionSize = 3;
        var uvSize = 2;
        var faceIndexSize = 1;
        var position = new Float32Array(positionSize * vertices * cubeFaces);
        var uv = new Float32Array(uvSize * vertices * cubeFaces);
        var faceIndex = new Float32Array(faceIndexSize * vertices * cubeFaces);
        for(var face = 0; face < cubeFaces; face++){
            var x = face % 3 * 2 / 3 - 1;
            var y = face > 2 ? 0 : -1;
            var coordinates = [
                x,
                y,
                0,
                x + 2 / 3,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y + 1,
                0
            ];
            position.set(coordinates, positionSize * vertices * face);
            uv.set(uv1, uvSize * vertices * face);
            var fill = [
                face,
                face,
                face,
                face,
                face,
                face
            ];
            faceIndex.set(fill, faceIndexSize * vertices * face);
        }
        var planes = new $c702e238df7c5123$export$b7be63a67df8959();
        planes.setAttribute('position', new $c702e238df7c5123$export$8dea267bd6bde117(position, positionSize));
        planes.setAttribute('uv', new $c702e238df7c5123$export$8dea267bd6bde117(uv, uvSize));
        planes.setAttribute('faceIndex', new $c702e238df7c5123$export$8dea267bd6bde117(faceIndex, faceIndexSize));
        _lodPlanes.push(planes);
        if (lod > $c702e238df7c5123$var$LOD_MIN) lod--;
    }
    return {
        _lodPlanes: _lodPlanes,
        _sizeLods: _sizeLods,
        _sigmas: _sigmas
    };
}
function $c702e238df7c5123$var$_createRenderTarget(params) {
    var cubeUVRenderTarget = new $c702e238df7c5123$export$3c052beb2e51e23f(3 * $c702e238df7c5123$var$SIZE_MAX, 3 * $c702e238df7c5123$var$SIZE_MAX, params);
    cubeUVRenderTarget.texture.mapping = $c702e238df7c5123$export$dbf3e70ff37af79;
    cubeUVRenderTarget.texture.name = 'PMREM.cubeUv';
    cubeUVRenderTarget.scissorTest = true;
    return cubeUVRenderTarget;
}
function $c702e238df7c5123$var$_setViewport(target, x, y, width, height) {
    target.viewport.set(x, y, width, height);
    target.scissor.set(x, y, width, height);
}
function $c702e238df7c5123$var$_getBlurShader(maxSamples) {
    var weights = new Float32Array(maxSamples);
    var poleAxis = new $c702e238df7c5123$export$64b5c384219d3699(0, 1, 0);
    var shaderMaterial = new $c702e238df7c5123$export$21c421a2e1df9d22({
        name: 'SphericalGaussianBlur',
        defines: {
            n: maxSamples
        },
        uniforms: {
            envMap: {
                value: null
            },
            samples: {
                value: 1
            },
            weights: {
                value: weights
            },
            latitudinal: {
                value: false
            },
            dTheta: {
                value: 0
            },
            mipInt: {
                value: 0
            },
            poleAxis: {
                value: poleAxis
            },
            inputEncoding: {
                value: $c702e238df7c5123$var$ENCODINGS[$c702e238df7c5123$export$7207336e4151a112]
            },
            outputEncoding: {
                value: $c702e238df7c5123$var$ENCODINGS[$c702e238df7c5123$export$7207336e4151a112]
            }
        },
        vertexShader: $c702e238df7c5123$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ "\n\n			precision mediump float;\n			precision mediump int;\n\n			varying vec3 vOutputDirection;\n\n			uniform sampler2D envMap;\n			uniform int samples;\n			uniform float weights[ n ];\n			uniform bool latitudinal;\n			uniform float dTheta;\n			uniform float mipInt;\n			uniform vec3 poleAxis;\n\n			".concat($c702e238df7c5123$var$_getEncodings(), "\n\n			#define ENVMAP_TYPE_CUBE_UV\n			#include <cube_uv_reflection_fragment>\n\n			vec3 getSample( float theta, vec3 axis ) {\n\n				float cosTheta = cos( theta );\n				// Rodrigues' axis-angle rotation\n				vec3 sampleDirection = vOutputDirection * cosTheta\n					+ cross( axis, vOutputDirection ) * sin( theta )\n					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );\n\n				return bilinearCubeUV( envMap, sampleDirection, mipInt );\n\n			}\n\n			void main() {\n\n				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );\n\n				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {\n\n					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );\n\n				}\n\n				axis = normalize( axis );\n\n				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );\n\n				for ( int i = 1; i < n; i++ ) {\n\n					if ( i >= samples ) {\n\n						break;\n\n					}\n\n					float theta = dTheta * float( i );\n					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );\n					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );\n\n				}\n\n				gl_FragColor = linearToOutputTexel( gl_FragColor );\n\n			}\n		"),
        blending: $c702e238df7c5123$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
    return shaderMaterial;
}
function $c702e238df7c5123$var$_getEquirectShader() {
    var texelSize = new $c702e238df7c5123$export$c977b3e384af9ae1(1, 1);
    var shaderMaterial = new $c702e238df7c5123$export$21c421a2e1df9d22({
        name: 'EquirectangularToCubeUV',
        uniforms: {
            envMap: {
                value: null
            },
            texelSize: {
                value: texelSize
            },
            inputEncoding: {
                value: $c702e238df7c5123$var$ENCODINGS[$c702e238df7c5123$export$7207336e4151a112]
            },
            outputEncoding: {
                value: $c702e238df7c5123$var$ENCODINGS[$c702e238df7c5123$export$7207336e4151a112]
            }
        },
        vertexShader: $c702e238df7c5123$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ "\n\n			precision mediump float;\n			precision mediump int;\n\n			varying vec3 vOutputDirection;\n\n			uniform sampler2D envMap;\n			uniform vec2 texelSize;\n\n			".concat($c702e238df7c5123$var$_getEncodings(), "\n\n			#include <common>\n\n			void main() {\n\n				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n\n				vec3 outputDirection = normalize( vOutputDirection );\n				vec2 uv = equirectUv( outputDirection );\n\n				vec2 f = fract( uv / texelSize - 0.5 );\n				uv -= f * texelSize;\n				vec3 tl = envMapTexelToLinear( texture2D ( envMap, uv ) ).rgb;\n				uv.x += texelSize.x;\n				vec3 tr = envMapTexelToLinear( texture2D ( envMap, uv ) ).rgb;\n				uv.y += texelSize.y;\n				vec3 br = envMapTexelToLinear( texture2D ( envMap, uv ) ).rgb;\n				uv.x -= texelSize.x;\n				vec3 bl = envMapTexelToLinear( texture2D ( envMap, uv ) ).rgb;\n\n				vec3 tm = mix( tl, tr, f.x );\n				vec3 bm = mix( bl, br, f.x );\n				gl_FragColor.rgb = mix( tm, bm, f.y );\n\n				gl_FragColor = linearToOutputTexel( gl_FragColor );\n\n			}\n		"),
        blending: $c702e238df7c5123$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
    return shaderMaterial;
}
function $c702e238df7c5123$var$_getCubemapShader() {
    var shaderMaterial = new $c702e238df7c5123$export$21c421a2e1df9d22({
        name: 'CubemapToCubeUV',
        uniforms: {
            envMap: {
                value: null
            },
            inputEncoding: {
                value: $c702e238df7c5123$var$ENCODINGS[$c702e238df7c5123$export$7207336e4151a112]
            },
            outputEncoding: {
                value: $c702e238df7c5123$var$ENCODINGS[$c702e238df7c5123$export$7207336e4151a112]
            }
        },
        vertexShader: $c702e238df7c5123$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ "\n\n			precision mediump float;\n			precision mediump int;\n\n			varying vec3 vOutputDirection;\n\n			uniform samplerCube envMap;\n\n			".concat($c702e238df7c5123$var$_getEncodings(), "\n\n			void main() {\n\n				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n				gl_FragColor.rgb = envMapTexelToLinear( textureCube( envMap, vec3( - vOutputDirection.x, vOutputDirection.yz ) ) ).rgb;\n				gl_FragColor = linearToOutputTexel( gl_FragColor );\n\n			}\n		"),
        blending: $c702e238df7c5123$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
    return shaderMaterial;
}
function $c702e238df7c5123$var$_getCommonVertexShader() {
    return "\n\n		precision mediump float;\n		precision mediump int;\n\n		attribute vec3 position;\n		attribute vec2 uv;\n		attribute float faceIndex;\n\n		varying vec3 vOutputDirection;\n\n		// RH coordinate system; PMREM face-indexing convention\n		vec3 getDirection( vec2 uv, float face ) {\n\n			uv = 2.0 * uv - 1.0;\n\n			vec3 direction = vec3( uv, 1.0 );\n\n			if ( face == 0.0 ) {\n\n				direction = direction.zyx; // ( 1, v, u ) pos x\n\n			} else if ( face == 1.0 ) {\n\n				direction = direction.xzy;\n				direction.xz *= -1.0; // ( -u, 1, -v ) pos y\n\n			} else if ( face == 2.0 ) {\n\n				direction.x *= -1.0; // ( -u, v, 1 ) pos z\n\n			} else if ( face == 3.0 ) {\n\n				direction = direction.zyx;\n				direction.xz *= -1.0; // ( -1, v, -u ) neg x\n\n			} else if ( face == 4.0 ) {\n\n				direction = direction.xzy;\n				direction.xy *= -1.0; // ( -u, -1, v ) neg y\n\n			} else if ( face == 5.0 ) {\n\n				direction.z *= -1.0; // ( u, v, -1 ) neg z\n\n			}\n\n			return direction;\n\n		}\n\n		void main() {\n\n			vOutputDirection = getDirection( uv, faceIndex );\n			gl_Position = vec4( position, 1.0 );\n\n		}\n	";
}
function $c702e238df7c5123$var$_getEncodings() {
    return "\n\n		uniform int inputEncoding;\n		uniform int outputEncoding;\n\n		#include <encodings_pars_fragment>\n\n		vec4 inputTexelToLinear( vec4 value ) {\n\n			if ( inputEncoding == 0 ) {\n\n				return value;\n\n			} else if ( inputEncoding == 1 ) {\n\n				return sRGBToLinear( value );\n\n			} else if ( inputEncoding == 2 ) {\n\n				return RGBEToLinear( value );\n\n			} else if ( inputEncoding == 3 ) {\n\n				return RGBMToLinear( value, 7.0 );\n\n			} else if ( inputEncoding == 4 ) {\n\n				return RGBMToLinear( value, 16.0 );\n\n			} else if ( inputEncoding == 5 ) {\n\n				return RGBDToLinear( value, 256.0 );\n\n			} else {\n\n				return GammaToLinear( value, 2.2 );\n\n			}\n\n		}\n\n		vec4 linearToOutputTexel( vec4 value ) {\n\n			if ( outputEncoding == 0 ) {\n\n				return value;\n\n			} else if ( outputEncoding == 1 ) {\n\n				return LinearTosRGB( value );\n\n			} else if ( outputEncoding == 2 ) {\n\n				return LinearToRGBE( value );\n\n			} else if ( outputEncoding == 3 ) {\n\n				return LinearToRGBM( value, 7.0 );\n\n			} else if ( outputEncoding == 4 ) {\n\n				return LinearToRGBM( value, 16.0 );\n\n			} else if ( outputEncoding == 5 ) {\n\n				return LinearToRGBD( value, 256.0 );\n\n			} else {\n\n				return LinearToGamma( value, 2.2 );\n\n			}\n\n		}\n\n		vec4 envMapTexelToLinear( vec4 color ) {\n\n			return inputTexelToLinear( color );\n\n		}\n	";
}
var $c702e238df7c5123$export$195910b613d3dbcb = 0;
var $c702e238df7c5123$export$c8a71586e494fb81 = 1;
var $c702e238df7c5123$export$1a5c46edbdc9a5b7 = 0;
var $c702e238df7c5123$export$617e978cc3201d85 = 1;
var $c702e238df7c5123$export$969ede3d37172881 = 2;
function $c702e238df7c5123$export$8f0d8c869214e38a(materials) {
    console.warn('THREE.MeshFaceMaterial has been removed. Use an Array instead.');
    return materials;
}
function $c702e238df7c5123$export$4f1842f7cdf61f78() {
    var materials = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    console.warn('THREE.MultiMaterial has been removed. Use an Array instead.');
    materials.isMultiMaterial = true;
    materials.materials = materials;
    materials.clone = function() {
        return materials.slice();
    };
    return materials;
}
function $c702e238df7c5123$export$5c812f854e08d33d(geometry, material) {
    console.warn('THREE.PointCloud has been renamed to THREE.Points.');
    return new $c702e238df7c5123$export$1c787534cb11aa3e(geometry, material);
}
function $c702e238df7c5123$export$c36c68baa13912a5(material) {
    console.warn('THREE.Particle has been renamed to THREE.Sprite.');
    return new $c702e238df7c5123$export$3075603db8e6204c(material);
}
function $c702e238df7c5123$export$f219b6a0e4bb0b6d(geometry, material) {
    console.warn('THREE.ParticleSystem has been renamed to THREE.Points.');
    return new $c702e238df7c5123$export$1c787534cb11aa3e(geometry, material);
}
function $c702e238df7c5123$export$29121d9ccd2f757a(parameters) {
    console.warn('THREE.PointCloudMaterial has been renamed to THREE.PointsMaterial.');
    return new $c702e238df7c5123$export$a178c45366ce5d6b(parameters);
}
function $c702e238df7c5123$export$ffa02580217a1c8(parameters) {
    console.warn('THREE.ParticleBasicMaterial has been renamed to THREE.PointsMaterial.');
    return new $c702e238df7c5123$export$a178c45366ce5d6b(parameters);
}
function $c702e238df7c5123$export$cb1306c614c86e6b(parameters) {
    console.warn('THREE.ParticleSystemMaterial has been renamed to THREE.PointsMaterial.');
    return new $c702e238df7c5123$export$a178c45366ce5d6b(parameters);
}
function $c702e238df7c5123$export$3e8a3cc8713efbec(x, y, z) {
    console.warn('THREE.Vertex has been removed. Use THREE.Vector3 instead.');
    return new $c702e238df7c5123$export$64b5c384219d3699(x, y, z);
}
//
function $c702e238df7c5123$export$189ab5ea9d161e81(array, itemSize) {
    console.warn('THREE.DynamicBufferAttribute has been removed. Use new THREE.BufferAttribute().setUsage( THREE.DynamicDrawUsage ) instead.');
    return new $c702e238df7c5123$export$8dea267bd6bde117(array, itemSize).setUsage($c702e238df7c5123$export$8505d14ac8546ca);
}
function $c702e238df7c5123$export$e0ae4f0a1804ea11(array, itemSize) {
    console.warn('THREE.Int8Attribute has been removed. Use new THREE.Int8BufferAttribute() instead.');
    return new $c702e238df7c5123$export$f9ff2d6a20248cbf(array, itemSize);
}
function $c702e238df7c5123$export$a0d192e03a5b32f5(array, itemSize) {
    console.warn('THREE.Uint8Attribute has been removed. Use new THREE.Uint8BufferAttribute() instead.');
    return new $c702e238df7c5123$export$cacc90cf35d11cdd(array, itemSize);
}
function $c702e238df7c5123$export$8ca743ab36552bfa(array, itemSize) {
    console.warn('THREE.Uint8ClampedAttribute has been removed. Use new THREE.Uint8ClampedBufferAttribute() instead.');
    return new $c702e238df7c5123$export$baaa85a1a812c157(array, itemSize);
}
function $c702e238df7c5123$export$5d9757676aad9dab(array, itemSize) {
    console.warn('THREE.Int16Attribute has been removed. Use new THREE.Int16BufferAttribute() instead.');
    return new $c702e238df7c5123$export$2b755a102ccdcefe(array, itemSize);
}
function $c702e238df7c5123$export$ed102ffd14092320(array, itemSize) {
    console.warn('THREE.Uint16Attribute has been removed. Use new THREE.Uint16BufferAttribute() instead.');
    return new $c702e238df7c5123$export$640a853f68025f2e(array, itemSize);
}
function $c702e238df7c5123$export$6acc479034658f15(array, itemSize) {
    console.warn('THREE.Int32Attribute has been removed. Use new THREE.Int32BufferAttribute() instead.');
    return new $c702e238df7c5123$export$46b369aed2968a0a(array, itemSize);
}
function $c702e238df7c5123$export$53474877d6e539b9(array, itemSize) {
    console.warn('THREE.Uint32Attribute has been removed. Use new THREE.Uint32BufferAttribute() instead.');
    return new $c702e238df7c5123$export$7eb8c9fa25cd5bd6(array, itemSize);
}
function $c702e238df7c5123$export$377af6eadc8006c3(array, itemSize) {
    console.warn('THREE.Float32Attribute has been removed. Use new THREE.Float32BufferAttribute() instead.');
    return new $c702e238df7c5123$export$cbe7a62641830ebd(array, itemSize);
}
function $c702e238df7c5123$export$b9212d1a67b6f081(array, itemSize) {
    console.warn('THREE.Float64Attribute has been removed. Use new THREE.Float64BufferAttribute() instead.');
    return new $c702e238df7c5123$export$9e0ade74842adbb8(array, itemSize);
}
//
$c702e238df7c5123$export$b0e83c3ef8d2db1.create = function(construct, getPoint) {
    console.log('THREE.Curve.create() has been deprecated');
    construct.prototype = Object.create($c702e238df7c5123$export$b0e83c3ef8d2db1.prototype);
    construct.prototype.constructor = construct;
    construct.prototype.getPoint = getPoint;
    return construct;
};
//
$c702e238df7c5123$export$4b2950bdac9b6ee9.prototype.fromPoints = function(points) {
    console.warn('THREE.Path: .fromPoints() has been renamed to .setFromPoints().');
    return this.setFromPoints(points);
};
//
function $c702e238df7c5123$export$46c1eaab6b8d1e23(size) {
    console.warn('THREE.AxisHelper has been renamed to THREE.AxesHelper.');
    return new $c702e238df7c5123$export$6c8303f35b8578fd(size);
}
function $c702e238df7c5123$export$3c24c67720a2146c(object, color) {
    console.warn('THREE.BoundingBoxHelper has been deprecated. Creating a THREE.BoxHelper instead.');
    return new $c702e238df7c5123$export$38a664cc862a6a9d(object, color);
}
function $c702e238df7c5123$export$e341a90264c62d4c(object, hex) {
    console.warn('THREE.EdgesHelper has been removed. Use THREE.EdgesGeometry instead.');
    return new $c702e238df7c5123$export$ff1ed10fedfdd604(new $c702e238df7c5123$export$4730b1542707547f(object.geometry), new $c702e238df7c5123$export$fbaaa33907730a0c({
        color: hex !== undefined ? hex : 0xffffff
    }));
}
$c702e238df7c5123$export$3875d39926561055.prototype.setColors = function() {
    console.error('THREE.GridHelper: setColors() has been deprecated, pass them in the constructor instead.');
};
$c702e238df7c5123$export$5277df3c9e732259.prototype.update = function() {
    console.error('THREE.SkeletonHelper: update() no longer needs to be called.');
};
function $c702e238df7c5123$export$72d033539c529f13(object, hex) {
    console.warn('THREE.WireframeHelper has been removed. Use THREE.WireframeGeometry instead.');
    return new $c702e238df7c5123$export$ff1ed10fedfdd604(new $c702e238df7c5123$export$4b739da06d24892b(object.geometry), new $c702e238df7c5123$export$fbaaa33907730a0c({
        color: hex !== undefined ? hex : 0xffffff
    }));
}
//
$c702e238df7c5123$export$3b0d6d7590275603.prototype.extractUrlBase = function(url) {
    console.warn('THREE.Loader: .extractUrlBase() has been deprecated. Use THREE.LoaderUtils.extractUrlBase() instead.');
    return $c702e238df7c5123$export$b5d2dc08d867e41a.extractUrlBase(url);
};
$c702e238df7c5123$export$3b0d6d7590275603.Handlers = {
    add: function add() {
        console.error('THREE.Loader: Handlers.add() has been removed. Use LoadingManager.addHandler() instead.');
    },
    get: function get() {
        console.error('THREE.Loader: Handlers.get() has been removed. Use LoadingManager.getHandler() instead.');
    }
};
function $c702e238df7c5123$export$c8b77178c5db4e0d(manager) {
    console.warn('THREE.XHRLoader has been renamed to THREE.FileLoader.');
    return new $c702e238df7c5123$export$98435a25b5cf7b2b(manager);
}
function $c702e238df7c5123$export$58c7c1107fc658f9(manager) {
    console.warn('THREE.BinaryTextureLoader has been renamed to THREE.DataTextureLoader.');
    return new $c702e238df7c5123$export$792d8a18f2c55855(manager);
}
//
$c702e238df7c5123$export$60f553fa130f08b0.prototype.center = function(optionalTarget) {
    console.warn('THREE.Box2: .center() has been renamed to .getCenter().');
    return this.getCenter(optionalTarget);
};
$c702e238df7c5123$export$60f553fa130f08b0.prototype.empty = function() {
    console.warn('THREE.Box2: .empty() has been renamed to .isEmpty().');
    return this.isEmpty();
};
$c702e238df7c5123$export$60f553fa130f08b0.prototype.isIntersectionBox = function(box) {
    console.warn('THREE.Box2: .isIntersectionBox() has been renamed to .intersectsBox().');
    return this.intersectsBox(box);
};
$c702e238df7c5123$export$60f553fa130f08b0.prototype.size = function(optionalTarget) {
    console.warn('THREE.Box2: .size() has been renamed to .getSize().');
    return this.getSize(optionalTarget);
};
//
$c702e238df7c5123$export$6f7d5a9418ab2aa3.prototype.center = function(optionalTarget) {
    console.warn('THREE.Box3: .center() has been renamed to .getCenter().');
    return this.getCenter(optionalTarget);
};
$c702e238df7c5123$export$6f7d5a9418ab2aa3.prototype.empty = function() {
    console.warn('THREE.Box3: .empty() has been renamed to .isEmpty().');
    return this.isEmpty();
};
$c702e238df7c5123$export$6f7d5a9418ab2aa3.prototype.isIntersectionBox = function(box) {
    console.warn('THREE.Box3: .isIntersectionBox() has been renamed to .intersectsBox().');
    return this.intersectsBox(box);
};
$c702e238df7c5123$export$6f7d5a9418ab2aa3.prototype.isIntersectionSphere = function(sphere) {
    console.warn('THREE.Box3: .isIntersectionSphere() has been renamed to .intersectsSphere().');
    return this.intersectsSphere(sphere);
};
$c702e238df7c5123$export$6f7d5a9418ab2aa3.prototype.size = function(optionalTarget) {
    console.warn('THREE.Box3: .size() has been renamed to .getSize().');
    return this.getSize(optionalTarget);
};
//
$c702e238df7c5123$export$805e8b72413ccaba.prototype.empty = function() {
    console.warn('THREE.Sphere: .empty() has been renamed to .isEmpty().');
    return this.isEmpty();
};
//
$c702e238df7c5123$export$35efe6f4c85463d2.prototype.setFromMatrix = function(m) {
    console.warn('THREE.Frustum: .setFromMatrix() has been renamed to .setFromProjectionMatrix().');
    return this.setFromProjectionMatrix(m);
};
//
$c702e238df7c5123$export$e0ba6359f1954fd3.prototype.center = function(optionalTarget) {
    console.warn('THREE.Line3: .center() has been renamed to .getCenter().');
    return this.getCenter(optionalTarget);
};
//
$c702e238df7c5123$export$8ff26dafa08918.prototype.flattenToArrayOffset = function(array, offset) {
    console.warn('THREE.Matrix3: .flattenToArrayOffset() has been deprecated. Use .toArray() instead.');
    return this.toArray(array, offset);
};
$c702e238df7c5123$export$8ff26dafa08918.prototype.multiplyVector3 = function(vector) {
    console.warn('THREE.Matrix3: .multiplyVector3() has been removed. Use vector.applyMatrix3( matrix ) instead.');
    return vector.applyMatrix3(this);
};
$c702e238df7c5123$export$8ff26dafa08918.prototype.multiplyVector3Array = function() {
    console.error('THREE.Matrix3: .multiplyVector3Array() has been removed.');
};
$c702e238df7c5123$export$8ff26dafa08918.prototype.applyToBufferAttribute = function(attribute) {
    console.warn('THREE.Matrix3: .applyToBufferAttribute() has been removed. Use attribute.applyMatrix3( matrix ) instead.');
    return attribute.applyMatrix3(this);
};
$c702e238df7c5123$export$8ff26dafa08918.prototype.applyToVector3Array = function() {
    console.error('THREE.Matrix3: .applyToVector3Array() has been removed.');
};
$c702e238df7c5123$export$8ff26dafa08918.prototype.getInverse = function(matrix) {
    console.warn('THREE.Matrix3: .getInverse() has been removed. Use matrixInv.copy( matrix ).invert(); instead.');
    return this.copy(matrix).invert();
};
//
$c702e238df7c5123$export$2ae72fc923e5eb5.prototype.extractPosition = function(m) {
    console.warn('THREE.Matrix4: .extractPosition() has been renamed to .copyPosition().');
    return this.copyPosition(m);
};
$c702e238df7c5123$export$2ae72fc923e5eb5.prototype.flattenToArrayOffset = function(array, offset) {
    console.warn('THREE.Matrix4: .flattenToArrayOffset() has been deprecated. Use .toArray() instead.');
    return this.toArray(array, offset);
};
$c702e238df7c5123$export$2ae72fc923e5eb5.prototype.getPosition = function() {
    console.warn('THREE.Matrix4: .getPosition() has been removed. Use Vector3.setFromMatrixPosition( matrix ) instead.');
    return new $c702e238df7c5123$export$64b5c384219d3699().setFromMatrixColumn(this, 3);
};
$c702e238df7c5123$export$2ae72fc923e5eb5.prototype.setRotationFromQuaternion = function(q) {
    console.warn('THREE.Matrix4: .setRotationFromQuaternion() has been renamed to .makeRotationFromQuaternion().');
    return this.makeRotationFromQuaternion(q);
};
$c702e238df7c5123$export$2ae72fc923e5eb5.prototype.multiplyToArray = function() {
    console.warn('THREE.Matrix4: .multiplyToArray() has been removed.');
};
$c702e238df7c5123$export$2ae72fc923e5eb5.prototype.multiplyVector3 = function(vector) {
    console.warn('THREE.Matrix4: .multiplyVector3() has been removed. Use vector.applyMatrix4( matrix ) instead.');
    return vector.applyMatrix4(this);
};
$c702e238df7c5123$export$2ae72fc923e5eb5.prototype.multiplyVector4 = function(vector) {
    console.warn('THREE.Matrix4: .multiplyVector4() has been removed. Use vector.applyMatrix4( matrix ) instead.');
    return vector.applyMatrix4(this);
};
$c702e238df7c5123$export$2ae72fc923e5eb5.prototype.multiplyVector3Array = function() {
    console.error('THREE.Matrix4: .multiplyVector3Array() has been removed.');
};
$c702e238df7c5123$export$2ae72fc923e5eb5.prototype.rotateAxis = function(v) {
    console.warn('THREE.Matrix4: .rotateAxis() has been removed. Use Vector3.transformDirection( matrix ) instead.');
    v.transformDirection(this);
};
$c702e238df7c5123$export$2ae72fc923e5eb5.prototype.crossVector = function(vector) {
    console.warn('THREE.Matrix4: .crossVector() has been removed. Use vector.applyMatrix4( matrix ) instead.');
    return vector.applyMatrix4(this);
};
$c702e238df7c5123$export$2ae72fc923e5eb5.prototype.translate = function() {
    console.error('THREE.Matrix4: .translate() has been removed.');
};
$c702e238df7c5123$export$2ae72fc923e5eb5.prototype.rotateX = function() {
    console.error('THREE.Matrix4: .rotateX() has been removed.');
};
$c702e238df7c5123$export$2ae72fc923e5eb5.prototype.rotateY = function() {
    console.error('THREE.Matrix4: .rotateY() has been removed.');
};
$c702e238df7c5123$export$2ae72fc923e5eb5.prototype.rotateZ = function() {
    console.error('THREE.Matrix4: .rotateZ() has been removed.');
};
$c702e238df7c5123$export$2ae72fc923e5eb5.prototype.rotateByAxis = function() {
    console.error('THREE.Matrix4: .rotateByAxis() has been removed.');
};
$c702e238df7c5123$export$2ae72fc923e5eb5.prototype.applyToBufferAttribute = function(attribute) {
    console.warn('THREE.Matrix4: .applyToBufferAttribute() has been removed. Use attribute.applyMatrix4( matrix ) instead.');
    return attribute.applyMatrix4(this);
};
$c702e238df7c5123$export$2ae72fc923e5eb5.prototype.applyToVector3Array = function() {
    console.error('THREE.Matrix4: .applyToVector3Array() has been removed.');
};
$c702e238df7c5123$export$2ae72fc923e5eb5.prototype.makeFrustum = function(left, right, bottom, top, near, far) {
    console.warn('THREE.Matrix4: .makeFrustum() has been removed. Use .makePerspective( left, right, top, bottom, near, far ) instead.');
    return this.makePerspective(left, right, top, bottom, near, far);
};
$c702e238df7c5123$export$2ae72fc923e5eb5.prototype.getInverse = function(matrix) {
    console.warn('THREE.Matrix4: .getInverse() has been removed. Use matrixInv.copy( matrix ).invert(); instead.');
    return this.copy(matrix).invert();
};
//
$c702e238df7c5123$export$7ff5ac152ef991b0.prototype.isIntersectionLine = function(line) {
    console.warn('THREE.Plane: .isIntersectionLine() has been renamed to .intersectsLine().');
    return this.intersectsLine(line);
};
//
$c702e238df7c5123$export$23d6a54f0bbc85a3.prototype.multiplyVector3 = function(vector) {
    console.warn('THREE.Quaternion: .multiplyVector3() has been removed. Use is now vector.applyQuaternion( quaternion ) instead.');
    return vector.applyQuaternion(this);
};
$c702e238df7c5123$export$23d6a54f0bbc85a3.prototype.inverse = function() {
    console.warn('THREE.Quaternion: .inverse() has been renamed to invert().');
    return this.invert();
};
//
$c702e238df7c5123$export$a186db52eed6d40e.prototype.isIntersectionBox = function(box) {
    console.warn('THREE.Ray: .isIntersectionBox() has been renamed to .intersectsBox().');
    return this.intersectsBox(box);
};
$c702e238df7c5123$export$a186db52eed6d40e.prototype.isIntersectionPlane = function(plane) {
    console.warn('THREE.Ray: .isIntersectionPlane() has been renamed to .intersectsPlane().');
    return this.intersectsPlane(plane);
};
$c702e238df7c5123$export$a186db52eed6d40e.prototype.isIntersectionSphere = function(sphere) {
    console.warn('THREE.Ray: .isIntersectionSphere() has been renamed to .intersectsSphere().');
    return this.intersectsSphere(sphere);
};
//
$c702e238df7c5123$export$5a465592bfe74b48.prototype.area = function() {
    console.warn('THREE.Triangle: .area() has been renamed to .getArea().');
    return this.getArea();
};
$c702e238df7c5123$export$5a465592bfe74b48.prototype.barycoordFromPoint = function(point, target) {
    console.warn('THREE.Triangle: .barycoordFromPoint() has been renamed to .getBarycoord().');
    return this.getBarycoord(point, target);
};
$c702e238df7c5123$export$5a465592bfe74b48.prototype.midpoint = function(target) {
    console.warn('THREE.Triangle: .midpoint() has been renamed to .getMidpoint().');
    return this.getMidpoint(target);
};
$c702e238df7c5123$export$5a465592bfe74b48.prototypenormal = function(target) {
    console.warn('THREE.Triangle: .normal() has been renamed to .getNormal().');
    return this.getNormal(target);
};
$c702e238df7c5123$export$5a465592bfe74b48.prototype.plane = function(target) {
    console.warn('THREE.Triangle: .plane() has been renamed to .getPlane().');
    return this.getPlane(target);
};
$c702e238df7c5123$export$5a465592bfe74b48.barycoordFromPoint = function(point, a, b, c, target) {
    console.warn('THREE.Triangle: .barycoordFromPoint() has been renamed to .getBarycoord().');
    return $c702e238df7c5123$export$5a465592bfe74b48.getBarycoord(point, a, b, c, target);
};
$c702e238df7c5123$export$5a465592bfe74b48.normal = function(a, b, c, target) {
    console.warn('THREE.Triangle: .normal() has been renamed to .getNormal().');
    return $c702e238df7c5123$export$5a465592bfe74b48.getNormal(a, b, c, target);
};
//
$c702e238df7c5123$export$6428a7f2611ef1fa.prototype.extractAllPoints = function(divisions) {
    console.warn('THREE.Shape: .extractAllPoints() has been removed. Use .extractPoints() instead.');
    return this.extractPoints(divisions);
};
$c702e238df7c5123$export$6428a7f2611ef1fa.prototype.extrude = function(options) {
    console.warn('THREE.Shape: .extrude() has been removed. Use ExtrudeGeometry() instead.');
    return new $c702e238df7c5123$export$91836d01b9f75a58(this, options);
};
$c702e238df7c5123$export$6428a7f2611ef1fa.prototype.makeGeometry = function(options) {
    console.warn('THREE.Shape: .makeGeometry() has been removed. Use ShapeGeometry() instead.');
    return new $c702e238df7c5123$export$233afc324766bed8(this, options);
};
//
$c702e238df7c5123$export$c977b3e384af9ae1.prototype.fromAttribute = function(attribute, index, offset) {
    console.warn('THREE.Vector2: .fromAttribute() has been renamed to .fromBufferAttribute().');
    return this.fromBufferAttribute(attribute, index, offset);
};
$c702e238df7c5123$export$c977b3e384af9ae1.prototype.distanceToManhattan = function(v) {
    console.warn('THREE.Vector2: .distanceToManhattan() has been renamed to .manhattanDistanceTo().');
    return this.manhattanDistanceTo(v);
};
$c702e238df7c5123$export$c977b3e384af9ae1.prototype.lengthManhattan = function() {
    console.warn('THREE.Vector2: .lengthManhattan() has been renamed to .manhattanLength().');
    return this.manhattanLength();
};
//
$c702e238df7c5123$export$64b5c384219d3699.prototype.setEulerFromRotationMatrix = function() {
    console.error('THREE.Vector3: .setEulerFromRotationMatrix() has been removed. Use Euler.setFromRotationMatrix() instead.');
};
$c702e238df7c5123$export$64b5c384219d3699.prototype.setEulerFromQuaternion = function() {
    console.error('THREE.Vector3: .setEulerFromQuaternion() has been removed. Use Euler.setFromQuaternion() instead.');
};
$c702e238df7c5123$export$64b5c384219d3699.prototype.getPositionFromMatrix = function(m) {
    console.warn('THREE.Vector3: .getPositionFromMatrix() has been renamed to .setFromMatrixPosition().');
    return this.setFromMatrixPosition(m);
};
$c702e238df7c5123$export$64b5c384219d3699.prototype.getScaleFromMatrix = function(m) {
    console.warn('THREE.Vector3: .getScaleFromMatrix() has been renamed to .setFromMatrixScale().');
    return this.setFromMatrixScale(m);
};
$c702e238df7c5123$export$64b5c384219d3699.prototype.getColumnFromMatrix = function(index, matrix) {
    console.warn('THREE.Vector3: .getColumnFromMatrix() has been renamed to .setFromMatrixColumn().');
    return this.setFromMatrixColumn(matrix, index);
};
$c702e238df7c5123$export$64b5c384219d3699.prototype.applyProjection = function(m) {
    console.warn('THREE.Vector3: .applyProjection() has been removed. Use .applyMatrix4( m ) instead.');
    return this.applyMatrix4(m);
};
$c702e238df7c5123$export$64b5c384219d3699.prototype.fromAttribute = function(attribute, index, offset) {
    console.warn('THREE.Vector3: .fromAttribute() has been renamed to .fromBufferAttribute().');
    return this.fromBufferAttribute(attribute, index, offset);
};
$c702e238df7c5123$export$64b5c384219d3699.prototype.distanceToManhattan = function(v) {
    console.warn('THREE.Vector3: .distanceToManhattan() has been renamed to .manhattanDistanceTo().');
    return this.manhattanDistanceTo(v);
};
$c702e238df7c5123$export$64b5c384219d3699.prototype.lengthManhattan = function() {
    console.warn('THREE.Vector3: .lengthManhattan() has been renamed to .manhattanLength().');
    return this.manhattanLength();
};
//
$c702e238df7c5123$export$fa7daccca11cdbe3.prototype.fromAttribute = function(attribute, index, offset) {
    console.warn('THREE.Vector4: .fromAttribute() has been renamed to .fromBufferAttribute().');
    return this.fromBufferAttribute(attribute, index, offset);
};
$c702e238df7c5123$export$fa7daccca11cdbe3.prototype.lengthManhattan = function() {
    console.warn('THREE.Vector4: .lengthManhattan() has been renamed to .manhattanLength().');
    return this.manhattanLength();
};
//
$c702e238df7c5123$export$e4dd07dff30cc924.prototype.getChildByName = function(name) {
    console.warn('THREE.Object3D: .getChildByName() has been renamed to .getObjectByName().');
    return this.getObjectByName(name);
};
$c702e238df7c5123$export$e4dd07dff30cc924.prototype.renderDepth = function() {
    console.warn('THREE.Object3D: .renderDepth has been removed. Use .renderOrder, instead.');
};
$c702e238df7c5123$export$e4dd07dff30cc924.prototype.translate = function(distance, axis) {
    console.warn('THREE.Object3D: .translate() has been removed. Use .translateOnAxis( axis, distance ) instead.');
    return this.translateOnAxis(axis, distance);
};
$c702e238df7c5123$export$e4dd07dff30cc924.prototype.getWorldRotation = function() {
    console.error('THREE.Object3D: .getWorldRotation() has been removed. Use THREE.Object3D.getWorldQuaternion( target ) instead.');
};
$c702e238df7c5123$export$e4dd07dff30cc924.prototype.applyMatrix = function(matrix) {
    console.warn('THREE.Object3D: .applyMatrix() has been renamed to .applyMatrix4().');
    return this.applyMatrix4(matrix);
};
Object.defineProperties($c702e238df7c5123$export$e4dd07dff30cc924.prototype, {
    eulerOrder: {
        get: function get() {
            console.warn('THREE.Object3D: .eulerOrder is now .rotation.order.');
            return this.rotation.order;
        },
        set: function set(value) {
            console.warn('THREE.Object3D: .eulerOrder is now .rotation.order.');
            this.rotation.order = value;
        }
    },
    useQuaternion: {
        get: function get() {
            console.warn('THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.');
        },
        set: function set() {
            console.warn('THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.');
        }
    }
});
$c702e238df7c5123$export$e176487c05830cc5.prototype.setDrawMode = function() {
    console.error('THREE.Mesh: .setDrawMode() has been removed. The renderer now always assumes THREE.TrianglesDrawMode. Transform your geometry via BufferGeometryUtils.toTrianglesDrawMode() if necessary.');
};
Object.defineProperties($c702e238df7c5123$export$e176487c05830cc5.prototype, {
    drawMode: {
        get: function get() {
            console.error('THREE.Mesh: .drawMode has been removed. The renderer now always assumes THREE.TrianglesDrawMode.');
            return $c702e238df7c5123$export$4c28c87c2dc84758;
        },
        set: function set() {
            console.error('THREE.Mesh: .drawMode has been removed. The renderer now always assumes THREE.TrianglesDrawMode. Transform your geometry via BufferGeometryUtils.toTrianglesDrawMode() if necessary.');
        }
    }
});
$c702e238df7c5123$export$b303577035157ecf.prototype.initBones = function() {
    console.error('THREE.SkinnedMesh: initBones() has been removed.');
};
//
$c702e238df7c5123$export$74e4ae24825f68d7.prototype.setLens = function(focalLength, filmGauge) {
    console.warn("THREE.PerspectiveCamera.setLens is deprecated. Use .setFocalLength and .filmGauge for a photographic setup.");
    if (filmGauge !== undefined) this.filmGauge = filmGauge;
    this.setFocalLength(focalLength);
};
//
Object.defineProperties($c702e238df7c5123$export$6ecadb6ed240d696.prototype, {
    onlyShadow: {
        set: function set() {
            console.warn('THREE.Light: .onlyShadow has been removed.');
        }
    },
    shadowCameraFov: {
        set: function set(value) {
            console.warn('THREE.Light: .shadowCameraFov is now .shadow.camera.fov.');
            this.shadow.camera.fov = value;
        }
    },
    shadowCameraLeft: {
        set: function set(value) {
            console.warn('THREE.Light: .shadowCameraLeft is now .shadow.camera.left.');
            this.shadow.camera.left = value;
        }
    },
    shadowCameraRight: {
        set: function set(value) {
            console.warn('THREE.Light: .shadowCameraRight is now .shadow.camera.right.');
            this.shadow.camera.right = value;
        }
    },
    shadowCameraTop: {
        set: function set(value) {
            console.warn('THREE.Light: .shadowCameraTop is now .shadow.camera.top.');
            this.shadow.camera.top = value;
        }
    },
    shadowCameraBottom: {
        set: function set(value) {
            console.warn('THREE.Light: .shadowCameraBottom is now .shadow.camera.bottom.');
            this.shadow.camera.bottom = value;
        }
    },
    shadowCameraNear: {
        set: function set(value) {
            console.warn('THREE.Light: .shadowCameraNear is now .shadow.camera.near.');
            this.shadow.camera.near = value;
        }
    },
    shadowCameraFar: {
        set: function set(value) {
            console.warn('THREE.Light: .shadowCameraFar is now .shadow.camera.far.');
            this.shadow.camera.far = value;
        }
    },
    shadowCameraVisible: {
        set: function set() {
            console.warn('THREE.Light: .shadowCameraVisible has been removed. Use new THREE.CameraHelper( light.shadow.camera ) instead.');
        }
    },
    shadowBias: {
        set: function set(value) {
            console.warn('THREE.Light: .shadowBias is now .shadow.bias.');
            this.shadow.bias = value;
        }
    },
    shadowDarkness: {
        set: function set() {
            console.warn('THREE.Light: .shadowDarkness has been removed.');
        }
    },
    shadowMapWidth: {
        set: function set(value) {
            console.warn('THREE.Light: .shadowMapWidth is now .shadow.mapSize.width.');
            this.shadow.mapSize.width = value;
        }
    },
    shadowMapHeight: {
        set: function set(value) {
            console.warn('THREE.Light: .shadowMapHeight is now .shadow.mapSize.height.');
            this.shadow.mapSize.height = value;
        }
    }
});
//
Object.defineProperties($c702e238df7c5123$export$8dea267bd6bde117.prototype, {
    length: {
        get: function get() {
            console.warn('THREE.BufferAttribute: .length has been deprecated. Use .count instead.');
            return this.array.length;
        }
    },
    dynamic: {
        get: function get() {
            console.warn('THREE.BufferAttribute: .dynamic has been deprecated. Use .usage instead.');
            return this.usage === $c702e238df7c5123$export$8505d14ac8546ca;
        },
        set: function set() {
            console.warn('THREE.BufferAttribute: .dynamic has been deprecated. Use .usage instead.');
            this.setUsage($c702e238df7c5123$export$8505d14ac8546ca);
        }
    }
});
$c702e238df7c5123$export$8dea267bd6bde117.prototype.setDynamic = function(value) {
    console.warn('THREE.BufferAttribute: .setDynamic() has been deprecated. Use .setUsage() instead.');
    this.setUsage(value === true ? $c702e238df7c5123$export$8505d14ac8546ca : $c702e238df7c5123$export$763e8360f4d7f77d);
    return this;
};
$c702e238df7c5123$export$8dea267bd6bde117.prototype.copyIndicesArray = function() {
    console.error('THREE.BufferAttribute: .copyIndicesArray() has been removed.');
}, $c702e238df7c5123$export$8dea267bd6bde117.prototype.setArray = function() {
    console.error('THREE.BufferAttribute: .setArray has been removed. Use BufferGeometry .setAttribute to replace/resize attribute buffers');
};
//
$c702e238df7c5123$export$b7be63a67df8959.prototype.addIndex = function(index) {
    console.warn('THREE.BufferGeometry: .addIndex() has been renamed to .setIndex().');
    this.setIndex(index);
};
$c702e238df7c5123$export$b7be63a67df8959.prototype.addAttribute = function(name, attribute) {
    console.warn('THREE.BufferGeometry: .addAttribute() has been renamed to .setAttribute().');
    if (!(attribute && attribute.isBufferAttribute) && !(attribute && attribute.isInterleavedBufferAttribute)) {
        console.warn('THREE.BufferGeometry: .addAttribute() now expects ( name, attribute ).');
        return this.setAttribute(name, new $c702e238df7c5123$export$8dea267bd6bde117(arguments[1], arguments[2]));
    }
    if (name === 'index') {
        console.warn('THREE.BufferGeometry.addAttribute: Use .setIndex() for index attribute.');
        this.setIndex(attribute);
        return this;
    }
    return this.setAttribute(name, attribute);
};
$c702e238df7c5123$export$b7be63a67df8959.prototype.addDrawCall = function(start, count, indexOffset) {
    if (indexOffset !== undefined) console.warn('THREE.BufferGeometry: .addDrawCall() no longer supports indexOffset.');
    console.warn('THREE.BufferGeometry: .addDrawCall() is now .addGroup().');
    this.addGroup(start, count);
};
$c702e238df7c5123$export$b7be63a67df8959.prototype.clearDrawCalls = function() {
    console.warn('THREE.BufferGeometry: .clearDrawCalls() is now .clearGroups().');
    this.clearGroups();
};
$c702e238df7c5123$export$b7be63a67df8959.prototype.computeOffsets = function() {
    console.warn('THREE.BufferGeometry: .computeOffsets() has been removed.');
};
$c702e238df7c5123$export$b7be63a67df8959.prototype.removeAttribute = function(name) {
    console.warn('THREE.BufferGeometry: .removeAttribute() has been renamed to .deleteAttribute().');
    return this.deleteAttribute(name);
};
$c702e238df7c5123$export$b7be63a67df8959.prototype.applyMatrix = function(matrix) {
    console.warn('THREE.BufferGeometry: .applyMatrix() has been renamed to .applyMatrix4().');
    return this.applyMatrix4(matrix);
};
Object.defineProperties($c702e238df7c5123$export$b7be63a67df8959.prototype, {
    drawcalls: {
        get: function get() {
            console.error('THREE.BufferGeometry: .drawcalls has been renamed to .groups.');
            return this.groups;
        }
    },
    offsets: {
        get: function get() {
            console.warn('THREE.BufferGeometry: .offsets has been renamed to .groups.');
            return this.groups;
        }
    }
});
$c702e238df7c5123$export$3d5cd879f108f53f.prototype.setDynamic = function(value) {
    console.warn('THREE.InterleavedBuffer: .setDynamic() has been deprecated. Use .setUsage() instead.');
    this.setUsage(value === true ? $c702e238df7c5123$export$8505d14ac8546ca : $c702e238df7c5123$export$763e8360f4d7f77d);
    return this;
};
$c702e238df7c5123$export$3d5cd879f108f53f.prototype.setArray = function() {
    console.error('THREE.InterleavedBuffer: .setArray has been removed. Use BufferGeometry .setAttribute to replace/resize attribute buffers');
};
//
$c702e238df7c5123$export$91836d01b9f75a58.prototype.getArrays = function() {
    console.error('THREE.ExtrudeGeometry: .getArrays() has been removed.');
};
$c702e238df7c5123$export$91836d01b9f75a58.prototype.addShapeList = function() {
    console.error('THREE.ExtrudeGeometry: .addShapeList() has been removed.');
};
$c702e238df7c5123$export$91836d01b9f75a58.prototype.addShape = function() {
    console.error('THREE.ExtrudeGeometry: .addShape() has been removed.');
};
//
$c702e238df7c5123$export$38af1803e3442a7f.prototype.dispose = function() {
    console.error('THREE.Scene: .dispose() has been removed.');
};
//
$c702e238df7c5123$export$2947cebfe91c02f8.prototype.onUpdate = function() {
    console.warn('THREE.Uniform: .onUpdate() has been removed. Use object.onBeforeRender() instead.');
    return this;
};
//
Object.defineProperties($c702e238df7c5123$export$a2d8b23205c25948.prototype, {
    wrapAround: {
        get: function get() {
            console.warn('THREE.Material: .wrapAround has been removed.');
        },
        set: function set() {
            console.warn('THREE.Material: .wrapAround has been removed.');
        }
    },
    overdraw: {
        get: function get() {
            console.warn('THREE.Material: .overdraw has been removed.');
        },
        set: function set() {
            console.warn('THREE.Material: .overdraw has been removed.');
        }
    },
    wrapRGB: {
        get: function get() {
            console.warn('THREE.Material: .wrapRGB has been removed.');
            return new $c702e238df7c5123$export$892596cec99bc70e();
        }
    },
    shading: {
        get: function get() {
            console.error('THREE.' + this.type + ': .shading has been removed. Use the boolean .flatShading instead.');
        },
        set: function set(value) {
            console.warn('THREE.' + this.type + ': .shading has been removed. Use the boolean .flatShading instead.');
            this.flatShading = value === $c702e238df7c5123$export$a62047d29c96d8ff;
        }
    },
    stencilMask: {
        get: function get() {
            console.warn('THREE.' + this.type + ': .stencilMask has been removed. Use .stencilFuncMask instead.');
            return this.stencilFuncMask;
        },
        set: function set(value) {
            console.warn('THREE.' + this.type + ': .stencilMask has been removed. Use .stencilFuncMask instead.');
            this.stencilFuncMask = value;
        }
    }
});
Object.defineProperties($c702e238df7c5123$export$83c7d75d550a8b0d.prototype, {
    derivatives: {
        get: function get() {
            console.warn('THREE.ShaderMaterial: .derivatives has been moved to .extensions.derivatives.');
            return this.extensions.derivatives;
        },
        set: function set(value) {
            console.warn('THREE. ShaderMaterial: .derivatives has been moved to .extensions.derivatives.');
            this.extensions.derivatives = value;
        }
    }
});
//
$c702e238df7c5123$export$f6cc00ef28d7cf97.prototype.clearTarget = function(renderTarget, color, depth, stencil) {
    console.warn('THREE.WebGLRenderer: .clearTarget() has been deprecated. Use .setRenderTarget() and .clear() instead.');
    this.setRenderTarget(renderTarget);
    this.clear(color, depth, stencil);
};
$c702e238df7c5123$export$f6cc00ef28d7cf97.prototype.animate = function(callback) {
    console.warn('THREE.WebGLRenderer: .animate() is now .setAnimationLoop().');
    this.setAnimationLoop(callback);
};
$c702e238df7c5123$export$f6cc00ef28d7cf97.prototype.getCurrentRenderTarget = function() {
    console.warn('THREE.WebGLRenderer: .getCurrentRenderTarget() is now .getRenderTarget().');
    return this.getRenderTarget();
};
$c702e238df7c5123$export$f6cc00ef28d7cf97.prototype.getMaxAnisotropy = function() {
    console.warn('THREE.WebGLRenderer: .getMaxAnisotropy() is now .capabilities.getMaxAnisotropy().');
    return this.capabilities.getMaxAnisotropy();
};
$c702e238df7c5123$export$f6cc00ef28d7cf97.prototype.getPrecision = function() {
    console.warn('THREE.WebGLRenderer: .getPrecision() is now .capabilities.precision.');
    return this.capabilities.precision;
};
$c702e238df7c5123$export$f6cc00ef28d7cf97.prototype.resetGLState = function() {
    console.warn('THREE.WebGLRenderer: .resetGLState() is now .state.reset().');
    return this.state.reset();
};
$c702e238df7c5123$export$f6cc00ef28d7cf97.prototype.supportsFloatTextures = function() {
    console.warn('THREE.WebGLRenderer: .supportsFloatTextures() is now .extensions.get( \'OES_texture_float\' ).');
    return this.extensions.get('OES_texture_float');
};
$c702e238df7c5123$export$f6cc00ef28d7cf97.prototype.supportsHalfFloatTextures = function() {
    console.warn('THREE.WebGLRenderer: .supportsHalfFloatTextures() is now .extensions.get( \'OES_texture_half_float\' ).');
    return this.extensions.get('OES_texture_half_float');
};
$c702e238df7c5123$export$f6cc00ef28d7cf97.prototype.supportsStandardDerivatives = function() {
    console.warn('THREE.WebGLRenderer: .supportsStandardDerivatives() is now .extensions.get( \'OES_standard_derivatives\' ).');
    return this.extensions.get('OES_standard_derivatives');
};
$c702e238df7c5123$export$f6cc00ef28d7cf97.prototype.supportsCompressedTextureS3TC = function() {
    console.warn('THREE.WebGLRenderer: .supportsCompressedTextureS3TC() is now .extensions.get( \'WEBGL_compressed_texture_s3tc\' ).');
    return this.extensions.get('WEBGL_compressed_texture_s3tc');
};
$c702e238df7c5123$export$f6cc00ef28d7cf97.prototype.supportsCompressedTexturePVRTC = function() {
    console.warn('THREE.WebGLRenderer: .supportsCompressedTexturePVRTC() is now .extensions.get( \'WEBGL_compressed_texture_pvrtc\' ).');
    return this.extensions.get('WEBGL_compressed_texture_pvrtc');
};
$c702e238df7c5123$export$f6cc00ef28d7cf97.prototype.supportsBlendMinMax = function() {
    console.warn('THREE.WebGLRenderer: .supportsBlendMinMax() is now .extensions.get( \'EXT_blend_minmax\' ).');
    return this.extensions.get('EXT_blend_minmax');
};
$c702e238df7c5123$export$f6cc00ef28d7cf97.prototype.supportsVertexTextures = function() {
    console.warn('THREE.WebGLRenderer: .supportsVertexTextures() is now .capabilities.vertexTextures.');
    return this.capabilities.vertexTextures;
};
$c702e238df7c5123$export$f6cc00ef28d7cf97.prototype.supportsInstancedArrays = function() {
    console.warn('THREE.WebGLRenderer: .supportsInstancedArrays() is now .extensions.get( \'ANGLE_instanced_arrays\' ).');
    return this.extensions.get('ANGLE_instanced_arrays');
};
$c702e238df7c5123$export$f6cc00ef28d7cf97.prototype.enableScissorTest = function(_boolean) {
    console.warn('THREE.WebGLRenderer: .enableScissorTest() is now .setScissorTest().');
    this.setScissorTest(_boolean);
};
$c702e238df7c5123$export$f6cc00ef28d7cf97.prototype.initMaterial = function() {
    console.warn('THREE.WebGLRenderer: .initMaterial() has been removed.');
};
$c702e238df7c5123$export$f6cc00ef28d7cf97.prototype.addPrePlugin = function() {
    console.warn('THREE.WebGLRenderer: .addPrePlugin() has been removed.');
};
$c702e238df7c5123$export$f6cc00ef28d7cf97.prototype.addPostPlugin = function() {
    console.warn('THREE.WebGLRenderer: .addPostPlugin() has been removed.');
};
$c702e238df7c5123$export$f6cc00ef28d7cf97.prototype.updateShadowMap = function() {
    console.warn('THREE.WebGLRenderer: .updateShadowMap() has been removed.');
};
$c702e238df7c5123$export$f6cc00ef28d7cf97.prototype.setFaceCulling = function() {
    console.warn('THREE.WebGLRenderer: .setFaceCulling() has been removed.');
};
$c702e238df7c5123$export$f6cc00ef28d7cf97.prototype.allocTextureUnit = function() {
    console.warn('THREE.WebGLRenderer: .allocTextureUnit() has been removed.');
};
$c702e238df7c5123$export$f6cc00ef28d7cf97.prototype.setTexture = function() {
    console.warn('THREE.WebGLRenderer: .setTexture() has been removed.');
};
$c702e238df7c5123$export$f6cc00ef28d7cf97.prototype.setTexture2D = function() {
    console.warn('THREE.WebGLRenderer: .setTexture2D() has been removed.');
};
$c702e238df7c5123$export$f6cc00ef28d7cf97.prototype.setTextureCube = function() {
    console.warn('THREE.WebGLRenderer: .setTextureCube() has been removed.');
};
$c702e238df7c5123$export$f6cc00ef28d7cf97.prototype.getActiveMipMapLevel = function() {
    console.warn('THREE.WebGLRenderer: .getActiveMipMapLevel() is now .getActiveMipmapLevel().');
    return this.getActiveMipmapLevel();
};
Object.defineProperties($c702e238df7c5123$export$f6cc00ef28d7cf97.prototype, {
    shadowMapEnabled: {
        get: function get() {
            return this.shadowMap.enabled;
        },
        set: function set(value) {
            console.warn('THREE.WebGLRenderer: .shadowMapEnabled is now .shadowMap.enabled.');
            this.shadowMap.enabled = value;
        }
    },
    shadowMapType: {
        get: function get() {
            return this.shadowMap.type;
        },
        set: function set(value) {
            console.warn('THREE.WebGLRenderer: .shadowMapType is now .shadowMap.type.');
            this.shadowMap.type = value;
        }
    },
    shadowMapCullFace: {
        get: function get() {
            console.warn('THREE.WebGLRenderer: .shadowMapCullFace has been removed. Set Material.shadowSide instead.');
            return undefined;
        },
        set: function set() {
            console.warn('THREE.WebGLRenderer: .shadowMapCullFace has been removed. Set Material.shadowSide instead.');
        }
    },
    context: {
        get: function get() {
            console.warn('THREE.WebGLRenderer: .context has been removed. Use .getContext() instead.');
            return this.getContext();
        }
    },
    vr: {
        get: function get() {
            console.warn('THREE.WebGLRenderer: .vr has been renamed to .xr');
            return this.xr;
        }
    },
    gammaInput: {
        get: function get() {
            console.warn('THREE.WebGLRenderer: .gammaInput has been removed. Set the encoding for textures via Texture.encoding instead.');
            return false;
        },
        set: function set() {
            console.warn('THREE.WebGLRenderer: .gammaInput has been removed. Set the encoding for textures via Texture.encoding instead.');
        }
    },
    gammaOutput: {
        get: function get() {
            console.warn('THREE.WebGLRenderer: .gammaOutput has been removed. Set WebGLRenderer.outputEncoding instead.');
            return false;
        },
        set: function set(value) {
            console.warn('THREE.WebGLRenderer: .gammaOutput has been removed. Set WebGLRenderer.outputEncoding instead.');
            this.outputEncoding = value === true ? $c702e238df7c5123$export$f32388edbb32674 : $c702e238df7c5123$export$7207336e4151a112;
        }
    },
    toneMappingWhitePoint: {
        get: function get() {
            console.warn('THREE.WebGLRenderer: .toneMappingWhitePoint has been removed.');
            return 1.0;
        },
        set: function set() {
            console.warn('THREE.WebGLRenderer: .toneMappingWhitePoint has been removed.');
        }
    }
});
Object.defineProperties($c702e238df7c5123$var$WebGLShadowMap.prototype, {
    cullFace: {
        get: function get() {
            console.warn('THREE.WebGLRenderer: .shadowMap.cullFace has been removed. Set Material.shadowSide instead.');
            return undefined;
        },
        set: function set() {
            console.warn('THREE.WebGLRenderer: .shadowMap.cullFace has been removed. Set Material.shadowSide instead.');
        }
    },
    renderReverseSided: {
        get: function get() {
            console.warn('THREE.WebGLRenderer: .shadowMap.renderReverseSided has been removed. Set Material.shadowSide instead.');
            return undefined;
        },
        set: function set() {
            console.warn('THREE.WebGLRenderer: .shadowMap.renderReverseSided has been removed. Set Material.shadowSide instead.');
        }
    },
    renderSingleSided: {
        get: function get() {
            console.warn('THREE.WebGLRenderer: .shadowMap.renderSingleSided has been removed. Set Material.shadowSide instead.');
            return undefined;
        },
        set: function set() {
            console.warn('THREE.WebGLRenderer: .shadowMap.renderSingleSided has been removed. Set Material.shadowSide instead.');
        }
    }
});
function $c702e238df7c5123$export$689069929abfa262(width, height, options) {
    console.warn('THREE.WebGLRenderTargetCube( width, height, options ) is now WebGLCubeRenderTarget( size, options ).');
    return new $c702e238df7c5123$export$ac386671d651941e(width, options);
}
//
Object.defineProperties($c702e238df7c5123$export$3c052beb2e51e23f.prototype, {
    wrapS: {
        get: function get() {
            console.warn('THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS.');
            return this.texture.wrapS;
        },
        set: function set(value) {
            console.warn('THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS.');
            this.texture.wrapS = value;
        }
    },
    wrapT: {
        get: function get() {
            console.warn('THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT.');
            return this.texture.wrapT;
        },
        set: function set(value) {
            console.warn('THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT.');
            this.texture.wrapT = value;
        }
    },
    magFilter: {
        get: function get() {
            console.warn('THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter.');
            return this.texture.magFilter;
        },
        set: function set(value) {
            console.warn('THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter.');
            this.texture.magFilter = value;
        }
    },
    minFilter: {
        get: function get() {
            console.warn('THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter.');
            return this.texture.minFilter;
        },
        set: function set(value) {
            console.warn('THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter.');
            this.texture.minFilter = value;
        }
    },
    anisotropy: {
        get: function get() {
            console.warn('THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy.');
            return this.texture.anisotropy;
        },
        set: function set(value) {
            console.warn('THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy.');
            this.texture.anisotropy = value;
        }
    },
    offset: {
        get: function get() {
            console.warn('THREE.WebGLRenderTarget: .offset is now .texture.offset.');
            return this.texture.offset;
        },
        set: function set(value) {
            console.warn('THREE.WebGLRenderTarget: .offset is now .texture.offset.');
            this.texture.offset = value;
        }
    },
    repeat: {
        get: function get() {
            console.warn('THREE.WebGLRenderTarget: .repeat is now .texture.repeat.');
            return this.texture.repeat;
        },
        set: function set(value) {
            console.warn('THREE.WebGLRenderTarget: .repeat is now .texture.repeat.');
            this.texture.repeat = value;
        }
    },
    format: {
        get: function get() {
            console.warn('THREE.WebGLRenderTarget: .format is now .texture.format.');
            return this.texture.format;
        },
        set: function set(value) {
            console.warn('THREE.WebGLRenderTarget: .format is now .texture.format.');
            this.texture.format = value;
        }
    },
    type: {
        get: function get() {
            console.warn('THREE.WebGLRenderTarget: .type is now .texture.type.');
            return this.texture.type;
        },
        set: function set(value) {
            console.warn('THREE.WebGLRenderTarget: .type is now .texture.type.');
            this.texture.type = value;
        }
    },
    generateMipmaps: {
        get: function get() {
            console.warn('THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps.');
            return this.texture.generateMipmaps;
        },
        set: function set(value) {
            console.warn('THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps.');
            this.texture.generateMipmaps = value;
        }
    }
});
//
$c702e238df7c5123$export$153755f98d9861de.prototype.load = function(file) {
    console.warn('THREE.Audio: .load has been deprecated. Use THREE.AudioLoader instead.');
    var scope = this;
    var audioLoader = new $c702e238df7c5123$export$d8d5fccfbf47714e();
    audioLoader.load(file, function(buffer) {
        scope.setBuffer(buffer);
    });
    return this;
};
$c702e238df7c5123$export$d47da1ef3d382827.prototype.getData = function() {
    console.warn('THREE.AudioAnalyser: .getData() is now .getFrequencyData().');
    return this.getFrequencyData();
};
//
$c702e238df7c5123$export$d0cdd0bd804995de.prototype.updateCubeMap = function(renderer, scene) {
    console.warn('THREE.CubeCamera: .updateCubeMap() is now .update().');
    return this.update(renderer, scene);
};
$c702e238df7c5123$export$d0cdd0bd804995de.prototype.clear = function(renderer, color, depth, stencil) {
    console.warn('THREE.CubeCamera: .clear() is now .renderTarget.clear().');
    return this.renderTarget.clear(renderer, color, depth, stencil);
};
$c702e238df7c5123$export$698882cf06df44aa.crossOrigin = undefined;
$c702e238df7c5123$export$698882cf06df44aa.loadTexture = function(url, mapping, onLoad, onError) {
    console.warn('THREE.ImageUtils.loadTexture has been deprecated. Use THREE.TextureLoader() instead.');
    var loader = new $c702e238df7c5123$export$fd1bfc71f64c538c();
    loader.setCrossOrigin(this.crossOrigin);
    var texture = loader.load(url, onLoad, undefined, onError);
    if (mapping) texture.mapping = mapping;
    return texture;
};
$c702e238df7c5123$export$698882cf06df44aa.loadTextureCube = function(urls, mapping, onLoad, onError) {
    console.warn('THREE.ImageUtils.loadTextureCube has been deprecated. Use THREE.CubeTextureLoader() instead.');
    var loader = new $c702e238df7c5123$export$2ec114afc2cf6308();
    loader.setCrossOrigin(this.crossOrigin);
    var texture = loader.load(urls, onLoad, undefined, onError);
    if (mapping) texture.mapping = mapping;
    return texture;
};
$c702e238df7c5123$export$698882cf06df44aa.loadCompressedTexture = function() {
    console.error('THREE.ImageUtils.loadCompressedTexture has been removed. Use THREE.DDSLoader instead.');
};
$c702e238df7c5123$export$698882cf06df44aa.loadCompressedTextureCube = function() {
    console.error('THREE.ImageUtils.loadCompressedTextureCube has been removed. Use THREE.DDSLoader instead.');
};
//
function $c702e238df7c5123$export$7adc20298958481a() {
    console.error('THREE.CanvasRenderer has been removed');
}
//
function $c702e238df7c5123$export$8e85bca5826c4696() {
    console.error('THREE.JSONLoader has been removed.');
}
//
var $c702e238df7c5123$export$a8351e0de8b3fd78 = {
    createMultiMaterialObject: function createMultiMaterialObject() {
        console.error('THREE.SceneUtils has been moved to /examples/jsm/utils/SceneUtils.js');
    },
    detach: function detach() {
        console.error('THREE.SceneUtils has been moved to /examples/jsm/utils/SceneUtils.js');
    },
    attach: function attach() {
        console.error('THREE.SceneUtils has been moved to /examples/jsm/utils/SceneUtils.js');
    }
};
//
function $c702e238df7c5123$export$3f909fba4d49fe3d() {
    console.error('THREE.LensFlare has been moved to /examples/jsm/objects/Lensflare.js');
}
if (typeof __THREE_DEVTOOLS__ !== 'undefined') /* eslint-disable no-undef */ __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('register', {
    detail: {
        revision: $c702e238df7c5123$export$3545e07a80636437
    }
}));
if (typeof window !== 'undefined') {
    if (window.__THREE__) console.warn('WARNING: Multiple instances of Three.js being imported.');
    else window.__THREE__ = $c702e238df7c5123$export$3545e07a80636437;
}







// o object_name | g group_name
var $48bd0f7f134d0c59$var$_object_pattern = /^[og]\s*(.+)?/;
// mtllib file_reference
var $48bd0f7f134d0c59$var$_material_library_pattern = /^mtllib /;
// usemtl material_name
var $48bd0f7f134d0c59$var$_material_use_pattern = /^usemtl /;
// usemap map_name
var $48bd0f7f134d0c59$var$_map_use_pattern = /^usemap /;
var $48bd0f7f134d0c59$var$_vA = new (0, $c702e238df7c5123$export$64b5c384219d3699)();
var $48bd0f7f134d0c59$var$_vB = new (0, $c702e238df7c5123$export$64b5c384219d3699)();
var $48bd0f7f134d0c59$var$_vC = new (0, $c702e238df7c5123$export$64b5c384219d3699)();
var $48bd0f7f134d0c59$var$_ab = new (0, $c702e238df7c5123$export$64b5c384219d3699)();
var $48bd0f7f134d0c59$var$_cb = new (0, $c702e238df7c5123$export$64b5c384219d3699)();
function $48bd0f7f134d0c59$var$ParserState() {
    var state = {
        objects: [],
        object: {},
        vertices: [],
        normals: [],
        colors: [],
        uvs: [],
        materials: {},
        materialLibraries: [],
        startObject: function startObject(name, fromDeclaration) {
            // If the current object (initial from reset) is not from a g/o declaration in the parsed
            // file. We need to use it for the first parsed g/o to keep things in sync.
            if (this.object && this.object.fromDeclaration === false) {
                this.object.name = name;
                this.object.fromDeclaration = fromDeclaration !== false;
                return;
            }
            var previousMaterial = this.object && typeof this.object.currentMaterial === 'function' ? this.object.currentMaterial() : undefined;
            if (this.object && typeof this.object._finalize === 'function') this.object._finalize(true);
            this.object = {
                name: name || '',
                fromDeclaration: fromDeclaration !== false,
                geometry: {
                    vertices: [],
                    normals: [],
                    colors: [],
                    uvs: [],
                    hasUVIndices: false
                },
                materials: [],
                smooth: true,
                startMaterial: function startMaterial(name, libraries) {
                    var previous = this._finalize(false);
                    // New usemtl declaration overwrites an inherited material, except if faces were declared
                    // after the material, then it must be preserved for proper MultiMaterial continuation.
                    if (previous && (previous.inherited || previous.groupCount <= 0)) this.materials.splice(previous.index, 1);
                    var material = {
                        index: this.materials.length,
                        name: name || '',
                        mtllib: Array.isArray(libraries) && libraries.length > 0 ? libraries[libraries.length - 1] : '',
                        smooth: previous !== undefined ? previous.smooth : this.smooth,
                        groupStart: previous !== undefined ? previous.groupEnd : 0,
                        groupEnd: -1,
                        groupCount: -1,
                        inherited: false,
                        clone: function clone(index) {
                            var cloned = {
                                index: typeof index === 'number' ? index : this.index,
                                name: this.name,
                                mtllib: this.mtllib,
                                smooth: this.smooth,
                                groupStart: 0,
                                groupEnd: -1,
                                groupCount: -1,
                                inherited: false
                            };
                            cloned.clone = this.clone.bind(cloned);
                            return cloned;
                        }
                    };
                    this.materials.push(material);
                    return material;
                },
                currentMaterial: function currentMaterial() {
                    if (this.materials.length > 0) return this.materials[this.materials.length - 1];
                    return undefined;
                },
                _finalize: function _finalize(end) {
                    var lastMultiMaterial = this.currentMaterial();
                    if (lastMultiMaterial && lastMultiMaterial.groupEnd === -1) {
                        lastMultiMaterial.groupEnd = this.geometry.vertices.length / 3;
                        lastMultiMaterial.groupCount = lastMultiMaterial.groupEnd - lastMultiMaterial.groupStart;
                        lastMultiMaterial.inherited = false;
                    }
                    // Ignore objects tail materials if no face declarations followed them before a new o/g started.
                    if (end && this.materials.length > 1) {
                        for(var mi = this.materials.length - 1; mi >= 0; mi--)if (this.materials[mi].groupCount <= 0) this.materials.splice(mi, 1);
                    }
                    // Guarantee at least one empty material, this makes the creation later more straight forward.
                    if (end && this.materials.length === 0) this.materials.push({
                        name: '',
                        smooth: this.smooth
                    });
                    return lastMultiMaterial;
                }
            };
            // Inherit previous objects material.
            // Spec tells us that a declared material must be set to all objects until a new material is declared.
            // If a usemtl declaration is encountered while this new object is being parsed, it will
            // overwrite the inherited material. Exception being that there was already face declarations
            // to the inherited material, then it will be preserved for proper MultiMaterial continuation.
            if (previousMaterial && previousMaterial.name && typeof previousMaterial.clone === 'function') {
                var declared = previousMaterial.clone(0);
                declared.inherited = true;
                this.object.materials.push(declared);
            }
            this.objects.push(this.object);
        },
        finalize: function finalize() {
            if (this.object && typeof this.object._finalize === 'function') this.object._finalize(true);
        },
        parseVertexIndex: function parseVertexIndex(value, len) {
            var index = parseInt(value, 10);
            return (index >= 0 ? index - 1 : index + len / 3) * 3;
        },
        parseNormalIndex: function parseNormalIndex(value, len) {
            var index = parseInt(value, 10);
            return (index >= 0 ? index - 1 : index + len / 3) * 3;
        },
        parseUVIndex: function parseUVIndex(value, len) {
            var index = parseInt(value, 10);
            return (index >= 0 ? index - 1 : index + len / 2) * 2;
        },
        addVertex: function addVertex(a, b, c) {
            var src = this.vertices;
            var dst = this.object.geometry.vertices;
            dst.push(src[a + 0], src[a + 1], src[a + 2]);
            dst.push(src[b + 0], src[b + 1], src[b + 2]);
            dst.push(src[c + 0], src[c + 1], src[c + 2]);
        },
        addVertexPoint: function addVertexPoint(a) {
            var src = this.vertices;
            var dst = this.object.geometry.vertices;
            dst.push(src[a + 0], src[a + 1], src[a + 2]);
        },
        addVertexLine: function addVertexLine(a) {
            var src = this.vertices;
            var dst = this.object.geometry.vertices;
            dst.push(src[a + 0], src[a + 1], src[a + 2]);
        },
        addNormal: function addNormal(a, b, c) {
            var src = this.normals;
            var dst = this.object.geometry.normals;
            dst.push(src[a + 0], src[a + 1], src[a + 2]);
            dst.push(src[b + 0], src[b + 1], src[b + 2]);
            dst.push(src[c + 0], src[c + 1], src[c + 2]);
        },
        addFaceNormal: function addFaceNormal(a, b, c) {
            var src = this.vertices;
            var dst = this.object.geometry.normals;
            $48bd0f7f134d0c59$var$_vA.fromArray(src, a);
            $48bd0f7f134d0c59$var$_vB.fromArray(src, b);
            $48bd0f7f134d0c59$var$_vC.fromArray(src, c);
            $48bd0f7f134d0c59$var$_cb.subVectors($48bd0f7f134d0c59$var$_vC, $48bd0f7f134d0c59$var$_vB);
            $48bd0f7f134d0c59$var$_ab.subVectors($48bd0f7f134d0c59$var$_vA, $48bd0f7f134d0c59$var$_vB);
            $48bd0f7f134d0c59$var$_cb.cross($48bd0f7f134d0c59$var$_ab);
            $48bd0f7f134d0c59$var$_cb.normalize();
            dst.push($48bd0f7f134d0c59$var$_cb.x, $48bd0f7f134d0c59$var$_cb.y, $48bd0f7f134d0c59$var$_cb.z);
            dst.push($48bd0f7f134d0c59$var$_cb.x, $48bd0f7f134d0c59$var$_cb.y, $48bd0f7f134d0c59$var$_cb.z);
            dst.push($48bd0f7f134d0c59$var$_cb.x, $48bd0f7f134d0c59$var$_cb.y, $48bd0f7f134d0c59$var$_cb.z);
        },
        addColor: function addColor(a, b, c) {
            var src = this.colors;
            var dst = this.object.geometry.colors;
            if (src[a] !== undefined) dst.push(src[a + 0], src[a + 1], src[a + 2]);
            if (src[b] !== undefined) dst.push(src[b + 0], src[b + 1], src[b + 2]);
            if (src[c] !== undefined) dst.push(src[c + 0], src[c + 1], src[c + 2]);
        },
        addUV: function addUV(a, b, c) {
            var src = this.uvs;
            var dst = this.object.geometry.uvs;
            dst.push(src[a + 0], src[a + 1]);
            dst.push(src[b + 0], src[b + 1]);
            dst.push(src[c + 0], src[c + 1]);
        },
        addDefaultUV: function addDefaultUV() {
            var dst = this.object.geometry.uvs;
            dst.push(0, 0);
            dst.push(0, 0);
            dst.push(0, 0);
        },
        addUVLine: function addUVLine(a) {
            var src = this.uvs;
            var dst = this.object.geometry.uvs;
            dst.push(src[a + 0], src[a + 1]);
        },
        addFace: function addFace(a, b, c, ua, ub, uc, na, nb, nc) {
            var vLen = this.vertices.length;
            var ia = this.parseVertexIndex(a, vLen);
            var ib = this.parseVertexIndex(b, vLen);
            var ic = this.parseVertexIndex(c, vLen);
            this.addVertex(ia, ib, ic);
            this.addColor(ia, ib, ic);
            // normals
            if (na !== undefined && na !== '') {
                var nLen = this.normals.length;
                ia = this.parseNormalIndex(na, nLen);
                ib = this.parseNormalIndex(nb, nLen);
                ic = this.parseNormalIndex(nc, nLen);
                this.addNormal(ia, ib, ic);
            } else this.addFaceNormal(ia, ib, ic);
            // uvs
            if (ua !== undefined && ua !== '') {
                var uvLen = this.uvs.length;
                ia = this.parseUVIndex(ua, uvLen);
                ib = this.parseUVIndex(ub, uvLen);
                ic = this.parseUVIndex(uc, uvLen);
                this.addUV(ia, ib, ic);
                this.object.geometry.hasUVIndices = true;
            } else // add placeholder values (for inconsistent face definitions)
            this.addDefaultUV();
        },
        addPointGeometry: function addPointGeometry(vertices) {
            this.object.geometry.type = 'Points';
            var vLen = this.vertices.length;
            for(var vi = 0, l = vertices.length; vi < l; vi++){
                var index = this.parseVertexIndex(vertices[vi], vLen);
                this.addVertexPoint(index);
                this.addColor(index);
            }
        },
        addLineGeometry: function addLineGeometry(vertices, uvs) {
            this.object.geometry.type = 'Line';
            var vLen = this.vertices.length;
            var uvLen = this.uvs.length;
            for(var vi = 0, l = vertices.length; vi < l; vi++)this.addVertexLine(this.parseVertexIndex(vertices[vi], vLen));
            for(var uvi = 0, l1 = uvs.length; uvi < l1; uvi++)this.addUVLine(this.parseUVIndex(uvs[uvi], uvLen));
        }
    };
    state.startObject('', false);
    return state;
}
//
var $48bd0f7f134d0c59$export$7ae31604ad04b4a7 = /*#__PURE__*/ function(Loader) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(OBJLoader, Loader);
    function OBJLoader(manager) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, OBJLoader);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, OBJLoader, [
            manager
        ]);
        _this.materials = null;
        return _this;
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(OBJLoader, [
        {
            key: "load",
            value: function load(url, onLoad, onProgress, onError) {
                var scope = this;
                var loader = new (0, $c702e238df7c5123$export$98435a25b5cf7b2b)(this.manager);
                loader.setPath(this.path);
                loader.setRequestHeader(this.requestHeader);
                loader.setWithCredentials(this.withCredentials);
                loader.load(url, function(text) {
                    try {
                        onLoad(scope.parse(text));
                    } catch (e) {
                        if (onError) onError(e);
                        else console.error(e);
                        scope.manager.itemError(url);
                    }
                }, onProgress, onError);
            }
        },
        {
            key: "setMaterials",
            value: function setMaterials(materials) {
                this.materials = materials;
                return this;
            }
        },
        {
            key: "parse",
            value: function parse(text) {
                var state = new $48bd0f7f134d0c59$var$ParserState();
                if (text.indexOf('\r\n') !== -1) // This is faster than String.split with regex that splits on both
                text = text.replace(/\r\n/g, '\n');
                if (text.indexOf('\\\n') !== -1) // join lines separated by a line continuation character (\)
                text = text.replace(/\\\n/g, '');
                var lines = text.split('\n');
                var line = '', lineFirstChar = '';
                var lineLength = 0;
                var result = [];
                // Faster to just trim left side of the line. Use if available.
                var trimLeft = typeof ''.trimLeft === 'function';
                for(var i = 0, l = lines.length; i < l; i++){
                    line = lines[i];
                    line = trimLeft ? line.trimLeft() : line.trim();
                    lineLength = line.length;
                    if (lineLength === 0) continue;
                    lineFirstChar = line.charAt(0);
                    // @todo invoke passed in handler if any
                    if (lineFirstChar === '#') continue;
                    if (lineFirstChar === 'v') {
                        var data = line.split(/\s+/);
                        switch(data[0]){
                            case 'v':
                                state.vertices.push(parseFloat(data[1]), parseFloat(data[2]), parseFloat(data[3]));
                                if (data.length >= 7) state.colors.push(parseFloat(data[4]), parseFloat(data[5]), parseFloat(data[6]));
                                else // if no colors are defined, add placeholders so color and vertex indices match
                                state.colors.push(undefined, undefined, undefined);
                                break;
                            case 'vn':
                                state.normals.push(parseFloat(data[1]), parseFloat(data[2]), parseFloat(data[3]));
                                break;
                            case 'vt':
                                state.uvs.push(parseFloat(data[1]), parseFloat(data[2]));
                                break;
                        }
                    } else if (lineFirstChar === 'f') {
                        var lineData = line.substr(1).trim();
                        var vertexData = lineData.split(/\s+/);
                        var faceVertices = [];
                        // Parse the face vertex data into an easy to work with format
                        for(var j = 0, jl = vertexData.length; j < jl; j++){
                            var vertex = vertexData[j];
                            if (vertex.length > 0) {
                                var vertexParts = vertex.split('/');
                                faceVertices.push(vertexParts);
                            }
                        }
                        // Draw an edge between the first vertex and all subsequent vertices to form an n-gon
                        var v1 = faceVertices[0];
                        for(var j1 = 1, jl1 = faceVertices.length - 1; j1 < jl1; j1++){
                            var v2 = faceVertices[j1];
                            var v3 = faceVertices[j1 + 1];
                            state.addFace(v1[0], v2[0], v3[0], v1[1], v2[1], v3[1], v1[2], v2[2], v3[2]);
                        }
                    } else if (lineFirstChar === 'l') {
                        var lineParts = line.substring(1).trim().split(' ');
                        var lineVertices = [];
                        var lineUVs = [];
                        if (line.indexOf('/') === -1) lineVertices = lineParts;
                        else for(var li = 0, llen = lineParts.length; li < llen; li++){
                            var parts = lineParts[li].split('/');
                            if (parts[0] !== '') lineVertices.push(parts[0]);
                            if (parts[1] !== '') lineUVs.push(parts[1]);
                        }
                        state.addLineGeometry(lineVertices, lineUVs);
                    } else if (lineFirstChar === 'p') {
                        var lineData1 = line.substr(1).trim();
                        var pointData = lineData1.split(' ');
                        state.addPointGeometry(pointData);
                    } else if ((result = $48bd0f7f134d0c59$var$_object_pattern.exec(line)) !== null) {
                        // o object_name
                        // or
                        // g group_name
                        // WORKAROUND: https://bugs.chromium.org/p/v8/issues/detail?id=2869
                        // let name = result[ 0 ].substr( 1 ).trim();
                        var name = (' ' + result[0].substr(1).trim()).substr(1);
                        state.startObject(name);
                    } else if ($48bd0f7f134d0c59$var$_material_use_pattern.test(line)) // material
                    state.object.startMaterial(line.substring(7).trim(), state.materialLibraries);
                    else if ($48bd0f7f134d0c59$var$_material_library_pattern.test(line)) // mtl file
                    state.materialLibraries.push(line.substring(7).trim());
                    else if ($48bd0f7f134d0c59$var$_map_use_pattern.test(line)) // the line is parsed but ignored since the loader assumes textures are defined MTL files
                    // (according to https://www.okino.com/conv/imp_wave.htm, 'usemap' is the old-style Wavefront texture reference method)
                    console.warn('THREE.OBJLoader: Rendering identifier "usemap" not supported. Textures must be defined in MTL files.');
                    else if (lineFirstChar === 's') {
                        result = line.split(' ');
                        // smooth shading
                        // @todo Handle files that have varying smooth values for a set of faces inside one geometry,
                        // but does not define a usemtl for each face set.
                        // This should be detected and a dummy material created (later MultiMaterial and geometry groups).
                        // This requires some care to not create extra material on each smooth value for "normal" obj files.
                        // where explicit usemtl defines geometry groups.
                        // Example asset: examples/models/obj/cerberus/Cerberus.obj
                        /*
					 * http://paulbourke.net/dataformats/obj/
					 * or
					 * http://www.cs.utah.edu/~boulos/cs3505/obj_spec.pdf
					 *
					 * From chapter "Grouping" Syntax explanation "s group_number":
					 * "group_number is the smoothing group number. To turn off smoothing groups, use a value of 0 or off.
					 * Polygonal elements use group numbers to put elements in different smoothing groups. For free-form
					 * surfaces, smoothing groups are either turned on or off; there is no difference between values greater
					 * than 0."
					 */ if (result.length > 1) {
                            var value = result[1].trim().toLowerCase();
                            state.object.smooth = value !== '0' && value !== 'off';
                        } else // ZBrush can produce "s" lines #11707
                        state.object.smooth = true;
                        var material = state.object.currentMaterial();
                        if (material) material.smooth = state.object.smooth;
                    } else {
                        // Handle null terminated files without exception
                        if (line === '\0') continue;
                        console.warn('THREE.OBJLoader: Unexpected line: "' + line + '"');
                    }
                }
                state.finalize();
                var container = new (0, $c702e238df7c5123$export$eb2fcfdbd7ba97d4)();
                container.materialLibraries = [].concat(state.materialLibraries);
                var hasPrimitives = !(state.objects.length === 1 && state.objects[0].geometry.vertices.length === 0);
                if (hasPrimitives === true) for(var i1 = 0, l1 = state.objects.length; i1 < l1; i1++){
                    var object = state.objects[i1];
                    var geometry = object.geometry;
                    var materials = object.materials;
                    var isLine = geometry.type === 'Line';
                    var isPoints = geometry.type === 'Points';
                    var hasVertexColors = false;
                    // Skip o/g line declarations that did not follow with any faces
                    if (geometry.vertices.length === 0) continue;
                    var buffergeometry = new (0, $c702e238df7c5123$export$b7be63a67df8959)();
                    buffergeometry.setAttribute('position', new (0, $c702e238df7c5123$export$cbe7a62641830ebd)(geometry.vertices, 3));
                    if (geometry.normals.length > 0) buffergeometry.setAttribute('normal', new (0, $c702e238df7c5123$export$cbe7a62641830ebd)(geometry.normals, 3));
                    if (geometry.colors.length > 0) {
                        hasVertexColors = true;
                        buffergeometry.setAttribute('color', new (0, $c702e238df7c5123$export$cbe7a62641830ebd)(geometry.colors, 3));
                    }
                    if (geometry.hasUVIndices === true) buffergeometry.setAttribute('uv', new (0, $c702e238df7c5123$export$cbe7a62641830ebd)(geometry.uvs, 2));
                    // Create materials
                    var createdMaterials = [];
                    for(var mi = 0, miLen = materials.length; mi < miLen; mi++){
                        var sourceMaterial = materials[mi];
                        var materialHash = sourceMaterial.name + '_' + sourceMaterial.smooth + '_' + hasVertexColors;
                        var material1 = state.materials[materialHash];
                        if (this.materials !== null) {
                            material1 = this.materials.create(sourceMaterial.name);
                            // mtl etc. loaders probably can't create line materials correctly, copy properties to a line material.
                            if (isLine && material1 && !(material1 instanceof (0, $c702e238df7c5123$export$fbaaa33907730a0c))) {
                                var materialLine = new (0, $c702e238df7c5123$export$fbaaa33907730a0c)();
                                (0, $c702e238df7c5123$export$a2d8b23205c25948).prototype.copy.call(materialLine, material1);
                                materialLine.color.copy(material1.color);
                                material1 = materialLine;
                            } else if (isPoints && material1 && !(material1 instanceof (0, $c702e238df7c5123$export$a178c45366ce5d6b))) {
                                var materialPoints = new (0, $c702e238df7c5123$export$a178c45366ce5d6b)({
                                    size: 10,
                                    sizeAttenuation: false
                                });
                                (0, $c702e238df7c5123$export$a2d8b23205c25948).prototype.copy.call(materialPoints, material1);
                                materialPoints.color.copy(material1.color);
                                materialPoints.map = material1.map;
                                material1 = materialPoints;
                            }
                        }
                        if (material1 === undefined) {
                            if (isLine) material1 = new (0, $c702e238df7c5123$export$fbaaa33907730a0c)();
                            else if (isPoints) material1 = new (0, $c702e238df7c5123$export$a178c45366ce5d6b)({
                                size: 1,
                                sizeAttenuation: false
                            });
                            else material1 = new (0, $c702e238df7c5123$export$24c72f71cbaf0678)();
                            material1.name = sourceMaterial.name;
                            material1.flatShading = sourceMaterial.smooth ? false : true;
                            material1.vertexColors = hasVertexColors;
                            state.materials[materialHash] = material1;
                        }
                        createdMaterials.push(material1);
                    }
                    // Create mesh
                    var mesh = void 0;
                    if (createdMaterials.length > 1) {
                        for(var mi1 = 0, miLen1 = materials.length; mi1 < miLen1; mi1++){
                            var sourceMaterial1 = materials[mi1];
                            buffergeometry.addGroup(sourceMaterial1.groupStart, sourceMaterial1.groupCount, mi1);
                        }
                        if (isLine) mesh = new (0, $c702e238df7c5123$export$ff1ed10fedfdd604)(buffergeometry, createdMaterials);
                        else if (isPoints) mesh = new (0, $c702e238df7c5123$export$1c787534cb11aa3e)(buffergeometry, createdMaterials);
                        else mesh = new (0, $c702e238df7c5123$export$e176487c05830cc5)(buffergeometry, createdMaterials);
                    } else {
                        if (isLine) mesh = new (0, $c702e238df7c5123$export$ff1ed10fedfdd604)(buffergeometry, createdMaterials[0]);
                        else if (isPoints) mesh = new (0, $c702e238df7c5123$export$1c787534cb11aa3e)(buffergeometry, createdMaterials[0]);
                        else mesh = new (0, $c702e238df7c5123$export$e176487c05830cc5)(buffergeometry, createdMaterials[0]);
                    }
                    mesh.name = object.name;
                    container.add(mesh);
                }
                else // if there is only the default parser state object with no geometry data, interpret data as point cloud
                if (state.vertices.length > 0) {
                    var material2 = new (0, $c702e238df7c5123$export$a178c45366ce5d6b)({
                        size: 1,
                        sizeAttenuation: false
                    });
                    var buffergeometry1 = new (0, $c702e238df7c5123$export$b7be63a67df8959)();
                    buffergeometry1.setAttribute('position', new (0, $c702e238df7c5123$export$cbe7a62641830ebd)(state.vertices, 3));
                    if (state.colors.length > 0 && state.colors[0] !== undefined) {
                        buffergeometry1.setAttribute('color', new (0, $c702e238df7c5123$export$cbe7a62641830ebd)(state.colors, 3));
                        material2.vertexColors = true;
                    }
                    var points = new (0, $c702e238df7c5123$export$1c787534cb11aa3e)(buffergeometry1, material2);
                    container.add(points);
                }
                return container;
            }
        }
    ]);
    return OBJLoader;
}((0, $c702e238df7c5123$export$3b0d6d7590275603));







/**
 * Loads a Wavefront .mtl file specifying materials
 */ var $60176c8546b1ce93$export$2a0ca4746a43f1f8 = /*#__PURE__*/ function(Loader) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(MTLLoader, Loader);
    function MTLLoader(manager) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, MTLLoader);
        return (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, MTLLoader, [
            manager
        ]);
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(MTLLoader, [
        {
            /**
	 * Loads and parses a MTL asset from a URL.
	 *
	 * @param {String} url - URL to the MTL file.
	 * @param {Function} [onLoad] - Callback invoked with the loaded object.
	 * @param {Function} [onProgress] - Callback for download progress.
	 * @param {Function} [onError] - Callback for download errors.
	 *
	 * @see setPath setResourcePath
	 *
	 * @note In order for relative texture references to resolve correctly
	 * you must call setResourcePath() explicitly prior to load.
	 */ key: "load",
            value: function load(url, onLoad, onProgress, onError) {
                var scope = this;
                var path = this.path === '' ? (0, $c702e238df7c5123$export$b5d2dc08d867e41a).extractUrlBase(url) : this.path;
                var loader = new (0, $c702e238df7c5123$export$98435a25b5cf7b2b)(this.manager);
                loader.setPath(this.path);
                loader.setRequestHeader(this.requestHeader);
                loader.setWithCredentials(this.withCredentials);
                loader.load(url, function(text) {
                    try {
                        onLoad(scope.parse(text, path));
                    } catch (e) {
                        if (onError) onError(e);
                        else console.error(e);
                        scope.manager.itemError(url);
                    }
                }, onProgress, onError);
            }
        },
        {
            key: "setMaterialOptions",
            value: function setMaterialOptions(value) {
                this.materialOptions = value;
                return this;
            }
        },
        {
            /**
	 * Parses a MTL file.
	 *
	 * @param {String} text - Content of MTL file
	 * @return {MaterialCreator}
	 *
	 * @see setPath setResourcePath
	 *
	 * @note In order for relative texture references to resolve correctly
	 * you must call setResourcePath() explicitly prior to parse.
	 */ key: "parse",
            value: function parse(text, path) {
                var lines = text.split('\n');
                var info = {};
                var delimiter_pattern = /\s+/;
                var materialsInfo = {};
                for(var i = 0; i < lines.length; i++){
                    var line = lines[i];
                    line = line.trim();
                    if (line.length === 0 || line.charAt(0) === '#') continue;
                    var pos = line.indexOf(' ');
                    var key = pos >= 0 ? line.substring(0, pos) : line;
                    key = key.toLowerCase();
                    var value = pos >= 0 ? line.substring(pos + 1) : '';
                    value = value.trim();
                    if (key === 'newmtl') {
                        // New material
                        info = {
                            name: value
                        };
                        materialsInfo[value] = info;
                    } else if (key === 'ka' || key === 'kd' || key === 'ks' || key === 'ke') {
                        var ss = value.split(delimiter_pattern, 3);
                        info[key] = [
                            parseFloat(ss[0]),
                            parseFloat(ss[1]),
                            parseFloat(ss[2])
                        ];
                    } else info[key] = value;
                }
                var materialCreator = new $60176c8546b1ce93$var$MaterialCreator(this.resourcePath || path, this.materialOptions);
                materialCreator.setCrossOrigin(this.crossOrigin);
                materialCreator.setManager(this.manager);
                materialCreator.setMaterials(materialsInfo);
                return materialCreator;
            }
        }
    ]);
    return MTLLoader;
}((0, $c702e238df7c5123$export$3b0d6d7590275603));
/**
 * Create a new MTLLoader.MaterialCreator
 * @param baseUrl - Url relative to which textures are loaded
 * @param options - Set of options on how to construct the materials
 *                  side: Which side to apply the material
 *                        FrontSide (default), THREE.BackSide, THREE.DoubleSide
 *                  wrap: What type of wrapping to apply for textures
 *                        RepeatWrapping (default), THREE.ClampToEdgeWrapping, THREE.MirroredRepeatWrapping
 *                  normalizeRGB: RGBs need to be normalized to 0-1 from 0-255
 *                                Default: false, assumed to be already normalized
 *                  ignoreZeroRGBs: Ignore values of RGBs (Ka,Kd,Ks) that are all 0's
 *                                  Default: false
 * @constructor
 */ var $60176c8546b1ce93$var$MaterialCreator = /*#__PURE__*/ function() {
    "use strict";
    function MaterialCreator() {
        var baseUrl = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '', options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, MaterialCreator);
        this.baseUrl = baseUrl;
        this.options = options;
        this.materialsInfo = {};
        this.materials = {};
        this.materialsArray = [];
        this.nameLookup = {};
        this.crossOrigin = 'anonymous';
        this.side = this.options.side !== undefined ? this.options.side : (0, $c702e238df7c5123$export$2ede184fc2998901);
        this.wrap = this.options.wrap !== undefined ? this.options.wrap : (0, $c702e238df7c5123$export$533346c8e8dac0f5);
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(MaterialCreator, [
        {
            key: "setCrossOrigin",
            value: function setCrossOrigin(value) {
                this.crossOrigin = value;
                return this;
            }
        },
        {
            key: "setManager",
            value: function setManager(value) {
                this.manager = value;
            }
        },
        {
            key: "setMaterials",
            value: function setMaterials(materialsInfo) {
                this.materialsInfo = this.convert(materialsInfo);
                this.materials = {};
                this.materialsArray = [];
                this.nameLookup = {};
            }
        },
        {
            key: "convert",
            value: function convert(materialsInfo) {
                if (!this.options) return materialsInfo;
                var converted = {};
                for(var mn in materialsInfo){
                    // Convert materials info into normalized form based on options
                    var mat = materialsInfo[mn];
                    var covmat = {};
                    converted[mn] = covmat;
                    for(var prop in mat){
                        var save = true;
                        var value = mat[prop];
                        var lprop = prop.toLowerCase();
                        switch(lprop){
                            case 'kd':
                            case 'ka':
                            case 'ks':
                                // Diffuse color (color under white light) using RGB values
                                if (this.options && this.options.normalizeRGB) value = [
                                    value[0] / 255,
                                    value[1] / 255,
                                    value[2] / 255
                                ];
                                if (this.options && this.options.ignoreZeroRGBs) {
                                    if (value[0] === 0 && value[1] === 0 && value[2] === 0) // ignore
                                    save = false;
                                }
                                break;
                            default:
                                break;
                        }
                        if (save) covmat[lprop] = value;
                    }
                }
                return converted;
            }
        },
        {
            key: "preload",
            value: function preload() {
                for(var mn in this.materialsInfo)this.create(mn);
            }
        },
        {
            key: "getIndex",
            value: function getIndex(materialName) {
                return this.nameLookup[materialName];
            }
        },
        {
            key: "getAsArray",
            value: function getAsArray() {
                var index = 0;
                for(var mn in this.materialsInfo){
                    this.materialsArray[index] = this.create(mn);
                    this.nameLookup[mn] = index;
                    index++;
                }
                return this.materialsArray;
            }
        },
        {
            key: "create",
            value: function create(materialName) {
                if (this.materials[materialName] === undefined) this.createMaterial_(materialName);
                return this.materials[materialName];
            }
        },
        {
            key: "createMaterial_",
            value: function createMaterial_(materialName) {
                // Create material
                var scope = this;
                var mat = this.materialsInfo[materialName];
                var params = {
                    name: materialName,
                    side: this.side
                };
                function resolveURL(baseUrl, url) {
                    if (typeof url !== 'string' || url === '') return '';
                    // Absolute URL
                    if (/^https?:\/\//i.test(url)) return url;
                    return baseUrl + url;
                }
                function setMapForType(mapType, value) {
                    if (params[mapType]) return; // Keep the first encountered texture
                    var texParams = scope.getTextureParams(value, params);
                    var map = scope.loadTexture(resolveURL(scope.baseUrl, texParams.url));
                    map.repeat.copy(texParams.scale);
                    map.offset.copy(texParams.offset);
                    map.wrapS = scope.wrap;
                    map.wrapT = scope.wrap;
                    params[mapType] = map;
                }
                for(var prop in mat){
                    var value = mat[prop];
                    var n = void 0;
                    if (value === '') continue;
                    switch(prop.toLowerCase()){
                        // Ns is material specular exponent
                        case 'kd':
                            // Diffuse color (color under white light) using RGB values
                            params.color = new (0, $c702e238df7c5123$export$892596cec99bc70e)().fromArray(value);
                            break;
                        case 'ks':
                            // Specular color (color when light is reflected from shiny surface) using RGB values
                            params.specular = new (0, $c702e238df7c5123$export$892596cec99bc70e)().fromArray(value);
                            break;
                        case 'ke':
                            // Emissive using RGB values
                            params.emissive = new (0, $c702e238df7c5123$export$892596cec99bc70e)().fromArray(value);
                            break;
                        case 'map_kd':
                            // Diffuse texture map
                            setMapForType('map', value);
                            break;
                        case 'map_ks':
                            // Specular map
                            setMapForType('specularMap', value);
                            break;
                        case 'map_ke':
                            // Emissive map
                            setMapForType('emissiveMap', value);
                            break;
                        case 'norm':
                            setMapForType('normalMap', value);
                            break;
                        case 'map_bump':
                        case 'bump':
                            // Bump texture map
                            setMapForType('bumpMap', value);
                            break;
                        case 'map_d':
                            // Alpha map
                            setMapForType('alphaMap', value);
                            params.transparent = true;
                            break;
                        case 'ns':
                            // The specular exponent (defines the focus of the specular highlight)
                            // A high exponent results in a tight, concentrated highlight. Ns values normally range from 0 to 1000.
                            params.shininess = parseFloat(value);
                            break;
                        case 'd':
                            n = parseFloat(value);
                            if (n < 1) {
                                params.opacity = n;
                                params.transparent = true;
                            }
                            break;
                        case 'tr':
                            n = parseFloat(value);
                            if (this.options && this.options.invertTrProperty) n = 1 - n;
                            if (n > 0) {
                                params.opacity = 1 - n;
                                params.transparent = true;
                            }
                            break;
                        default:
                            break;
                    }
                }
                this.materials[materialName] = new (0, $c702e238df7c5123$export$24c72f71cbaf0678)(params);
                return this.materials[materialName];
            }
        },
        {
            key: "getTextureParams",
            value: function getTextureParams(value, matParams) {
                var texParams = {
                    scale: new (0, $c702e238df7c5123$export$c977b3e384af9ae1)(1, 1),
                    offset: new (0, $c702e238df7c5123$export$c977b3e384af9ae1)(0, 0)
                };
                var items = value.split(/\s+/);
                var pos;
                pos = items.indexOf('-bm');
                if (pos >= 0) {
                    matParams.bumpScale = parseFloat(items[pos + 1]);
                    items.splice(pos, 2);
                }
                pos = items.indexOf('-s');
                if (pos >= 0) {
                    texParams.scale.set(parseFloat(items[pos + 1]), parseFloat(items[pos + 2]));
                    items.splice(pos, 4); // we expect 3 parameters here!
                }
                pos = items.indexOf('-o');
                if (pos >= 0) {
                    texParams.offset.set(parseFloat(items[pos + 1]), parseFloat(items[pos + 2]));
                    items.splice(pos, 4); // we expect 3 parameters here!
                }
                texParams.url = items.join(' ').trim();
                return texParams;
            }
        },
        {
            key: "loadTexture",
            value: function loadTexture(url, mapping, onLoad, onProgress, onError) {
                var manager = this.manager !== undefined ? this.manager : (0, $c702e238df7c5123$export$b033c3f9a95c6a16);
                var loader = manager.getHandler(url);
                if (loader === null) loader = new (0, $c702e238df7c5123$export$fd1bfc71f64c538c)(manager);
                if (loader.setCrossOrigin) loader.setCrossOrigin(this.crossOrigin);
                var texture = loader.load(url, onLoad, onProgress, onError);
                if (mapping !== undefined) texture.mapping = mapping;
                return texture;
            }
        }
    ]);
    return MaterialCreator;
}();






// This set of controls performs orbiting, dollying (zooming), and panning.
// Unlike TrackballControls, it maintains the "up" direction object.up (+Y by default).
//
//    Orbit - left mouse / touch: one-finger move
//    Zoom - middle mouse, or mousewheel / touch: two-finger spread or squish
//    Pan - right mouse, or left mouse + ctrl/meta/shiftKey, or arrow keys / touch: two-finger move
var $cfa4b88fbc45945c$var$_changeEvent = {
    type: 'change'
};
var $cfa4b88fbc45945c$var$_startEvent = {
    type: 'start'
};
var $cfa4b88fbc45945c$var$_endEvent = {
    type: 'end'
};
var $cfa4b88fbc45945c$export$8ff7788029dfdf52 = /*#__PURE__*/ function(EventDispatcher) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(OrbitControls, EventDispatcher);
    function OrbitControls(object, domElement) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, OrbitControls);
        var _this;
        var getAutoRotationAngle = function getAutoRotationAngle() {
            return 2 * Math.PI / 60 / 60 * scope.autoRotateSpeed;
        };
        var getZoomScale = function getZoomScale() {
            return Math.pow(0.95, scope.zoomSpeed);
        };
        var rotateLeft = function rotateLeft(angle) {
            sphericalDelta.theta -= angle;
        };
        var rotateUp = function rotateUp(angle) {
            sphericalDelta.phi -= angle;
        };
        var dollyOut = function dollyOut(dollyScale) {
            if (scope.object.isPerspectiveCamera) scale /= dollyScale;
            else if (scope.object.isOrthographicCamera) {
                scope.object.zoom = Math.max(scope.minZoom, Math.min(scope.maxZoom, scope.object.zoom * dollyScale));
                scope.object.updateProjectionMatrix();
                zoomChanged = true;
            } else {
                console.warn('WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled.');
                scope.enableZoom = false;
            }
        };
        var dollyIn = function dollyIn(dollyScale) {
            if (scope.object.isPerspectiveCamera) scale *= dollyScale;
            else if (scope.object.isOrthographicCamera) {
                scope.object.zoom = Math.max(scope.minZoom, Math.min(scope.maxZoom, scope.object.zoom / dollyScale));
                scope.object.updateProjectionMatrix();
                zoomChanged = true;
            } else {
                console.warn('WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled.');
                scope.enableZoom = false;
            }
        };
        var handleMouseDownRotate = //
        // event callbacks - update the object state
        //
        function handleMouseDownRotate(event) {
            rotateStart.set(event.clientX, event.clientY);
        };
        var handleMouseDownDolly = function handleMouseDownDolly(event) {
            dollyStart.set(event.clientX, event.clientY);
        };
        var handleMouseDownPan = function handleMouseDownPan(event) {
            panStart.set(event.clientX, event.clientY);
        };
        var handleMouseMoveRotate = function handleMouseMoveRotate(event) {
            rotateEnd.set(event.clientX, event.clientY);
            rotateDelta.subVectors(rotateEnd, rotateStart).multiplyScalar(scope.rotateSpeed);
            var element = scope.domElement;
            rotateLeft(2 * Math.PI * rotateDelta.x / element.clientHeight); // yes, height
            rotateUp(2 * Math.PI * rotateDelta.y / element.clientHeight);
            rotateStart.copy(rotateEnd);
            scope.update();
        };
        var handleMouseMoveDolly = function handleMouseMoveDolly(event) {
            dollyEnd.set(event.clientX, event.clientY);
            dollyDelta.subVectors(dollyEnd, dollyStart);
            if (dollyDelta.y > 0) dollyOut(getZoomScale());
            else if (dollyDelta.y < 0) dollyIn(getZoomScale());
            dollyStart.copy(dollyEnd);
            scope.update();
        };
        var handleMouseMovePan = function handleMouseMovePan(event) {
            panEnd.set(event.clientX, event.clientY);
            panDelta.subVectors(panEnd, panStart).multiplyScalar(scope.panSpeed);
            pan(panDelta.x, panDelta.y);
            panStart.copy(panEnd);
            scope.update();
        };
        var handleMouseUp = function handleMouseUp() {
        // no-op
        };
        var handleMouseWheel = function handleMouseWheel(event) {
            if (event.deltaY < 0) dollyIn(getZoomScale());
            else if (event.deltaY > 0) dollyOut(getZoomScale());
            scope.update();
        };
        var handleKeyDown = function handleKeyDown(event) {
            var needsUpdate = false;
            switch(event.code){
                case scope.keys.UP:
                    pan(0, scope.keyPanSpeed);
                    needsUpdate = true;
                    break;
                case scope.keys.BOTTOM:
                    pan(0, -scope.keyPanSpeed);
                    needsUpdate = true;
                    break;
                case scope.keys.LEFT:
                    pan(scope.keyPanSpeed, 0);
                    needsUpdate = true;
                    break;
                case scope.keys.RIGHT:
                    pan(-scope.keyPanSpeed, 0);
                    needsUpdate = true;
                    break;
            }
            if (needsUpdate) {
                // prevent the browser from scrolling on cursor keys
                event.preventDefault();
                scope.update();
            }
        };
        var handleTouchStartRotate = function handleTouchStartRotate() {
            if (pointers.length === 1) rotateStart.set(pointers[0].pageX, pointers[0].pageY);
            else {
                var x = 0.5 * (pointers[0].pageX + pointers[1].pageX);
                var y = 0.5 * (pointers[0].pageY + pointers[1].pageY);
                rotateStart.set(x, y);
            }
        };
        var handleTouchStartPan = function handleTouchStartPan() {
            if (pointers.length === 1) panStart.set(pointers[0].pageX, pointers[0].pageY);
            else {
                var x = 0.5 * (pointers[0].pageX + pointers[1].pageX);
                var y = 0.5 * (pointers[0].pageY + pointers[1].pageY);
                panStart.set(x, y);
            }
        };
        var handleTouchStartDolly = function handleTouchStartDolly() {
            var dx = pointers[0].pageX - pointers[1].pageX;
            var dy = pointers[0].pageY - pointers[1].pageY;
            var distance = Math.sqrt(dx * dx + dy * dy);
            dollyStart.set(0, distance);
        };
        var handleTouchStartDollyPan = function handleTouchStartDollyPan() {
            if (scope.enableZoom) handleTouchStartDolly();
            if (scope.enablePan) handleTouchStartPan();
        };
        var handleTouchStartDollyRotate = function handleTouchStartDollyRotate() {
            if (scope.enableZoom) handleTouchStartDolly();
            if (scope.enableRotate) handleTouchStartRotate();
        };
        var handleTouchMoveRotate = function handleTouchMoveRotate(event) {
            if (pointers.length == 1) rotateEnd.set(event.pageX, event.pageY);
            else {
                var position = getSecondPointerPosition(event);
                var x = 0.5 * (event.pageX + position.x);
                var y = 0.5 * (event.pageY + position.y);
                rotateEnd.set(x, y);
            }
            rotateDelta.subVectors(rotateEnd, rotateStart).multiplyScalar(scope.rotateSpeed);
            var element = scope.domElement;
            rotateLeft(2 * Math.PI * rotateDelta.x / element.clientHeight); // yes, height
            rotateUp(2 * Math.PI * rotateDelta.y / element.clientHeight);
            rotateStart.copy(rotateEnd);
        };
        var handleTouchMovePan = function handleTouchMovePan(event) {
            if (pointers.length === 1) panEnd.set(event.pageX, event.pageY);
            else {
                var position = getSecondPointerPosition(event);
                var x = 0.5 * (event.pageX + position.x);
                var y = 0.5 * (event.pageY + position.y);
                panEnd.set(x, y);
            }
            panDelta.subVectors(panEnd, panStart).multiplyScalar(scope.panSpeed);
            pan(panDelta.x, panDelta.y);
            panStart.copy(panEnd);
        };
        var handleTouchMoveDolly = function handleTouchMoveDolly(event) {
            var position = getSecondPointerPosition(event);
            var dx = event.pageX - position.x;
            var dy = event.pageY - position.y;
            var distance = Math.sqrt(dx * dx + dy * dy);
            dollyEnd.set(0, distance);
            dollyDelta.set(0, Math.pow(dollyEnd.y / dollyStart.y, scope.zoomSpeed));
            dollyOut(dollyDelta.y);
            dollyStart.copy(dollyEnd);
        };
        var handleTouchMoveDollyPan = function handleTouchMoveDollyPan(event) {
            if (scope.enableZoom) handleTouchMoveDolly(event);
            if (scope.enablePan) handleTouchMovePan(event);
        };
        var handleTouchMoveDollyRotate = function handleTouchMoveDollyRotate(event) {
            if (scope.enableZoom) handleTouchMoveDolly(event);
            if (scope.enableRotate) handleTouchMoveRotate(event);
        };
        var handleTouchEnd = function handleTouchEnd() {
        // no-op
        };
        var onPointerDown = //
        // event handlers - FSM: listen for events and reset state
        //
        function onPointerDown(event) {
            if (scope.enabled === false) return;
            if (pointers.length === 0) {
                scope.domElement.ownerDocument.addEventListener('pointermove', onPointerMove);
                scope.domElement.ownerDocument.addEventListener('pointerup', onPointerUp);
            }
            //
            addPointer(event);
            if (event.pointerType === 'touch') onTouchStart(event);
            else onMouseDown(event);
        };
        var onPointerMove = function onPointerMove(event) {
            if (scope.enabled === false) return;
            if (event.pointerType === 'touch') onTouchMove(event);
            else onMouseMove(event);
        };
        var onPointerCancel = function onPointerCancel(event) {
            removePointer(event);
        };
        var onMouseDown = function onMouseDown(event) {
            var mouseAction;
            switch(event.button){
                case 0:
                    mouseAction = scope.mouseButtons.LEFT;
                    break;
                case 1:
                    mouseAction = scope.mouseButtons.MIDDLE;
                    break;
                case 2:
                    mouseAction = scope.mouseButtons.RIGHT;
                    break;
                default:
                    mouseAction = -1;
            }
            switch(mouseAction){
                case (0, $c702e238df7c5123$export$7177b3e430c2d7ca).DOLLY:
                    if (scope.enableZoom === false) return;
                    handleMouseDownDolly(event);
                    state = STATE.DOLLY;
                    break;
                case (0, $c702e238df7c5123$export$7177b3e430c2d7ca).ROTATE:
                    if (event.ctrlKey || event.metaKey || event.shiftKey) {
                        if (scope.enablePan === false) return;
                        handleMouseDownPan(event);
                        state = STATE.PAN;
                    } else {
                        if (scope.enableRotate === false) return;
                        handleMouseDownRotate(event);
                        state = STATE.ROTATE;
                    }
                    break;
                case (0, $c702e238df7c5123$export$7177b3e430c2d7ca).PAN:
                    if (event.ctrlKey || event.metaKey || event.shiftKey) {
                        if (scope.enableRotate === false) return;
                        handleMouseDownRotate(event);
                        state = STATE.ROTATE;
                    } else {
                        if (scope.enablePan === false) return;
                        handleMouseDownPan(event);
                        state = STATE.PAN;
                    }
                    break;
                default:
                    state = STATE.NONE;
            }
            if (state !== STATE.NONE) scope.dispatchEvent($cfa4b88fbc45945c$var$_startEvent);
        };
        var onMouseMove = function onMouseMove(event) {
            if (scope.enabled === false) return;
            switch(state){
                case STATE.ROTATE:
                    if (scope.enableRotate === false) return;
                    handleMouseMoveRotate(event);
                    break;
                case STATE.DOLLY:
                    if (scope.enableZoom === false) return;
                    handleMouseMoveDolly(event);
                    break;
                case STATE.PAN:
                    if (scope.enablePan === false) return;
                    handleMouseMovePan(event);
                    break;
            }
        };
        var onMouseUp = function onMouseUp(event) {
            handleMouseUp(event);
            scope.dispatchEvent($cfa4b88fbc45945c$var$_endEvent);
            state = STATE.NONE;
        };
        var onMouseWheel = function onMouseWheel(event) {
            if (scope.enabled === false || scope.enableZoom === false || state !== STATE.NONE && state !== STATE.ROTATE) return;
            event.preventDefault();
            scope.dispatchEvent($cfa4b88fbc45945c$var$_startEvent);
            handleMouseWheel(event);
            scope.dispatchEvent($cfa4b88fbc45945c$var$_endEvent);
        };
        var onKeyDown = function onKeyDown(event) {
            if (scope.enabled === false || scope.enablePan === false) return;
            handleKeyDown(event);
        };
        var onTouchStart = function onTouchStart(event) {
            trackPointer(event);
            switch(pointers.length){
                case 1:
                    switch(scope.touches.ONE){
                        case (0, $c702e238df7c5123$export$d46bd3ead7cc759b).ROTATE:
                            if (scope.enableRotate === false) return;
                            handleTouchStartRotate();
                            state = STATE.TOUCH_ROTATE;
                            break;
                        case (0, $c702e238df7c5123$export$d46bd3ead7cc759b).PAN:
                            if (scope.enablePan === false) return;
                            handleTouchStartPan();
                            state = STATE.TOUCH_PAN;
                            break;
                        default:
                            state = STATE.NONE;
                    }
                    break;
                case 2:
                    switch(scope.touches.TWO){
                        case (0, $c702e238df7c5123$export$d46bd3ead7cc759b).DOLLY_PAN:
                            if (scope.enableZoom === false && scope.enablePan === false) return;
                            handleTouchStartDollyPan();
                            state = STATE.TOUCH_DOLLY_PAN;
                            break;
                        case (0, $c702e238df7c5123$export$d46bd3ead7cc759b).DOLLY_ROTATE:
                            if (scope.enableZoom === false && scope.enableRotate === false) return;
                            handleTouchStartDollyRotate();
                            state = STATE.TOUCH_DOLLY_ROTATE;
                            break;
                        default:
                            state = STATE.NONE;
                    }
                    break;
                default:
                    state = STATE.NONE;
            }
            if (state !== STATE.NONE) scope.dispatchEvent($cfa4b88fbc45945c$var$_startEvent);
        };
        var onTouchMove = function onTouchMove(event) {
            trackPointer(event);
            switch(state){
                case STATE.TOUCH_ROTATE:
                    if (scope.enableRotate === false) return;
                    handleTouchMoveRotate(event);
                    scope.update();
                    break;
                case STATE.TOUCH_PAN:
                    if (scope.enablePan === false) return;
                    handleTouchMovePan(event);
                    scope.update();
                    break;
                case STATE.TOUCH_DOLLY_PAN:
                    if (scope.enableZoom === false && scope.enablePan === false) return;
                    handleTouchMoveDollyPan(event);
                    scope.update();
                    break;
                case STATE.TOUCH_DOLLY_ROTATE:
                    if (scope.enableZoom === false && scope.enableRotate === false) return;
                    handleTouchMoveDollyRotate(event);
                    scope.update();
                    break;
                default:
                    state = STATE.NONE;
            }
        };
        var onTouchEnd = function onTouchEnd(event) {
            handleTouchEnd(event);
            scope.dispatchEvent($cfa4b88fbc45945c$var$_endEvent);
            state = STATE.NONE;
        };
        var onContextMenu = function onContextMenu(event) {
            if (scope.enabled === false) return;
            event.preventDefault();
        };
        var addPointer = function addPointer(event) {
            pointers.push(event);
        };
        var removePointer = function removePointer(event) {
            delete pointerPositions[event.pointerId];
            for(var i = 0; i < pointers.length; i++)if (pointers[i].pointerId == event.pointerId) {
                pointers.splice(i, 1);
                return;
            }
        };
        var trackPointer = function trackPointer(event) {
            var position = pointerPositions[event.pointerId];
            if (position === undefined) {
                position = new (0, $c702e238df7c5123$export$c977b3e384af9ae1)();
                pointerPositions[event.pointerId] = position;
            }
            position.set(event.pageX, event.pageY);
        };
        var getSecondPointerPosition = function getSecondPointerPosition(event) {
            var pointer = event.pointerId === pointers[0].pointerId ? pointers[1] : pointers[0];
            return pointerPositions[pointer.pointerId];
        };
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, OrbitControls);
        if (domElement === undefined) console.warn('THREE.OrbitControls: The second parameter "domElement" is now mandatory.');
        if (domElement === document) console.error('THREE.OrbitControls: "document" should not be used as the target "domElement". Please use "renderer.domElement" instead.');
        _this.object = object;
        _this.domElement = domElement;
        _this.domElement.style.touchAction = 'none'; // disable touch scroll
        // Set to false to disable this control
        _this.enabled = true;
        // "target" sets the location of focus, where the object orbits around
        _this.target = new (0, $c702e238df7c5123$export$64b5c384219d3699)();
        // How far you can dolly in and out ( PerspectiveCamera only )
        _this.minDistance = 0;
        _this.maxDistance = Infinity;
        // How far you can zoom in and out ( OrthographicCamera only )
        _this.minZoom = 0;
        _this.maxZoom = Infinity;
        // How far you can orbit vertically, upper and lower limits.
        // Range is 0 to Math.PI radians.
        _this.minPolarAngle = 0; // radians
        _this.maxPolarAngle = Math.PI; // radians
        // How far you can orbit horizontally, upper and lower limits.
        // If set, the interval [ min, max ] must be a sub-interval of [ - 2 PI, 2 PI ], with ( max - min < 2 PI )
        _this.minAzimuthAngle = -Infinity; // radians
        _this.maxAzimuthAngle = Infinity; // radians
        // Set to true to enable damping (inertia)
        // If damping is enabled, you must call controls.update() in your animation loop
        _this.enableDamping = false;
        _this.dampingFactor = 0.05;
        // This option actually enables dollying in and out; left as "zoom" for backwards compatibility.
        // Set to false to disable zooming
        _this.enableZoom = true;
        _this.zoomSpeed = 1.0;
        // Set to false to disable rotating
        _this.enableRotate = true;
        _this.rotateSpeed = 1.0;
        // Set to false to disable panning
        _this.enablePan = true;
        _this.panSpeed = 1.0;
        _this.screenSpacePanning = true; // if false, pan orthogonal to world-space direction camera.up
        _this.keyPanSpeed = 7.0; // pixels moved per arrow key push
        // Set to true to automatically rotate around the target
        // If auto-rotate is enabled, you must call controls.update() in your animation loop
        _this.autoRotate = false;
        _this.autoRotateSpeed = 2.0; // 30 seconds per orbit when fps is 60
        // The four arrow keys
        _this.keys = {
            LEFT: 'ArrowLeft',
            UP: 'ArrowUp',
            RIGHT: 'ArrowRight',
            BOTTOM: 'ArrowDown'
        };
        // Mouse buttons
        _this.mouseButtons = {
            LEFT: (0, $c702e238df7c5123$export$7177b3e430c2d7ca).ROTATE,
            MIDDLE: (0, $c702e238df7c5123$export$7177b3e430c2d7ca).DOLLY,
            RIGHT: (0, $c702e238df7c5123$export$7177b3e430c2d7ca).PAN
        };
        // Touch fingers
        _this.touches = {
            ONE: (0, $c702e238df7c5123$export$d46bd3ead7cc759b).ROTATE,
            TWO: (0, $c702e238df7c5123$export$d46bd3ead7cc759b).DOLLY_PAN
        };
        // for reset
        _this.target0 = _this.target.clone();
        _this.position0 = _this.object.position.clone();
        _this.zoom0 = _this.object.zoom;
        // the target DOM element for key events
        _this._domElementKeyEvents = null;
        //
        // public methods
        //
        _this.getPolarAngle = function() {
            return spherical.phi;
        };
        _this.getAzimuthalAngle = function() {
            return spherical.theta;
        };
        _this.listenToKeyEvents = function(domElement) {
            domElement.addEventListener('keydown', onKeyDown);
            this._domElementKeyEvents = domElement;
        };
        _this.saveState = function() {
            scope.target0.copy(scope.target);
            scope.position0.copy(scope.object.position);
            scope.zoom0 = scope.object.zoom;
        };
        _this.reset = function() {
            scope.target.copy(scope.target0);
            scope.object.position.copy(scope.position0);
            scope.object.zoom = scope.zoom0;
            scope.object.updateProjectionMatrix();
            scope.dispatchEvent($cfa4b88fbc45945c$var$_changeEvent);
            scope.update();
            state = STATE.NONE;
        };
        // this method is exposed, but perhaps it would be better if we can make it private...
        _this.update = function() {
            var offset = new (0, $c702e238df7c5123$export$64b5c384219d3699)();
            // so camera.up is the orbit axis
            var quat = new (0, $c702e238df7c5123$export$23d6a54f0bbc85a3)().setFromUnitVectors(object.up, new (0, $c702e238df7c5123$export$64b5c384219d3699)(0, 1, 0));
            var quatInverse = quat.clone().invert();
            var lastPosition = new (0, $c702e238df7c5123$export$64b5c384219d3699)();
            var lastQuaternion = new (0, $c702e238df7c5123$export$23d6a54f0bbc85a3)();
            var twoPI = 2 * Math.PI;
            return function update() {
                var position = scope.object.position;
                offset.copy(position).sub(scope.target);
                // rotate offset to "y-axis-is-up" space
                offset.applyQuaternion(quat);
                // angle from z-axis around y-axis
                spherical.setFromVector3(offset);
                if (scope.autoRotate && state === STATE.NONE) rotateLeft(getAutoRotationAngle());
                if (scope.enableDamping) {
                    spherical.theta += sphericalDelta.theta * scope.dampingFactor;
                    spherical.phi += sphericalDelta.phi * scope.dampingFactor;
                } else {
                    spherical.theta += sphericalDelta.theta;
                    spherical.phi += sphericalDelta.phi;
                }
                // restrict theta to be between desired limits
                var min = scope.minAzimuthAngle;
                var max = scope.maxAzimuthAngle;
                if (isFinite(min) && isFinite(max)) {
                    if (min < -Math.PI) min += twoPI;
                    else if (min > Math.PI) min -= twoPI;
                    if (max < -Math.PI) max += twoPI;
                    else if (max > Math.PI) max -= twoPI;
                    if (min <= max) spherical.theta = Math.max(min, Math.min(max, spherical.theta));
                    else spherical.theta = spherical.theta > (min + max) / 2 ? Math.max(min, spherical.theta) : Math.min(max, spherical.theta);
                }
                // restrict phi to be between desired limits
                spherical.phi = Math.max(scope.minPolarAngle, Math.min(scope.maxPolarAngle, spherical.phi));
                spherical.makeSafe();
                spherical.radius *= scale;
                // restrict radius to be between desired limits
                spherical.radius = Math.max(scope.minDistance, Math.min(scope.maxDistance, spherical.radius));
                // move target to panned location
                if (scope.enableDamping === true) scope.target.addScaledVector(panOffset, scope.dampingFactor);
                else scope.target.add(panOffset);
                offset.setFromSpherical(spherical);
                // rotate offset back to "camera-up-vector-is-up" space
                offset.applyQuaternion(quatInverse);
                position.copy(scope.target).add(offset);
                scope.object.lookAt(scope.target);
                if (scope.enableDamping === true) {
                    sphericalDelta.theta *= 1 - scope.dampingFactor;
                    sphericalDelta.phi *= 1 - scope.dampingFactor;
                    panOffset.multiplyScalar(1 - scope.dampingFactor);
                } else {
                    sphericalDelta.set(0, 0, 0);
                    panOffset.set(0, 0, 0);
                }
                scale = 1;
                // update condition is:
                // min(camera displacement, camera rotation in radians)^2 > EPS
                // using small-angle approximation cos(x/2) = 1 - x^2 / 8
                if (zoomChanged || lastPosition.distanceToSquared(scope.object.position) > EPS || 8 * (1 - lastQuaternion.dot(scope.object.quaternion)) > EPS) {
                    scope.dispatchEvent($cfa4b88fbc45945c$var$_changeEvent);
                    lastPosition.copy(scope.object.position);
                    lastQuaternion.copy(scope.object.quaternion);
                    zoomChanged = false;
                    return true;
                }
                return false;
            };
        }();
        _this.dispose = function() {
            scope.domElement.removeEventListener('contextmenu', onContextMenu);
            scope.domElement.removeEventListener('pointerdown', onPointerDown);
            scope.domElement.removeEventListener('pointercancel', onPointerCancel);
            scope.domElement.removeEventListener('wheel', onMouseWheel);
            scope.domElement.ownerDocument.removeEventListener('pointermove', onPointerMove);
            scope.domElement.ownerDocument.removeEventListener('pointerup', onPointerUp);
            if (scope._domElementKeyEvents !== null) scope._domElementKeyEvents.removeEventListener('keydown', onKeyDown);
        //scope.dispatchEvent( { type: 'dispose' } ); // should this be added here?
        };
        //
        // internals
        //
        var scope = _this;
        var STATE = {
            NONE: -1,
            ROTATE: 0,
            DOLLY: 1,
            PAN: 2,
            TOUCH_ROTATE: 3,
            TOUCH_PAN: 4,
            TOUCH_DOLLY_PAN: 5,
            TOUCH_DOLLY_ROTATE: 6
        };
        var state = STATE.NONE;
        var EPS = 0.000001;
        // current position in spherical coordinates
        var spherical = new (0, $c702e238df7c5123$export$d712cd887b4a00f7)();
        var sphericalDelta = new (0, $c702e238df7c5123$export$d712cd887b4a00f7)();
        var scale = 1;
        var panOffset = new (0, $c702e238df7c5123$export$64b5c384219d3699)();
        var zoomChanged = false;
        var rotateStart = new (0, $c702e238df7c5123$export$c977b3e384af9ae1)();
        var rotateEnd = new (0, $c702e238df7c5123$export$c977b3e384af9ae1)();
        var rotateDelta = new (0, $c702e238df7c5123$export$c977b3e384af9ae1)();
        var panStart = new (0, $c702e238df7c5123$export$c977b3e384af9ae1)();
        var panEnd = new (0, $c702e238df7c5123$export$c977b3e384af9ae1)();
        var panDelta = new (0, $c702e238df7c5123$export$c977b3e384af9ae1)();
        var dollyStart = new (0, $c702e238df7c5123$export$c977b3e384af9ae1)();
        var dollyEnd = new (0, $c702e238df7c5123$export$c977b3e384af9ae1)();
        var dollyDelta = new (0, $c702e238df7c5123$export$c977b3e384af9ae1)();
        var pointers = [];
        var pointerPositions = {};
        var panLeft = function() {
            var v = new (0, $c702e238df7c5123$export$64b5c384219d3699)();
            return function panLeft(distance, objectMatrix) {
                v.setFromMatrixColumn(objectMatrix, 0); // get X column of objectMatrix
                v.multiplyScalar(-distance);
                panOffset.add(v);
            };
        }();
        var panUp = function() {
            var v = new (0, $c702e238df7c5123$export$64b5c384219d3699)();
            return function panUp(distance, objectMatrix) {
                if (scope.screenSpacePanning === true) v.setFromMatrixColumn(objectMatrix, 1);
                else {
                    v.setFromMatrixColumn(objectMatrix, 0);
                    v.crossVectors(scope.object.up, v);
                }
                v.multiplyScalar(distance);
                panOffset.add(v);
            };
        }();
        // deltaX and deltaY are in pixels; right and down are positive
        var pan = function() {
            var offset = new (0, $c702e238df7c5123$export$64b5c384219d3699)();
            return function pan(deltaX, deltaY) {
                var element = scope.domElement;
                if (scope.object.isPerspectiveCamera) {
                    // perspective
                    var position = scope.object.position;
                    offset.copy(position).sub(scope.target);
                    var targetDistance = offset.length();
                    // half of the fov is center to top of screen
                    targetDistance *= Math.tan(scope.object.fov / 2 * Math.PI / 180.0);
                    // we use only clientHeight here so aspect ratio does not distort speed
                    panLeft(2 * deltaX * targetDistance / element.clientHeight, scope.object.matrix);
                    panUp(2 * deltaY * targetDistance / element.clientHeight, scope.object.matrix);
                } else if (scope.object.isOrthographicCamera) {
                    // orthographic
                    panLeft(deltaX * (scope.object.right - scope.object.left) / scope.object.zoom / element.clientWidth, scope.object.matrix);
                    panUp(deltaY * (scope.object.top - scope.object.bottom) / scope.object.zoom / element.clientHeight, scope.object.matrix);
                } else {
                    // camera neither orthographic nor perspective
                    console.warn('WARNING: OrbitControls.js encountered an unknown camera type - pan disabled.');
                    scope.enablePan = false;
                }
            };
        }();
        function onPointerUp(event) {
            if (scope.enabled === false) return;
            if (event.pointerType === 'touch') onTouchEnd();
            else onMouseUp(event);
            removePointer(event);
            //
            if (pointers.length === 0) {
                scope.domElement.ownerDocument.removeEventListener('pointermove', onPointerMove);
                scope.domElement.ownerDocument.removeEventListener('pointerup', onPointerUp);
            }
        }
        //
        scope.domElement.addEventListener('contextmenu', onContextMenu);
        scope.domElement.addEventListener('pointerdown', onPointerDown);
        scope.domElement.addEventListener('pointercancel', onPointerCancel);
        scope.domElement.addEventListener('wheel', onMouseWheel, {
            passive: false
        });
        // force an update at start
        _this.update();
        return _this;
    }
    return OrbitControls;
}((0, $c702e238df7c5123$export$ec8b666c5fe2c75a));
// This set of controls performs orbiting, dollying (zooming), and panning.
// Unlike TrackballControls, it maintains the "up" direction object.up (+Y by default).
// This is very similar to OrbitControls, another set of touch behavior
//
//    Orbit - right mouse, or left mouse + ctrl/meta/shiftKey / touch: two-finger rotate
//    Zoom - middle mouse, or mousewheel / touch: two-finger spread or squish
//    Pan - left mouse, or arrow keys / touch: one-finger move
var $cfa4b88fbc45945c$export$7628ccdac312035f = /*#__PURE__*/ function(OrbitControls) {
    "use strict";
    (0, $6937a2c821db5183$export$71511d61b312f219)(MapControls, OrbitControls);
    function MapControls(object, domElement) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, MapControls);
        var _this;
        _this = (0, $3fd3dd3bc726a20c$export$71511d61b312f219)(this, MapControls, [
            object,
            domElement
        ]);
        _this.screenSpacePanning = false; // pan orthogonal to world-space direction camera.up
        _this.mouseButtons.LEFT = (0, $c702e238df7c5123$export$7177b3e430c2d7ca).PAN;
        _this.mouseButtons.RIGHT = (0, $c702e238df7c5123$export$7177b3e430c2d7ca).ROTATE;
        _this.touches.ONE = (0, $c702e238df7c5123$export$d46bd3ead7cc759b).PAN;
        _this.touches.TWO = (0, $c702e238df7c5123$export$d46bd3ead7cc759b).DOLLY_ROTATE;
        return _this;
    }
    return MapControls;
}($cfa4b88fbc45945c$export$8ff7788029dfdf52);


/**
 * Configuration constants
 */ var $f314e95b0ccedc3d$var$CONFIG = {
    camera: {
        fov: 35,
        near: 0.1,
        far: 100,
        position: new $c702e238df7c5123$export$64b5c384219d3699(0, 0, 5)
    },
    particles: {
        count: 300,
        size: {
            min: 0.05,
            max: 0.15
        },
        radius: 3.5,
        speed: 0.01
    },
    leaves: {
        floatMin: 0.09,
        floatMax: 0.19,
        repulsionRadius: 2.0,
        repulsionStrength: 0.8,
        lerpFactor: 0.1 // Controls smoothness (lower = smoother but slower)
    },
    resources: {
        mtl: 'https://res.cloudinary.com/dyl1v35zu/raw/upload/v1621115739/Leaf_pljcaw.mtl',
        texture: 'https://res.cloudinary.com/dyl1v35zu/image/upload/v1625920260/Leaf_Tex_ugemeg.jpg',
        particleTexture: 'https://threejs.org/examples/textures/sprites/circle.png',
        models: [
            'https://res.cloudinary.com/dyl1v35zu/raw/upload/v1621115739/Leaf_1_r13yhj.obj',
            'https://res.cloudinary.com/dyl1v35zu/raw/upload/v1621115739/Leaf_2_tc6znp.obj',
            'https://res.cloudinary.com/dyl1v35zu/raw/upload/v1621115739/Leaf_3_davoem.obj',
            'https://res.cloudinary.com/dyl1v35zu/raw/upload/v1621115739/Leaf_4_jtpeee.obj',
            'https://res.cloudinary.com/dyl1v35zu/raw/upload/v1621115739/Leaf_5_l0ngyl.obj',
            'https://res.cloudinary.com/dyl1v35zu/raw/upload/v1621115739/Leaf_6_qhb3sl.obj',
            'https://res.cloudinary.com/dyl1v35zu/raw/upload/v1621115739/Leaf_7_y2ovkv.obj',
            'https://res.cloudinary.com/dyl1v35zu/raw/upload/v1621115739/Leaf_8_ux1dgp.obj'
        ]
    }
};
/**
 * Main application class
 */ var $f314e95b0ccedc3d$var$LeavesApp = /*#__PURE__*/ function() {
    "use strict";
    function LeavesApp(canvasId) {
        (0, $313db6c3a7373211$export$71511d61b312f219)(this, LeavesApp);
        // Get canvas element
        this.canvas = document.querySelector(canvasId);
        // Three.js essentials
        this.scene = new $c702e238df7c5123$export$38af1803e3442a7f();
        this.camera = this.createCamera();
        this.renderer = this.createRenderer();
        this.clock = new $c702e238df7c5123$export$9735c82c4bae3302();
        // Mouse interaction
        this.mouse = new $c702e238df7c5123$export$c977b3e384af9ae1();
        this.raycaster = new $c702e238df7c5123$export$8b7aaceff00bd2f();
        this.mouseInCanvas = false;
        // Scene elements
        this.leaves = [];
        this.particles = null;
        this.particlesData = [];
        // Initialize application
        this.setupControls();
        this.setupLighting();
        this.setupMouseHandlers();
        this.setupParticles();
        this.loadModels();
        this.setupResizeHandler();
    }
    (0, $bd3afd8f91324b60$export$71511d61b312f219)(LeavesApp, [
        {
            /**
   * Create and configure the camera
   */ key: "createCamera",
            value: function createCamera() {
                var _CONFIG_camera = $f314e95b0ccedc3d$var$CONFIG.camera, fov = _CONFIG_camera.fov, near = _CONFIG_camera.near, far = _CONFIG_camera.far, position = _CONFIG_camera.position;
                var aspect = window.innerWidth / window.innerHeight;
                var camera = new $c702e238df7c5123$export$74e4ae24825f68d7(fov, aspect, near, far);
                camera.position.copy(position);
                return camera;
            }
        },
        {
            /**
   * Create and configure the renderer
   */ key: "createRenderer",
            value: function createRenderer() {
                var renderer = new $c702e238df7c5123$export$f6cc00ef28d7cf97({
                    canvas: this.canvas,
                    alpha: true,
                    antialias: true
                });
                renderer.setSize(window.innerWidth, window.innerHeight);
                renderer.shadowMap.enabled = true;
                renderer.shadowMap.type = $c702e238df7c5123$export$a47c4b43a1be34f0;
                return renderer;
            }
        },
        {
            /**
   * Set up camera orbit controls
   */ key: "setupControls",
            value: function setupControls() {
                var controls = new (0, $cfa4b88fbc45945c$export$8ff7788029dfdf52)(this.camera, this.canvas);
                controls.enableZoom = false;
                controls.enablePan = false;
                controls.minPolarAngle = Math.PI / 2;
                controls.maxPolarAngle = Math.PI / 2;
                controls.update();
            }
        },
        {
            /**
   * Set up scene lights
   */ key: "setupLighting",
            value: function setupLighting() {
                // Ambient light for overall scene illumination
                this.scene.add(new $c702e238df7c5123$export$af279bfef9ec2c96(0xffffff, 0.5));
                // Main spotlight with shadow casting
                var spotLight = new $c702e238df7c5123$export$81495cbb73897362(0xffffff, 1.0);
                spotLight.position.set(0, -90, -50);
                spotLight.castShadow = true;
                spotLight.shadow.mapSize.width = 1024;
                spotLight.shadow.mapSize.height = 1024;
                spotLight.shadow.bias = -0.0001;
                this.scene.add(spotLight);
                // Secondary spotlight for additional illumination
                var spotLightB = new $c702e238df7c5123$export$81495cbb73897362(0xffffff, 0.7);
                spotLightB.position.set(-50, 70, -10);
                spotLightB.castShadow = true;
                spotLightB.shadow.mapSize.width = 512;
                spotLightB.shadow.mapSize.height = 512;
                this.scene.add(spotLightB);
                // Add a subtle directional light for better depth
                var directionalLight = new $c702e238df7c5123$export$3fea33cc9972c868(0xffffee, 0.3);
                directionalLight.position.set(1, 1, 1);
                directionalLight.castShadow = true;
                // Configure directional light shadow camera
                directionalLight.shadow.camera.near = 0.1;
                directionalLight.shadow.camera.far = 10;
                directionalLight.shadow.camera.right = 5;
                directionalLight.shadow.camera.left = -5;
                directionalLight.shadow.camera.top = 5;
                directionalLight.shadow.camera.bottom = -5;
                directionalLight.shadow.mapSize.width = 1024;
                directionalLight.shadow.mapSize.height = 1024;
                this.scene.add(directionalLight);
            }
        },
        {
            /**
   * Set up mouse event handlers
   */ key: "setupMouseHandlers",
            value: function setupMouseHandlers() {
                this.canvas.addEventListener('mousemove', this.onMouseMove.bind(this));
                this.canvas.addEventListener('mouseenter', this.onMouseEnter.bind(this));
                this.canvas.addEventListener('mouseleave', this.onMouseLeave.bind(this));
            }
        },
        {
            /**
   * Update mouse position handler
   */ key: "onMouseMove",
            value: function onMouseMove(event) {
                var rect = this.canvas.getBoundingClientRect();
                this.mouse.x = (event.clientX - rect.left) / rect.width * 2 - 1;
                this.mouse.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;
            }
        },
        {
            /**
   * Mouse enter handler
   */ key: "onMouseEnter",
            value: function onMouseEnter() {
                this.mouseInCanvas = true;
            }
        },
        {
            /**
   * Mouse leave handler
   */ key: "onMouseLeave",
            value: function onMouseLeave() {
                this.mouseInCanvas = false;
            }
        },
        {
            /**
   * Handle window resize
   */ key: "onWindowResize",
            value: function onWindowResize() {
                this.camera.aspect = window.innerWidth / window.innerHeight;
                this.camera.updateProjectionMatrix();
                this.renderer.setSize(window.innerWidth, window.innerHeight);
            }
        },
        {
            /**
   * Set up window resize handler
   */ key: "setupResizeHandler",
            value: function setupResizeHandler() {
                window.addEventListener('resize', this.onWindowResize.bind(this));
            }
        },
        {
            /**
   * Create and initialize particle system
   */ key: "setupParticles",
            value: function setupParticles() {
                var _CONFIG_particles = $f314e95b0ccedc3d$var$CONFIG.particles, count = _CONFIG_particles.count, radius = _CONFIG_particles.radius, size = _CONFIG_particles.size, speed = _CONFIG_particles.speed;
                // Create geometry and attribute arrays
                var geometry = new $c702e238df7c5123$export$b7be63a67df8959();
                var positions = new Float32Array(count * 3);
                var sizes = new Float32Array(count);
                // Fill arrays with random positions and sizes
                for(var i = 0; i < count; i++){
                    // Position particles in a spherical volume
                    var theta = Math.random() * Math.PI * 2; // 0 to 2π
                    var phi = Math.acos(2 * Math.random() - 1); // 0 to π
                    positions[i * 3] = radius * Math.sin(phi) * Math.cos(theta); // x
                    positions[i * 3 + 1] = radius * Math.sin(phi) * Math.sin(theta); // y
                    positions[i * 3 + 2] = radius * Math.cos(phi); // z
                    // Random sizes
                    sizes[i] = Math.random() * (size.max - size.min) + size.min;
                    // Store particle animation data
                    this.particlesData.push({
                        velocity: new $c702e238df7c5123$export$64b5c384219d3699((Math.random() - 0.5) * speed, (Math.random() - 0.5) * speed, (Math.random() - 0.5) * speed),
                        initialY: positions[i * 3 + 1]
                    });
                }
                // Set buffer attributes
                geometry.setAttribute('position', new $c702e238df7c5123$export$8dea267bd6bde117(positions, 3));
                geometry.setAttribute('size', new $c702e238df7c5123$export$8dea267bd6bde117(sizes, 1));
                // Create particle material
                var texture = new $c702e238df7c5123$export$fd1bfc71f64c538c().load($f314e95b0ccedc3d$var$CONFIG.resources.particleTexture);
                var material = new $c702e238df7c5123$export$a178c45366ce5d6b({
                    size: 0.05,
                    color: 0xffffff,
                    transparent: true,
                    opacity: 0.4,
                    map: texture,
                    blending: $c702e238df7c5123$export$777d8f9551c2216b,
                    depthWrite: false
                });
                // Create and add particle system
                this.particles = new $c702e238df7c5123$export$1c787534cb11aa3e(geometry, material);
                this.scene.add(this.particles);
            }
        },
        {
            /**
   * Load 3D models of leaves
   */ key: "loadModels",
            value: function loadModels() {
                var _this = this;
                var mtlLoader = new (0, $60176c8546b1ce93$export$2a0ca4746a43f1f8)();
                var objLoader = new (0, $48bd0f7f134d0c59$export$7ae31604ad04b4a7)();
                var _CONFIG_resources = $f314e95b0ccedc3d$var$CONFIG.resources, mtl = _CONFIG_resources.mtl, texture = _CONFIG_resources.texture, models = _CONFIG_resources.models;
                mtlLoader.load(mtl, function(materials) {
                    materials.preload();
                    objLoader.setMaterials(materials);
                    // Load texture
                    var textureLoader = new $c702e238df7c5123$export$fd1bfc71f64c538c();
                    textureLoader.load(texture, function(tex) {
                        // Load each model
                        var loadedCount = 0;
                        models.forEach(function(modelUrl, index) {
                            objLoader.load(modelUrl, function(obj) {
                                loadedCount++;
                                // Create leaf data object
                                var leaf = {
                                    model: obj,
                                    float: parseFloat((Math.random() * ($f314e95b0ccedc3d$var$CONFIG.leaves.floatMax - $f314e95b0ccedc3d$var$CONFIG.leaves.floatMin) + $f314e95b0ccedc3d$var$CONFIG.leaves.floatMin).toFixed(2))
                                };
                                _this.leaves.push(leaf);
                                // Apply texture and shadow settings
                                obj.traverse(function(child) {
                                    if (child instanceof $c702e238df7c5123$export$e176487c05830cc5) {
                                        child.material.map = tex;
                                        child.castShadow = true;
                                        child.receiveShadow = true;
                                        child.material.side = $c702e238df7c5123$export$3b296b6f144d5b03;
                                        child.material.shadowSide = $c702e238df7c5123$export$d9f0486e75b5ace;
                                    }
                                });
                                // Add model to scene
                                _this.scene.add(obj);
                                // Start animation when all models are loaded
                                if (loadedCount === models.length) {
                                    var _document_querySelector;
                                    (_document_querySelector = document.querySelector('.leaves-loader')) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.remove();
                                    _this.startAnimation();
                                }
                            });
                        });
                    });
                });
            }
        },
        {
            /**
   * Start animation loop
   */ key: "startAnimation",
            value: function startAnimation() {
                this.renderer.render(this.scene, this.camera);
                this.animate();
            }
        },
        {
            /**
   * Animation loop
   */ key: "animate",
            value: function animate() {
                var _this = this;
                this.renderer.setAnimationLoop(function() {
                    // Render scene
                    _this.renderer.render(_this.scene, _this.camera);
                    // Get elapsed time
                    var time = _this.clock.getElapsedTime();
                    // Update particles
                    _this.updateParticles(time);
                    // Update leaves
                    _this.updateLeaves(time);
                });
            }
        },
        {
            /**
   * Update particle positions
   */ key: "updateParticles",
            value: function updateParticles(time) {
                var positions = this.particles.geometry.attributes.position.array;
                var count = $f314e95b0ccedc3d$var$CONFIG.particles.count;
                for(var i = 0; i < count; i++){
                    // Update positions based on velocity
                    positions[i * 3] += this.particlesData[i].velocity.x;
                    positions[i * 3 + 1] += this.particlesData[i].velocity.y + Math.sin(time * 0.5 + i) * 0.001; // Slight sine wave motion
                    positions[i * 3 + 2] += this.particlesData[i].velocity.z;
                    // Keep particles within bounds
                    var distance = Math.sqrt(Math.pow(positions[i * 3], 2) + Math.pow(positions[i * 3 + 1], 2) + Math.pow(positions[i * 3 + 2], 2));
                    if (distance > 5) {
                        // Reset position to a random location within the sphere
                        var radius = $f314e95b0ccedc3d$var$CONFIG.particles.radius;
                        var theta = Math.random() * Math.PI * 2;
                        var phi = Math.acos(2 * Math.random() - 1);
                        positions[i * 3] = radius * Math.sin(phi) * Math.cos(theta);
                        positions[i * 3 + 1] = radius * Math.sin(phi) * Math.sin(theta);
                        positions[i * 3 + 2] = radius * Math.cos(phi);
                        // Reset velocity
                        this.particlesData[i].velocity.set((Math.random() - 0.5) * $f314e95b0ccedc3d$var$CONFIG.particles.speed, (Math.random() - 0.5) * $f314e95b0ccedc3d$var$CONFIG.particles.speed, (Math.random() - 0.5) * $f314e95b0ccedc3d$var$CONFIG.particles.speed);
                    }
                }
                this.particles.geometry.attributes.position.needsUpdate = true;
                // Rotate particle system slightly for more natural movement
                this.particles.rotation.y += 0.0003;
            }
        },
        {
            /**
   * Update leaf positions and rotations
   */ key: "updateLeaves",
            value: function updateLeaves(time) {
                var _this = this;
                this.leaves.forEach(function(leaf, i) {
                    var model = leaf.model;
                    // Initialize leaf properties if needed
                    if (!leaf.originalPosition) {
                        leaf.originalPosition = new $c702e238df7c5123$export$64b5c384219d3699().copy(model.position);
                        leaf.currentOffset = new $c702e238df7c5123$export$64b5c384219d3699(0, 0, 0);
                        leaf.targetOffset = new $c702e238df7c5123$export$64b5c384219d3699(0, 0, 0);
                        leaf.rotationOffset = new $c702e238df7c5123$export$64b5c384219d3699(0, 0, 0);
                        leaf.targetRotation = new $c702e238df7c5123$export$64b5c384219d3699(0, 0, 0);
                        leaf.randomAngle = i * Math.PI / 4;
                        leaf.uniqueFactor = i % 3 * 0.2 + 0.8;
                    }
                    // Calculate base floating animation
                    var floatOffset = Math.sin(2 * Math.PI * 2 + time) * leaf["float"];
                    // Handle mouse interaction
                    if (_this.mouseInCanvas) _this.applyMouseInteraction(leaf, i);
                    else {
                        // Reset to original position when mouse isn't in canvas
                        leaf.targetOffset.x = 0;
                        leaf.targetOffset.y = 0;
                        leaf.targetRotation.y = 0;
                        leaf.targetRotation.z = 0;
                    }
                    // Apply smooth interpolation
                    _this.applyLeafInterpolation(leaf, floatOffset);
                });
            }
        },
        {
            /**
   * Calculate and apply mouse interaction effects
   */ key: "applyMouseInteraction",
            value: function applyMouseInteraction(leaf, index) {
                var _CONFIG_leaves = $f314e95b0ccedc3d$var$CONFIG.leaves, repulsionRadius = _CONFIG_leaves.repulsionRadius, repulsionStrength = _CONFIG_leaves.repulsionStrength;
                // Convert mouse position to 3D world coordinates
                var mouseWorldPos = new $c702e238df7c5123$export$64b5c384219d3699(this.mouse.x, this.mouse.y, 0);
                mouseWorldPos.unproject(this.camera);
                var dir = mouseWorldPos.sub(this.camera.position).normalize();
                var distance = -this.camera.position.z / dir.z;
                var pos = this.camera.position.clone().add(dir.multiplyScalar(distance));
                // Calculate distance between leaf and mouse position
                var distanceToMouse = pos.distanceTo(leaf.originalPosition);
                if (distanceToMouse < repulsionRadius) {
                    // Calculate repulsion direction with consistent randomness
                    var repulsionDir = new $c702e238df7c5123$export$64b5c384219d3699(leaf.originalPosition.x - pos.x + Math.cos(leaf.randomAngle) * 0.3, leaf.originalPosition.y - pos.y + Math.sin(leaf.randomAngle) * 0.3, 0).normalize();
                    // Calculate repulsion force (stronger when closer)
                    var repulsionForce = repulsionStrength * (1 - distanceToMouse / repulsionRadius);
                    // Set target offset with individual movement patterns
                    leaf.targetOffset.x = repulsionDir.x * repulsionForce * leaf.uniqueFactor;
                    leaf.targetOffset.y = repulsionDir.y * repulsionForce * leaf.uniqueFactor;
                    // Set target rotation
                    leaf.targetRotation.y = repulsionForce * (1 + index % 4 * 0.2);
                    leaf.targetRotation.z = index % 2 * repulsionForce * 0.2;
                } else {
                    // Target returning to original position
                    leaf.targetOffset.x = 0;
                    leaf.targetOffset.y = 0;
                    leaf.targetRotation.y = 0;
                    leaf.targetRotation.z = 0;
                }
            }
        },
        {
            /**
   * Apply smooth interpolation to leaf position and rotation
   */ key: "applyLeafInterpolation",
            value: function applyLeafInterpolation(leaf, floatOffset) {
                var lerpFactor = $f314e95b0ccedc3d$var$CONFIG.leaves.lerpFactor;
                var model = leaf.model;
                // Smoothly interpolate current offset toward target offset
                leaf.currentOffset.x += (leaf.targetOffset.x - leaf.currentOffset.x) * lerpFactor;
                leaf.currentOffset.y += (leaf.targetOffset.y - leaf.currentOffset.y) * lerpFactor;
                leaf.rotationOffset.y += (leaf.targetRotation.y - leaf.rotationOffset.y) * lerpFactor;
                leaf.rotationOffset.z += (leaf.targetRotation.z - leaf.rotationOffset.z) * lerpFactor;
                // Apply smooth movement
                model.position.x = leaf.originalPosition.x + leaf.currentOffset.x;
                model.position.y = leaf.originalPosition.y + floatOffset + leaf.currentOffset.y;
                model.rotation.y = floatOffset + leaf.rotationOffset.y;
                model.rotation.z = leaf.rotationOffset.z;
            }
        }
    ]);
    return LeavesApp;
}();
// Initialize the application
document.addEventListener('DOMContentLoaded', function() {
    new $f314e95b0ccedc3d$var$LeavesApp('#leavesCanvas');
});


var $ba141fb2f8557f26$var$isMobileMenuVisible = false;
var $ba141fb2f8557f26$var$mobileMenuToggler = document.getElementById('mobile-menu-toggler');
var $ba141fb2f8557f26$var$mobileMenu = document.getElementsByClassName('m-nav')[0];
var $ba141fb2f8557f26$var$mobileMenuLinks = document.querySelectorAll('.nav-link');
var $ba141fb2f8557f26$var$socialMedia = document.getElementsByClassName('social-media')[0];
var $ba141fb2f8557f26$var$careerSection = document.getElementById("career-section");
var $ba141fb2f8557f26$var$toolsSection = document.getElementById("tools-section");
var $ba141fb2f8557f26$var$publicationsSection = document.getElementById("publications-section");
var $ba141fb2f8557f26$var$projectsSection = document.getElementById("projects-section");
var $ba141fb2f8557f26$var$contactSection = document.getElementById("contact-section");
$ba141fb2f8557f26$var$mobileMenuToggler.addEventListener("click", function() {
    // Toggle display state
    $ba141fb2f8557f26$var$isMobileMenuVisible = !$ba141fb2f8557f26$var$isMobileMenuVisible;
    if ($ba141fb2f8557f26$var$isMobileMenuVisible) {
        $ba141fb2f8557f26$var$openMobileMenu();
        $ba141fb2f8557f26$var$mobileMenuLinks.forEach(function(l) {
            l.addEventListener('click', function() {
                return $ba141fb2f8557f26$var$closeMobileMenu();
            });
        });
    } else $ba141fb2f8557f26$var$closeMobileMenu();
});
//#region Navbar links navigation
var $ba141fb2f8557f26$var$careerLink = document.getElementById("career-link");
$ba141fb2f8557f26$var$careerLink.addEventListener("click", function() {
    $ba141fb2f8557f26$var$careerSection.scrollIntoView({
        behavior: 'smooth'
    });
});
//#endregion
function $ba141fb2f8557f26$var$openMobileMenu() {
    $ba141fb2f8557f26$var$mobileMenuToggler.classList.add('open');
    $ba141fb2f8557f26$var$mobileMenu.classList.add('existing');
    $ba141fb2f8557f26$var$socialMedia.style.display = "unset";
    setTimeout(function() {
        $ba141fb2f8557f26$var$mobileMenu.classList.add('open');
        $ba141fb2f8557f26$var$socialMedia.style.opacity = "1";
    }, 300);
}
function $ba141fb2f8557f26$var$closeMobileMenu() {
    $ba141fb2f8557f26$var$mobileMenuToggler.classList.remove('open');
    $ba141fb2f8557f26$var$mobileMenu.classList.remove('open');
    $ba141fb2f8557f26$var$socialMedia.style.opacity = "0";
    setTimeout(function() {
        $ba141fb2f8557f26$var$mobileMenu.classList.remove('existing');
        $ba141fb2f8557f26$var$socialMedia.style.display = "none";
    }, 300);
}


var $d6345808c4188ae5$exports = {};

(function webpackUniversalModuleDefinition(root, factory) {
    $d6345808c4188ae5$exports = factory();
})(typeof self !== 'undefined' ? self : undefined, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                /******/ configurable: false,
                /******/ enumerable: true,
                /******/ get: getter
            });
        /******/ };
        /******/ /******/ // define __esModule on exports
        /******/ __webpack_require__.r = function(exports) {
            /******/ Object.defineProperty(exports, '__esModule', {
                value: true
            });
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1['default'];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, 'a', getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 0);
    /******/ }({
        /***/ "./dist/icons.json": /*!*************************!*\
  !*** ./dist/icons.json ***!
  \*************************/ /*! exports provided: activity, airplay, alert-circle, alert-octagon, alert-triangle, align-center, align-justify, align-left, align-right, anchor, aperture, archive, arrow-down-circle, arrow-down-left, arrow-down-right, arrow-down, arrow-left-circle, arrow-left, arrow-right-circle, arrow-right, arrow-up-circle, arrow-up-left, arrow-up-right, arrow-up, at-sign, award, bar-chart-2, bar-chart, battery-charging, battery, bell-off, bell, bluetooth, bold, book-open, book, bookmark, box, briefcase, calendar, camera-off, camera, cast, check-circle, check-square, check, chevron-down, chevron-left, chevron-right, chevron-up, chevrons-down, chevrons-left, chevrons-right, chevrons-up, chrome, circle, clipboard, clock, cloud-drizzle, cloud-lightning, cloud-off, cloud-rain, cloud-snow, cloud, code, codepen, codesandbox, coffee, columns, command, compass, copy, corner-down-left, corner-down-right, corner-left-down, corner-left-up, corner-right-down, corner-right-up, corner-up-left, corner-up-right, cpu, credit-card, crop, crosshair, database, delete, disc, divide-circle, divide-square, divide, dollar-sign, download-cloud, download, dribbble, droplet, edit-2, edit-3, edit, external-link, eye-off, eye, facebook, fast-forward, feather, figma, file-minus, file-plus, file-text, file, film, filter, flag, folder-minus, folder-plus, folder, framer, frown, gift, git-branch, git-commit, git-merge, git-pull-request, github, gitlab, globe, grid, hard-drive, hash, headphones, heart, help-circle, hexagon, home, image, inbox, info, instagram, italic, key, layers, layout, life-buoy, link-2, link, linkedin, list, loader, lock, log-in, log-out, mail, map-pin, map, maximize-2, maximize, meh, menu, message-circle, message-square, mic-off, mic, minimize-2, minimize, minus-circle, minus-square, minus, monitor, moon, more-horizontal, more-vertical, mouse-pointer, move, music, navigation-2, navigation, octagon, package, paperclip, pause-circle, pause, pen-tool, percent, phone-call, phone-forwarded, phone-incoming, phone-missed, phone-off, phone-outgoing, phone, pie-chart, play-circle, play, plus-circle, plus-square, plus, pocket, power, printer, radio, refresh-ccw, refresh-cw, repeat, rewind, rotate-ccw, rotate-cw, rss, save, scissors, search, send, server, settings, share-2, share, shield-off, shield, shopping-bag, shopping-cart, shuffle, sidebar, skip-back, skip-forward, slack, slash, sliders, smartphone, smile, speaker, square, star, stop-circle, sun, sunrise, sunset, table, tablet, tag, target, terminal, thermometer, thumbs-down, thumbs-up, toggle-left, toggle-right, tool, trash-2, trash, trello, trending-down, trending-up, triangle, truck, tv, twitch, twitter, type, umbrella, underline, unlock, upload-cloud, upload, user-check, user-minus, user-plus, user-x, user, users, video-off, video, voicemail, volume-1, volume-2, volume-x, volume, watch, wifi-off, wifi, wind, x-circle, x-octagon, x-square, x, youtube, zap-off, zap, zoom-in, zoom-out, default */ /***/ function(module1) {
            module1.exports = {
                activity: "<polyline points=\"22 12 18 12 15 21 9 3 6 12 2 12\"></polyline>",
                airplay: "<path d=\"M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1\"></path><polygon points=\"12 15 17 21 7 21 12 15\"></polygon>",
                "alert-circle": "<circle cx=\"12\" cy=\"12\" r=\"10\"></circle><line x1=\"12\" y1=\"8\" x2=\"12\" y2=\"12\"></line><line x1=\"12\" y1=\"16\" x2=\"12.01\" y2=\"16\"></line>",
                "alert-octagon": "<polygon points=\"7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2\"></polygon><line x1=\"12\" y1=\"8\" x2=\"12\" y2=\"12\"></line><line x1=\"12\" y1=\"16\" x2=\"12.01\" y2=\"16\"></line>",
                "alert-triangle": "<path d=\"M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z\"></path><line x1=\"12\" y1=\"9\" x2=\"12\" y2=\"13\"></line><line x1=\"12\" y1=\"17\" x2=\"12.01\" y2=\"17\"></line>",
                "align-center": "<line x1=\"18\" y1=\"10\" x2=\"6\" y2=\"10\"></line><line x1=\"21\" y1=\"6\" x2=\"3\" y2=\"6\"></line><line x1=\"21\" y1=\"14\" x2=\"3\" y2=\"14\"></line><line x1=\"18\" y1=\"18\" x2=\"6\" y2=\"18\"></line>",
                "align-justify": "<line x1=\"21\" y1=\"10\" x2=\"3\" y2=\"10\"></line><line x1=\"21\" y1=\"6\" x2=\"3\" y2=\"6\"></line><line x1=\"21\" y1=\"14\" x2=\"3\" y2=\"14\"></line><line x1=\"21\" y1=\"18\" x2=\"3\" y2=\"18\"></line>",
                "align-left": "<line x1=\"17\" y1=\"10\" x2=\"3\" y2=\"10\"></line><line x1=\"21\" y1=\"6\" x2=\"3\" y2=\"6\"></line><line x1=\"21\" y1=\"14\" x2=\"3\" y2=\"14\"></line><line x1=\"17\" y1=\"18\" x2=\"3\" y2=\"18\"></line>",
                "align-right": "<line x1=\"21\" y1=\"10\" x2=\"7\" y2=\"10\"></line><line x1=\"21\" y1=\"6\" x2=\"3\" y2=\"6\"></line><line x1=\"21\" y1=\"14\" x2=\"3\" y2=\"14\"></line><line x1=\"21\" y1=\"18\" x2=\"7\" y2=\"18\"></line>",
                anchor: "<circle cx=\"12\" cy=\"5\" r=\"3\"></circle><line x1=\"12\" y1=\"22\" x2=\"12\" y2=\"8\"></line><path d=\"M5 12H2a10 10 0 0 0 20 0h-3\"></path>",
                aperture: "<circle cx=\"12\" cy=\"12\" r=\"10\"></circle><line x1=\"14.31\" y1=\"8\" x2=\"20.05\" y2=\"17.94\"></line><line x1=\"9.69\" y1=\"8\" x2=\"21.17\" y2=\"8\"></line><line x1=\"7.38\" y1=\"12\" x2=\"13.12\" y2=\"2.06\"></line><line x1=\"9.69\" y1=\"16\" x2=\"3.95\" y2=\"6.06\"></line><line x1=\"14.31\" y1=\"16\" x2=\"2.83\" y2=\"16\"></line><line x1=\"16.62\" y1=\"12\" x2=\"10.88\" y2=\"21.94\"></line>",
                archive: "<polyline points=\"21 8 21 21 3 21 3 8\"></polyline><rect x=\"1\" y=\"3\" width=\"22\" height=\"5\"></rect><line x1=\"10\" y1=\"12\" x2=\"14\" y2=\"12\"></line>",
                "arrow-down-circle": "<circle cx=\"12\" cy=\"12\" r=\"10\"></circle><polyline points=\"8 12 12 16 16 12\"></polyline><line x1=\"12\" y1=\"8\" x2=\"12\" y2=\"16\"></line>",
                "arrow-down-left": "<line x1=\"17\" y1=\"7\" x2=\"7\" y2=\"17\"></line><polyline points=\"17 17 7 17 7 7\"></polyline>",
                "arrow-down-right": "<line x1=\"7\" y1=\"7\" x2=\"17\" y2=\"17\"></line><polyline points=\"17 7 17 17 7 17\"></polyline>",
                "arrow-down": "<line x1=\"12\" y1=\"5\" x2=\"12\" y2=\"19\"></line><polyline points=\"19 12 12 19 5 12\"></polyline>",
                "arrow-left-circle": "<circle cx=\"12\" cy=\"12\" r=\"10\"></circle><polyline points=\"12 8 8 12 12 16\"></polyline><line x1=\"16\" y1=\"12\" x2=\"8\" y2=\"12\"></line>",
                "arrow-left": "<line x1=\"19\" y1=\"12\" x2=\"5\" y2=\"12\"></line><polyline points=\"12 19 5 12 12 5\"></polyline>",
                "arrow-right-circle": "<circle cx=\"12\" cy=\"12\" r=\"10\"></circle><polyline points=\"12 16 16 12 12 8\"></polyline><line x1=\"8\" y1=\"12\" x2=\"16\" y2=\"12\"></line>",
                "arrow-right": "<line x1=\"5\" y1=\"12\" x2=\"19\" y2=\"12\"></line><polyline points=\"12 5 19 12 12 19\"></polyline>",
                "arrow-up-circle": "<circle cx=\"12\" cy=\"12\" r=\"10\"></circle><polyline points=\"16 12 12 8 8 12\"></polyline><line x1=\"12\" y1=\"16\" x2=\"12\" y2=\"8\"></line>",
                "arrow-up-left": "<line x1=\"17\" y1=\"17\" x2=\"7\" y2=\"7\"></line><polyline points=\"7 17 7 7 17 7\"></polyline>",
                "arrow-up-right": "<line x1=\"7\" y1=\"17\" x2=\"17\" y2=\"7\"></line><polyline points=\"7 7 17 7 17 17\"></polyline>",
                "arrow-up": "<line x1=\"12\" y1=\"19\" x2=\"12\" y2=\"5\"></line><polyline points=\"5 12 12 5 19 12\"></polyline>",
                "at-sign": "<circle cx=\"12\" cy=\"12\" r=\"4\"></circle><path d=\"M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94\"></path>",
                award: "<circle cx=\"12\" cy=\"8\" r=\"7\"></circle><polyline points=\"8.21 13.89 7 23 12 20 17 23 15.79 13.88\"></polyline>",
                "bar-chart-2": "<line x1=\"18\" y1=\"20\" x2=\"18\" y2=\"10\"></line><line x1=\"12\" y1=\"20\" x2=\"12\" y2=\"4\"></line><line x1=\"6\" y1=\"20\" x2=\"6\" y2=\"14\"></line>",
                "bar-chart": "<line x1=\"12\" y1=\"20\" x2=\"12\" y2=\"10\"></line><line x1=\"18\" y1=\"20\" x2=\"18\" y2=\"4\"></line><line x1=\"6\" y1=\"20\" x2=\"6\" y2=\"16\"></line>",
                "battery-charging": "<path d=\"M5 18H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3.19M15 6h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-3.19\"></path><line x1=\"23\" y1=\"13\" x2=\"23\" y2=\"11\"></line><polyline points=\"11 6 7 12 13 12 9 18\"></polyline>",
                battery: "<rect x=\"1\" y=\"6\" width=\"18\" height=\"12\" rx=\"2\" ry=\"2\"></rect><line x1=\"23\" y1=\"13\" x2=\"23\" y2=\"11\"></line>",
                "bell-off": "<path d=\"M13.73 21a2 2 0 0 1-3.46 0\"></path><path d=\"M18.63 13A17.89 17.89 0 0 1 18 8\"></path><path d=\"M6.26 6.26A5.86 5.86 0 0 0 6 8c0 7-3 9-3 9h14\"></path><path d=\"M18 8a6 6 0 0 0-9.33-5\"></path><line x1=\"1\" y1=\"1\" x2=\"23\" y2=\"23\"></line>",
                bell: "<path d=\"M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9\"></path><path d=\"M13.73 21a2 2 0 0 1-3.46 0\"></path>",
                bluetooth: "<polyline points=\"6.5 6.5 17.5 17.5 12 23 12 1 17.5 6.5 6.5 17.5\"></polyline>",
                bold: "<path d=\"M6 4h8a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z\"></path><path d=\"M6 12h9a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z\"></path>",
                "book-open": "<path d=\"M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z\"></path><path d=\"M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z\"></path>",
                book: "<path d=\"M4 19.5A2.5 2.5 0 0 1 6.5 17H20\"></path><path d=\"M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z\"></path>",
                bookmark: "<path d=\"M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z\"></path>",
                box: "<path d=\"M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z\"></path><polyline points=\"3.27 6.96 12 12.01 20.73 6.96\"></polyline><line x1=\"12\" y1=\"22.08\" x2=\"12\" y2=\"12\"></line>",
                briefcase: "<rect x=\"2\" y=\"7\" width=\"20\" height=\"14\" rx=\"2\" ry=\"2\"></rect><path d=\"M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16\"></path>",
                calendar: "<rect x=\"3\" y=\"4\" width=\"18\" height=\"18\" rx=\"2\" ry=\"2\"></rect><line x1=\"16\" y1=\"2\" x2=\"16\" y2=\"6\"></line><line x1=\"8\" y1=\"2\" x2=\"8\" y2=\"6\"></line><line x1=\"3\" y1=\"10\" x2=\"21\" y2=\"10\"></line>",
                "camera-off": "<line x1=\"1\" y1=\"1\" x2=\"23\" y2=\"23\"></line><path d=\"M21 21H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3m3-3h6l2 3h4a2 2 0 0 1 2 2v9.34m-7.72-2.06a4 4 0 1 1-5.56-5.56\"></path>",
                camera: "<path d=\"M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z\"></path><circle cx=\"12\" cy=\"13\" r=\"4\"></circle>",
                cast: "<path d=\"M2 16.1A5 5 0 0 1 5.9 20M2 12.05A9 9 0 0 1 9.95 20M2 8V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6\"></path><line x1=\"2\" y1=\"20\" x2=\"2.01\" y2=\"20\"></line>",
                "check-circle": "<path d=\"M22 11.08V12a10 10 0 1 1-5.93-9.14\"></path><polyline points=\"22 4 12 14.01 9 11.01\"></polyline>",
                "check-square": "<polyline points=\"9 11 12 14 22 4\"></polyline><path d=\"M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11\"></path>",
                check: "<polyline points=\"20 6 9 17 4 12\"></polyline>",
                "chevron-down": "<polyline points=\"6 9 12 15 18 9\"></polyline>",
                "chevron-left": "<polyline points=\"15 18 9 12 15 6\"></polyline>",
                "chevron-right": "<polyline points=\"9 18 15 12 9 6\"></polyline>",
                "chevron-up": "<polyline points=\"18 15 12 9 6 15\"></polyline>",
                "chevrons-down": "<polyline points=\"7 13 12 18 17 13\"></polyline><polyline points=\"7 6 12 11 17 6\"></polyline>",
                "chevrons-left": "<polyline points=\"11 17 6 12 11 7\"></polyline><polyline points=\"18 17 13 12 18 7\"></polyline>",
                "chevrons-right": "<polyline points=\"13 17 18 12 13 7\"></polyline><polyline points=\"6 17 11 12 6 7\"></polyline>",
                "chevrons-up": "<polyline points=\"17 11 12 6 7 11\"></polyline><polyline points=\"17 18 12 13 7 18\"></polyline>",
                chrome: "<circle cx=\"12\" cy=\"12\" r=\"10\"></circle><circle cx=\"12\" cy=\"12\" r=\"4\"></circle><line x1=\"21.17\" y1=\"8\" x2=\"12\" y2=\"8\"></line><line x1=\"3.95\" y1=\"6.06\" x2=\"8.54\" y2=\"14\"></line><line x1=\"10.88\" y1=\"21.94\" x2=\"15.46\" y2=\"14\"></line>",
                circle: "<circle cx=\"12\" cy=\"12\" r=\"10\"></circle>",
                clipboard: "<path d=\"M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2\"></path><rect x=\"8\" y=\"2\" width=\"8\" height=\"4\" rx=\"1\" ry=\"1\"></rect>",
                clock: "<circle cx=\"12\" cy=\"12\" r=\"10\"></circle><polyline points=\"12 6 12 12 16 14\"></polyline>",
                "cloud-drizzle": "<line x1=\"8\" y1=\"19\" x2=\"8\" y2=\"21\"></line><line x1=\"8\" y1=\"13\" x2=\"8\" y2=\"15\"></line><line x1=\"16\" y1=\"19\" x2=\"16\" y2=\"21\"></line><line x1=\"16\" y1=\"13\" x2=\"16\" y2=\"15\"></line><line x1=\"12\" y1=\"21\" x2=\"12\" y2=\"23\"></line><line x1=\"12\" y1=\"15\" x2=\"12\" y2=\"17\"></line><path d=\"M20 16.58A5 5 0 0 0 18 7h-1.26A8 8 0 1 0 4 15.25\"></path>",
                "cloud-lightning": "<path d=\"M19 16.9A5 5 0 0 0 18 7h-1.26a8 8 0 1 0-11.62 9\"></path><polyline points=\"13 11 9 17 15 17 11 23\"></polyline>",
                "cloud-off": "<path d=\"M22.61 16.95A5 5 0 0 0 18 10h-1.26a8 8 0 0 0-7.05-6M5 5a8 8 0 0 0 4 15h9a5 5 0 0 0 1.7-.3\"></path><line x1=\"1\" y1=\"1\" x2=\"23\" y2=\"23\"></line>",
                "cloud-rain": "<line x1=\"16\" y1=\"13\" x2=\"16\" y2=\"21\"></line><line x1=\"8\" y1=\"13\" x2=\"8\" y2=\"21\"></line><line x1=\"12\" y1=\"15\" x2=\"12\" y2=\"23\"></line><path d=\"M20 16.58A5 5 0 0 0 18 7h-1.26A8 8 0 1 0 4 15.25\"></path>",
                "cloud-snow": "<path d=\"M20 17.58A5 5 0 0 0 18 8h-1.26A8 8 0 1 0 4 16.25\"></path><line x1=\"8\" y1=\"16\" x2=\"8.01\" y2=\"16\"></line><line x1=\"8\" y1=\"20\" x2=\"8.01\" y2=\"20\"></line><line x1=\"12\" y1=\"18\" x2=\"12.01\" y2=\"18\"></line><line x1=\"12\" y1=\"22\" x2=\"12.01\" y2=\"22\"></line><line x1=\"16\" y1=\"16\" x2=\"16.01\" y2=\"16\"></line><line x1=\"16\" y1=\"20\" x2=\"16.01\" y2=\"20\"></line>",
                cloud: "<path d=\"M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z\"></path>",
                code: "<polyline points=\"16 18 22 12 16 6\"></polyline><polyline points=\"8 6 2 12 8 18\"></polyline>",
                codepen: "<polygon points=\"12 2 22 8.5 22 15.5 12 22 2 15.5 2 8.5 12 2\"></polygon><line x1=\"12\" y1=\"22\" x2=\"12\" y2=\"15.5\"></line><polyline points=\"22 8.5 12 15.5 2 8.5\"></polyline><polyline points=\"2 15.5 12 8.5 22 15.5\"></polyline><line x1=\"12\" y1=\"2\" x2=\"12\" y2=\"8.5\"></line>",
                codesandbox: "<path d=\"M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z\"></path><polyline points=\"7.5 4.21 12 6.81 16.5 4.21\"></polyline><polyline points=\"7.5 19.79 7.5 14.6 3 12\"></polyline><polyline points=\"21 12 16.5 14.6 16.5 19.79\"></polyline><polyline points=\"3.27 6.96 12 12.01 20.73 6.96\"></polyline><line x1=\"12\" y1=\"22.08\" x2=\"12\" y2=\"12\"></line>",
                coffee: "<path d=\"M18 8h1a4 4 0 0 1 0 8h-1\"></path><path d=\"M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z\"></path><line x1=\"6\" y1=\"1\" x2=\"6\" y2=\"4\"></line><line x1=\"10\" y1=\"1\" x2=\"10\" y2=\"4\"></line><line x1=\"14\" y1=\"1\" x2=\"14\" y2=\"4\"></line>",
                columns: "<path d=\"M12 3h7a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-7m0-18H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7m0-18v18\"></path>",
                command: "<path d=\"M18 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3H6a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3V6a3 3 0 0 0-3-3 3 3 0 0 0-3 3 3 3 0 0 0 3 3h12a3 3 0 0 0 3-3 3 3 0 0 0-3-3z\"></path>",
                compass: "<circle cx=\"12\" cy=\"12\" r=\"10\"></circle><polygon points=\"16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76\"></polygon>",
                copy: "<rect x=\"9\" y=\"9\" width=\"13\" height=\"13\" rx=\"2\" ry=\"2\"></rect><path d=\"M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1\"></path>",
                "corner-down-left": "<polyline points=\"9 10 4 15 9 20\"></polyline><path d=\"M20 4v7a4 4 0 0 1-4 4H4\"></path>",
                "corner-down-right": "<polyline points=\"15 10 20 15 15 20\"></polyline><path d=\"M4 4v7a4 4 0 0 0 4 4h12\"></path>",
                "corner-left-down": "<polyline points=\"14 15 9 20 4 15\"></polyline><path d=\"M20 4h-7a4 4 0 0 0-4 4v12\"></path>",
                "corner-left-up": "<polyline points=\"14 9 9 4 4 9\"></polyline><path d=\"M20 20h-7a4 4 0 0 1-4-4V4\"></path>",
                "corner-right-down": "<polyline points=\"10 15 15 20 20 15\"></polyline><path d=\"M4 4h7a4 4 0 0 1 4 4v12\"></path>",
                "corner-right-up": "<polyline points=\"10 9 15 4 20 9\"></polyline><path d=\"M4 20h7a4 4 0 0 0 4-4V4\"></path>",
                "corner-up-left": "<polyline points=\"9 14 4 9 9 4\"></polyline><path d=\"M20 20v-7a4 4 0 0 0-4-4H4\"></path>",
                "corner-up-right": "<polyline points=\"15 14 20 9 15 4\"></polyline><path d=\"M4 20v-7a4 4 0 0 1 4-4h12\"></path>",
                cpu: "<rect x=\"4\" y=\"4\" width=\"16\" height=\"16\" rx=\"2\" ry=\"2\"></rect><rect x=\"9\" y=\"9\" width=\"6\" height=\"6\"></rect><line x1=\"9\" y1=\"1\" x2=\"9\" y2=\"4\"></line><line x1=\"15\" y1=\"1\" x2=\"15\" y2=\"4\"></line><line x1=\"9\" y1=\"20\" x2=\"9\" y2=\"23\"></line><line x1=\"15\" y1=\"20\" x2=\"15\" y2=\"23\"></line><line x1=\"20\" y1=\"9\" x2=\"23\" y2=\"9\"></line><line x1=\"20\" y1=\"14\" x2=\"23\" y2=\"14\"></line><line x1=\"1\" y1=\"9\" x2=\"4\" y2=\"9\"></line><line x1=\"1\" y1=\"14\" x2=\"4\" y2=\"14\"></line>",
                "credit-card": "<rect x=\"1\" y=\"4\" width=\"22\" height=\"16\" rx=\"2\" ry=\"2\"></rect><line x1=\"1\" y1=\"10\" x2=\"23\" y2=\"10\"></line>",
                crop: "<path d=\"M6.13 1L6 16a2 2 0 0 0 2 2h15\"></path><path d=\"M1 6.13L16 6a2 2 0 0 1 2 2v15\"></path>",
                crosshair: "<circle cx=\"12\" cy=\"12\" r=\"10\"></circle><line x1=\"22\" y1=\"12\" x2=\"18\" y2=\"12\"></line><line x1=\"6\" y1=\"12\" x2=\"2\" y2=\"12\"></line><line x1=\"12\" y1=\"6\" x2=\"12\" y2=\"2\"></line><line x1=\"12\" y1=\"22\" x2=\"12\" y2=\"18\"></line>",
                database: "<ellipse cx=\"12\" cy=\"5\" rx=\"9\" ry=\"3\"></ellipse><path d=\"M21 12c0 1.66-4 3-9 3s-9-1.34-9-3\"></path><path d=\"M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5\"></path>",
                "delete": "<path d=\"M21 4H8l-7 8 7 8h13a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z\"></path><line x1=\"18\" y1=\"9\" x2=\"12\" y2=\"15\"></line><line x1=\"12\" y1=\"9\" x2=\"18\" y2=\"15\"></line>",
                disc: "<circle cx=\"12\" cy=\"12\" r=\"10\"></circle><circle cx=\"12\" cy=\"12\" r=\"3\"></circle>",
                "divide-circle": "<line x1=\"8\" y1=\"12\" x2=\"16\" y2=\"12\"></line><line x1=\"12\" y1=\"16\" x2=\"12\" y2=\"16\"></line><line x1=\"12\" y1=\"8\" x2=\"12\" y2=\"8\"></line><circle cx=\"12\" cy=\"12\" r=\"10\"></circle>",
                "divide-square": "<rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"2\" ry=\"2\"></rect><line x1=\"8\" y1=\"12\" x2=\"16\" y2=\"12\"></line><line x1=\"12\" y1=\"16\" x2=\"12\" y2=\"16\"></line><line x1=\"12\" y1=\"8\" x2=\"12\" y2=\"8\"></line>",
                divide: "<circle cx=\"12\" cy=\"6\" r=\"2\"></circle><line x1=\"5\" y1=\"12\" x2=\"19\" y2=\"12\"></line><circle cx=\"12\" cy=\"18\" r=\"2\"></circle>",
                "dollar-sign": "<line x1=\"12\" y1=\"1\" x2=\"12\" y2=\"23\"></line><path d=\"M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6\"></path>",
                "download-cloud": "<polyline points=\"8 17 12 21 16 17\"></polyline><line x1=\"12\" y1=\"12\" x2=\"12\" y2=\"21\"></line><path d=\"M20.88 18.09A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.29\"></path>",
                download: "<path d=\"M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4\"></path><polyline points=\"7 10 12 15 17 10\"></polyline><line x1=\"12\" y1=\"15\" x2=\"12\" y2=\"3\"></line>",
                dribbble: "<circle cx=\"12\" cy=\"12\" r=\"10\"></circle><path d=\"M8.56 2.75c4.37 6.03 6.02 9.42 8.03 17.72m2.54-15.38c-3.72 4.35-8.94 5.66-16.88 5.85m19.5 1.9c-3.5-.93-6.63-.82-8.94 0-2.58.92-5.01 2.86-7.44 6.32\"></path>",
                droplet: "<path d=\"M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z\"></path>",
                "edit-2": "<path d=\"M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z\"></path>",
                "edit-3": "<path d=\"M12 20h9\"></path><path d=\"M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z\"></path>",
                edit: "<path d=\"M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7\"></path><path d=\"M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z\"></path>",
                "external-link": "<path d=\"M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6\"></path><polyline points=\"15 3 21 3 21 9\"></polyline><line x1=\"10\" y1=\"14\" x2=\"21\" y2=\"3\"></line>",
                "eye-off": "<path d=\"M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24\"></path><line x1=\"1\" y1=\"1\" x2=\"23\" y2=\"23\"></line>",
                eye: "<path d=\"M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z\"></path><circle cx=\"12\" cy=\"12\" r=\"3\"></circle>",
                facebook: "<path d=\"M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z\"></path>",
                "fast-forward": "<polygon points=\"13 19 22 12 13 5 13 19\"></polygon><polygon points=\"2 19 11 12 2 5 2 19\"></polygon>",
                feather: "<path d=\"M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z\"></path><line x1=\"16\" y1=\"8\" x2=\"2\" y2=\"22\"></line><line x1=\"17.5\" y1=\"15\" x2=\"9\" y2=\"15\"></line>",
                figma: "<path d=\"M5 5.5A3.5 3.5 0 0 1 8.5 2H12v7H8.5A3.5 3.5 0 0 1 5 5.5z\"></path><path d=\"M12 2h3.5a3.5 3.5 0 1 1 0 7H12V2z\"></path><path d=\"M12 12.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 1 1-7 0z\"></path><path d=\"M5 19.5A3.5 3.5 0 0 1 8.5 16H12v3.5a3.5 3.5 0 1 1-7 0z\"></path><path d=\"M5 12.5A3.5 3.5 0 0 1 8.5 9H12v7H8.5A3.5 3.5 0 0 1 5 12.5z\"></path>",
                "file-minus": "<path d=\"M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z\"></path><polyline points=\"14 2 14 8 20 8\"></polyline><line x1=\"9\" y1=\"15\" x2=\"15\" y2=\"15\"></line>",
                "file-plus": "<path d=\"M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z\"></path><polyline points=\"14 2 14 8 20 8\"></polyline><line x1=\"12\" y1=\"18\" x2=\"12\" y2=\"12\"></line><line x1=\"9\" y1=\"15\" x2=\"15\" y2=\"15\"></line>",
                "file-text": "<path d=\"M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z\"></path><polyline points=\"14 2 14 8 20 8\"></polyline><line x1=\"16\" y1=\"13\" x2=\"8\" y2=\"13\"></line><line x1=\"16\" y1=\"17\" x2=\"8\" y2=\"17\"></line><polyline points=\"10 9 9 9 8 9\"></polyline>",
                file: "<path d=\"M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z\"></path><polyline points=\"13 2 13 9 20 9\"></polyline>",
                film: "<rect x=\"2\" y=\"2\" width=\"20\" height=\"20\" rx=\"2.18\" ry=\"2.18\"></rect><line x1=\"7\" y1=\"2\" x2=\"7\" y2=\"22\"></line><line x1=\"17\" y1=\"2\" x2=\"17\" y2=\"22\"></line><line x1=\"2\" y1=\"12\" x2=\"22\" y2=\"12\"></line><line x1=\"2\" y1=\"7\" x2=\"7\" y2=\"7\"></line><line x1=\"2\" y1=\"17\" x2=\"7\" y2=\"17\"></line><line x1=\"17\" y1=\"17\" x2=\"22\" y2=\"17\"></line><line x1=\"17\" y1=\"7\" x2=\"22\" y2=\"7\"></line>",
                filter: "<polygon points=\"22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3\"></polygon>",
                flag: "<path d=\"M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z\"></path><line x1=\"4\" y1=\"22\" x2=\"4\" y2=\"15\"></line>",
                "folder-minus": "<path d=\"M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z\"></path><line x1=\"9\" y1=\"14\" x2=\"15\" y2=\"14\"></line>",
                "folder-plus": "<path d=\"M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z\"></path><line x1=\"12\" y1=\"11\" x2=\"12\" y2=\"17\"></line><line x1=\"9\" y1=\"14\" x2=\"15\" y2=\"14\"></line>",
                folder: "<path d=\"M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z\"></path>",
                framer: "<path d=\"M5 16V9h14V2H5l14 14h-7m-7 0l7 7v-7m-7 0h7\"></path>",
                frown: "<circle cx=\"12\" cy=\"12\" r=\"10\"></circle><path d=\"M16 16s-1.5-2-4-2-4 2-4 2\"></path><line x1=\"9\" y1=\"9\" x2=\"9.01\" y2=\"9\"></line><line x1=\"15\" y1=\"9\" x2=\"15.01\" y2=\"9\"></line>",
                gift: "<polyline points=\"20 12 20 22 4 22 4 12\"></polyline><rect x=\"2\" y=\"7\" width=\"20\" height=\"5\"></rect><line x1=\"12\" y1=\"22\" x2=\"12\" y2=\"7\"></line><path d=\"M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z\"></path><path d=\"M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z\"></path>",
                "git-branch": "<line x1=\"6\" y1=\"3\" x2=\"6\" y2=\"15\"></line><circle cx=\"18\" cy=\"6\" r=\"3\"></circle><circle cx=\"6\" cy=\"18\" r=\"3\"></circle><path d=\"M18 9a9 9 0 0 1-9 9\"></path>",
                "git-commit": "<circle cx=\"12\" cy=\"12\" r=\"4\"></circle><line x1=\"1.05\" y1=\"12\" x2=\"7\" y2=\"12\"></line><line x1=\"17.01\" y1=\"12\" x2=\"22.96\" y2=\"12\"></line>",
                "git-merge": "<circle cx=\"18\" cy=\"18\" r=\"3\"></circle><circle cx=\"6\" cy=\"6\" r=\"3\"></circle><path d=\"M6 21V9a9 9 0 0 0 9 9\"></path>",
                "git-pull-request": "<circle cx=\"18\" cy=\"18\" r=\"3\"></circle><circle cx=\"6\" cy=\"6\" r=\"3\"></circle><path d=\"M13 6h3a2 2 0 0 1 2 2v7\"></path><line x1=\"6\" y1=\"9\" x2=\"6\" y2=\"21\"></line>",
                github: "<path d=\"M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22\"></path>",
                gitlab: "<path d=\"M22.65 14.39L12 22.13 1.35 14.39a.84.84 0 0 1-.3-.94l1.22-3.78 2.44-7.51A.42.42 0 0 1 4.82 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.49h8.1l2.44-7.51A.42.42 0 0 1 18.6 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.51L23 13.45a.84.84 0 0 1-.35.94z\"></path>",
                globe: "<circle cx=\"12\" cy=\"12\" r=\"10\"></circle><line x1=\"2\" y1=\"12\" x2=\"22\" y2=\"12\"></line><path d=\"M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z\"></path>",
                grid: "<rect x=\"3\" y=\"3\" width=\"7\" height=\"7\"></rect><rect x=\"14\" y=\"3\" width=\"7\" height=\"7\"></rect><rect x=\"14\" y=\"14\" width=\"7\" height=\"7\"></rect><rect x=\"3\" y=\"14\" width=\"7\" height=\"7\"></rect>",
                "hard-drive": "<line x1=\"22\" y1=\"12\" x2=\"2\" y2=\"12\"></line><path d=\"M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z\"></path><line x1=\"6\" y1=\"16\" x2=\"6.01\" y2=\"16\"></line><line x1=\"10\" y1=\"16\" x2=\"10.01\" y2=\"16\"></line>",
                hash: "<line x1=\"4\" y1=\"9\" x2=\"20\" y2=\"9\"></line><line x1=\"4\" y1=\"15\" x2=\"20\" y2=\"15\"></line><line x1=\"10\" y1=\"3\" x2=\"8\" y2=\"21\"></line><line x1=\"16\" y1=\"3\" x2=\"14\" y2=\"21\"></line>",
                headphones: "<path d=\"M3 18v-6a9 9 0 0 1 18 0v6\"></path><path d=\"M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z\"></path>",
                heart: "<path d=\"M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z\"></path>",
                "help-circle": "<circle cx=\"12\" cy=\"12\" r=\"10\"></circle><path d=\"M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3\"></path><line x1=\"12\" y1=\"17\" x2=\"12.01\" y2=\"17\"></line>",
                hexagon: "<path d=\"M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z\"></path>",
                home: "<path d=\"M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z\"></path><polyline points=\"9 22 9 12 15 12 15 22\"></polyline>",
                image: "<rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"2\" ry=\"2\"></rect><circle cx=\"8.5\" cy=\"8.5\" r=\"1.5\"></circle><polyline points=\"21 15 16 10 5 21\"></polyline>",
                inbox: "<polyline points=\"22 12 16 12 14 15 10 15 8 12 2 12\"></polyline><path d=\"M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z\"></path>",
                info: "<circle cx=\"12\" cy=\"12\" r=\"10\"></circle><line x1=\"12\" y1=\"16\" x2=\"12\" y2=\"12\"></line><line x1=\"12\" y1=\"8\" x2=\"12.01\" y2=\"8\"></line>",
                instagram: "<rect x=\"2\" y=\"2\" width=\"20\" height=\"20\" rx=\"5\" ry=\"5\"></rect><path d=\"M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z\"></path><line x1=\"17.5\" y1=\"6.5\" x2=\"17.51\" y2=\"6.5\"></line>",
                italic: "<line x1=\"19\" y1=\"4\" x2=\"10\" y2=\"4\"></line><line x1=\"14\" y1=\"20\" x2=\"5\" y2=\"20\"></line><line x1=\"15\" y1=\"4\" x2=\"9\" y2=\"20\"></line>",
                key: "<path d=\"M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4\"></path>",
                layers: "<polygon points=\"12 2 2 7 12 12 22 7 12 2\"></polygon><polyline points=\"2 17 12 22 22 17\"></polyline><polyline points=\"2 12 12 17 22 12\"></polyline>",
                layout: "<rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"2\" ry=\"2\"></rect><line x1=\"3\" y1=\"9\" x2=\"21\" y2=\"9\"></line><line x1=\"9\" y1=\"21\" x2=\"9\" y2=\"9\"></line>",
                "life-buoy": "<circle cx=\"12\" cy=\"12\" r=\"10\"></circle><circle cx=\"12\" cy=\"12\" r=\"4\"></circle><line x1=\"4.93\" y1=\"4.93\" x2=\"9.17\" y2=\"9.17\"></line><line x1=\"14.83\" y1=\"14.83\" x2=\"19.07\" y2=\"19.07\"></line><line x1=\"14.83\" y1=\"9.17\" x2=\"19.07\" y2=\"4.93\"></line><line x1=\"14.83\" y1=\"9.17\" x2=\"18.36\" y2=\"5.64\"></line><line x1=\"4.93\" y1=\"19.07\" x2=\"9.17\" y2=\"14.83\"></line>",
                "link-2": "<path d=\"M15 7h3a5 5 0 0 1 5 5 5 5 0 0 1-5 5h-3m-6 0H6a5 5 0 0 1-5-5 5 5 0 0 1 5-5h3\"></path><line x1=\"8\" y1=\"12\" x2=\"16\" y2=\"12\"></line>",
                link: "<path d=\"M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71\"></path><path d=\"M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71\"></path>",
                linkedin: "<path d=\"M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z\"></path><rect x=\"2\" y=\"9\" width=\"4\" height=\"12\"></rect><circle cx=\"4\" cy=\"4\" r=\"2\"></circle>",
                list: "<line x1=\"8\" y1=\"6\" x2=\"21\" y2=\"6\"></line><line x1=\"8\" y1=\"12\" x2=\"21\" y2=\"12\"></line><line x1=\"8\" y1=\"18\" x2=\"21\" y2=\"18\"></line><line x1=\"3\" y1=\"6\" x2=\"3.01\" y2=\"6\"></line><line x1=\"3\" y1=\"12\" x2=\"3.01\" y2=\"12\"></line><line x1=\"3\" y1=\"18\" x2=\"3.01\" y2=\"18\"></line>",
                loader: "<line x1=\"12\" y1=\"2\" x2=\"12\" y2=\"6\"></line><line x1=\"12\" y1=\"18\" x2=\"12\" y2=\"22\"></line><line x1=\"4.93\" y1=\"4.93\" x2=\"7.76\" y2=\"7.76\"></line><line x1=\"16.24\" y1=\"16.24\" x2=\"19.07\" y2=\"19.07\"></line><line x1=\"2\" y1=\"12\" x2=\"6\" y2=\"12\"></line><line x1=\"18\" y1=\"12\" x2=\"22\" y2=\"12\"></line><line x1=\"4.93\" y1=\"19.07\" x2=\"7.76\" y2=\"16.24\"></line><line x1=\"16.24\" y1=\"7.76\" x2=\"19.07\" y2=\"4.93\"></line>",
                lock: "<rect x=\"3\" y=\"11\" width=\"18\" height=\"11\" rx=\"2\" ry=\"2\"></rect><path d=\"M7 11V7a5 5 0 0 1 10 0v4\"></path>",
                "log-in": "<path d=\"M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4\"></path><polyline points=\"10 17 15 12 10 7\"></polyline><line x1=\"15\" y1=\"12\" x2=\"3\" y2=\"12\"></line>",
                "log-out": "<path d=\"M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4\"></path><polyline points=\"16 17 21 12 16 7\"></polyline><line x1=\"21\" y1=\"12\" x2=\"9\" y2=\"12\"></line>",
                mail: "<path d=\"M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z\"></path><polyline points=\"22,6 12,13 2,6\"></polyline>",
                "map-pin": "<path d=\"M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z\"></path><circle cx=\"12\" cy=\"10\" r=\"3\"></circle>",
                map: "<polygon points=\"1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6\"></polygon><line x1=\"8\" y1=\"2\" x2=\"8\" y2=\"18\"></line><line x1=\"16\" y1=\"6\" x2=\"16\" y2=\"22\"></line>",
                "maximize-2": "<polyline points=\"15 3 21 3 21 9\"></polyline><polyline points=\"9 21 3 21 3 15\"></polyline><line x1=\"21\" y1=\"3\" x2=\"14\" y2=\"10\"></line><line x1=\"3\" y1=\"21\" x2=\"10\" y2=\"14\"></line>",
                maximize: "<path d=\"M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3\"></path>",
                meh: "<circle cx=\"12\" cy=\"12\" r=\"10\"></circle><line x1=\"8\" y1=\"15\" x2=\"16\" y2=\"15\"></line><line x1=\"9\" y1=\"9\" x2=\"9.01\" y2=\"9\"></line><line x1=\"15\" y1=\"9\" x2=\"15.01\" y2=\"9\"></line>",
                menu: "<line x1=\"3\" y1=\"12\" x2=\"21\" y2=\"12\"></line><line x1=\"3\" y1=\"6\" x2=\"21\" y2=\"6\"></line><line x1=\"3\" y1=\"18\" x2=\"21\" y2=\"18\"></line>",
                "message-circle": "<path d=\"M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z\"></path>",
                "message-square": "<path d=\"M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z\"></path>",
                "mic-off": "<line x1=\"1\" y1=\"1\" x2=\"23\" y2=\"23\"></line><path d=\"M9 9v3a3 3 0 0 0 5.12 2.12M15 9.34V4a3 3 0 0 0-5.94-.6\"></path><path d=\"M17 16.95A7 7 0 0 1 5 12v-2m14 0v2a7 7 0 0 1-.11 1.23\"></path><line x1=\"12\" y1=\"19\" x2=\"12\" y2=\"23\"></line><line x1=\"8\" y1=\"23\" x2=\"16\" y2=\"23\"></line>",
                mic: "<path d=\"M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z\"></path><path d=\"M19 10v2a7 7 0 0 1-14 0v-2\"></path><line x1=\"12\" y1=\"19\" x2=\"12\" y2=\"23\"></line><line x1=\"8\" y1=\"23\" x2=\"16\" y2=\"23\"></line>",
                "minimize-2": "<polyline points=\"4 14 10 14 10 20\"></polyline><polyline points=\"20 10 14 10 14 4\"></polyline><line x1=\"14\" y1=\"10\" x2=\"21\" y2=\"3\"></line><line x1=\"3\" y1=\"21\" x2=\"10\" y2=\"14\"></line>",
                minimize: "<path d=\"M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3\"></path>",
                "minus-circle": "<circle cx=\"12\" cy=\"12\" r=\"10\"></circle><line x1=\"8\" y1=\"12\" x2=\"16\" y2=\"12\"></line>",
                "minus-square": "<rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"2\" ry=\"2\"></rect><line x1=\"8\" y1=\"12\" x2=\"16\" y2=\"12\"></line>",
                minus: "<line x1=\"5\" y1=\"12\" x2=\"19\" y2=\"12\"></line>",
                monitor: "<rect x=\"2\" y=\"3\" width=\"20\" height=\"14\" rx=\"2\" ry=\"2\"></rect><line x1=\"8\" y1=\"21\" x2=\"16\" y2=\"21\"></line><line x1=\"12\" y1=\"17\" x2=\"12\" y2=\"21\"></line>",
                moon: "<path d=\"M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z\"></path>",
                "more-horizontal": "<circle cx=\"12\" cy=\"12\" r=\"1\"></circle><circle cx=\"19\" cy=\"12\" r=\"1\"></circle><circle cx=\"5\" cy=\"12\" r=\"1\"></circle>",
                "more-vertical": "<circle cx=\"12\" cy=\"12\" r=\"1\"></circle><circle cx=\"12\" cy=\"5\" r=\"1\"></circle><circle cx=\"12\" cy=\"19\" r=\"1\"></circle>",
                "mouse-pointer": "<path d=\"M3 3l7.07 16.97 2.51-7.39 7.39-2.51L3 3z\"></path><path d=\"M13 13l6 6\"></path>",
                move: "<polyline points=\"5 9 2 12 5 15\"></polyline><polyline points=\"9 5 12 2 15 5\"></polyline><polyline points=\"15 19 12 22 9 19\"></polyline><polyline points=\"19 9 22 12 19 15\"></polyline><line x1=\"2\" y1=\"12\" x2=\"22\" y2=\"12\"></line><line x1=\"12\" y1=\"2\" x2=\"12\" y2=\"22\"></line>",
                music: "<path d=\"M9 18V5l12-2v13\"></path><circle cx=\"6\" cy=\"18\" r=\"3\"></circle><circle cx=\"18\" cy=\"16\" r=\"3\"></circle>",
                "navigation-2": "<polygon points=\"12 2 19 21 12 17 5 21 12 2\"></polygon>",
                navigation: "<polygon points=\"3 11 22 2 13 21 11 13 3 11\"></polygon>",
                octagon: "<polygon points=\"7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2\"></polygon>",
                "package": "<line x1=\"16.5\" y1=\"9.4\" x2=\"7.5\" y2=\"4.21\"></line><path d=\"M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z\"></path><polyline points=\"3.27 6.96 12 12.01 20.73 6.96\"></polyline><line x1=\"12\" y1=\"22.08\" x2=\"12\" y2=\"12\"></line>",
                paperclip: "<path d=\"M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48\"></path>",
                "pause-circle": "<circle cx=\"12\" cy=\"12\" r=\"10\"></circle><line x1=\"10\" y1=\"15\" x2=\"10\" y2=\"9\"></line><line x1=\"14\" y1=\"15\" x2=\"14\" y2=\"9\"></line>",
                pause: "<rect x=\"6\" y=\"4\" width=\"4\" height=\"16\"></rect><rect x=\"14\" y=\"4\" width=\"4\" height=\"16\"></rect>",
                "pen-tool": "<path d=\"M12 19l7-7 3 3-7 7-3-3z\"></path><path d=\"M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z\"></path><path d=\"M2 2l7.586 7.586\"></path><circle cx=\"11\" cy=\"11\" r=\"2\"></circle>",
                percent: "<line x1=\"19\" y1=\"5\" x2=\"5\" y2=\"19\"></line><circle cx=\"6.5\" cy=\"6.5\" r=\"2.5\"></circle><circle cx=\"17.5\" cy=\"17.5\" r=\"2.5\"></circle>",
                "phone-call": "<path d=\"M15.05 5A5 5 0 0 1 19 8.95M15.05 1A9 9 0 0 1 23 8.94m-1 7.98v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z\"></path>",
                "phone-forwarded": "<polyline points=\"19 1 23 5 19 9\"></polyline><line x1=\"15\" y1=\"5\" x2=\"23\" y2=\"5\"></line><path d=\"M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z\"></path>",
                "phone-incoming": "<polyline points=\"16 2 16 8 22 8\"></polyline><line x1=\"23\" y1=\"1\" x2=\"16\" y2=\"8\"></line><path d=\"M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z\"></path>",
                "phone-missed": "<line x1=\"23\" y1=\"1\" x2=\"17\" y2=\"7\"></line><line x1=\"17\" y1=\"1\" x2=\"23\" y2=\"7\"></line><path d=\"M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z\"></path>",
                "phone-off": "<path d=\"M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7 2 2 0 0 1 1.72 2v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.42 19.42 0 0 1-3.33-2.67m-2.67-3.34a19.79 19.79 0 0 1-3.07-8.63A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91\"></path><line x1=\"23\" y1=\"1\" x2=\"1\" y2=\"23\"></line>",
                "phone-outgoing": "<polyline points=\"23 7 23 1 17 1\"></polyline><line x1=\"16\" y1=\"8\" x2=\"23\" y2=\"1\"></line><path d=\"M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z\"></path>",
                phone: "<path d=\"M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z\"></path>",
                "pie-chart": "<path d=\"M21.21 15.89A10 10 0 1 1 8 2.83\"></path><path d=\"M22 12A10 10 0 0 0 12 2v10z\"></path>",
                "play-circle": "<circle cx=\"12\" cy=\"12\" r=\"10\"></circle><polygon points=\"10 8 16 12 10 16 10 8\"></polygon>",
                play: "<polygon points=\"5 3 19 12 5 21 5 3\"></polygon>",
                "plus-circle": "<circle cx=\"12\" cy=\"12\" r=\"10\"></circle><line x1=\"12\" y1=\"8\" x2=\"12\" y2=\"16\"></line><line x1=\"8\" y1=\"12\" x2=\"16\" y2=\"12\"></line>",
                "plus-square": "<rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"2\" ry=\"2\"></rect><line x1=\"12\" y1=\"8\" x2=\"12\" y2=\"16\"></line><line x1=\"8\" y1=\"12\" x2=\"16\" y2=\"12\"></line>",
                plus: "<line x1=\"12\" y1=\"5\" x2=\"12\" y2=\"19\"></line><line x1=\"5\" y1=\"12\" x2=\"19\" y2=\"12\"></line>",
                pocket: "<path d=\"M4 3h16a2 2 0 0 1 2 2v6a10 10 0 0 1-10 10A10 10 0 0 1 2 11V5a2 2 0 0 1 2-2z\"></path><polyline points=\"8 10 12 14 16 10\"></polyline>",
                power: "<path d=\"M18.36 6.64a9 9 0 1 1-12.73 0\"></path><line x1=\"12\" y1=\"2\" x2=\"12\" y2=\"12\"></line>",
                printer: "<polyline points=\"6 9 6 2 18 2 18 9\"></polyline><path d=\"M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2\"></path><rect x=\"6\" y=\"14\" width=\"12\" height=\"8\"></rect>",
                radio: "<circle cx=\"12\" cy=\"12\" r=\"2\"></circle><path d=\"M16.24 7.76a6 6 0 0 1 0 8.49m-8.48-.01a6 6 0 0 1 0-8.49m11.31-2.82a10 10 0 0 1 0 14.14m-14.14 0a10 10 0 0 1 0-14.14\"></path>",
                "refresh-ccw": "<polyline points=\"1 4 1 10 7 10\"></polyline><polyline points=\"23 20 23 14 17 14\"></polyline><path d=\"M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15\"></path>",
                "refresh-cw": "<polyline points=\"23 4 23 10 17 10\"></polyline><polyline points=\"1 20 1 14 7 14\"></polyline><path d=\"M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15\"></path>",
                repeat: "<polyline points=\"17 1 21 5 17 9\"></polyline><path d=\"M3 11V9a4 4 0 0 1 4-4h14\"></path><polyline points=\"7 23 3 19 7 15\"></polyline><path d=\"M21 13v2a4 4 0 0 1-4 4H3\"></path>",
                rewind: "<polygon points=\"11 19 2 12 11 5 11 19\"></polygon><polygon points=\"22 19 13 12 22 5 22 19\"></polygon>",
                "rotate-ccw": "<polyline points=\"1 4 1 10 7 10\"></polyline><path d=\"M3.51 15a9 9 0 1 0 2.13-9.36L1 10\"></path>",
                "rotate-cw": "<polyline points=\"23 4 23 10 17 10\"></polyline><path d=\"M20.49 15a9 9 0 1 1-2.12-9.36L23 10\"></path>",
                rss: "<path d=\"M4 11a9 9 0 0 1 9 9\"></path><path d=\"M4 4a16 16 0 0 1 16 16\"></path><circle cx=\"5\" cy=\"19\" r=\"1\"></circle>",
                save: "<path d=\"M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z\"></path><polyline points=\"17 21 17 13 7 13 7 21\"></polyline><polyline points=\"7 3 7 8 15 8\"></polyline>",
                scissors: "<circle cx=\"6\" cy=\"6\" r=\"3\"></circle><circle cx=\"6\" cy=\"18\" r=\"3\"></circle><line x1=\"20\" y1=\"4\" x2=\"8.12\" y2=\"15.88\"></line><line x1=\"14.47\" y1=\"14.48\" x2=\"20\" y2=\"20\"></line><line x1=\"8.12\" y1=\"8.12\" x2=\"12\" y2=\"12\"></line>",
                search: "<circle cx=\"11\" cy=\"11\" r=\"8\"></circle><line x1=\"21\" y1=\"21\" x2=\"16.65\" y2=\"16.65\"></line>",
                send: "<line x1=\"22\" y1=\"2\" x2=\"11\" y2=\"13\"></line><polygon points=\"22 2 15 22 11 13 2 9 22 2\"></polygon>",
                server: "<rect x=\"2\" y=\"2\" width=\"20\" height=\"8\" rx=\"2\" ry=\"2\"></rect><rect x=\"2\" y=\"14\" width=\"20\" height=\"8\" rx=\"2\" ry=\"2\"></rect><line x1=\"6\" y1=\"6\" x2=\"6.01\" y2=\"6\"></line><line x1=\"6\" y1=\"18\" x2=\"6.01\" y2=\"18\"></line>",
                settings: "<circle cx=\"12\" cy=\"12\" r=\"3\"></circle><path d=\"M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z\"></path>",
                "share-2": "<circle cx=\"18\" cy=\"5\" r=\"3\"></circle><circle cx=\"6\" cy=\"12\" r=\"3\"></circle><circle cx=\"18\" cy=\"19\" r=\"3\"></circle><line x1=\"8.59\" y1=\"13.51\" x2=\"15.42\" y2=\"17.49\"></line><line x1=\"15.41\" y1=\"6.51\" x2=\"8.59\" y2=\"10.49\"></line>",
                share: "<path d=\"M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8\"></path><polyline points=\"16 6 12 2 8 6\"></polyline><line x1=\"12\" y1=\"2\" x2=\"12\" y2=\"15\"></line>",
                "shield-off": "<path d=\"M19.69 14a6.9 6.9 0 0 0 .31-2V5l-8-3-3.16 1.18\"></path><path d=\"M4.73 4.73L4 5v7c0 6 8 10 8 10a20.29 20.29 0 0 0 5.62-4.38\"></path><line x1=\"1\" y1=\"1\" x2=\"23\" y2=\"23\"></line>",
                shield: "<path d=\"M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z\"></path>",
                "shopping-bag": "<path d=\"M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z\"></path><line x1=\"3\" y1=\"6\" x2=\"21\" y2=\"6\"></line><path d=\"M16 10a4 4 0 0 1-8 0\"></path>",
                "shopping-cart": "<circle cx=\"9\" cy=\"21\" r=\"1\"></circle><circle cx=\"20\" cy=\"21\" r=\"1\"></circle><path d=\"M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6\"></path>",
                shuffle: "<polyline points=\"16 3 21 3 21 8\"></polyline><line x1=\"4\" y1=\"20\" x2=\"21\" y2=\"3\"></line><polyline points=\"21 16 21 21 16 21\"></polyline><line x1=\"15\" y1=\"15\" x2=\"21\" y2=\"21\"></line><line x1=\"4\" y1=\"4\" x2=\"9\" y2=\"9\"></line>",
                sidebar: "<rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"2\" ry=\"2\"></rect><line x1=\"9\" y1=\"3\" x2=\"9\" y2=\"21\"></line>",
                "skip-back": "<polygon points=\"19 20 9 12 19 4 19 20\"></polygon><line x1=\"5\" y1=\"19\" x2=\"5\" y2=\"5\"></line>",
                "skip-forward": "<polygon points=\"5 4 15 12 5 20 5 4\"></polygon><line x1=\"19\" y1=\"5\" x2=\"19\" y2=\"19\"></line>",
                slack: "<path d=\"M14.5 10c-.83 0-1.5-.67-1.5-1.5v-5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5z\"></path><path d=\"M20.5 10H19V8.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z\"></path><path d=\"M9.5 14c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5S8 21.33 8 20.5v-5c0-.83.67-1.5 1.5-1.5z\"></path><path d=\"M3.5 14H5v1.5c0 .83-.67 1.5-1.5 1.5S2 16.33 2 15.5 2.67 14 3.5 14z\"></path><path d=\"M14 14.5c0-.83.67-1.5 1.5-1.5h5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-5c-.83 0-1.5-.67-1.5-1.5z\"></path><path d=\"M15.5 19H14v1.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z\"></path><path d=\"M10 9.5C10 8.67 9.33 8 8.5 8h-5C2.67 8 2 8.67 2 9.5S2.67 11 3.5 11h5c.83 0 1.5-.67 1.5-1.5z\"></path><path d=\"M8.5 5H10V3.5C10 2.67 9.33 2 8.5 2S7 2.67 7 3.5 7.67 5 8.5 5z\"></path>",
                slash: "<circle cx=\"12\" cy=\"12\" r=\"10\"></circle><line x1=\"4.93\" y1=\"4.93\" x2=\"19.07\" y2=\"19.07\"></line>",
                sliders: "<line x1=\"4\" y1=\"21\" x2=\"4\" y2=\"14\"></line><line x1=\"4\" y1=\"10\" x2=\"4\" y2=\"3\"></line><line x1=\"12\" y1=\"21\" x2=\"12\" y2=\"12\"></line><line x1=\"12\" y1=\"8\" x2=\"12\" y2=\"3\"></line><line x1=\"20\" y1=\"21\" x2=\"20\" y2=\"16\"></line><line x1=\"20\" y1=\"12\" x2=\"20\" y2=\"3\"></line><line x1=\"1\" y1=\"14\" x2=\"7\" y2=\"14\"></line><line x1=\"9\" y1=\"8\" x2=\"15\" y2=\"8\"></line><line x1=\"17\" y1=\"16\" x2=\"23\" y2=\"16\"></line>",
                smartphone: "<rect x=\"5\" y=\"2\" width=\"14\" height=\"20\" rx=\"2\" ry=\"2\"></rect><line x1=\"12\" y1=\"18\" x2=\"12.01\" y2=\"18\"></line>",
                smile: "<circle cx=\"12\" cy=\"12\" r=\"10\"></circle><path d=\"M8 14s1.5 2 4 2 4-2 4-2\"></path><line x1=\"9\" y1=\"9\" x2=\"9.01\" y2=\"9\"></line><line x1=\"15\" y1=\"9\" x2=\"15.01\" y2=\"9\"></line>",
                speaker: "<rect x=\"4\" y=\"2\" width=\"16\" height=\"20\" rx=\"2\" ry=\"2\"></rect><circle cx=\"12\" cy=\"14\" r=\"4\"></circle><line x1=\"12\" y1=\"6\" x2=\"12.01\" y2=\"6\"></line>",
                square: "<rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"2\" ry=\"2\"></rect>",
                star: "<polygon points=\"12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2\"></polygon>",
                "stop-circle": "<circle cx=\"12\" cy=\"12\" r=\"10\"></circle><rect x=\"9\" y=\"9\" width=\"6\" height=\"6\"></rect>",
                sun: "<circle cx=\"12\" cy=\"12\" r=\"5\"></circle><line x1=\"12\" y1=\"1\" x2=\"12\" y2=\"3\"></line><line x1=\"12\" y1=\"21\" x2=\"12\" y2=\"23\"></line><line x1=\"4.22\" y1=\"4.22\" x2=\"5.64\" y2=\"5.64\"></line><line x1=\"18.36\" y1=\"18.36\" x2=\"19.78\" y2=\"19.78\"></line><line x1=\"1\" y1=\"12\" x2=\"3\" y2=\"12\"></line><line x1=\"21\" y1=\"12\" x2=\"23\" y2=\"12\"></line><line x1=\"4.22\" y1=\"19.78\" x2=\"5.64\" y2=\"18.36\"></line><line x1=\"18.36\" y1=\"5.64\" x2=\"19.78\" y2=\"4.22\"></line>",
                sunrise: "<path d=\"M17 18a5 5 0 0 0-10 0\"></path><line x1=\"12\" y1=\"2\" x2=\"12\" y2=\"9\"></line><line x1=\"4.22\" y1=\"10.22\" x2=\"5.64\" y2=\"11.64\"></line><line x1=\"1\" y1=\"18\" x2=\"3\" y2=\"18\"></line><line x1=\"21\" y1=\"18\" x2=\"23\" y2=\"18\"></line><line x1=\"18.36\" y1=\"11.64\" x2=\"19.78\" y2=\"10.22\"></line><line x1=\"23\" y1=\"22\" x2=\"1\" y2=\"22\"></line><polyline points=\"8 6 12 2 16 6\"></polyline>",
                sunset: "<path d=\"M17 18a5 5 0 0 0-10 0\"></path><line x1=\"12\" y1=\"9\" x2=\"12\" y2=\"2\"></line><line x1=\"4.22\" y1=\"10.22\" x2=\"5.64\" y2=\"11.64\"></line><line x1=\"1\" y1=\"18\" x2=\"3\" y2=\"18\"></line><line x1=\"21\" y1=\"18\" x2=\"23\" y2=\"18\"></line><line x1=\"18.36\" y1=\"11.64\" x2=\"19.78\" y2=\"10.22\"></line><line x1=\"23\" y1=\"22\" x2=\"1\" y2=\"22\"></line><polyline points=\"16 5 12 9 8 5\"></polyline>",
                table: "<path d=\"M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18\"></path>",
                tablet: "<rect x=\"4\" y=\"2\" width=\"16\" height=\"20\" rx=\"2\" ry=\"2\"></rect><line x1=\"12\" y1=\"18\" x2=\"12.01\" y2=\"18\"></line>",
                tag: "<path d=\"M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z\"></path><line x1=\"7\" y1=\"7\" x2=\"7.01\" y2=\"7\"></line>",
                target: "<circle cx=\"12\" cy=\"12\" r=\"10\"></circle><circle cx=\"12\" cy=\"12\" r=\"6\"></circle><circle cx=\"12\" cy=\"12\" r=\"2\"></circle>",
                terminal: "<polyline points=\"4 17 10 11 4 5\"></polyline><line x1=\"12\" y1=\"19\" x2=\"20\" y2=\"19\"></line>",
                thermometer: "<path d=\"M14 14.76V3.5a2.5 2.5 0 0 0-5 0v11.26a4.5 4.5 0 1 0 5 0z\"></path>",
                "thumbs-down": "<path d=\"M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17\"></path>",
                "thumbs-up": "<path d=\"M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3\"></path>",
                "toggle-left": "<rect x=\"1\" y=\"5\" width=\"22\" height=\"14\" rx=\"7\" ry=\"7\"></rect><circle cx=\"8\" cy=\"12\" r=\"3\"></circle>",
                "toggle-right": "<rect x=\"1\" y=\"5\" width=\"22\" height=\"14\" rx=\"7\" ry=\"7\"></rect><circle cx=\"16\" cy=\"12\" r=\"3\"></circle>",
                tool: "<path d=\"M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z\"></path>",
                "trash-2": "<polyline points=\"3 6 5 6 21 6\"></polyline><path d=\"M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2\"></path><line x1=\"10\" y1=\"11\" x2=\"10\" y2=\"17\"></line><line x1=\"14\" y1=\"11\" x2=\"14\" y2=\"17\"></line>",
                trash: "<polyline points=\"3 6 5 6 21 6\"></polyline><path d=\"M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2\"></path>",
                trello: "<rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"2\" ry=\"2\"></rect><rect x=\"7\" y=\"7\" width=\"3\" height=\"9\"></rect><rect x=\"14\" y=\"7\" width=\"3\" height=\"5\"></rect>",
                "trending-down": "<polyline points=\"23 18 13.5 8.5 8.5 13.5 1 6\"></polyline><polyline points=\"17 18 23 18 23 12\"></polyline>",
                "trending-up": "<polyline points=\"23 6 13.5 15.5 8.5 10.5 1 18\"></polyline><polyline points=\"17 6 23 6 23 12\"></polyline>",
                triangle: "<path d=\"M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z\"></path>",
                truck: "<rect x=\"1\" y=\"3\" width=\"15\" height=\"13\"></rect><polygon points=\"16 8 20 8 23 11 23 16 16 16 16 8\"></polygon><circle cx=\"5.5\" cy=\"18.5\" r=\"2.5\"></circle><circle cx=\"18.5\" cy=\"18.5\" r=\"2.5\"></circle>",
                tv: "<rect x=\"2\" y=\"7\" width=\"20\" height=\"15\" rx=\"2\" ry=\"2\"></rect><polyline points=\"17 2 12 7 7 2\"></polyline>",
                twitch: "<path d=\"M21 2H3v16h5v4l4-4h5l4-4V2zm-10 9V7m5 4V7\"></path>",
                twitter: "<path d=\"M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z\"></path>",
                type: "<polyline points=\"4 7 4 4 20 4 20 7\"></polyline><line x1=\"9\" y1=\"20\" x2=\"15\" y2=\"20\"></line><line x1=\"12\" y1=\"4\" x2=\"12\" y2=\"20\"></line>",
                umbrella: "<path d=\"M23 12a11.05 11.05 0 0 0-22 0zm-5 7a3 3 0 0 1-6 0v-7\"></path>",
                underline: "<path d=\"M6 3v7a6 6 0 0 0 6 6 6 6 0 0 0 6-6V3\"></path><line x1=\"4\" y1=\"21\" x2=\"20\" y2=\"21\"></line>",
                unlock: "<rect x=\"3\" y=\"11\" width=\"18\" height=\"11\" rx=\"2\" ry=\"2\"></rect><path d=\"M7 11V7a5 5 0 0 1 9.9-1\"></path>",
                "upload-cloud": "<polyline points=\"16 16 12 12 8 16\"></polyline><line x1=\"12\" y1=\"12\" x2=\"12\" y2=\"21\"></line><path d=\"M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3\"></path><polyline points=\"16 16 12 12 8 16\"></polyline>",
                upload: "<path d=\"M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4\"></path><polyline points=\"17 8 12 3 7 8\"></polyline><line x1=\"12\" y1=\"3\" x2=\"12\" y2=\"15\"></line>",
                "user-check": "<path d=\"M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2\"></path><circle cx=\"8.5\" cy=\"7\" r=\"4\"></circle><polyline points=\"17 11 19 13 23 9\"></polyline>",
                "user-minus": "<path d=\"M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2\"></path><circle cx=\"8.5\" cy=\"7\" r=\"4\"></circle><line x1=\"23\" y1=\"11\" x2=\"17\" y2=\"11\"></line>",
                "user-plus": "<path d=\"M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2\"></path><circle cx=\"8.5\" cy=\"7\" r=\"4\"></circle><line x1=\"20\" y1=\"8\" x2=\"20\" y2=\"14\"></line><line x1=\"23\" y1=\"11\" x2=\"17\" y2=\"11\"></line>",
                "user-x": "<path d=\"M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2\"></path><circle cx=\"8.5\" cy=\"7\" r=\"4\"></circle><line x1=\"18\" y1=\"8\" x2=\"23\" y2=\"13\"></line><line x1=\"23\" y1=\"8\" x2=\"18\" y2=\"13\"></line>",
                user: "<path d=\"M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2\"></path><circle cx=\"12\" cy=\"7\" r=\"4\"></circle>",
                users: "<path d=\"M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2\"></path><circle cx=\"9\" cy=\"7\" r=\"4\"></circle><path d=\"M23 21v-2a4 4 0 0 0-3-3.87\"></path><path d=\"M16 3.13a4 4 0 0 1 0 7.75\"></path>",
                "video-off": "<path d=\"M16 16v1a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2m5.66 0H14a2 2 0 0 1 2 2v3.34l1 1L23 7v10\"></path><line x1=\"1\" y1=\"1\" x2=\"23\" y2=\"23\"></line>",
                video: "<polygon points=\"23 7 16 12 23 17 23 7\"></polygon><rect x=\"1\" y=\"5\" width=\"15\" height=\"14\" rx=\"2\" ry=\"2\"></rect>",
                voicemail: "<circle cx=\"5.5\" cy=\"11.5\" r=\"4.5\"></circle><circle cx=\"18.5\" cy=\"11.5\" r=\"4.5\"></circle><line x1=\"5.5\" y1=\"16\" x2=\"18.5\" y2=\"16\"></line>",
                "volume-1": "<polygon points=\"11 5 6 9 2 9 2 15 6 15 11 19 11 5\"></polygon><path d=\"M15.54 8.46a5 5 0 0 1 0 7.07\"></path>",
                "volume-2": "<polygon points=\"11 5 6 9 2 9 2 15 6 15 11 19 11 5\"></polygon><path d=\"M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07\"></path>",
                "volume-x": "<polygon points=\"11 5 6 9 2 9 2 15 6 15 11 19 11 5\"></polygon><line x1=\"23\" y1=\"9\" x2=\"17\" y2=\"15\"></line><line x1=\"17\" y1=\"9\" x2=\"23\" y2=\"15\"></line>",
                volume: "<polygon points=\"11 5 6 9 2 9 2 15 6 15 11 19 11 5\"></polygon>",
                watch: "<circle cx=\"12\" cy=\"12\" r=\"7\"></circle><polyline points=\"12 9 12 12 13.5 13.5\"></polyline><path d=\"M16.51 17.35l-.35 3.83a2 2 0 0 1-2 1.82H9.83a2 2 0 0 1-2-1.82l-.35-3.83m.01-10.7l.35-3.83A2 2 0 0 1 9.83 1h4.35a2 2 0 0 1 2 1.82l.35 3.83\"></path>",
                "wifi-off": "<line x1=\"1\" y1=\"1\" x2=\"23\" y2=\"23\"></line><path d=\"M16.72 11.06A10.94 10.94 0 0 1 19 12.55\"></path><path d=\"M5 12.55a10.94 10.94 0 0 1 5.17-2.39\"></path><path d=\"M10.71 5.05A16 16 0 0 1 22.58 9\"></path><path d=\"M1.42 9a15.91 15.91 0 0 1 4.7-2.88\"></path><path d=\"M8.53 16.11a6 6 0 0 1 6.95 0\"></path><line x1=\"12\" y1=\"20\" x2=\"12.01\" y2=\"20\"></line>",
                wifi: "<path d=\"M5 12.55a11 11 0 0 1 14.08 0\"></path><path d=\"M1.42 9a16 16 0 0 1 21.16 0\"></path><path d=\"M8.53 16.11a6 6 0 0 1 6.95 0\"></path><line x1=\"12\" y1=\"20\" x2=\"12.01\" y2=\"20\"></line>",
                wind: "<path d=\"M9.59 4.59A2 2 0 1 1 11 8H2m10.59 11.41A2 2 0 1 0 14 16H2m15.73-8.27A2.5 2.5 0 1 1 19.5 12H2\"></path>",
                "x-circle": "<circle cx=\"12\" cy=\"12\" r=\"10\"></circle><line x1=\"15\" y1=\"9\" x2=\"9\" y2=\"15\"></line><line x1=\"9\" y1=\"9\" x2=\"15\" y2=\"15\"></line>",
                "x-octagon": "<polygon points=\"7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2\"></polygon><line x1=\"15\" y1=\"9\" x2=\"9\" y2=\"15\"></line><line x1=\"9\" y1=\"9\" x2=\"15\" y2=\"15\"></line>",
                "x-square": "<rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"2\" ry=\"2\"></rect><line x1=\"9\" y1=\"9\" x2=\"15\" y2=\"15\"></line><line x1=\"15\" y1=\"9\" x2=\"9\" y2=\"15\"></line>",
                x: "<line x1=\"18\" y1=\"6\" x2=\"6\" y2=\"18\"></line><line x1=\"6\" y1=\"6\" x2=\"18\" y2=\"18\"></line>",
                youtube: "<path d=\"M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z\"></path><polygon points=\"9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02\"></polygon>",
                "zap-off": "<polyline points=\"12.41 6.75 13 2 10.57 4.92\"></polyline><polyline points=\"18.57 12.91 21 10 15.66 10\"></polyline><polyline points=\"8 8 3 14 12 14 11 22 16 16\"></polyline><line x1=\"1\" y1=\"1\" x2=\"23\" y2=\"23\"></line>",
                zap: "<polygon points=\"13 2 3 14 12 14 11 22 21 10 12 10 13 2\"></polygon>",
                "zoom-in": "<circle cx=\"11\" cy=\"11\" r=\"8\"></circle><line x1=\"21\" y1=\"21\" x2=\"16.65\" y2=\"16.65\"></line><line x1=\"11\" y1=\"8\" x2=\"11\" y2=\"14\"></line><line x1=\"8\" y1=\"11\" x2=\"14\" y2=\"11\"></line>",
                "zoom-out": "<circle cx=\"11\" cy=\"11\" r=\"8\"></circle><line x1=\"21\" y1=\"21\" x2=\"16.65\" y2=\"16.65\"></line><line x1=\"8\" y1=\"11\" x2=\"14\" y2=\"11\"></line>"
            };
        /***/ },
        /***/ "./node_modules/classnames/dedupe.js": /*!*******************************************!*\
  !*** ./node_modules/classnames/dedupe.js ***!
  \*******************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; /*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/ 
            /* global define */ (function() {
                'use strict';
                var classNames = function() {
                    // don't inherit from Object so we can skip hasOwnProperty check later
                    // http://stackoverflow.com/questions/15518328/creating-js-object-with-object-createnull#answer-21079232
                    function StorageObject() {}
                    StorageObject.prototype = Object.create(null);
                    function _parseArray(resultSet, array) {
                        var length = array.length;
                        for(var i = 0; i < length; ++i)_parse(resultSet, array[i]);
                    }
                    var hasOwn = {}.hasOwnProperty;
                    function _parseNumber(resultSet, num) {
                        resultSet[num] = true;
                    }
                    function _parseObject(resultSet, object) {
                        for(var k in object)if (hasOwn.call(object, k)) // set value to false instead of deleting it to avoid changing object structure
                        // https://www.smashingmagazine.com/2012/11/writing-fast-memory-efficient-javascript/#de-referencing-misconceptions
                        resultSet[k] = !!object[k];
                    }
                    var SPACE = /\s+/;
                    function _parseString(resultSet, str) {
                        var array = str.split(SPACE);
                        var length = array.length;
                        for(var i = 0; i < length; ++i)resultSet[array[i]] = true;
                    }
                    function _parse(resultSet, arg) {
                        if (!arg) return;
                        var argType = typeof arg === "undefined" ? "undefined" : (0, $7e5af7f007906526$export$71511d61b312f219)(arg);
                        // 'foo bar'
                        if (argType === 'string') _parseString(resultSet, arg);
                        else if (Array.isArray(arg)) _parseArray(resultSet, arg);
                        else if (argType === 'object') _parseObject(resultSet, arg);
                        else if (argType === 'number') _parseNumber(resultSet, arg);
                    }
                    function _classNames() {
                        // don't leak arguments
                        // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
                        var len = arguments.length;
                        var args = Array(len);
                        for(var i = 0; i < len; i++)args[i] = arguments[i];
                        var classSet = new StorageObject();
                        _parseArray(classSet, args);
                        var list = [];
                        for(var k in classSet)if (classSet[k]) list.push(k);
                        return list.join(' ');
                    }
                    return _classNames;
                }();
                if (typeof module1 !== 'undefined' && module1.exports) module1.exports = classNames;
                else // register as 'classnames', consistent with npm package name
                __WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
                    return classNames;
                }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module1.exports = __WEBPACK_AMD_DEFINE_RESULT__);
            })();
        /***/ },
        /***/ "./node_modules/core-js/es/array/from.js": /*!***********************************************!*\
  !*** ./node_modules/core-js/es/array/from.js ***!
  \***********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            __webpack_require__(/*! ../../modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js");
            __webpack_require__(/*! ../../modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js");
            var path = __webpack_require__(/*! ../../internals/path */ "./node_modules/core-js/internals/path.js");
            module1.exports = path.Array.from;
        /***/ },
        /***/ "./node_modules/core-js/internals/a-function.js": /*!******************************************************!*\
  !*** ./node_modules/core-js/internals/a-function.js ***!
  \******************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = function(it) {
                if (typeof it != 'function') throw TypeError(String(it) + ' is not a function');
                return it;
            };
        /***/ },
        /***/ "./node_modules/core-js/internals/an-object.js": /*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/an-object.js ***!
  \*****************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
            module1.exports = function(it) {
                if (!isObject(it)) throw TypeError(String(it) + ' is not an object');
                return it;
            };
        /***/ },
        /***/ "./node_modules/core-js/internals/array-from.js": /*!******************************************************!*\
  !*** ./node_modules/core-js/internals/array-from.js ***!
  \******************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var bind = __webpack_require__(/*! ../internals/bind-context */ "./node_modules/core-js/internals/bind-context.js");
            var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/core-js/internals/to-object.js");
            var callWithSafeIterationClosing = __webpack_require__(/*! ../internals/call-with-safe-iteration-closing */ "./node_modules/core-js/internals/call-with-safe-iteration-closing.js");
            var isArrayIteratorMethod = __webpack_require__(/*! ../internals/is-array-iterator-method */ "./node_modules/core-js/internals/is-array-iterator-method.js");
            var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js/internals/to-length.js");
            var createProperty = __webpack_require__(/*! ../internals/create-property */ "./node_modules/core-js/internals/create-property.js");
            var getIteratorMethod = __webpack_require__(/*! ../internals/get-iterator-method */ "./node_modules/core-js/internals/get-iterator-method.js");
            // `Array.from` method
            // https://tc39.github.io/ecma262/#sec-array.from
            module1.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */ ) {
                var O = toObject(arrayLike);
                var C = typeof this == 'function' ? this : Array;
                var argumentsLength = arguments.length;
                var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
                var mapping = mapfn !== undefined;
                var index = 0;
                var iteratorMethod = getIteratorMethod(O);
                var length, result, step, iterator;
                if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined, 2);
                // if the target is not iterable or it's an array with the default iterator - use a simple case
                if (iteratorMethod != undefined && !(C == Array && isArrayIteratorMethod(iteratorMethod))) {
                    iterator = iteratorMethod.call(O);
                    result = new C();
                    for(; !(step = iterator.next()).done; index++)createProperty(result, index, mapping ? callWithSafeIterationClosing(iterator, mapfn, [
                        step.value,
                        index
                    ], true) : step.value);
                } else {
                    length = toLength(O.length);
                    result = new C(length);
                    for(; length > index; index++)createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
                }
                result.length = index;
                return result;
            };
        /***/ },
        /***/ "./node_modules/core-js/internals/array-includes.js": /*!**********************************************************!*\
  !*** ./node_modules/core-js/internals/array-includes.js ***!
  \**********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var toIndexedObject = __webpack_require__(/*! ../internals/to-indexed-object */ "./node_modules/core-js/internals/to-indexed-object.js");
            var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js/internals/to-length.js");
            var toAbsoluteIndex = __webpack_require__(/*! ../internals/to-absolute-index */ "./node_modules/core-js/internals/to-absolute-index.js");
            // `Array.prototype.{ indexOf, includes }` methods implementation
            // false -> Array#indexOf
            // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
            // true  -> Array#includes
            // https://tc39.github.io/ecma262/#sec-array.prototype.includes
            module1.exports = function(IS_INCLUDES) {
                return function($this, el, fromIndex) {
                    var O = toIndexedObject($this);
                    var length = toLength(O.length);
                    var index = toAbsoluteIndex(fromIndex, length);
                    var value;
                    // Array#includes uses SameValueZero equality algorithm
                    // eslint-disable-next-line no-self-compare
                    if (IS_INCLUDES && el != el) while(length > index){
                        value = O[index++];
                        // eslint-disable-next-line no-self-compare
                        if (value != value) return true;
                    // Array#indexOf ignores holes, Array#includes - not
                    }
                    else for(; length > index; index++)if (IS_INCLUDES || index in O) {
                        if (O[index] === el) return IS_INCLUDES || index || 0;
                    }
                    return !IS_INCLUDES && -1;
                };
            };
        /***/ },
        /***/ "./node_modules/core-js/internals/bind-context.js": /*!********************************************************!*\
  !*** ./node_modules/core-js/internals/bind-context.js ***!
  \********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var aFunction = __webpack_require__(/*! ../internals/a-function */ "./node_modules/core-js/internals/a-function.js");
            // optional / simple context binding
            module1.exports = function(fn, that, length) {
                aFunction(fn);
                if (that === undefined) return fn;
                switch(length){
                    case 0:
                        return function() {
                            return fn.call(that);
                        };
                    case 1:
                        return function(a) {
                            return fn.call(that, a);
                        };
                    case 2:
                        return function(a, b) {
                            return fn.call(that, a, b);
                        };
                    case 3:
                        return function(a, b, c) {
                            return fn.call(that, a, b, c);
                        };
                }
                return function() {
                    return fn.apply(that, arguments);
                };
            };
        /***/ },
        /***/ "./node_modules/core-js/internals/call-with-safe-iteration-closing.js": /*!****************************************************************************!*\
  !*** ./node_modules/core-js/internals/call-with-safe-iteration-closing.js ***!
  \****************************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
            // call something on iterator step with safe closing on error
            module1.exports = function(iterator, fn, value, ENTRIES) {
                try {
                    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
                // 7.4.6 IteratorClose(iterator, completion)
                } catch (error) {
                    var returnMethod = iterator['return'];
                    if (returnMethod !== undefined) anObject(returnMethod.call(iterator));
                    throw error;
                }
            };
        /***/ },
        /***/ "./node_modules/core-js/internals/check-correctness-of-iteration.js": /*!**************************************************************************!*\
  !*** ./node_modules/core-js/internals/check-correctness-of-iteration.js ***!
  \**************************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
            var ITERATOR = wellKnownSymbol('iterator');
            var SAFE_CLOSING = false;
            try {
                var called = 0;
                var iteratorWithReturn = {
                    next: function next() {
                        return {
                            done: !!called++
                        };
                    },
                    'return': function() {
                        SAFE_CLOSING = true;
                    }
                };
                iteratorWithReturn[ITERATOR] = function() {
                    return this;
                };
                // eslint-disable-next-line no-throw-literal
                Array.from(iteratorWithReturn, function() {
                    throw 2;
                });
            } catch (error) {}
            module1.exports = function(exec, SKIP_CLOSING) {
                if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
                var ITERATION_SUPPORT = false;
                try {
                    var object = {};
                    object[ITERATOR] = function() {
                        return {
                            next: function next() {
                                return {
                                    done: ITERATION_SUPPORT = true
                                };
                            }
                        };
                    };
                    exec(object);
                } catch (error) {}
                return ITERATION_SUPPORT;
            };
        /***/ },
        /***/ "./node_modules/core-js/internals/classof-raw.js": /*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/classof-raw.js ***!
  \*******************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            var toString = {}.toString;
            module1.exports = function(it) {
                return toString.call(it).slice(8, -1);
            };
        /***/ },
        /***/ "./node_modules/core-js/internals/classof.js": /*!***************************************************!*\
  !*** ./node_modules/core-js/internals/classof.js ***!
  \***************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var classofRaw = __webpack_require__(/*! ../internals/classof-raw */ "./node_modules/core-js/internals/classof-raw.js");
            var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
            var TO_STRING_TAG = wellKnownSymbol('toStringTag');
            // ES3 wrong here
            var CORRECT_ARGUMENTS = classofRaw(function() {
                return arguments;
            }()) == 'Arguments';
            // fallback for IE11 Script Access Denied error
            var tryGet = function tryGet(it, key) {
                try {
                    return it[key];
                } catch (error) {}
            };
            // getting tag from ES6+ `Object.prototype.toString`
            module1.exports = function(it) {
                var O, tag, result;
                return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag : CORRECT_ARGUMENTS ? classofRaw(O) : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
            };
        /***/ },
        /***/ "./node_modules/core-js/internals/copy-constructor-properties.js": /*!***********************************************************************!*\
  !*** ./node_modules/core-js/internals/copy-constructor-properties.js ***!
  \***********************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
            var ownKeys = __webpack_require__(/*! ../internals/own-keys */ "./node_modules/core-js/internals/own-keys.js");
            var getOwnPropertyDescriptorModule = __webpack_require__(/*! ../internals/object-get-own-property-descriptor */ "./node_modules/core-js/internals/object-get-own-property-descriptor.js");
            var definePropertyModule = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js");
            module1.exports = function(target, source) {
                var keys = ownKeys(source);
                var defineProperty = definePropertyModule.f;
                var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
                for(var i = 0; i < keys.length; i++){
                    var key = keys[i];
                    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
                }
            };
        /***/ },
        /***/ "./node_modules/core-js/internals/correct-prototype-getter.js": /*!********************************************************************!*\
  !*** ./node_modules/core-js/internals/correct-prototype-getter.js ***!
  \********************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
            module1.exports = !fails(function() {
                function F() {}
                F.prototype.constructor = null;
                return Object.getPrototypeOf(new F()) !== F.prototype;
            });
        /***/ },
        /***/ "./node_modules/core-js/internals/create-iterator-constructor.js": /*!***********************************************************************!*\
  !*** ./node_modules/core-js/internals/create-iterator-constructor.js ***!
  \***********************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var IteratorPrototype = __webpack_require__(/*! ../internals/iterators-core */ "./node_modules/core-js/internals/iterators-core.js").IteratorPrototype;
            var create = __webpack_require__(/*! ../internals/object-create */ "./node_modules/core-js/internals/object-create.js");
            var createPropertyDescriptor = __webpack_require__(/*! ../internals/create-property-descriptor */ "./node_modules/core-js/internals/create-property-descriptor.js");
            var setToStringTag = __webpack_require__(/*! ../internals/set-to-string-tag */ "./node_modules/core-js/internals/set-to-string-tag.js");
            var Iterators = __webpack_require__(/*! ../internals/iterators */ "./node_modules/core-js/internals/iterators.js");
            var returnThis = function returnThis() {
                return this;
            };
            module1.exports = function(IteratorConstructor, NAME, next) {
                var TO_STRING_TAG = NAME + ' Iterator';
                IteratorConstructor.prototype = create(IteratorPrototype, {
                    next: createPropertyDescriptor(1, next)
                });
                setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
                Iterators[TO_STRING_TAG] = returnThis;
                return IteratorConstructor;
            };
        /***/ },
        /***/ "./node_modules/core-js/internals/create-property-descriptor.js": /*!**********************************************************************!*\
  !*** ./node_modules/core-js/internals/create-property-descriptor.js ***!
  \**********************************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = function(bitmap, value) {
                return {
                    enumerable: !(bitmap & 1),
                    configurable: !(bitmap & 2),
                    writable: !(bitmap & 4),
                    value: value
                };
            };
        /***/ },
        /***/ "./node_modules/core-js/internals/create-property.js": /*!***********************************************************!*\
  !*** ./node_modules/core-js/internals/create-property.js ***!
  \***********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var toPrimitive = __webpack_require__(/*! ../internals/to-primitive */ "./node_modules/core-js/internals/to-primitive.js");
            var definePropertyModule = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js");
            var createPropertyDescriptor = __webpack_require__(/*! ../internals/create-property-descriptor */ "./node_modules/core-js/internals/create-property-descriptor.js");
            module1.exports = function(object, key, value) {
                var propertyKey = toPrimitive(key);
                if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
                else object[propertyKey] = value;
            };
        /***/ },
        /***/ "./node_modules/core-js/internals/define-iterator.js": /*!***********************************************************!*\
  !*** ./node_modules/core-js/internals/define-iterator.js ***!
  \***********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
            var createIteratorConstructor = __webpack_require__(/*! ../internals/create-iterator-constructor */ "./node_modules/core-js/internals/create-iterator-constructor.js");
            var getPrototypeOf = __webpack_require__(/*! ../internals/object-get-prototype-of */ "./node_modules/core-js/internals/object-get-prototype-of.js");
            var setPrototypeOf = __webpack_require__(/*! ../internals/object-set-prototype-of */ "./node_modules/core-js/internals/object-set-prototype-of.js");
            var setToStringTag = __webpack_require__(/*! ../internals/set-to-string-tag */ "./node_modules/core-js/internals/set-to-string-tag.js");
            var hide = __webpack_require__(/*! ../internals/hide */ "./node_modules/core-js/internals/hide.js");
            var redefine = __webpack_require__(/*! ../internals/redefine */ "./node_modules/core-js/internals/redefine.js");
            var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
            var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
            var Iterators = __webpack_require__(/*! ../internals/iterators */ "./node_modules/core-js/internals/iterators.js");
            var IteratorsCore = __webpack_require__(/*! ../internals/iterators-core */ "./node_modules/core-js/internals/iterators-core.js");
            var IteratorPrototype = IteratorsCore.IteratorPrototype;
            var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
            var ITERATOR = wellKnownSymbol('iterator');
            var KEYS = 'keys';
            var VALUES = 'values';
            var ENTRIES = 'entries';
            var returnThis = function returnThis() {
                return this;
            };
            module1.exports = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
                createIteratorConstructor(IteratorConstructor, NAME, next);
                var getIterationMethod = function getIterationMethod(KIND) {
                    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
                    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
                    switch(KIND){
                        case KEYS:
                            return function keys() {
                                return new IteratorConstructor(this, KIND);
                            };
                        case VALUES:
                            return function values() {
                                return new IteratorConstructor(this, KIND);
                            };
                        case ENTRIES:
                            return function entries() {
                                return new IteratorConstructor(this, KIND);
                            };
                    }
                    return function() {
                        return new IteratorConstructor(this);
                    };
                };
                var TO_STRING_TAG = NAME + ' Iterator';
                var INCORRECT_VALUES_NAME = false;
                var IterablePrototype = Iterable.prototype;
                var nativeIterator = IterablePrototype[ITERATOR] || IterablePrototype['@@iterator'] || DEFAULT && IterablePrototype[DEFAULT];
                var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
                var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
                var CurrentIteratorPrototype, methods, KEY;
                // fix native
                if (anyNativeIterator) {
                    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
                    if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
                        if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
                            if (setPrototypeOf) setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
                            else if (typeof CurrentIteratorPrototype[ITERATOR] != 'function') hide(CurrentIteratorPrototype, ITERATOR, returnThis);
                        }
                        // Set @@toStringTag to native iterators
                        setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
                        if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
                    }
                }
                // fix Array#{values, @@iterator}.name in V8 / FF
                if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
                    INCORRECT_VALUES_NAME = true;
                    defaultIterator = function values() {
                        return nativeIterator.call(this);
                    };
                }
                // define iterator
                if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) hide(IterablePrototype, ITERATOR, defaultIterator);
                Iterators[NAME] = defaultIterator;
                // export additional methods
                if (DEFAULT) {
                    methods = {
                        values: getIterationMethod(VALUES),
                        keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
                        entries: getIterationMethod(ENTRIES)
                    };
                    if (FORCED) {
                        for(KEY in methods)if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) redefine(IterablePrototype, KEY, methods[KEY]);
                    } else $({
                        target: NAME,
                        proto: true,
                        forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
                    }, methods);
                }
                return methods;
            };
        /***/ },
        /***/ "./node_modules/core-js/internals/descriptors.js": /*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/descriptors.js ***!
  \*******************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
            // Thank's IE8 for his funny defineProperty
            module1.exports = !fails(function() {
                return Object.defineProperty({}, 'a', {
                    get: function get() {
                        return 7;
                    }
                }).a != 7;
            });
        /***/ },
        /***/ "./node_modules/core-js/internals/document-create-element.js": /*!*******************************************************************!*\
  !*** ./node_modules/core-js/internals/document-create-element.js ***!
  \*******************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
            var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
            var document1 = global.document;
            // typeof document.createElement is 'object' in old IE
            var exist = isObject(document1) && isObject(document1.createElement);
            module1.exports = function(it) {
                return exist ? document1.createElement(it) : {};
            };
        /***/ },
        /***/ "./node_modules/core-js/internals/enum-bug-keys.js": /*!*********************************************************!*\
  !*** ./node_modules/core-js/internals/enum-bug-keys.js ***!
  \*********************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            // IE8- don't enum bug keys
            module1.exports = [
                'constructor',
                'hasOwnProperty',
                'isPrototypeOf',
                'propertyIsEnumerable',
                'toLocaleString',
                'toString',
                'valueOf'
            ];
        /***/ },
        /***/ "./node_modules/core-js/internals/export.js": /*!**************************************************!*\
  !*** ./node_modules/core-js/internals/export.js ***!
  \**************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
            var getOwnPropertyDescriptor = __webpack_require__(/*! ../internals/object-get-own-property-descriptor */ "./node_modules/core-js/internals/object-get-own-property-descriptor.js").f;
            var hide = __webpack_require__(/*! ../internals/hide */ "./node_modules/core-js/internals/hide.js");
            var redefine = __webpack_require__(/*! ../internals/redefine */ "./node_modules/core-js/internals/redefine.js");
            var setGlobal = __webpack_require__(/*! ../internals/set-global */ "./node_modules/core-js/internals/set-global.js");
            var copyConstructorProperties = __webpack_require__(/*! ../internals/copy-constructor-properties */ "./node_modules/core-js/internals/copy-constructor-properties.js");
            var isForced = __webpack_require__(/*! ../internals/is-forced */ "./node_modules/core-js/internals/is-forced.js");
            /*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/ module1.exports = function(options, source) {
                var TARGET = options.target;
                var GLOBAL = options.global;
                var STATIC = options.stat;
                var FORCED, target, key, targetProperty, sourceProperty, descriptor;
                if (GLOBAL) target = global;
                else if (STATIC) target = global[TARGET] || setGlobal(TARGET, {});
                else target = (global[TARGET] || {}).prototype;
                if (target) for(key in source){
                    sourceProperty = source[key];
                    if (options.noTargetGet) {
                        descriptor = getOwnPropertyDescriptor(target, key);
                        targetProperty = descriptor && descriptor.value;
                    } else targetProperty = target[key];
                    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
                    // contained in target
                    if (!FORCED && targetProperty !== undefined) {
                        if ((typeof sourceProperty === "undefined" ? "undefined" : (0, $7e5af7f007906526$export$71511d61b312f219)(sourceProperty)) === (typeof targetProperty === "undefined" ? "undefined" : (0, $7e5af7f007906526$export$71511d61b312f219)(targetProperty))) continue;
                        copyConstructorProperties(sourceProperty, targetProperty);
                    }
                    // add a flag to not completely full polyfills
                    if (options.sham || targetProperty && targetProperty.sham) hide(sourceProperty, 'sham', true);
                    // extend global
                    redefine(target, key, sourceProperty, options);
                }
            };
        /***/ },
        /***/ "./node_modules/core-js/internals/fails.js": /*!*************************************************!*\
  !*** ./node_modules/core-js/internals/fails.js ***!
  \*************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = function(exec) {
                try {
                    return !!exec();
                } catch (error) {
                    return true;
                }
            };
        /***/ },
        /***/ "./node_modules/core-js/internals/function-to-string.js": /*!**************************************************************!*\
  !*** ./node_modules/core-js/internals/function-to-string.js ***!
  \**************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var shared = __webpack_require__(/*! ../internals/shared */ "./node_modules/core-js/internals/shared.js");
            module1.exports = shared('native-function-to-string', Function.toString);
        /***/ },
        /***/ "./node_modules/core-js/internals/get-iterator-method.js": /*!***************************************************************!*\
  !*** ./node_modules/core-js/internals/get-iterator-method.js ***!
  \***************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var classof = __webpack_require__(/*! ../internals/classof */ "./node_modules/core-js/internals/classof.js");
            var Iterators = __webpack_require__(/*! ../internals/iterators */ "./node_modules/core-js/internals/iterators.js");
            var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
            var ITERATOR = wellKnownSymbol('iterator');
            module1.exports = function(it) {
                if (it != undefined) return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
            };
        /***/ },
        /***/ "./node_modules/core-js/internals/global.js": /*!**************************************************!*\
  !*** ./node_modules/core-js/internals/global.js ***!
  \**************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            /* WEBPACK VAR INJECTION */ (function(global) {
                var O = 'object';
                var check = function check(it) {
                    return it && it.Math == Math && it;
                };
                // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
                module1.exports = // eslint-disable-next-line no-undef
                check((typeof globalThis === "undefined" ? "undefined" : (0, $7e5af7f007906526$export$71511d61b312f219)(globalThis)) == O && globalThis) || check((typeof window === "undefined" ? "undefined" : (0, $7e5af7f007906526$export$71511d61b312f219)(window)) == O && window) || check((typeof self === "undefined" ? "undefined" : (0, $7e5af7f007906526$export$71511d61b312f219)(self)) == O && self) || check((typeof global === "undefined" ? "undefined" : (0, $7e5af7f007906526$export$71511d61b312f219)(global)) == O && global) || // eslint-disable-next-line no-new-func
                Function('return this')();
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(/*! ./../../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js"));
        /***/ },
        /***/ "./node_modules/core-js/internals/has.js": /*!***********************************************!*\
  !*** ./node_modules/core-js/internals/has.js ***!
  \***********************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            var hasOwnProperty = {}.hasOwnProperty;
            module1.exports = function(it, key) {
                return hasOwnProperty.call(it, key);
            };
        /***/ },
        /***/ "./node_modules/core-js/internals/hidden-keys.js": /*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/hidden-keys.js ***!
  \*******************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = {};
        /***/ },
        /***/ "./node_modules/core-js/internals/hide.js": /*!************************************************!*\
  !*** ./node_modules/core-js/internals/hide.js ***!
  \************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
            var definePropertyModule = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js");
            var createPropertyDescriptor = __webpack_require__(/*! ../internals/create-property-descriptor */ "./node_modules/core-js/internals/create-property-descriptor.js");
            module1.exports = DESCRIPTORS ? function(object, key, value) {
                return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
            } : function(object, key, value) {
                object[key] = value;
                return object;
            };
        /***/ },
        /***/ "./node_modules/core-js/internals/html.js": /*!************************************************!*\
  !*** ./node_modules/core-js/internals/html.js ***!
  \************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
            var document1 = global.document;
            module1.exports = document1 && document1.documentElement;
        /***/ },
        /***/ "./node_modules/core-js/internals/ie8-dom-define.js": /*!**********************************************************!*\
  !*** ./node_modules/core-js/internals/ie8-dom-define.js ***!
  \**********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
            var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
            var createElement = __webpack_require__(/*! ../internals/document-create-element */ "./node_modules/core-js/internals/document-create-element.js");
            // Thank's IE8 for his funny defineProperty
            module1.exports = !DESCRIPTORS && !fails(function() {
                return Object.defineProperty(createElement('div'), 'a', {
                    get: function get() {
                        return 7;
                    }
                }).a != 7;
            });
        /***/ },
        /***/ "./node_modules/core-js/internals/indexed-object.js": /*!**********************************************************!*\
  !*** ./node_modules/core-js/internals/indexed-object.js ***!
  \**********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            // fallback for non-array-like ES3 and non-enumerable old V8 strings
            var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
            var classof = __webpack_require__(/*! ../internals/classof-raw */ "./node_modules/core-js/internals/classof-raw.js");
            var split = ''.split;
            module1.exports = fails(function() {
                // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
                // eslint-disable-next-line no-prototype-builtins
                return !Object('z').propertyIsEnumerable(0);
            }) ? function(it) {
                return classof(it) == 'String' ? split.call(it, '') : Object(it);
            } : Object;
        /***/ },
        /***/ "./node_modules/core-js/internals/internal-state.js": /*!**********************************************************!*\
  !*** ./node_modules/core-js/internals/internal-state.js ***!
  \**********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var NATIVE_WEAK_MAP = __webpack_require__(/*! ../internals/native-weak-map */ "./node_modules/core-js/internals/native-weak-map.js");
            var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
            var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
            var hide = __webpack_require__(/*! ../internals/hide */ "./node_modules/core-js/internals/hide.js");
            var objectHas = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
            var sharedKey = __webpack_require__(/*! ../internals/shared-key */ "./node_modules/core-js/internals/shared-key.js");
            var hiddenKeys = __webpack_require__(/*! ../internals/hidden-keys */ "./node_modules/core-js/internals/hidden-keys.js");
            var WeakMap = global.WeakMap;
            var set, get, has;
            var enforce = function enforce(it) {
                return has(it) ? get(it) : set(it, {});
            };
            var getterFor = function getterFor(TYPE) {
                return function(it) {
                    var state;
                    if (!isObject(it) || (state = get(it)).type !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required');
                    return state;
                };
            };
            if (NATIVE_WEAK_MAP) {
                var store = new WeakMap();
                var wmget = store.get;
                var wmhas = store.has;
                var wmset = store.set;
                set = function set(it, metadata) {
                    wmset.call(store, it, metadata);
                    return metadata;
                };
                get = function get(it) {
                    return wmget.call(store, it) || {};
                };
                has = function has(it) {
                    return wmhas.call(store, it);
                };
            } else {
                var STATE = sharedKey('state');
                hiddenKeys[STATE] = true;
                set = function set(it, metadata) {
                    hide(it, STATE, metadata);
                    return metadata;
                };
                get = function get(it) {
                    return objectHas(it, STATE) ? it[STATE] : {};
                };
                has = function has(it) {
                    return objectHas(it, STATE);
                };
            }
            module1.exports = {
                set: set,
                get: get,
                has: has,
                enforce: enforce,
                getterFor: getterFor
            };
        /***/ },
        /***/ "./node_modules/core-js/internals/is-array-iterator-method.js": /*!********************************************************************!*\
  !*** ./node_modules/core-js/internals/is-array-iterator-method.js ***!
  \********************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
            var Iterators = __webpack_require__(/*! ../internals/iterators */ "./node_modules/core-js/internals/iterators.js");
            var ITERATOR = wellKnownSymbol('iterator');
            var ArrayPrototype = Array.prototype;
            // check on default Array iterator
            module1.exports = function(it) {
                return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
            };
        /***/ },
        /***/ "./node_modules/core-js/internals/is-forced.js": /*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/is-forced.js ***!
  \*****************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
            var replacement = /#|\.prototype\./;
            var isForced = function isForced(feature, detection) {
                var value = data[normalize(feature)];
                return value == POLYFILL ? true : value == NATIVE ? false : typeof detection == 'function' ? fails(detection) : !!detection;
            };
            var normalize = isForced.normalize = function normalize(string) {
                return String(string).replace(replacement, '.').toLowerCase();
            };
            var data = isForced.data = {};
            var NATIVE = isForced.NATIVE = 'N';
            var POLYFILL = isForced.POLYFILL = 'P';
            module1.exports = isForced;
        /***/ },
        /***/ "./node_modules/core-js/internals/is-object.js": /*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/is-object.js ***!
  \*****************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = function(it) {
                return (typeof it === "undefined" ? "undefined" : (0, $7e5af7f007906526$export$71511d61b312f219)(it)) === 'object' ? it !== null : typeof it === 'function';
            };
        /***/ },
        /***/ "./node_modules/core-js/internals/is-pure.js": /*!***************************************************!*\
  !*** ./node_modules/core-js/internals/is-pure.js ***!
  \***************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = false;
        /***/ },
        /***/ "./node_modules/core-js/internals/iterators-core.js": /*!**********************************************************!*\
  !*** ./node_modules/core-js/internals/iterators-core.js ***!
  \**********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var getPrototypeOf = __webpack_require__(/*! ../internals/object-get-prototype-of */ "./node_modules/core-js/internals/object-get-prototype-of.js");
            var hide = __webpack_require__(/*! ../internals/hide */ "./node_modules/core-js/internals/hide.js");
            var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
            var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
            var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
            var ITERATOR = wellKnownSymbol('iterator');
            var BUGGY_SAFARI_ITERATORS = false;
            var returnThis = function returnThis() {
                return this;
            };
            // `%IteratorPrototype%` object
            // https://tc39.github.io/ecma262/#sec-%iteratorprototype%-object
            var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;
            if ([].keys) {
                arrayIterator = [].keys();
                // Safari 8 has buggy iterators w/o `next`
                if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
                else {
                    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
                    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
                }
            }
            if (IteratorPrototype == undefined) IteratorPrototype = {};
            // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
            if (!IS_PURE && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
            module1.exports = {
                IteratorPrototype: IteratorPrototype,
                BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
            };
        /***/ },
        /***/ "./node_modules/core-js/internals/iterators.js": /*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/iterators.js ***!
  \*****************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = {};
        /***/ },
        /***/ "./node_modules/core-js/internals/native-symbol.js": /*!*********************************************************!*\
  !*** ./node_modules/core-js/internals/native-symbol.js ***!
  \*********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
            module1.exports = !!Object.getOwnPropertySymbols && !fails(function() {
                // Chrome 38 Symbol has incorrect toString conversion
                // eslint-disable-next-line no-undef
                return !String(Symbol());
            });
        /***/ },
        /***/ "./node_modules/core-js/internals/native-weak-map.js": /*!***********************************************************!*\
  !*** ./node_modules/core-js/internals/native-weak-map.js ***!
  \***********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
            var nativeFunctionToString = __webpack_require__(/*! ../internals/function-to-string */ "./node_modules/core-js/internals/function-to-string.js");
            var WeakMap = global.WeakMap;
            module1.exports = typeof WeakMap === 'function' && /native code/.test(nativeFunctionToString.call(WeakMap));
        /***/ },
        /***/ "./node_modules/core-js/internals/object-create.js": /*!*********************************************************!*\
  !*** ./node_modules/core-js/internals/object-create.js ***!
  \*********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
            var defineProperties = __webpack_require__(/*! ../internals/object-define-properties */ "./node_modules/core-js/internals/object-define-properties.js");
            var enumBugKeys = __webpack_require__(/*! ../internals/enum-bug-keys */ "./node_modules/core-js/internals/enum-bug-keys.js");
            var hiddenKeys = __webpack_require__(/*! ../internals/hidden-keys */ "./node_modules/core-js/internals/hidden-keys.js");
            var html = __webpack_require__(/*! ../internals/html */ "./node_modules/core-js/internals/html.js");
            var documentCreateElement = __webpack_require__(/*! ../internals/document-create-element */ "./node_modules/core-js/internals/document-create-element.js");
            var sharedKey = __webpack_require__(/*! ../internals/shared-key */ "./node_modules/core-js/internals/shared-key.js");
            var IE_PROTO = sharedKey('IE_PROTO');
            var PROTOTYPE = 'prototype';
            var Empty = function Empty() {};
            // Create object with fake `null` prototype: use iframe Object with cleared prototype
            var createDict = function createDict1() {
                // Thrash, waste and sodomy: IE GC bug
                var iframe = documentCreateElement('iframe');
                var length = enumBugKeys.length;
                var lt = '<';
                var script = 'script';
                var gt = '>';
                var js = 'java' + script + ':';
                var iframeDocument;
                iframe.style.display = 'none';
                html.appendChild(iframe);
                iframe.src = String(js);
                iframeDocument = iframe.contentWindow.document;
                iframeDocument.open();
                iframeDocument.write(lt + script + gt + 'document.F=Object' + lt + '/' + script + gt);
                iframeDocument.close();
                createDict = iframeDocument.F;
                while(length--)delete createDict[PROTOTYPE][enumBugKeys[length]];
                return createDict();
            };
            // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
            module1.exports = Object.create || function create(O, Properties) {
                var result;
                if (O !== null) {
                    Empty[PROTOTYPE] = anObject(O);
                    result = new Empty();
                    Empty[PROTOTYPE] = null;
                    // add "__proto__" for Object.getPrototypeOf polyfill
                    result[IE_PROTO] = O;
                } else result = createDict();
                return Properties === undefined ? result : defineProperties(result, Properties);
            };
            hiddenKeys[IE_PROTO] = true;
        /***/ },
        /***/ "./node_modules/core-js/internals/object-define-properties.js": /*!********************************************************************!*\
  !*** ./node_modules/core-js/internals/object-define-properties.js ***!
  \********************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
            var definePropertyModule = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js");
            var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
            var objectKeys = __webpack_require__(/*! ../internals/object-keys */ "./node_modules/core-js/internals/object-keys.js");
            module1.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
                anObject(O);
                var keys = objectKeys(Properties);
                var length = keys.length;
                var i = 0;
                var key;
                while(length > i)definePropertyModule.f(O, key = keys[i++], Properties[key]);
                return O;
            };
        /***/ },
        /***/ "./node_modules/core-js/internals/object-define-property.js": /*!******************************************************************!*\
  !*** ./node_modules/core-js/internals/object-define-property.js ***!
  \******************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
            var IE8_DOM_DEFINE = __webpack_require__(/*! ../internals/ie8-dom-define */ "./node_modules/core-js/internals/ie8-dom-define.js");
            var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
            var toPrimitive = __webpack_require__(/*! ../internals/to-primitive */ "./node_modules/core-js/internals/to-primitive.js");
            var nativeDefineProperty = Object.defineProperty;
            exports.f = DESCRIPTORS ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
                anObject(O);
                P = toPrimitive(P, true);
                anObject(Attributes);
                if (IE8_DOM_DEFINE) try {
                    return nativeDefineProperty(O, P, Attributes);
                } catch (error) {}
                if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
                if ('value' in Attributes) O[P] = Attributes.value;
                return O;
            };
        /***/ },
        /***/ "./node_modules/core-js/internals/object-get-own-property-descriptor.js": /*!******************************************************************************!*\
  !*** ./node_modules/core-js/internals/object-get-own-property-descriptor.js ***!
  \******************************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
            var propertyIsEnumerableModule = __webpack_require__(/*! ../internals/object-property-is-enumerable */ "./node_modules/core-js/internals/object-property-is-enumerable.js");
            var createPropertyDescriptor = __webpack_require__(/*! ../internals/create-property-descriptor */ "./node_modules/core-js/internals/create-property-descriptor.js");
            var toIndexedObject = __webpack_require__(/*! ../internals/to-indexed-object */ "./node_modules/core-js/internals/to-indexed-object.js");
            var toPrimitive = __webpack_require__(/*! ../internals/to-primitive */ "./node_modules/core-js/internals/to-primitive.js");
            var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
            var IE8_DOM_DEFINE = __webpack_require__(/*! ../internals/ie8-dom-define */ "./node_modules/core-js/internals/ie8-dom-define.js");
            var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
            exports.f = DESCRIPTORS ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
                O = toIndexedObject(O);
                P = toPrimitive(P, true);
                if (IE8_DOM_DEFINE) try {
                    return nativeGetOwnPropertyDescriptor(O, P);
                } catch (error) {}
                if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
            };
        /***/ },
        /***/ "./node_modules/core-js/internals/object-get-own-property-names.js": /*!*************************************************************************!*\
  !*** ./node_modules/core-js/internals/object-get-own-property-names.js ***!
  \*************************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            // 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
            var internalObjectKeys = __webpack_require__(/*! ../internals/object-keys-internal */ "./node_modules/core-js/internals/object-keys-internal.js");
            var enumBugKeys = __webpack_require__(/*! ../internals/enum-bug-keys */ "./node_modules/core-js/internals/enum-bug-keys.js");
            var hiddenKeys = enumBugKeys.concat('length', 'prototype');
            exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
                return internalObjectKeys(O, hiddenKeys);
            };
        /***/ },
        /***/ "./node_modules/core-js/internals/object-get-own-property-symbols.js": /*!***************************************************************************!*\
  !*** ./node_modules/core-js/internals/object-get-own-property-symbols.js ***!
  \***************************************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            exports.f = Object.getOwnPropertySymbols;
        /***/ },
        /***/ "./node_modules/core-js/internals/object-get-prototype-of.js": /*!*******************************************************************!*\
  !*** ./node_modules/core-js/internals/object-get-prototype-of.js ***!
  \*******************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
            var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/core-js/internals/to-object.js");
            var sharedKey = __webpack_require__(/*! ../internals/shared-key */ "./node_modules/core-js/internals/shared-key.js");
            var CORRECT_PROTOTYPE_GETTER = __webpack_require__(/*! ../internals/correct-prototype-getter */ "./node_modules/core-js/internals/correct-prototype-getter.js");
            var IE_PROTO = sharedKey('IE_PROTO');
            var ObjectPrototype = Object.prototype;
            // 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
            module1.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function(O) {
                O = toObject(O);
                if (has(O, IE_PROTO)) return O[IE_PROTO];
                if (typeof O.constructor == 'function' && O instanceof O.constructor) return O.constructor.prototype;
                return O instanceof Object ? ObjectPrototype : null;
            };
        /***/ },
        /***/ "./node_modules/core-js/internals/object-keys-internal.js": /*!****************************************************************!*\
  !*** ./node_modules/core-js/internals/object-keys-internal.js ***!
  \****************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
            var toIndexedObject = __webpack_require__(/*! ../internals/to-indexed-object */ "./node_modules/core-js/internals/to-indexed-object.js");
            var arrayIncludes = __webpack_require__(/*! ../internals/array-includes */ "./node_modules/core-js/internals/array-includes.js");
            var hiddenKeys = __webpack_require__(/*! ../internals/hidden-keys */ "./node_modules/core-js/internals/hidden-keys.js");
            var arrayIndexOf = arrayIncludes(false);
            module1.exports = function(object, names) {
                var O = toIndexedObject(object);
                var i = 0;
                var result = [];
                var key;
                for(key in O)!has(hiddenKeys, key) && has(O, key) && result.push(key);
                // Don't enum bug & hidden keys
                while(names.length > i)if (has(O, key = names[i++])) ~arrayIndexOf(result, key) || result.push(key);
                return result;
            };
        /***/ },
        /***/ "./node_modules/core-js/internals/object-keys.js": /*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/object-keys.js ***!
  \*******************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var internalObjectKeys = __webpack_require__(/*! ../internals/object-keys-internal */ "./node_modules/core-js/internals/object-keys-internal.js");
            var enumBugKeys = __webpack_require__(/*! ../internals/enum-bug-keys */ "./node_modules/core-js/internals/enum-bug-keys.js");
            // 19.1.2.14 / 15.2.3.14 Object.keys(O)
            module1.exports = Object.keys || function keys(O) {
                return internalObjectKeys(O, enumBugKeys);
            };
        /***/ },
        /***/ "./node_modules/core-js/internals/object-property-is-enumerable.js": /*!*************************************************************************!*\
  !*** ./node_modules/core-js/internals/object-property-is-enumerable.js ***!
  \*************************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
            var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
            // Nashorn ~ JDK8 bug
            var NASHORN_BUG = getOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({
                1: 2
            }, 1);
            exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
                var descriptor = getOwnPropertyDescriptor(this, V);
                return !!descriptor && descriptor.enumerable;
            } : nativePropertyIsEnumerable;
        /***/ },
        /***/ "./node_modules/core-js/internals/object-set-prototype-of.js": /*!*******************************************************************!*\
  !*** ./node_modules/core-js/internals/object-set-prototype-of.js ***!
  \*******************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var validateSetPrototypeOfArguments = __webpack_require__(/*! ../internals/validate-set-prototype-of-arguments */ "./node_modules/core-js/internals/validate-set-prototype-of-arguments.js");
            // Works with __proto__ only. Old v8 can't work with null proto objects.
            /* eslint-disable no-proto */ module1.exports = Object.setPrototypeOf || ('__proto__' in {} ? function() {
                var correctSetter = false;
                var test = {};
                var setter;
                try {
                    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
                    setter.call(test, []);
                    correctSetter = test instanceof Array;
                } catch (error) {}
                return function setPrototypeOf(O, proto) {
                    validateSetPrototypeOfArguments(O, proto);
                    if (correctSetter) setter.call(O, proto);
                    else O.__proto__ = proto;
                    return O;
                };
            }() : undefined);
        /***/ },
        /***/ "./node_modules/core-js/internals/own-keys.js": /*!****************************************************!*\
  !*** ./node_modules/core-js/internals/own-keys.js ***!
  \****************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
            var getOwnPropertyNamesModule = __webpack_require__(/*! ../internals/object-get-own-property-names */ "./node_modules/core-js/internals/object-get-own-property-names.js");
            var getOwnPropertySymbolsModule = __webpack_require__(/*! ../internals/object-get-own-property-symbols */ "./node_modules/core-js/internals/object-get-own-property-symbols.js");
            var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
            var Reflect = global.Reflect;
            // all object keys, includes non-enumerable and symbols
            module1.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
                var keys = getOwnPropertyNamesModule.f(anObject(it));
                var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
                return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
            };
        /***/ },
        /***/ "./node_modules/core-js/internals/path.js": /*!************************************************!*\
  !*** ./node_modules/core-js/internals/path.js ***!
  \************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            module1.exports = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
        /***/ },
        /***/ "./node_modules/core-js/internals/redefine.js": /*!****************************************************!*\
  !*** ./node_modules/core-js/internals/redefine.js ***!
  \****************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
            var shared = __webpack_require__(/*! ../internals/shared */ "./node_modules/core-js/internals/shared.js");
            var hide = __webpack_require__(/*! ../internals/hide */ "./node_modules/core-js/internals/hide.js");
            var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
            var setGlobal = __webpack_require__(/*! ../internals/set-global */ "./node_modules/core-js/internals/set-global.js");
            var nativeFunctionToString = __webpack_require__(/*! ../internals/function-to-string */ "./node_modules/core-js/internals/function-to-string.js");
            var InternalStateModule = __webpack_require__(/*! ../internals/internal-state */ "./node_modules/core-js/internals/internal-state.js");
            var getInternalState = InternalStateModule.get;
            var enforceInternalState = InternalStateModule.enforce;
            var TEMPLATE = String(nativeFunctionToString).split('toString');
            shared('inspectSource', function(it) {
                return nativeFunctionToString.call(it);
            });
            (module1.exports = function(O, key, value, options) {
                var unsafe = options ? !!options.unsafe : false;
                var simple = options ? !!options.enumerable : false;
                var noTargetGet = options ? !!options.noTargetGet : false;
                if (typeof value == 'function') {
                    if (typeof key == 'string' && !has(value, 'name')) hide(value, 'name', key);
                    enforceInternalState(value).source = TEMPLATE.join(typeof key == 'string' ? key : '');
                }
                if (O === global) {
                    if (simple) O[key] = value;
                    else setGlobal(key, value);
                    return;
                } else if (!unsafe) delete O[key];
                else if (!noTargetGet && O[key]) simple = true;
                if (simple) O[key] = value;
                else hide(O, key, value);
            // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
            })(Function.prototype, 'toString', function toString() {
                return typeof this == 'function' && getInternalState(this).source || nativeFunctionToString.call(this);
            });
        /***/ },
        /***/ "./node_modules/core-js/internals/require-object-coercible.js": /*!********************************************************************!*\
  !*** ./node_modules/core-js/internals/require-object-coercible.js ***!
  \********************************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            // `RequireObjectCoercible` abstract operation
            // https://tc39.github.io/ecma262/#sec-requireobjectcoercible
            module1.exports = function(it) {
                if (it == undefined) throw TypeError("Can't call method on " + it);
                return it;
            };
        /***/ },
        /***/ "./node_modules/core-js/internals/set-global.js": /*!******************************************************!*\
  !*** ./node_modules/core-js/internals/set-global.js ***!
  \******************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
            var hide = __webpack_require__(/*! ../internals/hide */ "./node_modules/core-js/internals/hide.js");
            module1.exports = function(key, value) {
                try {
                    hide(global, key, value);
                } catch (error) {
                    global[key] = value;
                }
                return value;
            };
        /***/ },
        /***/ "./node_modules/core-js/internals/set-to-string-tag.js": /*!*************************************************************!*\
  !*** ./node_modules/core-js/internals/set-to-string-tag.js ***!
  \*************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var defineProperty = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js").f;
            var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
            var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
            var TO_STRING_TAG = wellKnownSymbol('toStringTag');
            module1.exports = function(it, TAG, STATIC) {
                if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) defineProperty(it, TO_STRING_TAG, {
                    configurable: true,
                    value: TAG
                });
            };
        /***/ },
        /***/ "./node_modules/core-js/internals/shared-key.js": /*!******************************************************!*\
  !*** ./node_modules/core-js/internals/shared-key.js ***!
  \******************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var shared = __webpack_require__(/*! ../internals/shared */ "./node_modules/core-js/internals/shared.js");
            var uid = __webpack_require__(/*! ../internals/uid */ "./node_modules/core-js/internals/uid.js");
            var keys = shared('keys');
            module1.exports = function(key) {
                return keys[key] || (keys[key] = uid(key));
            };
        /***/ },
        /***/ "./node_modules/core-js/internals/shared.js": /*!**************************************************!*\
  !*** ./node_modules/core-js/internals/shared.js ***!
  \**************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
            var setGlobal = __webpack_require__(/*! ../internals/set-global */ "./node_modules/core-js/internals/set-global.js");
            var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
            var SHARED = '__core-js_shared__';
            var store = global[SHARED] || setGlobal(SHARED, {});
            (module1.exports = function(key, value) {
                return store[key] || (store[key] = value !== undefined ? value : {});
            })('versions', []).push({
                version: '3.1.3',
                mode: IS_PURE ? 'pure' : 'global',
                copyright: "\xa9 2019 Denis Pushkarev (zloirock.ru)"
            });
        /***/ },
        /***/ "./node_modules/core-js/internals/string-at.js": /*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/string-at.js ***!
  \*****************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var toInteger = __webpack_require__(/*! ../internals/to-integer */ "./node_modules/core-js/internals/to-integer.js");
            var requireObjectCoercible = __webpack_require__(/*! ../internals/require-object-coercible */ "./node_modules/core-js/internals/require-object-coercible.js");
            // CONVERT_TO_STRING: true  -> String#at
            // CONVERT_TO_STRING: false -> String#codePointAt
            module1.exports = function(that, pos, CONVERT_TO_STRING) {
                var S = String(requireObjectCoercible(that));
                var position = toInteger(pos);
                var size = S.length;
                var first, second;
                if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
                first = S.charCodeAt(position);
                return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? S.charAt(position) : first : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
            };
        /***/ },
        /***/ "./node_modules/core-js/internals/to-absolute-index.js": /*!*************************************************************!*\
  !*** ./node_modules/core-js/internals/to-absolute-index.js ***!
  \*************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var toInteger = __webpack_require__(/*! ../internals/to-integer */ "./node_modules/core-js/internals/to-integer.js");
            var max = Math.max;
            var min = Math.min;
            // Helper for a popular repeating case of the spec:
            // Let integer be ? ToInteger(index).
            // If integer < 0, let result be max((length + integer), 0); else let result be min(length, length).
            module1.exports = function(index, length) {
                var integer = toInteger(index);
                return integer < 0 ? max(integer + length, 0) : min(integer, length);
            };
        /***/ },
        /***/ "./node_modules/core-js/internals/to-indexed-object.js": /*!*************************************************************!*\
  !*** ./node_modules/core-js/internals/to-indexed-object.js ***!
  \*************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            // toObject with fallback for non-array-like ES3 strings
            var IndexedObject = __webpack_require__(/*! ../internals/indexed-object */ "./node_modules/core-js/internals/indexed-object.js");
            var requireObjectCoercible = __webpack_require__(/*! ../internals/require-object-coercible */ "./node_modules/core-js/internals/require-object-coercible.js");
            module1.exports = function(it) {
                return IndexedObject(requireObjectCoercible(it));
            };
        /***/ },
        /***/ "./node_modules/core-js/internals/to-integer.js": /*!******************************************************!*\
  !*** ./node_modules/core-js/internals/to-integer.js ***!
  \******************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            var ceil = Math.ceil;
            var floor = Math.floor;
            // `ToInteger` abstract operation
            // https://tc39.github.io/ecma262/#sec-tointeger
            module1.exports = function(argument) {
                return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
            };
        /***/ },
        /***/ "./node_modules/core-js/internals/to-length.js": /*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/to-length.js ***!
  \*****************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var toInteger = __webpack_require__(/*! ../internals/to-integer */ "./node_modules/core-js/internals/to-integer.js");
            var min = Math.min;
            // `ToLength` abstract operation
            // https://tc39.github.io/ecma262/#sec-tolength
            module1.exports = function(argument) {
                return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
            };
        /***/ },
        /***/ "./node_modules/core-js/internals/to-object.js": /*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/to-object.js ***!
  \*****************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var requireObjectCoercible = __webpack_require__(/*! ../internals/require-object-coercible */ "./node_modules/core-js/internals/require-object-coercible.js");
            // `ToObject` abstract operation
            // https://tc39.github.io/ecma262/#sec-toobject
            module1.exports = function(argument) {
                return Object(requireObjectCoercible(argument));
            };
        /***/ },
        /***/ "./node_modules/core-js/internals/to-primitive.js": /*!********************************************************!*\
  !*** ./node_modules/core-js/internals/to-primitive.js ***!
  \********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
            // 7.1.1 ToPrimitive(input [, PreferredType])
            // instead of the ES6 spec version, we didn't implement @@toPrimitive case
            // and the second argument - flag - preferred type is a string
            module1.exports = function(it, S) {
                if (!isObject(it)) return it;
                var fn, val;
                if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
                if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
                if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
                throw TypeError("Can't convert object to primitive value");
            };
        /***/ },
        /***/ "./node_modules/core-js/internals/uid.js": /*!***********************************************!*\
  !*** ./node_modules/core-js/internals/uid.js ***!
  \***********************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            var id = 0;
            var postfix = Math.random();
            module1.exports = function(key) {
                return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + postfix).toString(36));
            };
        /***/ },
        /***/ "./node_modules/core-js/internals/validate-set-prototype-of-arguments.js": /*!*******************************************************************************!*\
  !*** ./node_modules/core-js/internals/validate-set-prototype-of-arguments.js ***!
  \*******************************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
            var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
            module1.exports = function(O, proto) {
                anObject(O);
                if (!isObject(proto) && proto !== null) throw TypeError("Can't set " + String(proto) + ' as a prototype');
            };
        /***/ },
        /***/ "./node_modules/core-js/internals/well-known-symbol.js": /*!*************************************************************!*\
  !*** ./node_modules/core-js/internals/well-known-symbol.js ***!
  \*************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
            var shared = __webpack_require__(/*! ../internals/shared */ "./node_modules/core-js/internals/shared.js");
            var uid = __webpack_require__(/*! ../internals/uid */ "./node_modules/core-js/internals/uid.js");
            var NATIVE_SYMBOL = __webpack_require__(/*! ../internals/native-symbol */ "./node_modules/core-js/internals/native-symbol.js");
            var Symbol1 = global.Symbol;
            var store = shared('wks');
            module1.exports = function(name) {
                return store[name] || (store[name] = NATIVE_SYMBOL && Symbol1[name] || (NATIVE_SYMBOL ? Symbol1 : uid)('Symbol.' + name));
            };
        /***/ },
        /***/ "./node_modules/core-js/modules/es.array.from.js": /*!*******************************************************!*\
  !*** ./node_modules/core-js/modules/es.array.from.js ***!
  \*******************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
            var from = __webpack_require__(/*! ../internals/array-from */ "./node_modules/core-js/internals/array-from.js");
            var checkCorrectnessOfIteration = __webpack_require__(/*! ../internals/check-correctness-of-iteration */ "./node_modules/core-js/internals/check-correctness-of-iteration.js");
            var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function(iterable) {
                Array.from(iterable);
            });
            // `Array.from` method
            // https://tc39.github.io/ecma262/#sec-array.from
            $({
                target: 'Array',
                stat: true,
                forced: INCORRECT_ITERATION
            }, {
                from: from
            });
        /***/ },
        /***/ "./node_modules/core-js/modules/es.string.iterator.js": /*!************************************************************!*\
  !*** ./node_modules/core-js/modules/es.string.iterator.js ***!
  \************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var codePointAt = __webpack_require__(/*! ../internals/string-at */ "./node_modules/core-js/internals/string-at.js");
            var InternalStateModule = __webpack_require__(/*! ../internals/internal-state */ "./node_modules/core-js/internals/internal-state.js");
            var defineIterator = __webpack_require__(/*! ../internals/define-iterator */ "./node_modules/core-js/internals/define-iterator.js");
            var STRING_ITERATOR = 'String Iterator';
            var setInternalState = InternalStateModule.set;
            var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);
            // `String.prototype[@@iterator]` method
            // https://tc39.github.io/ecma262/#sec-string.prototype-@@iterator
            defineIterator(String, 'String', function(iterated) {
                setInternalState(this, {
                    type: STRING_ITERATOR,
                    string: String(iterated),
                    index: 0
                });
            // `%StringIteratorPrototype%.next` method
            // https://tc39.github.io/ecma262/#sec-%stringiteratorprototype%.next
            }, function next() {
                var state = getInternalState(this);
                var string = state.string;
                var index = state.index;
                var point;
                if (index >= string.length) return {
                    value: undefined,
                    done: true
                };
                point = codePointAt(string, index, true);
                state.index += point.length;
                return {
                    value: point,
                    done: false
                };
            });
        /***/ },
        /***/ "./node_modules/webpack/buildin/global.js": /*!***********************************!*\
  !*** (webpack)/buildin/global.js ***!
  \***********************************/ /*! no static exports found */ /***/ function(module1, exports) {
            var g;
            // This works in non-strict mode
            g = function() {
                return this;
            }();
            try {
                // This works if eval is allowed (see CSP)
                g = g || Function("return this")() || (0, eval)("this");
            } catch (e) {
                // This works if the window reference is available
                if ((typeof window === "undefined" ? "undefined" : (0, $7e5af7f007906526$export$71511d61b312f219)(window)) === "object") g = window;
            }
            // g can still be undefined, but nothing to do about it...
            // We return undefined, instead of nothing here, so it's
            // easier to handle this case. if(!global) { ...}
            module1.exports = g;
        /***/ },
        /***/ "./src/default-attrs.json": /*!********************************!*\
  !*** ./src/default-attrs.json ***!
  \********************************/ /*! exports provided: xmlns, width, height, viewBox, fill, stroke, stroke-width, stroke-linecap, stroke-linejoin, default */ /***/ function(module1) {
            module1.exports = {
                xmlns: "http://www.w3.org/2000/svg",
                width: 24,
                height: 24,
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": 2,
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            };
        /***/ },
        /***/ "./src/icon.js": /*!*********************!*\
  !*** ./src/icon.js ***!
  \*********************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _extends = Object.assign || function(target) {
                for(var i = 1; i < arguments.length; i++){
                    var source = arguments[i];
                    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
                }
                return target;
            };
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _dedupe = __webpack_require__(/*! classnames/dedupe */ "./node_modules/classnames/dedupe.js");
            var _dedupe2 = _interopRequireDefault(_dedupe);
            var _defaultAttrs = __webpack_require__(/*! ./default-attrs.json */ "./src/default-attrs.json");
            var _defaultAttrs2 = _interopRequireDefault(_defaultAttrs);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    "default": obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var Icon = function() {
                function Icon(name, contents) {
                    var tags = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
                    _classCallCheck(this, Icon);
                    this.name = name;
                    this.contents = contents;
                    this.tags = tags;
                    this.attrs = _extends({}, _defaultAttrs2["default"], {
                        "class": 'feather feather-' + name
                    });
                }
                /**
   * Create an SVG string.
   * @param {Object} attrs
   * @returns {string}
   */ _createClass(Icon, [
                    {
                        key: 'toSvg',
                        value: function toSvg() {
                            var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                            var combinedAttrs = _extends({}, this.attrs, attrs, {
                                "class": (0, _dedupe2["default"])(this.attrs["class"], attrs["class"])
                            });
                            return '<svg ' + attrsToString(combinedAttrs) + '>' + this.contents + '</svg>';
                        }
                    },
                    {
                        key: 'toString',
                        value: function toString() {
                            return this.contents;
                        }
                    }
                ]);
                return Icon;
            }();
            /**
 * Convert attributes object to string of HTML attributes.
 * @param {Object} attrs
 * @returns {string}
 */ function attrsToString(attrs) {
                return Object.keys(attrs).map(function(key) {
                    return key + '="' + attrs[key] + '"';
                }).join(' ');
            }
            exports["default"] = Icon;
        /***/ },
        /***/ "./src/icons.js": /*!**********************!*\
  !*** ./src/icons.js ***!
  \**********************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _icon = __webpack_require__(/*! ./icon */ "./src/icon.js");
            var _icon2 = _interopRequireDefault(_icon);
            var _icons = __webpack_require__(/*! ../dist/icons.json */ "./dist/icons.json");
            var _icons2 = _interopRequireDefault(_icons);
            var _tags = __webpack_require__(/*! ./tags.json */ "./src/tags.json");
            var _tags2 = _interopRequireDefault(_tags);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    "default": obj
                };
            }
            exports["default"] = Object.keys(_icons2["default"]).map(function(key) {
                return new _icon2["default"](key, _icons2["default"][key], _tags2["default"][key]);
            }).reduce(function(object, icon) {
                object[icon.name] = icon;
                return object;
            }, {});
        /***/ },
        /***/ "./src/index.js": /*!**********************!*\
  !*** ./src/index.js ***!
  \**********************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _icons = __webpack_require__(/*! ./icons */ "./src/icons.js");
            var _icons2 = _interopRequireDefault(_icons);
            var _toSvg = __webpack_require__(/*! ./to-svg */ "./src/to-svg.js");
            var _toSvg2 = _interopRequireDefault(_toSvg);
            var _replace = __webpack_require__(/*! ./replace */ "./src/replace.js");
            var _replace2 = _interopRequireDefault(_replace);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    "default": obj
                };
            }
            module1.exports = {
                icons: _icons2["default"],
                toSvg: _toSvg2["default"],
                replace: _replace2["default"]
            };
        /***/ },
        /***/ "./src/replace.js": /*!************************!*\
  !*** ./src/replace.js ***!
  \************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _extends = Object.assign || function(target) {
                for(var i = 1; i < arguments.length; i++){
                    var source = arguments[i];
                    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
                }
                return target;
            }; /* eslint-env browser */ 
            var _dedupe = __webpack_require__(/*! classnames/dedupe */ "./node_modules/classnames/dedupe.js");
            var _dedupe2 = _interopRequireDefault(_dedupe);
            var _icons = __webpack_require__(/*! ./icons */ "./src/icons.js");
            var _icons2 = _interopRequireDefault(_icons);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    "default": obj
                };
            }
            /**
 * Replace all HTML elements that have a `data-feather` attribute with SVG markup
 * corresponding to the element's `data-feather` attribute value.
 * @param {Object} attrs
 */ function replace() {
                var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                if (typeof document === 'undefined') throw new Error('`feather.replace()` only works in a browser environment.');
                var elementsToReplace = document.querySelectorAll('[data-feather]');
                Array.from(elementsToReplace).forEach(function(element) {
                    return replaceElement(element, attrs);
                });
            }
            /**
 * Replace a single HTML element with SVG markup
 * corresponding to the element's `data-feather` attribute value.
 * @param {HTMLElement} element
 * @param {Object} attrs
 */ function replaceElement(element) {
                var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var elementAttrs = getAttrs(element);
                var name = elementAttrs['data-feather'];
                delete elementAttrs['data-feather'];
                if (_icons2["default"][name] === undefined) {
                    console.warn('feather: \'' + name + '\' is not a valid icon');
                    return;
                }
                var svgString = _icons2["default"][name].toSvg(_extends({}, attrs, elementAttrs, {
                    "class": (0, _dedupe2["default"])(attrs["class"], elementAttrs["class"])
                }));
                var svgDocument = new DOMParser().parseFromString(svgString, 'image/svg+xml');
                var svgElement = svgDocument.querySelector('svg');
                element.parentNode.replaceChild(svgElement, element);
            }
            /**
 * Get the attributes of an HTML element.
 * @param {HTMLElement} element
 * @returns {Object}
 */ function getAttrs(element) {
                return Array.from(element.attributes).reduce(function(attrs, attr) {
                    attrs[attr.name] = attr.value;
                    return attrs;
                }, {});
            }
            exports["default"] = replace;
        /***/ },
        /***/ "./src/tags.json": /*!***********************!*\
  !*** ./src/tags.json ***!
  \***********************/ /*! exports provided: activity, airplay, alert-circle, alert-octagon, alert-triangle, align-center, align-justify, align-left, align-right, anchor, archive, at-sign, award, aperture, bar-chart, bar-chart-2, battery, battery-charging, bell, bell-off, bluetooth, book-open, book, bookmark, box, briefcase, calendar, camera, cast, chevron-down, chevron-up, circle, clipboard, clock, cloud-drizzle, cloud-lightning, cloud-rain, cloud-snow, cloud, codepen, codesandbox, code, coffee, columns, command, compass, copy, corner-down-left, corner-down-right, corner-left-down, corner-left-up, corner-right-down, corner-right-up, corner-up-left, corner-up-right, cpu, credit-card, crop, crosshair, database, delete, disc, dollar-sign, droplet, edit, edit-2, edit-3, eye, eye-off, external-link, facebook, fast-forward, figma, file-minus, file-plus, file-text, film, filter, flag, folder-minus, folder-plus, folder, framer, frown, gift, git-branch, git-commit, git-merge, git-pull-request, github, gitlab, globe, hard-drive, hash, headphones, heart, help-circle, hexagon, home, image, inbox, instagram, key, layers, layout, life-buoy, link, link-2, linkedin, list, lock, log-in, log-out, mail, map-pin, map, maximize, maximize-2, meh, menu, message-circle, message-square, mic-off, mic, minimize, minimize-2, minus, monitor, moon, more-horizontal, more-vertical, mouse-pointer, move, music, navigation, navigation-2, octagon, package, paperclip, pause, pause-circle, pen-tool, percent, phone-call, phone-forwarded, phone-incoming, phone-missed, phone-off, phone-outgoing, phone, play, pie-chart, play-circle, plus, plus-circle, plus-square, pocket, power, printer, radio, refresh-cw, refresh-ccw, repeat, rewind, rotate-ccw, rotate-cw, rss, save, scissors, search, send, settings, share-2, shield, shield-off, shopping-bag, shopping-cart, shuffle, skip-back, skip-forward, slack, slash, sliders, smartphone, smile, speaker, star, stop-circle, sun, sunrise, sunset, tablet, tag, target, terminal, thermometer, thumbs-down, thumbs-up, toggle-left, toggle-right, tool, trash, trash-2, triangle, truck, tv, twitch, twitter, type, umbrella, unlock, user-check, user-minus, user-plus, user-x, user, users, video-off, video, voicemail, volume, volume-1, volume-2, volume-x, watch, wifi-off, wifi, wind, x-circle, x-octagon, x-square, x, youtube, zap-off, zap, zoom-in, zoom-out, default */ /***/ function(module1) {
            module1.exports = {
                activity: [
                    "pulse",
                    "health",
                    "action",
                    "motion"
                ],
                airplay: [
                    "stream",
                    "cast",
                    "mirroring"
                ],
                "alert-circle": [
                    "warning",
                    "alert",
                    "danger"
                ],
                "alert-octagon": [
                    "warning",
                    "alert",
                    "danger"
                ],
                "alert-triangle": [
                    "warning",
                    "alert",
                    "danger"
                ],
                "align-center": [
                    "text alignment",
                    "center"
                ],
                "align-justify": [
                    "text alignment",
                    "justified"
                ],
                "align-left": [
                    "text alignment",
                    "left"
                ],
                "align-right": [
                    "text alignment",
                    "right"
                ],
                anchor: [],
                archive: [
                    "index",
                    "box"
                ],
                "at-sign": [
                    "mention",
                    "at",
                    "email",
                    "message"
                ],
                award: [
                    "achievement",
                    "badge"
                ],
                aperture: [
                    "camera",
                    "photo"
                ],
                "bar-chart": [
                    "statistics",
                    "diagram",
                    "graph"
                ],
                "bar-chart-2": [
                    "statistics",
                    "diagram",
                    "graph"
                ],
                battery: [
                    "power",
                    "electricity"
                ],
                "battery-charging": [
                    "power",
                    "electricity"
                ],
                bell: [
                    "alarm",
                    "notification",
                    "sound"
                ],
                "bell-off": [
                    "alarm",
                    "notification",
                    "silent"
                ],
                bluetooth: [
                    "wireless"
                ],
                "book-open": [
                    "read",
                    "library"
                ],
                book: [
                    "read",
                    "dictionary",
                    "booklet",
                    "magazine",
                    "library"
                ],
                bookmark: [
                    "read",
                    "clip",
                    "marker",
                    "tag"
                ],
                box: [
                    "cube"
                ],
                briefcase: [
                    "work",
                    "bag",
                    "baggage",
                    "folder"
                ],
                calendar: [
                    "date"
                ],
                camera: [
                    "photo"
                ],
                cast: [
                    "chromecast",
                    "airplay"
                ],
                "chevron-down": [
                    "expand"
                ],
                "chevron-up": [
                    "collapse"
                ],
                circle: [
                    "off",
                    "zero",
                    "record"
                ],
                clipboard: [
                    "copy"
                ],
                clock: [
                    "time",
                    "watch",
                    "alarm"
                ],
                "cloud-drizzle": [
                    "weather",
                    "shower"
                ],
                "cloud-lightning": [
                    "weather",
                    "bolt"
                ],
                "cloud-rain": [
                    "weather"
                ],
                "cloud-snow": [
                    "weather",
                    "blizzard"
                ],
                cloud: [
                    "weather"
                ],
                codepen: [
                    "logo"
                ],
                codesandbox: [
                    "logo"
                ],
                code: [
                    "source",
                    "programming"
                ],
                coffee: [
                    "drink",
                    "cup",
                    "mug",
                    "tea",
                    "cafe",
                    "hot",
                    "beverage"
                ],
                columns: [
                    "layout"
                ],
                command: [
                    "keyboard",
                    "cmd",
                    "terminal",
                    "prompt"
                ],
                compass: [
                    "navigation",
                    "safari",
                    "travel",
                    "direction"
                ],
                copy: [
                    "clone",
                    "duplicate"
                ],
                "corner-down-left": [
                    "arrow",
                    "return"
                ],
                "corner-down-right": [
                    "arrow"
                ],
                "corner-left-down": [
                    "arrow"
                ],
                "corner-left-up": [
                    "arrow"
                ],
                "corner-right-down": [
                    "arrow"
                ],
                "corner-right-up": [
                    "arrow"
                ],
                "corner-up-left": [
                    "arrow"
                ],
                "corner-up-right": [
                    "arrow"
                ],
                cpu: [
                    "processor",
                    "technology"
                ],
                "credit-card": [
                    "purchase",
                    "payment",
                    "cc"
                ],
                crop: [
                    "photo",
                    "image"
                ],
                crosshair: [
                    "aim",
                    "target"
                ],
                database: [
                    "storage",
                    "memory"
                ],
                "delete": [
                    "remove"
                ],
                disc: [
                    "album",
                    "cd",
                    "dvd",
                    "music"
                ],
                "dollar-sign": [
                    "currency",
                    "money",
                    "payment"
                ],
                droplet: [
                    "water"
                ],
                edit: [
                    "pencil",
                    "change"
                ],
                "edit-2": [
                    "pencil",
                    "change"
                ],
                "edit-3": [
                    "pencil",
                    "change"
                ],
                eye: [
                    "view",
                    "watch"
                ],
                "eye-off": [
                    "view",
                    "watch",
                    "hide",
                    "hidden"
                ],
                "external-link": [
                    "outbound"
                ],
                facebook: [
                    "logo",
                    "social"
                ],
                "fast-forward": [
                    "music"
                ],
                figma: [
                    "logo",
                    "design",
                    "tool"
                ],
                "file-minus": [
                    "delete",
                    "remove",
                    "erase"
                ],
                "file-plus": [
                    "add",
                    "create",
                    "new"
                ],
                "file-text": [
                    "data",
                    "txt",
                    "pdf"
                ],
                film: [
                    "movie",
                    "video"
                ],
                filter: [
                    "funnel",
                    "hopper"
                ],
                flag: [
                    "report"
                ],
                "folder-minus": [
                    "directory"
                ],
                "folder-plus": [
                    "directory"
                ],
                folder: [
                    "directory"
                ],
                framer: [
                    "logo",
                    "design",
                    "tool"
                ],
                frown: [
                    "emoji",
                    "face",
                    "bad",
                    "sad",
                    "emotion"
                ],
                gift: [
                    "present",
                    "box",
                    "birthday",
                    "party"
                ],
                "git-branch": [
                    "code",
                    "version control"
                ],
                "git-commit": [
                    "code",
                    "version control"
                ],
                "git-merge": [
                    "code",
                    "version control"
                ],
                "git-pull-request": [
                    "code",
                    "version control"
                ],
                github: [
                    "logo",
                    "version control"
                ],
                gitlab: [
                    "logo",
                    "version control"
                ],
                globe: [
                    "world",
                    "browser",
                    "language",
                    "translate"
                ],
                "hard-drive": [
                    "computer",
                    "server",
                    "memory",
                    "data"
                ],
                hash: [
                    "hashtag",
                    "number",
                    "pound"
                ],
                headphones: [
                    "music",
                    "audio",
                    "sound"
                ],
                heart: [
                    "like",
                    "love",
                    "emotion"
                ],
                "help-circle": [
                    "question mark"
                ],
                hexagon: [
                    "shape",
                    "node.js",
                    "logo"
                ],
                home: [
                    "house",
                    "living"
                ],
                image: [
                    "picture"
                ],
                inbox: [
                    "email"
                ],
                instagram: [
                    "logo",
                    "camera"
                ],
                key: [
                    "password",
                    "login",
                    "authentication",
                    "secure"
                ],
                layers: [
                    "stack"
                ],
                layout: [
                    "window",
                    "webpage"
                ],
                "life-buoy": [
                    "help",
                    "life ring",
                    "support"
                ],
                link: [
                    "chain",
                    "url"
                ],
                "link-2": [
                    "chain",
                    "url"
                ],
                linkedin: [
                    "logo",
                    "social media"
                ],
                list: [
                    "options"
                ],
                lock: [
                    "security",
                    "password",
                    "secure"
                ],
                "log-in": [
                    "sign in",
                    "arrow",
                    "enter"
                ],
                "log-out": [
                    "sign out",
                    "arrow",
                    "exit"
                ],
                mail: [
                    "email",
                    "message"
                ],
                "map-pin": [
                    "location",
                    "navigation",
                    "travel",
                    "marker"
                ],
                map: [
                    "location",
                    "navigation",
                    "travel"
                ],
                maximize: [
                    "fullscreen"
                ],
                "maximize-2": [
                    "fullscreen",
                    "arrows",
                    "expand"
                ],
                meh: [
                    "emoji",
                    "face",
                    "neutral",
                    "emotion"
                ],
                menu: [
                    "bars",
                    "navigation",
                    "hamburger"
                ],
                "message-circle": [
                    "comment",
                    "chat"
                ],
                "message-square": [
                    "comment",
                    "chat"
                ],
                "mic-off": [
                    "record",
                    "sound",
                    "mute"
                ],
                mic: [
                    "record",
                    "sound",
                    "listen"
                ],
                minimize: [
                    "exit fullscreen",
                    "close"
                ],
                "minimize-2": [
                    "exit fullscreen",
                    "arrows",
                    "close"
                ],
                minus: [
                    "subtract"
                ],
                monitor: [
                    "tv",
                    "screen",
                    "display"
                ],
                moon: [
                    "dark",
                    "night"
                ],
                "more-horizontal": [
                    "ellipsis"
                ],
                "more-vertical": [
                    "ellipsis"
                ],
                "mouse-pointer": [
                    "arrow",
                    "cursor"
                ],
                move: [
                    "arrows"
                ],
                music: [
                    "note"
                ],
                navigation: [
                    "location",
                    "travel"
                ],
                "navigation-2": [
                    "location",
                    "travel"
                ],
                octagon: [
                    "stop"
                ],
                "package": [
                    "box",
                    "container"
                ],
                paperclip: [
                    "attachment"
                ],
                pause: [
                    "music",
                    "stop"
                ],
                "pause-circle": [
                    "music",
                    "audio",
                    "stop"
                ],
                "pen-tool": [
                    "vector",
                    "drawing"
                ],
                percent: [
                    "discount"
                ],
                "phone-call": [
                    "ring"
                ],
                "phone-forwarded": [
                    "call"
                ],
                "phone-incoming": [
                    "call"
                ],
                "phone-missed": [
                    "call"
                ],
                "phone-off": [
                    "call",
                    "mute"
                ],
                "phone-outgoing": [
                    "call"
                ],
                phone: [
                    "call"
                ],
                play: [
                    "music",
                    "start"
                ],
                "pie-chart": [
                    "statistics",
                    "diagram"
                ],
                "play-circle": [
                    "music",
                    "start"
                ],
                plus: [
                    "add",
                    "new"
                ],
                "plus-circle": [
                    "add",
                    "new"
                ],
                "plus-square": [
                    "add",
                    "new"
                ],
                pocket: [
                    "logo",
                    "save"
                ],
                power: [
                    "on",
                    "off"
                ],
                printer: [
                    "fax",
                    "office",
                    "device"
                ],
                radio: [
                    "signal"
                ],
                "refresh-cw": [
                    "synchronise",
                    "arrows"
                ],
                "refresh-ccw": [
                    "arrows"
                ],
                repeat: [
                    "loop",
                    "arrows"
                ],
                rewind: [
                    "music"
                ],
                "rotate-ccw": [
                    "arrow"
                ],
                "rotate-cw": [
                    "arrow"
                ],
                rss: [
                    "feed",
                    "subscribe"
                ],
                save: [
                    "floppy disk"
                ],
                scissors: [
                    "cut"
                ],
                search: [
                    "find",
                    "magnifier",
                    "magnifying glass"
                ],
                send: [
                    "message",
                    "mail",
                    "email",
                    "paper airplane",
                    "paper aeroplane"
                ],
                settings: [
                    "cog",
                    "edit",
                    "gear",
                    "preferences"
                ],
                "share-2": [
                    "network",
                    "connections"
                ],
                shield: [
                    "security",
                    "secure"
                ],
                "shield-off": [
                    "security",
                    "insecure"
                ],
                "shopping-bag": [
                    "ecommerce",
                    "cart",
                    "purchase",
                    "store"
                ],
                "shopping-cart": [
                    "ecommerce",
                    "cart",
                    "purchase",
                    "store"
                ],
                shuffle: [
                    "music"
                ],
                "skip-back": [
                    "music"
                ],
                "skip-forward": [
                    "music"
                ],
                slack: [
                    "logo"
                ],
                slash: [
                    "ban",
                    "no"
                ],
                sliders: [
                    "settings",
                    "controls"
                ],
                smartphone: [
                    "cellphone",
                    "device"
                ],
                smile: [
                    "emoji",
                    "face",
                    "happy",
                    "good",
                    "emotion"
                ],
                speaker: [
                    "audio",
                    "music"
                ],
                star: [
                    "bookmark",
                    "favorite",
                    "like"
                ],
                "stop-circle": [
                    "media",
                    "music"
                ],
                sun: [
                    "brightness",
                    "weather",
                    "light"
                ],
                sunrise: [
                    "weather",
                    "time",
                    "morning",
                    "day"
                ],
                sunset: [
                    "weather",
                    "time",
                    "evening",
                    "night"
                ],
                tablet: [
                    "device"
                ],
                tag: [
                    "label"
                ],
                target: [
                    "logo",
                    "bullseye"
                ],
                terminal: [
                    "code",
                    "command line",
                    "prompt"
                ],
                thermometer: [
                    "temperature",
                    "celsius",
                    "fahrenheit",
                    "weather"
                ],
                "thumbs-down": [
                    "dislike",
                    "bad",
                    "emotion"
                ],
                "thumbs-up": [
                    "like",
                    "good",
                    "emotion"
                ],
                "toggle-left": [
                    "on",
                    "off",
                    "switch"
                ],
                "toggle-right": [
                    "on",
                    "off",
                    "switch"
                ],
                tool: [
                    "settings",
                    "spanner"
                ],
                trash: [
                    "garbage",
                    "delete",
                    "remove",
                    "bin"
                ],
                "trash-2": [
                    "garbage",
                    "delete",
                    "remove",
                    "bin"
                ],
                triangle: [
                    "delta"
                ],
                truck: [
                    "delivery",
                    "van",
                    "shipping",
                    "transport",
                    "lorry"
                ],
                tv: [
                    "television",
                    "stream"
                ],
                twitch: [
                    "logo"
                ],
                twitter: [
                    "logo",
                    "social"
                ],
                type: [
                    "text"
                ],
                umbrella: [
                    "rain",
                    "weather"
                ],
                unlock: [
                    "security"
                ],
                "user-check": [
                    "followed",
                    "subscribed"
                ],
                "user-minus": [
                    "delete",
                    "remove",
                    "unfollow",
                    "unsubscribe"
                ],
                "user-plus": [
                    "new",
                    "add",
                    "create",
                    "follow",
                    "subscribe"
                ],
                "user-x": [
                    "delete",
                    "remove",
                    "unfollow",
                    "unsubscribe",
                    "unavailable"
                ],
                user: [
                    "person",
                    "account"
                ],
                users: [
                    "group"
                ],
                "video-off": [
                    "camera",
                    "movie",
                    "film"
                ],
                video: [
                    "camera",
                    "movie",
                    "film"
                ],
                voicemail: [
                    "phone"
                ],
                volume: [
                    "music",
                    "sound",
                    "mute"
                ],
                "volume-1": [
                    "music",
                    "sound"
                ],
                "volume-2": [
                    "music",
                    "sound"
                ],
                "volume-x": [
                    "music",
                    "sound",
                    "mute"
                ],
                watch: [
                    "clock",
                    "time"
                ],
                "wifi-off": [
                    "disabled"
                ],
                wifi: [
                    "connection",
                    "signal",
                    "wireless"
                ],
                wind: [
                    "weather",
                    "air"
                ],
                "x-circle": [
                    "cancel",
                    "close",
                    "delete",
                    "remove",
                    "times",
                    "clear"
                ],
                "x-octagon": [
                    "delete",
                    "stop",
                    "alert",
                    "warning",
                    "times",
                    "clear"
                ],
                "x-square": [
                    "cancel",
                    "close",
                    "delete",
                    "remove",
                    "times",
                    "clear"
                ],
                x: [
                    "cancel",
                    "close",
                    "delete",
                    "remove",
                    "times",
                    "clear"
                ],
                youtube: [
                    "logo",
                    "video",
                    "play"
                ],
                "zap-off": [
                    "flash",
                    "camera",
                    "lightning"
                ],
                zap: [
                    "flash",
                    "camera",
                    "lightning"
                ],
                "zoom-in": [
                    "magnifying glass"
                ],
                "zoom-out": [
                    "magnifying glass"
                ]
            };
        /***/ },
        /***/ "./src/to-svg.js": /*!***********************!*\
  !*** ./src/to-svg.js ***!
  \***********************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _icons = __webpack_require__(/*! ./icons */ "./src/icons.js");
            var _icons2 = _interopRequireDefault(_icons);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    "default": obj
                };
            }
            /**
 * Create an SVG string.
 * @deprecated
 * @param {string} name
 * @param {Object} attrs
 * @returns {string}
 */ function toSvg(name) {
                var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                console.warn('feather.toSvg() is deprecated. Please use feather.icons[name].toSvg() instead.');
                if (!name) throw new Error('The required `key` (icon name) parameter is missing.');
                if (!_icons2["default"][name]) throw new Error('No icon matching \'' + name + '\'. See the complete list of icons at https://feathericons.com');
                return _icons2["default"][name].toSvg(attrs);
            }
            exports["default"] = toSvg;
        /***/ },
        /***/ 0: /*!**************************************************!*\
  !*** multi core-js/es/array/from ./src/index.js ***!
  \**************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            __webpack_require__(/*! core-js/es/array/from */ "./node_modules/core-js/es/array/from.js");
            module1.exports = __webpack_require__(/*! /home/runner/work/feather/feather/src/index.js */ "./src/index.js");
        /***/ }
    });
});


$d6345808c4188ae5$exports.replace();
//#endregion
//#region Typewriter
new (0, (/*@__PURE__*/$parcel$interopDefault($dc96d98a7dcdceb5$exports)))('#typewriter', {
    strings: [
        'Performant',
        'Scalable',
        'Maintainable',
        'Reactive',
        'Robust',
        'Testable',
        'Clean'
    ],
    autoStart: true,
    loop: true
}); //#endregion

})();
//# sourceMappingURL=repo.65543f71.js.map
